webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.makeRequestDirect = exports.makeRequest = undefined;

var _promise = __webpack_require__(283);

var _promise2 = _interopRequireDefault(_promise);

var _axios = __webpack_require__(291);

var _axios2 = _interopRequireDefault(_axios);

var _collection = __webpack_require__(201);

var _constants = __webpack_require__(55);

var _storage = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var makeRequest = exports.makeRequest = function makeRequest(endpoint) {
    var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var token = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    if (data == null) {
        data = {};
    }
    var country = _storage.CountryService.getCountry();
    var city = window.localStorage.getItem('City');
    city = JSON.parse(city);
    if (!country) {
        country = 195;
    }
    if (!token) {
        token = _storage.TokenService.getToken();
    }

    data['CountryID'] = country.CountryID;
    data['CityID'] = city == null ? 0 : city.CityID;
    console.log('URL_BASE :', _constants.URL_BASE);
    var url = _constants.URL_BASE + endpoint;
    // const url = endpoint
    var options = (0, _collection.getOptions)(url, method, token, data);
    return new _promise2.default(function (resolve, reject) {
        (0, _axios2.default)(options).then(function (res) {
            return resolve({ error: false, res: res });
        }).catch(function (error) {
            reject({ error: true, res: null });
        });
    });
};

var makeRequestDirect = exports.makeRequestDirect = function makeRequestDirect(endpoint) {
    var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var token = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    // const url = URL_BASE + endpoint;
    var url = _constants.URL_BASE;
    var options = (0, _collection.getOptions)(url, method, token, data);
    return new _promise2.default(function (resolve, reject) {
        (0, _axios2.default)(options).then(function (res) {
            return resolve({ error: false, res: res });
        }).catch(function (error) {
            reject({ error: true, res: null });
        });
    });
};

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAxOSAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iOS41IiBjeT0iOS41IiByPSI5IiBzdHJva2U9ImJsYWNrIi8+CjxsaW5lIHgxPSI5LjYzMzc5IiB5MT0iNC41IiB4Mj0iOS42MzM3OSIgeTI9IjE0LjUiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8bGluZSB4MT0iNC41IiB5MT0iOS4zNjY3IiB4Mj0iMTQuNSIgeTI9IjkuMzY2NyIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPgo="

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Api = __webpack_require__(147);

var _Api2 = _interopRequireDefault(_Api);

var _ApiHelper = __webpack_require__(294);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  GetBanners: function GetBanners(payload) {
    return (0, _Api2.default)().get("/api/cinema/banners");
  },
  updateSeatStatus: function updateSeatStatus(payload) {
    return (0, _Api2.default)().put("/update-seat-status", payload);
  },
  getOrgDetails: function getOrgDetails() {
    return (0, _Api2.default)().get("/api/pos/getOrgDetails");
  },
  GetTodaysScreening: function GetTodaysScreening(payload) {
    var cinema = JSON.parse(localStorage.getItem("selected_cinema"));
    if (cinema) {
      payload.cinema_id = cinema.cinema_id;
    }
    var query = (0, _ApiHelper.createQueryString)(payload);
    return (0, _Api2.default)().get("/api/cinema/admin/now-showing-confirmed-list" + query);
  },
  GetCreateOwnShow: function GetCreateOwnShow(payload) {
    var cinema = JSON.parse(localStorage.getItem("selected_cinema"));
    if (cinema) {
      payload.cinema_id = cinema.cinema_id;
    }
    var query = (0, _ApiHelper.createQueryString)(payload);
    return (0, _Api2.default)().get("/api/cinema/admin/now-showing-list" + query + "&onDemand=true");
  },
  GetComingSoon: function GetComingSoon(payload) {
    var cinema = JSON.parse(localStorage.getItem("selected_cinema"));
    if (cinema) {
      payload.cinema_id = cinema.cinema_id;
    }
    var query = (0, _ApiHelper.createQueryString)(payload);
    return (0, _Api2.default)().get("/api/cinema/admin/upcoming-show-list" + query);
  },
  SearchMovie: function SearchMovie(payload) {
    payload.limit = 5;
    payload.currentPage = 1;
    var query = (0, _ApiHelper.createQueryString)(payload);
    return (0, _Api2.default)().get("/api/cinema/admin/search-movie" + query);
  },
  GetMovieDetails: function GetMovieDetails(payload) {
    var movie_id = payload.movie_id,
        content_lang_id = payload.content_lang_id,
        cinema_id = payload.cinema_id,
        md_for_ondemand = payload.md_for_ondemand,
        guest_user_id = payload.guest_user_id,
        cust_id = payload.cust_id;

    var query = (0, _ApiHelper.createQueryString)({
      cinema_id: cinema_id,
      md_for_ondemand: md_for_ondemand,
      guest_user_id: guest_user_id,
      cust_id: cust_id
    });
    return (0, _Api2.default)().get("/api/cinema/movie-detail/" + movie_id + "/" + content_lang_id + "/" + query);
  },
  getMovieConfirmedList: function getMovieConfirmedList(payload) {
    var movie_id = payload.movie_id,
        cinema_id = payload.cinema_id;

    var query = (0, _ApiHelper.createQueryString)(payload);
    return (0, _Api2.default)().get("/api/cinema/admin/movie-confirmed-list/" + movie_id + query);
  },
  getScheduleDetails: function getScheduleDetails(payload) {
    var ss_id = payload.ss_id;

    return (0, _Api2.default)().get("/api/cinema/schedule-details/" + ss_id);
  },
  getSeatLayout: function getSeatLayout(payload) {
    return (0, _Api2.default)().post("/api/external/seat-layout/", payload);
  },
  getSeatLayoutCreateScreen: function getSeatLayoutCreateScreen(payload) {
    return (0, _Api2.default)().post("/api/cinema/admin/seat-layout-list/", payload);
  },
  ReserveSeats: function ReserveSeats(payload) {
    return (0, _Api2.default)().post("/api/cinema/reserve-seat/", payload);
  },
  ReserveSeatsCreateShow: function ReserveSeatsCreateShow(payload) {
    return (0, _Api2.default)().post("/api/cinema/admin/reserve-seats", payload);
  },
  GetCountries: function GetCountries() {
    return (0, _Api2.default)().get("/api/external/countries");
  },
  GetReservationDetails: function GetReservationDetails(payload) {
    var reservation_id = payload.reservation_id;

    return (0, _Api2.default)().get("/api/external/reservation-detail/" + reservation_id);
  },
  GetCreateShowReservationDetails: function GetCreateShowReservationDetails(payload) {
    var reservation_id = payload.reservation_id;

    return (0, _Api2.default)().get("/api/cinema/admin/reservation-detail/" + reservation_id);
  },
  GetCreateShowDetails: function GetCreateShowDetails(payload) {
    var movie_id = payload.movie_id,
        cinema_id = payload.cinema_id,
        guest_user_id = payload.guest_user_id,
        fromDate = payload.fromDate;


    var query = (0, _ApiHelper.createQueryString)({
      cinema_id: cinema_id,
      guest_user_id: guest_user_id,
      fromDate: fromDate
    });

    return (0, _Api2.default)().get("/api/cinema/admin/v2/movie-schedule-list/" + movie_id + query);
  },
  ReserveShowsMyCinema: function ReserveShowsMyCinema(payload) {
    return (0, _Api2.default)().post("/api/cinema/admin/create-schedule/", payload);
    // https://cinematic-server-imaculix-1.brij.tech/api/cinema/admin/screening-type-list?mycinema_ss_d_id=901
  },
  GetScreeningType: function GetScreeningType(payload) {
    var mycinema_ss_d_id = payload.mycinema_ss_d_id;


    var query = (0, _ApiHelper.createQueryString)({
      mycinema_ss_d_id: mycinema_ss_d_id
    });
    return (0, _Api2.default)().get("/api/cinema/admin/screening-type-list/" + query);
  },
  BookSeats: function BookSeats(payload) {
    return (0, _Api2.default)().post("/api/cinema/book-seat", payload);
  },
  VistaBookSeats: function VistaBookSeats(payload) {
    return (0, _Api2.default)().post("/api/external/vista/book-seats-vista", payload);
  },
  GetBookingDetails: function GetBookingDetails(payload) {
    var sb_id = payload.sb_id;

    return (0, _Api2.default)().get("/api/cinema/booking-details/" + sb_id, payload);
  },
  GetBookingDetailsVista: function GetBookingDetailsVista(payload) {
    var sb_id = payload.sb_id;

    return (0, _Api2.default)().get("/api/external/vista/getBookingDetails/" + sb_id, payload);
  },
  GetCinemaList: function GetCinemaList(payload) {
    var query = (0, _ApiHelper.createQueryString)(payload);
    return (0, _Api2.default)().post("/api/external/cinemas" + query, payload);
  },
  GetActivePaymentModes: function GetActivePaymentModes(payload) {
    return (0, _Api2.default)().get("/api/external/payment-modes/" + payload);
  },
  createBrainTreeClientToken: function createBrainTreeClientToken(payload) {
    return (0, _Api2.default)().get("/api/cinema/braintree/generate-client-token/" + payload.cust_id);
  },
  MakePayment: function MakePayment(payload) {
    return (0, _Api2.default)().post("/api/cinema/braintree/pay", payload);
  },
  MakePaymentWithPaypal: function MakePaymentWithPaypal(payload) {
    return (0, _Api2.default)().post("/api/cinema/paypal/pay", payload);
  },
  ExecutePaymentWithPaypal: function ExecutePaymentWithPaypal(payload) {
    return (0, _Api2.default)().post("/api/cinema/paypal/execute", payload);
  },
  MakeVistaPayment: function MakeVistaPayment(payload) {
    return (0, _Api2.default)().post("/api/cinema/braintree/pay-vista", payload);
  },

  // MakePaymentWithPaypal(payload) {
  //   return Api().post(`/api/cinema/braintree/pay-paypal`, payload);
  // },
  // MakeVistaPaymentWithPaypal(payload) {
  //   return Api().post(`/api/cinema/braintree/pay-vista-paypal`, payload);
  // },
  GetFestivalList: function GetFestivalList(payload) {
    return (0, _Api2.default)().get("api/cinema/festival-list");
  },
  GetMiniFestivals: function GetMiniFestivals(payload) {
    var cinema = JSON.parse(localStorage.getItem("selected_cinema"));
    if (cinema) {
      payload.cinema_id = cinema.cinema_id;
    }
    var query = (0, _ApiHelper.createQueryString)(payload);
    console.log("query :>> ", query);
    return (0, _Api2.default)().get("api/cinema/get-minifestival-list" + query);
  },
  GetAllRegions: function GetAllRegions() {
    return (0, _Api2.default)().get("api/external/getRegions");
  },
  GetFilterList: function GetFilterList() {
    return (0, _Api2.default)().get("api/cinema/admin/filter-list");
  },
  GetVistaReservationDetails: function GetVistaReservationDetails(payload) {
    return (0, _Api2.default)().get("api/external/vista/reservation/" + payload.orderId);
  }
};

/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CountryService = exports.LanguageService = exports.TokenService = undefined;

var _stringify = __webpack_require__(101);

var _stringify2 = _interopRequireDefault(_stringify);

var _vue = __webpack_require__(59);

var _vue2 = _interopRequireDefault(_vue);

var _vueLocalstorage = __webpack_require__(576);

var _vueLocalstorage2 = _interopRequireDefault(_vueLocalstorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueLocalstorage2.default);

var TOKEN_KEY = 'access_token';
var COUNTRY = 'country';
var LANGUAGE = 'language';
/**
 * Manage the how Access Tokens are being stored and retreived from storage.
 *
 * Current implementation stores to localStorage. Local Storage should always be
 * accessed through this instace.
 **/
var TokenService = {
  getToken: function getToken() {
    return _vue2.default.localStorage.get(TOKEN_KEY);
  },
  saveToken: function saveToken(accessToken) {
    _vue2.default.localStorage.set(TOKEN_KEY, accessToken);
  },
  removeToken: function removeToken() {
    _vue2.default.localStorage.remove(TOKEN_KEY);
  }
};

var LanguageService = {
  getLanguage: function getLanguage() {
    return _vue2.default.localStorage.get(LANGUAGE);
  },
  saveLanguage: function saveLanguage(language) {
    this.$localStorage.set(LANGUAGE, language);
  },
  removeLanguage: function removeLanguage() {
    this.$localStorage.remove(LANGUAGE);
  }
};

var CountryService = {
  getCountry: function getCountry() {
    return JSON.parse(_vue2.default.localStorage.get(COUNTRY));
  },
  saveCountry: function saveCountry(country) {
    _vue2.default.localStorage.set(COUNTRY, (0, _stringify2.default)(country));
  },
  removeCountry: function removeCountry() {
    _vue2.default.localStorage.remove(COUNTRY);
  }
};
exports.TokenService = TokenService;
exports.LanguageService = LanguageService;
exports.CountryService = CountryService;

/***/ }),
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAxOSAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iOS41IiBjeT0iOS41IiByPSI5IiBzdHJva2U9IndoaXRlIi8+CjxsaW5lIHgxPSI0LjUiIHkxPSI5LjM2NjciIHgyPSIxNC41IiB5Mj0iOS4zNjY3IiBzdHJva2U9IndoaXRlIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg=="

/***/ }),
/* 51 */,
/* 52 */,
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(59);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventBus = new _vue2.default(); // event-bus.js
exports.default = EventBus;

/***/ }),
/* 54 */,
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// export const BASEURL = 'http://gogo-cinemacon.binarynumbers.io';
// export const BASEURL = 'http://gogocinema.binarynumbers.io';
// export const BASEURL = 'https://api.gogocinema.com';
// export const BASEURL = 'http://developmentgogocinema.binarynumbers.io';
// export const BASEURL = 'http://www.yogesh.com';
// export const BASEURL = 'https://api-uat.gogocinema.com';
// export const BASEURL = 'https://gogo-alpha-api.binarynumbers.io';
// export const BASEURL = 'http://13.228.128.234';
// export const BASEURL = 'http://api.gogocinema.com';

var url = "https://api-gogocinemas.enpointe.io" || "";
var stripePublicKey = "";
if (window.location.host === "test.gogocinema.com") {
  url = "https://api-test-1.binarynumbers.io";
  stripePublicKey = "pk_live_XmcqMGTPozqA2i9zxpyWzcwg004N11eO55";
} else if (window.location.host === "gogocinema.com") {
  url = "https://api-gdc-prod.binarynumbers.io";
  stripePublicKey = "pk_test_ugVaLIFJmaQKYnVc71msZtST00aJhA3Tds";
} else if (window.location.host === "test.gogocinema.com") {
  url = "https://api.gogocinema.com/api";
  stripePublicKey = "pk_live_XmcqMGTPozqA2i9zxpyWzcwg004N11eO55";
} else if (window.location.host === "test-uat.gogocinema.com") {
  url = "https://api-uat.gogocinema.com/api";
  stripePublicKey = "pk_live_XmcqMGTPozqA2i9zxpyWzcwg004N11eO55";
} else if (window.location.hostname == "gogo-1.brij.tech") {
  url = "https://api-gdc-1.brij.tech";
  stripePublicKey = "pk_test_ugVaLIFJmaQKYnVc71msZtST00aJhA3Tds";
} else if (window.location.hostname == "stg.gogocinema.com") {
  url = "https://api-gdc-1.brij.tech";
  stripePublicKey = "pk_test_ugVaLIFJmaQKYnVc71msZtST00aJhA3Tds";
} else if (window.location.hostname == "bnb-prod.gogocinema.com") {
  url = "https://api-gdc-1.brij.tech";
  stripePublicKey = "pk_test_ugVaLIFJmaQKYnVc71msZtST00aJhA3Tds";
} else if (window.location.hostname == "localhost") {
  //url = "http://localhost:3800";
  url = "https://api-gogocinemas.enpointe.io" || "http://localhost:4200";
  stripePublicKey = "pk_test_ugVaLIFJmaQKYnVc71msZtST00aJhA3Tds";
} else {
  url = "https://api-gogocinemas.enpointe.io" || "http://developmentgogocinema.binarynumbers.io/api";
  stripePublicKey = "pk_test_ugVaLIFJmaQKYnVc71msZtST00aJhA3Tds";
}
var ARENA_TOKEN = exports.ARENA_TOKEN = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6IjYwN2VkY2MwLTNjODQtNGRhZC1hY2VmLTBjN2FhYjNmMzU1MyIsImlhdCI6MTYwNjg5MzA0MCwiZXhwIjoxNjA5NDg1MDQwfQ.3dkWIqaDYXjJ0Eayq_nL8Q0rbmqfYcyI3NLZbcbKh8Y";
var BING_TOKEN = exports.BING_TOKEN = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6IjIwNTE5ZGM2LTNkODktNDViMi04OTM5LWM2Yjg4YmM2NmExNSIsImlhdCI6MTYxMjQzNzQzOSwiZXhwIjoxNjE1MDI5NDM5fQ.jMjwQUqQopck_eOQga-zTig3DDhuhnRLMpgSRo2_5s4";
var imaculix1 = exports.imaculix1 = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6IjRkMDE4OGIyLTdhNzctNDIzMy1iMjM5LTNlNTkyMmJmYTk3MyIsImlhdCI6MTYxMzIwODE4MSwiZXhwIjoxNjE1ODAwMTgxfQ.ZbFgp541YdJqRvR3P7BrZlLwN2Bv73bdgixWyaIMeBE";
var GOGOLIVE = exports.GOGOLIVE = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6IjdiNjZjZTcxLWE0YmYtNGNjNS1iM2Y5LTYwMzA5ZDhhZTI0ZCIsImlhdCI6MTYyODA2NDYxMSwiZXhwIjoxNjMwNjU2NjExfQ.Ulkr2mY0ZpE6-dTIa8O8abx2ETegjXxfJpl8ODFxN4E";
var cinema_Akil_dump1 = exports.cinema_Akil_dump1 = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6ImU0YmMxZmMzLWYyZmYtNDdiYy05OTQyLWQxZTE5NzZhYjZiOSIsImlhdCI6MTYyMjQ2ODQ2NCwiZXhwIjoxNjg1NTIwNjY1fQ.EYaseltsTkWgUbkW3ug0qPgoYb0yneodvYWS0deGbvo";
var GOGOLIVENEW = exports.GOGOLIVENEW = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6IjZhNmU2YjIzLTZmN2EtNDdmZS05Y2U3LWE3NDA0ZDJiYmJmYSIsImlhdCI6MTYzMTE5MjYzMSwiZXhwIjoxNjMzNzg0NjMxfQ.-Nw28gtaV7m43ztlzKdZZn-9L95l28o30xo9GQuqrvo";
//export const GOGOTEST = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6IjI2NzYzYzI3LTMzNjYtNDUzZS1hYWI2LTdkYjhkZWIwM2VjMSIsImlhdCI6MTYzODg3Nzc1NSwiZXhwIjoxNjQxNDY5NzU1fQ.xyiMlGWwaacTrswZFQFPSUCj4L6HrgJtmQqEVhKaMEU`;
var GOGOTEST = exports.GOGOTEST = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6IjdmYWExODNhLTMxOTctNDIxZS1iZDJkLTA3YTVlYjRlNjEwOCIsImlhdCI6MTYzODg3ODY4OSwiZXhwIjoxNjQxNDcwNjg5fQ.QoUmCOkmWq8xgs7kLKQCjZYsWhIrbxmHnNCxt6o-gw8';
var TOKEN = exports.TOKEN = GOGOLIVE;
var URL_BASE = exports.URL_BASE = url;
var STRIPE_PUBLIC_KEY = exports.STRIPE_PUBLIC_KEY = stripePublicKey;
var PROJECT_TITLE = exports.PROJECT_TITLE = "GoGoCinema";
var LIMIT = exports.LIMIT = "90";

/***/ }),
/* 56 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNSAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE3LjI5NzMgOC4zNDQ0NkwxMC44NDQ2IDE0LjQ5MzFMNy43NzAzIDExLjMxNzRDNy4zNjQ5IDEwLjkxMiA2LjcyMzAxIDEwLjkxMiA2LjM1MTM4IDExLjI4MzZDNS45NDU5OCAxMS42ODkgNS45NDU5OCAxMi4zMzA5IDYuMzE3NiAxMi43MDI2TDEwLjEwMTQgMTYuNTg3N0MxMC4zMDQxIDE2Ljc5MDQgMTAuNTc0NCAxNi44OTE4IDEwLjgxMDggMTYuODkxOEMxMS4wNDczIDE2Ljg5MTggMTEuMzE3NiAxNi43OTA0IDExLjUyMDMgMTYuNjIxNUwxOC43MTYzIDkuNzk3MTZDMTkuMTIxNyA5LjQyNTU0IDE5LjE1NTQgOC43ODM2NCAxOC43NSA4LjM3ODI0QzE4LjM0NDYgNy45NzI4MyAxNy43MDI3IDcuOTcyODMgMTcuMjk3MyA4LjM0NDQ2WiIgZmlsbD0iIzQ0QkI0QyIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTAgMTIuNUMwIDUuNjA4MTEgNS42MDgxMSAwIDEyLjUgMEMxOS4zOTE5IDAgMjUgNS42MDgxMSAyNSAxMi41QzI1IDE5LjM5MTkgMTkuMzkxOSAyNSAxMi41IDI1QzUuNjA4MTEgMjUgMCAxOS4zOTE5IDAgMTIuNVpNMi4wMjcwMiAxMi41QzIuMDI3MDIgMTguMjc3IDYuNzIyOTYgMjIuOTczIDEyLjUgMjIuOTczQzE4LjI3NyAyMi45NzMgMjIuOTczIDE4LjI3NyAyMi45NzMgMTIuNUMyMi45NzMgNi43MjI5NiAxOC4yNzcgMi4wMjcwMiAxMi41IDIuMDI3MDJDNi43MjI5NiAyLjAyNzAyIDIuMDI3MDIgNi43MjI5NiAyLjAyNzAyIDEyLjVaIiBmaWxsPSIjNDRCQjRDIi8+Cjwvc3ZnPgo="

/***/ }),
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loadMore.f18b1df.gif";

/***/ }),
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAxOSAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iOS41IiBjeT0iOS41IiByPSI5IiBzdHJva2U9IiMwMDAiLz4KPGxpbmUgeDE9IjQuNSIgeTE9IjkuMzY2NyIgeDI9IjE0LjUiIHkyPSI5LjM2NjciIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPgo="

/***/ }),
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Api = __webpack_require__(147);

var _Api2 = _interopRequireDefault(_Api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  Login: function Login(payload) {
    return (0, _Api2.default)().post("/api/cinema/sign-in", payload);
  },
  Register: function Register(payload) {
    return (0, _Api2.default)().post("/api/cinema/sign-up", payload);
  },
  ContactusMail: function ContactusMail(payload) {
    return (0, _Api2.default)().post("/api/external/mail", payload);
  },
  GetUserHistory: function GetUserHistory(payload) {
    return (0, _Api2.default)().post("/api/cinema/user-history", payload);
  },
  UpdateUser: function UpdateUser(payload) {
    return (0, _Api2.default)().post("/api/cinema/update-user", payload);
  },
  ForgotPassword: function ForgotPassword(payload) {
    return (0, _Api2.default)().post("/api/external/website-forgot-password", payload);
  },
  VerifyOTP: function VerifyOTP(payload) {
    return (0, _Api2.default)().post("/api/external/website-verify-otp", payload);
  },
  ResetPassword: function ResetPassword(payload) {
    return (0, _Api2.default)().post("/api/external/website-change-password", payload);
  },
  LoginViaOtp: function LoginViaOtp(payload) {
    return (0, _Api2.default)().post("/api/external/website-login-via-otp", payload);
  }
};

/***/ }),
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Api = __webpack_require__(147);

var _Api2 = _interopRequireDefault(_Api);

var _ApiHelper = __webpack_require__(294);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  GetVouchersList: function GetVouchersList(payload) {
    return (0, _Api2.default)().post("/api/external/offers-vouchers", payload);
  },
  ValidateVoucherCode: function ValidateVoucherCode(payload) {
    return (0, _Api2.default)().post("/api/external/verify-voucher", payload);
  },
  AddCustomerToSegment: function AddCustomerToSegment(payload) {
    return (0, _Api2.default)().post("/api/segments", payload);
  },
  VerifyVoucherCode: function VerifyVoucherCode(payload) {
    return (0, _Api2.default)().post("/api/external/v2/verify-voucher", payload);
  }
};

/***/ }),
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(283);

var _promise2 = _interopRequireDefault(_promise);

var _axios = __webpack_require__(291);

var _axios2 = _interopRequireDefault(_axios);

var _vue = __webpack_require__(59);

var _vue2 = _interopRequireDefault(_vue);

var _constants = __webpack_require__(55);

var _storage = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createAxiosInstance = function createAxiosInstance() {
  var instance = _axios2.default.create({
    baseURL: "" + _constants.URL_BASE
  });
  if (_constants.TOKEN) {
    instance.defaults.headers.common["Authorization"] = "" + _constants.TOKEN;
  }
  // instance.defaults.headers.common["Access-Control-Allow-Origin"] = "*";

  instance.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
    if (error.response && error.response.status === 401) {
      _storage.TokenService.removeToken();
    }
    return _promise2.default.reject(error);
  });
  return instance;
};

exports.default = createAxiosInstance;

/***/ }),
/* 148 */,
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OwnScreeningSlider_vue__ = __webpack_require__(586);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04438341_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OwnScreeningSlider_vue__ = __webpack_require__(1121);
function injectStyle (ssrContext) {
  __webpack_require__(1120)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OwnScreeningSlider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04438341_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OwnScreeningSlider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nowShowingSlider_vue__ = __webpack_require__(583);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74c34dd4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nowShowingSlider_vue__ = __webpack_require__(1117);
function injectStyle (ssrContext) {
  __webpack_require__(1116)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nowShowingSlider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74c34dd4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nowShowingSlider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpecialScreeningsSlider_vue__ = __webpack_require__(584);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a54f2b34_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpecialScreeningsSlider_vue__ = __webpack_require__(1119);
function injectStyle (ssrContext) {
  __webpack_require__(1118)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpecialScreeningsSlider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a54f2b34_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpecialScreeningsSlider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loader_vue__ = __webpack_require__(595);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0550247c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loader_vue__ = __webpack_require__(1139);
function injectStyle (ssrContext) {
  __webpack_require__(1138)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0550247c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.countryArray = exports.decodeFrontUserToken = exports.formatDate = exports.getCurrentDate = exports.getOptions = undefined;

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _vue = __webpack_require__(59);

var _vue2 = _interopRequireDefault(_vue);

var _cryptoJs = __webpack_require__(573);

var _cryptoJs2 = _interopRequireDefault(_cryptoJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getOptions = exports.getOptions = function getOptions(url, method, token, payload, direct) {
  // if((url.search('ticketak') == -1 || url.search('gogo') == -1) && direct){
  //     url = 'http://api.ticketak.com' + url
  // }

  var options = {
    method: method || 'GET',
    url: url,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  };
  if (token) {
    options.headers.Authorization = token;
  }

  // if (token) {
  //     options.headers['Authorization'] = `Bearer ${token}`
  // }

  if (method == 'GET' && payload) {
    options['params'] = payload;
  }

  if (payload) {
    options['method'] = method || 'POST';
    options['data'] = payload;
  }
  return options;
};

var getCurrentDate = exports.getCurrentDate = function getCurrentDate() {
  var dateTime = new Date();
  var date = dateTime.getDate();
  var month = dateTime.getMonth() + 1; // increment month by 1
  var year = dateTime.getFullYear();
  return year + '/' + month + '/' + date;
};

var formatDate = exports.formatDate = _vue2.default.filter('formatDate', function (value) {
  if (value) {
    return (0, _moment2.default)(String(value)).format('MMMM Do YYYY, h:mm:ss a');
  }
});

var decodeFrontUserToken = exports.decodeFrontUserToken = function decodeFrontUserToken(token) {
  // console.log("here Front token >>", token)
  return JSON.parse(_cryptoJs2.default.AES.decrypt(token, 'HereIsTheMyEncryptedCryptoSecretLOL').toString(_cryptoJs2.default.enc.Utf8));
};

var countryArray = exports.countryArray = [{
  name: "Israel",
  dial_code: "+972",
  code: "IL"
}, {
  name: "Afghanistan",
  dial_code: "+93",
  code: "AF"
}, {
  name: "Albania",
  dial_code: "+355",
  code: "AL"
}, {
  name: "Algeria",
  dial_code: "+213",
  code: "DZ"
}, {
  name: "AmericanSamoa",
  dial_code: "+1 684",
  code: "AS"
}, {
  name: "Andorra",
  dial_code: "+376",
  code: "AD"
}, {
  name: "Angola",
  dial_code: "+244",
  code: "AO"
}, {
  name: "Anguilla",
  dial_code: "+1 264",
  code: "AI"
}, {
  name: "Antigua and Barbuda",
  dial_code: "+1268",
  code: "AG"
}, {
  name: "Argentina",
  dial_code: "+54",
  code: "AR"
}, {
  name: "Armenia",
  dial_code: "+374",
  code: "AM"
}, {
  name: "Aruba",
  dial_code: "+297",
  code: "AW"
}, {
  name: "Australia",
  dial_code: "+61",
  code: "AU"
}, {
  name: "Austria",
  dial_code: "+43",
  code: "AT"
}, {
  name: "Azerbaijan",
  dial_code: "+994",
  code: "AZ"
}, {
  name: "Bahamas",
  dial_code: "+1 242",
  code: "BS"
}, {
  name: "Bahrain",
  dial_code: "+973",
  code: "BH"
}, {
  name: "Bangladesh",
  dial_code: "+880",
  code: "BD"
}, {
  name: "Barbados",
  dial_code: "+1 246",
  code: "BB"
}, {
  name: "Belarus",
  dial_code: "+375",
  code: "BY"
}, {
  name: "Belgium",
  dial_code: "+32",
  code: "BE"
}, {
  name: "Belize",
  dial_code: "+501",
  code: "BZ"
}, {
  name: "Benin",
  dial_code: "+229",
  code: "BJ"
}, {
  name: "Bermuda",
  dial_code: "+1 441",
  code: "BM"
}, {
  name: "Bhutan",
  dial_code: "+975",
  code: "BT"
}, {
  name: "Bosnia and Herzegovina",
  dial_code: "+387",
  code: "BA"
}, {
  name: "Botswana",
  dial_code: "+267",
  code: "BW"
}, {
  name: "Brazil",
  dial_code: "+55",
  code: "BR"
}, {
  name: "British Indian Ocean Territory",
  dial_code: "+246",
  code: "IO"
}, {
  name: "Bulgaria",
  dial_code: "+359",
  code: "BG"
}, {
  name: "Burkina Faso",
  dial_code: "+226",
  code: "BF"
}, {
  name: "Burundi",
  dial_code: "+257",
  code: "BI"
}, {
  name: "Cambodia",
  dial_code: "+855",
  code: "KH"
}, {
  name: "Cameroon",
  dial_code: "+237",
  code: "CM"
}, {
  name: "Canada",
  dial_code: "+1",
  code: "CA"
}, {
  name: "Cape Verde",
  dial_code: "+238",
  code: "CV"
}, {
  name: "Cayman Islands",
  dial_code: "+ 345",
  code: "KY"
}, {
  name: "Central African Republic",
  dial_code: "+236",
  code: "CF"
}, {
  name: "Chad",
  dial_code: "+235",
  code: "TD"
}, {
  name: "Chile",
  dial_code: "+56",
  code: "CL"
}, {
  name: "China",
  dial_code: "+86",
  code: "CN"
}, {
  name: "Christmas Island",
  dial_code: "+61",
  code: "CX"
}, {
  name: "Colombia",
  dial_code: "+57",
  code: "CO"
}, {
  name: "Comoros",
  dial_code: "+269",
  code: "KM"
}, {
  name: "Congo",
  dial_code: "+242",
  code: "CG"
}, {
  name: "Cook Islands",
  dial_code: "+682",
  code: "CK"
}, {
  name: "Costa Rica",
  dial_code: "+506",
  code: "CR"
}, {
  name: "Croatia",
  dial_code: "+385",
  code: "HR"
}, {
  name: "Cuba",
  dial_code: "+53",
  code: "CU"
}, {
  name: "Cyprus",
  dial_code: "+537",
  code: "CY"
}, {
  name: "Czech Republic",
  dial_code: "+420",
  code: "CZ"
}, {
  name: "Denmark",
  dial_code: "+45",
  code: "DK"
}, {
  name: "Djibouti",
  dial_code: "+253",
  code: "DJ"
}, {
  name: "Dominica",
  dial_code: "+1 767",
  code: "DM"
}, {
  name: "Dominican Republic",
  dial_code: "+1 849",
  code: "DO"
}, {
  name: "Ecuador",
  dial_code: "+593",
  code: "EC"
}, {
  name: "Egypt",
  dial_code: "+20",
  code: "EG"
}, {
  name: "El Salvador",
  dial_code: "+503",
  code: "SV"
}, {
  name: "Equatorial Guinea",
  dial_code: "+240",
  code: "GQ"
}, {
  name: "Eritrea",
  dial_code: "+291",
  code: "ER"
}, {
  name: "Estonia",
  dial_code: "+372",
  code: "EE"
}, {
  name: "Ethiopia",
  dial_code: "+251",
  code: "ET"
}, {
  name: "Faroe Islands",
  dial_code: "+298",
  code: "FO"
}, {
  name: "Fiji",
  dial_code: "+679",
  code: "FJ"
}, {
  name: "Finland",
  dial_code: "+358",
  code: "FI"
}, {
  name: "France",
  dial_code: "+33",
  code: "FR"
}, {
  name: "French Guiana",
  dial_code: "+594",
  code: "GF"
}, {
  name: "French Polynesia",
  dial_code: "+689",
  code: "PF"
}, {
  name: "Gabon",
  dial_code: "+241",
  code: "GA"
}, {
  name: "Gambia",
  dial_code: "+220",
  code: "GM"
}, {
  name: "Georgia",
  dial_code: "+995",
  code: "GE"
}, {
  name: "Germany",
  dial_code: "+49",
  code: "DE"
}, {
  name: "Ghana",
  dial_code: "+233",
  code: "GH"
}, {
  name: "Gibraltar",
  dial_code: "+350",
  code: "GI"
}, {
  name: "Greece",
  dial_code: "+30",
  code: "GR"
}, {
  name: "Greenland",
  dial_code: "+299",
  code: "GL"
}, {
  name: "Grenada",
  dial_code: "+1 473",
  code: "GD"
}, {
  name: "Guadeloupe",
  dial_code: "+590",
  code: "GP"
}, {
  name: "Guam",
  dial_code: "+1 671",
  code: "GU"
}, {
  name: "Guatemala",
  dial_code: "+502",
  code: "GT"
}, {
  name: "Guinea",
  dial_code: "+224",
  code: "GN"
}, {
  name: "Guinea-Bissau",
  dial_code: "+245",
  code: "GW"
}, {
  name: "Guyana",
  dial_code: "+595",
  code: "GY"
}, {
  name: "Haiti",
  dial_code: "+509",
  code: "HT"
}, {
  name: "Honduras",
  dial_code: "+504",
  code: "HN"
}, {
  name: "Hungary",
  dial_code: "+36",
  code: "HU"
}, {
  name: "Iceland",
  dial_code: "+354",
  code: "IS"
}, {
  name: "India",
  dial_code: "+91",
  code: "IN"
}, {
  name: "Indonesia",
  dial_code: "+62",
  code: "ID"
}, {
  name: "Iraq",
  dial_code: "+964",
  code: "IQ"
}, {
  name: "Ireland",
  dial_code: "+353",
  code: "IE"
}, {
  name: "Israel",
  dial_code: "+972",
  code: "IL"
}, {
  name: "Italy",
  dial_code: "+39",
  code: "IT"
}, {
  name: "Jamaica",
  dial_code: "+1 876",
  code: "JM"
}, {
  name: "Japan",
  dial_code: "+81",
  code: "JP"
}, {
  name: "Jordan",
  dial_code: "+962",
  code: "JO"
}, {
  name: "Kazakhstan",
  dial_code: "+7 7",
  code: "KZ"
}, {
  name: "Kenya",
  dial_code: "+254",
  code: "KE"
}, {
  name: "Kiribati",
  dial_code: "+686",
  code: "KI"
}, {
  name: "Kuwait",
  dial_code: "+965",
  code: "KW"
}, {
  name: "Kyrgyzstan",
  dial_code: "+996",
  code: "KG"
}, {
  name: "Latvia",
  dial_code: "+371",
  code: "LV"
}, {
  name: "Lebanon",
  dial_code: "+961",
  code: "LB"
}, {
  name: "Lesotho",
  dial_code: "+266",
  code: "LS"
}, {
  name: "Liberia",
  dial_code: "+231",
  code: "LR"
}, {
  name: "Liechtenstein",
  dial_code: "+423",
  code: "LI"
}, {
  name: "Lithuania",
  dial_code: "+370",
  code: "LT"
}, {
  name: "Luxembourg",
  dial_code: "+352",
  code: "LU"
}, {
  name: "Madagascar",
  dial_code: "+261",
  code: "MG"
}, {
  name: "Malawi",
  dial_code: "+265",
  code: "MW"
}, {
  name: "Malaysia",
  dial_code: "+60",
  code: "MY"
}, {
  name: "Maldives",
  dial_code: "+960",
  code: "MV"
}, {
  name: "Mali",
  dial_code: "+223",
  code: "ML"
}, {
  name: "Malta",
  dial_code: "+356",
  code: "MT"
}, {
  name: "Marshall Islands",
  dial_code: "+692",
  code: "MH"
}, {
  name: "Martinique",
  dial_code: "+596",
  code: "MQ"
}, {
  name: "Mauritania",
  dial_code: "+222",
  code: "MR"
}, {
  name: "Mauritius",
  dial_code: "+230",
  code: "MU"
}, {
  name: "Mayotte",
  dial_code: "+262",
  code: "YT"
}, {
  name: "Mexico",
  dial_code: "+52",
  code: "MX"
}, {
  name: "Monaco",
  dial_code: "+377",
  code: "MC"
}, {
  name: "Mongolia",
  dial_code: "+976",
  code: "MN"
}, {
  name: "Montenegro",
  dial_code: "+382",
  code: "ME"
}, {
  name: "Montserrat",
  dial_code: "+1664",
  code: "MS"
}, {
  name: "Morocco",
  dial_code: "+212",
  code: "MA"
}, {
  name: "Myanmar",
  dial_code: "+95",
  code: "MM"
}, {
  name: "Namibia",
  dial_code: "+264",
  code: "NA"
}, {
  name: "Nauru",
  dial_code: "+674",
  code: "NR"
}, {
  name: "Nepal",
  dial_code: "+977",
  code: "NP"
}, {
  name: "Netherlands",
  dial_code: "+31",
  code: "NL"
}, {
  name: "Netherlands Antilles",
  dial_code: "+599",
  code: "AN"
}, {
  name: "New Caledonia",
  dial_code: "+687",
  code: "NC"
}, {
  name: "New Zealand",
  dial_code: "+64",
  code: "NZ"
}, {
  name: "Nicaragua",
  dial_code: "+505",
  code: "NI"
}, {
  name: "Niger",
  dial_code: "+227",
  code: "NE"
}, {
  name: "Nigeria",
  dial_code: "+234",
  code: "NG"
}, {
  name: "Niue",
  dial_code: "+683",
  code: "NU"
}, {
  name: "Norfolk Island",
  dial_code: "+672",
  code: "NF"
}, {
  name: "Northern Mariana Islands",
  dial_code: "+1 670",
  code: "MP"
}, {
  name: "Norway",
  dial_code: "+47",
  code: "NO"
}, {
  name: "Oman",
  dial_code: "+968",
  code: "OM"
}, {
  name: "Pakistan",
  dial_code: "+92",
  code: "PK"
}, {
  name: "Palau",
  dial_code: "+680",
  code: "PW"
}, {
  name: "Panama",
  dial_code: "+507",
  code: "PA"
}, {
  name: "Papua New Guinea",
  dial_code: "+675",
  code: "PG"
}, {
  name: "Paraguay",
  dial_code: "+595",
  code: "PY"
}, {
  name: "Peru",
  dial_code: "+51",
  code: "PE"
}, {
  name: "Philippines",
  dial_code: "+63",
  code: "PH"
}, {
  name: "Poland",
  dial_code: "+48",
  code: "PL"
}, {
  name: "Portugal",
  dial_code: "+351",
  code: "PT"
}, {
  name: "Puerto Rico",
  dial_code: "+1 939",
  code: "PR"
}, {
  name: "Qatar",
  dial_code: "+974",
  code: "QA"
}, {
  name: "Romania",
  dial_code: "+40",
  code: "RO"
}, {
  name: "Rwanda",
  dial_code: "+250",
  code: "RW"
}, {
  name: "Samoa",
  dial_code: "+685",
  code: "WS"
}, {
  name: "San Marino",
  dial_code: "+378",
  code: "SM"
}, {
  name: "Saudi Arabia",
  dial_code: "+966",
  code: "SA"
}, {
  name: "Senegal",
  dial_code: "+221",
  code: "SN"
}, {
  name: "Serbia",
  dial_code: "+381",
  code: "RS"
}, {
  name: "Seychelles",
  dial_code: "+248",
  code: "SC"
}, {
  name: "Sierra Leone",
  dial_code: "+232",
  code: "SL"
}, {
  name: "Singapore",
  dial_code: "+65",
  code: "SG"
}, {
  name: "Slovakia",
  dial_code: "+421",
  code: "SK"
}, {
  name: "Slovenia",
  dial_code: "+386",
  code: "SI"
}, {
  name: "Solomon Islands",
  dial_code: "+677",
  code: "SB"
}, {
  name: "South Africa",
  dial_code: "+27",
  code: "ZA"
}, {
  name: "South Georgia and the South Sandwich Islands",
  dial_code: "+500",
  code: "GS"
}, {
  name: "Spain",
  dial_code: "+34",
  code: "ES"
}, {
  name: "Sri Lanka",
  dial_code: "+94",
  code: "LK"
}, {
  name: "Sudan",
  dial_code: "+249",
  code: "SD"
}, {
  name: "Suriname",
  dial_code: "+597",
  code: "SR"
}, {
  name: "Swaziland",
  dial_code: "+268",
  code: "SZ"
}, {
  name: "Sweden",
  dial_code: "+46",
  code: "SE"
}, {
  name: "Switzerland",
  dial_code: "+41",
  code: "CH"
}, {
  name: "Tajikistan",
  dial_code: "+992",
  code: "TJ"
}, {
  name: "Thailand",
  dial_code: "+66",
  code: "TH"
}, {
  name: "Togo",
  dial_code: "+228",
  code: "TG"
}, {
  name: "Tokelau",
  dial_code: "+690",
  code: "TK"
}, {
  name: "Tonga",
  dial_code: "+676",
  code: "TO"
}, {
  name: "Trinidad and Tobago",
  dial_code: "+1 868",
  code: "TT"
}, {
  name: "Tunisia",
  dial_code: "+216",
  code: "TN"
}, {
  name: "Turkey",
  dial_code: "+90",
  code: "TR"
}, {
  name: "Turkmenistan",
  dial_code: "+993",
  code: "TM"
}, {
  name: "Turks and Caicos Islands",
  dial_code: "+1 649",
  code: "TC"
}, {
  name: "Tuvalu",
  dial_code: "+688",
  code: "TV"
}, {
  name: "Uganda",
  dial_code: "+256",
  code: "UG"
}, {
  name: "Ukraine",
  dial_code: "+380",
  code: "UA"
}, {
  name: "United Arab Emirates",
  dial_code: "+971",
  code: "AE"
}, {
  name: "United Kingdom",
  dial_code: "+44",
  code: "GB"
}, {
  name: "United States",
  dial_code: "+1",
  code: "US"
}, {
  name: "Uruguay",
  dial_code: "+598",
  code: "UY"
}, {
  name: "Uzbekistan",
  dial_code: "+998",
  code: "UZ"
}, {
  name: "Vanuatu",
  dial_code: "+678",
  code: "VU"
}, {
  name: "Wallis and Futuna",
  dial_code: "+681",
  code: "WF"
}, {
  name: "Yemen",
  dial_code: "+967",
  code: "YE"
}, {
  name: "Zambia",
  dial_code: "+260",
  code: "ZM"
}, {
  name: "Zimbabwe",
  dial_code: "+263",
  code: "ZW"
}, {
  name: "land Islands",
  dial_code: "",
  code: "AX"
}, {
  name: "Antarctica",
  dial_code: null,
  code: "AQ"
}, {
  name: "Bolivia, Plurinational State of",
  dial_code: "+591",
  code: "BO"
}, {
  name: "Brunei Darussalam",
  dial_code: "+673",
  code: "BN"
}, {
  name: "Cocos (Keeling) Islands",
  dial_code: "+61",
  code: "CC"
}, {
  name: "Congo, The Democratic Republic of the",
  dial_code: "+243",
  code: "CD"
}, {
  name: "Cote d'Ivoire",
  dial_code: "+225",
  code: "CI"
}, {
  name: "Falkland Islands (Malvinas)",
  dial_code: "+500",
  code: "FK"
}, {
  name: "Guernsey",
  dial_code: "+44",
  code: "GG"
}, {
  name: "Holy See (Vatican City State)",
  dial_code: "+379",
  code: "VA"
}, {
  name: "Hong Kong",
  dial_code: "+852",
  code: "HK"
}, {
  name: "Iran, Islamic Republic of",
  dial_code: "+98",
  code: "IR"
}, {
  name: "Isle of Man",
  dial_code: "+44",
  code: "IM"
}, {
  name: "Jersey",
  dial_code: "+44",
  code: "JE"
}, {
  name: "Korea, Democratic People's Republic of",
  dial_code: "+850",
  code: "KP"
}, {
  name: "Korea, Republic of",
  dial_code: "+82",
  code: "KR"
}, {
  name: "Lao People's Democratic Republic",
  dial_code: "+856",
  code: "LA"
}, {
  name: "Libyan Arab Jamahiriya",
  dial_code: "+218",
  code: "LY"
}, {
  name: "Macao",
  dial_code: "+853",
  code: "MO"
}, {
  name: "Macedonia, The Former Yugoslav Republic of",
  dial_code: "+389",
  code: "MK"
}, {
  name: "Micronesia, Federated States of",
  dial_code: "+691",
  code: "FM"
}, {
  name: "Moldova, Republic of",
  dial_code: "+373",
  code: "MD"
}, {
  name: "Mozambique",
  dial_code: "+258",
  code: "MZ"
}, {
  name: "Palestinian Territory, Occupied",
  dial_code: "+970",
  code: "PS"
}, {
  name: "Pitcairn",
  dial_code: "+872",
  code: "PN"
}, {
  name: "Réunion",
  dial_code: "+262",
  code: "RE"
}, {
  name: "Russia",
  dial_code: "+7",
  code: "RU"
}, {
  name: "Saint Barthélemy",
  dial_code: "+590",
  code: "BL"
}, {
  name: "Saint Helena, Ascension and Tristan Da Cunha",
  dial_code: "+290",
  code: "SH"
}, {
  name: "Saint Kitts and Nevis",
  dial_code: "+1 869",
  code: "KN"
}, {
  name: "Saint Lucia",
  dial_code: "+1 758",
  code: "LC"
}, {
  name: "Saint Martin",
  dial_code: "+590",
  code: "MF"
}, {
  name: "Saint Pierre and Miquelon",
  dial_code: "+508",
  code: "PM"
}, {
  name: "Saint Vincent and the Grenadines",
  dial_code: "+1 784",
  code: "VC"
}, {
  name: "Sao Tome and Principe",
  dial_code: "+239",
  code: "ST"
}, {
  name: "Somalia",
  dial_code: "+252",
  code: "SO"
}, {
  name: "Svalbard and Jan Mayen",
  dial_code: "+47",
  code: "SJ"
}, {
  name: "Syrian Arab Republic",
  dial_code: "+963",
  code: "SY"
}, {
  name: "Taiwan, Province of China",
  dial_code: "+886",
  code: "TW"
}, {
  name: "Tanzania, United Republic of",
  dial_code: "+255",
  code: "TZ"
}, {
  name: "Timor-Leste",
  dial_code: "+670",
  code: "TL"
}, {
  name: "Venezuela, Bolivarian Republic of",
  dial_code: "+58",
  code: "VE"
}, {
  name: "Viet Nam",
  dial_code: "+84",
  code: "VN"
}, {
  name: "Virgin Islands, British",
  dial_code: "+1 284",
  code: "VG"
}, {
  name: "Virgin Islands, U.S.",
  dial_code: "+1 340",
  code: "VI"
}];

/***/ }),
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Api = __webpack_require__(147);

var _Api2 = _interopRequireDefault(_Api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    getSeatLayout: function getSeatLayout(payload) {
        return (0, _Api2.default)().get("/api/rts/seat-layout/" + payload.rts_performance_id);
    },
    reserveSeats: function reserveSeats(payload) {
        return (0, _Api2.default)().post("/api/rts/reserve-seats/" + payload.rts_performance_id, payload);
    },
    makeRtsPayment: function makeRtsPayment(payload) {
        return (0, _Api2.default)().post("/api/cinema/braintree/pay-rts", payload);
    },
    getReservationDetails: function getReservationDetails(payload) {
        return (0, _Api2.default)().get("/api/rts/reserve-details/" + payload.reserve_id);
    },
    getBookingDetails: function getBookingDetails(payload) {
        return (0, _Api2.default)().get("/api/rts/book-details/" + payload.reserve_id);
    }
};

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_progressRing_vue__ = __webpack_require__(624);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0b53c1e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_progressRing_vue__ = __webpack_require__(1236);
function injectStyle (ssrContext) {
  __webpack_require__(1235)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_progressRing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0b53c1e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_progressRing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_NavigatorShare_vue__ = __webpack_require__(629);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_190f0165_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_NavigatorShare_vue__ = __webpack_require__(1249);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_NavigatorShare_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_190f0165_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_NavigatorShare_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/new-gogo-logo.010b230.svg";

/***/ }),
/* 215 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mac1.682e024.png";

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mac3.145a7f4.png";

/***/ }),
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(59);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(204);

var _vuex2 = _interopRequireDefault(_vuex);

var _vuexPersist = __webpack_require__(1425);

var _vuexPersist2 = _interopRequireDefault(_vuexPersist);

var _modules = __webpack_require__(824);

var _modules2 = _interopRequireDefault(_modules);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var vuexPersist = new _vuexPersist2.default({
  key: "my-app",
  storage: window.localStorage,
  modules: []
});

exports.default = new _vuex2.default.Store({
  modules: _modules2.default,
  plugins: [vuexPersist.plugin],
  strict: "production" !== "production"
});

/***/ }),
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EventBus = undefined;

var _stringify = __webpack_require__(101);

var _stringify2 = _interopRequireDefault(_stringify);

__webpack_require__(849);

var _vue = __webpack_require__(59);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(1026);

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__(581);

var _router2 = _interopRequireDefault(_router);

var _bootstrapVue = __webpack_require__(1386);

var _bootstrapVue2 = _interopRequireDefault(_bootstrapVue);

var _vueMeta = __webpack_require__(1424);

var _vueMeta2 = _interopRequireDefault(_vueMeta);

var _vueSlick = __webpack_require__(18);

var _vueSlick2 = _interopRequireDefault(_vueSlick);

var _vuex = __webpack_require__(204);

var _vuex2 = _interopRequireDefault(_vuex);

var _store = __webpack_require__(239);

var _store2 = _interopRequireDefault(_store);

var _vueLocalstorage = __webpack_require__(576);

var _vueLocalstorage2 = _interopRequireDefault(_vueLocalstorage);

var _vueGoogleSigninButton = __webpack_require__(1464);

var _vueGoogleSigninButton2 = _interopRequireDefault(_vueGoogleSigninButton);

var _vueFacebookSigninButton = __webpack_require__(1465);

var _vueFacebookSigninButton2 = _interopRequireDefault(_vueFacebookSigninButton);

var _vueCarousel3d = __webpack_require__(1466);

var _vueCarousel3d2 = _interopRequireDefault(_vueCarousel3d);

var _calendar = __webpack_require__(634);

var _calendar2 = _interopRequireDefault(_calendar);

__webpack_require__(1467);

var _veeValidate = __webpack_require__(1468);

var _veeValidate2 = _interopRequireDefault(_veeValidate);

var _cryptoJs = __webpack_require__(573);

var _cryptoJs2 = _interopRequireDefault(_cryptoJs);

var _lodash = __webpack_require__(77);

var _lodash2 = _interopRequireDefault(_lodash);

var _vueLazyload = __webpack_require__(1469);

var _vueLazyload2 = _interopRequireDefault(_vueLazyload);

var _vueDebounce = __webpack_require__(1470);

var _vueDebounce2 = _interopRequireDefault(_vueDebounce);

__webpack_require__(1471);

__webpack_require__(1472);

__webpack_require__(1473);

__webpack_require__(1474);

__webpack_require__(1475);

__webpack_require__(1476);

var _vueTelInput = __webpack_require__(1477);

var _vueTelInput2 = _interopRequireDefault(_vueTelInput);

var _vueHtmlToPaper = __webpack_require__(1541);

var _vueHtmlToPaper2 = _interopRequireDefault(_vueHtmlToPaper);

var _vueInfiniteScroll = __webpack_require__(1542);

var _vueInfiniteScroll2 = _interopRequireDefault(_vueInfiniteScroll);

var _currencyFormat = __webpack_require__(1543);

var _timeFormat = __webpack_require__(1544);

var _vueBraintree = __webpack_require__(1545);

var _vueBraintree2 = _interopRequireDefault(_vueBraintree);

var _vueLoadingOverlay = __webpack_require__(1547);

var _vueLoadingOverlay2 = _interopRequireDefault(_vueLoadingOverlay);

__webpack_require__(1548);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
var secretKey = "HereIsTheMySecretKey_LOL";
// import {  } from "@/components/";

var VueScrollTo = __webpack_require__(129);


_vue2.default.use(_vueBraintree2.default);
_vue2.default.use(_vueInfiniteScroll2.default);
var pjson = __webpack_require__(1549);
// Vue.use(VueScrollTo)
_vue2.default.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: -100,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});

var options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: ["https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css", "https://unpkg.com/kidlat-css/css/kidlat.css"]
};
_vue2.default.use(_vueHtmlToPaper2.default, options);
_vue2.default.use(_vueTelInput2.default);

// Import component

// Import stylesheet

_vue2.default.use(_vueLoadingOverlay2.default);
_vue2.default.use(_vueLazyload2.default, {
  preLoad: 1.3,
  error: "/static/placeholder-image.png",
  loading: "/static/placeholder-image.png",
  attempt: 1
});

_vue2.default.use(_vueDebounce2.default);
_vue2.default.use(_vuex2.default);

_vue2.default.mixin({
  data: function data() {
    return {
      LOADING: null,
      packageVersion: pjson,
      // isShowLoading: false,
      countryId: 230,
      languageId: 2,
      selectedMainDate: "",
      secureStore: {
        set: function set(key, value) {
          var setEncryptedData = _cryptoJs2.default.AES.encrypt((0, _stringify2.default)(value), secretKey).toString();
          window.localStorage.setItem(key, setEncryptedData);
        },
        get: function get(key) {
          var getEncryptedData = window.localStorage.getItem(key);
          if (!_lodash2.default.isNull(getEncryptedData)) return JSON.parse(_cryptoJs2.default.AES.decrypt(getEncryptedData, secretKey).toString(_cryptoJs2.default.enc.Utf8));
          return null;
        },
        remove: function remove(key) {
          window.localStorage.removeItem(key);
        }
      },
      sessionStore: {
        set: function set(key, value) {
          var setEncryptedData = _cryptoJs2.default.AES.encrypt((0, _stringify2.default)(value), secretKey).toString();
          window.sessionStorage.setItem(key, setEncryptedData);
        },
        get: function get(key) {
          var getEncryptedData = window.sessionStorage.getItem(key);
          if (!_lodash2.default.isNull(getEncryptedData)) return JSON.parse(_cryptoJs2.default.AES.decrypt(getEncryptedData, secretKey).toString(_cryptoJs2.default.enc.Utf8));
          return null;
        },
        remove: function remove(key) {
          window.sessionStorage.removeItem(key);
        }
      },
      encrypt: function encrypt(value) {
        _cryptoJs2.default.AES.encrypt((0, _stringify2.default)(value), secretKey).toString();
      },
      decrypt: function decrypt(value) {
        return JSON.parse(_cryptoJs2.default.AES.decrypt(value, secretKey).toString(_cryptoJs2.default.enc.Utf8));
      }
    };
  },
  computed: {
    timeFormat: function timeFormat() {
      var tFormat = "am/pm";
      return (0, _timeFormat.getTimeFormatter)(tFormat);
    },
    currFormat: function currFormat() {
      var cFormat = void 0;
      var precesion = void 0;
      var global_options_latest = this.$store.getters.getGlobalOptions;
      cFormat = global_options_latest.find(function (x) {
        return x.go_key == "CURR_FORMAT";
      });
      precesion = global_options_latest.find(function (x) {
        return x.go_key == "MIN_FRACTION_DIGITS";
      });
      if (cFormat && cFormat.go_value) {
        cFormat = cFormat.go_value;
      } else {
        cFormat = "en-US";
      }
      if (precesion && precesion.go_value) {
        precesion = precesion.go_value;
      } else {
        precesion = 2;
      }
      return (0, _currencyFormat.getNumberFormatter)(cFormat, precesion);
    }
  },
  methods: {
    showLoading: function showLoading() {
      this.LOADING = this.$loading.show({
        color: "#e70d00",
        loader: "spinner",
        width: 105,
        height: 105,
        class: "css-loader",
        backgroundColor: "rgba(0, 0, 0, 0.5);",
        opacity: 0.5,
        zIndex: 99999
      });
      document.body.classList.add("modal-open");
    },

    hideLoading: function hideLoading() {
      this.LOADING ? this.LOADING.hide() : "";
      document.body.classList.remove("modal-open");
    }
  }
});
_vue2.default.use(_vueCarousel3d2.default);
_vue2.default.use(_veeValidate2.default);
_vue2.default.use(_vueGoogleSigninButton2.default);
_vue2.default.use(_vueFacebookSigninButton2.default);
_vue2.default.use(_vueMeta2.default);
_vue2.default.use(_bootstrapVue2.default);
_vue2.default.use(_vueLocalstorage2.default, {
  name: "persistStore"
});
_vue2.default.config.productionTip = false;

// Created the Event Bus for the call parent function
var EventBus = exports.EventBus = new _vue2.default();
var Calendar = _vue2.default.component("calendar", {
  template: "#calendar"
});
/* eslint-disable no-new */
new _vue2.default({
  el: "#app",
  router: _router2.default,
  store: _store2.default,
  template: "<App/>",
  components: {
    App: _App2.default
  }
});

/***/ }),
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createQueryString = undefined;

var _toConsumableArray2 = __webpack_require__(125);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _keys = __webpack_require__(276);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createQueryString = exports.createQueryString = function createQueryString() {
    var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var query = "";
    if ((0, _keys2.default)(payload).length > 0) {
        var urlparams = new URLSearchParams();
        for (var key in payload) {
            if (payload[key]) {
                urlparams.append(key, payload[key]);
            }
        }
        if ([].concat((0, _toConsumableArray3.default)(urlparams.entries())).length > 0) {
            query += "?" + urlparams.toString();
        }
    }
    return query;
};

/***/ }),
/* 295 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAG1SURBVHgBpZRNTgJBEIVfFYq6MOoN8ATqDfQIE90zLozBDRLcuBJWLoxBVyyFA5jhBuIJxBtwBHaa0em2qodRHIafwEuAZqr4uvp1FYSU7pvPPuW4aC325eu2vAZE6NnItKul4xamiJLFbTMorOYQUAyZpH5ocHRd8vpZQU5AecbLENRHhArnsVM994gNdmFw6p4DLk/zs2Ar+qYJmmiNbefW6bJy6g2ShEpcRavxFHSiT/tATMU1OYE8O0jDSD0C85PuLNUcjILSEuC2CfHmNo4i7+ripPPvmGq2WxnUp4FclRI3ER5dFcx+Os7DW1PzuphDKxtoxWeivTEY4utPvJmpkeoLWTAXVD8wh0ZucswS1obUxXdofMyhPMyhW1j7OgazEdpxiVyeVV1N48w3MYw6Y7BqyWvJGGh1BfOFxiSggrYkjtirvv4uneOalgw8q41r4UsfHUrv1UNwV8dGIZsfYkGIsvkzvZO14e9sNsRYM5wETJC0UVc+3sXnMjNqlTOvnglLdN8MfEkuWhr+a1g3kz1LUfvqPO74u2ZQE9hNGkhYUFnAhWFZwKVgaeDSsBFg8QdZv7ezojcwiAAAAABJRU5ErkJggg=="

/***/ }),
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB2aWV3Qm94PSIwIDAgNTIgNTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUyIDUyOyIgZmlsbD0iI0U3MEQwMCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggZD0iTTI2LDBDMTEuNjY0LDAsMCwxMS42NjMsMCwyNnMxMS42NjQsMjYsMjYsMjZzMjYtMTEuNjYzLDI2LTI2UzQwLjMzNiwwLDI2LDB6IE00MC40OTUsMTcuMzI5bC0xNiwxOAoJCUMyNC4xMDEsMzUuNzcyLDIzLjU1MiwzNiwyMi45OTksMzZjLTAuNDM5LDAtMC44OC0wLjE0NC0xLjI0OS0wLjQzOGwtMTAtOGMtMC44NjItMC42ODktMS4wMDItMS45NDgtMC4zMTItMi44MTEKCQljMC42ODktMC44NjMsMS45NDktMS4wMDMsMi44MTEtMC4zMTNsOC41MTcsNi44MTNsMTQuNzM5LTE2LjU4MWMwLjczMi0wLjgyNiwxLjk5OC0wLjksMi44MjMtMC4xNjYKCQlDNDEuMTU0LDE1LjIzOSw0MS4yMjksMTYuNTAzLDQwLjQ5NSwxNy4zMjl6Ii8+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg=="

/***/ }),
/* 310 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTM0IiBoZWlnaHQ9IjEzNCIgdmlld0JveD0iMCAwIDEzNCAxMzQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik05MC43ODUzIDQzLjg3MThDOTEuODQxOCA0Mi43NTU3IDkzLjYyOTUgNDIuNzEwMiA5NC43NDY3IDQzLjc0MTFMOTguNzY3NCA0Ny40NTEzQzk5Ljg5ODcgNDguNDk1MiA5OS45NjEzIDUwLjI1NzcgOTguOTIyNCA1MS4zNzE1TDU5LjkyODcgOTMuMTc3OUM1OC44ODMgOTQuMjk5MSA1Ny4yMDMgOTQuMjY5NCA1Ni4xNzgxIDkzLjExMzdMMzUuNzEyMiA3MC4wMzZDMzQuNjg2NSA2OC44NzkzIDM0Ljc4NTMgNjcuMDgyNSAzNS45MDE0IDY2LjA1MTVMMzkuOTE4MyA2Mi4zNDE0QzQxLjA0ODUgNjEuMjk3NSA0Mi44MDYxIDYxLjM5NDUgNDMuODIzOSA2Mi41MzU1TDU2LjgwMDkgNzcuMDgzOUM1Ny40ODI3IDc3Ljg0ODIgNTguNjA4IDc3Ljg2MjcgNTkuMzEwMSA3Ny4xMjExTDkwLjc4NTMgNDMuODcxOFoiIGZpbGw9IiM0NEJCNEMiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02NyAxMzFDMTAyLjM0NiAxMzEgMTMxIDEwMi4zNDYgMTMxIDY3QzEzMSAzMS42NTM4IDEwMi4zNDYgMyA2NyAzQzMxLjY1MzggMyAzIDMxLjY1MzggMyA2N0MzIDEwMi4zNDYgMzEuNjUzOCAxMzEgNjcgMTMxWiIgc3Ryb2tlPSIjOEQ5OUFFIiBzdHJva2Utd2lkdGg9IjUiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02NyAxMjdDMTAwLjEzNyAxMjcgMTI3IDEwMC4xMzcgMTI3IDY3QzEyNyAzMy44NjI5IDEwMC4xMzcgNyA2NyA3QzMzLjg2MjkgNyA3IDMzLjg2MjkgNyA2N0M3IDEwMC4xMzcgMzMuODYyOSAxMjcgNjcgMTI3WiIgc3Ryb2tlPSIjRURGMkY0IiBzdHJva2Utd2lkdGg9IjciLz4KPC9zdmc+Cg=="

/***/ }),
/* 311 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTciIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCA5NyAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00OC41IDI3QzU1Ljk1NTggMjcgNjIgMjAuOTU1OCA2MiAxMy41QzYyIDYuMDQ0MTYgNTUuOTU1OCAwIDQ4LjUgMEM0MS4wNDQyIDAgMzUgNi4wNDQxNiAzNSAxMy41QzM1IDIwLjk1NTggNDEuMDQ0MiAyNyA0OC41IDI3WiIgZmlsbD0iI0VERjJGNCIvPgo8cGF0aCBkPSJNNDUuNjk4MiAxNy4yOEM0Ny41NTQyIDE3LjI4IDQ4LjgwMjIgMTYuMDY0IDQ4LjgwMjIgMTQuMjRDNDguODAyMiAxMi40MTYgNDcuNTU0MiAxMS4yIDQ1LjY5ODIgMTEuMkM0My44MzQyIDExLjIgNDIuNTg2MiAxMi40MTYgNDIuNTg2MiAxNC4yNEM0Mi41ODYyIDE2LjA2NCA0My44MzQyIDE3LjI4IDQ1LjY5ODIgMTcuMjhaTTQ1LjY5ODIgMTYuMzQ0QzQ0LjUzODIgMTYuMzQ0IDQzLjc1NDIgMTUuNTA0IDQzLjc1NDIgMTQuMjRDNDMuNzU0MiAxMi45NzYgNDQuNTM4MiAxMi4xMzYgNDUuNjk4MiAxMi4xMzZDNDYuODU4MiAxMi4xMzYgNDcuNjM0MiAxMi45NzYgNDcuNjM0MiAxNC4yNEM0Ny42MzQyIDE1LjUwNCA0Ni44NTgyIDE2LjM0NCA0NS42OTgyIDE2LjM0NFpNNTMuNTQwNCAxNy4ySDU0Ljg2ODRMNTMuMzA4NCAxNC44MDhDNTMuOTk2NCAxNC41MTIgNTQuNDA0NCAxMy45MiA1NC40MDQ0IDEzLjE1MkM1NC40MDQ0IDEyLjAzMiA1My41ODA0IDExLjI4IDUyLjMzMjQgMTEuMjhINDkuODUyNFYxNy4ySDUwLjk4MDRWMTUuMDI0SDUyLjE4ODRMNTMuNTQwNCAxNy4yWk01MC45ODA0IDEyLjIxNkg1Mi4yMDQ0QzUyLjgyODQgMTIuMjE2IDUzLjI0NDQgMTIuNTkyIDUzLjI0NDQgMTMuMTUyQzUzLjI0NDQgMTMuNzEyIDUyLjc5NjQgMTQuMDg4IDUyLjEyNDQgMTQuMDg4SDUwLjk4MDRWMTIuMjE2WiIgZmlsbD0iIzhEOTlBRSIvPgo8cGF0aCBkPSJNNjkuNSAxMy41SDk2LjUiIHN0cm9rZT0iIzhEOTlBRSIgc3Ryb2tlLW9wYWNpdHk9IjAuNSIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIvPgo8cGF0aCBkPSJNMC41IDEzLjI1SDI3LjUiIHN0cm9rZT0iIzhEOTlBRSIgc3Ryb2tlLW9wYWNpdHk9IjAuNSIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIvPgo8L3N2Zz4K"

/***/ }),
/* 312 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI3LjA2MyIgaGVpZ2h0PSI3LjAxOCIgdmlld0JveD0iMCAwIDcuMDYzIDcuMDE4Ij4KICA8ZyBpZD0ibUdCeEZRLnRpZiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTcwNi4zNDMgLTM3NC45MDEpIj4KICAgIDxnIGlkPSJHcm91cF8xMTUxIiBkYXRhLW5hbWU9Ikdyb3VwIDExNTEiPgogICAgICA8cGF0aCBpZD0iUGF0aF8yNTQ0IiBkYXRhLW5hbWU9IlBhdGggMjU0NCIgZD0iTTcwOS41ODYsMzgwLjY2N2wtMS45MzctMS45NDIsMy44MDctMy44MjQsMS45NSwxLjk1N1oiIGZpbGw9IiM4MDgwODAiLz4KICAgICAgPHBhdGggaWQ9IlBhdGhfMjU0NSIgZGF0YS1uYW1lPSJQYXRoIDI1NDUiIGQ9Ik03MDYuOTU3LDM3OS40MzhsMS45MjIsMS45LTIuNTM2LjU3OFoiIGZpbGw9IiM4MDgwODAiLz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo="

/***/ }),
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_burger_menu__ = __webpack_require__(1027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_burger_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_burger_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_partials_header_vue__ = __webpack_require__(1028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_partials_footer_vue__ = __webpack_require__(1105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_youtube_embed__ = __webpack_require__(1108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_partials_connectionLost__ = __webpack_require__(1109);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



 // import the CSS transitions you wish to use, in this case we are using `Slide`





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      pageName: "",
      onLine: navigator.onLine,
      // onLine: false,
      showBackOnline: false
    };
  },
  beforeMount: function beforeMount() {
    this.$store.dispatch("fetchGlobalOptions");
    this.$store.dispatch("fetchCountries");
  },
  mounted: function mounted() {
    this.pageName = this.$route.name;
    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOnlineStatus);
  },

  components: {
    Header: __WEBPACK_IMPORTED_MODULE_3__components_partials_header_vue__["a" /* default */],
    Footer: __WEBPACK_IMPORTED_MODULE_4__components_partials_footer_vue__["a" /* default */],
    Slide: __WEBPACK_IMPORTED_MODULE_2_vue_burger_menu__["Slide"],
    connectionLost: __WEBPACK_IMPORTED_MODULE_6__components_partials_connectionLost__["a" /* default */]
  },

  name: "app",
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("online", this.updateOnlineStatus);
    window.removeEventListener("offline", this.updateOnlineStatus);
  },

  methods: {
    updateOnlineStatus: function updateOnlineStatus(e) {
      var type = e.type;

      this.onLine = type === "online";
    }
  }
});

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_internet_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__helper_internet_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_storage_service__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_storage_service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__services_storage_service__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__eventBus_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__eventBus_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__eventBus_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_cookie_law__ = __webpack_require__(1093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_cookie_law___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_cookie_law__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_partials_BottomBar_vue__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helper_constants__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helper_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__helper_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_mainService_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_mainService_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__services_mainService_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_AuthServices_js__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_AuthServices_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__services_AuthServices_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_debounce__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_debounce__);




var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      Regions: [],
      selectedRegion: "",
      selectedRegionId: null,
      DATEYEAR: "",
      phone: "",
      backdrop: false,
      rightOpen: "-100vw",
      hideSearch: "-100vw",
      fbSignInParams: {
        scope: "email",
        return_scopes: false
      },
      googleSignInParams: {
        client_id: "911938447926-kls328d23otm80v12n1jq13h8ajeh57f.apps.googleusercontent.com"
      },
      // User Details
      userDetails: {
        password: "",
        email: "",
        CountryCode: "1",
        phoneNumber: "",
        OTP: ["", "", "", "", "", ""],
        userName: "",
        termsAndConditions: true,
        ConfirmPassword: "",
        country_id: 38,
        country_mob_code: "1"
      },
      socialLoginError: {
        error: ""
      },
      countries: [],
      selectedCity: {
        CityName: "",
        CityID: ""
      },
      selectedCityName: "",
      countryData: {},
      errorMessage: {
        login: "",
        signUp: "",
        checkout: "",
        otp: "",
        forgotpassword: "",
        resetPassword: ""
      },
      showBottom: false,
      modal: {
        signUp: {
          info: true,
          OTP: false
        },
        signIn: {
          info: true,
          OTP: false
        },
        forgotpassword: {
          email: true,
          OTP: false,
          resetPassword: false
        }
      },
      isUserLoggedIn: false,
      searchValue: "",
      movieListSearch: [],
      CountryCodeList: [],
      TITLE: __WEBPACK_IMPORTED_MODULE_8__helper_constants__["PROJECT_TITLE"],
      CountryText: "",
      imageCountry: "",
      checkPhoneNumber: "",
      TempCust: {},
      searchCode: "",
      countriesCopy: [],
      passwordRequiredMessage: "Password is Required.",
      passwordValidationMessage: "Password must contain minimum 6 characters, Contains at least one Lowercase letter, one Uppercase letter and one Number"
    };
  },

  computed: {
    usernameInfo: function usernameInfo() {
      if (localStorage.getItem("user")) {
        var user = JSON.parse(localStorage.getItem("user"));
        var username = user.first_name;
        return username;
      } else {
        return false;
      }
    }
  },
  beforeMount: function beforeMount() {
    if (!localStorage.getItem("guest_user_id")) {
      localStorage.setItem("guest_user_id", Math.floor(100000000 + Math.random() * 900000000));
    }
    var city = window.localStorage.getItem("City");
    city = JSON.parse(city);
    if (city) {
      this.selectedCity = city;
      this.selectedCityName = this.selectedCity.CityName;
    }

    this.getAllRegionList();
  },

  mounted: function mounted() {
    var _this = this;

    this.getAllGetCountryList();
    this.checkToken();
    this.getNowShowingData();
    this.getUserProfile();
    __WEBPACK_IMPORTED_MODULE_5__eventBus_js___default.a.$on("MakeUserLogin", function () {
      _this.checkToken();
    });
    __WEBPACK_IMPORTED_MODULE_5__eventBus_js___default.a.$on("profileUpdate", function () {
      _this.$forceUpdate();
    });
    __WEBPACK_IMPORTED_MODULE_5__eventBus_js___default.a.$on("onSingnUp", function (userDetails) {
      // this.$refs.signUp.show();
      _this.userDetails = userDetails;
      _this.SignUpUser();
    });
    __WEBPACK_IMPORTED_MODULE_5__eventBus_js___default.a.$on("OnGoogleSignIn", function (googleUser) {
      _this.onGoogleSignInSuccess(googleUser);
    });
    __WEBPACK_IMPORTED_MODULE_5__eventBus_js___default.a.$on("OnFacebookSignIn", function (response) {
      _this.onSignFBInSuccess(response);
    });
    __WEBPACK_IMPORTED_MODULE_5__eventBus_js___default.a.$on("SHOWSIGNIN", function () {
      _this.checkSignIn();
    });
    __WEBPACK_IMPORTED_MODULE_5__eventBus_js___default.a.$on("CHECKROUTE", function (val) {
      _this.showBottom = val;
    });
    this.checkRoute();
    // this.getAllCountry();
    this.checkPhoneNumber = this.userDetails.phoneNumber;
  },

  components: {
    CookieLaw: __WEBPACK_IMPORTED_MODULE_6_vue_cookie_law___default.a,
    BOTTOMBAR: __WEBPACK_IMPORTED_MODULE_7__components_partials_BottomBar_vue__["a" /* default */]
  },
  methods: (_methods = {
    resetError: function resetError() {
      this.errorMessage.login = "";
    },
    hideModal: function hideModal() {
      this.$refs.registerMsg.hide();
    },
    checkValidPhone: function checkValidPhone(e) {
      if (String(e.key) !== "Backspace" && String(e.key).match(/^[a-zA-Z!@#\$%\^\&*\\"\'\;\:\[\]\{\}\(\)\`\/\~)\(+=._-]+$/g)) {
        this.userDetails.phoneNumber = this.checkPhoneNumber;
      } else if (String(e.key) !== "Backspace") {
        this.checkPhoneNumber = this.userDetails.phoneNumber;
      }
    },
    checkRoute: function checkRoute() {
      var array = [
      // {
      //   routeName: "offers-promotions",
      //   value: "2"
      // },
      {
        routeName: "myaccount",
        value: "4"
      }, {
        routeName: "myTransaction",
        value: "3"
      }, {
        routeName: "cinema-page",
        value: "5"
      }, {
        routeName: "cinema-movie-list",
        value: "5"
      }];
      var count = 0;
      var path = window.location.pathname;
      array.map(function (x) {
        if (path == "/") {
          __WEBPACK_IMPORTED_MODULE_5__eventBus_js___default.a.$emit("BOTTOMTABCHANGE", "1");
          count++;
        } else if (path.includes(x.routeName)) {
          setTimeout(function () {
            __WEBPACK_IMPORTED_MODULE_5__eventBus_js___default.a.$emit("BOTTOMTABCHANGE", x.value);
          }, 200);
          count++;
        }
      });
      if (count > 0) {
        this.showBottom = true;
      } else {
        this.showBottom = false;
      }
    },
    getAllRegionList: function getAllRegionList() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_9__services_mainService_js___default.a.GetAllRegions().then(function (response) {
        var data = response.data;

        if (data.status) {
          _this2.Regions = data.Records;
          var obj = {
            region_id: null,
            region_name: "All"
          };
          _this2.Regions.unshift(obj);
          _this2.selectedRegion = "All";
        } else {
          _this2.Regions = [];
        }
      }).catch(function (err) {
        console.log("Error:", err);
      });
    },
    onSearchCode: function onSearchCode() {
      var _this3 = this;

      if (this.searchCode && this.searchCode.length > 0) {
        this.CountryCodeList = this.countriesCopy.filter(function (x) {
          if (x.country_mob_code && x.country_mob_code.toLowerCase().includes(_this3.searchCode.toLowerCase())) {
            return x;
          } else if (x.country_name && x.country_name.toLowerCase().includes(_this3.searchCode.toLowerCase())) {
            return x;
          }
        });
      } else {
        this.CountryCodeList = this.countriesCopy;
      }
    },
    showForgotPassword: function showForgotPassword() {
      this.$refs["signInModal"].hide();
      this.$refs["forgotpasswordEmailModal"].show();
    },
    showSignUp: function showSignUp() {
      this.$refs["signInModal"].hide();
      this.$refs["signUp"].show();
    },
    showSignIn: function showSignIn() {
      this.$refs["signUp"].hide();
      this.$refs["signInModal"].show();
    },
    Redirect: function Redirect() {
      if (this.countryData == null) {
        window.location.pathname = "/";
      } else {
        this.$router.push({
          path: "/"
        });
      }
    },

    onClickCountrySelector: function onClickCountrySelector() {
      this.openSideNav();

      this.$refs.countryModalRef.show();
    },
    closeMenu: function closeMenu() {
      this.$refs.hovermenu.hide();
    },

    getUserProfile: function getUserProfile() {
      var _this4 = this;

      var token = __WEBPACK_IMPORTED_MODULE_4__services_storage_service__["TokenService"].getToken();
      Object(__WEBPACK_IMPORTED_MODULE_3__helper_internet_js__["makeRequest"])("/Account/GetUserProfile", "POST", token, null).then(function (result) {
        if (!result.error && result.res.data) {
          _this4.isUserLoggedIn = true;
        } else {
          __WEBPACK_IMPORTED_MODULE_4__services_storage_service__["TokenService"].removeToken();
        }
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_4__services_storage_service__["TokenService"].removeToken();
        console.log("Error", error);
      });
    },
    getNowShowingData: function getNowShowingData() {
      var _this5 = this;

      var payload = {
        Version: "1"
      };
      Object(__WEBPACK_IMPORTED_MODULE_3__helper_internet_js__["makeRequest"])("/GetShows/", "POST", null, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        _this5.userDetails.CountryCode = res.data.Default && res.data.Default.CountryISOCode;
      }).catch(function (error) {
        console.log("Error", error);
      });
    },
    getAllCountry: function getAllCountry(country) {
      var _this6 = this;

      var array = ["hiw", "coming-soon", "termsCondition", "privacyPolicy", "faqs", "cookiesprivacyPolicy", "aboutus"];
      var self = this;
      this.countryData = __WEBPACK_IMPORTED_MODULE_4__services_storage_service__["CountryService"].getCountry();
      var count = 0;
      var path = window.location.pathname;
      array.map(function (x) {
        if (path.includes(x)) {
          count++;
        }
      });
      __WEBPACK_IMPORTED_MODULE_9__services_mainService_js___default.a.GetCountries().then(function (response) {
        var data = response.data;

        if (data.status) {
          _this6.countries = data.data;
          _this6.countriesCopy = data.data;
        }
      }).catch(function (err) {
        console.log("error:", err);
      });
    },
    getAllGetCountryList: function getAllGetCountryList() {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_9__services_mainService_js___default.a.GetCountries().then(function (response) {
        var data = response.data;

        if (data.data.length > 0) {
          _this7.CountryCodeList = data.data;
          _this7.countries = data.data;
          _this7.countriesCopy = data.data;
          var countryId = _this7.$store.getters.getGlobalOptions.filter(function (x) {
            return x.go_key == "OPERATION_COUNTRY";
          });
          if (countryId.length > 0) {
            var findCountryObj = data.data.filter(function (z) {
              return z.country_id == countryId[0].go_value;
            });
            console.log(findCountryObj, "findCountryObj");
          }
        }
      }).catch(function (err) {
        console.log("error:", err);
      });
    },
    setCountry: function setCountry(country) {
      this.CountryText = country.country_code;
      __WEBPACK_IMPORTED_MODULE_4__services_storage_service__["CountryService"].saveCountry(country);
      window.location = "/";
      this.countryData = country;
    },
    onChangeCityName: function onChangeCityName(selectedData) {
      this.selectedCity = selectedData;
      this.selectedCityName = this.selectedCity.CityName;
      window.localStorage.setItem("City", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(selectedData));
    },
    onChangeRegion: function onChangeRegion(region) {
      this.selectedRegion = region.region_name;
      this.selectedRegionId = region.region_id;
      this.searchValue = "";
      this.movieListSearch = [];
    },

    onChangeCountry: function onChangeCountry(country) {
      this.userDetails.CountryCode = country.country_mob_code;
      this.userDetails.country_mob_code = country.country_mob_code;
      this.userDetails.country_id = country.country_id;
    },

    onInput: function onInput(_ref) {
      var number = _ref.number,
          isValid = _ref.isValid,
          country = _ref.country;

      this.userDetails.phoneNumber = number;
      this.userDetails.CountryCode = country.dialCode;
    },

    onCheck: function onCheck() {
      this.userDetails.termsAndConditions = !this.userDetails.termsAndConditions;
    },
    openSideNav: function openSideNav() {
      this.rightOpen = this.rightOpen == "0vw" ? "-100vw" : "0vw";
      if (this.rightOpen == "0vw") {
        document.getElementsByTagName("body")[0].style.overflow = "hidden";
        this.backdrop = true;
      } else {
        document.getElementsByTagName("body")[0].style.overflow = "auto";
        this.backdrop = false;
      }
    },
    checkToken: function checkToken() {
      var checkUserLoggedIn = localStorage.getItem("user");
      if (checkUserLoggedIn) {
        this.isUserLoggedIn = true;
      }
    },
    OTPonKeyUp: function OTPonKeyUp(item, e) {
      this.userDetails.OTP[item] = e.data;
      if (e.data != "" && e.data != null && item < 5) {
        var value = "fotp" + (item + 2);
        this.$refs[value].focus();
      }
      var array = this.userDetails.OTP.filter(function (x) {
        return x != "" && x != null;
      });

      if (array.length == 6) {
        this.verifyForgotPasswordOtp();
      }
    },
    OTPonKeyUp1: function OTPonKeyUp1(item, e) {
      this.userDetails.OTP[item] = e.data;
      if (e.data != "" && e.data != null && item < 3) {
        var value = "sotp" + (item + 1);
        this.$refs[value].focus();
      }
      var array = this.userDetails.OTP.filter(function (x) {
        return x != "" && x != null;
      });

      if (array.length == 4) {
        this.verifyOtp();
      }
    },
    hideSignIn: function hideSignIn() {
      this.userDetails.OTP = ["", "", "", "", "", ""];
      this.userDetails.email = "";
      this.userDetails.password = "";
      this.$refs.signInModal.hide();
      this.resetError();
    },
    hideSignUp: function hideSignUp() {
      this.userDetails.email = "";
      this.userDetails.password = "";
      this.userDetails.phoneNumber = "";
      this.$refs.signUp.hide();
      this.resetError();
    },
    hideSignUpOTP: function hideSignUpOTP() {
      this.userDetails.email = "";
      this.userDetails.password = "";
      this.userDetails.phoneNumber = "";
      this.OTP = ["", "", "", "", "", ""];
      this.$refs.OTPModal.hide();
      this.resetError();
    },
    hideForgotPassword: function hideForgotPassword() {
      this.userDetails.email = "";
      this.$refs.forgotpasswordEmailModal.hide();
      this.resetError();
    },
    hideForgotPasswordOTPModal: function hideForgotPasswordOTPModal() {
      this.userDetails.email = "";
      this.userDetails.OTP = ["", "", "", "", "", ""];
      this.$refs.ForgotPasswordOTPModal.hide();
      this.resetError();
    },
    hideresetPassword: function hideresetPassword() {
      this.userDetails.email = "";
      this.userDetails.OTP = ["", "", "", "", "", ""];
      this.userDetails.password = "";
      this.userDetails.ConfirmPassword = "";
      this.$refs.resetPassword.hide();
      this.resetError();
    },
    onClickOTP: function onClickOTP(item, e) {
      var val = "sotp" + item;
      this.$refs[val].value = "";
    },

    searchData: function searchData() {
      if (this.searchValue) {
        this.searchAPI();
      } else {
        this.movieListSearch = [];
      }
    },
    topNavHandler: function topNavHandler() {
      this.openSearch(false);
    },
    openSearch: function openSearch(status) {
      this.movieListSearch = [];
      if (status) {
        if (this.hideSearch == "0vw") {
          this.hideSearch = "-100vw";
        } else {
          this.hideSearch = "0vw";
        }
      } else if (!status) {
        this.hideSearch = "-100vw";
      }
    },
    searchAPI: function searchAPI() {
      var _this8 = this;

      this.movieListSearch = [];
      __WEBPACK_IMPORTED_MODULE_9__services_mainService_js___default.a.SearchMovie({
        search: this.searchValue,
        region_id: this.selectedRegionId
      }).then(function (response) {
        var data = response.data;

        if (data && data.Records.data.length > 0) {
          _this8.movieListSearch = data.Records.data;
        } else {
          _this8.movieListSearch = [];
        }
      }).catch(function (err) {
        console.log("Error", err);
      });
    },
    onSignFBInSuccess: function onSignFBInSuccess(response) {
      var _this9 = this;

      console.log("Facebook Response >>>>>>>", response);
      Object(__WEBPACK_IMPORTED_MODULE_3__helper_internet_js__["makeRequest"])("/Account/SocialLogin", "POST", null, {
        FireBaseID: "",
        TokenFrom: "Facebook",
        stoken: response.authResponse.accessToken
      }).then(function (result) {
        console.log("Check Socal Facebook response From here ", result);
        //send token to loginuser
        _this9.loginUser(result.res.data.access_token);
        _this9.isUserLoggedIn = true;
        _this9.modal.signIn.info = false;
        _this9.$refs.signInModal.hide();
        _this9.$refs.signUp.hide();
        __WEBPACK_IMPORTED_MODULE_5__eventBus_js___default.a.$emit("onProfileSuccess");
        //result has
      }).catch(function (error) {
        console.log("Face book Login Error", error);
      });
      // Testing;
      FB.api("/me", function (data) {
        console.log("Facebook Data ", data);
      });
    },
    onSignFBInError: function onSignFBInError(error) {
      var _this10 = this;

      this.socialLoginError.error = "Whoops, !Something went wrong";
      setTimeout(function () {
        _this10.socialLoginError.error = "";
      }, 5000);
    },


    //google
    onGoogleSignInSuccess: function onGoogleSignInSuccess(googleUser) {
      var _this11 = this;

      var profile = googleUser.getBasicProfile();
      Object(__WEBPACK_IMPORTED_MODULE_3__helper_internet_js__["makeRequest"])("/Account/SocialLogin", "POST", null, {
        FireBaseID: "",
        TokenFrom: "Google",
        stoken: googleUser.Zi.id_token
      }).then(function (result) {
        _this11.modal.signIn.info = false;
        __WEBPACK_IMPORTED_MODULE_4__services_storage_service__["TokenService"].saveToken(result.res.data.access_token);
        _this11.isUserLoggedIn = true;
        __WEBPACK_IMPORTED_MODULE_5__eventBus_js___default.a.$emit("onProfileSuccess");
        // window.location = "/";
      }).catch(function (error) {
        console.log("Google Login Error", error);
      });
    },
    onGoogleSignInError: function onGoogleSignInError(error) {
      var _this12 = this;

      // `error` contains any error occurred.
      this.socialLoginError.error = "Whoops, !Something went wrong";
      setTimeout(function () {
        _this12.socialLoginError.error = "";
      }, 5000);
    },
    validateBeforeSubmit: function validateBeforeSubmit(scope) {
      var _this13 = this;

      if (scope == "signIn") {
        this.$validator.validateAll(scope).then(function (result) {
          if (result) {
            var payload = {
              email: _this13.userDetails.email,
              password: _this13.userDetails.password
            };
            __WEBPACK_IMPORTED_MODULE_10__services_AuthServices_js___default.a.Login(payload).then(function (response) {
              var data = response.data;

              if (data.status && data.Records && data.Records.length > 0) {
                _this13.isUserLoggedIn = true;
                window.localStorage.setItem("user", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(data.Records[0]));
                _this13.modal.signIn.info = false;
                _this13.$refs.registerMsg.hide();
              } else {
                _this13.errorMessage.login = data.message;
              }
            }).catch(function (err) {
              console.log("error:", err);
              _this13.errorMessage.login = data.message;
            });
          }
        });
      }

      if (scope == "signUp") {
        this.errorMessage.signUp = "";
        this.userDetails.ConfirmPassword = this.userDetails.password;
        console.log(this.$validator.validateAll(scope));
        this.$validator.validateAll(scope).then(function (result) {
          if (_this13.userDetails.termsAndConditions && _this13.userDetails.email && _this13.userDetails.password && _this13.userDetails.CountryCode && _this13.userDetails.phoneNumber) {
            _this13.SignUpUser();
            return;
          } else {
            _this13.errorMessage.signUp = "Please fill in all the details";
          }
        }).catch(function (err) {
          console.log("result err", err);
        });
      }
      if (scope == "forgotPassword") {
        this.$validator.validateAll(scope).then(function (result) {
          if (result) {
            _this13.sendResetOTP();
          }
          return;
        });
      }
      if (scope == "resetPasswordForm") {
        this.errorMessage.resetPassword = "";
        this.$validator.validateAll(scope).then(function (result) {
          if (result) {
            if (_this13.userDetails.password == _this13.userDetails.ConfirmPassword) {
              var payload = {
                cust_email: _this13.TempCust.cust_email,
                cust_id: _this13.TempCust.cust_id,
                first_name: _this13.TempCust.first_name,
                otp: _this13.userDetails.OTP.toString().replace(/,/g, ""),
                password: _this13.userDetails.password
              };
              __WEBPACK_IMPORTED_MODULE_10__services_AuthServices_js___default.a.ResetPassword(payload).then(function (response) {
                var data = response.data;

                if (data.status) {
                  _this13.$refs.ForgotPasswordOTPModal.hide();
                  _this13.$refs.resetPassword.hide();
                  _this13.$refs.resetPasswordSuccessModal.show();
                } else {
                  _this13.errorMessage.resetPassword = data.message;
                }
              }).catch(function (err) {
                console.log("error: ", err);
                _this13.errorMessage.resetPassword = "Something went wrong";
              });
            } else {
              _this13.errorMessage.resetPassword = "Password do not match with confirm Password";
              return;
            }
            return;
          }
        });
      }
      if (scope == "fortpasswordVerifyOtp") {
        this.verifyForgotPasswordOtp();
      }
      if (scope == "verifyOtp") {
        this.verifyOtp();
      }
      if (scope == "signUpVerifyOTP") {
        this.verifyUser();
      }
    },
    SignUpUser: function SignUpUser() {
      var _this14 = this;

      this.showLoading();
      var payload = {
        email: this.userDetails.email,
        phone_no: this.userDetails.phoneNumber,
        password: this.userDetails.password,
        country_id: this.userDetails.country_id,
        first_name: this.userDetails.userName
      };
      __WEBPACK_IMPORTED_MODULE_10__services_AuthServices_js___default.a.Register(payload).then(function (response) {
        var data = response.data;

        console.log("data response", data, response);
        if (data.status) {
          console.log("data", data);
          _this14.$refs.signUp.hide();
          _this14.$refs.registerMsg.show();
          // this.$refs.OTPModal.show();
          _this14.errorMessage.signUp = data.message;
          __WEBPACK_IMPORTED_MODULE_5__eventBus_js___default.a.$emit("onSignUpError", _this14.errorMessage.signUp);
          __WEBPACK_IMPORTED_MODULE_5__eventBus_js___default.a.$emit("onSignUpSuccess");
        } else {
          _this14.errorMessage.signUp = data.message;
          __WEBPACK_IMPORTED_MODULE_5__eventBus_js___default.a.$emit("onSignUpError", data.message);
        }
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_5__eventBus_js___default.a.$emit("onSignUpError", err);
        console.log("error:", err);
      }).finally(function () {
        _this14.hideLoading();
      });
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "resetError", function resetError() {
    var _this15 = this;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.errorMessage).map(function (x) {
      _this15.errorMessage[x] = "";
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "loginUser", function loginUser(token) {
    __WEBPACK_IMPORTED_MODULE_4__services_storage_service__["TokenService"].saveToken(token);
    this.isUserLoggedIn = true;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "sendResetOTP", function sendResetOTP() {
    var _this16 = this;

    this.showLoading();
    var payload = {
      email: this.userDetails.email
    };
    __WEBPACK_IMPORTED_MODULE_10__services_AuthServices_js___default.a.ForgotPassword(payload).then(function (response) {
      var data = response.data;

      if (data.status) {
        _this16.TempCust = data.Records[0];
        _this16.$refs.forgotpasswordEmailModal.hide();
        _this16.$refs.ForgotPasswordOTPModal.show();
        _this16.modal.forgotpassword.OTP = true;
        _this16.errorMessage.otp = "";
      } else {
        _this16.errorMessage.forgotpassword = data.message;
      }
    }).catch(function (err) {
      console.log("error:", err);
      _this16.errorMessage.forgotpassword = "Something went wrong";
    }).finally(function () {
      _this16.hideLoading();
    });
    // makeRequest("/Account/ResetPassword/", "POST", null, payload)
    //   .then(response => {
    //     const { error, res } = response;
    //     this.hideLoading();
    //     if (!error && res.data.Status) {
    //       this.$refs.forgotpasswordEmailModal.hide();
    //       this.$refs.ForgotPasswordOTPModal.show();
    //       this.modal.forgotpassword.OTP = true;
    //       this.errorMessage.otp = "";
    //       this.OTP = ["", "", "", ""];
    //     } else {
    //       this.hideLoading();
    //       this.errorMessage.forgotpassword = res.data.Message;
    //     }
    //   })
    //   .catch(error => {
    //     console.log("Error", error);
    //     this.errorMessage.forgotpassword = "Something went wrong";
    //   });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "verifyForgotPasswordOtp", function verifyForgotPasswordOtp() {
    var _this17 = this;

    this.errorMessage.otp = "";
    this.userDetails.password = "";
    this.showLoading();
    var payload = {
      cust_id: this.TempCust.cust_id,
      otp: this.userDetails.OTP.toString().replace(/,/g, "")
    };
    __WEBPACK_IMPORTED_MODULE_10__services_AuthServices_js___default.a.VerifyOTP(payload).then(function (response) {
      var data = response.data;

      if (data.status) {
        _this17.$refs.ForgotPasswordOTPModal.hide();
        _this17.$refs.resetPassword.show();
      } else {
        _this17.errorMessage.otp = data.message;
      }
    }).catch(function (err) {
      console.log("error:", err);
      _this17.errorMessage.otp = "Something Went Wrong";
    }).finally(function () {
      _this17.hideLoading();
    });
    // makeRequest("/Account/VerifyOTP/", "POST", null, payload)
    //   .then(response => {
    //     this.hideLoading();
    //     const { error, res } = response;
    //     if (!error && res.data.Status) {
    //       this.$refs.ForgotPasswordOTPModal.hide();
    //       this.$refs.resetPassword.show();
    //     } else {
    //       this.hideLoading();
    //       this.errorMessage.otp = res.data.Message;
    //     }
    //   })
    //   .catch(error => {
    //     console.log("Error", error);
    //     this.errorMessage.otp = error;
    //     //   resolve(null);
    //   });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "verifyOtp", function verifyOtp() {
    var _this18 = this;

    this.errorMessage.otp = "";
    this.showLoading();
    var payload = {
      Email: this.userDetails.email,
      MobileNo: this.userDetails.phoneNumber,
      Password: this.userDetails.password,
      UserName: this.userDetails.userName,
      OTP: this.userDetails.OTP.toString().replace(/,/g, ""),
      FireBaseID: "e-SmvRUQAnM:APA91bF_Am5XZRsi-hsRwPMqk9CrJhDG1Jt-JCaXs2x0sAhEX7OM1phK8BEJPIlRJK2zogz-G01_DjIrGrGMlXLntRQjkpvHrxUlYl9Tcom-jinT6OSFPWiys9qNT21VZfmVEhbjW6Vm"
    };

    Object(__WEBPACK_IMPORTED_MODULE_3__helper_internet_js__["makeRequest"])("/Account/Verifyme", "POST", null, payload).then(function (response) {
      _this18.hideLoading();
      var error = response.error,
          res = response.res;

      if (!error && res.data.Status) {
        // Switch to OTP section
        _this18.$refs.OTPModal.hide();
        _this18.$refs.verifyContact.show();
        setTimeout(function () {
          _this18.$refs.verifyContact.hide();
        }, 3000);
        _this18.loginUser(res.data.access_token);
        __WEBPACK_IMPORTED_MODULE_5__eventBus_js___default.a.$emit("onProfileSuccess");
      } else {
        _this18.errorMessage.otp = res.data.Message;
      }
    }).catch(function (error) {
      console.log("Error", error);
      //   resolve(null);
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "onLogout", function onLogout() {
    window.localStorage.removeItem("access_token");
    window.localStorage.removeItem("user");
    window.location.reload();
    window.location.pathname = "/";
    this.isUserLoggedIn = false;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "checkSignIn", function checkSignIn() {
    if (this.isUserLoggedIn === false) {
      this.$refs.signInModal.show();
    }
  }), _methods)
});

/***/ }),
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BottomBar_vue__ = __webpack_require__(578);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3455c084_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BottomBar_vue__ = __webpack_require__(1095);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BottomBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3455c084_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BottomBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slick__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_internet_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__helper_internet_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eventBus_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eventBus_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__eventBus_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_storage_service__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_storage_service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__services_storage_service__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "NowShowingSlider",

  components: {
    Slick: __WEBPACK_IMPORTED_MODULE_0_vue_slick__["default"]
  },
  data: function data() {
    return {
      routeName: "",
      loadingNow: true,
      selectedBottomTab: ["1"]
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3__eventBus_js___default.a.$on("BOTTOMTABCHANGE", function (val) {
      _this.selectedBottomTab = [];
      _this.selectedBottomTab.push(val);
    });
  },

  watch: {},
  computed: {},
  methods: {
    bottomTab: function bottomTab(val) {
      this.selectedBottomTab = [];
      this.selectedBottomTab.push(val);

      if (val == "1") {
        this.$router.push({
          path: "/"
        });
      } else if (val == "2") {
        this.$router.push({
          path: "/offers-promotions"
        });
      } else if (val == "5") {
        this.$router.push({
          path: "/cinema-page"
        });
      } else if (val == "3") {
        if (!localStorage.getItem("user")) {
          __WEBPACK_IMPORTED_MODULE_3__eventBus_js___default.a.$emit("SHOWSIGNIN");
        } else {
          this.$router.push({
            path: "/profile/myTransaction"
          });
        }
      } else if (val == "4") {
        if (!localStorage.getItem("user")) {
          __WEBPACK_IMPORTED_MODULE_3__eventBus_js___default.a.$emit("SHOWSIGNIN");
        } else {
          this.$router.push({
            path: "/profile/myaccount"
          });
        }
      }
    }
  }
});

/***/ }),
/* 579 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_internet_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__helper_internet_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_storage_service__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_storage_service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__services_storage_service__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eventBus_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eventBus_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__eventBus_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_constants__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__helper_constants__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "footer-main",
  components: {},
  data: function data() {
    return {
      pathname: false,
      pop: false,
      email: "",
      dateYear: "",
      message: "",
      slickOptions: {
        slidesToShow: 3
      },
      TITLE: __WEBPACK_IMPORTED_MODULE_3__helper_constants__["PROJECT_TITLE"]
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2__eventBus_js___default.a.$on("FOOTERSET", function (val) {
      _this.pathname = val;
    });
    __WEBPACK_IMPORTED_MODULE_2__eventBus_js___default.a.$on("DateSet", function (val) {
      _this.dateYear = val;
    });
    if (window.location.pathname.length == "1") {
      this.pathname = true;
    } else {
      this.pathname = false;
    }
  },

  methods: {
    //   footerset(val){
    //     this.pathname=val;
    // },
    show: function show() {
      this.pop = !this.pop;
    },

    subscribe: function subscribe() {
      var _this2 = this;

      var bool = validateEmail(this.email);

      if (!bool) {
        this.message = "Please Enter Valid Email";
      } else {
        var token = __WEBPACK_IMPORTED_MODULE_1__services_storage_service__["TokenService"].getToken();
        var payload = {
          Email: this.email
        };
        Object(__WEBPACK_IMPORTED_MODULE_0__helper_internet_js__["makeRequest"])("/Subscribe/", "POST", token, payload).then(function (response) {
          var error = response.error,
              res = response.res;

          if (res.data.Status) {
            _this2.message = res.data.Message;
          } else {
            _this2.message = res.data.Message;
          }
        }).catch(function (error) {
          _this2.message = "You must be a user to subscribe";
        });
      }

      function validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
      }
    }
  }
});

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(59);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(275);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _home = __webpack_require__(1114);

var _home2 = _interopRequireDefault(_home);

var _movieDetails = __webpack_require__(1147);

var _movieDetails2 = _interopRequireDefault(_movieDetails);

var _movieListing = __webpack_require__(1150);

var _movieListing2 = _interopRequireDefault(_movieListing);

var _seatlayout = __webpack_require__(1153);

var _seatlayout2 = _interopRequireDefault(_seatlayout);

var _payment = __webpack_require__(1233);

var _payment2 = _interopRequireDefault(_payment);

var _VistaPayment = __webpack_require__(1238);

var _VistaPayment2 = _interopRequireDefault(_VistaPayment);

var _RtsPayment = __webpack_require__(1241);

var _RtsPayment2 = _interopRequireDefault(_RtsPayment);

var _createShowpayment = __webpack_require__(1244);

var _createShowpayment2 = _interopRequireDefault(_createShowpayment);

var _confirmScreen = __webpack_require__(1247);

var _confirmScreen2 = _interopRequireDefault(_confirmScreen);

var _confirmScreenVista = __webpack_require__(1251);

var _confirmScreenVista2 = _interopRequireDefault(_confirmScreenVista);

var _confirmScreenRts = __webpack_require__(1254);

var _confirmScreenRts2 = _interopRequireDefault(_confirmScreenRts);

var _failedPayment = __webpack_require__(1257);

var _failedPayment2 = _interopRequireDefault(_failedPayment);

var _specialScreening = __webpack_require__(1261);

var _specialScreening2 = _interopRequireDefault(_specialScreening);

var _regularMovies = __webpack_require__(1274);

var _regularMovies2 = _interopRequireDefault(_regularMovies);

var _searchResultCinema = __webpack_require__(1281);

var _searchResultCinema2 = _interopRequireDefault(_searchResultCinema);

var _createScreen = __webpack_require__(1285);

var _createScreen2 = _interopRequireDefault(_createScreen);

var _cinemaCreateScreen = __webpack_require__(1287);

var _cinemaCreateScreen2 = _interopRequireDefault(_cinemaCreateScreen);

var _createScreenList = __webpack_require__(1289);

var _createScreenList2 = _interopRequireDefault(_createScreenList);

var _NowShowingList = __webpack_require__(1292);

var _NowShowingList2 = _interopRequireDefault(_NowShowingList);

var _specialScreeningList = __webpack_require__(1295);

var _specialScreeningList2 = _interopRequireDefault(_specialScreeningList);

var _miniFestivalsList = __webpack_require__(1298);

var _miniFestivalsList2 = _interopRequireDefault(_miniFestivalsList);

var _howItsWorks = __webpack_require__(1301);

var _howItsWorks2 = _interopRequireDefault(_howItsWorks);

var _howItsWorkswebiste = __webpack_require__(1304);

var _howItsWorkswebiste2 = _interopRequireDefault(_howItsWorkswebiste);

var _noSearchFound = __webpack_require__(1307);

var _noSearchFound2 = _interopRequireDefault(_noSearchFound);

var _cinemapage = __webpack_require__(1311);

var _cinemapage2 = _interopRequireDefault(_cinemapage);

var _aboutus = __webpack_require__(1314);

var _aboutus2 = _interopRequireDefault(_aboutus);

var _helpPage = __webpack_require__(1319);

var _helpPage2 = _interopRequireDefault(_helpPage);

var _faqs = __webpack_require__(1322);

var _faqs2 = _interopRequireDefault(_faqs);

var _privacyPolicy = __webpack_require__(1326);

var _privacyPolicy2 = _interopRequireDefault(_privacyPolicy);

var _cookiesprivacyPolicy = __webpack_require__(1329);

var _cookiesprivacyPolicy2 = _interopRequireDefault(_cookiesprivacyPolicy);

var _termsCondition = __webpack_require__(1332);

var _termsCondition2 = _interopRequireDefault(_termsCondition);

var _termsCondition3 = __webpack_require__(1335);

var _termsCondition4 = _interopRequireDefault(_termsCondition3);

var _termsConditionTicket = __webpack_require__(1338);

var _termsConditionTicket2 = _interopRequireDefault(_termsConditionTicket);

var _profile = __webpack_require__(1341);

var _profile2 = _interopRequireDefault(_profile);

var _myaccount = __webpack_require__(1344);

var _myaccount2 = _interopRequireDefault(_myaccount);

var _mySpecialScreening = __webpack_require__(1348);

var _mySpecialScreening2 = _interopRequireDefault(_mySpecialScreening);

var _myNotification = __webpack_require__(1352);

var _myNotification2 = _interopRequireDefault(_myNotification);

var _myFavourites = __webpack_require__(1355);

var _myFavourites2 = _interopRequireDefault(_myFavourites);

var _myTransaction = __webpack_require__(1359);

var _myTransaction2 = _interopRequireDefault(_myTransaction);

var _myWallet = __webpack_require__(1367);

var _myWallet2 = _interopRequireDefault(_myWallet);

var _offersPromotion = __webpack_require__(1371);

var _offersPromotion2 = _interopRequireDefault(_offersPromotion);

var _error = __webpack_require__(1374);

var _error2 = _interopRequireDefault(_error);

var _comingSoon = __webpack_require__(1378);

var _comingSoon2 = _interopRequireDefault(_comingSoon);

var _contactUs = __webpack_require__(1381);

var _contactUs2 = _interopRequireDefault(_contactUs);

var _NewsRoom = __webpack_require__(1383);

var _NewsRoom2 = _interopRequireDefault(_NewsRoom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import offers&promotions from '@/components/pages/offers&promotion'

_vue2.default.use(_vueRouter2.default);

exports.default = new _vueRouter2.default({
  mode: "history",
  routes: [{
    path: "/",
    name: "Home",
    component: _home2.default
  }, {
    path: "/movie",
    name: "movieDetails",
    component: _movieDetails2.default
  }, {
    path: "/failedPayment",
    name: "failedPayment",
    component: _failedPayment2.default
  }, {
    path: "/specialScreening/:categoryId/:movieId/:content_lang_id/:cinemaId?",
    name: "specialScreening",
    component: _specialScreening2.default
  }, {
    path: "/seatLayout/:ss_id/:screen_id/:md_id",
    name: "seatLayout",
    component: _seatlayout2.default
  }, {
    path: "/confirmScreen/:show_booking_id/:category_id",
    name: "confirmScreen",
    component: _confirmScreen2.default
  }, {
    path: "/vista-confirmScreen/:show_booking_id",
    name: "confirmScreenVista",
    component: _confirmScreenVista2.default
  }, {
    path: "/rts-confirmScreen/:rts_reserve_id",
    name: "confirmScreenRts",
    component: _confirmScreenRts2.default
  }, {
    path: "/regularMovies/:movie_id/:content_lang_id",
    name: "regularMovies",
    component: _regularMovies2.default
  }, {
    path: "/createScreen/:movie_id/:content_lang_id",
    name: "createScreen",
    component: _createScreen2.default
  }, {
    path: "/cinemaScreen/:cinemaId",
    name: "cinemaScreen",
    component: _cinemaCreateScreen2.default
  }, {
    path: "/terms-condition-ticket/",
    name: "termsConditionTicket",
    component: _termsConditionTicket2.default
  }, {
    path: "/help-page/",
    name: "helpPage",
    component: _helpPage2.default
  }, {
    path: "/createScreenList",
    name: "createScreenList",
    component: _createScreenList2.default
  }, {
    path: "/nowShowingList",
    name: "nowShowingList",
    component: _NowShowingList2.default
  }, {
    path: "/specialScreeningList",
    name: "specialScreeningList",
    component: _specialScreeningList2.default
  }, {
    path: "/miniFestivalList",
    name: "miniFestivalList",
    component: _miniFestivalsList2.default
  }, {
    path: "/noSearchFound",
    name: "noSearchFound",
    component: _noSearchFound2.default
  }, {
    path: "/cinema-page",
    name: "cinemapage",
    component: _cinemapage2.default
  }, {
    path: "/how-it-works",
    name: "howItsWorks",
    component: _howItsWorks2.default
  }, {
    path: "/hiw",
    name: "hiw",
    component: _howItsWorkswebiste2.default
  }, {
    path: "/aboutus",
    name: "aboutus",
    component: _aboutus2.default
  }, {
    path: "/faqs",
    name: "faqs",
    component: _faqs2.default
  }, {
    path: "/privacyPolicy",
    name: "privacyPolicy",
    component: _privacyPolicy2.default
  }, {
    path: "/cookiesprivacyPolicy",
    name: "cookiesprivacyPolicy",
    component: _cookiesprivacyPolicy2.default
  }, {
    path: "/termsCondition",
    name: "termsCondition",
    component: _termsCondition2.default
  }, {
    path: "/searchResult",
    name: "searchResult",
    component: _searchResultCinema2.default
  }, {
    path: "/payment/:reservation_id/:category_id",
    name: "payment",
    component: _payment2.default
  }, {
    path: "/v-payment/:orderId/",
    name: "v-payment",
    component: _VistaPayment2.default
  }, {
    path: "/rts-payment/:orderId",
    name: "rts-payment",
    component: _RtsPayment2.default
  }, {
    path: "/create-show-payment/:reservation_id/:category_id",
    name: "createpayment",
    component: _createShowpayment2.default
  }, {
    path: "/terms-condition",
    name: _termsCondition4.default,
    component: _termsCondition4.default
  }, {
    path: "/coming-soon",
    name: _comingSoon2.default,
    component: _comingSoon2.default
  }, {
    path: "/offers-promotions",
    name: _offersPromotion2.default,
    component: _offersPromotion2.default
  }, {
    path: "/feedback",
    name: _contactUs2.default,
    component: _contactUs2.default
  }, {
    path: "/newsroom",
    name: _NewsRoom2.default,
    component: _NewsRoom2.default
  },
  // Nested Routes
  {
    path: "/profile/",
    component: _profile2.default,
    children: [{
      path: "",
      redirect: "/profile/myaccount"
    }, {
      path: "myaccount",
      component: _myaccount2.default
    }, {
      path: "myspecialscreening",
      component: _mySpecialScreening2.default
    }, {
      path: "myNotification",
      component: _myNotification2.default
    }, {
      path: "myFavourites",
      component: _myFavourites2.default
    }, {
      path: "myTransaction",
      component: _myTransaction2.default
    }, {
      path: "myWallet",
      component: _myWallet2.default

      //
    }]
  }, {
    path: "*",
    name: "error404",
    component: _error2.default
  }],

  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    };
  }
});

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slick__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_date_pick__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_date_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_date_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_date_pick_dist_vueDatePick_css__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_date_pick_dist_vueDatePick_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_date_pick_dist_vueDatePick_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper_constants__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__helper_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper_internet_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__helper_internet_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_partials_nowShowingSlider_vue__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_partials_SpecialScreeningsSlider_vue__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_partials_OwnScreeningSlider_vue__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_partials_nowShowingSliderMobile_vue__ = __webpack_require__(1122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_partials_SpecialScreeningsSliderMobile_vue__ = __webpack_require__(1124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_partials_OwnScreeningSliderMobile_vue__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_partials_UpcomingMiniFestivals_vue__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_partials_UpcomingMiniFestivalsone_vue__ = __webpack_require__(1131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_partials_UpcomingMiniFestivalsMobile_vue__ = __webpack_require__(1134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_partials_UpcomingMiniFestivalsMobileOne_vue__ = __webpack_require__(1136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_partials_BottomBar_vue__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_partials_loader_vue__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__eventBus_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__eventBus_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__eventBus_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__services_storage_service__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__services_storage_service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__services_storage_service__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__services_mainService_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__services_mainService_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__services_mainService_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_slick_carousel__ = __webpack_require__(1140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_vue_slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_slick_carousel_dist_vue_slick_carousel_theme_css__ = __webpack_require__(1141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_slick_carousel_dist_vue_slick_carousel_theme_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_vue_slick_carousel_dist_vue_slick_carousel_theme_css__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import { dragscroll } from 'vue-dragscroll'


























// optional style for arrows & dots


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "home",
  directives: {
    // 'dragscroll': dragscroll
  },
  components: {
    VueSlickCarousel: __WEBPACK_IMPORTED_MODULE_23_vue_slick_carousel___default.a,
    NowShowing: __WEBPACK_IMPORTED_MODULE_7__components_partials_nowShowingSlider_vue__["a" /* default */],
    loader: __WEBPACK_IMPORTED_MODULE_18__components_partials_loader_vue__["a" /* default */],
    SpecialScreenings: __WEBPACK_IMPORTED_MODULE_8__components_partials_SpecialScreeningsSlider_vue__["a" /* default */],
    NowShowingMobile: __WEBPACK_IMPORTED_MODULE_10__components_partials_nowShowingSliderMobile_vue__["a" /* default */],
    SpecialScreeningsMobile: __WEBPACK_IMPORTED_MODULE_11__components_partials_SpecialScreeningsSliderMobile_vue__["a" /* default */],
    OwnScreeningMobile: __WEBPACK_IMPORTED_MODULE_12__components_partials_OwnScreeningSliderMobile_vue__["a" /* default */],
    OwnScreening: __WEBPACK_IMPORTED_MODULE_9__components_partials_OwnScreeningSlider_vue__["a" /* default */],
    UpcomingFestivals: __WEBPACK_IMPORTED_MODULE_13__components_partials_UpcomingMiniFestivals_vue__["a" /* default */],
    UpcomingFestivalsMobile: __WEBPACK_IMPORTED_MODULE_15__components_partials_UpcomingMiniFestivalsMobile_vue__["a" /* default */],
    UpcomingFestivalsOne: __WEBPACK_IMPORTED_MODULE_14__components_partials_UpcomingMiniFestivalsone_vue__["a" /* default */],
    UpcomingFestivalsMobileOne: __WEBPACK_IMPORTED_MODULE_16__components_partials_UpcomingMiniFestivalsMobileOne_vue__["a" /* default */],
    Slick: __WEBPACK_IMPORTED_MODULE_1_vue_slick__["default"],
    BOTTOMBAR: __WEBPACK_IMPORTED_MODULE_17__components_partials_BottomBar_vue__["a" /* default */],
    DatePick: __WEBPACK_IMPORTED_MODULE_2_vue_date_pick___default.a
  },

  computed: {
    checkFilterExist: function checkFilterExist() {
      var obj = false;
      this.showFilter.map(function (x) {
        x.all_filter.map(function (y) {
          if (y.isActiveFilter == "1") {
            obj = true;
          }
        });
      });
      return obj;
    }
  },
  data: function data() {
    return {
      tabArray: [{
        // title: "Now Showing",
        title: "Join This Show",
        position: "1",
        active: "1",
        payload: { CategoryID: 1 }
      }, {
        title: "Create Your \n Own Show",
        position: "2",
        active: "0",
        payload: {
          CategoryID: 4
        }
      }, {
        title: "Gogo Library",
        position: "3",
        active: "0",
        payload: {
          CategoryID: 3
        }
      }],

      movieFilterArray: ["English", "Citimall", "Mumbai", "2D", "English", "Citimall", "Mumbai", "2D"],
      homeSlider: {
        arrows: true,
        slidesToShow: 1,
        centerMode: true,
        centerPadding: "15%",
        slidesToScroll: 1,
        // speed: 1000,

        responsive: [{
          breakpoint: 1025,
          settings: {
            arrows: true,
            dots: true,
            centerMode: false,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }]
      },

      homeSliderNew: {
        centerMode: true,
        centerPadding: "15%",
        focusOnSelect: true,
        infinite: true,
        slidesToShow: 1,
        lazyLoad: "progressive",
        // speed: 1000,
        responsive: [{
          breakpoint: 1025,
          settings: {
            arrows: true,
            // dots: true,
            centerMode: false,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }]
      },
      mobileHomeSliderNew: {
        centerMode: true,
        // centerPadding: "15%",
        focusOnSelect: true,
        infinite: true,
        slidesToShow: 1,
        lazyLoad: "progressive",
        responsive: [{
          breakpoint: 768,
          settings: {
            arrows: false,
            centerMode: true,
            // centerPadding: "10%", 
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }]
      },

      loaded: false,
      NowShowing: [],
      Banners: [],
      selectedTab: ["5"],
      showFilter: [],
      filterObj: {},
      selectedBottomTab: ["1"],
      // NEW
      MobileData: {
        nowShowing: [],
        OwnScreeningData: [],
        MiniFestivalData: []
      },
      busy: false,
      arrayCheck: ["Ajit"],
      count: 0,
      PageNo: 0,
      lastPage: 1,
      loadingData: true,
      NextPage: false,
      MiniFestivals: []
    };
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_19__eventBus_js___default.a.$emit("FOOTERSET", false);
    __WEBPACK_IMPORTED_MODULE_19__eventBus_js___default.a.$emit("CHECKROUTE", false);
    window.removeEventListener('scroll', this.handleScroll);
  },
  beforeMount: function beforeMount() {
    this.getBannerData();
    this.fetchFilterDetails();
    if (screen.width > 768) {
      this.getNowShowingData();
    }

    var payload = {
      title: "Create Your \n Own Show",
      position: "2",
      active: "0",
      payload: {
        CategoryID: 4
      }
    };
    // this.TabChange("2",payload);
    this.TabChange("3", payload);
    // this.getFestivals();
    // this.getCreateYourScreeningData();
    // this.getUpcomingShow();
    // this.getQuickBookDetails();
    // this.getLanguages();
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_19__eventBus_js___default.a.$emit("CHECKROUTE", true);
    __WEBPACK_IMPORTED_MODULE_19__eventBus_js___default.a.$emit("FOOTERSET", true);
    __WEBPACK_IMPORTED_MODULE_19__eventBus_js___default.a.$emit("BOTTOMTABCHANGE", "1");
    window.addEventListener('scroll', this.handleScroll);
  },

  methods: {
    getFestivals: function getFestivals() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_21__services_mainService_js___default.a.GetMiniFestivals().then(function (response) {
        var data = response.data;

        console.log("response", response);

        data.Records.sort(function (a, b) {
          var aDescription = a.category_link_description.toLowerCase();
          var bDescription = b.category_link_description.toLowerCase();

          // Handle the special case where "New Movies" should be at the top
          if (aDescription === 'new movies') return -1;
          if (bDescription === 'new movies') return 1;

          // Alphabetical sort for the rest of the items
          if (aDescription < bDescription) return -1;
          if (aDescription > bDescription) return 1;
          return 0;
        });

        console.log(data.Records, "data.Records >>>>>>>>>>>>>>>>>>");

        if (data.status) {
          _this.MiniFestivals = data.Records;
          _this.MobileData.MiniFestivalData = data.Records;
          __WEBPACK_IMPORTED_MODULE_19__eventBus_js___default.a.$emit("MINI", data.Records);
          _this.loadingData = true;
        }
      });
    },
    GetYear: function GetYear(date) {
      return __WEBPACK_IMPORTED_MODULE_22_moment___default()(date).format("YYYY");
    },

    loadMore: function loadMore() {
      var _this2 = this;

      console.log(this.loadingData, this.NextPage);
      if (this.loadingData && this.NextPage) {
        this.loadingData = false;
        setTimeout(function () {
          var count = _this2.selectedTab[0] - 1;
          console.log(_this2.selectedTab, "fdsdfsd");
          _this2.getPaginationData(_this2.tabArray[count]["payload"], _this2.selectedTab[0]);
        }, 1000);
      }
    },
    bottomTab: function bottomTab(val) {
      // this.selectedBottomTab=[];
      // this.selectedBottomTab.push(val)
      if (val == "2") {
        this.$router.push({
          path: "/offers-promotions"
        });
      } else if (val == "3") {
        var token = __WEBPACK_IMPORTED_MODULE_20__services_storage_service__["TokenService"].getToken();
        if (token == null || token == "" || token == undefined) {
          __WEBPACK_IMPORTED_MODULE_19__eventBus_js___default.a.$emit("SHOWSIGNIN");
        } else {
          this.$router.push({
            path: "/profile/myTransaction"
          });
        }
      } else if (val == "4") {
        var _token = __WEBPACK_IMPORTED_MODULE_20__services_storage_service__["TokenService"].getToken();
        if (_token == null || _token == "" || _token == undefined) {
          __WEBPACK_IMPORTED_MODULE_19__eventBus_js___default.a.$emit("SHOWSIGNIN");
        } else {
          this.$router.push({
            path: "/profile/myaccount"
          });
        }
      }
    },

    getPaginationData: function getPaginationData(payload, value) {
      var _this3 = this;

      if (this.showFilter.length > 0) {
        this.showFilter.map(function (x) {
          if (_this3.filterObj[x.filter_key].length > 0) {
            payload[x.query_id] = _this3.filterObj[x.filter_key].toString();
          } else {
            delete payload[x.query_id];
          }
        });
      }
      // console.log(payload);
      payload["PageNo"] = this.PageNo;
      payload["Version"] = "1";
      console.log(value, "fsddfsdfsdfsd");
      if (value == 1) {
        this.getNowShowingData(payload);
      } else if (value == 2) {
        this.getCreateYourScreeningData(payload);
      }

      // makeRequest("/GetShows/", "POST", null, payload)
      //   .then(response => {
      //     const { error, res } = response;
      //     if (res.data.Status) {
      //       this.PageNo = res.data.Shows.PageNo;
      //       this.NextPage = res.data.Shows.Next;

      //       if (
      //         payload &&
      //         payload["CategoryID"] &&
      //         payload["CategoryID"] == 1
      //       ) {
      //         res.data.Shows.Movies.map(x => {
      //           let __Index = this.MobileData.NowShowing.findIndex(
      //             z => z.ID === x.ID
      //           );
      //           if (__Index === -1) {
      //             this.MobileData.NowShowing.push(x);
      //           }
      //         });
      //         EventBus.$emit("NOWSHOWING", this.MobileData.NowShowing);
      //       } else if (
      //         payload &&
      //         payload["CategoryID"] &&
      //         payload["CategoryID"] == 4
      //       ) {
      //         res.data.Shows.Movies.map(x => {
      //           let __Index = this.MobileData.OwnScreeningData.findIndex(
      //             z => z.ID === x.ID
      //           );
      //           if (__Index === -1) {
      //             this.MobileData.OwnScreeningData.push(x);
      //           }
      //         });
      //         EventBus.$emit("CREATESHOWING", this.MobileData.OwnScreeningData);
      //       } else if (
      //         payload &&
      //         payload["CategoryID"] &&
      //         payload["CategoryID"] == 3
      //       ) {
      //         res.data.Shows.Movies.map(x => {
      //           let __Index = this.MobileData.MiniFestivalData.findIndex(
      //             z => z.ID === x.ID
      //           );
      //           if (__Index === -1) {
      //             this.MobileData.MiniFestivalData.push(x);
      //           }
      //         });
      //         EventBus.$emit("MINI", this.MobileData.MiniFestivalData);
      //       }
      //       this.loadingData = true;
      //     }
      //   })
      //   .catch(error => {
      //     console.log("Error", error);
      //   });
    },
    getCreateYourScreeningData: function getCreateYourScreeningData() {
      var _this4 = this;

      var payloadNew = { limit: __WEBPACK_IMPORTED_MODULE_4__helper_constants__["LIMIT"], currentPage: this.PageNo };
      if (this.showFilter.length > 0) {
        this.showFilter.map(function (x) {
          if (_this4.filterObj[x.filter_key].length > 0) {
            payloadNew[x.query_id] = _this4.filterObj[x.filter_key].toString();
          } else {
            delete payloadNew[x.query_id];
          }
        });
      }
      __WEBPACK_IMPORTED_MODULE_21__services_mainService_js___default.a.GetCreateOwnShow(payloadNew).then(function (response) {
        var data = response.data;

        console.log("response", response, _this4.PageNo);
        if (data.status && data.Records.data.length > 0) {
          if (_this4.PageNo > 1) {
            _this4.MobileData.OwnScreeningData = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this4.MobileData.OwnScreeningData), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data.Records.data));
          } else {
            console.log("TESSSSSSST", _this4.PageNo);
            _this4.lastPage = data.Records.pagination.lastPage;
            _this4.MobileData.OwnScreeningData = data.Records.data;
          }

          console.log(data, "fsdfsdf");
          __WEBPACK_IMPORTED_MODULE_19__eventBus_js___default.a.$emit("CREATESHOWING", _this4.MobileData.OwnScreeningData);
          _this4.PageNo = _this4.PageNo + 1;

          _this4.NextPage = _this4.lastPage >= _this4.PageNo;
          _this4.loadingData = true;

          // this.$refs.slick1.destroy();
          // this.$nextTick(() => {
          //   this.$refs.slick1.create();
          //   this.$refs.slick1.goTo(1, true);
          // });
        } else if (_this4.PageNo == 1) {
          _this4.MobileData.OwnScreeningData = [];
          __WEBPACK_IMPORTED_MODULE_19__eventBus_js___default.a.$emit("CREATESHOWING", _this4.MobileData.OwnScreeningData);
        }
      }).catch(function (error) {
        console.log("Error", error);
      });
    },


    getNowShowingData: function getNowShowingData(payload) {
      var _this5 = this;

      var payloadNew = { limit: __WEBPACK_IMPORTED_MODULE_4__helper_constants__["LIMIT"], currentPage: this.PageNo };
      if (this.showFilter.length > 0) {
        this.showFilter.map(function (x) {
          if (_this5.filterObj[x.filter_key].length > 0) {
            payloadNew[x.query_id] = _this5.filterObj[x.filter_key].toString();
          } else {
            delete payloadNew[x.query_id];
          }
        });
      }
      __WEBPACK_IMPORTED_MODULE_21__services_mainService_js___default.a.GetTodaysScreening(payloadNew).then(function (response) {
        var data = response.data;

        _this5.loadingData = true;
        console.log("response", response);
        if (data.status && data.Records.data.length > 0) {
          if (_this5.PageNo > 1) {
            _this5.MobileData.NowShowing = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this5.MobileData.NowShowing), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data.Records.data));
          } else {
            _this5.lastPage = data.Records.pagination.lastPage;
            _this5.MobileData.NowShowing = data.Records.data;
          }

          __WEBPACK_IMPORTED_MODULE_19__eventBus_js___default.a.$emit("NOWSHOWING", _this5.MobileData.NowShowing);

          _this5.PageNo = _this5.PageNo + 1;
          _this5.NextPage = _this5.lastPage >= _this5.PageNo;
          // this.$refs.slick1.destroy();
          // this.$nextTick(() => {
          //   this.$refs.slick1.create();
          //   this.$refs.slick1.goTo(1, true);
          // });
        } else if (_this5.PageNo == 1) {
          _this5.MobileData.NowShowing = [];

          __WEBPACK_IMPORTED_MODULE_19__eventBus_js___default.a.$emit("NOWSHOWING", _this5.MobileData.NowShowing);
        }
      }).catch(function (error) {
        console.log("Error", error);
      });
      // makeRequest("/GetShows/", "POST", null, payload)
      //   .then(response => {
      //     const { error, res } = response;
      //     if (res.data.Status) {
      //       //        tabArray: [
      //       //   {
      //       //     title: "Now Showing",
      //       //     position: "1",
      //       //     active: "1",
      //       //     payload: { CategoryID: 1 }
      //       //   },
      //       //   {
      //       //     title: "Create Your \n Own Show",
      //       //     position: "2",
      //       //     active: "0",
      //       //     payload: {
      //       //       CategoryID: 4
      //       //     }
      //       //   },
      //       //   {
      //       //     title: "Animation Special",
      //       //     position: "3",
      //       //     active: "0",
      //       //     payload: {
      //       //       CategoryID: 3
      //       //     }
      //       //   }
      //       // ],
      //       if (this.tabArray.length == 0) {
      //         res.data.Categories.map((x, index) => {
      //           let obj = {
      //             title: x.CategoryName,
      //             active: index == 0 ? "1" : "0",
      //             position: `${index + 1}`,
      //             payload: { CategoryID: x.CategoryID }
      //           };
      //           this.tabArray.push(obj);
      //         });
      //         console.log(this.tabArray);
      //       }
      //       console.log("fsdfsdf");
      //       this.PageNo = res.data.Shows.PageNo;
      //       this.NextPage = res.data.Shows.Next;
      //       if (
      //         payload &&
      //         payload["CategoryID"] &&
      //         payload["CategoryID"] == 1
      //       ) {
      //         this.MobileData.NowShowing = res.data.Shows.Movies;
      //         EventBus.$emit("NOWSHOWING", this.MobileData.NowShowing);
      //       } else if (
      //         payload &&
      //         payload["CategoryID"] &&
      //         payload["CategoryID"] == 4
      //       ) {
      //         this.MobileData.OwnScreeningData = res.data.Shows.Movies;
      //         EventBus.$emit("CREATESHOWING", this.MobileData.OwnScreeningData);
      //       } else if (
      //         payload &&
      //         payload["CategoryID"] &&
      //         payload["CategoryID"] == 3
      //       ) {
      //         this.MobileData.MiniFestivalData = res.data.Shows.Movies;
      //         EventBus.$emit("MINI", this.MobileData.MiniFestivalData);
      //       }
      //       window.scroll(0, 0);
      //       this.$refs["filterModalRef"].hide();
      //     }
      //   })
      //   .catch(error => {
      //     console.log("Error", error);
      //   });
    },

    redirectApi: function redirectApi() {
      this.PageNo = 1;
      if (this.selectedTab == 1) {
        this.getNowShowingData({});
      } else if (this.selectedTab == 2) {
        this.getCreateYourScreeningData({});
      } else if (this.selectedTab == 3) {
        this.getFestivals({});
      }
    },


    resetFilter: function resetFilter() {
      var _this6 = this;

      this.PageNo = 1;
      this.showFilter.map(function (x) {
        _this6[x.filter_key] = [];
      });
      this.redirectApi();

      this.showFilter = [];

      this.hideFilter();
    },
    getFilterVal: function getFilterVal(movie, data, index1, index2, val) {
      var _this7 = this;

      var i = this.filterObj[movie.filter_key].indexOf(data.value);
      this.filterObj[movie.filter_key] = [];
      this.showFilter[index1].all_filter.map(function (y) {
        y.isActive = "0";
        y.isActiveFilter = "0";
      });
      if (i >= 0) {
        if (val == "1") {
          this.redirectApi();
        }
        return false;
      }
      setTimeout(function (x) {
        if (i >= 0) {
          _this7.filterObj[movie.filter_key].splice(i, 1);
          _this7.showFilter[index1].all_filter[index2].isActive = "0";
          if (val == "1") {
            _this7.showFilter[index1].all_filter[index2].isActiveFilter = "0";
          }
        } else {
          _this7.filterObj[movie.filter_key].push(data.value);
          _this7.showFilter[index1].all_filter[index2].isActive = "1";
        }
        if (val == "1") {
          // this.fetchScreeningDetails();
        }
      }, 100);
    },

    // getFilterVal(movie, data, index1, index2, val) {
    //   let i = this.filterObj[movie.filter_key].indexOf(data.value);
    //   if (i >= 0) {
    //     this.filterObj[movie.filter_key].splice(i, 1);
    //     this.showFilter[index1].all_filter[index2].isActive = "0";
    //     if (val == "1") {
    //       this.showFilter[index1].all_filter[index2].isActiveFilter = "0";
    //     }
    //   } else {
    //     this.filterObj[movie.filter_key].push(data.value);
    //     this.showFilter[index1].all_filter[index2].isActive = "1";
    //   }
    //   if (val == "1") {
    //     let count = this.selectedTab[0] - 1;
    //     this.getNowShowingData(this.tabArray[count]["payload"]);
    //   }
    // },
    applyFilter: function applyFilter() {
      this.PageNo = 1;
      this.showFilter.map(function (x) {
        x.all_filter.map(function (y) {
          if (y.isActive == "1") {
            y.isActiveFilter = "1";
          }
        });
      });
      console.log(this.selectedTab);
      this.redirectApi();
      this.hideFilter();
    },
    showFilterModal: function showFilterModal() {
      this.$refs["filterModalRef"].show();
    },
    hideFilter: function hideFilter() {
      this.$refs["filterModalRef"].hide();
    },

    fetchFilterDetails: function fetchFilterDetails() {
      var _this8 = this;

      var payload = {};
      __WEBPACK_IMPORTED_MODULE_21__services_mainService_js___default.a.GetFilterList().then(function (response) {
        var data = response.data;


        if (data.filterData.length > 0) {
          data.filterData.map(function (x) {
            _this8.filterObj[x.filter_key] = [];
            x.all_filter.map(function (y) {
              y["isActive"] = "0";
              y["isActiveFilter"] = "0";
            });
          });
          _this8.showFilter = data.filterData;
        }
      }).catch(function (error) {
        console.log("Error", error);
      });
    },
    TabChange: function TabChange(value, payload) {
      console.log(payload, "payloadpayloadpayloadpayload");
      var i = this.selectedTab.indexOf(value);
      if (i < 0) {
        this.PageNo = 1;
        this.NextPage = true;
        this.lastPage = 1;
        this.selectedTab = [];
        this.selectedTab.push(value);
        window.scroll(0, 0);
        this.movieFilterArray = [];
        __WEBPACK_IMPORTED_MODULE_19__eventBus_js___default.a.$emit("LoadingMini", true);
        __WEBPACK_IMPORTED_MODULE_19__eventBus_js___default.a.$emit("LoadingNow", true);
        __WEBPACK_IMPORTED_MODULE_19__eventBus_js___default.a.$emit("LoadingShow", true);
        if (value == 1) {
          this.getNowShowingData(payload);
        } else if (value == 2) {
          this.getCreateYourScreeningData(payload);
        } else if (value == 3) {
          this.getFestivals();
        }
      }
    },

    getBannerData: function getBannerData() {
      var _this9 = this;

      this.showLoading();
      __WEBPACK_IMPORTED_MODULE_21__services_mainService_js___default.a.GetBanners().then(function (response) {
        var data = response.data;
        // console.log("esponse222", response);

        console.log(data.Records, "data.Records>>");

        _this9.hideLoading();
        if (data.status) {
          var records = data.Records.map(function (res) {
            console.log(res, "res>>>");
            if (res['b_id'] == 205) {
              delete res.b_order;

              res['banner_image_url'] = "https://api-test-1.binarynumbers.io/uploads/fnb_item/whats-app-image.jpg";
            }
          });

          _this9.Banners = data.Records.sort(function (a, b) {
            return a.b_id - b.b_id;
          });

          console.log(_this9.Banners, "this.Banners >>>>>>>>>>>>>.");

          // let a = data.Records;
          // a = a.concat([...a]);
          // a = a.concat([...a]);
          // a = a.concat([...a]);
          // a = a.concat([...a]);
          // this.Banners = a;
          // console.log(a, "Rec")

          _this9.loaded = true;
          _this9.$refs.slickBanner.destroy();
          _this9.$nextTick(function () {
            _this9.$refs.slickBanner.create();
            _this9.$refs.slickBanner.goTo(0, true);
          });
        }
      }).catch(function (err) {
        console.log("Error", err);
      });
      // makeRequest("/cinema/banners", "GET", null, payload)
      //   .then(response => {
      //     const { error, res } = response;
      //     this.hideLoading();
      //     if (res.data.Status) {
      //       this.Banners = res.data.Banner;
      //       this.loaded = true;
      //       this.Banners.filter(movie => {
      //         return movie.hasOwnProperty("MovieDetails");
      //       }).map(x => {
      //         this.Banners.Actor =
      //           this.Banners.Actors && this.Banners.Actors[0].Name;
      //         this.Banners.RYear = x.MovieDetails.Year.split(" ")[2];
      //       });
      //       this.$refs.slickBanner.destroy();
      //       this.$nextTick(() => {
      //         this.$refs.slickBanner.create();
      //         this.$refs.slickBanner.goTo(1, true);
      //       });
      //     }
      //   })
      //   .catch(error => {
      //     console.log("Error", error);
      //   });
    },
    handleScroll: function handleScroll() {
      var imageHeight = document.querySelector('.slider-container').offsetHeight;
      this.isSticky = window.scrollY > imageHeight;
    }
  }
});

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slick__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_internet_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__helper_internet_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_mainService_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_mainService_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__services_mainService_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper_constants__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__helper_constants__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "NowShowingSlider",

  components: {
    Slick: __WEBPACK_IMPORTED_MODULE_1_vue_slick__["default"]
  },

  data: function data() {
    var _movieSlider;

    return {
      routeName: "",
      showModal: false,
      movieSlider: (_movieSlider = {
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 5,
        slidesToScroll: 4
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_movieSlider, "dots", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_movieSlider, "responsive", [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }]), _movieSlider),
      NowShowing: []
    };
  },
  mounted: function mounted() {
    this.routeName = window.location.pathname;
    if (screen.width > 768) {
      this.getNowShowingData();
    }
  },

  methods: {
    getNowShowingData: function getNowShowingData() {
      var _this = this;

      var payload = { limit: __WEBPACK_IMPORTED_MODULE_5__helper_constants__["LIMIT"], currentPage: 1 };

      __WEBPACK_IMPORTED_MODULE_4__services_mainService_js___default.a.GetTodaysScreening(payload).then(function (response) {
        var data = response.data;

        console.log("response", response);
        if (data.status) {
          _this.NowShowing = data.Records.data;
          _this.$refs.slick1.destroy();
          _this.$nextTick(function () {
            _this.$refs.slick1.create();
            _this.$refs.slick1.goTo(1, true);
          });
        }
      }).catch(function (error) {
        console.log("Error", error);
      });
    }
  }
});

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slick__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_internet_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__helper_internet_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "SpecialScreeningsSlider",

  components: {
    Slick: __WEBPACK_IMPORTED_MODULE_1_vue_slick__["default"]
  },

  data: function data() {
    var _movieSlider;

    return {
      showModal: false,
      movieSlider: (_movieSlider = {
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 5,
        slidesToScroll: 4
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_movieSlider, "dots", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_movieSlider, "responsive", [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }]), _movieSlider),
      SpecialScreening: [],
      routeName: ""
    };
  },
  mounted: function mounted() {
    this.routeName = window.location.pathname;

    // this.getNowShowingData();
  },

  methods: {
    getNowShowingData: function getNowShowingData() {
      var _this = this;

      var payload = {
        Version: "1"
      };
      Object(__WEBPACK_IMPORTED_MODULE_2__helper_internet_js__["makeRequest"])("/GetShows/", "POST", null, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        if (res.data.Status) {
          _this.SpecialScreening = res.data.shows[1].Movies;
          _this.$refs.slick2.destroy();
          _this.$nextTick(function () {
            _this.$refs.slick2.create();
            _this.$refs.slick2.goTo(1, true);
          });
        }
      }).catch(function (error) {
        console.log("Error", error);
      });
    }
  }
});

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/transparent_movie.451a0dd.png";

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slick__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_internet_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__helper_internet_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_mainService_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_mainService_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__services_mainService_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper_constants__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__helper_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "OwnScreeningSlider",

  components: {
    Slick: __WEBPACK_IMPORTED_MODULE_1_vue_slick__["default"]
  },

  data: function data() {
    var _movieSlider;

    return {
      showModal: false,
      movieSlider: (_movieSlider = {
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 5,
        slidesToScroll: 4
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_movieSlider, "dots", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_movieSlider, "responsive", [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }]), _movieSlider),
      OwnScreening: [],
      routeName: ""
    };
  },
  mounted: function mounted() {
    this.routeName = window.location.pathname;

    this.getNowShowingData();
  },

  methods: {
    getNowShowingData: function getNowShowingData() {
      var _this = this;

      var payload = { limit: __WEBPACK_IMPORTED_MODULE_5__helper_constants__["LIMIT"], currentPage: 1 };

      __WEBPACK_IMPORTED_MODULE_4__services_mainService_js___default.a.GetCreateOwnShow(payload).then(function (response) {
        var data = response.data;

        console.log("response", response);
        if (data.status) {
          _this.OwnScreening = data.Records.data;
          _this.$refs.slick3.destroy();
          _this.$nextTick(function () {
            _this.$refs.slick3.create();
            _this.$refs.slick3.goTo(1, true);
          });
        }
      }).catch(function (error) {
        console.log("Error", error);
      });
    },
    goToRoute: function goToRoute(singleMovie) {
      console.log("object");
      __WEBPACK_IMPORTED_MODULE_3_jquery___default()("html, body").animate({ scrollTop: 0 }, "slow");
      this.$router.push({
        name: 'createScreen',
        params: {
          movie_id: singleMovie.movie_id,
          content_lang_id: singleMovie.content_lang_id
        }
      });
    }
  }
});

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slick__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_internet_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__helper_internet_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eventBus_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eventBus_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__eventBus_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_mainService_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_mainService_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__services_mainService_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: "NowShowingSlider",
  components: {
    Slick: __WEBPACK_IMPORTED_MODULE_0_vue_slick__["default"]
  },
  data: function data() {
    return {
      routeName: "",
      loadingNow: true,
      nowShowing: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.routeName = window.location.pathname;
    __WEBPACK_IMPORTED_MODULE_3__eventBus_js___default.a.$on("NOWSHOWING", function (val) {
      _this.nowShowing = val;
      _this.loadingNow = false;
    });
    __WEBPACK_IMPORTED_MODULE_3__eventBus_js___default.a.$on("LoadingNow", function (val) {
      _this.loadingNow = val;
      _this.nowShowing = [];
    });
  },

  watch: {
    nowShowing: function nowShowing(newVal, oldVal) {
      this.$forceUpdate();
    }
  },
  computed: {
    NowShowing: function NowShowing() {
      return this.nowShowing;
    }
  },
  methods: {}
});

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slick__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_internet_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__helper_internet_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "SpecialScreeningsSlider",

  components: {
    Slick: __WEBPACK_IMPORTED_MODULE_1_vue_slick__["default"]
  },

  data: function data() {
    var _movieSlider;

    return {
      showModal: false,
      movieSlider: (_movieSlider = {
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 5,
        slidesToScroll: 4
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_movieSlider, "dots", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_movieSlider, "responsive", [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }]), _movieSlider),
      SpecialScreening: [],
      routeName: ""
    };
  },
  mounted: function mounted() {
    this.routeName = window.location.pathname;

    // this.getNowShowingData();
  },

  methods: {
    getNowShowingData: function getNowShowingData() {
      var _this = this;

      var payload = {
        Version: "1"
      };
      Object(__WEBPACK_IMPORTED_MODULE_2__helper_internet_js__["makeRequest"])("/GetShows/", "POST", null, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        if (res.data.Status) {
          _this.SpecialScreening = res.data.shows[1].Movies;
          _this.$refs.slick2.destroy();
          _this.$nextTick(function () {
            _this.$refs.slick2.create();
            _this.$refs.slick2.goTo(1, true);
          });
        }
      }).catch(function (error) {
        console.log("Error", error);
      });
    }
  }
});

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slick__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_internet_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__helper_internet_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eventBus_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eventBus_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__eventBus_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_mainService_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_mainService_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__services_mainService_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ownScreeningSlider",
  components: {
    Slick: __WEBPACK_IMPORTED_MODULE_0_vue_slick__["default"]
  },
  data: function data() {
    return {
      routeName: "",
      loadingNow: true,
      ownScreening: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.routeName = window.location.pathname;
    __WEBPACK_IMPORTED_MODULE_3__eventBus_js___default.a.$on("CREATESHOWING", function (val) {
      _this.ownScreening = val;
      _this.loadingNow = false;
    });
    __WEBPACK_IMPORTED_MODULE_3__eventBus_js___default.a.$on("LoadingNow", function (val) {
      _this.loadingNow = val;
      _this.ownScreening = [];
    });
  },

  watch: {
    ownScreening: function ownScreening(newVal, oldVal) {
      this.$forceUpdate();
    }
  },
  computed: {
    ownScreening: function ownScreening() {
      return this.ownScreening;
    }
  },
  methods: {}
});

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpcomingMiniFestivals_vue__ = __webpack_require__(591);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b504f3a2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UpcomingMiniFestivals_vue__ = __webpack_require__(1130);
function injectStyle (ssrContext) {
  __webpack_require__(1129)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpcomingMiniFestivals_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b504f3a2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UpcomingMiniFestivals_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slick__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_internet_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__helper_internet_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_mainService_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_mainService_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__services_mainService_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "NowShowingSlider",

  components: {
    Slick: __WEBPACK_IMPORTED_MODULE_1_vue_slick__["default"]
  },

  data: function data() {
    var _movieSlider;

    return {
      showModal: [],
      movieSlider: (_movieSlider = {
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 5,
        slidesToScroll: 4
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_movieSlider, "dots", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_movieSlider, "responsive", [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }]), _movieSlider),
      MiniFestivals: [],
      SubTitle: "Gog Library",
      Title: "",
      routeName: ""
    };
  },
  mounted: function mounted() {
    this.routeName = window.location.pathname;

    this.getFestivals();
  },

  methods: {
    openModal: function openModal(index) {
      this.$set(this.showModal, index, true);
    },

    /* getFestivals() {
      MainServices.GetMiniFestivals().then(response => {
        const { data } = response;
        console.log("response", response);
        if (data.status) {
          this.MiniFestivals = data.Records;
        }
      });
    }, */
    getFestivals: function getFestivals() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_4__services_mainService_js___default.a.GetMiniFestivals().then(function (response) {
        var data = response.data;

        console.log("response >>>>>>>>>>>>>>", response);

        data.Records.sort(function (a, b) {
          var aDescription = a.unique_id;
          var bDescription = b.unique_id;

          // Handle the special case where "New Movies" should be at the top
          if (aDescription == 270365326) return -1;
          if (bDescription == 270365326) return 1;

          // Alphabetical sort for the rest of the items
          if (aDescription < bDescription) return -1;
          if (aDescription > bDescription) return 1;
          return 0;
        });

        if (data.status) {
          _this.MiniFestivals = data.Records.filter(function (item) {
            return item.unique_id !== 270365326 && item.category_link_movie_id !== 2450;
          }).sort(function (a, b) {

            var nameA = a.category_link_name.toUpperCase(); // Ignore case
            var nameB = b.category_link_name.toUpperCase(); // Ignore case

            if (nameA === "NEW RELEASES MOVIES") return -1;
            if (nameB === "NEW RELEASES MOVIES") return 1;

            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0; // Names are equal
          });
        }
      });
    },

    getNowShowingData: function getNowShowingData() {
      var _this2 = this;

      var payload = {
        CategoryID: 3,
        Version: "1"
      };
      Object(__WEBPACK_IMPORTED_MODULE_2__helper_internet_js__["makeRequest"])("/GetShows/", "POST", null, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        if (res.data.Status) {
          _this2.MiniFestivals = res.data.Shows.Movies;
          _this2.Title = res.data.Categories[2].CategoryName.toUpperCase();
          // this.SubTitle = res.data.shows[3].SubTitle || "Mini Festials";
          // this.MiniFestivals = this.MiniFestivals.filter(show => {
          //   return show.CategoryID == "3";
          // });
          _this2.$refs.slick4.destroy();
          _this2.$nextTick(function () {
            _this2.$refs.slick4.create();
            _this2.$refs.slick4.goTo(1, true);
          });
        }
      }).catch(function (error) {
        console.log("Error", error);
      });
    }
  }
});

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_slick__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_internet_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__helper_internet_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_mainService_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_mainService_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__services_mainService_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "NowShowingSlider",

  components: {
    Slick: __WEBPACK_IMPORTED_MODULE_2_vue_slick__["default"]
  },

  data: function data() {
    var _movieSlider;

    return {
      showModal: [],
      movieSlider: (_movieSlider = {
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 5,
        slidesToScroll: 4
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_movieSlider, "dots", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_movieSlider, "responsive", [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }]), _movieSlider),
      MiniFestivals: [],
      SubTitle: "Mini Festivals",
      Title: "",
      routeName: ""
    };
  },
  mounted: function mounted() {
    this.routeName = window.location.pathname;

    this.getFestivals();
  },

  methods: {
    openModal: function openModal(index) {
      this.$set(this.showModal, index, true);
    },

    /* getFestivals() {
      MainServices.GetMiniFestivals().then(response => {
        const { data } = response;
        console.log("response", response);
        if (data.status) {
          this.MiniFestivals = data.Records;
        }
      });
    }, */
    getFestivals: function getFestivals() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_5__services_mainService_js___default.a.GetMiniFestivals().then(function (response) {
        var data = response.data;

        console.log("response >>>>>>>>>>>>>>", response);

        data.Records.sort(function (a, b) {
          var aDescription = a.unique_id;
          var bDescription = b.unique_id;

          // Handle the special case where "New Movies" should be at the top
          if (aDescription == 270365326) return -1;
          if (bDescription == 270365326) return 1;

          // Alphabetical sort for the rest of the items
          if (aDescription < bDescription) return -1;
          if (aDescription > bDescription) return 1;
          return 0;
        });

        if (data.status) {

          var specialItem = data.Records.filter(function (item) {
            return item.unique_id === 270365326;
          });
          var otherItems = data.Records.filter(function (item) {
            return item.unique_id !== 270365326 && item.category_link_movie_id !== 2450;
          });

          otherItems.sort(function (a, b) {
            var nameA = a.category_link_name.toUpperCase();
            var nameB = b.category_link_name.toUpperCase();
            if (nameA === "NEW RELEASES MOVIES") return -1;
            if (nameB === "NEW RELEASES MOVIES") return 1;
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
          });

          _this.MiniFestivals = tempArray;

          _this.MiniFestivals = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(specialItem), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(otherItems));
        }
      });
    },

    getNowShowingData: function getNowShowingData() {
      var _this2 = this;

      var payload = {
        CategoryID: 3,
        Version: "1"
      };
      Object(__WEBPACK_IMPORTED_MODULE_3__helper_internet_js__["makeRequest"])("/GetShows/", "POST", null, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        if (res.data.Status) {
          _this2.MiniFestivals = res.data.Shows.Movies;
          _this2.Title = res.data.Categories[2].CategoryName.toUpperCase();
          // this.SubTitle = res.data.shows[3].SubTitle || "Mini Festials";
          // this.MiniFestivals = this.MiniFestivals.filter(show => {
          //   return show.CategoryID == "3";
          // });
          _this2.$refs.slick4.destroy();
          _this2.$nextTick(function () {
            _this2.$refs.slick4.create();
            _this2.$refs.slick4.goTo(1, true);
          });
        }
      }).catch(function (error) {
        console.log("Error", error);
      });
    }
  }
});

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_slick__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_internet_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__helper_internet_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__eventBus_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__eventBus_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__eventBus_js__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "NowShowingSlider",

  components: {
    Slick: __WEBPACK_IMPORTED_MODULE_2_vue_slick__["default"]
  },
  props: {},
  data: function data() {
    var _movieSlider;

    return {
      showModal: [],
      movieSlider: (_movieSlider = {
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 5,
        slidesToScroll: 4
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_movieSlider, "dots", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_movieSlider, "responsive", [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }]), _movieSlider),
      SubTitle: "Gog Library",
      Title: "",
      routeName: "",
      loadingMini: true,
      miniFestivals: []
    };
  },

  computed: {
    MiniFestivalsArray: function MiniFestivalsArray() {
      var specialItem = this.miniFestivals.filter(function (item) {
        return item.unique_id === 270365326;
      });
      var otherItems = this.miniFestivals.filter(function (item) {
        return item.unique_id !== 270365326 && item.category_link_movie_id !== 2450;
      });

      // Sort the other items alphabetically by category_link_name
      otherItems.sort(function (a, b) {
        var nameA = a.category_link_name.toUpperCase(); // Ignore case
        var nameB = b.category_link_name.toUpperCase(); // Ignore case
        if (nameA === "NEW RELEASES MOVIES") return -1;
        if (nameB === "NEW RELEASES MOVIES") return 1;
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0; // Names are equal
      });

      // Combine the special item with the sorted array
      return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(specialItem), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(otherItems));
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.routeName = window.location.pathname;
    __WEBPACK_IMPORTED_MODULE_5__eventBus_js___default.a.$on("MINI", function (val) {
      _this.miniFestivals = val;
      _this.loadingMini = false;
    });
    __WEBPACK_IMPORTED_MODULE_5__eventBus_js___default.a.$on("LoadingMini", function (val) {
      _this.loadingMini = val;
      _this.miniFestivals = [];
    });
  },

  methods: {
    openModal: function openModal(index) {
      this.$set(this.showModal, index, true);
    }
  }
});

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_slick__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_internet_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__helper_internet_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__eventBus_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__eventBus_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__eventBus_js__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "NowShowingSlider",

  components: {
    Slick: __WEBPACK_IMPORTED_MODULE_2_vue_slick__["default"]
  },
  props: {},
  data: function data() {
    var _movieSlider;

    return {
      showModal: [],
      movieSlider: (_movieSlider = {
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 5,
        slidesToScroll: 4
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_movieSlider, "dots", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_movieSlider, "responsive", [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }]), _movieSlider),
      SubTitle: "Mini Festivals",
      Title: "",
      routeName: "",
      loadingMini: true,
      miniFestivals: []
    };
  },

  computed: {
    MiniFestivalsArray: function MiniFestivalsArray() {

      // console.log(this.miniFestivals, "this.miniFestivals >>>>>>>>>>>>>>>")

      // return this.miniFestivals;
      var specialItem = this.miniFestivals.filter(function (item) {
        return item.unique_id === 270365326;
      });
      var otherItems = this.miniFestivals.filter(function (item) {
        return item.unique_id !== 270365326 && item.category_link_movie_id !== 2450;
      });

      // Sort the other items alphabetically by category_link_name
      otherItems.sort(function (a, b) {
        var nameA = a.category_link_name.toUpperCase(); // Ignore case
        var nameB = b.category_link_name.toUpperCase(); // Ignore case
        if (nameA === "NEW RELEASES MOVIES") return -1;
        if (nameB === "NEW RELEASES MOVIES") return 1;
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0; // Names are equal
      });

      // Combine the special item with the sorted array
      return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(specialItem), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(otherItems));
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.routeName = window.location.pathname;
    __WEBPACK_IMPORTED_MODULE_5__eventBus_js___default.a.$on("MINI", function (val) {
      _this.miniFestivals = val;
      _this.loadingMini = false;
    });
    __WEBPACK_IMPORTED_MODULE_5__eventBus_js___default.a.$on("LoadingMini", function (val) {
      _this.loadingMini = val;
      _this.miniFestivals = [];
    });
  },

  methods: {
    openModal: function openModal(index) {
      this.$set(this.showModal, index, true);
    }
  }
});

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "loader"
});

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/transparent_banner.804e583.png";

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slick__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_internet_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__helper_internet_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "movieDetails",
  components: { Slick: __WEBPACK_IMPORTED_MODULE_0_vue_slick__["default"] },
  metaInfo: {
    title: "perfect",
    titleTemplate: null
  },
  data: function data() {
    return {
      msg: "Welcome to Your HOMEPAGE",
      slickOptions: {
        slidesToShow: 3
      },
      shows: {},
      youtubeURL: "i4K3os977h4",
      movieDetails: {}
    };
  },
  beforeMount: function beforeMount() {
    this.fetchMovieDetails();
  },

  methods: {
    ready: function ready(event) {
      this.player = event.target;
    },
    fetchMovieDetails: function fetchMovieDetails() {
      var _this = this;

      var token = null;
      var payload = {
        MovieID: this.$route.params.movieID
      };
      if (this.$persistStore.get("accessToken")) {
        token = this.$persistStore.get("accessToken");
        payload["access_token"] = token;
      }
      console.log("payload", payload);
      Object(__WEBPACK_IMPORTED_MODULE_1__helper_internet_js__["makeRequestDirect"])("/api/GetMovieDetails", "POST", null, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        console.log("data movie", res, error);
        if (!error && res.data) {
          if (!error) {
            _this.movieDetails = res.data;
            _this.movieDetails["url"] = "/movie-showtimes-page?movieId=" + _this.movieDetails.ID;
            _this.movieDetails.IMDBRating = _this.movieDetails.IMDBRating.split("/")[0];
            _this.movieDetails.IMDBRating = Math.round(parseFloat(_this.movieDetails.IMDBRating));
            if (_this.movieDetails.Trailers && _this.movieDetails.Trailers[0]) {
              _this.youtube = "https://www.youtube.com/embed/" + _this.movieDetails.Trailers[0].URI;
            }
            _this.userRatingDetails.user = _this.movieDetails.YourRating;
            console.log("y", _this.youtube);
          }
        } else {
          console.log("Response Error ");
        }
      }).catch(function (error) {
        console.log("Error", error);
      });
    },

    stopYoutube: function stopYoutube() {
      this.player.stopVideo();
    }
  }
});

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slick__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_internet_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__helper_internet_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "homepage",
  components: { Slick: __WEBPACK_IMPORTED_MODULE_0_vue_slick__["default"] },
  metaInfo: {
    title: "perfect",
    titleTemplate: null
  },
  data: function data() {
    return {
      msg: "Movie Listing",
      slickOptions: {
        slidesToShow: 3
      },
      shows: {}
    };
  },
  beforeMount: function beforeMount() {
    // this.getNowShowingData();
  },

  methods: {
    getNowShowingData: function getNowShowingData() {
      var _this = this;

      var payload = {};
      // console.log('test2', this.dropDowns.cinemaChain.selected)
      // if(this.dropDowns.cinemaChain.selected.OrganizationName != 'All Cinemas'){
      // console.log('test3', this.dropDowns.cinemaChain.selected)
      //     payload.organisationID = this.dropDowns.cinemaChain.selected.OrganisationID;
      // }
      // if(this.dropDowns.languages.selected.Title != 'All Languages'){
      //     payload.language = this.dropDowns.languages.selected.Title;
      // };
      // if(this.$persistStore.get("accessToken")){
      //     payload.accessToken = this.$persistStore.get("accessToken");
      // };

      // payload.CountryID = this.getCountryFromLocalStorage().CountryID;
      payload.CountryID = 5;
      payload.LanguageID = 1;
      Object(__WEBPACK_IMPORTED_MODULE_1__helper_internet_js__["makeRequestDirect"])("/GetAllShow/", "POST", null, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        console.log("movie", error, res);
        if (!error && res.data.Status) {
          var data = res.data.data;

          var arr = [];
          console.log("t3", res);
          _this.shows = res.data;
          res.data.shows.map(function (x) {
            // x.Movies.map(function(y,_index){
            //     y['url'] =  "/movie-details-page?movieId=" + y.ID;
            //     y['bookingURL'] =  "/movie-details-page?movieId=" + y.ID + '&timing=1';
            // })
          });

          //                         this.banners = res.data.Banner;
          //                         console.log('banners',this.banners)
          // //                      for(let movie in res.data.shows[0]){
          // //                          console.log()
          // //                          movie["url"] = "/movie-details-page?movieId=" + movie.ID;
          // //                        arr.push(movie);
          // //                      }
          //                       this.nowShowing = res.data.shows[0];
          //                       this.comingSoon = res.data.shows[1];
          //                       this.artHouse = res.data.shows[2];
          //                       if(this.movieFilterValue == 'Now Showing'){
          //                           this.listingMovies = res.data.shows[0];
          //                       }else if(this.movieFilterValue == 'Coming Soon'){
          //                       this.listingMovies = res.data.shows[1];
          //                       } else{
          //                       this.listingMovies = res.data.shows[2];
          //                       }
          // //                      console.log(arr);
          // //                      this.nowShowing = arr;
          // //                      this.slides.nowShowing =
          // //                          typeof data.nowShowing[0] !== undefined &&
          // //                          Object.keys(data.nowShowing[0]).length > 0
          // //                              ? data.nowShowing[0]
          //                              : null;
          // console.log("Data >>>", this.slides);
        } else {
          console.log("Response Error ");
        }
      }).catch(function (error) {
        console.log("Error", error);
      });
    }
  }
});

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_vistaServices_js__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_vistaServices_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__services_vistaServices_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper_internet_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__helper_internet_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_slick__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_date_pick__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_date_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_date_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_date_pick_dist_vueDatePick_css__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_date_pick_dist_vueDatePick_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_date_pick_dist_vueDatePick_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_mainService_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_mainService_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__services_mainService_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_rtsServices__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_rtsServices___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__services_rtsServices__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var VueScrollTo = __webpack_require__(129);

// import { dragscroll } from 'vue-dragscroll'

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "MyComponent",
  directives: {
    // 'dragscroll': dragscroll
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    chargeTypeArray: function chargeTypeArray() {
      var selectedSeats = this.$store.getters.SELECTED_SEATS;
      var tempArr = [];
      var testObj = {};
      var finalArr = [];

      if (selectedSeats.length > 0) {
        selectedSeats.forEach(function (x) {
          if (x.hasOwnProperty("chargeTypeArray")) {
            x.chargeTypeArray.forEach(function (y) {
              tempArr.push(y);
            });
          }
        });
      }

      if (tempArr.length > 0) {
        tempArr.forEach(function (o) {
          if (!testObj[o.ct_id]) {
            testObj[o.ct_id] = {
              ct_id: o.ct_id,
              ct_name: o.ct_name,
              tax_amount: 0,
              quantity: o.quantity
            };
            finalArr.push(testObj[o.ct_id]);
          }
          testObj[o.ct_id].tax_amount += +o.tax_amount;
        });
      }
      // console.log(
      //   "this.$store.getters.SELECTED_SEATS",
      //   this.$store.getters.SELECTED_SEATS
      // );
      // // console.log("finalArr", finalArr);
      return finalArr;
    },
    curr_code: function curr_code() {
      return this.$store.getters.getCurrCode;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapGetters"])(["getSeatLayout", "getNowShowingDates", "getMovieDetailsScheduleList", "seatType", "seatsSelected", "totalPrice", "totalGrossPrice",
  // "getselectedDate",
  "getMovieDetailsScheduleList", "getMovieDetailsObject", "schedule_details_obj", "getGlobalCurrency", "getMovieDates", "getMovieId", "getCurrentLangIsoCode", "totalNumberOfSeats"]), {
    getSeatsSelected: function getSeatsSelected() {
      return this.$store.getters.SELECTED_SEATS.length > 0 ? this.$store.getters.SELECTED_SEATS : [];
    },
    ShowProceed: function ShowProceed() {
      var count = 0;
      this.priceTypeArray.map(function (x) {
        x.PriceType.map(function (y) {
          count = count + y.Selected;
        });
      });
      if (this.selectedSeats.length == count) {
        this.remainingTicket = 0;
        return true;
      } else {
        this.remainingTicket = this.selectedSeats.length - count;
        return false;
      }
    }
  }),

  components: {
    Slick: __WEBPACK_IMPORTED_MODULE_7_vue_slick__["default"],
    DatePick: __WEBPACK_IMPORTED_MODULE_9_vue_date_pick___default.a
  },
  filters: {
    moment: function moment(date) {
      return __WEBPACK_IMPORTED_MODULE_13_moment___default()(date).format("MMM DD, YYYY | h:mm A");
    },
    date: function date(_date) {
      return __WEBPACK_IMPORTED_MODULE_13_moment___default()(_date).format("MMM DD, YYYY");
    }
  },

  data: function data() {
    return {
      ticketPriceNew: 0,
      priceTypeArray: [],
      promoApplied: false,
      remainingTicket: 0,
      sSlider: {
        dots: false,
        arrows: false,
        slidesToShow: 3.5,
        slidesToScroll: 3,
        centerPadding: "50px",
        promoApplied: false,
        DiscountValue: "",

        loop: false,
        responsive: [{
          breakpoint: 992,
          settings: {
            arrows: false,
            dots: false,
            slidesToShow: 3,
            slidesToScroll: 1
          }
        }, {
          breakpoint: 480,
          settings: {
            arrows: false,
            dots: false,
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }]
      },
      count: 0,
      showCollapse: false,
      showMessage: "",
      showCollapseSeatLayout: true,
      date: "2019-01-01",
      movieDetails: {},
      MovieID: "",
      CategoryID: "",
      CinemaScheduleID: "",
      CinemaList: [],
      selectedCinemaObject: {},
      ShowDates: [],
      ShowTimes: {},
      Currency: "",
      ShowTypes: {},
      CinemaTimeScheduleID: "",
      selectedTime: "",
      ScreeningType: "",
      seatLayout: [],
      seatTypes: [],
      showDetails: {
        CinemaName: "Citimall",
        CinemaAddress: "Adsd",
        ShowDateTime: "2019-20-20"
      },
      numberOfSeatsSelected: 0,
      totalNumberOfSeats: 0,
      selectedSeats: [],
      row: "",
      column: "",
      newSeatLayout: [],
      totalAmount: "",
      OGtotalAmount: "",
      promocode: "",
      promocodeSuccesMessage: "",
      promocodeErrorMessage: "",
      ServiceFee: 0,
      TotalPriceNew: 0,
      showModalPrice: false,
      TaxRate: 0,
      TaxAmount: 0,
      ServiceFeePer: 0,
      ServiceFeeNew: 0,
      TaxAmountNew: 0,
      //
      ss_id: 0,
      screen_id: 0,
      vista_schedule_id: null,
      rts_performance_id: null,
      seatsSelectedRateGroupNew: [],
      totalAmountPrice: 0,
      totalSeatBooked: 0,
      totalNetAmout: 0,
      checkPopupExist: false,
      errorMessage: ""
    };
  },
  beforeMount: function beforeMount() {
    this.onResetSeatLayout();

    this.MovieID = this.$route.params.md_id;
    this.CategoryID = 1;
    this.ss_id = this.$route.params.ss_id;
    this.screen_id = this.$route.params.screen_id;

    if (this.$route.query.vista_schedule_id) this.vista_schedule_id = this.$route.query.vista_schedule_id;
    if (this.$route.query.rts_performance_id) this.rts_performance_id = this.$route.query.rts_performance_id;

    if (this.CategoryID == 2 || this.CategoryID == "2") {
      this.secureStore.set("SCRTN", "Crowdsourced Screening");
    }
    this.fetchScheduleDetail();
    // this.fetchCinemasList();

    this.getSeats({
      md_id: this.MovieID,
      screen_id: this.screen_id,
      ss_id: this.ss_id,
      vista_schedule_id: this.vista_schedule_id,
      rts_performance_id: this.rts_performance_id
    });
  },
  mounted: function mounted() {
    var _this = this;

    this.showLoading();
    setTimeout(function (x) {
      _this.hideLoading();
    }, 2000);
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapActions"])(["getSeats", "getMovieDetailsSelectedFilter", "SelectNumberOfSeats", "seatHandler", "RESERVE_SEATS", "onResetSeatLayout", "getAdditionalCharges",
  // "getselectedDate",
  "onSetDefaultFilter", "getScheduleDetails", "setScheduleObj", "onGetAllMoviesSchedulesSeatPage", "onSetCompleteRateCard", "onSetCompleteNewTotalAmount", "getVouchersList", "fetchStripePublisherKey", "getAllShowDates", "onGetMovieShowDates", "onGetMovieDetails"]), {
    showDateHandlaler: function showDateHandlaler(date) {
      return __WEBPACK_IMPORTED_MODULE_13_moment___default()(date).format("MMMM DD, YYYY");
    },
    getVistaSeatClass: function getVistaSeatClass(singleSeat) {
      if (singleSeat.selectStatus) {
        if (singleSeat.status === 3) {
          return "wheel active";
        } else {
          return "seat active";
        }
      } else {
        if ([1, 2, 5].includes(singleSeat.status)) {
          if (singleSeat.originalStatus === 3) {
            return "wheel disabled seat";
          } else {
            return "seat disabled";
          }
        } else {
          if (singleSeat.status === 3) {
            return "wheel";
          } else {
            return "seat";
          }
        }
      }
    },
    getRtsSeatClass: function getRtsSeatClass(singleSeat) {
      if (singleSeat.selectStatus) {
        if (singleSeat.Type._text === "1") {
          return "wheel active";
        }
        return "seat active";
      } else {
        if ([1, 2, 3, 5, 6].includes(singleSeat.Status._text)) {
          if (singleSeat.Type._text === "1") {
            return "wheel disabled seat";
          }
          return "seat disabled";
        }
      }
      if (singleSeat.Type._text === "1") {
        return "wheel";
      }
      return "seat";
    },
    hidePriceModal: function hidePriceModal() {
      this.$refs.gogoModal.hide();
    },
    IncrementSelected: function IncrementSelected(item, index2, index1) {
      this.priceTypeArray[index1]["PriceType"][index2]["Selected"]++;
      this.priceTypeArray[index1]["NoOfSeatSelected"]++;
      this.ServiceFeeNew = parseFloat(+parseFloat(this.ServiceFeeNew) + parseFloat(item.ServiceFee)).toFixed(2);
      this.TaxAmountNew = parseFloat(+parseFloat(this.TaxAmountNew) + parseFloat(item.TaxAmountPer)).toFixed(2);
      this.ServiceFeePerNew = parseFloat(+parseFloat(this.ServiceFeePerNew) + parseFloat(item.ServiceFeePer)).toFixed(2);

      this.ticketPriceNew = parseFloat(+parseFloat(this.ticketPriceNew) + parseFloat(item.Price)).toFixed(2);
      this.TotalPriceNew = parseFloat(+parseFloat(this.ticketPriceNew) + parseFloat(this.ServiceFeeNew)).toFixed(2);
    },
    DecrementSelected: function DecrementSelected(item, index2, index1) {
      if (this.priceTypeArray[index1]["PriceType"][index2]["Selected"] > 0) {
        this.priceTypeArray[index1]["PriceType"][index2]["Selected"]--;
        this.priceTypeArray[index1]["NoOfSeatSelected"]--;
        this.ServiceFeeNew = parseFloat(parseFloat(this.ServiceFeeNew) - parseFloat(item.ServiceFee)).toFixed(2);

        this.TaxAmountNew = parseFloat(parseFloat(this.TaxAmountNew) - parseFloat(item.TaxAmountPer)).toFixed(2);
        this.ServiceFeePerNew = parseFloat(parseFloat(this.ServiceFeePerNew) - parseFloat(item.ServiceFeePer)).toFixed(2);
        this.ticketPriceNew = parseFloat(parseFloat(this.ticketPriceNew) - parseFloat(item.Price)).toFixed(2);
        this.TotalPriceNew = parseFloat(this.TotalPriceNew - parseFloat(item.Price) - parseFloat(item.ServiceFee)).toFixed(2);
      }
    },
    totalCount: function totalCount(rg, index, rg_index, type) {
      var seatsSelectedRateGroupCopy = __WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep___default()(this.seatsSelectedRateGroupNew);
      var x = seatsSelectedRateGroupCopy[index]["rate_card_group"][rg_index];
      if (type == "increment" && seatsSelectedRateGroupCopy[index].totalSelected == seatsSelectedRateGroupCopy[index].AllSeats.length) {
        return false;
      }

      if (type == "increment" && this.totalSeatBooked + 1 <= this.$store.getters.SELECTED_SEATS.length && x["totalSeatSelected"] <= this.$store.getters.SELECTED_SEATS.length) {
        x["totalSeatSelected"] = x["totalSeatSelected"] + 1;
        seatsSelectedRateGroupCopy[index].totalSelected = seatsSelectedRateGroupCopy[index].totalSelected + 1;
      } else if (seatsSelectedRateGroupCopy[index].totalSelected >= 1 && type == "decrement" && x["totalSeatSelected"] >= 1) {
        x["totalSeatSelected"] = x["totalSeatSelected"] - 1;
        seatsSelectedRateGroupCopy[index].totalSelected = seatsSelectedRateGroupCopy[index].totalSelected - 1;
      }

      var totalAmount = 0;
      var totalSeatBooked2 = 0;
      var totalNetAmout2 = 0;
      seatsSelectedRateGroupCopy.map(function (z) {
        z.rate_card_group.map(function (y) {
          totalAmount = parseFloat(totalAmount) + parseFloat(y.totalSeatSelected) * parseFloat(y.rc_total_amount);

          totalNetAmout2 = parseFloat(totalNetAmout2) + parseFloat(y.totalSeatSelected) * parseFloat(y.rc_net_amount);
        });

        totalSeatBooked2 = parseInt(totalSeatBooked2) + parseInt(z.totalSelected);
      });
      this.totalAmountPrice = totalAmount;
      this.totalSeatBooked = totalSeatBooked2;
      this.totalNetAmout = totalNetAmout2;
      if (totalSeatBooked2 == this.$store.getters.SELECTED_SEATS.length) {} else {
        this.$store.dispatch("onSetCompleteRateCard", {
          status: false,
          seatGroup: __WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep___default()(seatsSelectedRateGroupCopy)
        });
      }
      this.seatsSelectedRateGroupNew = seatsSelectedRateGroupCopy;
      if (this.totalSeatBooked == this.$store.getters.SELECTED_SEATS.length) {
        this.errorMessage = "";
      } else {
        this.errorMessage = "Please Select All Seats";
      }
    },

    onClickOk: function onClickOk() {
      this.count = 0;
      this.$refs.WheelChairModal.hide();
    },
    onClickTab: function onClickTab() {
      this.showCollapseSeatLayout = !this.showCollapseSeatLayout;
    },

    onEdit: function onEdit() {
      this.totalNumberOfSeats = 0;
      this.editNumberOfSeats(0);
    },
    fetchScheduleDetail: function fetchScheduleDetail() {
      var _this2 = this;

      var payload = {
        ss_id: this.ss_id
      };
      __WEBPACK_IMPORTED_MODULE_12__services_mainService_js___default.a.getScheduleDetails(payload).then(function (response) {
        var error = response.error,
            res = response.res;

        _this2.movieDetails = response.data.Records[0];
        _this2.movieDetails["mrrdr_release_date_year"] = __WEBPACK_IMPORTED_MODULE_13_moment___default()(_this2.movieDetails.mrrdr_release_date).format("YYYY");
      }).catch(function (error) {});
    },

    getSeatLayoutList: function getSeatLayoutList() {
      var _this3 = this;

      var payload = {
        screen_id: this.screen_id,
        ss_id: this.ss_id,
        md_id: this.MovieID,
        vista_schedule_id: this.vista_schedule_id
      };
      __WEBPACK_IMPORTED_MODULE_12__services_mainService_js___default.a.getSeatLayout(payload).then(function (response) {
        var error = response.error,
            res = response.res;

        _this3.seatLayout = response.data.seatLayoutNew;
      }).catch(function (error) {
        console.log("Error", error);
      });
    },

    editNumberOfSeats: function editNumberOfSeats(number) {
      var _this4 = this;

      this.SelectNumberOfSeats(number);
      this.totalNumberOfSeats = number;
      //deselect all
      this.selectedSeats.map(function (x, index) {
        _this4.seatLayout[x.mainIndex].Seats[x.rowIndex][x.seatIndex].SelectStatus = false;
        _this4.seatLayout[x.mainIndex].Seats[x.rowIndex][x.seatIndex].SelectStatusFlag = false;
      });
      this.selectedSeats = [];
    },
    handlerSeatSelected: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(seat, rowIndex, seatIndex, originalIndex, backward, e, type) {
        var payload;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(seat.seat_reserve_type_id == 9)) {
                  _context.next = 3;
                  break;
                }

                this.$toasted.show($t("Sorry! These seats can be booked from Box Office only"));
                return _context.abrupt("return");

              case 3:
                payload = {
                  seat: seat,
                  rowIndex: rowIndex,
                  seatIndex: seatIndex,
                  originalIndex: originalIndex,
                  backward: backward,
                  e: e,
                  type: type
                };
                _context.next = 6;
                return this.seatHandler(payload);

              case 6:
                if (seat.srt_id && seat.srt_id == 3) {
                  this.$refs.WheelChairModal.show();
                } else if (seat.status && seat.status == 3) {
                  this.$refs.WheelChairModal.show();
                }

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handlerSeatSelected(_x, _x2, _x3, _x4, _x5, _x6, _x7) {
        return _ref.apply(this, arguments);
      }

      return handlerSeatSelected;
    }(),
    seatsSelectedRateGroup: function seatsSelectedRateGroup() {
      var _this5 = this;

      if (this.vista_schedule_id) {
        this.totalSeatBooked = this.$store.getters.SELECTED_SEATS.length;
        this.totalAmountPrice = 0;
        this.totalNetAmout = 0;
        var seatType = this.seatType[0];
        var seat_price = parseFloat(seatType.seat_price);
        this.$store.getters.SELECTED_SEATS.forEach(function (seat) {
          _this5.totalAmountPrice = _this5.totalAmountPrice + seat_price;
          _this5.totalNetAmout = _this5.totalNetAmout + seat_price;
        });
      } else if (this.rts_performance_id) {
        this.totalSeatBooked = this.$store.getters.SELECTED_SEATS.length;
        this.totalAmountPrice = 0;
        this.totalNetAmout = 0;
        var _seatType = this.seatType[0];
        var _seat_price = parseFloat(_seatType.seat_price);
        this.$store.getters.SELECTED_SEATS.forEach(function (seat) {
          _this5.totalAmountPrice = _this5.totalAmountPrice + _seat_price;
          _this5.totalNetAmout = _this5.totalNetAmout + _seat_price;
        });
      } else {
        var array = [];
        if (this.checkPopupExist == false) {
          this.totalSeatBooked = 0;
          this.totalAmountPrice = 0;
          this.totalNetAmout = 0;
          var checkCheckoutRateCardNeeded = 0;
          if (this.$store.getters.SELECTED_SEATS.length > 0) {
            this.$store.getters.SELECTED_SEATS.map(function (x) {
              var find_In = array.findIndex(function (new1) {
                // return new1.sst_id == x.sst_id;
                return new1.sst_id == x.sst_id;
              });
              if (find_In >= 0) {
                array[find_In]["AllSeats"].push(x);
                if (array[find_In]["rate_card_group"].length == 1) {
                  array[find_In]["totalSelected"] = array[find_In]["totalSelected"] + 1;
                  array[find_In]["rate_card_group"][0].totalSeatSelected = array[find_In]["rate_card_group"][0].totalSeatSelected + 1;
                  _this5.totalAmountPrice = parseFloat(_this5.totalAmountPrice) + parseFloat(array[find_In]["rate_card_group"][0].rc_total_amount);
                  _this5.totalNetAmout = parseFloat(_this5.totalNetAmout) + parseFloat(array[find_In]["rate_card_group"][0].rc_net_amount);
                  _this5.totalSeatBooked = _this5.totalSeatBooked + 1;
                } else if (array[find_In]["rate_card_group"].length > 1) {
                  checkCheckoutRateCardNeeded = checkCheckoutRateCardNeeded + 1;
                }
              } else {
                var arrayCardGroup = [];
                x.rate_card_group.map(function (rg) {
                  rg["totalSeatSelected"] = 0;
                  arrayCardGroup.push(rg);
                });
                var obj = {
                  srt_name: x.sst_seat_type,
                  sst_id: x.sst_id,
                  AllSeats: [x],
                  totalSelected: 0,
                  rate_card_group: arrayCardGroup
                };
                if (arrayCardGroup.length == 1) {
                  obj["totalSelected"] = 1;
                  obj["rate_card_group"][0].totalSeatSelected = 1;
                  _this5.totalAmountPrice = parseFloat(_this5.totalAmountPrice) + parseFloat(obj["rate_card_group"][0].rc_total_amount);
                  _this5.totalNetAmout = parseFloat(_this5.totalNetAmout) + parseFloat(obj["rate_card_group"][0].rc_net_amount);
                  _this5.totalSeatBooked = _this5.totalSeatBooked + 1;
                } else if (arrayCardGroup.length > 1) {
                  checkCheckoutRateCardNeeded = checkCheckoutRateCardNeeded + 1;
                }
                array.push(obj);
              }
            });
            this.seatsSelectedRateGroupNew = array;

            if (checkCheckoutRateCardNeeded == 0 && array[0]["rate_card_group"].length > 0) {
              this.$store.dispatch("onSetCompleteRateCard", {
                status: true,
                seatGroup: __WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep___default()(this.seatsSelectedRateGroupNew)
              });
              this.$store.dispatch("onSetCompleteNewTotalAmount", {
                totalAmount: this.totalAmountPrice,
                netAmount: this.totalNetAmout
              });
            } else if (checkCheckoutRateCardNeeded > 0) {
              this.$store.dispatch("onSetCompleteRateCard", {
                status: false,
                seatGroup: __WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep___default()(this.seatsSelectedRateGroupNew)
              });
            }

            return array;
          } else {
            this.seatsSelectedRateGroupNew = [];
            return array;
          }
        } else {
          return this.seatsSelectedRateGroupNew;
        }
      }
    },


    checkForWheelChair: function checkForWheelChair() {
      var _this6 = this;

      var popUpStatus = 0;
      var self = this;
      this.selectedSeats.map(function (x, index) {
        if (x.Status == 3 && popUpStatus == 0) {
          _this6.$refs.WheelChairModal.show();
          popUpStatus = 1;
          self.count = 0;
        }
      });
    },
    ProceedNew: function ProceedNew() {
      var _this7 = this;

      var seatId = [];
      var seatNames = [];
      this.selectedSeats.map(function (x) {
        seatId.push(parseInt(x.SeatlayoutID));
        seatNames.push(x.SeatName);
      });

      this.secureStore.set("BSN", seatNames.toString());
      this.secureStore.set("BSID", seatId.toString());
      var ShowType = this.secureStore.get("SCRT") || "";
      // let CinemaScheduleID = this.CinemaTimeScheduleID;
      //check seats available
      var payload = {
        BookSeats: seatId,
        CategoryID: this.CategoryID,
        CinemaScheduleID: this.CinemaTimeScheduleID,
        ShowType: ShowType,
        ticketPrice: this.ticketPriceNew,
        ServiceFee: this.ServiceFeePerNew,
        TaxRate: this.TaxRate,
        TaxAmount: this.TaxAmountNew,
        TotalPrice: this.TotalPriceNew,
        TotalTaxAmount: this.ServiceFeeNew,
        PriceType: this.priceTypeArray
      };
      Object(__WEBPACK_IMPORTED_MODULE_5__helper_internet_js__["makeRequest"])("/CheckAvailable/", "POST", null, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        if (res.data.Status && res.data.SeatStatus) {
          _this7.secureStore.set("RID", res.data.ReserveID);

          _this7.$router.push({
            name: "payment",
            params: {
              categoryId: _this7.CategoryID,
              scheduleId: _this7.CinemaTimeScheduleID
            }
          });
        } else {
          _this7.showMessage = res.data.Message;
        }
      }).catch(function (error) {
        _this7.showMessage = "Something went wrong";
      });
    },
    setBookingSeats: function setBookingSeats() {
      if (this.totalSeatBooked == this.$store.getters.SELECTED_SEATS.length) {
        this.onSubmitFromRateCardModal();
      } else {
        // this.errorMessage = `Please Select All Seats`;
        this.$refs.showRateCard.show();
      }
    },
    onSubmitFromRateCardModal: function onSubmitFromRateCardModal() {
      if (!(this.totalSeatBooked == this.$store.getters.SELECTED_SEATS.length)) {
        return false;
      }

      this.$store.dispatch("onSetCompleteRateCard", {
        status: true,
        seatGroup: this.seatsSelectedRateGroupNew
      });

      this.$store.dispatch("onSetCompleteNewTotalAmount", {
        totalAmount: this.totalAmountPrice,
        netAmount: this.totalNetAmout
      });

      this.reserveSeats();
      this.$refs.showRateCard.hide();
    },
    reserveSeats: function reserveSeats() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var reservation_id, seats, payload, dataNew, data, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this8.showLoading();
                reservation_id = Math.floor(100000000 + Math.random() * 900000000);

                if (!_this8.vista_schedule_id) {
                  _context2.next = 14;
                  break;
                }

                seats = _this8.$store.getters.seatsSelected.map(function (ticket) {
                  return {
                    areaCategoryCode: _this8.seatType[0].areaCategoryCode,
                    areaNumber: ticket.position.areaNumber,
                    columnId: ticket.position.columnIndex,
                    rowId: ticket.position.rowIndex
                  };
                });
                payload = {
                  cinemaChainId: _this8.seatType[0].cinemaChainId,
                  showtimeId: _this8.vista_schedule_id,
                  ticketTypes: [{
                    showtimeId: _this8.vista_schedule_id,
                    id: _this8.seatType[0].ticket_type_id,
                    quantity: _this8.$store.getters.seatsSelected.length
                  }],
                  seats: seats
                };
                _context2.next = 8;
                return __WEBPACK_IMPORTED_MODULE_4__services_vistaServices_js___default.a.reserveSeats(payload);

              case 8:
                dataNew = _context2.sent;
                data = dataNew.data;

                if (data.status) {
                  _this8.hideLoading();
                  _this8.$router.push({
                    path: "/v-payment/" + data.data.vista_order_id
                  });
                } else {
                  _this8.$refs.showRateCard.hide();
                  _this8.showMessage = "Sorry, those seats have already been reserved. Please choose new seats.";
                  _this8.$refs.SeatRealeased.show();
                  _this8.hideLoading();
                }
                return _context2.abrupt("return", false);

              case 14:
                if (!_this8.rts_performance_id) {
                  _context2.next = 32;
                  break;
                }

                _context2.next = 17;
                return __WEBPACK_IMPORTED_MODULE_14__services_rtsServices___default.a.reserveSeats({
                  rts_performance_id: _this8.rts_performance_id,
                  Seats: _this8.$store.getters.seatsSelected,
                  amount: _this8.totalAmountPrice
                });

              case 17:
                res = _context2.sent;

                if (!res.data.status) {
                  _context2.next = 23;
                  break;
                }

                _this8.hideLoading();
                _this8.$router.push({
                  path: "/rts-payment/" + res.data.data.rts_reserve_id
                });
                _context2.next = 29;
                break;

              case 23:
                _this8.getSeats({
                  md_id: _this8.MovieID,
                  screen_id: _this8.screen_id,
                  ss_id: _this8.ss_id,
                  vista_schedule_id: _this8.vista_schedule_id,
                  rts_performance_id: _this8.rts_performance_id
                });
                _this8.$refs.showRateCard.hide();
                _this8.showMessage = "Sorry, those seats have already been reserved. Please choose new seats.";
                _this8.$refs.SeatRealeased.show();
                _this8.hideLoading();
                return _context2.abrupt("return");

              case 29:
                return _context2.abrupt("return");

              case 32:
                _context2.next = 34;
                return _this8.$store.dispatch("RESERVE_SEATS", {
                  seat_layout_id: _this8.$store.getters.seatsSelected,
                  schedule_show_id: _this8.ss_id,
                  reservation_id: reservation_id,
                  aggregator_cinema: _this8.movieDetails.cine_id,
                  seatGroup: _this8.seatsSelectedRateGroupNew
                });

              case 34:

                // const { ss_id } = this.$route.params;
                if (_this8.$store.getters.seatsSelected.length > 0) {
                  _this8.hideLoading();
                  // await this.getAdditionalCharges({
                  //   movieDetails: this.schedule_details_obj,
                  //   selected_seats: this.seatsSelected,
                  //   showDetails: this.schedule_details_obj
                  // });
                  _this8.$router.push({
                    path: "/payment/" + reservation_id + "/1"
                  });
                } else {
                  _this8.$refs.showRateCard.hide();
                  _this8.showMessage = "Sorry, those seats have already been reserved. Please choose new seats.";
                  _this8.$refs.SeatRealeased.show();
                  _this8.hideLoading();
                }
                _context2.next = 43;
                break;

              case 37:
                _context2.prev = 37;
                _context2.t0 = _context2["catch"](0);

                console.log("Error in reserve seat ", _context2.t0);
                _this8.showMessage = "Sorry, those seats have already been reserved. Please choose new seats.";
                _this8.$refs.SeatRealeased.show();
                _this8.hideLoading();

              case 43:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this8, [[0, 37]]);
      }))();
    },
    hideModal: function hideModal() {
      var _this9 = this;

      this.$refs.SeatRealeased.hide();
      this.showLoading();
      this.resetList();
      setTimeout(function (x) {
        _this9.hideLoading();
      }, 3000);
    },
    resetList: function resetList() {
      this.onResetSeatLayout();
      this.totalNumberOfSeats = 0;
      this.editNumberOfSeats(0);
      this.getSeats({
        md_id: this.MovieID,
        screen_id: this.screen_id,
        ss_id: this.ss_id,
        vista_schedule_id: this.vista_schedule_id,
        rts_performance_id: this.rts_performance_id
      });
    }
  })
});

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Api = __webpack_require__(147);

var _Api2 = _interopRequireDefault(_Api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    getSeatLayout: function getSeatLayout(payload) {
        return (0, _Api2.default)().get("/api/vista/seat-layout/" + payload.vista_schedule_id);
    },
    reserveSeats: function reserveSeats(payload) {
        return (0, _Api2.default)().post("/api/external/vista/reserve-seats", payload);
    }
};

/***/ }),
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 618 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 619 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CjxyZWN0IHdpZHRoPSIxNyIgaGVpZ2h0PSIxNiIgZmlsbD0idXJsKCNwYXR0ZXJuMCkiLz4KPGRlZnM+CjxwYXR0ZXJuIGlkPSJwYXR0ZXJuMCIgcGF0dGVybkNvbnRlbnRVbml0cz0ib2JqZWN0Qm91bmRpbmdCb3giIHdpZHRoPSIxIiBoZWlnaHQ9IjEiPgo8dXNlIHhsaW5rOmhyZWY9IiNpbWFnZTAiIHRyYW5zZm9ybT0ic2NhbGUoMC4wMDYyMTExOCAwLjAwNjYyMjUyKSIvPgo8L3BhdHRlcm4+CjxpbWFnZSBpZD0iaW1hZ2UwIiB3aWR0aD0iMTYxIiBoZWlnaHQ9IjE1MSIgeGxpbms6aHJlZj0iZGF0YTppbWFnZS9wbmc7YmFzZTY0LGlWQk9SdzBLR2dvQUFBQU5TVWhFVWdBQUFLRUFBQUNYQ0FZQUFBQjljanNHQUFBQUFYTlNSMElBcnM0YzZRQUFEc1ZKUkVGVWVBSHRuWDl3VmNVVng4L2VGeExBU0RXRGhJQUNTaFZRRXFTUXhsOFlNRUliT3Ezd1IycC9UTzMwRDJzN2JVZUxXc2ZSVW10bEhLdFNIY2ZwMlA3UnFUUDlZVE1kYVR2S0ZJaEFZOUUwTUV6eUFJTTBsUjlDQkNsU2pQeEk4dDUyencwdkU4STk1OTEzMzgzeTdzM1pHU1o1WjNmUG52MmNML2ZIM3IwdkNvYXhORFEwRk85Njk2TkZTdXN2Z1lacnRZSkpvUFVrTTJUcE1BNHJyb01UNkFhbERpa05oMERCTHEzVVg2Kzk1dEtOalkyTlBjRmRadStwc2pmSnZVVjE5ZEtKcDg2Y1hxbTEranFBSHBlN0IrbFJPQVRVQ2FYMDc4YVVqSDY4dGZYMUQ0WWpybEJGV0Y5Zlg3TC8vWjVIbElJVld1dUxoaU5nOFhsaENDaWxQdEVhVmsrNXZIalYyclZyejRRWlJXZ2k3RC82blhuVmlPK0dNQU1VWDRWRndJang3VEVsSmN2RFBDcUdJc0xabjZtcmdqNzltdm1mY25saElaTm9ob09BT2RPOXI3U3pOSm5ja0F6RGY5NGlQSHY5MXlvQ0RDTWQwZkdCUWpUWGlkVmhIQkdkZkthTjE0Q256dUFwV0k2QStYQ01ZbC9NT2VZZU5aQnYvRVg1T01DYkVIUDNtLzBhVUVHVG81MVhsQ3I2UjFuWnhRYzNiV3Jzem1kYzZUczhCQll1YkNnOWR1emp5VnIzM1pwVzZUdk5zbG9kTnhKZS8vZHJBRlp5N2JMVkJUNGRuNzBSK1RkN0Y2elVIaWZoM0ozY3ZuNXp0a0NrdnZBSVZNNWRYSnRPcFg5dDFuYXZwcUxEdTJaem8vTHBmRTdMZ1UvSC9ldUF6REtNVXMyT0hsMGpBcVRTVi9oMnpCM20wQ3hnTjFQUjRrRUl0VURWKzdFSEVpRStDZWxmaUNhR3dDT2dIbjFITXZuYVIwUUxNVWVFQU9ZUWMybUV1SWNLR2JXQW1xRHFzOWtEaVJBZnhYRlBRdHhUc0Fnd0cvdkkxTHRDTkpkVmRNQjZYTDhtNkJaY1RTQVJ1cytDS2EvbUprUk93UlNjNk5yZG5KcmNVak5nTlVGMU9tc1BKRUxjakVENXhidGdxazdzMFNiQTVwYlJSTFpaQnhLaHV4dUc4SXpMTUVTVm1DTk9nTXN0cDRsczB3NGt3clBic1R4OTR6cWdaNFVZSTArQXpXMy9GcjFBY3d3bVFtWS9vQ3hFQjhwREpEcGx5VzNnUGFKQlJSZ0phQkprTkFpSUNLT1JwMWhIS1NLTWRYcWpNVGtSWVRUeUZPc29SWVN4VG04MEppY2lqRWFlWWgybGlERFc2WTNHNUVTRTBjaFRyS01VRWNZNnZkR1luSWd3R25tS2RaUWl3bGluTnhxVEV4RkdJMCt4amxKRUdPdjBSbU55SXNKbzVDbldVWW9JWTUzZWFFeE9SQmlOUE1VNnlrU3VzN3R1N3VmbVFEcjlIYXBmK2NTcjVrMG92L0theXlaZGMvekREem9QVSszRUhpMENtUGZ5Q1ZNeDd3dXB5TXNuWGdsQjh1N3JHeGhxYXVySGRaL3NlUUNVdnN1ODVEU1ZDdUk4dTRKOW9OWExwV09MbjJscFdYdml2SG94RkRRQlczbG5qNFQ0UXJOVFZQSDlucjYrUHh0YTllYmZKVGxTdy9hMVBYMnB1OHZMcitxcHZYWCs5bDI3ZHFWeTlDSE5MUk93blhmeVNEaG56bTJUVTJtMVJvT2VIeFlEQldwcnd0SEwydHJla0plaHdvSWFzcDhMa1hkUEVWWlZMYWxKNmRTcjVsc1dLa0tlbzNHbnVoSXFzYnk5ZlYxTCtMN0ZZejRFTGxUZXp4TmhmeUI5bTh4a1J1Y3pvU3g5VHlkVTBVSVJZaFpLRnFzdlpON1BFU0VlaXZ2U3FuVjRqb0JEaWFxdUlrZFh5Nmw1S0JmN255OTAzZ2RFaUJlajczVDhkNHNHbUpjTnc4d1owMkh4NGxxNDZjWjVVRkV4QVM2NVpCd2NQMzRDdXJxT3dKYTN0c0Y2ODNXRUhiczdzN2t4ZnlwRGJaMDFzK3ptNGY0N0dWa0RHY0VOQ2lIdkF5S2NYVlYzci9tdXVlZTRmRXk1WWhLc1dIRVAzRjUzQzlmTXJkdlE5Q2FzWHYwUzdEOXdpRzFydm1UeHZoM3RUYyt6amFSeTJBZ1VRdDVkRWJyclFhZk9kSm8xd1BIVWJCY3NxSUdubjNvRVNrdjkvM21TN3U1UDRNR0hWa0Z6TTNNUG91Qm82WmlTNmJLT1NKRWZQbnVoNU4xZEp5d2JQK1ZSODBYWW42ZW1pd0o4OFlVbm9LUWt0Ky9JTGk0dWhxWDFpMkRIem5kaC8zNXlWV1pzVDIrNjc4TWo3MjJreGhmNzhCQW9sTHk3ejQ3VEdyNUJUUk5Qd1hnRWRKeGdqNW14SC9aSFAyVEJKekZTckJNb2xMdzcxMSsvK0hydVVSeGVBK1p5Q3ZZaWlmM1JEMW5NbzBEM21UVFpRQ3JDSmxCSWVYZjYwcWs3cUFuaVhiQ2ZteENxLzJBNytrRi9WRkdwM21WVW5kakRKMUJJZVRmbldFVXV5ZUF5VEppRjkwZkhFV1lNNGl0RGdPYk41eW5UMy85UDNwK2E1M0JmZUlucmdHRVcxbDhlWDdJWVpvd2p4aGZEbTgxVEFFQ3NQeE9IbzBHUmR3eTRFQjFtNGZ4eGNZUVpnL2pxSjhEeDV2SVVoQi9uRCtOd3pCL0tJNVZXVnBicnppMCtSTTRmRndmdlZXcURFT0I0YzNrS01oYm5EK053ekZNU2NrOWgwR1VaS2xET0h4Y0g1VS9zd1Fsd3ZMazhCUm1SODRkeEJGdjhDeEtKOUJFQ0JBRVJJUUZHelBZSWlBanRzWmFSQ0FJaVFnS01tTzBSRUJIYVl5MGpFUVJFaEFRWU1kc2pJQ0sweDFwR0lnaUlDQWt3WXJaSFFFUm9qN1dNUkJBUUVSSmd4R3lQZ0lqUUhtc1ppU0FnSWlUQWlOa2VBUkdoUGRZeUVrRkFSRWlBRWJNOUFpSkNlNnhsSklLQWlKQUFJMlo3QkVTRTlsakxTQVFCRVNFQlJzejJDSWdJN2JHV2tRZ0NJa0lDakpqdEVSQVIybU10SXhFRVJJUUVHREhiSXlBaXRNZGFSaUlJaUFnSk1HSzJSMEJFYUkrMWpFUVFFQkVTWU1Sc2o0Q0kwQjVyR1lrZ0lDSWt3SWpaSGdFUm9UM1dNaEpCUUVSSWdCR3pQUUlpUW51c1pTU0NnSWlRQUNObWV3UkVoUFpZeTBnRUFSRWhBVWJNOWdpSUNPMnhscEVJQWlKQ0FveVk3UkVRRWRwakxTTVJCRVNFQkJneDJ5TWdJclRIV2tZaUNJZ0lDVEJpdGtkQVJHaVB0WXhFRUJBUkVtREViSStBaU5BZWF4bUpJQ0FpSk1DSTJSNEJFYUU5MWpJU1FVQkVTSUFSc3owQ0lrSjdyR1VrZ29DSWtBQWpabnNFUklUMldNdElCQUVSSVFGR3pQWUlpQWp0c1phUkNBSWlRZ0tNbU8wUkVCSGFZeTBqRVFSRWhBUVlNZHNqSUNLMHgxcEdJZ2lJQ0Frd1lyWkh3RkZLcGFqaDB1azBWUlhJenZuajRnZzBtSFJpQ1hDOHVUeXhUb2xLemgvRzRXZ05SNGkrY096WWNhb3FrSjN6eDhVUmFERHB4QkxnZUhONVlwMFNsWncvak1OUm9BOFJmYUdyaTlRbjFZVzFjLzY0T0ZpblVobUlBTWVieTFPUXdUaC9HSWNEU3BFaTNQTFd0aUJqa24xWWYwd2NwRU9wQ0U2QTRjM21LY0NJckQ4VGg3a3gwYVRTMXEvZkhHQkl1Z3Z2ajQ2RDlpZzF3UW5RdlBrODVUNGk3MDl2YzNSaTFCcktiY2Z1VHRqUTlDWlZuWk1kL2FBL3FuQnhVSDNFSHB3QXg5dDIzcDJkMi8vZUJncjJVZE5admZvbDZPNytoS3IyWmNmKzZJY3NabnczRHJLQlZJUk5vSkR5cm5CeTExWFdQVzVPeXorbUpycGdRUTI4K01JVDREaTVMeXNlUFBnQlBQalFLbWh2MzBXNVIvdG1wWnhOWEFPcEM1K0ExdW1GeG1zdDVibXE2bHA0K3FsSFlQTGtpVlFUMG83TE10Lzd3YVBRM054Q3RnRlFQOXVaYkZycGlyQ21wbjVjOTZrem5hQmhQTlVEaFlnQmxaWmVSRFVac0NlVEhlNXB2S21wR2ZidWUzL0FMcjlFazhDMHFaZERYZDBDdUwzdUZxaXNuSmwxRW5qbXd3TVBLMEFGUjB2SGxFeHZhVmw3d2hVaGVwMWRWWGV2MXZvNWJvUXBWMHlDRlN2dWNZUHhhcmRqUndjOHUvcFgwTHExemF0YWJERWdVRDEvRHR5LzR0c3dlN2EzR1BIYUh5Kzk5aDhnRjExY0NtYVIrcjRkN1UzUDQ0Y0JFVFkwTkJTLzAzSHNueHIwL0d5c1pzNllEb3NYMThKTk44NkRpb29KN21uNnNaOCtDMjlzM0pLdHE5VEhoTUJ0aTI2Q3gzNXlQK0JwRjljQmNSa0c3NEs1bTgvTTFCV29yYk5tbHQzYzJOallnN1lCRWVLSE9YTnVtOXlYVnEzbStyQUNQMHNSQXVFVFVGMUZqcTV1YTN2allNYjNPWGNhV0pGUWllV204blNtZ2Z3VUFpRVNPSTM2R2l4QTlIMk9DTkhRM3I2dUphR0tGcHFEWkJkK2xpSUV3aUdndWxCWHFLK2gvczQ1SFErdXhGTnpLcTNXK0xsR0hOelA2L2ZwMDZmQmpCbFh3WVRMeHNQWXNXTzhtb2l0Z0FpY1BIa0tqbng0Rkhidi9nOTBkdTdOT3pLOEJrdzRldG5RSTJER01TbENiT0Rlck93KzlsMGp4RWU1NVp1TXM4RS9pNHVMNFd0ZlhRWjNmdm1MY0lXNXE1WVNUUUlIekYzdUszLzZHL3orRDJ1Z3A4ZTlqL0EvRWJNTVl3VDR4S3daWmIvTTNJUjRkV1pGbU9uZ3JpT2U3SGtBbEw3TGlIRnF4azc5cktxYUJjOCt2ZEs5YzZiYWlEMWFCUEFPK1A0SEh6ZVhhKzlrRHh5ZndHbjFjdW5ZNG1kd0hUQmJCMThpSE94a2RtVmRLM2VLWHJLa0ZwNTY4bUVZTldyVTRHN3lld3dJOVBiMndrTVBQd25yMW0wbVo0T24zaDNKcG1xeWdVZEZUaUtzcWxwU2s5SjliM3Y0Y1UxNEJQenRiMzRoQXFRQXhjQ09RdnptdDM3SUhoSE5EY2dOWGpjZzFQVFB1enVtR3FJOXBkTzRmT05aOEJvUVQ4RnlCUFRFRXhzajVoZnpqUG1tQ3FjVHJ6NDVpVkJCK2c0dkoyakRteEI4ZWlJbC9nUXd6NWh2cW5BNjhlcmpXNFJ6NXk2ZHFnRzhIeGdhejNnWExHWGtFT0R5alRwQnZmaWw0VnVFZmRBN2pYS0s2NEN5REVQUmlhY2Q4NDE1cHdxbmw2RjlmSXZRdkJoS0x2YmhRclNVa1VlQXl6dW5sNkdrZklzd3JkS2tDUEZKaUpTUlI0RExPNmVYb2FSOGkzQm9SL2tzQkRnQ1p1M1BYQnI2Szc1RjZHaUgzS1dJenhtbGpEd0NYTjZWZG54dmdQRXRRcDBBVW9UNG9Gdkt5Q1BBNVozVHkxQlN2a1ZZQktQMkR1MmMrWXc3TGZCQnQ1U1JRd0R6emUydzRmUXlsSkp2RVc3Zi92bytjNTd2R09vZzh4bDNXa2daT1FTNGZLTk9VQzkrYWZnV0lUclU0UHlGY294YmZianZIS0g2aVQxNkJERFBtRytxY0RyeDZwT1RDQlBLZWRYTENkcHdyeGx1OWNFSDNGTGlTd0R6aTNubTloWnlPdkVpay9BeVVyYkRoenNQbHBkZnVjalVUL05xYy9qd1VYaHY3d0hBTjdFU2laeGNlN2tUVzRFUnlHemwyckpsS3htWk9SVnZUaVkzckNJYmVGVGtkQ1RFL2drSGZ1VGhaOENFZTgxd3E0K2NtZ2VReE9JWHpDZm1sZHRMaUJQTnBnOHZHRWE0dVJmem92d2Z6WXZ5ZDNJOVpYcy9SeWM2ZGJsczd6Y3Z0TDlpWG1qL1NxNnpDeVRDeXNvdlhKcFdwMXRBNjZ2OURDZ3ZPdm1oVkRodEFyM29wTlFlUjQrdVNTWmYreWpYbVFRU0lRNVNPVy9KVE4yYmV0c2NFVCtWNjZEU1BsNEV6Qkh3ZjJwVTRvYmt0blhrRWg0MzQ1eXZDVFBPY0VDdFlEa0drTEhKejVGSEFQT1BPZ2dxUUNRV1dJVFllV2RiMDBiOEgyQytjbmdQZnBZeXdnaVl2R1ArVVFmNXpEd3ZFZUxBK0Q4QXJ3WHdvalNmUUtSdnRBaGd2dDFyd0lDbjRNR3pEWHhOT05oSjVuZnpyUTJmVGFYaDUyWVBUMjNHSmovalJjQUlaak11dzVodlUvaFhXRE1MVllTWm9QcGZEVTB2eHhkZWpDREo5MUl5N2VWbllSTXdJdW5BUjNINEpDU1hWem45em1wWVJEaDRjSHpoQmQ4M3dPM2U3bTViclM0ZVhDKy9GeUFCcFQvRy9hTzRIUXQzdytTeUdTSEliUDRQTkJ3TStpU29CWVVBQUFBQVNVVk9SSzVDWUlJPSIvPgo8L2RlZnM+Cjwvc3ZnPgo="

/***/ }),
/* 620 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CjxyZWN0IG9wYWNpdHk9IjAuMTUiIHg9IjAuMDk1NzAzMSIgeT0iMC4yOTM3MDEiIHdpZHRoPSIxNi4wMDk5IiBoZWlnaHQ9IjE1LjAxNTUiIGZpbGw9InVybCgjcGF0dGVybjApIi8+CjxkZWZzPgo8cGF0dGVybiBpZD0icGF0dGVybjAiIHBhdHRlcm5Db250ZW50VW5pdHM9Im9iamVjdEJvdW5kaW5nQm94IiB3aWR0aD0iMSIgaGVpZ2h0PSIxIj4KPHVzZSB4bGluazpocmVmPSIjaW1hZ2UwIiB0cmFuc2Zvcm09InNjYWxlKDAuMDA2MjExMTggMC4wMDY2MjI1MikiLz4KPC9wYXR0ZXJuPgo8aW1hZ2UgaWQ9ImltYWdlMCIgd2lkdGg9IjE2MSIgaGVpZ2h0PSIxNTEiIHhsaW5rOmhyZWY9ImRhdGE6aW1hZ2UvcG5nO2Jhc2U2NCxpVkJPUncwS0dnb0FBQUFOU1VoRVVnQUFBS0VBQUFDWENBWUFBQUI5Y2pzR0FBQUFBWE5TUjBJQXJzNGM2UUFBRDMxSlJFRlVlQUh0blg5d2xNVVp4NSs5SkdEdUxtQkNVREJhNkJBUndkRzBtZ1lHRWFuL01FNUhpVk10WTZlT1RqditLRm9kQjBFSHhTZ3lpREtPVmhrczA0Nk9NKzFZN1FoMTJvNy9XSXhva1FiYWFBVVZZUWFyQ1doQ1lwSzdpNURrdHZzY1hucWM3KzY5KytiZG1CL2ZuWEZ5dC92czk5MzNzMS8yZlhmZmZVOUJEcE9VY2tKSE1ybEVTSEVWa1p3ckpaMUZKTlIvTXU3d3NKQU9URUFrVk4rMENrR3RxcC8yU3lGZnJZakZkZ2doVGdTVzlGRlIrSWl4RGtra0V0Tk9TTEZXbWZDbnF2SWthd0ZVR0VrRXVwVUpmejlCeUlmajhmaFJGdzBMMVlUS2RCTTdFcWsxSk9sdTlTOHE1cUxCMFB5MkNJZ2tDWHFpSWg1ZHIweDVQTXhXaEdaQ0h2Mk9wOFUyWmI3NVlUWVFXaU9OZ0hobllrVFdoemtxaG1MQ2pzVHhDNlhzL3l0SmVmWklRNGIyT0NBZ3hHZENGRjlaRVovNG56RFVoMnpDekFnb1JSTU1HRVozakNJTlpjU0pRdGFHTVNKR2huTGFmQStZdVFSakJCd0t4dEZaVi9VNTl6MTdZS2duVUR3VWdjd2t4TWM5NE40OTc5THJyKytrOTk3ZFIyMWZIS1BlM3ErR2NsalVkVVNndFBRMG1uckdGTHJ3b25sMHhSV0w2T0pMTGlwd0pEbi9wQWRvYllGQVkzSGd5L0hYRTVHRHBsbndaNSsyMG1PUFBrUE56ZThiRzRIQ2tVbWdwdVlDV25YdjdYVDJPV3BwVjV0RVVrMVVxb2R5V1E1OE9lWjFRSk1CZWRTNzVlYVZNS0MyODBaK0FROGUzSWZjbC9va1l5ZTlvSThvVkJKb0pGVDNBUk02ZXBKdFN0eHpJWnBIUUc1OFQ3ZGFnRWNhOVFUS0pzWHBOMXMzbVViRTdvcXkyTlNnVDFZQ2pZVDhLRTZSOVRRZ0UrZExNQXc0NnIwM2VBTGNsOXluaGpUcGEwOFlRdlJGZ1V4NDhsbXd0eWhQUW5BUDZNMW1OT2R5bjNMZjZwTEpFN282MmZ4QUpsVDNnbk96QXZsL2VSYU1ORFlKbVB0Vzc0bENOQUtaOE9SdUdHOXA4MDJzZHgza2pnNENwcjQxZWFMUTJRVXk0Y250V043U3ZBNklORFlKbVB1V3QrZ0ZTd0ZOcU44UGlJWG9ZQjB4R21xWisxYnZpVUxuRnRDRWhXUlJEZ0wrQ2NDRS9sa2gwaEVCbU5BUldNajZKd0FUK21lRlNFY0VZRUpIWUNIcm53Qk02SjhWSWgwUmdBa2RnWVdzZndJd29YOVdpSFJFQUNaMEJCYXkvZ25BaFA1WklkSVJBWmpRRVZqSStpY0FFL3BuaFVoSEJHQkNSMkFoNjU4QVRPaWZGU0lkRVlBSkhZR0ZySDhDTUtGL1ZvaDBSTUQ2RnhnNkU0bUwwbWw5YXpac3ZKOE9mSFNJZHI2NWl3NGVQS3dQUk1tb0lsQmRQWk1XWGJiQTJPYk9udVNESk9UMjhuaGMvMGFVaDRLdjk0N1ZlOGFUMU04OXJCU1NicEFrWjNqb2VHWjlmclNOWG52dDcvVGlIN1pSTXBueWpFSG15Q1VRaTBWcCtmWDF0SFRwRCtuTWFWTjlOMVNRK0VRS2VrSDlsdUVtOVM1eWQ2R0tSaFB5Uys1ZkpudHZreko5djNxUnBiS1FtSzY4cTZ1YlhuaitKZHIyeXQrb3Y3OWZGNGI4RVVLZ3VMaVk2cSs1a202NDhUcWFQRm43ZW5uQjFxcWZIVzRYSXZMSTZiSFNMYVlYNDdVbVRLVlNWYjM5Y3J0NnZmT1Nna2Z6R2ZEaGh3ZHB6YjNycWEwTkwwUDVSRGJzWVZPblRxSDFqNjZoT1hPcVF6eTIyRk5hTEpaRm85RVdMMUZQRTNhbFVuWDlBM0tiK3MzQjZWNlZocEozN0ZnbnJibHZQZTNmZDJBb01xanJnTURjZWJOcC9ZWTFOR1ZLZWZqcVFod3BMaEwxazZQUjNmbmkzekRoMXdaOFF4bnd0UHpnc0w2Zk9ORkh2N3I5UGhneExLQWg2TEFCZi8zTUJwb3dvU1FFTlkyRUVGOHBJMTZlYjhSVFRKaTVCQTlJL3RYVjBFZkEvR2J4aUhqenorL0dwVGtmekxmd25TL0JXMy8zaEpzUk1QOTgxSWhZV2lScWN5L05neWJrU1Vobkl2VVA5ZmZpL0hyNTMzbnBwWEhIVzlUVTFFdzhBKzdxNmxFM3NHV1pHVlJ0YlEwdFhuSXA4WlMrVU9KN3hGL2VzZ3FUbFVLZ0hKYnpKR1RMMXNmcHZQTm1GVHhLV1AydWZqeGhUMFZaZEdGMnNqSm9RbVhBTzlQcDlKT21sclMwSEtWbk56OUhqWTI3VEdHWnNzV0xGOUN0SzI2aXFxcHB4dGlubi9vdHZmelNxOFlZRkxvamNPMTFWOUVkZC83Q2VBQVgvUjZKUk80cWowZWY0Z05uVE1qcmdKMko1Q0hUTXN6dVhYdXBvV0VUSlJOSlk0TnpDMlB4bUtxemt1b1c2QWRYWHI1WmZ1M05XRWZNQlRkTW4za2Q4TVdYdHhxWFlWejFPeS9mbE1kanMzZ2RNZlBZVGkxRTMxUElnS3RYcmJNeUlITmt3M0k5UGhGZDRuVW9YaEJGR240Q3k2Ky9wcUFCWGZVNys0MGZnUEJaWjB5b25vVDhUSWVBaDJJZUFkV2xXaGRpek9kNlhKOTFkSWxYNUpHR244RFNwVXUwQngyT2Z1Y25jTnlBaUhvV1hHTjZGTWYzZ0RhWFlLK3o0dnFzbzB2OFNNalBSRVpYSC9uMkJLclAvYTd4VWR4dzlEdjdqdmNpUkVpS3EzV25rSmtOK1ppRTZPcm41dk5reHJTaG9kREQ4Vnd0ZkI0NmdVV0w5UC8zdCtIc2QrVy9aUkYxYmRiT0duZ1pKc3hrMHB2dFk0a2d6TGFNZHkwVGIxTS9CZUZtMG1QL1JkVDhXUHZqaHJ3T0dHWXk2VldxQlZPazRTTmc0bTNxcHlBdE5Pb3AvMFVrNlUzSUM5RmhKcE5lWldWRm1JZUNWZ0VDSnQ2bWZpb2c2MWxzMG1QL1JkUkM0Um1lTlZWbVoyZVhyaWhRdmttdnZIeHlJRTFVQ2tiQXhOdlVUMEdPWnRKai82bDdRbG1rRXc2NkxCTkVUNjJnNjZvaDN3RUJFKy9oN0hmMkgzcmVRUWREMG80QVRHakhDOUVPQ01DRURxQkMwbzRBVEdqSEM5RU9DTUNFRHFCQzBvNEFUR2pIQzlFT0NNQ0VEcUJDMG80QVRHakhDOUVPQ01DRURxQkMwbzRBVEdqSEM5RU9DTUNFRHFCQzBvNEFUR2pIQzlFT0NNQ0VEcUJDMG80QVRHakhDOUVPQ01DRURxQkMwbzRBVEdqSEM5RU9DTUNFRHFCQzBvNEFUR2pIQzlFT0NNQ0VEcUJDMG80QVRHakhDOUVPQ01DRURxQkMwbzRBVEdqSEM5RU9DTUNFRHFCQzBvNEFUR2pIQzlFT0NNQ0VEcUJDMG80QVRHakhDOUVPQ01DRURxQkMwbzRBVEdqSEM5RU9DTUNFRHFCQzBvNEFUR2pIQzlFT0NNQ0VEcUJDMG80QVRHakhDOUVPQ01DRURxQkMwbzRBVEdqSEM5RU9DTUNFRHFCQzBvNEFUR2pIQzlFT0NNQ0VEcUJDMG80QVRHakhDOUVPQ01DRURxQkMwbzRBVEdqSEM5RU9DTUNFRHFCQzBvNEFUR2pIQzlFT0NNQ0VEcUJDMG80QVRHakhDOUVPQ01DRURxQkMwbzRBVEdqSEM5RU9DTUNFRHFCQzBvNEFUR2pIQzlFT0NNQ0VEcUJDMG80QVRHakhDOUVPQ01DRURxQkMwbzRBVEdqSEM5RU9DTUNFRHFCQzBvNEFUR2pIQzlFT0NNQ0VEcUJDMG80QVRHakhDOUVPQ0VTRUVBTTYzVWdrWEkrYTlOTHB0SzRaeUhkQXdNVGIxRTlCbW1MU1kvOUZKTkVYT3VIeThzbTZva0Q1SnIzT3pxNUFtcWdVaklDSnQ2bWZnaHpOcE1mK2l3aWlWcDN3bWRPbTZvb0M1WnYwMnRzN0FtbWlVakFDSnQ2bWZncHlOSk1lK3k5Q1VtL0MydHFhSU1mVTFqSHB0YmNkMDlaRFFmZ0VUTHhOL1JTa0pVWTk1VDkxVDBoN2RjS0xsMXlxS3dxVWI5STc4TkdoUUpxb0ZJeUFpYmVwbjRJY3phVEgvb3VRa050MXd0WFZNMm54NGdXNllxdDgxbUU5WGRyNTVpNWRFZklkRUREeEhzNStaLzlGeXVQeGR3V0pUM1RuZWV1S215Z1dqK21LZmVWemZkYlJwYytQdHRIQmc0ZDF4Y2gzUUlCNU0zZGRHbzUrWjkrZDlKOXF4YkdlNU1NazVRTzZCdTNldFpkV3IxcEhwbW05cnU3MHM4Nmtob1o3NlB4NXMzVWgxTnk4ai83OXIvZTA1U2h3UStCNzM3K1FhbXJtYWNVLzJIZEE5ZDNqZEtUMWMyMk1yb0NYWlRZKzlnRFZMYmhZRjBJa3hMb3BaYkcxYW5KQ3luOXlVbWNpZVVoS3F0VFZZQ00yTkd5aVpDS3BDeG5NbjZzTWQ1bTYvQzY2YkFHZGM4NVpnL240TURvSmZQcHBLL0hsKzgzR1hiUmZHYk5RNGl0ZlE4Tktvd0hWdldCN2VUdzJTNjBUZG1kTXlLS2RpZFNkYXFSNzBuU0FscGFqOU96bTU2aFJOY1lyblQ5M050MjI0a2IxcitzQ3IyTGtqUUVDemMzdjA1Yk56OU1IKzczTnlQZitmQ212cXBwbVBGczFVdDVWSG84K3hVR0RKbFNqNFlTT250VGJhbHk4eEZoYkZmTDlST09PdDZpcHFUbHpYekdRbHJSNjlRcGF1S2l1VUZXVWp4RUNiKy9jVFJzM2JxWWl0ZExNNjRDOERNT3pZTlBrOC8rbkx2WlVsRVVYcWxId0JPY05tcEMvcEZLcHF0NEIyYVN1ejlQNU94SUloRTVBaUNPbFJhSTJHbzIyWkxWUGVUak1CY1ZGb2w3ZE1INlZEY0JmRUFpTmdQSVYreXZYZ0t4OWlnazVZM0kwdWxzRlhxNk1lSVMvSTRGQUtBU1VuOWhYN0s5OHZWTXV4N21GbVV0elB5OWtGNzVIekszbjlmbnc0Zi9Tb1k4UFUzdjdNVXIxWXBEMVlqU1M4cUtscDFGbDVSU2FkZTVNbWpuek95RTBUZXdwTFJiTDhrZkFyTERXaEJ6QWs1VXZrNzIzU1ptKzM3UjhreFhML2R2WDEwZXYvT2t2dEgzN2E5VHlHUWJWWERhajZYUFYyZE5wMmJLbGRNMlBmMFFsSlNWV1RlZGxHQ0VpajV3ZUs5MlNuWVI0Q1JoTm1LM0E2NGdkaWRSS0lla0dTWEpHTmwvM2w5ZVNIbHk3MGJnaXI2dUwvSkZKZ0dmQUR6MjhtbmdOdUZEaUp5RlMwQXNWOGVnbVhnY3NIRjhvSXE5Y0xXbzNwZFA2Uy9RYk85Nm1kUTg5UVR3U0lvMHRBandTUHZEZzNYVDVrb1hhRTR0RXhCNjFDRjJyRGZBbzhEVVNadXQxcFZKMS9mM3BkN0xmOC8veUNIakhpdnRnd0h3d1krZzdHL0hwelJ1TUkySnhjV1MrMXdSRWgrRWJzMk5kSU9jUHBLbGVWODRqSDErQ01RTHFDSTJOZkQvOWJQS0pGd1VyRTZvSnl0VmVJcHpIa3hEVHJneGRQZVNQUGdMY3o5emZ1bVR5aVZjZDN5YnM3TzJkb1haaHovRVM0VHllQlNPTkh3TEcvbFkreWZqRkp3N2ZKcVIrbXFuVDVIVkFMTVBvNkl6TmZPNXY3bmR0TXZnbHY0NXZFMG9odFh1eWVDRWFhZndSTVBXN3lTLzVwUHlia0VoclFuNFNnalQrQ0pqNlhiM0txZlZMUGluZkpzeXZpTzhnVUlDQThxRy81TnVFYWtGUiszNHlQMmRFR244RVRQMnUvT0w3V2ExL0UwcWhOU0UvNkVZYWZ3Uk0vUzRNZnNrbjVkdUVWRXlIOHl0bnYvTk9DMzdRalRSK0NIQi9HM2ZZR1B5U1Q4bTNDY3RMU3o5Uis3QS96QmZJZnVlZEZrampoNEN4djVWUE1uN3hpY08zQ1ZsUGJjdjVzMDZYdC9xWWZuTkVWdy81bzQ4QTl6UDN0eTZaZk9KVng4cUVSUkhhNWlYQ2VmeGdtN2Y2Mk80NTAra2hmMlFTOE5QUEpwOTRuWldWQ1hsbmhOcW8yT2dseEhtODE0eTMrc0NJT2tLak81LzdsZnZYdEtlUS9XR3pnNGFKcUptMFhWTGJ1WDZndG5OOTR6MkJYQlZzYXMybE1UWSsrOTNVcXJaeDFTa1QvdFBtcksxTnlPSWRQWWtYMVhiL241Z094RnQrc0wzZlJHaDBsTmxzNzFlajRCOHJ5dUxMYmM4c2tBbS9sTEo4b0NmSm8rRzVmZzZJRjUzOFVCbzVNUUZmZFBxNHFDeFdkN29RbmJabkVzaUVmSkR1N3VOeitxbnZIZlZzSnR6ZkZMWTlBOFIvNndTVWlicUtxV1QrcEVrVHRVdDRwa1phVFV4eWhmaUFRaFRWY3dOeTgvRjVmQkhnL21jZkJEVWcwd284RW1aUjg0allSMzJ2cXUrK0xzM1pldmc3SmdoOFhFSWxWdzNGZ0V3aDhFaVlSY2dONEhzQnZpbk41dUh2MkNmQS9jMzlQbFFETXFraGo0UzV1SG41Wm1BZy9aaWFPUy9PemNmbnNVT0Exd0dMaWlLcmJKZGhUQVJDTldIMlFQeHFLTDl4bFhuaHhmQmVTalllZjBjNEFmVXNtQi9GOFpNUTI0Vm9QMmZteElTNUI4Njg4S0xlTitEdDNwbmR0bEtXNVpiajh3Z2tJRVNQTWtaclpqdVcyZzFqc3hraHlObjhENnNKNjhLY3EvWldBQUFBQUVsRlRrU3VRbUNDIi8+CjwvZGVmcz4KPC9zdmc+Cg=="

/***/ }),
/* 621 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAgCAYAAAB3j6rJAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALCSURBVHgB7Zi/liFBFMavWeHMJBPNRBPNPMDIySQ8AHIegAcQiZCTI0ckQc4DkCOSIJL09q/OXqf0Ybfan90N5junTlNdXfXdW/fer7ojng+x0Gw2pdPpyHa7lXshn8+bZiNiE1mtVpJOpyWVSsnb25vcA/P5XEajkfR6PXl9fT30R+1By+XSXCHz9fUl98B0OjVEWMsm8iD/Cb6JBHExEQI7m81KLBYzmfbPiLTbbZMBACLXprvJGqzTSHbF09PT4Tepbv93AethSCKRMNkTpaNUKklYaOoxUbFYlLCgaIJarSbValV+rNfr8vPzs3S7XUkmk7Lf700NeXl5+e1EeHEwGEilUpH393dxxW63M3NTWQuFgqkrNBb1Go2GFxaLxcLjWb9CeteAtZknKhdCJYC4wjs2Hh8fQ8dM6KwhOzRdiRN+Iwl2G4/HEhahPILl7K2KI1bTMpnM0bhLdMqZiJKIRCIH5fz8/JTJZGKKWhB4Lsz2OBNhCyDhB9chdbmqd4IghlqtljMZJyIshheoF7Z0syWntoHx5XLZ1IrgAegqIrPZzFyDi2LtuXiAOEQg6+IVp6xRHXF1s8YTz2kFvQkRJeAqbJTtj48P4y09/1I96b+KiLofXfoTVED7/f7BK7lczpRz+oLFLxQRPEJmYN25iRRa7BBDDKBBBlLomR3sR3DVms1m4/mne88n5Pll/eR9X0W9U/Nx72Zag1ewFsv0lK9bht5Q1rGcFA9WWpcgjzJIT1qAoKIYnXIhfaQljf22NYd3IY6OZ13/C2wtxNUI/rNexD/yeRrldGIV1fOe7zUELouj0jgBL0dxIx1YiHfMIeUvAM+pYBqJsAPHFzATOMPh0LsXdA2uNh6CLIEdM7eGzh18tz7KGm4SGwQhAXXrF3Et+Xpyt3H0NUAH1+t1Ux1v/WmCmIjH4ybFgyn9E+Td0spradxuAAAAAElFTkSuQmCC"

/***/ }),
/* 622 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAABACAYAAACjgtGkAAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAVjSURBVHgB7VxNaFNLFD7JqyAkT7Bgq8Lrw+bxhPfUCroI1p1SN1K1LqRCu1JQFyL+gbrQjQr+gLpREDf1b6VFd60/uGmtoGCjLgQTQaHaKgqaoKBS57vp3E6uuXdu0pm5NzEfhKa5bTPz5Zsz53xnbiPjDCTB9Vc32eMGjX4do0pEIt5MHX+3U9ucFdKfjcgI6clcpYuZK1QN6G7eSF3NnZ4/E/W6CEVUCxlAD5uLTOWehAyM3adqw/DHlOd1T0Ky33NUbXj7ZQoK+R1RI8SBGiEO1AhxoEaIAzVCHKgR4kAdBYSOv9pZfbGGGqc3UDqbseql/pE7FDQCIaSb1RNdrK7gQPG1578dFKuLUS8jJkgYXzJxNmmRDBHdLq+bhHFCGqc3ul4DWVhCQcI4IdnvWc/ruR/B1k92DMmxQg6BbWBsyBp0vC4uHXw5QPmNohFqcALvn/2ml5DBsQd28MYcV81dQcsakrYyLYMIg9z1cJ8xR+zS8gu/LI3+N3fo+LNTFAQwlpNLj1pf60yTAaQ/ZWxCzj4/TwPvhgK1JzkH55JnKOrHRVKN7I+s8DwXCq8WY+hlvnH0xecMmYZo0sSKxJKg0MdiSzTz+SWZhqgIJGVhAcYVSC2T/jT5IcSnhUchQCCEiNv5P3+GRyFAILWMuGSw2/jJTpG75AyY3kYJaZm5kLUBnljPQQonAnmJDPi93Y/2k24YWTIg4sSSI9aDxwzkImGEdoVs/XcTdTStsb+P/RGz0nMxF4FaRr+Mev6dtKHdUCshe/7fUdBgRgyIT4tbBIi5SN/IbdYyvUphgDZCoAyRDBRuyIp5YCwMrI0UFmghBI6YuEyKnSAQc5HF9Qupba78qAKA3WaQVeS6oJwQ7BwyMgAxF8HvwEL0CyhN1xJTvsvABuT1CbZKt+MU3BcpByBcV4arVCEwfUTpy/yNLUPbfS8VoHVWkhIss8X7rGOuvQ6VKCUE+QYH1CEr6/MHcvxPKvXxqZXLAFBJ72v1DpvSJbNo5gL7OUwf1QDJqYlMl6tENZQSIhZquhKpHkFRUIlql15b6q7aoOa+iVMlqns52gjJKV7b2FV4ABZVgtdUqkQpIWKAS8yYRyohqkFUCVBMJbEym15KCXn7dbJAU20NLpuV753IVBKzWqWddJlZCqilSoVSQgbfPbCfi1uwCrTU5/+em0q2zd/M6qfNFhE8OcQYFpU4DqWEYJA8+yxnMG5wixOiSqCgjqb2Ahcf4yk1likPquhtcGybv2nKKXbMsZP0CKWAUyXi63DX8MDZk1KgnBCrPzuhEsSRrnmdNBXsZXGAqwOZrfNQzTFWHvD3E4kYLkKUH0RW3lotvRuiVKDmONRywP6+3OrUaTC5TZQvExUmtJY8BGm7SAAkX6zB7QbEn3PJ0wVkIF64feo5hY68FoVwFLsdA5IfeD9Ewx+eFEwCZGEnAQnOHcrkLSpaCQGwQ4CYYuoAIfysSLEeL64fHD5cdjwoB5G19zaM6z6kAjK6Ext93dEE8MM719iOZaI5xYEPJrLz4b7xlKFPgC+L1omsMzFRHXOlYBlhm0QX3iQRHFiqkccfUuMmOmKVAPi6UbCyrkm90VJpwEFixDv7JkSdTnaYkc+EJ9smBXdlIhPEiaI0e8xmzSN+5LqaABUgg4aBhTm2NiQLdrgCk5kfTUDQA/pGqOrQwnzftjkrXa9LblP1bkBXImQphichYeq5qsJsyZw8CVlcr9bkCQMSM7ydPIlCGpSZPGEAUgxZgSmtduFHhO2kYDnATuLHY5USAkbRPgz6to2pIH+W3d8cIn7+XQaAHAX/C6D/zV0rT6kEcJd+PUu6/J6Y/gkIUYBT5UyBtQAAAABJRU5ErkJggg=="

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_slick__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_date_pick__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_date_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_date_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_date_pick_dist_vueDatePick_css__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_date_pick_dist_vueDatePick_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_date_pick_dist_vueDatePick_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper_internet_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__helper_internet_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helper_collection_js__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helper_collection_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__helper_collection_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helper_constants_js__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helper_constants_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__helper_constants_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_storage_service__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_storage_service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__services_storage_service__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__eventBus_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__eventBus_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__eventBus_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_partials_progressRing_vue__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_stripe_elements_plus__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_stripe_elements_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_stripe_elements_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__services_mainService_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__services_mainService_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__services_mainService_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__services_AuthServices_js__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__services_AuthServices_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__services_AuthServices_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__services_PromotionServices_js__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__services_PromotionServices_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__services_PromotionServices_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_debounce__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_debounce__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














var STRIPEPUBLICKEY;
if (window.localStorage.getItem("country") != "" && window.localStorage.getItem("country") != null && window.localStorage.getItem("country") != undefined && JSON.parse(window.localStorage.getItem("country")).hasOwnProperty("pgData")) {
  if (JSON.parse(window.localStorage.getItem("country")).pgData[0].PublicKey != "") {
    STRIPEPUBLICKEY = JSON.parse(window.localStorage.getItem("country")).pgData[0].PublicKey;
  } else {
    STRIPEPUBLICKEY = __WEBPACK_IMPORTED_MODULE_7__helper_constants_js__["STRIPE_PUBLIC_KEY"];
  }
} else {
  STRIPEPUBLICKEY = __WEBPACK_IMPORTED_MODULE_7__helper_constants_js__["STRIPE_PUBLIC_KEY"];
}

console.log(STRIPEPUBLICKEY, "keyp");

var stripe = Stripe(STRIPEPUBLICKEY);
var VueScrollTo = __webpack_require__(129);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "payment",
  props: ["stripe", "options"],
  components: {
    Slick: __WEBPACK_IMPORTED_MODULE_2_vue_slick__["default"],
    DatePick: __WEBPACK_IMPORTED_MODULE_3_vue_date_pick___default.a,
    progressRing: __WEBPACK_IMPORTED_MODULE_11__components_partials_progressRing_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_14_vue_stripe_elements_plus__["Card"],
    CardNumber: __WEBPACK_IMPORTED_MODULE_14_vue_stripe_elements_plus__["CardNumber"],
    CardExpiry: __WEBPACK_IMPORTED_MODULE_14_vue_stripe_elements_plus__["CardExpiry"],
    CardCvc: __WEBPACK_IMPORTED_MODULE_14_vue_stripe_elements_plus__["CardCvc"]
  },

  data: function data() {
    return {
      showPayPalConformationBlur: false,
      showCoupon: true,
      msgError: "",
      stripePublicKey: STRIPEPUBLICKEY,
      complete: false,
      number: false,
      expiry: false,
      cvc: false,
      instance: null,
      isPayLoading: false,
      PaymentOptionsLoading: false,
      cientToken: "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",
      stripeOptions: {
        // see https://stripe.com/docs/stripe.js#element-options for details
      },
      BASEURL: __WEBPACK_IMPORTED_MODULE_7__helper_constants_js__["URL_BASE"],
      phone: "",
      MobileNo: "",
      promoApplied: false,
      statusFlag: {
        paymentActive: ""
      },
      timerStartFunction: null,
      timer: {
        TimeoutModal: false,
        minutes: 10,
        seconds: 0,
        stop: false
      },
      fbSignInParams: {
        scope: "email",
        return_scopes: false
      },
      googleSignInParams: {
        client_id: "911938447926-kls328d23otm80v12n1jq13h8ajeh57f.apps.googleusercontent.com"
      },
      tabs: {
        collapse1: true,
        collapse2: false,
        collapse3: false
      },
      UserToken: false,
      userLoggedIn: false,
      ShowLogin: true,
      showDetails: {},
      movieDetails: {},
      bookingDetails: {},
      CinemaScheduleID: "",
      CategoryID: "",
      BookSeats: "",
      BookingSeatsName: "",
      ShowType: "",
      nonce: "",
      ReserveId: "",
      Successurl: "",
      Failurl: "",
      bookID: "",
      PaymentId: "",
      userDetails: {
        email: "",
        phone_no: "",
        password: "",
        CountryCode: "1",
        country_id: 38,
        country_mob_code: "1"
      },
      signUpUserDetails: {
        password: "",
        email: "",
        CountryCode: "1",
        phoneNumber: "",
        OTP: ["", "", "", ""],
        userName: "",
        termsAndConditions: true,
        ConfirmPassword: "",
        country_mob_code: "1",
        country_id: 38
      },
      OTP: ["", "", "", ""],
      errorMessage: {
        login: "",
        signUp: "",
        reserveBooking: "",
        payment: "",
        socialLoginError: ""
      },
      OGtotalAmount: "",
      days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      paymentToken: "",
      months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      checkKey: false,
      paymetOptions: {},
      showOtpSection: false,
      showBrainTreeContainer: false,
      showProceedForLogin: false,
      showProceedButton: false,
      ScreeningTypeName: "",
      selected: true,
      confirmDetails: {},
      promocode: "",
      DiscountValue: 0,
      TaxOfferValue: 0,
      promocodeSuccesMessage: "",
      promocodeErrorMessage: "",
      CountryCodeList: [],
      paymentSecret: "",
      stripeCards: [],
      stripeCardSelected: {},
      selectedPaymentOptionID: "",
      ReservationID: null,
      offerData: {},
      directPay: false,
      showMessage: "",
      searchCode: "",
      countriesCopy: [],
      ActivePaymentModes: [],
      isBrainTreeActive: false,
      slect_payment_mode: true,
      is_branin_tree_active: false,
      is_paypal_active: true,
      bt_client_token: null,
      braintree_customerid: "",
      userInfo: null,
      ShowSignUp: false,
      passwordRequiredMessage: "Password is Required.",
      passwordValidationMessage: "Password must contain minimum 6 characters, Contains at least one Lowercase letter, one Uppercase letter and one Number"
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_10__eventBus_js___default.a.$on("onSignUpError", function (message) {
      _this.errorMessage.signUp = message;
    });
    __WEBPACK_IMPORTED_MODULE_10__eventBus_js___default.a.$on("onSignUpSuccess", function () {
      _this.ShowLogin = true;
      _this.ShowSignUp = false;
    });
    __WEBPACK_IMPORTED_MODULE_10__eventBus_js___default.a.$on("onProfileSuccess", function () {
      _this.fetchUserDetails();
    });
    // Create an instance of Elements.
    var elements = stripe.elements();
    // import { StripeElement } from
    // Custom styling can be passed to options when creating an Element.
    // (Note that this demo uses a wider set of styles than the guide below.)
    var style = {
      base: {
        color: "#32325d",
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: "antialiased",
        fontSize: "16px",
        "::placeholder": {
          color: "#aab7c4"
        }
      },
      invalid: {
        color: "#fa755a",
        iconColor: "#fa755a"
      }
    };
    if (window.innerWidth <= 991) {
      setTimeout(function () {
        VueScrollTo.scrollTo("#totalPayment", "1000");
      }, 1000);
    }

    // var stripe = Stripe('pk_test_xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx')

    // Create an instance of the card Element.
    // var card = elements.create("card", { style: style });

    // // Add an instance of the card Element into the `card-element` <div>.
    // card.mount("#card-element");

    // // Handle real-time validation errors from the card Element.
    // card.addEventListener("change", function(event) {
    //   var displayError = document.getElementById("card-errors");
    //   if (event.error) {
    //     displayError.textContent = event.error.message;
    //   } else {
    //     displayError.textContent = "";
    //   }
    // });

    // // Handle form submission.
    // var form = document.getElementById("payment-form");
    // form.addEventListener("submit", function(event) {
    //   event.preventDefault();

    //   stripe.createToken(card).then(function(result) {
    //     if (result.error) {
    //       // Inform the user if there was an error.
    //       var errorElement = document.getElementById("card-errors");
    //       errorElement.textContent = result.error.message;
    //     } else {
    //       // Send the token to your server.
    //       stripeTokenHandler(result.token);
    //     }
    //   });
    // });

    // // Submit the form with the token ID.
    // function stripeTokenHandler(token) {
    //   // Insert the token ID into the form so it gets submitted to the server
    //   var form = document.getElementById("payment-form");
    //   var hiddenInput = document.createElement("input");
    //   hiddenInput.setAttribute("type", "hidden");
    //   hiddenInput.setAttribute("name", "stripeToken");
    //   hiddenInput.setAttribute("value", token.id);
    //   form.appendChild(hiddenInput);

    //   // Submit the form
    //   form.submit();
    // }
  },
  beforeMount: function beforeMount() {
    var _this2 = this;

    // this.isPayLoading = true;
    // this.showLoading();


    if (this.$route.query.paymentId && this.$route.query.PayerID) {

      this.showPayPalConformationBlur = true;
      //  this.showLoading();


      __WEBPACK_IMPORTED_MODULE_15__services_mainService_js___default.a.ExecutePaymentWithPaypal({
        payment_id: this.$route.query.paymentId,
        payer_id: this.$route.query.PayerID
      }).then(function (response) {
        //  console.log(response,  "success >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>")
        // this.isPayLoading = false
        // this.hideLoading();
        if (response.data && response.data.status == "success") {
          _this2.payNow("paypal");
        } else {
          _this2.$router.push({
            name: "failedPayment"
          });
        }

        //  window.location.href = response.data.payment_url
      }).catch(function (err) {
        console.log("Error:", err);
        _this2.$router.push({
          name: "failedPayment"
        });
      }).finally(function () {
        // this.isPayLoading = false;
        // this.hideLoading();
      });
    }

    this.ReservationID = this.$route.params.reservation_id || null;
    this.CategoryID = this.$route.params.category_id || 1;
    this.userInfo = window.localStorage.getItem("user") ? JSON.parse(window.localStorage.getItem("user")) : null;
    console.log(this.$route.params);
    if (this.CategoryID == 2) {
      this.getCreateReservation();
    } else {
      this.getReservationDetails();
    }
    this.fetchUserDetails();
    this.getAllGetCountryList();
    this.getActivePaymentModes();
    this.checkUserLogin();
  },

  watch: {
    number: function number() {
      this.update();
    },
    expiry: function expiry() {
      this.update();
    },
    cvc: function cvc() {
      this.update();
    }
  },
  computed: {
    payBtnText: function payBtnText() {
      return "Pay " + curr_code + " " + currFormat(totalPayableAmount);
    },
    totalPayableAmount: function totalPayableAmount() {
      var total = this.showDetails.amount - this.DiscountValue - this.TaxOfferValue;
      return total;
    },
    curr_code: function curr_code() {
      return this.$store.getters.getCurrCode;
    },
    _userInfo: function _userInfo() {
      if (window.localStorage.getItem("user")) {
        var user = JSON.parse(window.localStorage.getItem("user"));
        this.userLoggedIn = true;
        return user;
      } else {
        return false;
      }
    }
  },
  methods: {
    showDateHandlaler: function showDateHandlaler(date) {
      return __WEBPACK_IMPORTED_MODULE_12_moment___default()(date).format("MMMM DD, YYYY");
    },
    payNowWithPaypal: function payNowWithPaypal() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_15__services_mainService_js___default.a.MakePaymentWithPaypal().then(function (response) {
        console.log(response, "success >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");

        window.location.href = response.data.payment_url;
      }).catch(function (err) {
        console.log("Error:", err);
        _this3.$router.push({
          name: "failedPayment"
        });
      }).finally(function () {
        _this3.isPayLoading = false;
      });
    },
    checkUserLogin: function checkUserLogin() {
      if (window.localStorage.getItem("user")) {
        this.userLoggedIn = true;
      }
    },
    onLoad: function onLoad(instance) {
      this.instance = instance;
    },
    onLoadFail: function onLoadFail(instance) {
      this.showMessage = "Something Went Wrong!";
      this.$refs.SeatRealeased.show();
    },
    bt_makePayment: function bt_makePayment(payload) {
      var _this4 = this;

      this.isPayLoading = true;
      // this.showLoading();
      console.log("Success!", payload.nonce);

      payload = {
        nounce: payload.nonce,
        reservation_id: this.ReservationID,
        cust_id: this.userInfo.cust_id,
        email: this.userInfo.cust_email,
        braintree_customerid: this.braintree_customerid,
        mobile: this.userInfo.cust_mobile,
        countryMobCode: this.userInfo.country_mob_code,
        category_id: this.CategoryID,
        cinema_id: this.showDetails.cine_id,
        cinema_name: this.showDetails.cine_name,
        isCinema: this.CategoryID == 2
      };
      __WEBPACK_IMPORTED_MODULE_15__services_mainService_js___default.a.MakePayment(payload).then(function (response) {
        var data = response.data;

        if (data.status) {
          _this4.payNow();
        } else {
          _this4.showMessage = data.message;
          // this.hideLoading();
          _this4.$refs.SeatRealeased.show();
        }
      }).catch(function (err) {
        console.log("Error:", err);
        _this4.$router.push({
          name: "failedPayment"
        });
      }).finally(function () {
        _this4.isPayLoading = false;
      });
    },
    EditPaymentMode: function EditPaymentMode(payload) {
      this.slect_payment_mode = true;
    },
    slectPaymentMode: function slectPaymentMode(payload) {
      this.slect_payment_mode = false;
      if (payload == "paypal") {
        this.is_paypal_active = true;
      } else {
        this.is_branin_tree_active = true;
      }
      // console.log(payload, "payload >>>>>>>>>>>>>>>>>>")
    },
    paypal_makePayment: function paypal_makePayment(payload) {
      var _payload,
          _this5 = this;

      // console.log(window.location.hostname, "inside >>>>>>>>>>>>>")

      this.isPayLoading = true;
      // this.showLoading();
      // console.log("Success!", payload.nonce);

      console.log(window.location.hostname, "window.location.hostname >>>>>>>>>>>>>");

      payload = (_payload = {
        // nounce: payload.nonce,
        category_id: this.CategoryID,
        reservation_id: this.ReservationID,
        cust_id: this.userInfo.cust_id,
        email: this.userInfo.cust_email,
        braintree_customerid: this.braintree_customerid,
        mobile: this.userInfo.cust_mobile,
        countryMobCode: this.userInfo.country_mob_code
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_payload, "category_id", this.CategoryID), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_payload, "cinema_id", this.showDetails.cine_id), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_payload, "cinema_name", this.showDetails.cine_name), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_payload, "isCinema", this.CategoryID == 2), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_payload, "host", window.location.hostname), _payload);
      __WEBPACK_IMPORTED_MODULE_15__services_mainService_js___default.a.MakePaymentWithPaypal(payload).then(function (response) {
        var data = response.data;
        // console.log(response, "response >>>>>>>>>>>>>>>>>>>>")

        if (data.status) {
          // this.payNow();
          window.location.href = response.data.payment_url;
        } else {
          _this5.showMessage = data.message;
          // this.hideLoading();
          _this5.$refs.SeatRealeased.show();
        }
      }).catch(function (err) {
        console.log("Error:", err);
        _this5.$router.push({
          name: "failedPayment"
        });
      }).finally(function () {
        _this5.isPayLoading = false;
      });
    },
    onError: function onError(error) {
      console.log("Error!", error);
    },
    getActivePaymentModes: function getActivePaymentModes() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_15__services_mainService_js___default.a.GetActivePaymentModes(2).then(function (response) {
        var data = response.data;

        if (data.status && data.Records.length > 0) {
          _this6.ActivePaymentModes = data.Records;
        } else {
          console.log("Error:", data.message);
        }
      }).catch(function (err) {
        console.log("Error:", err);
      });
    },
    checkPaymentMode: function checkPaymentMode(paymentModes) {
      var _this7 = this;

      this.PaymentOptionsLoading = true;
      // this.showLoading();
      var BrainTree = paymentModes.find(function (x) {
        return x.pm_id == 16;
      });
      if (BrainTree) {
        this.isBrainTreeActive = true;
        console.log("this.userInfo checkPaymentMode", this.userInfo);
        __WEBPACK_IMPORTED_MODULE_15__services_mainService_js___default.a.createBrainTreeClientToken({
          cust_id: this.userInfo.cust_id
        }).then(function (response) {
          var data = response.data;

          if (data.status) {
            _this7.bt_client_token = data.clientToken;
            _this7.braintree_customerid = data.braintree_customerid;
          } else {
            console.log("Error: ", data.message);
          }
        }).catch(function (err) {
          console.log("Error:", err);
        }).finally(function () {
          _this7.PaymentOptionsLoading = false;
          // this.hideLoading();
        });
      }
    },
    onSearchCode: function onSearchCode() {
      var _this8 = this;

      if (this.searchCode && this.searchCode.length > 0) {
        this.CountryCodeList = this.countriesCopy.filter(function (x) {
          if (x.country_mob_code && x.country_mob_code.toLowerCase().includes(_this8.searchCode.toLowerCase())) {
            return x;
          } else if (x.country_name && x.country_name.toLowerCase().includes(_this8.searchCode.toLowerCase())) {
            return x;
          }
        });
      } else {
        this.CountryCodeList = this.countriesCopy;
      }
    },
    GetDate: function GetDate(date, format) {
      if (format == "day") {
        return __WEBPACK_IMPORTED_MODULE_12_moment___default()(date).format("ddd");
      } else if (format == "time") {
        return __WEBPACK_IMPORTED_MODULE_12_moment___default()(date).format("HH:mm");
      } else if (format == "month") {
        return __WEBPACK_IMPORTED_MODULE_12_moment___default()(date).format("mmm");
      } else if (format == "date") {
        return __WEBPACK_IMPORTED_MODULE_12_moment___default()(date).format("dd");
      } else if (format == "full") {
        return __WEBPACK_IMPORTED_MODULE_12_moment___default()(date).format("ll");
      }
    },
    selectPayment: function selectPayment(Payment) {
      this.PaymentId = Payment.PaymentID;
      this.onSelectPayment(Payment);
    },
    proceedStripePayment: function proceedStripePayment() {
      this.selectedPaymentOptionID = 3;
    },
    confirmStripePaymentDetails: function confirmStripePaymentDetails() {
      this.timer.stop = true;

      if (this.stripeCardSelected.id) {
        // this.useAlreadyPresentCard();
        var cardButton = document.getElementById("card-button");
        console.log("test1", this.paymentSecret);

        // cardButton.addEventListener('click', function(ev) {
        //     // console.log('test2', this.paymentSecret)

        //     // stripe.handleCardPayment(
        //     //     this.paymentSecret, {
        //     //         payment_method:'pm_1FMeCsHnQVOfChkcPTGI8tAT',
        //     //     }
        //     // ).then(function(result) {
        //     //     if (result.error) {
        //     //         // Display error.message in your UI.
        //     //     } else {
        //     //         // The payment has succeeded. Display a success message.
        //     //     }
        //     // });
        // });
      } else {
        this.startStripeWithoutSavedCard();
      }
    },
    updatePaymentMethod: function updatePaymentMethod(paymentMethodID) {
      var payload = {
        ReserveID: this.ReserveId,
        PaymentID: this.PaymentId,
        PaymentMethod: paymentMethodID,
        updateCustomer: true,
        gogoStripe: 1
      };
      console.log("paymentMethodID :", paymentMethodID);
      Object(__WEBPACK_IMPORTED_MODULE_5__helper_internet_js__["makeRequest"])("/getPGOptions/", "POST", null, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        console.log("res payment1:", res);
      }).catch(function (error) {
        console.log("Error", error);
      });
    },
    useAlreadyPresentCard: function useAlreadyPresentCard() {
      var _this9 = this;

      var payload = {
        ReserveID: this.ReserveId,
        PaymentID: this.PaymentId,
        payment_method_id: this.stripeCardSelected.id,
        gogoStripe: 1
      };
      // this.showLoading();
      Object(__WEBPACK_IMPORTED_MODULE_5__helper_internet_js__["makeRequest"])("/getPGOptions/", "POST", null, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        console.log("res payment handle already present card:", res, _this9.stripeCardSelected);
        if (res.data.Status == false) {
          // this.hideLoading();
          _this9.$refs.sessionTimeOut.show();
        } else {
          _this9.paymentSecret = res.data.paymentintentid;
          var that = _this9;
          stripe.handleCardPayment(res.data.paymentintentid, {
            payment_method: _this9.stripeCardSelected.id
          }).then(function (result) {
            if (result.error && !result.hasOwnProperty("paymentIntent")) {
              that.$refs.apiKeyfailed.show();
              that.hideLoading();
            } else if (result.paymentIntent.status != "succeeded") {
              alert("sorry your payment failed");
              that.hideLoading();
              // Display error.message in your UI.
            } else {
              that.hideLoading();

              that.$router.replace({
                name: "confirmScreen",
                params: {
                  bookingId: that.ReserveId || 0,
                  paymentId: that.PaymentId || 2
                }
              });
              // The payment has succeeded. Display a success message.
            }
          });
        }
        //   handleCardPayment(this.paymentSecret, {
        // payment_method: this.stripeCards[0].id
        //       }).then(function(result) {
        //         console.log("handleCardPayment", result);
        //         if (result.error) {
        //           // Display error.message in your UI.
        //         } else {
        //           // The payment has succeeded. Display a success message.
        //         }
        //       });
        // this.handleCardPayment1();
      }).catch(function (error) {
        console.log("Error", error);
      });
    },
    getSinglePaymentOptions: function getSinglePaymentOptions() {
      var _this10 = this;

      var payload = {
        PaymentID: this.PaymentId,
        CouponCode: this.promocode,
        ReserveID: this.ReserveId,
        CategoryID: this.CategoryID,
        gogoStripe: 1
      };
      // this.showLoading();
      var that = this;
      Object(__WEBPACK_IMPORTED_MODULE_5__helper_internet_js__["makeRequest"])("/getPGOptions/", "POST", null, payload).then(function (response) {
        that.hideLoading();
        var error = response.error,
            res = response.res;

        console.log("res payment2:", res);
        if (res.data.Status == false) {
          _this10.$refs.minimumPayment.show();
        } else {
          _this10.paymentSecret = res.data.paymentintentid;
          _this10.payNewCard();
        }
      }).catch(function (error) {
        console.log("Error", error);
      });
    },
    update: function update() {
      console.log("test Update");
      this.complete = this.number && this.expiry && this.cvc;

      // this.stripeCardSelected = {
      //   type: "new"
      // };
      // field completed, find field to focus next
      if (this.number) {
        if (!this.expiry) {
          this.$refs.cardExpiry.focus();
        } else if (!this.cvc) {
          this.$refs.cardCvc.focus();
        }
      } else if (this.expiry) {
        if (!this.cvc) {
          this.$refs.cardCvc.focus();
        } else if (!this.number) {
          this.$refs.cardNumber.focus();
        }
      }
      // no focus magic for the CVC field as it gets complete with three
      // numbers, but can also have four
    },
    payNewCard: function payNewCard() {
      var _this11 = this;

      // createToken returns a Promise which resolves in a result object with
      // either a token or an error key.
      // See https://stripe.com/docs/api#tokens for the token object.
      // See https://stripe.com/docs/api#errors for the error object.
      // More general https://stripe.com/docs/stripe.js#stripe-create-token.
      Object(__WEBPACK_IMPORTED_MODULE_14_vue_stripe_elements_plus__["createToken"])().then(function (data) {
        console.log(data.token, "fsdf");

        _this11.createPaymentMethodMain();
        _this11.handleNewCardPayment();
      });
    },
    createPaymentMethodMain: function createPaymentMethodMain() {
      var _this12 = this;

      Object(__WEBPACK_IMPORTED_MODULE_14_vue_stripe_elements_plus__["createPaymentMethod"])("card").then(function (data) {
        _this12.updatePaymentMethod(data.paymentMethod.id);

        console.log("createPaymentMethod", data);
      });
    },
    handleNewCardPayment: function handleNewCardPayment() {
      var that = this;
      // console.log(
      //   "handleCardPayment start",
      //   this.paymentSecret,
      //   this.stripeCardSelected
      // );
      // this.showLoading();
      Object(__WEBPACK_IMPORTED_MODULE_14_vue_stripe_elements_plus__["handleCardPayment"])(this.paymentSecret, {
        payment_method: this.stripeCardSelected.id
      }).then(function (result) {
        that.hideLoading();
        if (result.error) {
          console.log("handleNewCardPayment", result.error);
          if (result.error.code == "card_declined") {
            that.$refs["errorCard"].show();
            that.msgError = result.error.message;
          }

          // Display error.message in your UI.
        } else {
          that.$router.replace({
            name: "confirmScreen",
            params: {
              bookingId: that.ReserveId || 0,
              paymentId: that.PaymentId || 2
            }
          });
          // The payment has succeeded. Display a success message.
        }
      });
    },

    startStripeWithoutSavedCard: function startStripeWithoutSavedCard() {
      this.timer.stop = true;
      this.getSinglePaymentOptions();

      // this.getStripeToken();
    },

    getStripeToken: function getStripeToken() {
      this.PaymentId = 3;

      // let payload = {
      //   PaymentID: this.PaymentId,
      //   CouponCode: this.promocode,
      //   ReserveID: this.ReserveId,
      //   CategoryID: this.CategoryID,
      //   Successurl:
      //     window.location.origin +
      //     "/confirmScreen/" +
      //     this.ReserveId +
      //     "/" +
      //     this.PaymentId +
      //     "?MovieID=" +
      //     this.showDetails.MovieID +
      //     "&CategoryID=" +
      //     this.CategoryID +
      //     "&CinemaScheduleID=" +
      //     this.CinemaScheduleID,
      //   Failurl:
      //     window.location.origin +
      //     "/failedPayment/" +
      //     this.showDetails.MovieID +
      //     "/" +
      //     this.CategoryID +
      //     "/" +
      //     this.CinemaScheduleID
      // };

      // //alert(this.ReserveId)

      // makeRequest("/pgGetToken/", "POST", null, payload)
      //   .then(response => {
      //     const { error, res } = response;
      //     console.log("res :", res);
      //     stripe
      //       .redirectToCheckout({
      //         // Make the id field from the Checkout Session creation API response
      //         // available to this file, so you can provide it as parameter here
      //         // instead of the {{CHECKOUT_SESSION_ID}} placeholder.
      //         // "cs_test_zK9hjlUwP2t8wSKsSN08j3NwxKbl7jZZ7NeiCwRWZyJjuRaZzAneNDsa"
      //         // res.data.substr(1, res.data.length)
      //         sessionId: res.data
      //       })
      //       .then(function(result) {
      //         console.log("result :", result);
      //         // If `redirectToCheckout` fails due to a browser or network
      //         // error, display the localized error message to your customer
      //         // using `result.error.message`.
      //       });
      //   })
      //   .catch(error => {
      //     console.log("Error", error);
      //   });
    },

    onClickForgotPassword: function onClickForgotPassword() {
      this.$root.$emit("bv::show::modal", "forgotpassword");
    },
    onClickLogin: function onClickLogin() {
      this.ShowLogin = true;
      this.ShowSignUp = false;
    },
    onClickSignUp: function onClickSignUp() {
      this.ShowLogin = false;
      this.ShowSignUp = true;
    },
    getNowShowingData: function getNowShowingData() {
      var _this13 = this;

      var payload = {
        Unique: ""
      };
      Object(__WEBPACK_IMPORTED_MODULE_5__helper_internet_js__["makeRequest"])("/GetShows/", "POST", null, null).then(function (response) {
        var error = response.error,
            res = response.res;

        _this13.signUpUserDetails.CountryCode = res.data.Default && res.data.Default.CountryISOCode;
      }).catch(function (error) {
        console.log("Error", error);
      });
    },
    startTimer: function startTimer() {
      var _this14 = this;

      this.timerStartFunction = setInterval(function () {
        if (_this14.timer.stop == true) {
          console.log("false");
          return;
        }

        if (parseInt(_this14.timer.seconds) == 0 && parseInt(_this14.timer.minutes) == 0) {
          // this.timer.seconds = 60;
          _this14.timer.stop = false;
          // this.$root.$emit("bv::show::modal", "sessionTimeOut");
          _this14.$refs.sessionTimeOut.show();
          clearTimeout(self.timerStartFunction);
          return false;
        }
        if (parseInt(_this14.timer.seconds) <= 0) {
          _this14.timer.seconds = 60;

          _this14.timer.minutes = _this14.timer.minutes >= 1 ? _this14.timer.minutes - 1 : "0";
        }
        _this14.timer.seconds = parseInt(_this14.timer.seconds) - 1;
        if (_this14.timer.seconds < 10) {
          _this14.timer.seconds = "0" + _this14.timer.seconds;
        }
      }, 1000);
      // setInterval(() => {
      //   if (this.timer.stop == true) {
      //     return;
      //   }
      //   if (this.timer.minutes == 0 && this.timer.seconds == 0) {
      //     this.$refs.sessionTimeOut.show();

      //     // this.$root.$emit("bv::show::modal", "sessionTimeOut");
      //     //TODO Show timeout message and a redirect button
      //     this.timer.TimeoutModal = true;
      //     this.timer.minutes = 0;
      //     this.timer.seconds = 0;
      //     this.timer.stop = true;
      //   }
      //   this.timer.minutes = parseInt(this.timer.minutes) - 1;
      // }, 60000);
    },
    onCheck: function onCheck() {
      this.signUpUserDetails.termsAndConditions = !this.signUpUserDetails.termsAndConditions;
    },
    onUserInput: function onUserInput(_ref) {
      var number = _ref.number,
          isValid = _ref.isValid,
          country = _ref.country;

      this.userDetails.MobileNo = number;
      this.userDetails.CountryCode = country.dialCode;
      this.userDetails.CountryCode = country.dialCode;
    },
    onInput: function onInput(_ref2) {
      var number = _ref2.number,
          isValid = _ref2.isValid,
          country = _ref2.country;

      this.signUpUserDetails.phoneNumber = number;
      this.signUpUserDetails.CountryCode = country.dialCode;
    },

    onApplyPromocode: function onApplyPromocode() {
      var _this15 = this;

      var payload = {
        voucher_code: this.promocode,
        cinema_id: this.showDetails.cine_id,
        cinema_name: this.showDetails.cine_name,
        isTicket: true,
        md_id: this.showDetails.md_id,
        net_amount: this.showDetails.net_amount,
        total_amount: this.showDetails.amount,
        total_ticket: this.showDetails.ticket_count,
        voucher_title: this.promocode,
        reservation_id: this.ReservationID,
        category_id: this.CategoryID
      };

      __WEBPACK_IMPORTED_MODULE_17__services_PromotionServices_js___default.a.VerifyVoucherCode(payload).then(function (response) {
        var data = response.data;

        if (data.status) {
          _this15.promocodeSuccesMessage = data.message;
          _this15.promocodeErrorMessage = "";
          _this15.promoApplied = true;
          var selectedVoucher = data.BoxOffice;
          _this15.offerData = data.Records[0];
          _this15.offerData["t_offer_price"] = selectedVoucher.TotalOfferPrice;
          _this15.offerData["oc_discount_value"] = selectedVoucher.TotalOfferPrice;
          _this15.offerData["is_on_net_amount"] = selectedVoucher.isOfferAppliedonNet;
          _this15.offerData["is_offer_for"] = "vouchers";
          _this15.offerData["is_offer_applied"] = true;
          _this15.offerData.voucher_discount = selectedVoucher.TotalOfferPrice;
          _this15.DiscountValue = parseFloat(selectedVoucher.TotalOfferPrice);
          _this15.TaxOfferValue = parseFloat(data.taxOffer);
          _this15.showDetails.chargeTypeArray = data.tax_calculation;
        } else {
          _this15.promocodeSuccesMessage = "";
          _this15.DiscountValue = 0;
          _this15.promoApplied = false;
          _this15.promocodeErrorMessage = data.message;
        }
      }).catch(function (err) {
        console.log("Error", err);
      });
      // makeRequest("/Payment/VerifyCoupon/", "POST", null, payload)
      //   .then(response => {
      //     const { error, res } = response;
      //     if (res.data.Status) {
      //       this.promocodeSuccesMessage = res.data.Message;
      //       this.promocodeErrorMessage = "";
      //       this.promoApplied = true;
      //       this.showDetails.TotalPrice = res.data.TicketValue.toFixed(2);
      //       this.DiscountValue = res.data.DiscountValue;
      //     } else {
      //       this.promocodeSuccesMessage = "";
      //       this.showDetails.TotalPrice = this.OGtotalAmount;
      //       this.DiscountValue = "";
      //       this.promoApplied = false;
      //       this.promocodeErrorMessage = res.data.Message;
      //     }
      //   })
      //   .catch(error => {
      //     console.log("Error", error);
      //   });
    },

    calculateVoucherDiscount: function calculateVoucherDiscount(_ref3) {
      var selectedVoucher = _ref3.selectedVoucher,
          totalAmount = _ref3.totalAmount,
          netAmount = _ref3.netAmount;

      var voucherDiscount = 0;

      if (selectedVoucher.voucher_is_percentage === "Y") {
        voucherDiscount = selectedVoucher.voucher_redeem_on_gross === "Y" ? selectedVoucher.voucher_amount / 100 * totalAmount : selectedVoucher.voucher_redeem_on_net === "Y" ? selectedVoucher.voucher_amount / 100 * netAmount : 0;
      } else {
        voucherDiscount = selectedVoucher.voucher_amount;
      }

      if (voucherDiscount > selectedVoucher.voucher_max_redemption_amount) {
        voucherDiscount = selectedVoucher.voucher_max_redemption_amount;
      } else if (voucherDiscount < selectedVoucher.voucher_min_redemption_amount) {
        voucherDiscount = selectedVoucher.voucher_min_redemption_amount;
      }

      voucherDiscount = __WEBPACK_IMPORTED_MODULE_13_lodash___default.a.round(voucherDiscount, 2);

      return voucherDiscount;
    },

    onCollapse: function onCollapse(params) {
      this.statusFlag.paymentActive = "active";
      this.$root.$emit("bv::toggle::collapse", params);
    },
    OTPonKeyUp: function OTPonKeyUp(item, e) {
      if (this.OTP[item].length > 1) {
        this.OTP[item] = this.OTP[item][this.OTP[item].length];
      }
      if (e.keyCode < 58 && e.keyCode > 47) {
        var value = "otp" + (item + 2);
        this.$refs[value].focus();
      }
    },
    getAllGetCountryList: function getAllGetCountryList() {
      var _this16 = this;

      __WEBPACK_IMPORTED_MODULE_15__services_mainService_js___default.a.GetCountries().then(function (response) {
        var data = response.data;

        if (data.data.length > 0) {
          _this16.CountryCodeList = data.data;
          _this16.countries = data.data;
          _this16.countriesCopy = data.data;
        }
      }).catch(function (err) {
        console.log("error:", err);
      });
    },
    _getAllGetCountryList: function _getAllGetCountryList() {
      var _this17 = this;

      Object(__WEBPACK_IMPORTED_MODULE_5__helper_internet_js__["makeRequest"])("/AllGetCountryList/", "POST", null, {}).then(function (response) {
        var error = response.error,
            res = response.res;

        if (res.data.Status) {
          _this17.CountryCodeList = res.data.Country;
          // this.userDetails.CountryCode = this.CountryCodeList[0].CountryISOCode;
          // this.signUpUserDetails.CountryCode = this.CountryCodeList[0].CountryISOCode;
        }
      }).catch(function (error) {
        console.log("Error", error);
        //   resolve(null);
      });
    },
    onChangeCountry: function onChangeCountry(country) {
      this.userDetails.CountryCode = country.country_mob_code;
      this.userDetails.country_mob_code = country.country_mob_code;
      this.signUpUserDetails.country_mob_code = country.country_mob_code;
      this.signUpUserDetails.country_id = country.country_id;
    },
    getCreateReservation: function getCreateReservation() {
      var _this18 = this;

      // this.showLoading();
      var payload = {
        reservation_id: this.ReservationID,
        category_id: this.CategoryID
      };
      __WEBPACK_IMPORTED_MODULE_15__services_mainService_js___default.a.GetCreateShowReservationDetails(payload).then(function (response) {
        var data = response.data;

        if (data.status) {
          // console.log("response show details", response);
          console.log(data.Records[0], "data.Records[0]; >>>>>>>>>>>>>>");
          _this18.showDetails = data.Records[0];
          _this18.timer.minutes = parseInt(_this18.showDetails.timer_minutes);
          _this18.timer.seconds = parseInt(_this18.showDetails.timer_second);
        } else {
          _this18.showMessage = data.message;
          _this18.$refs.SeatRealeased.show();
        }
      }).catch(function (err) {
        console.log("error:", err);
      }).finally(function () {
        _this18.startTimer();
        // this.hideLoading();
      });

      function tConvert(time) {
        // Check correct time format and split into components
        time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

        if (time.length > 1) {
          // If time format correct
          time = time.slice(1); // Remove full string match value
          time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
          time[0] = +time[0] % 12 || 12; // Adjust hours
        }
        return time.join(""); // return adjusted time or original string
      }
    },
    getReservationDetails: function getReservationDetails() {
      var _this19 = this;

      // this.showLoading();
      var payload = {
        reservation_id: this.ReservationID,
        category_id: this.CategoryID
      };
      __WEBPACK_IMPORTED_MODULE_15__services_mainService_js___default.a.GetReservationDetails(payload).then(function (response) {
        var data = response.data;

        if (data.status) {
          console.log("response", response);
          _this19.showDetails = data.Records[0];
          _this19.timer.minutes = parseInt(_this19.showDetails.timer_minutes);
          _this19.timer.seconds = parseInt(_this19.showDetails.timer_second);
        } else {
          _this19.showMessage = data.message;
          _this19.$refs.SeatRealeased.show();
        }
      }).catch(function (err) {
        console.log("error:", err);
      }).finally(function () {
        _this19.startTimer();
        // this.hideLoading();
      });

      function tConvert(time) {
        // Check correct time format and split into components
        time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

        if (time.length > 1) {
          // If time format correct
          time = time.slice(1); // Remove full string match value
          time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
          time[0] = +time[0] % 12 || 12; // Adjust hours
        }
        return time.join(""); // return adjusted time or original string
      }
    },
    hideModal: function hideModal() {
      this.$refs.SeatRealeased.hide();
      this.$router.go(-1);
    },

    fetchShowDetails: function fetchShowDetails() {
      var _this20 = this;

      var payload = {
        CategoryID: this.CategoryID,
        CinemaScheduleID: this.CinemaScheduleID,
        ShowType: this.ShowType,
        Version: "1"
      };
      if (this.ShowType != "Private") {
        payload.BookSeats = this.BookSeats;
      }
      Object(__WEBPACK_IMPORTED_MODULE_5__helper_internet_js__["makeRequest"])("/GetShowDetails", "POST", null, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        _this20.showDetails = res.data;
        console.log(_this20.showDetails, "show details responce");
        if (res.data.hasOwnProperty("DateTime")) {
          _this20.checkKey = true;
        }
        var parts = _this20.showDetails.Date.split("-"),
            year = parseInt(parts[0], 10),
            month = parseInt(parts[1], 10) - 1,
            // NB: month is zero-based!
        day = parseInt(parts[2], 10);
        var date1 = new Date(year, month, day);
        _this20.showDetails.day = _this20.days[date1.getDay()].substring(0, 3);
        _this20.showDetails.date = date1.getDate();
        _this20.showDetails.month = _this20.months[date1.getMonth()].substring(0, 3);
        _this20.showDetails.year = year;
        _this20.OGtotalAmount = _this20.showDetails.TotalPrice;
        _this20.showDetails.Timing = tConvert(_this20.showDetails.Time);
        console.log(_this20.showDetails.Timer);
        _this20.timer.minutes = parseInt(_this20.showDetails.Timer / 60);
        _this20.timer.seconds = parseInt(_this20.showDetails.Timer % 60);
      }).catch(function (error) {
        console.log("Error", error);
      });

      function tConvert(time) {
        // Check correct time format and split into components
        time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

        if (time.length > 1) {
          // If time format correct
          time = time.slice(1); // Remove full string match value
          time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
          time[0] = +time[0] % 12 || 12; // Adjust hours
        }
        return time.join(""); // return adjusted time or original string
      }
    },
    fetchUserDetails: function fetchUserDetails() {
      var _this21 = this;

      var token = __WEBPACK_IMPORTED_MODULE_8__services_storage_service__["TokenService"].getToken();
      var user = JSON.parse(window.localStorage.getItem("user")) || {};
      console.log("USER fetchUserDetails", user);
      if (user) {
        this.userDetails.email = user.cust_email;
        this.userDetails.phone_no = user.cust_mobile;
        this.userDetails.country_mob_code = user.country_mob_code;
      }
      if (false) {
        makeRequest("/Account/GetUserProfile/", "POST", token, null).then(function (response) {
          var error = response.error,
              res = response.res;

          _this21.userDetails = res.data;
          _this21.UserToken = true;
          // let phoneCode = "+" + String(this.userDetails.CountryCode);
          // this.userDetails.PhoneCode = countryArray.filter(x => {
          //   return x.dial_code === phoneCode;
          // })[0].code;
          _this21.errorMessage.login = "";
        }).catch(function (error) {
          console.log("Errorwewew", error);
        });
      }
    },
    validateBeforeSubmit: function validateBeforeSubmit(scope) {
      var _this22 = this;

      var token = __WEBPACK_IMPORTED_MODULE_8__services_storage_service__["TokenService"].getToken();
      if (scope == "UserSignIn") {
        var payload = {
          email: this.userDetails.email,
          password: this.userDetails.password
        };
        __WEBPACK_IMPORTED_MODULE_16__services_AuthServices_js___default.a.Login(payload).then(function (response) {
          var data = response.data;

          if (data.status) {
            _this22.ShowLogin = false;
            _this22.ShowSignUp = false;
            // this.tabs.collapse1 = false;
            // this.tabs.collapse2 = true;
            _this22.userInfo = data.Records[0];
            window.localStorage.setItem("user", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data.Records[0]));
            _this22.userLoggedIn = true;
            _this22.fetchUserDetails();
            _this22.checkPaymentMode(_this22.ActivePaymentModes);
            // this.$root.$emit("bv::toggle::collapse", "accordion2");
            __WEBPACK_IMPORTED_MODULE_10__eventBus_js___default.a.$emit("MakeUserLogin");
          } else {
            _this22.errorMessage.login = data.message;
          }
        }).catch(function (err) {
          console.log("error:", err);
        });
      }
      if (scope == "verifyUserDetails") {
        this.$validator.validateAll(scope).then(function (result) {
          console.log("result", result);
          if (result) {
            _this22.checkPaymentMode(_this22.ActivePaymentModes);
            _this22.tabs.collapse1 = false;
            _this22.tabs.collapse2 = true;
            _this22.$root.$emit("bv::toggle::collapse", "accordion2");
            // this.getReserveBookinId();
            // this.showProceedForLogin = true;
            return;
          }
        });
      } else if (scope == "verifyOtp") {
        this.confirmBooking();
      }
      if (scope == "signUp") {
        this.$validator.validateAll(scope).then(function (result) {
          if (result && _this22.signUpUserDetails.termsAndConditions && _this22.signUpUserDetails.country_mob_code) {
            console.log(_this22.signUpUserDetails, "fdsf");
            __WEBPACK_IMPORTED_MODULE_10__eventBus_js___default.a.$emit("onSingnUp", _this22.signUpUserDetails);
            return;
          } else {
            _this22.errorMessage.signUp = "Please fill in all the details";
          }
        });
      }
    },
    onSignUp: function onSignUp() {
      __WEBPACK_IMPORTED_MODULE_10__eventBus_js___default.a.$emit("onSingnUp");
    },

    //google
    onGoogleSignInSuccess: function onGoogleSignInSuccess(googleUser) {
      __WEBPACK_IMPORTED_MODULE_10__eventBus_js___default.a.$emit("OnGoogleSignIn", googleUser);
    },
    onGoogleSignInError: function onGoogleSignInError(error) {
      var _this23 = this;

      // `error` contains any error occurred.
      console.log("OH NOES", error);
      this.errorMessage.socialLoginError = "Whoops, !Something went wrong";
      setTimeout(function () {
        _this23.errorMessage.socialLoginError = "";
      }, 5000);
    },

    //fb
    onSignFBInSuccess: function onSignFBInSuccess(response) {
      __WEBPACK_IMPORTED_MODULE_10__eventBus_js___default.a.$emit("OnFacebookSignIn", googleUser);
    },
    onSignFBInError: function onSignFBInError(error) {
      var _this24 = this;

      this.errorMessage.socialLoginError = "Whoops, !Something went wrong";
      setTimeout(function () {
        _this24.errorMessage.socialLoginError = "";
      }, 5000);
    },
    getReserveBookinId: function getReserveBookinId() {
      var _this25 = this;

      // this.showLoading();
      var token = __WEBPACK_IMPORTED_MODULE_8__services_storage_service__["TokenService"].getToken();
      var payload = {
        BookSeats: this.BookSeats,
        CategoryID: this.CategoryID,
        CinemaScheduleID: this.CinemaScheduleID,
        Coupon: this.promocode,
        Email: this.userDetails.Email,
        Mobile: this.userDetails.MobileNo,
        CountryCode: this.userDetails.CountryCode,
        ShowType: this.ShowType,
        ReserveID: this.ReserveId,
        Version: "1"
      };
      Object(__WEBPACK_IMPORTED_MODULE_5__helper_internet_js__["makeRequest"])("/Booking/ReserveBooking", "POST", token, payload).then(function (response) {
        var error = response.error,
            res = response.res;
        // this.hideLoading();

        _this25.showCoupon = false;
        setTimeout(function () {
          VueScrollTo.scrollTo("#PaymentShow", "1000");
        }, 1000);
        if (_this25.showDetails.TotalPrice != 0) {
          if (res.data.Status == true) {
            _this25.bookingDetails = res.data;
            _this25.tabs.collapse1 = false;
            _this25.tabs.collapse2 = true;
            _this25.$root.$emit("bv::toggle::collapse", "accordion2");
            _this25.getPaymentOptions();
          } else {
            _this25.errorMessage.reserveBooking = "Sorry the seats have been released, Please go back and select the seats again";
            _this25.$root.$emit("bv::toggle::collapse", "accordion2");
          }
        } else {
          if (res.data.Status == true) {
            _this25.FreemakePayment();
          }
        }
      }).catch(function (error) {
        console.log("Error", error);
      });
    },

    getPaymentOptions: function getPaymentOptions() {
      var _this26 = this;

      var payload = {
        ReserveID: this.ReserveId,
        gogoStripe: 1
      };
      var token = __WEBPACK_IMPORTED_MODULE_8__services_storage_service__["TokenService"].getToken();

      Object(__WEBPACK_IMPORTED_MODULE_5__helper_internet_js__["makeRequest"])("/Booking/GetPaymentOptions", "POST", token, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        if (res.data.Status == true) {
          _this26.paymetOptions = res.data.Paymentoptions;
          if (_this26.paymetOptions.length == 1) {
            _this26.selectPayment(_this26.paymetOptions[0]);
            _this26.proceedStripePayment();
          }
          _this26.paymetOptions.map(function (x) {
            x.Image = x["Img-url"];
            if (x.PaymentID == 3) {
              _this26.stripeCards = x.savedCards.data;
            }
          });
        } else {
          _this26.errorMessage.reserveBooking = res.data.Message;
        }
      });
    },
    onSelectPayment: function onSelectPayment(payment) {
      if (payment.PaymentID == 1) {
        this.SendOTP();
      } else {
        this.errorMessage.payment = "Something Went Wrong";
      }
      if (payment.PaymentID == 3) {
        this.getSinglePaymentOptions();
      }
    },

    SendOTP: function SendOTP() {
      var _this27 = this;

      // this.showLoading();
      var token = __WEBPACK_IMPORTED_MODULE_8__services_storage_service__["TokenService"].getToken();
      var payload = {
        ReserveID: this.ReserveId
      };
      this.PaymentId = 1;
      Object(__WEBPACK_IMPORTED_MODULE_5__helper_internet_js__["makeRequest"])("/Payment/CheckWallet", "POST", token, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        if (res.data.Status === true) {
          // this.hideLoading();
          _this27.showOtpSection = true;
        } else {
          // this.hideLoading();
          _this27.errorMessage.payment = res.data.Message;
        }
      });
    },
    getBrainTreeToken: function getBrainTreeToken() {
      var _this28 = this;

      var self = this;
      // this.showLoading();
      var token = __WEBPACK_IMPORTED_MODULE_8__services_storage_service__["TokenService"].getToken();
      var payload = {
        ReserveID: this.ReserveId
      };
      this.PaymentId = 2;
      Object(__WEBPACK_IMPORTED_MODULE_5__helper_internet_js__["makeRequest"])("/pgapi/braintree/getToken", "POST", token, payload).then(function (response) {
        var error = response.error,
            res = response.res;
        // this.hideLoading();

        if (res.data.Status === true) {
          _this28.showBrainTreeContainer = true;
          _this28.showOtpSection = false;
          var clientToken = res.data.Token;
          _this28.paymentToken = clientToken;
          braintree.dropin.create({
            authorization: clientToken,
            selector: "#dropin-container",
            threeDSecure: {
              amount: self.showDetails.TotalPrice
            }
          }, function (err, dropinInstance) {
            if (err) {
              // Handle any errors that might've occurred when creating Drop-in
              console.error(err);
              return;
            }
            self.$refs.submitButton.addEventListener("click", function () {
              dropinInstance.requestPaymentMethod(function (err, payload) {
                if (err) {
                  // Handle errors in requesting payment method
                } else {
                  self.nonce = payload.nonce;
                  self.makePayment();
                }
                // Send payload.nonce to your server
              });
            });
          });
        } else {
          // this.hideLoading();
          _this28.errorMessage.payment = res.data.Message;
        }
      });
    },

    FreemakePayment: function FreemakePayment() {
      var _this29 = this;

      // this.showLoading();
      var token = __WEBPACK_IMPORTED_MODULE_8__services_storage_service__["TokenService"].getToken();

      var payload = {
        PaymentID: 0,
        ReserveID: this.ReserveId
      };
      Object(__WEBPACK_IMPORTED_MODULE_5__helper_internet_js__["makeRequest"])("/Booking/ConfirmBooking/", "POST", token, payload).then(function (response) {
        var error = response.error,
            res = response.res;
        // this.hideLoading();

        if (res.data.Status) {
          _this29.showProceedButton = true;
          _this29.tabs.collapse2 = false;
          // this.tabs.collapse3 = true;
          // this.$root.$emit("bv::toggle::collapse", "accordion3");
          _this29.confirmDetails = res.data;

          _this29.$router.replace({
            name: "confirmScreen",
            params: {
              bookingId: _this29.confirmDetails.BookingID || 0,
              paymentId: _this29.PaymentId || 2
            }
          });
        } else {
          _this29.$router.push({
            name: "failedPayment",
            params: {
              ss_id: _this29.showDetails.MovieID,
              screen_id: _this29.CategoryID,
              md_id: _this29.CinemaScheduleID
            }
          });
          _this29.errorMessage.payment = res.data.Message;
        }
      });
    },

    payNow: function payNow(paymode) {
      var _this30 = this;

      // console.log(this.ReservationID, "Reservation >>>>>>>>>>>>")
      // this.showLoading();
      var payload = {
        isGroupRateCard: true,
        reservation_id: this.ReservationID,
        isSplitPayment: false,
        unpaid_booking: false,
        cinema_id: 1,
        payment_mode_id: 18,
        approverId: null,
        order_code: null,
        oldCustomer: true,
        customer_id: this.userInfo.cust_id,
        cust_id: this.userInfo.cust_id,
        email: this.userInfo.cust_email,
        category_id: this.CategoryID,
        payment_mode: {
          bs_id: 1,
          bs_source: "Box Office",
          bs_is_active: "Y",
          created_by: null,
          created_at: null,
          updated_by: 4,
          updated_at: "2020-07-16T04:20:00.000Z",
          bspm_id: 20,
          booking_source_id: 1,
          mapping_is_active: "Y",
          payment_mode_id: 18,
          pm_payment_mode: "BrainTree",
          pm_icon_url: null,
          pm_is_active: "Y",
          pm_id: 18,
          amount: 0
        },
        isLoyaltyApplied: false,
        offer: this.offerData
      };
      if (this.CategoryID == 2) {
        payload["MyCinema"] = true;
      }
      __WEBPACK_IMPORTED_MODULE_15__services_mainService_js___default.a.BookSeats(payload).then(function (response) {
        var data = response.data;

        if (data.status) {
          console.log("data", data);
          _this30.showProceedButton = true;
          _this30.tabs.collapse2 = false;
          _this30.confirmDetails = data;
          _this30.$router.replace({
            name: "confirmScreen",
            params: {
              show_booking_id: data.sb_booking_code,
              category_id: _this30.CategoryID
            }
          });
        } else {
          _this30.$router.push({
            name: "failedPayment"
          });
          _this30.errorMessage.payment = data.message;
        }
      }).catch(function (err) {
        console.log("error", err);
      }).finally(function () {
        // this.hideLoading();
      });
    },


    //---
    makePayment: function makePayment() {
      var _this31 = this;

      // this.showLoading();
      var token = __WEBPACK_IMPORTED_MODULE_8__services_storage_service__["TokenService"].getToken();
      var payload = {
        CountryID: "195",
        nonce: this.nonce,
        PaymentID: this.PaymentId,
        ReserveID: this.ReserveId
      };
      Object(__WEBPACK_IMPORTED_MODULE_5__helper_internet_js__["makeRequest"])("/Booking/ConfirmBooking/", "POST", token, payload).then(function (response) {
        var error = response.error,
            res = response.res;
        // this.hideLoading();

        if (res.data.Status) {
          _this31.showProceedButton = true;
          _this31.tabs.collapse2 = false;
          // this.tabs.collapse3 = true;
          // this.$root.$emit("bv::toggle::collapse", "accordion3");
          _this31.confirmDetails = res.data;
          _this31.$router.replace({
            name: "confirmScreen",
            params: {
              bookingId: _this31.confirmDetails.BookingID || 0,
              paymentId: _this31.PaymentId || 2
            }
          });
        } else {
          _this31.$router.push({
            name: "failedPayment",
            params: {
              movieId: _this31.showDetails.MovieID,
              categoryId: _this31.CategoryID,
              scheduleId: _this31.CinemaScheduleID
            }
          });
          _this31.errorMessage.payment = res.data.Message;
        }
      });
    },
    confirmBooking: function confirmBooking() {
      var _this32 = this;

      // this.showLoading();
      var token = __WEBPACK_IMPORTED_MODULE_8__services_storage_service__["TokenService"].getToken();
      var payload = {
        OTP: this.OTP.toString().replace(/,/g, ""),
        PaymentID: this.PaymentId,
        ReserveID: this.ReserveId
      };
      Object(__WEBPACK_IMPORTED_MODULE_5__helper_internet_js__["makeRequest"])("/Booking/ConfirmBooking/", "POST", token, payload).then(function (response) {
        var error = response.error,
            res = response.res;
        // this.hideLoading();

        if (res.data.Status) {
          _this32.showProceedButton = true;
          _this32.tabs.collapse2 = false;
          // this.tabs.collapse3 = true;
          // this.$root.$emit("bv::toggle::collapse", "accordion3");
          _this32.confirmDetails = res.data;
          _this32.$router.push({
            name: "confirmScreen",
            params: {
              bookingId: _this32.confirmDetails.BookingID || 0,
              paymentId: _this32.PaymentId || 2
            }
          });
        } else {
          _this32.$router.push({
            name: "failedPayment",
            params: {
              movieId: _this32.showDetails.MovieID,
              categoryId: _this32.CategoryID,
              scheduleId: _this32.CinemaScheduleID
            }
          });
          _this32.errorMessage.payment = res.data.Message;
        }
      });
    }
  }
});

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "progress-ring",
  data: function data() {
    return {
      timerStartFunction: null,
      timer: {
        TimeoutModal: false,
        minutes: 9,
        seconds: 59,
        stop: false
      }
    };
  },

  mounted: function mounted() {
    this.startTimer();
  },
  methods: {
    startTimer: function startTimer() {
      var _this = this;

      this.timerStartFunction = setInterval(function () {
        if (_this.timer.stop == true) {
          return;
        }
        if (parseInt(_this.timer.seconds) <= 0) {
          _this.timer.seconds = 60;
        }
        if (parseInt(_this.timer.seconds) <= 0 && parseInt(_this.timer.minutes) <= 0) {
          // this.timer.seconds = 60;
          _this.timer.stop = false;
          // this.$root.$emit("bv::show::modal", "sessionTimeOut");
          clearTimeout(self.timerStartFunction);
          return false;
        }
        _this.timer.seconds = parseInt(_this.timer.seconds) - 1;
        if (_this.timer.seconds < 10) {
          _this.timer.seconds = "0" + _this.timer.seconds;
        }
      }, 1000);
      setInterval(function () {
        if (_this.timer.stop == true) {
          return;
        }
        if (_this.timer.minutes == 0 && _this.timer.seconds == 0) {
          // this.$root.$emit("bv::show::modal", "sessionTimeOut");
          //TODO Show timeout message and a redirect button
          _this.timer.TimeoutModal = true;
          _this.timer.minutes = 0;
          _this.timer.seconds = 0;
          _this.timer.stop = true;
        }
        _this.timer.minutes = parseInt(_this.timer.minutes) - 1;
      }, 60000);
    }
  }
});

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slick__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_date_pick__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_date_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_date_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_date_pick_dist_vueDatePick_css__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_date_pick_dist_vueDatePick_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_date_pick_dist_vueDatePick_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper_internet_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__helper_internet_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper_collection_js__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper_collection_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__helper_collection_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helper_constants_js__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helper_constants_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__helper_constants_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_storage_service__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_storage_service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__services_storage_service__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__eventBus_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__eventBus_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__eventBus_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_partials_progressRing_vue__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_stripe_elements_plus__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_stripe_elements_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_stripe_elements_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_mainService_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_mainService_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__services_mainService_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__services_AuthServices_js__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__services_AuthServices_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__services_AuthServices_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__services_PromotionServices_js__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__services_PromotionServices_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__services_PromotionServices_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_debounce__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_debounce__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














var STRIPEPUBLICKEY;
if (window.localStorage.getItem("country") != "" && window.localStorage.getItem("country") != null && window.localStorage.getItem("country") != undefined && JSON.parse(window.localStorage.getItem("country")).hasOwnProperty("pgData")) {
  if (JSON.parse(window.localStorage.getItem("country")).pgData[0].PublicKey != "") {
    STRIPEPUBLICKEY = JSON.parse(window.localStorage.getItem("country")).pgData[0].PublicKey;
  } else {
    STRIPEPUBLICKEY = __WEBPACK_IMPORTED_MODULE_6__helper_constants_js__["STRIPE_PUBLIC_KEY"];
  }
} else {
  STRIPEPUBLICKEY = __WEBPACK_IMPORTED_MODULE_6__helper_constants_js__["STRIPE_PUBLIC_KEY"];
}

var stripe = Stripe(STRIPEPUBLICKEY);
var VueScrollTo = __webpack_require__(129);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "payment",
  props: ["stripe", "options"],
  components: {
    Slick: __WEBPACK_IMPORTED_MODULE_1_vue_slick__["default"],
    DatePick: __WEBPACK_IMPORTED_MODULE_2_vue_date_pick___default.a,
    progressRing: __WEBPACK_IMPORTED_MODULE_10__components_partials_progressRing_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_13_vue_stripe_elements_plus__["Card"],
    CardNumber: __WEBPACK_IMPORTED_MODULE_13_vue_stripe_elements_plus__["CardNumber"],
    CardExpiry: __WEBPACK_IMPORTED_MODULE_13_vue_stripe_elements_plus__["CardExpiry"],
    CardCvc: __WEBPACK_IMPORTED_MODULE_13_vue_stripe_elements_plus__["CardCvc"]
  },

  data: function data() {
    return {
      showCoupon: true,
      msgError: "",
      stripePublicKey: STRIPEPUBLICKEY,
      complete: false,
      number: false,
      expiry: false,
      cvc: false,
      instance: null,
      isPayLoading: false,
      PaymentOptionsLoading: false,
      cientToken: "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",
      stripeOptions: {
        // see https://stripe.com/docs/stripe.js#element-options for details
      },
      BASEURL: __WEBPACK_IMPORTED_MODULE_6__helper_constants_js__["URL_BASE"],
      phone: "",
      MobileNo: "",
      promoApplied: false,
      statusFlag: {
        paymentActive: ""
      },
      timerStartFunction: null,
      timer: {
        TimeoutModal: false,
        minutes: 10,
        seconds: 0,
        stop: false
      },
      fbSignInParams: {
        scope: "email",
        return_scopes: false
      },
      googleSignInParams: {
        client_id: "911938447926-kls328d23otm80v12n1jq13h8ajeh57f.apps.googleusercontent.com"
      },
      tabs: {
        collapse1: true,
        collapse2: false,
        collapse3: false
      },
      UserToken: false,
      userLoggedIn: false,
      ShowLogin: true,
      showDetails: {},
      movieDetails: {},
      bookingDetails: {},
      CinemaScheduleID: "",
      CategoryID: "",
      BookSeats: "",
      BookingSeatsName: "",
      ShowType: "",
      nonce: "",
      ReserveId: "",
      Successurl: "",
      Failurl: "",
      bookID: "",
      PaymentId: "",
      userDetails: {
        email: "",
        phone_no: "",
        password: "",
        CountryCode: "1",
        country_id: 38,
        country_mob_code: "1"
      },
      signUpUserDetails: {
        password: "",
        email: "",
        CountryCode: "1",
        phoneNumber: "",
        OTP: ["", "", "", ""],
        userName: "",
        termsAndConditions: true,
        ConfirmPassword: "",
        country_mob_code: "1",
        country_id: 38
      },
      OTP: ["", "", "", ""],
      errorMessage: {
        login: "",
        signUp: "",
        reserveBooking: "",
        payment: "",
        socialLoginError: ""
      },
      OGtotalAmount: "",
      days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      paymentToken: "",
      months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      checkKey: false,
      paymetOptions: {},
      showOtpSection: false,
      showBrainTreeContainer: false,
      showProceedForLogin: false,
      showProceedButton: false,
      ScreeningTypeName: "",
      selected: true,
      confirmDetails: {},
      promocode: "",
      DiscountValue: 0,
      TaxOfferValue: 0,
      promocodeSuccesMessage: "",
      promocodeErrorMessage: "",
      CountryCodeList: [],
      paymentSecret: "",
      stripeCards: [],
      stripeCardSelected: {},
      selectedPaymentOptionID: "",
      ReservationID: null,
      offerData: {},
      directPay: false,
      showMessage: "",
      searchCode: "",
      countriesCopy: [],
      ActivePaymentModes: [],
      isBrainTreeActive: false,
      bt_client_token: null,
      braintree_customerid: "",
      userInfo: null,
      ShowSignUp: false,
      passwordRequiredMessage: "Password is Required.",
      passwordValidationMessage: "Password must contain minimum 6 characters, Contains at least one Lowercase letter, one Uppercase letter and one Number"
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.getVistaReservationDetails();

    __WEBPACK_IMPORTED_MODULE_9__eventBus_js___default.a.$on("onSignUpError", function (message) {
      _this.errorMessage.signUp = message;
    });
    __WEBPACK_IMPORTED_MODULE_9__eventBus_js___default.a.$on("onSignUpSuccess", function () {
      _this.ShowLogin = true;
      _this.ShowSignUp = false;
    });
    __WEBPACK_IMPORTED_MODULE_9__eventBus_js___default.a.$on("onProfileSuccess", function () {
      _this.fetchUserDetails();
    });
    // Create an instance of Elements.
    var elements = stripe.elements();
    // import { StripeElement } from
    // Custom styling can be passed to options when creating an Element.
    // (Note that this demo uses a wider set of styles than the guide below.)
    var style = {
      base: {
        color: "#32325d",
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: "antialiased",
        fontSize: "16px",
        "::placeholder": {
          color: "#aab7c4"
        }
      },
      invalid: {
        color: "#fa755a",
        iconColor: "#fa755a"
      }
    };
    if (window.innerWidth <= 991) {
      setTimeout(function () {
        VueScrollTo.scrollTo("#totalPayment", "1000");
      }, 1000);
    }

    // var stripe = Stripe('pk_test_xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx')

    // Create an instance of the card Element.
    // var card = elements.create("card", { style: style });

    // // Add an instance of the card Element into the `card-element` <div>.
    // card.mount("#card-element");

    // // Handle real-time validation errors from the card Element.
    // card.addEventListener("change", function(event) {
    //   var displayError = document.getElementById("card-errors");
    //   if (event.error) {
    //     displayError.textContent = event.error.message;
    //   } else {
    //     displayError.textContent = "";
    //   }
    // });

    // // Handle form submission.
    // var form = document.getElementById("payment-form");
    // form.addEventListener("submit", function(event) {
    //   event.preventDefault();

    //   stripe.createToken(card).then(function(result) {
    //     if (result.error) {
    //       // Inform the user if there was an error.
    //       var errorElement = document.getElementById("card-errors");
    //       errorElement.textContent = result.error.message;
    //     } else {
    //       // Send the token to your server.
    //       stripeTokenHandler(result.token);
    //     }
    //   });
    // });

    // // Submit the form with the token ID.
    // function stripeTokenHandler(token) {
    //   // Insert the token ID into the form so it gets submitted to the server
    //   var form = document.getElementById("payment-form");
    //   var hiddenInput = document.createElement("input");
    //   hiddenInput.setAttribute("type", "hidden");
    //   hiddenInput.setAttribute("name", "stripeToken");
    //   hiddenInput.setAttribute("value", token.id);
    //   form.appendChild(hiddenInput);

    //   // Submit the form
    //   form.submit();
    // }
  },
  beforeMount: function beforeMount() {
    this.ReservationID = this.$route.params.orderId || null;
    this.userInfo = window.localStorage.getItem("user") ? JSON.parse(window.localStorage.getItem("user")) : null;

    this.fetchUserDetails();
    this.getAllGetCountryList();
    this.getActivePaymentModes();
    this.checkUserLogin();
  },

  watch: {
    number: function number() {
      this.update();
    },
    expiry: function expiry() {
      this.update();
    },
    cvc: function cvc() {
      this.update();
    }
  },
  computed: {
    payBtnText: function payBtnText() {
      return "Pay " + curr_code + " " + currFormat(totalPayableAmount);
    },
    totalPayableAmount: function totalPayableAmount() {
      var total = this.showDetails.amount - this.DiscountValue - this.TaxOfferValue;
      return total;
    },
    curr_code: function curr_code() {
      return this.$store.getters.getCurrCode;
    },
    _userInfo: function _userInfo() {
      if (window.localStorage.getItem("user")) {
        var user = JSON.parse(window.localStorage.getItem("user"));
        this.userLoggedIn = true;
        return user;
      } else {
        return false;
      }
    }
  },
  methods: {
    checkUserLogin: function checkUserLogin() {
      if (window.localStorage.getItem("user")) {
        this.userLoggedIn = true;
      }
    },
    onLoad: function onLoad(instance) {
      this.instance = instance;
    },
    onLoadFail: function onLoadFail(instance) {
      this.showMessage = "Something Went Wrong!";
      this.$refs.SeatRealeased.show();
    },
    bt_makePayment: function bt_makePayment(payload) {
      var _this2 = this;

      this.isPayLoading = true;
      this.showLoading();
      console.log("Success!", payload.nonce);

      payload = {
        nounce: payload.nonce,
        reservation_id: this.ReservationID,
        cust_id: this.userInfo.cust_id,
        email: this.userInfo.cust_email,
        braintree_customerid: this.braintree_customerid,
        mobile: this.userInfo.cust_mobile,
        countryMobCode: this.userInfo.country_mob_code,
        category_id: this.CategoryID,
        cinema_id: this.showDetails.cine_id,
        cinema_name: this.showDetails.cine_name,
        isCinema: this.CategoryID == 2
      };
      __WEBPACK_IMPORTED_MODULE_14__services_mainService_js___default.a.MakeVistaPayment(payload).then(function (response) {
        var data = response.data;

        if (data.status) {
          _this2.payNow();
        } else {
          _this2.showMessage = data.message;
          _this2.hideLoading();
          _this2.$refs.SeatRealeased.show();
        }
      }).catch(function (err) {
        console.log("Error:", err);
        _this2.$router.push({
          name: "failedPayment"
        });
      }).finally(function () {
        _this2.isPayLoading = false;
      });
    },
    onError: function onError(error) {
      console.log("Error!", error);
    },
    getActivePaymentModes: function getActivePaymentModes() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_14__services_mainService_js___default.a.GetActivePaymentModes(2).then(function (response) {
        var data = response.data;

        if (data.status && data.Records.length > 0) {
          _this3.ActivePaymentModes = data.Records;
        } else {
          console.log("Error:", data.message);
        }
      }).catch(function (err) {
        console.log("Error:", err);
      });
    },
    checkPaymentMode: function checkPaymentMode(paymentModes) {
      var _this4 = this;

      this.PaymentOptionsLoading = true;
      this.showLoading();
      var BrainTree = paymentModes.find(function (x) {
        return x.pm_id == 16;
      });
      if (BrainTree) {
        this.isBrainTreeActive = true;
        console.log("this.userInfo checkPaymentMode", this.userInfo);
        __WEBPACK_IMPORTED_MODULE_14__services_mainService_js___default.a.createBrainTreeClientToken({
          cust_id: this.userInfo.cust_id
        }).then(function (response) {
          var data = response.data;

          if (data.status) {
            _this4.bt_client_token = data.clientToken;
            _this4.braintree_customerid = data.braintree_customerid;
          } else {
            console.log("Error: ", data.message);
          }
        }).catch(function (err) {
          console.log("Error:", err);
        }).finally(function () {
          _this4.PaymentOptionsLoading = false;
          _this4.hideLoading();
        });
      }
    },
    onSearchCode: function onSearchCode() {
      var _this5 = this;

      if (this.searchCode && this.searchCode.length > 0) {
        this.CountryCodeList = this.countriesCopy.filter(function (x) {
          if (x.country_mob_code && x.country_mob_code.toLowerCase().includes(_this5.searchCode.toLowerCase())) {
            return x;
          } else if (x.country_name && x.country_name.toLowerCase().includes(_this5.searchCode.toLowerCase())) {
            return x;
          }
        });
      } else {
        this.CountryCodeList = this.countriesCopy;
      }
    },
    GetDate: function GetDate(date, format) {
      if (format == "day") {
        return __WEBPACK_IMPORTED_MODULE_11_moment___default()(date).format("ddd");
      } else if (format == "time") {
        return __WEBPACK_IMPORTED_MODULE_11_moment___default()(date).format("HH:mm");
      } else if (format == "month") {
        return __WEBPACK_IMPORTED_MODULE_11_moment___default()(date).format("mmm");
      } else if (format == "date") {
        return __WEBPACK_IMPORTED_MODULE_11_moment___default()(date).format("dd");
      } else if (format == "full") {
        return __WEBPACK_IMPORTED_MODULE_11_moment___default()(date).format("ll");
      }
    },
    selectPayment: function selectPayment(Payment) {
      this.PaymentId = Payment.PaymentID;
      this.onSelectPayment(Payment);
    },
    proceedStripePayment: function proceedStripePayment() {
      this.selectedPaymentOptionID = 3;
    },
    confirmStripePaymentDetails: function confirmStripePaymentDetails() {
      this.timer.stop = true;

      if (this.stripeCardSelected.id) {
        // this.useAlreadyPresentCard();
        var cardButton = document.getElementById("card-button");
        console.log("test1", this.paymentSecret);

        // cardButton.addEventListener('click', function(ev) {
        //     // console.log('test2', this.paymentSecret)

        //     // stripe.handleCardPayment(
        //     //     this.paymentSecret, {
        //     //         payment_method:'pm_1FMeCsHnQVOfChkcPTGI8tAT',
        //     //     }
        //     // ).then(function(result) {
        //     //     if (result.error) {
        //     //         // Display error.message in your UI.
        //     //     } else {
        //     //         // The payment has succeeded. Display a success message.
        //     //     }
        //     // });
        // });
      } else {
        this.startStripeWithoutSavedCard();
      }
    },
    updatePaymentMethod: function updatePaymentMethod(paymentMethodID) {
      var payload = {
        ReserveID: this.ReserveId,
        PaymentID: this.PaymentId,
        PaymentMethod: paymentMethodID,
        updateCustomer: true,
        gogoStripe: 1
      };
      console.log("paymentMethodID :", paymentMethodID);
      Object(__WEBPACK_IMPORTED_MODULE_4__helper_internet_js__["makeRequest"])("/getPGOptions/", "POST", null, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        console.log("res payment1:", res);
      }).catch(function (error) {
        console.log("Error", error);
      });
    },
    useAlreadyPresentCard: function useAlreadyPresentCard() {
      var _this6 = this;

      var payload = {
        ReserveID: this.ReserveId,
        PaymentID: this.PaymentId,
        payment_method_id: this.stripeCardSelected.id,
        gogoStripe: 1
      };
      this.showLoading();
      Object(__WEBPACK_IMPORTED_MODULE_4__helper_internet_js__["makeRequest"])("/getPGOptions/", "POST", null, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        console.log("res payment handle already present card:", res, _this6.stripeCardSelected);
        if (res.data.Status == false) {
          _this6.hideLoading();
          _this6.$refs.sessionTimeOut.show();
        } else {
          _this6.paymentSecret = res.data.paymentintentid;
          var that = _this6;
          stripe.handleCardPayment(res.data.paymentintentid, {
            payment_method: _this6.stripeCardSelected.id
          }).then(function (result) {
            if (result.error && !result.hasOwnProperty("paymentIntent")) {
              that.$refs.apiKeyfailed.show();
              that.hideLoading();
            } else if (result.paymentIntent.status != "succeeded") {
              alert("sorry your payment failed");
              that.hideLoading();
              // Display error.message in your UI.
            } else {
              that.hideLoading();

              that.$router.replace({
                name: "confirmScreen",
                params: {
                  bookingId: that.ReserveId || 0,
                  paymentId: that.PaymentId || 2
                }
              });
              // The payment has succeeded. Display a success message.
            }
          });
        }
        //   handleCardPayment(this.paymentSecret, {
        // payment_method: this.stripeCards[0].id
        //       }).then(function(result) {
        //         console.log("handleCardPayment", result);
        //         if (result.error) {
        //           // Display error.message in your UI.
        //         } else {
        //           // The payment has succeeded. Display a success message.
        //         }
        //       });
        // this.handleCardPayment1();
      }).catch(function (error) {
        console.log("Error", error);
      });
    },
    getSinglePaymentOptions: function getSinglePaymentOptions() {
      var _this7 = this;

      var payload = {
        PaymentID: this.PaymentId,
        CouponCode: this.promocode,
        ReserveID: this.ReserveId,
        CategoryID: this.CategoryID,
        gogoStripe: 1
      };
      this.showLoading();
      var that = this;
      Object(__WEBPACK_IMPORTED_MODULE_4__helper_internet_js__["makeRequest"])("/getPGOptions/", "POST", null, payload).then(function (response) {
        that.hideLoading();
        var error = response.error,
            res = response.res;

        console.log("res payment2:", res);
        if (res.data.Status == false) {
          _this7.$refs.minimumPayment.show();
        } else {
          _this7.paymentSecret = res.data.paymentintentid;
          _this7.payNewCard();
        }
      }).catch(function (error) {
        console.log("Error", error);
      });
    },
    update: function update() {
      console.log("test Update");
      this.complete = this.number && this.expiry && this.cvc;

      // this.stripeCardSelected = {
      //   type: "new"
      // };
      // field completed, find field to focus next
      if (this.number) {
        if (!this.expiry) {
          this.$refs.cardExpiry.focus();
        } else if (!this.cvc) {
          this.$refs.cardCvc.focus();
        }
      } else if (this.expiry) {
        if (!this.cvc) {
          this.$refs.cardCvc.focus();
        } else if (!this.number) {
          this.$refs.cardNumber.focus();
        }
      }
      // no focus magic for the CVC field as it gets complete with three
      // numbers, but can also have four
    },
    payNewCard: function payNewCard() {
      var _this8 = this;

      // createToken returns a Promise which resolves in a result object with
      // either a token or an error key.
      // See https://stripe.com/docs/api#tokens for the token object.
      // See https://stripe.com/docs/api#errors for the error object.
      // More general https://stripe.com/docs/stripe.js#stripe-create-token.
      Object(__WEBPACK_IMPORTED_MODULE_13_vue_stripe_elements_plus__["createToken"])().then(function (data) {
        console.log(data.token, "fsdf");

        _this8.createPaymentMethodMain();
        _this8.handleNewCardPayment();
      });
    },
    createPaymentMethodMain: function createPaymentMethodMain() {
      var _this9 = this;

      Object(__WEBPACK_IMPORTED_MODULE_13_vue_stripe_elements_plus__["createPaymentMethod"])("card").then(function (data) {
        _this9.updatePaymentMethod(data.paymentMethod.id);

        console.log("createPaymentMethod", data);
      });
    },
    handleNewCardPayment: function handleNewCardPayment() {
      var that = this;
      // console.log(
      //   "handleCardPayment start",
      //   this.paymentSecret,
      //   this.stripeCardSelected
      // );
      this.showLoading();
      Object(__WEBPACK_IMPORTED_MODULE_13_vue_stripe_elements_plus__["handleCardPayment"])(this.paymentSecret, {
        payment_method: this.stripeCardSelected.id
      }).then(function (result) {
        that.hideLoading();
        if (result.error) {
          console.log("handleNewCardPayment", result.error);
          if (result.error.code == "card_declined") {
            that.$refs["errorCard"].show();
            that.msgError = result.error.message;
          }

          // Display error.message in your UI.
        } else {
          that.$router.replace({
            name: "confirmScreen",
            params: {
              bookingId: that.ReserveId || 0,
              paymentId: that.PaymentId || 2
            }
          });
          // The payment has succeeded. Display a success message.
        }
      });
    },

    startStripeWithoutSavedCard: function startStripeWithoutSavedCard() {
      this.timer.stop = true;
      this.getSinglePaymentOptions();

      // this.getStripeToken();
    },

    getStripeToken: function getStripeToken() {
      this.PaymentId = 3;

      // let payload = {
      //   PaymentID: this.PaymentId,
      //   CouponCode: this.promocode,
      //   ReserveID: this.ReserveId,
      //   CategoryID: this.CategoryID,
      //   Successurl:
      //     window.location.origin +
      //     "/confirmScreen/" +
      //     this.ReserveId +
      //     "/" +
      //     this.PaymentId +
      //     "?MovieID=" +
      //     this.showDetails.MovieID +
      //     "&CategoryID=" +
      //     this.CategoryID +
      //     "&CinemaScheduleID=" +
      //     this.CinemaScheduleID,
      //   Failurl:
      //     window.location.origin +
      //     "/failedPayment/" +
      //     this.showDetails.MovieID +
      //     "/" +
      //     this.CategoryID +
      //     "/" +
      //     this.CinemaScheduleID
      // };

      // //alert(this.ReserveId)

      // makeRequest("/pgGetToken/", "POST", null, payload)
      //   .then(response => {
      //     const { error, res } = response;
      //     console.log("res :", res);
      //     stripe
      //       .redirectToCheckout({
      //         // Make the id field from the Checkout Session creation API response
      //         // available to this file, so you can provide it as parameter here
      //         // instead of the {{CHECKOUT_SESSION_ID}} placeholder.
      //         // "cs_test_zK9hjlUwP2t8wSKsSN08j3NwxKbl7jZZ7NeiCwRWZyJjuRaZzAneNDsa"
      //         // res.data.substr(1, res.data.length)
      //         sessionId: res.data
      //       })
      //       .then(function(result) {
      //         console.log("result :", result);
      //         // If `redirectToCheckout` fails due to a browser or network
      //         // error, display the localized error message to your customer
      //         // using `result.error.message`.
      //       });
      //   })
      //   .catch(error => {
      //     console.log("Error", error);
      //   });
    },

    onClickForgotPassword: function onClickForgotPassword() {
      this.$root.$emit("bv::show::modal", "forgotpassword");
    },
    onClickLogin: function onClickLogin() {
      this.ShowLogin = true;
      this.ShowSignUp = false;
    },
    onClickSignUp: function onClickSignUp() {
      this.ShowLogin = false;
      this.ShowSignUp = true;
    },
    getNowShowingData: function getNowShowingData() {
      var _this10 = this;

      var payload = {
        Unique: ""
      };
      Object(__WEBPACK_IMPORTED_MODULE_4__helper_internet_js__["makeRequest"])("/GetShows/", "POST", null, null).then(function (response) {
        var error = response.error,
            res = response.res;

        _this10.signUpUserDetails.CountryCode = res.data.Default && res.data.Default.CountryISOCode;
      }).catch(function (error) {
        console.log("Error", error);
      });
    },
    startTimer: function startTimer() {
      var _this11 = this;

      this.timerStartFunction = setInterval(function () {
        if (_this11.timer.stop == true) {
          console.log("false");
          return;
        }

        if (parseInt(_this11.timer.seconds) == 0 && parseInt(_this11.timer.minutes) == 0) {
          // this.timer.seconds = 60;
          _this11.timer.stop = false;
          // this.$root.$emit("bv::show::modal", "sessionTimeOut");
          _this11.$refs.sessionTimeOut.show();
          clearTimeout(self.timerStartFunction);
          return false;
        }
        if (parseInt(_this11.timer.seconds) <= 0) {
          _this11.timer.seconds = 60;

          _this11.timer.minutes = _this11.timer.minutes >= 1 ? _this11.timer.minutes - 1 : "0";
        }
        _this11.timer.seconds = parseInt(_this11.timer.seconds) - 1;
        if (_this11.timer.seconds < 10) {
          _this11.timer.seconds = "0" + _this11.timer.seconds;
        }
      }, 1000);
      // setInterval(() => {
      //   if (this.timer.stop == true) {
      //     return;
      //   }
      //   if (this.timer.minutes == 0 && this.timer.seconds == 0) {
      //     this.$refs.sessionTimeOut.show();

      //     // this.$root.$emit("bv::show::modal", "sessionTimeOut");
      //     //TODO Show timeout message and a redirect button
      //     this.timer.TimeoutModal = true;
      //     this.timer.minutes = 0;
      //     this.timer.seconds = 0;
      //     this.timer.stop = true;
      //   }
      //   this.timer.minutes = parseInt(this.timer.minutes) - 1;
      // }, 60000);
    },
    onCheck: function onCheck() {
      this.signUpUserDetails.termsAndConditions = !this.signUpUserDetails.termsAndConditions;
    },
    onUserInput: function onUserInput(_ref) {
      var number = _ref.number,
          isValid = _ref.isValid,
          country = _ref.country;

      this.userDetails.MobileNo = number;
      this.userDetails.CountryCode = country.dialCode;
      this.userDetails.CountryCode = country.dialCode;
    },
    onInput: function onInput(_ref2) {
      var number = _ref2.number,
          isValid = _ref2.isValid,
          country = _ref2.country;

      this.signUpUserDetails.phoneNumber = number;
      this.signUpUserDetails.CountryCode = country.dialCode;
    },

    onApplyPromocode: function onApplyPromocode() {
      var _this12 = this;

      var payload = {
        voucher_code: this.promocode,
        cinema_id: this.showDetails.cine_id,
        cinema_name: this.showDetails.cine_name,
        isTicket: true,
        md_id: this.showDetails.md_id,
        net_amount: this.showDetails.net_amount,
        total_amount: this.showDetails.amount,
        total_ticket: this.showDetails.ticket_count,
        voucher_title: this.promocode,
        reservation_id: this.ReservationID,
        category_id: this.CategoryID
      };

      __WEBPACK_IMPORTED_MODULE_16__services_PromotionServices_js___default.a.VerifyVoucherCode(payload).then(function (response) {
        var data = response.data;

        if (data.status) {
          _this12.promocodeSuccesMessage = data.message;
          _this12.promocodeErrorMessage = "";
          _this12.promoApplied = true;
          var selectedVoucher = data.BoxOffice;
          _this12.offerData = data.Records[0];
          _this12.offerData["t_offer_price"] = selectedVoucher.TotalOfferPrice;
          _this12.offerData["oc_discount_value"] = selectedVoucher.TotalOfferPrice;
          _this12.offerData["is_on_net_amount"] = selectedVoucher.isOfferAppliedonNet;
          _this12.offerData["is_offer_for"] = "vouchers";
          _this12.offerData["is_offer_applied"] = true;
          _this12.offerData.voucher_discount = selectedVoucher.TotalOfferPrice;
          _this12.DiscountValue = parseFloat(selectedVoucher.TotalOfferPrice);
          _this12.TaxOfferValue = parseFloat(data.taxOffer);
          _this12.showDetails.chargeTypeArray = data.tax_calculation;
        } else {
          _this12.promocodeSuccesMessage = "";
          _this12.DiscountValue = 0;
          _this12.promoApplied = false;
          _this12.promocodeErrorMessage = data.message;
        }
      }).catch(function (err) {
        console.log("Error", err);
      });
      // makeRequest("/Payment/VerifyCoupon/", "POST", null, payload)
      //   .then(response => {
      //     const { error, res } = response;
      //     if (res.data.Status) {
      //       this.promocodeSuccesMessage = res.data.Message;
      //       this.promocodeErrorMessage = "";
      //       this.promoApplied = true;
      //       this.showDetails.TotalPrice = res.data.TicketValue.toFixed(2);
      //       this.DiscountValue = res.data.DiscountValue;
      //     } else {
      //       this.promocodeSuccesMessage = "";
      //       this.showDetails.TotalPrice = this.OGtotalAmount;
      //       this.DiscountValue = "";
      //       this.promoApplied = false;
      //       this.promocodeErrorMessage = res.data.Message;
      //     }
      //   })
      //   .catch(error => {
      //     console.log("Error", error);
      //   });
    },

    calculateVoucherDiscount: function calculateVoucherDiscount(_ref3) {
      var selectedVoucher = _ref3.selectedVoucher,
          totalAmount = _ref3.totalAmount,
          netAmount = _ref3.netAmount;

      var voucherDiscount = 0;

      if (selectedVoucher.voucher_is_percentage === "Y") {
        voucherDiscount = selectedVoucher.voucher_redeem_on_gross === "Y" ? selectedVoucher.voucher_amount / 100 * totalAmount : selectedVoucher.voucher_redeem_on_net === "Y" ? selectedVoucher.voucher_amount / 100 * netAmount : 0;
      } else {
        voucherDiscount = selectedVoucher.voucher_amount;
      }

      if (voucherDiscount > selectedVoucher.voucher_max_redemption_amount) {
        voucherDiscount = selectedVoucher.voucher_max_redemption_amount;
      } else if (voucherDiscount < selectedVoucher.voucher_min_redemption_amount) {
        voucherDiscount = selectedVoucher.voucher_min_redemption_amount;
      }

      voucherDiscount = __WEBPACK_IMPORTED_MODULE_12_lodash___default.a.round(voucherDiscount, 2);

      return voucherDiscount;
    },

    onCollapse: function onCollapse(params) {
      this.statusFlag.paymentActive = "active";
      this.$root.$emit("bv::toggle::collapse", params);
    },
    OTPonKeyUp: function OTPonKeyUp(item, e) {
      if (this.OTP[item].length > 1) {
        this.OTP[item] = this.OTP[item][this.OTP[item].length];
      }
      if (e.keyCode < 58 && e.keyCode > 47) {
        var value = "otp" + (item + 2);
        this.$refs[value].focus();
      }
    },
    getAllGetCountryList: function getAllGetCountryList() {
      var _this13 = this;

      __WEBPACK_IMPORTED_MODULE_14__services_mainService_js___default.a.GetCountries().then(function (response) {
        var data = response.data;

        if (data.data.length > 0) {
          _this13.CountryCodeList = data.data;
          _this13.countries = data.data;
          _this13.countriesCopy = data.data;
        }
      }).catch(function (err) {
        console.log("error:", err);
      });
    },
    _getAllGetCountryList: function _getAllGetCountryList() {
      var _this14 = this;

      Object(__WEBPACK_IMPORTED_MODULE_4__helper_internet_js__["makeRequest"])("/AllGetCountryList/", "POST", null, {}).then(function (response) {
        var error = response.error,
            res = response.res;

        if (res.data.Status) {
          _this14.CountryCodeList = res.data.Country;
          // this.userDetails.CountryCode = this.CountryCodeList[0].CountryISOCode;
          // this.signUpUserDetails.CountryCode = this.CountryCodeList[0].CountryISOCode;
        }
      }).catch(function (error) {
        console.log("Error", error);
        //   resolve(null);
      });
    },
    onChangeCountry: function onChangeCountry(country) {
      this.userDetails.CountryCode = country.country_mob_code;
      this.userDetails.country_mob_code = country.country_mob_code;
      this.signUpUserDetails.country_mob_code = country.country_mob_code;
      this.signUpUserDetails.country_id = country.country_id;
    },
    getCreateReservation: function getCreateReservation() {
      var _this15 = this;

      this.showLoading();
      var payload = {
        reservation_id: this.ReservationID,
        category_id: this.CategoryID
      };
      __WEBPACK_IMPORTED_MODULE_14__services_mainService_js___default.a.GetCreateShowReservationDetails(payload).then(function (response) {
        var data = response.data;

        if (data.status) {
          console.log("response", response);
          _this15.showDetails = data.Records[0];
          _this15.timer.minutes = parseInt(_this15.showDetails.timer_minutes);
          _this15.timer.seconds = parseInt(_this15.showDetails.timer_second);
        } else {
          _this15.showMessage = data.message;
          _this15.$refs.SeatRealeased.show();
        }
      }).catch(function (err) {
        console.log("error:", err);
      }).finally(function () {
        _this15.startTimer();
        _this15.hideLoading();
      });

      function tConvert(time) {
        // Check correct time format and split into components
        time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

        if (time.length > 1) {
          // If time format correct
          time = time.slice(1); // Remove full string match value
          time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
          time[0] = +time[0] % 12 || 12; // Adjust hours
        }
        return time.join(""); // return adjusted time or original string
      }
    },
    getVistaReservationDetails: function getVistaReservationDetails() {
      var _this16 = this;

      this.showLoading();
      var payload = {
        orderId: this.ReservationID
      };
      __WEBPACK_IMPORTED_MODULE_14__services_mainService_js___default.a.GetVistaReservationDetails(payload).then(function (response) {
        var data = response.data;

        console.log("response2", data);

        if (data.status) {
          _this16.showDetails = data.Records[0];
          _this16.timer.minutes = parseInt(_this16.showDetails.timer_minutes);
          _this16.timer.seconds = parseInt(_this16.showDetails.timer_second);
        } else {

          _this16.showMessage = data.message;
          _this16.$refs.SeatRealeased.show();
        }
      }).catch(function (err) {
        console.log("error:", err);
        _this16.onLoadFail();
      }).finally(function () {
        _this16.startTimer();
        _this16.hideLoading();
      });

      function tConvert(time) {
        // Check correct time format and split into components
        time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

        if (time.length > 1) {
          // If time format correct
          time = time.slice(1); // Remove full string match value
          time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
          time[0] = +time[0] % 12 || 12; // Adjust hours
        }
        return time.join(""); // return adjusted time or original string
      }
    },
    hideModal: function hideModal() {
      this.$refs.SeatRealeased.hide();
      this.$router.go(-1);
    },

    fetchShowDetails: function fetchShowDetails() {
      var _this17 = this;

      var payload = {
        CategoryID: this.CategoryID,
        CinemaScheduleID: this.CinemaScheduleID,
        ShowType: this.ShowType,
        Version: "1"
      };
      if (this.ShowType != "Private") {
        payload.BookSeats = this.BookSeats;
      }
      Object(__WEBPACK_IMPORTED_MODULE_4__helper_internet_js__["makeRequest"])("/GetShowDetails", "POST", null, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        _this17.showDetails = res.data;
        console.log(_this17.showDetails, "dsads");
        if (res.data.hasOwnProperty("DateTime")) {
          _this17.checkKey = true;
        }
        var parts = _this17.showDetails.Date.split("-"),
            year = parseInt(parts[0], 10),
            month = parseInt(parts[1], 10) - 1,
            // NB: month is zero-based!
        day = parseInt(parts[2], 10);
        var date1 = new Date(year, month, day);
        _this17.showDetails.day = _this17.days[date1.getDay()].substring(0, 3);
        _this17.showDetails.date = date1.getDate();
        _this17.showDetails.month = _this17.months[date1.getMonth()].substring(0, 3);
        _this17.showDetails.year = year;
        _this17.OGtotalAmount = _this17.showDetails.TotalPrice;
        _this17.showDetails.Timing = tConvert(_this17.showDetails.Time);
        console.log(_this17.showDetails.Timer);
        _this17.timer.minutes = parseInt(_this17.showDetails.Timer / 60);
        _this17.timer.seconds = parseInt(_this17.showDetails.Timer % 60);
      }).catch(function (error) {
        console.log("Error", error);
      });

      function tConvert(time) {
        // Check correct time format and split into components
        time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

        if (time.length > 1) {
          // If time format correct
          time = time.slice(1); // Remove full string match value
          time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
          time[0] = +time[0] % 12 || 12; // Adjust hours
        }
        return time.join(""); // return adjusted time or original string
      }
    },
    fetchUserDetails: function fetchUserDetails() {
      var _this18 = this;

      var token = __WEBPACK_IMPORTED_MODULE_7__services_storage_service__["TokenService"].getToken();
      var user = JSON.parse(window.localStorage.getItem("user")) || {};
      console.log("USER fetchUserDetails", user);
      if (user) {
        this.userDetails.email = user.cust_email;
        this.userDetails.phone_no = user.cust_mobile;
        this.userDetails.country_mob_code = user.country_mob_code;
      }
      if (false) {
        makeRequest("/Account/GetUserProfile/", "POST", token, null).then(function (response) {
          var error = response.error,
              res = response.res;

          _this18.userDetails = res.data;
          _this18.UserToken = true;
          // let phoneCode = "+" + String(this.userDetails.CountryCode);
          // this.userDetails.PhoneCode = countryArray.filter(x => {
          //   return x.dial_code === phoneCode;
          // })[0].code;
          _this18.errorMessage.login = "";
        }).catch(function (error) {
          console.log("Errorwewew", error);
        });
      }
    },
    validateBeforeSubmit: function validateBeforeSubmit(scope) {
      var _this19 = this;

      console.log(scope);
      var token = __WEBPACK_IMPORTED_MODULE_7__services_storage_service__["TokenService"].getToken();
      if (scope == "UserSignIn") {
        var payload = {
          email: this.userDetails.email,
          password: this.userDetails.password
        };
        __WEBPACK_IMPORTED_MODULE_15__services_AuthServices_js___default.a.Login(payload).then(function (response) {
          var data = response.data;

          if (data.status) {
            _this19.ShowLogin = false;
            _this19.ShowSignUp = false;
            // this.tabs.collapse1 = false;
            // this.tabs.collapse2 = true;
            _this19.userInfo = data.Records[0];
            window.localStorage.setItem("user", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data.Records[0]));
            _this19.userLoggedIn = true;
            _this19.fetchUserDetails();
            _this19.checkPaymentMode(_this19.ActivePaymentModes);
            // this.$root.$emit("bv::toggle::collapse", "accordion2");
            __WEBPACK_IMPORTED_MODULE_9__eventBus_js___default.a.$emit("MakeUserLogin");
          } else {
            _this19.errorMessage.login = data.message;
          }
        }).catch(function (err) {
          console.log("error:", err);
        });
      }
      if (scope == "verifyUserDetails") {
        this.$validator.validateAll(scope).then(function (result) {
          console.log("result", result);
          if (result) {
            _this19.checkPaymentMode(_this19.ActivePaymentModes);
            _this19.tabs.collapse1 = false;
            _this19.tabs.collapse2 = true;
            _this19.$root.$emit("bv::toggle::collapse", "accordion2");
            // this.getReserveBookinId();
            // this.showProceedForLogin = true;
            return;
          }
        });
      } else if (scope == "verifyOtp") {
        this.confirmBooking();
      }
      if (scope == "signUp") {
        this.$validator.validateAll(scope).then(function (result) {
          console.log(result, scope, _this19.signUpUserDetails);
          // if (
          //   result &&
          //   this.signUpUserDetails.termsAndConditions &&
          //   this.signUpUserDetails.country_mob_code
          // ) {
          if (_this19.signUpUserDetails.termsAndConditions && _this19.signUpUserDetails.email && _this19.signUpUserDetails.password && _this19.signUpUserDetails.CountryCode && _this19.signUpUserDetails.phoneNumber) {
            console.log(_this19.signUpUserDetails, "fdsf");
            __WEBPACK_IMPORTED_MODULE_9__eventBus_js___default.a.$emit("onSingnUp", _this19.signUpUserDetails);
            return;
          } else {
            _this19.errorMessage.signUp = "Please fill in all the details";
          }
        });
      }
    },
    onSignUp: function onSignUp() {
      __WEBPACK_IMPORTED_MODULE_9__eventBus_js___default.a.$emit("onSingnUp");
    },

    //google
    onGoogleSignInSuccess: function onGoogleSignInSuccess(googleUser) {
      __WEBPACK_IMPORTED_MODULE_9__eventBus_js___default.a.$emit("OnGoogleSignIn", googleUser);
    },
    onGoogleSignInError: function onGoogleSignInError(error) {
      var _this20 = this;

      // `error` contains any error occurred.
      console.log("OH NOES", error);
      this.errorMessage.socialLoginError = "Whoops, !Something went wrong";
      setTimeout(function () {
        _this20.errorMessage.socialLoginError = "";
      }, 5000);
    },

    //fb
    onSignFBInSuccess: function onSignFBInSuccess(response) {
      __WEBPACK_IMPORTED_MODULE_9__eventBus_js___default.a.$emit("OnFacebookSignIn", googleUser);
    },
    onSignFBInError: function onSignFBInError(error) {
      var _this21 = this;

      this.errorMessage.socialLoginError = "Whoops, !Something went wrong";
      setTimeout(function () {
        _this21.errorMessage.socialLoginError = "";
      }, 5000);
    },
    getReserveBookinId: function getReserveBookinId() {
      var _this22 = this;

      this.showLoading();
      var token = __WEBPACK_IMPORTED_MODULE_7__services_storage_service__["TokenService"].getToken();
      var payload = {
        BookSeats: this.BookSeats,
        CategoryID: this.CategoryID,
        CinemaScheduleID: this.CinemaScheduleID,
        Coupon: this.promocode,
        Email: this.userDetails.Email,
        Mobile: this.userDetails.MobileNo,
        CountryCode: this.userDetails.CountryCode,
        ShowType: this.ShowType,
        ReserveID: this.ReserveId,
        Version: "1"
      };
      Object(__WEBPACK_IMPORTED_MODULE_4__helper_internet_js__["makeRequest"])("/Booking/ReserveBooking", "POST", token, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        _this22.hideLoading();
        _this22.showCoupon = false;
        setTimeout(function () {
          VueScrollTo.scrollTo("#PaymentShow", "1000");
        }, 1000);
        if (_this22.showDetails.TotalPrice != 0) {
          if (res.data.Status == true) {
            _this22.bookingDetails = res.data;
            _this22.tabs.collapse1 = false;
            _this22.tabs.collapse2 = true;
            _this22.$root.$emit("bv::toggle::collapse", "accordion2");
            _this22.getPaymentOptions();
          } else {
            _this22.errorMessage.reserveBooking = "Sorry the seats have been released, Please go back and select the seats again";
            _this22.$root.$emit("bv::toggle::collapse", "accordion2");
          }
        } else {
          if (res.data.Status == true) {
            _this22.FreemakePayment();
          }
        }
      }).catch(function (error) {
        console.log("Error", error);
      });
    },

    getPaymentOptions: function getPaymentOptions() {
      var _this23 = this;

      var payload = {
        ReserveID: this.ReserveId,
        gogoStripe: 1
      };
      var token = __WEBPACK_IMPORTED_MODULE_7__services_storage_service__["TokenService"].getToken();

      Object(__WEBPACK_IMPORTED_MODULE_4__helper_internet_js__["makeRequest"])("/Booking/GetPaymentOptions", "POST", token, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        if (res.data.Status == true) {
          _this23.paymetOptions = res.data.Paymentoptions;
          if (_this23.paymetOptions.length == 1) {
            _this23.selectPayment(_this23.paymetOptions[0]);
            _this23.proceedStripePayment();
          }
          _this23.paymetOptions.map(function (x) {
            x.Image = x["Img-url"];
            if (x.PaymentID == 3) {
              _this23.stripeCards = x.savedCards.data;
            }
          });
        } else {
          _this23.errorMessage.reserveBooking = res.data.Message;
        }
      });
    },
    onSelectPayment: function onSelectPayment(payment) {
      if (payment.PaymentID == 1) {
        this.SendOTP();
      } else {
        this.errorMessage.payment = "Something Went Wrong";
      }
      if (payment.PaymentID == 3) {
        this.getSinglePaymentOptions();
      }
    },

    SendOTP: function SendOTP() {
      var _this24 = this;

      this.showLoading();
      var token = __WEBPACK_IMPORTED_MODULE_7__services_storage_service__["TokenService"].getToken();
      var payload = {
        ReserveID: this.ReserveId
      };
      this.PaymentId = 1;
      Object(__WEBPACK_IMPORTED_MODULE_4__helper_internet_js__["makeRequest"])("/Payment/CheckWallet", "POST", token, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        if (res.data.Status === true) {
          _this24.hideLoading();
          _this24.showOtpSection = true;
        } else {
          _this24.hideLoading();
          _this24.errorMessage.payment = res.data.Message;
        }
      });
    },
    getBrainTreeToken: function getBrainTreeToken() {
      var _this25 = this;

      var self = this;
      this.showLoading();
      var token = __WEBPACK_IMPORTED_MODULE_7__services_storage_service__["TokenService"].getToken();
      var payload = {
        ReserveID: this.ReserveId
      };
      this.PaymentId = 2;
      Object(__WEBPACK_IMPORTED_MODULE_4__helper_internet_js__["makeRequest"])("/pgapi/braintree/getToken", "POST", token, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        _this25.hideLoading();
        if (res.data.Status === true) {
          _this25.showBrainTreeContainer = true;
          _this25.showOtpSection = false;
          var clientToken = res.data.Token;
          _this25.paymentToken = clientToken;
          braintree.dropin.create({
            authorization: clientToken,
            selector: "#dropin-container",
            threeDSecure: {
              amount: self.showDetails.TotalPrice
            }
          }, function (err, dropinInstance) {
            if (err) {
              // Handle any errors that might've occurred when creating Drop-in
              console.error(err);
              return;
            }
            self.$refs.submitButton.addEventListener("click", function () {
              dropinInstance.requestPaymentMethod(function (err, payload) {
                if (err) {
                  // Handle errors in requesting payment method
                } else {
                  self.nonce = payload.nonce;
                  self.makePayment();
                }
                // Send payload.nonce to your server
              });
            });
          });
        } else {
          _this25.hideLoading();
          _this25.errorMessage.payment = res.data.Message;
        }
      });
    },

    FreemakePayment: function FreemakePayment() {
      var _this26 = this;

      this.showLoading();
      var token = __WEBPACK_IMPORTED_MODULE_7__services_storage_service__["TokenService"].getToken();

      var payload = {
        PaymentID: 0,
        ReserveID: this.ReserveId
      };
      Object(__WEBPACK_IMPORTED_MODULE_4__helper_internet_js__["makeRequest"])("/Booking/ConfirmBooking/", "POST", token, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        _this26.hideLoading();
        if (res.data.Status) {
          _this26.showProceedButton = true;
          _this26.tabs.collapse2 = false;
          // this.tabs.collapse3 = true;
          // this.$root.$emit("bv::toggle::collapse", "accordion3");
          _this26.confirmDetails = res.data;

          _this26.$router.replace({
            name: "confirmScreen",
            params: {
              bookingId: _this26.confirmDetails.BookingID || 0,
              paymentId: _this26.PaymentId || 2
            }
          });
        } else {
          _this26.$router.push({
            name: "failedPayment",
            params: {
              ss_id: _this26.showDetails.MovieID,
              screen_id: _this26.CategoryID,
              md_id: _this26.CinemaScheduleID
            }
          });
          _this26.errorMessage.payment = res.data.Message;
        }
      });
    },

    payNow: function payNow() {
      var _this27 = this;

      // this.showLoading();
      var payload = {
        orderId: this.ReservationID,
        cust_id: this.userInfo.cust_id
      };

      __WEBPACK_IMPORTED_MODULE_14__services_mainService_js___default.a.VistaBookSeats(payload).then(function (response) {
        var data = response.data;

        if (data.status) {

          _this27.showProceedButton = true;
          _this27.tabs.collapse2 = false;
          _this27.confirmDetails = data;
          _this27.$router.replace({
            name: "confirmScreenVista",
            params: {
              show_booking_id: data.Records[0].bookingId
            }
          });
        } else {
          _this27.errorMessage.payment = data.message;
          _this27.$router.push({
            name: "failedPayment"
          });
        }
      }).catch(function (err) {
        console.log("error", err);
      }).finally(function () {
        _this27.hideLoading();
      });
    },


    //---
    makePayment: function makePayment() {
      var _this28 = this;

      this.showLoading();
      var token = __WEBPACK_IMPORTED_MODULE_7__services_storage_service__["TokenService"].getToken();
      var payload = {
        CountryID: "195",
        nonce: this.nonce,
        PaymentID: this.PaymentId,
        ReserveID: this.ReserveId
      };
      Object(__WEBPACK_IMPORTED_MODULE_4__helper_internet_js__["makeRequest"])("/Booking/ConfirmBooking/", "POST", token, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        _this28.hideLoading();
        if (res.data.Status) {
          _this28.showProceedButton = true;
          _this28.tabs.collapse2 = false;
          // this.tabs.collapse3 = true;
          // this.$root.$emit("bv::toggle::collapse", "accordion3");
          _this28.confirmDetails = res.data;
          _this28.$router.replace({
            name: "confirmScreen",
            params: {
              bookingId: _this28.confirmDetails.BookingID || 0,
              paymentId: _this28.PaymentId || 2
            }
          });
        } else {
          _this28.$router.push({
            name: "failedPayment",
            params: {
              movieId: _this28.showDetails.MovieID,
              categoryId: _this28.CategoryID,
              scheduleId: _this28.CinemaScheduleID
            }
          });
          _this28.errorMessage.payment = res.data.Message;
        }
      });
    },
    confirmBooking: function confirmBooking() {
      var _this29 = this;

      this.showLoading();
      var token = __WEBPACK_IMPORTED_MODULE_7__services_storage_service__["TokenService"].getToken();
      var payload = {
        OTP: this.OTP.toString().replace(/,/g, ""),
        PaymentID: this.PaymentId,
        ReserveID: this.ReserveId
      };
      Object(__WEBPACK_IMPORTED_MODULE_4__helper_internet_js__["makeRequest"])("/Booking/ConfirmBooking/", "POST", token, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        _this29.hideLoading();
        if (res.data.Status) {
          _this29.showProceedButton = true;
          _this29.tabs.collapse2 = false;
          // this.tabs.collapse3 = true;
          // this.$root.$emit("bv::toggle::collapse", "accordion3");
          _this29.confirmDetails = res.data;
          _this29.$router.push({
            name: "confirmScreen",
            params: {
              bookingId: _this29.confirmDetails.BookingID || 0,
              paymentId: _this29.PaymentId || 2
            }
          });
        } else {
          _this29.$router.push({
            name: "failedPayment",
            params: {
              movieId: _this29.showDetails.MovieID,
              categoryId: _this29.CategoryID,
              scheduleId: _this29.CinemaScheduleID
            }
          });
          _this29.errorMessage.payment = res.data.Message;
        }
      });
    }
  }
});

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slick__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_date_pick__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_date_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_date_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_date_pick_dist_vueDatePick_css__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_date_pick_dist_vueDatePick_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_date_pick_dist_vueDatePick_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper_internet_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__helper_internet_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper_constants_js__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper_constants_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__helper_constants_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_storage_service__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_storage_service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__services_storage_service__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__eventBus_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__eventBus_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__eventBus_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_partials_progressRing_vue__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_stripe_elements_plus__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_stripe_elements_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_stripe_elements_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_mainService_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_mainService_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__services_mainService_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services_AuthServices_js__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services_AuthServices_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__services_AuthServices_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_PromotionServices_js__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_PromotionServices_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__services_PromotionServices_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__services_rtsServices__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__services_rtsServices___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__services_rtsServices__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var STRIPEPUBLICKEY;
if (window.localStorage.getItem("country") != "" && window.localStorage.getItem("country") != null && window.localStorage.getItem("country") != undefined && JSON.parse(window.localStorage.getItem("country")).hasOwnProperty("pgData")) {
  if (JSON.parse(window.localStorage.getItem("country")).pgData[0].PublicKey != "") {
    STRIPEPUBLICKEY = JSON.parse(window.localStorage.getItem("country")).pgData[0].PublicKey;
  } else {
    STRIPEPUBLICKEY = __WEBPACK_IMPORTED_MODULE_5__helper_constants_js__["STRIPE_PUBLIC_KEY"];
  }
} else {
  STRIPEPUBLICKEY = __WEBPACK_IMPORTED_MODULE_5__helper_constants_js__["STRIPE_PUBLIC_KEY"];
}

console.log(STRIPEPUBLICKEY, "keyp");

var stripe = Stripe(STRIPEPUBLICKEY);
var VueScrollTo = __webpack_require__(129);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "payment",
  props: ["stripe", "options"],
  components: {
    Slick: __WEBPACK_IMPORTED_MODULE_1_vue_slick__["default"],
    DatePick: __WEBPACK_IMPORTED_MODULE_2_vue_date_pick___default.a,
    progressRing: __WEBPACK_IMPORTED_MODULE_8__components_partials_progressRing_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_11_vue_stripe_elements_plus__["Card"],
    CardNumber: __WEBPACK_IMPORTED_MODULE_11_vue_stripe_elements_plus__["CardNumber"],
    CardExpiry: __WEBPACK_IMPORTED_MODULE_11_vue_stripe_elements_plus__["CardExpiry"],
    CardCvc: __WEBPACK_IMPORTED_MODULE_11_vue_stripe_elements_plus__["CardCvc"]
  },

  data: function data() {
    return {
      showCoupon: true,
      msgError: "",
      // stripePublicKey: STRIPEPUBLICKEY,
      complete: false,
      number: false,
      expiry: false,
      cvc: false,
      instance: null,
      isPayLoading: false,
      PaymentOptionsLoading: false,
      phone: "",
      promoApplied: false,
      timerStartFunction: null,
      timer: {
        minutes: 10,
        seconds: 0,
        stop: false
      },
      tabs: {
        collapse1: true,
        collapse2: false,
        collapse3: false
      },
      userLoggedIn: false,
      ShowLogin: true,
      showDetails: {},
      bookingDetails: {},
      CinemaScheduleID: "",
      CategoryID: "",
      BookSeats: "",
      ShowType: "",
      nonce: "",
      ReserveId: "",
      PaymentId: "",
      userDetails: {
        email: "",
        phone_no: "",
        password: "",
        CountryCode: "1",
        country_id: 38,
        country_mob_code: "1"
      },
      signUpUserDetails: {
        password: "",
        email: "",
        CountryCode: "1",
        phoneNumber: "",
        OTP: ["", "", "", ""],
        userName: "",
        termsAndConditions: true,
        ConfirmPassword: "",
        country_mob_code: "1",
        country_id: 38
      },
      OTP: ["", "", "", ""],
      errorMessage: {
        login: "",
        signUp: "",
        reserveBooking: "",
        payment: "",
        socialLoginError: ""
      },
      checkKey: false,
      showProceedButton: false,
      selected: true,
      confirmDetails: {},
      promocode: "",
      DiscountValue: 0,
      TaxOfferValue: 0,
      promocodeSuccesMessage: "",
      promocodeErrorMessage: "",
      CountryCodeList: [],
      paymentSecret: "",
      stripeCardSelected: {},
      ReservationID: null,
      offerData: {},
      directPay: false,
      showMessage: "",
      searchCode: "",
      countriesCopy: [],
      ActivePaymentModes: [],
      isBrainTreeActive: false,
      bt_client_token: null,
      braintree_customerid: "",
      userInfo: null,
      ShowSignUp: false,
      passwordRequiredMessage: "Password is Required.",
      passwordValidationMessage: "Password must contain minimum 6 characters, Contains at least one Lowercase letter, one Uppercase letter and one Number"
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.getReservationDetails();
    __WEBPACK_IMPORTED_MODULE_7__eventBus_js___default.a.$on("onSignUpError", function (message) {
      _this.errorMessage.signUp = message;
    });
    __WEBPACK_IMPORTED_MODULE_7__eventBus_js___default.a.$on("onSignUpSuccess", function () {
      _this.ShowLogin = true;
      _this.ShowSignUp = false;
    });
    __WEBPACK_IMPORTED_MODULE_7__eventBus_js___default.a.$on("onProfileSuccess", function () {
      _this.fetchUserDetails();
    });
    var elements = stripe.elements();
    var style = {
      base: {
        color: "#32325d",
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: "antialiased",
        fontSize: "16px",
        "::placeholder": {
          color: "#aab7c4"
        }
      },
      invalid: {
        color: "#fa755a",
        iconColor: "#fa755a"
      }
    };
    if (window.innerWidth <= 991) {
      setTimeout(function () {
        VueScrollTo.scrollTo("#totalPayment", "1000");
      }, 1000);
    }
  },
  beforeMount: function beforeMount() {
    this.ReservationID = this.$route.params.orderId || null;
    this.userInfo = window.localStorage.getItem("user") ? JSON.parse(window.localStorage.getItem("user")) : null;

    this.fetchUserDetails();
    this.getAllGetCountryList();
    this.getActivePaymentModes();
    this.checkUserLogin();
  },

  watch: {
    number: function number() {
      this.update();
    },
    expiry: function expiry() {
      this.update();
    },
    cvc: function cvc() {
      this.update();
    }
  },
  computed: {
    totalPayableAmount: function totalPayableAmount() {
      var total = this.showDetails.amount - this.DiscountValue - this.TaxOfferValue;
      return total;
    },
    curr_code: function curr_code() {
      return this.$store.getters.getCurrCode;
    }
  },
  methods: {
    checkUserLogin: function checkUserLogin() {
      if (window.localStorage.getItem("user")) {
        this.userLoggedIn = true;
      }
    },
    onLoad: function onLoad(instance) {
      this.instance = instance;
    },
    onLoadFail: function onLoadFail(instance) {
      this.showMessage = "Something Went Wrong!";
      this.$refs.SeatRealeased.show();
    },
    bt_makePayment: function bt_makePayment(payload) {
      var _this2 = this;

      this.isPayLoading = true;
      this.showLoading();
      payload = {
        nounce: payload.nonce,
        reservation_id: this.ReservationID,
        cust_id: this.userInfo.cust_id,
        email: this.userInfo.cust_email,
        braintree_customerid: this.braintree_customerid,
        mobile: this.userInfo.cust_mobile,
        countryMobCode: this.userInfo.country_mob_code,
        category_id: this.CategoryID,
        cinema_id: this.showDetails.cine_id,
        cinema_name: this.showDetails.cine_name,
        isCinema: this.CategoryID == 2
      };
      __WEBPACK_IMPORTED_MODULE_15__services_rtsServices___default.a.makeRtsPayment(payload).then(function (response) {
        var data = response.data;

        if (data.status) {
          _this2.showProceedButton = true;
          _this2.tabs.collapse2 = false;
          _this2.confirmDetails = data;
          _this2.$router.replace({
            name: "confirmScreenRts",
            params: {
              rts_reserve_id: _this2.ReservationID
            }
          });
        } else {
          _this2.showMessage = data.message;
          _this2.hideLoading();
          _this2.$refs.SeatRealeased.show();
        }
      }).catch(function (err) {
        console.log("Error:", err);
        _this2.hideLoading();
        _this2.$router.push({
          name: "failedPayment"
        });
      }).finally(function () {
        _this2.hideLoading();
        _this2.isPayLoading = false;
      });
    },
    onError: function onError(error) {
      console.log("Error!", error);
    },
    getActivePaymentModes: function getActivePaymentModes() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_12__services_mainService_js___default.a.GetActivePaymentModes(2).then(function (response) {
        var data = response.data;

        if (data.status && data.Records.length > 0) {
          _this3.ActivePaymentModes = data.Records;
        } else {
          console.log("Error:", data.message);
        }
      }).catch(function (err) {
        console.log("Error:", err);
      });
    },
    checkPaymentMode: function checkPaymentMode(paymentModes) {
      var _this4 = this;

      this.PaymentOptionsLoading = true;
      this.showLoading();
      var BrainTree = paymentModes.find(function (x) {
        return x.pm_id == 16;
      });
      if (BrainTree) {
        this.isBrainTreeActive = true;
        __WEBPACK_IMPORTED_MODULE_12__services_mainService_js___default.a.createBrainTreeClientToken({
          cust_id: this.userInfo.cust_id
        }).then(function (response) {
          var data = response.data;

          if (data.status) {
            _this4.bt_client_token = data.clientToken;
            _this4.braintree_customerid = data.braintree_customerid;
          } else {
            console.log("Error: ", data.message);
          }
        }).catch(function (err) {
          console.log("Error:", err);
        }).finally(function () {
          _this4.PaymentOptionsLoading = false;
          _this4.hideLoading();
        });
      }
    },
    onSearchCode: function onSearchCode() {
      var _this5 = this;

      if (this.searchCode && this.searchCode.length > 0) {
        this.CountryCodeList = this.countriesCopy.filter(function (x) {
          if (x.country_mob_code && x.country_mob_code.toLowerCase().includes(_this5.searchCode.toLowerCase())) {
            return x;
          } else if (x.country_name && x.country_name.toLowerCase().includes(_this5.searchCode.toLowerCase())) {
            return x;
          }
        });
      } else {
        this.CountryCodeList = this.countriesCopy;
      }
    },
    GetDate: function GetDate(date, format) {
      if (format == "day") {
        return __WEBPACK_IMPORTED_MODULE_9_moment___default()(date).format("ddd");
      } else if (format == "time") {
        return __WEBPACK_IMPORTED_MODULE_9_moment___default()(date).format("HH:mm");
      } else if (format == "month") {
        return __WEBPACK_IMPORTED_MODULE_9_moment___default()(date).format("mmm");
      } else if (format == "date") {
        return __WEBPACK_IMPORTED_MODULE_9_moment___default()(date).format("dd");
      } else if (format == "full") {
        return __WEBPACK_IMPORTED_MODULE_9_moment___default()(date).format("ll");
      }
    },
    update: function update() {
      this.complete = this.number && this.expiry && this.cvc;
      if (this.number) {
        if (!this.expiry) {
          this.$refs.cardExpiry.focus();
        } else if (!this.cvc) {
          this.$refs.cardCvc.focus();
        }
      } else if (this.expiry) {
        if (!this.cvc) {
          this.$refs.cardCvc.focus();
        } else if (!this.number) {
          this.$refs.cardNumber.focus();
        }
      }
    },
    onClickForgotPassword: function onClickForgotPassword() {
      this.$root.$emit("bv::show::modal", "forgotpassword");
    },
    onClickLogin: function onClickLogin() {
      this.ShowLogin = true;
      this.ShowSignUp = false;
    },
    onClickSignUp: function onClickSignUp() {
      this.ShowLogin = false;
      this.ShowSignUp = true;
    },
    startTimer: function startTimer() {
      var _this6 = this;

      clearInterval(this.timerStartFunction);
      this.timerStartFunction = setInterval(function () {
        if (_this6.timer.stop == true) {
          return;
        }

        if (parseInt(_this6.timer.seconds) == 0 && parseInt(_this6.timer.minutes) == 0) {
          _this6.timer.stop = false;
          _this6.$refs.sessionTimeOut.show();
          clearInterval(_this6.timerStartFunction);
          return false;
        }
        if (parseInt(_this6.timer.seconds) <= 0) {
          _this6.timer.seconds = 60;

          _this6.timer.minutes = _this6.timer.minutes >= 1 ? _this6.timer.minutes - 1 : "0";
        }
        _this6.timer.seconds = parseInt(_this6.timer.seconds) - 1;
        if (_this6.timer.seconds < 10) {
          _this6.timer.seconds = "0" + _this6.timer.seconds;
        }
      }, 1000);
    },
    onApplyPromocode: function onApplyPromocode() {
      var _this7 = this;

      var payload = {
        voucher_code: this.promocode,
        cinema_id: this.showDetails.cine_id,
        cinema_name: this.showDetails.cine_name,
        isTicket: true,
        md_id: this.showDetails.md_id,
        net_amount: this.showDetails.net_amount,
        total_amount: this.showDetails.amount,
        total_ticket: this.showDetails.ticket_count,
        voucher_title: this.promocode,
        reservation_id: this.ReservationID,
        category_id: this.CategoryID
      };

      __WEBPACK_IMPORTED_MODULE_14__services_PromotionServices_js___default.a.VerifyVoucherCode(payload).then(function (response) {
        var data = response.data;

        if (data.status) {
          _this7.promocodeSuccesMessage = data.message;
          _this7.promocodeErrorMessage = "";
          _this7.promoApplied = true;
          var selectedVoucher = data.BoxOffice;
          _this7.offerData = data.Records[0];
          _this7.offerData["t_offer_price"] = selectedVoucher.TotalOfferPrice;
          _this7.offerData["oc_discount_value"] = selectedVoucher.TotalOfferPrice;
          _this7.offerData["is_on_net_amount"] = selectedVoucher.isOfferAppliedonNet;
          _this7.offerData["is_offer_for"] = "vouchers";
          _this7.offerData["is_offer_applied"] = true;
          _this7.offerData.voucher_discount = selectedVoucher.TotalOfferPrice;
          _this7.DiscountValue = parseFloat(selectedVoucher.TotalOfferPrice);
          _this7.TaxOfferValue = parseFloat(data.taxOffer);
          _this7.showDetails.chargeTypeArray = data.tax_calculation;
        } else {
          _this7.promocodeSuccesMessage = "";
          _this7.DiscountValue = 0;
          _this7.promoApplied = false;
          _this7.promocodeErrorMessage = data.message;
        }
      }).catch(function (err) {
        console.log("Error", err);
      });
    },
    getAllGetCountryList: function getAllGetCountryList() {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_12__services_mainService_js___default.a.GetCountries().then(function (response) {
        var data = response.data;

        if (data.data.length > 0) {
          _this8.CountryCodeList = data.data;
          _this8.countries = data.data;
          _this8.countriesCopy = data.data;
        }
      }).catch(function (err) {
        console.log("error:", err);
      });
    },
    onChangeCountry: function onChangeCountry(country) {
      this.userDetails.CountryCode = country.country_mob_code;
      this.userDetails.country_mob_code = country.country_mob_code;
      this.signUpUserDetails.country_mob_code = country.country_mob_code;
      this.signUpUserDetails.country_id = country.country_id;
    },
    getReservationDetails: function getReservationDetails() {
      var _this9 = this;

      this.showLoading();
      var payload = {
        reserve_id: this.ReservationID
      };
      __WEBPACK_IMPORTED_MODULE_15__services_rtsServices___default.a.getReservationDetails(payload).then(function (response) {
        var data = response.data;

        if (data.status) {
          _this9.showDetails = data.Records[0];
          _this9.timer.minutes = parseInt(_this9.showDetails.timer_minutes);
          _this9.timer.seconds = parseInt(_this9.showDetails.timer_second);
        } else {
          _this9.showMessage = data.message;
          _this9.$refs.SeatRealeased.show();
        }
      }).catch(function (err) {
        console.log("error: in get details", err);
        _this9.onLoadFail();
      }).finally(function () {
        _this9.startTimer();
        _this9.hideLoading();
      });
    },
    hideModal: function hideModal() {
      this.$refs.SeatRealeased.hide();
      this.$router.go(-1);
    },
    fetchUserDetails: function fetchUserDetails() {
      var token = __WEBPACK_IMPORTED_MODULE_6__services_storage_service__["TokenService"].getToken();
      var user = JSON.parse(window.localStorage.getItem("user")) || {};
      if (user) {
        this.userDetails.email = user.cust_email;
        this.userDetails.phone_no = user.cust_mobile;
        this.userDetails.country_mob_code = user.country_mob_code;
      }
    },
    validateBeforeSubmit: function validateBeforeSubmit(scope) {
      var _this10 = this;

      var token = __WEBPACK_IMPORTED_MODULE_6__services_storage_service__["TokenService"].getToken();
      if (scope == "UserSignIn") {
        var payload = {
          email: this.userDetails.email,
          password: this.userDetails.password
        };
        __WEBPACK_IMPORTED_MODULE_13__services_AuthServices_js___default.a.Login(payload).then(function (response) {
          var data = response.data;

          if (data.status) {
            _this10.ShowLogin = false;
            _this10.ShowSignUp = false;
            _this10.userInfo = data.Records[0];
            window.localStorage.setItem("user", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data.Records[0]));
            _this10.userLoggedIn = true;
            _this10.fetchUserDetails();
            _this10.checkPaymentMode(_this10.ActivePaymentModes);
            __WEBPACK_IMPORTED_MODULE_7__eventBus_js___default.a.$emit("MakeUserLogin");
          } else {
            _this10.errorMessage.login = data.message;
          }
        }).catch(function (err) {
          console.log("error:", err);
        });
      }
      if (scope == "verifyUserDetails") {
        this.$validator.validateAll(scope).then(function (result) {
          console.log("result", result);
          if (result) {
            _this10.checkPaymentMode(_this10.ActivePaymentModes);
            _this10.tabs.collapse1 = false;
            _this10.tabs.collapse2 = true;
            _this10.$root.$emit("bv::toggle::collapse", "accordion2");
            return;
          }
        });
      } else if (scope == "verifyOtp") {
        this.confirmBooking();
      }
      if (scope == "signUp") {
        this.$validator.validateAll(scope).then(function (result) {
          console.log(result, scope, _this10.signUpUserDetails);
          if (_this10.signUpUserDetails.termsAndConditions && _this10.signUpUserDetails.email && _this10.signUpUserDetails.password && _this10.signUpUserDetails.CountryCode && _this10.signUpUserDetails.phoneNumber) {
            console.log(_this10.signUpUserDetails, "fdsf");
            __WEBPACK_IMPORTED_MODULE_7__eventBus_js___default.a.$emit("onSingnUp", _this10.signUpUserDetails);
            return;
          } else {
            _this10.errorMessage.signUp = "Please fill in all the details";
          }
        });
      }
    },
    onSignUp: function onSignUp() {
      __WEBPACK_IMPORTED_MODULE_7__eventBus_js___default.a.$emit("onSingnUp");
    },
    confirmBooking: function confirmBooking() {
      var _this11 = this;

      this.showLoading();
      var token = __WEBPACK_IMPORTED_MODULE_6__services_storage_service__["TokenService"].getToken();
      var payload = {
        OTP: this.OTP.toString().replace(/,/g, ""),
        PaymentID: this.PaymentId,
        ReserveID: this.ReserveId
      };
      Object(__WEBPACK_IMPORTED_MODULE_4__helper_internet_js__["makeRequest"])("/Booking/ConfirmBooking/", "POST", token, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        _this11.hideLoading();
        if (res.data.Status) {
          _this11.showProceedButton = true;
          _this11.tabs.collapse2 = false;
          // this.tabs.collapse3 = true;
          // this.$root.$emit("bv::toggle::collapse", "accordion3");
          _this11.confirmDetails = res.data;
          _this11.$router.push({
            name: "confirmScreen",
            params: {
              bookingId: _this11.confirmDetails.BookingID || 0,
              paymentId: _this11.PaymentId || 2
            }
          });
        } else {
          _this11.$router.push({
            name: "failedPayment",
            params: {
              movieId: _this11.showDetails.MovieID,
              categoryId: _this11.CategoryID,
              scheduleId: _this11.CinemaScheduleID
            }
          });
          _this11.errorMessage.payment = res.data.Message;
        }
      });
    }
  }
});

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slick__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_date_pick__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_date_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_date_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_date_pick_dist_vueDatePick_css__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_date_pick_dist_vueDatePick_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_date_pick_dist_vueDatePick_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper_internet_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__helper_internet_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper_collection_js__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper_collection_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__helper_collection_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helper_constants_js__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helper_constants_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__helper_constants_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_storage_service__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_storage_service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__services_storage_service__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__eventBus_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__eventBus_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__eventBus_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_partials_progressRing_vue__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_stripe_elements_plus__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_stripe_elements_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_stripe_elements_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_mainService_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_mainService_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__services_mainService_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__services_AuthServices_js__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__services_AuthServices_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__services_AuthServices_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__services_PromotionServices_js__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__services_PromotionServices_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__services_PromotionServices_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_debounce__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_debounce__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














var STRIPEPUBLICKEY;
if (window.localStorage.getItem("country") != "" && window.localStorage.getItem("country") != null && window.localStorage.getItem("country") != undefined && JSON.parse(window.localStorage.getItem("country")).hasOwnProperty("pgData")) {
  if (JSON.parse(window.localStorage.getItem("country")).pgData[0].PublicKey != "") {
    STRIPEPUBLICKEY = JSON.parse(window.localStorage.getItem("country")).pgData[0].PublicKey;
  } else {
    STRIPEPUBLICKEY = __WEBPACK_IMPORTED_MODULE_6__helper_constants_js__["STRIPE_PUBLIC_KEY"];
  }
} else {
  STRIPEPUBLICKEY = __WEBPACK_IMPORTED_MODULE_6__helper_constants_js__["STRIPE_PUBLIC_KEY"];
}

console.log(STRIPEPUBLICKEY, "keyp");

var stripe = Stripe(STRIPEPUBLICKEY);
var VueScrollTo = __webpack_require__(129);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "payment",
  props: ["stripe", "options"],
  components: {
    Slick: __WEBPACK_IMPORTED_MODULE_1_vue_slick__["default"],
    DatePick: __WEBPACK_IMPORTED_MODULE_2_vue_date_pick___default.a,
    progressRing: __WEBPACK_IMPORTED_MODULE_10__components_partials_progressRing_vue__["a" /* default */],
    Card: __WEBPACK_IMPORTED_MODULE_13_vue_stripe_elements_plus__["Card"],
    CardNumber: __WEBPACK_IMPORTED_MODULE_13_vue_stripe_elements_plus__["CardNumber"],
    CardExpiry: __WEBPACK_IMPORTED_MODULE_13_vue_stripe_elements_plus__["CardExpiry"],
    CardCvc: __WEBPACK_IMPORTED_MODULE_13_vue_stripe_elements_plus__["CardCvc"]
  },

  data: function data() {
    return {
      showCoupon: true,
      msgError: "",
      stripePublicKey: STRIPEPUBLICKEY,
      complete: false,
      number: false,
      expiry: false,
      cvc: false,
      stripeOptions: {
        // see https://stripe.com/docs/stripe.js#element-options for details
      },
      BASEURL: __WEBPACK_IMPORTED_MODULE_6__helper_constants_js__["URL_BASE"],
      phone: "",
      MobileNo: "",
      promoApplied: false,
      statusFlag: {
        paymentActive: ""
      },
      timerStartFunction: null,
      timer: {
        TimeoutModal: false,
        minutes: 10,
        seconds: 0,
        stop: false
      },
      fbSignInParams: {
        scope: "email",
        return_scopes: false
      },
      googleSignInParams: {
        client_id: "911938447926-kls328d23otm80v12n1jq13h8ajeh57f.apps.googleusercontent.com"
      },
      tabs: {
        collapse1: true,
        collapse2: false,
        collapse3: false
      },
      UserToken: false,
      userLoggedIn: false,
      ShowLogin: false,
      showDetails: {},
      movieDetails: {},
      bookingDetails: {},
      CinemaScheduleID: "",
      CategoryID: "",
      BookSeats: "",
      BookingSeatsName: "",
      ShowType: "",
      nonce: "",
      ReserveId: "",
      Successurl: "",
      Failurl: "",
      bookID: "",
      PaymentId: "",
      userDetails: {
        email: "",
        phone_no: "",
        password: "",
        CountryCode: "",
        country_id: "",
        country_mob_code: ""
      },
      signUpUserDetails: {
        password: "",
        email: "",
        CountryCode: "",
        phoneNumber: "",
        OTP: ["", "", "", ""],
        userName: "",
        termsAndConditions: true,
        ConfirmPassword: "",
        country_mob_code: "",
        country_id: null
      },
      OTP: ["", "", "", ""],
      errorMessage: {
        login: "",
        signUp: "",
        reserveBooking: "",
        payment: "",
        socialLoginError: ""
      },
      OGtotalAmount: "",
      days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      paymentToken: "",
      months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      checkKey: false,
      paymetOptions: {},
      showOtpSection: false,
      showBrainTreeContainer: false,
      showProceedForLogin: false,
      showProceedButton: false,
      ScreeningTypeName: "",
      selected: true,
      confirmDetails: {},
      promocode: "",
      DiscountValue: 0,
      promocodeSuccesMessage: "",
      promocodeErrorMessage: "",
      CountryCodeList: [],
      paymentSecret: "",
      stripeCards: [],
      stripeCardSelected: {},
      selectedPaymentOptionID: "",
      ReservationID: null,
      offerData: {},
      directPay: true,
      showMessage: ""
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_9__eventBus_js___default.a.$on("onSignUpError", function (message) {
      _this.errorMessage.signUp = message;
    });
    __WEBPACK_IMPORTED_MODULE_9__eventBus_js___default.a.$on("onSignUpSuccess", function () {
      _this.ShowLogin = true;
    });
    __WEBPACK_IMPORTED_MODULE_9__eventBus_js___default.a.$on("onProfileSuccess", function () {
      _this.fetchUserDetails();
    });
    // Create an instance of Elements.
    var elements = stripe.elements();
    // import { StripeElement } from
    // Custom styling can be passed to options when creating an Element.
    // (Note that this demo uses a wider set of styles than the guide below.)
    var style = {
      base: {
        color: "#32325d",
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: "antialiased",
        fontSize: "16px",
        "::placeholder": {
          color: "#aab7c4"
        }
      },
      invalid: {
        color: "#fa755a",
        iconColor: "#fa755a"
      }
    };
    if (window.innerWidth <= 991) {
      setTimeout(function () {
        VueScrollTo.scrollTo("#totalPayment", "1000");
      }, 1000);
    }

    // var stripe = Stripe('pk_test_xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx')

    // Create an instance of the card Element.
    // var card = elements.create("card", { style: style });

    // // Add an instance of the card Element into the `card-element` <div>.
    // card.mount("#card-element");

    // // Handle real-time validation errors from the card Element.
    // card.addEventListener("change", function(event) {
    //   var displayError = document.getElementById("card-errors");
    //   if (event.error) {
    //     displayError.textContent = event.error.message;
    //   } else {
    //     displayError.textContent = "";
    //   }
    // });

    // // Handle form submission.
    // var form = document.getElementById("payment-form");
    // form.addEventListener("submit", function(event) {
    //   event.preventDefault();

    //   stripe.createToken(card).then(function(result) {
    //     if (result.error) {
    //       // Inform the user if there was an error.
    //       var errorElement = document.getElementById("card-errors");
    //       errorElement.textContent = result.error.message;
    //     } else {
    //       // Send the token to your server.
    //       stripeTokenHandler(result.token);
    //     }
    //   });
    // });

    // // Submit the form with the token ID.
    // function stripeTokenHandler(token) {
    //   // Insert the token ID into the form so it gets submitted to the server
    //   var form = document.getElementById("payment-form");
    //   var hiddenInput = document.createElement("input");
    //   hiddenInput.setAttribute("type", "hidden");
    //   hiddenInput.setAttribute("name", "stripeToken");
    //   hiddenInput.setAttribute("value", token.id);
    //   form.appendChild(hiddenInput);

    //   // Submit the form
    //   form.submit();
    // }
  },
  beforeMount: function beforeMount() {
    this.ReservationID = this.$route.params.reservation_id || null;
    this.CategoryID = this.$route.params.category_id || 1;
    this.getReservationDetails();
    this.fetchUserDetails();
    this.getAllGetCountryList();
  },

  watch: {
    number: function number() {
      this.update();
    },
    expiry: function expiry() {
      this.update();
    },
    cvc: function cvc() {
      this.update();
    }
  },
  computed: {
    totalPayableAmount: function totalPayableAmount() {
      var total = this.showDetails.amount - this.DiscountValue || 0;
      return total;
    },
    curr_code: function curr_code() {
      return this.$store.getters.getCurrCode;
    },
    userInfo: function userInfo() {
      if (localStorage.getItem("user")) {
        var user = JSON.parse(localStorage.getItem("user"));
        this.userLoggedIn = true;
        return user;
      } else {
        return false;
      }
    }
  },
  methods: {
    GetDate: function GetDate(date, format) {
      if (format == "day") {
        return __WEBPACK_IMPORTED_MODULE_11_moment___default()(date).format("ddd");
      } else if (format == "time") {
        return __WEBPACK_IMPORTED_MODULE_11_moment___default()(date).format("HH:mm");
      } else if (format == "month") {
        return __WEBPACK_IMPORTED_MODULE_11_moment___default()(date).format("mmm");
      } else if (format == "date") {
        return __WEBPACK_IMPORTED_MODULE_11_moment___default()(date).format("dd");
      } else if (format == "full") {
        return __WEBPACK_IMPORTED_MODULE_11_moment___default()(date).format("ll");
      }
    },
    selectPayment: function selectPayment(Payment) {
      this.PaymentId = Payment.PaymentID;
      this.onSelectPayment(Payment);
    },
    proceedStripePayment: function proceedStripePayment() {
      this.selectedPaymentOptionID = 3;
    },
    confirmStripePaymentDetails: function confirmStripePaymentDetails() {
      this.timer.stop = true;

      if (this.stripeCardSelected.id) {
        this.useAlreadyPresentCard();
        var cardButton = document.getElementById("card-button");
        console.log("test1", this.paymentSecret);

        // cardButton.addEventListener('click', function(ev) {
        //     // console.log('test2', this.paymentSecret)

        //     // stripe.handleCardPayment(
        //     //     this.paymentSecret, {
        //     //         payment_method:'pm_1FMeCsHnQVOfChkcPTGI8tAT',
        //     //     }
        //     // ).then(function(result) {
        //     //     if (result.error) {
        //     //         // Display error.message in your UI.
        //     //     } else {
        //     //         // The payment has succeeded. Display a success message.
        //     //     }
        //     // });
        // });
      } else {
        this.startStripeWithoutSavedCard();
      }
    },
    updatePaymentMethod: function updatePaymentMethod(paymentMethodID) {
      var payload = {
        ReserveID: this.ReserveId,
        PaymentID: this.PaymentId,
        PaymentMethod: paymentMethodID,
        updateCustomer: true,
        gogoStripe: 1
      };
      console.log("paymentMethodID :", paymentMethodID);
      Object(__WEBPACK_IMPORTED_MODULE_4__helper_internet_js__["makeRequest"])("/getPGOptions/", "POST", null, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        console.log("res payment1:", res);
      }).catch(function (error) {
        console.log("Error", error);
      });
    },
    useAlreadyPresentCard: function useAlreadyPresentCard() {
      var _this2 = this;

      var payload = {
        ReserveID: this.ReserveId,
        PaymentID: this.PaymentId,
        payment_method_id: this.stripeCardSelected.id,
        gogoStripe: 1
      };
      this.showLoading();
      Object(__WEBPACK_IMPORTED_MODULE_4__helper_internet_js__["makeRequest"])("/getPGOptions/", "POST", null, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        console.log("res payment handle already present card:", res, _this2.stripeCardSelected);
        if (res.data.Status == false) {
          _this2.hideLoading();
          _this2.$refs.sessionTimeOut.show();
        } else {
          _this2.paymentSecret = res.data.paymentintentid;
          var that = _this2;
          stripe.handleCardPayment(res.data.paymentintentid, {
            payment_method: _this2.stripeCardSelected.id
          }).then(function (result) {
            if (result.error && !result.hasOwnProperty("paymentIntent")) {
              that.$refs.apiKeyfailed.show();
              that.hideLoading();
            } else if (result.paymentIntent.status != "succeeded") {
              alert("sorry your payment failed");
              that.hideLoading();
              // Display error.message in your UI.
            } else {
              that.hideLoading();

              that.$router.replace({
                name: "confirmScreen",
                params: {
                  bookingId: that.ReserveId || 0,
                  paymentId: that.PaymentId || 2
                }
              });
              // The payment has succeeded. Display a success message.
            }
          });
        }
        //   handleCardPayment(this.paymentSecret, {
        // payment_method: this.stripeCards[0].id
        //       }).then(function(result) {
        //         console.log("handleCardPayment", result);
        //         if (result.error) {
        //           // Display error.message in your UI.
        //         } else {
        //           // The payment has succeeded. Display a success message.
        //         }
        //       });
        // this.handleCardPayment1();
      }).catch(function (error) {
        console.log("Error", error);
      });
    },
    getSinglePaymentOptions: function getSinglePaymentOptions() {
      var _this3 = this;

      var payload = {
        PaymentID: this.PaymentId,
        CouponCode: this.promocode,
        ReserveID: this.ReserveId,
        CategoryID: this.CategoryID,
        gogoStripe: 1
      };
      this.showLoading();
      var that = this;
      Object(__WEBPACK_IMPORTED_MODULE_4__helper_internet_js__["makeRequest"])("/getPGOptions/", "POST", null, payload).then(function (response) {
        that.hideLoading();
        var error = response.error,
            res = response.res;

        console.log("res payment2:", res);
        if (res.data.Status == false) {
          _this3.$refs.minimumPayment.show();
        } else {
          _this3.paymentSecret = res.data.paymentintentid;
          _this3.payNewCard();
        }
      }).catch(function (error) {
        console.log("Error", error);
      });
    },
    update: function update() {
      console.log("test Update");
      this.complete = this.number && this.expiry && this.cvc;

      // this.stripeCardSelected = {
      //   type: "new"
      // };
      // field completed, find field to focus next
      if (this.number) {
        if (!this.expiry) {
          this.$refs.cardExpiry.focus();
        } else if (!this.cvc) {
          this.$refs.cardCvc.focus();
        }
      } else if (this.expiry) {
        if (!this.cvc) {
          this.$refs.cardCvc.focus();
        } else if (!this.number) {
          this.$refs.cardNumber.focus();
        }
      }
      // no focus magic for the CVC field as it gets complete with three
      // numbers, but can also have four
    },
    payNewCard: function payNewCard() {
      var _this4 = this;

      // createToken returns a Promise which resolves in a result object with
      // either a token or an error key.
      // See https://stripe.com/docs/api#tokens for the token object.
      // See https://stripe.com/docs/api#errors for the error object.
      // More general https://stripe.com/docs/stripe.js#stripe-create-token.
      Object(__WEBPACK_IMPORTED_MODULE_13_vue_stripe_elements_plus__["createToken"])().then(function (data) {
        console.log(data.token, "fsdf");

        _this4.createPaymentMethodMain();
        _this4.handleNewCardPayment();
      });
    },
    createPaymentMethodMain: function createPaymentMethodMain() {
      var _this5 = this;

      Object(__WEBPACK_IMPORTED_MODULE_13_vue_stripe_elements_plus__["createPaymentMethod"])("card").then(function (data) {
        _this5.updatePaymentMethod(data.paymentMethod.id);

        console.log("createPaymentMethod", data);
      });
    },
    handleNewCardPayment: function handleNewCardPayment() {
      var that = this;
      // console.log(
      //   "handleCardPayment start",
      //   this.paymentSecret,
      //   this.stripeCardSelected
      // );
      this.showLoading();
      Object(__WEBPACK_IMPORTED_MODULE_13_vue_stripe_elements_plus__["handleCardPayment"])(this.paymentSecret, {
        payment_method: this.stripeCardSelected.id
      }).then(function (result) {
        that.hideLoading();
        if (result.error) {
          console.log("handleNewCardPayment", result.error);
          if (result.error.code == "card_declined") {
            that.$refs["errorCard"].show();
            that.msgError = result.error.message;
          }

          // Display error.message in your UI.
        } else {
          that.$router.replace({
            name: "confirmScreen",
            params: {
              bookingId: that.ReserveId || 0,
              paymentId: that.PaymentId || 2
            }
          });
          // The payment has succeeded. Display a success message.
        }
      });
    },

    startStripeWithoutSavedCard: function startStripeWithoutSavedCard() {
      this.timer.stop = true;
      this.getSinglePaymentOptions();

      // this.getStripeToken();
    },

    getStripeToken: function getStripeToken() {
      this.PaymentId = 3;

      // let payload = {
      //   PaymentID: this.PaymentId,
      //   CouponCode: this.promocode,
      //   ReserveID: this.ReserveId,
      //   CategoryID: this.CategoryID,
      //   Successurl:
      //     window.location.origin +
      //     "/confirmScreen/" +
      //     this.ReserveId +
      //     "/" +
      //     this.PaymentId +
      //     "?MovieID=" +
      //     this.showDetails.MovieID +
      //     "&CategoryID=" +
      //     this.CategoryID +
      //     "&CinemaScheduleID=" +
      //     this.CinemaScheduleID,
      //   Failurl:
      //     window.location.origin +
      //     "/failedPayment/" +
      //     this.showDetails.MovieID +
      //     "/" +
      //     this.CategoryID +
      //     "/" +
      //     this.CinemaScheduleID
      // };

      // //alert(this.ReserveId)

      // makeRequest("/pgGetToken/", "POST", null, payload)
      //   .then(response => {
      //     const { error, res } = response;
      //     console.log("res :", res);
      //     stripe
      //       .redirectToCheckout({
      //         // Make the id field from the Checkout Session creation API response
      //         // available to this file, so you can provide it as parameter here
      //         // instead of the {{CHECKOUT_SESSION_ID}} placeholder.
      //         // "cs_test_zK9hjlUwP2t8wSKsSN08j3NwxKbl7jZZ7NeiCwRWZyJjuRaZzAneNDsa"
      //         // res.data.substr(1, res.data.length)
      //         sessionId: res.data
      //       })
      //       .then(function(result) {
      //         console.log("result :", result);
      //         // If `redirectToCheckout` fails due to a browser or network
      //         // error, display the localized error message to your customer
      //         // using `result.error.message`.
      //       });
      //   })
      //   .catch(error => {
      //     console.log("Error", error);
      //   });
    },

    onClickForgotPassword: function onClickForgotPassword() {
      this.$root.$emit("bv::show::modal", "forgotpassword");
    },
    onClickLogin: function onClickLogin() {
      this.ShowLogin = true;
    },
    onClickSignUp: function onClickSignUp() {
      this.ShowLogin = false;
    },
    getNowShowingData: function getNowShowingData() {
      var _this6 = this;

      var payload = {
        Unique: ""
      };
      Object(__WEBPACK_IMPORTED_MODULE_4__helper_internet_js__["makeRequest"])("/GetShows/", "POST", null, null).then(function (response) {
        var error = response.error,
            res = response.res;

        _this6.signUpUserDetails.CountryCode = res.data.Default && res.data.Default.CountryISOCode;
      }).catch(function (error) {
        console.log("Error", error);
      });
    },
    startTimer: function startTimer() {
      var _this7 = this;

      this.timerStartFunction = setInterval(function () {
        if (_this7.timer.stop == true) {
          console.log("false");
          return;
        }

        if (parseInt(_this7.timer.seconds) == 0 && parseInt(_this7.timer.minutes) == 0) {
          // this.timer.seconds = 60;
          _this7.timer.stop = false;
          // this.$root.$emit("bv::show::modal", "sessionTimeOut");
          _this7.$refs.sessionTimeOut.show();
          clearTimeout(self.timerStartFunction);
          return false;
        }
        if (parseInt(_this7.timer.seconds) <= 0) {
          _this7.timer.seconds = 60;

          _this7.timer.minutes = _this7.timer.minutes >= 1 ? _this7.timer.minutes - 1 : "0";
        }
        _this7.timer.seconds = parseInt(_this7.timer.seconds) - 1;
        if (_this7.timer.seconds < 10) {
          _this7.timer.seconds = "0" + _this7.timer.seconds;
        }
      }, 1000);
      // setInterval(() => {
      //   if (this.timer.stop == true) {
      //     return;
      //   }
      //   if (this.timer.minutes == 0 && this.timer.seconds == 0) {
      //     this.$refs.sessionTimeOut.show();

      //     // this.$root.$emit("bv::show::modal", "sessionTimeOut");
      //     //TODO Show timeout message and a redirect button
      //     this.timer.TimeoutModal = true;
      //     this.timer.minutes = 0;
      //     this.timer.seconds = 0;
      //     this.timer.stop = true;
      //   }
      //   this.timer.minutes = parseInt(this.timer.minutes) - 1;
      // }, 60000);
    },
    onCheck: function onCheck() {
      this.signUpUserDetails.termsAndConditions = !this.signUpUserDetails.termsAndConditions;
    },
    onUserInput: function onUserInput(_ref) {
      var number = _ref.number,
          isValid = _ref.isValid,
          country = _ref.country;

      this.userDetails.MobileNo = number;
      this.userDetails.CountryCode = country.dialCode;
      this.userDetails.CountryCode = country.dialCode;
    },
    onInput: function onInput(_ref2) {
      var number = _ref2.number,
          isValid = _ref2.isValid,
          country = _ref2.country;

      this.signUpUserDetails.phoneNumber = number;
      this.signUpUserDetails.CountryCode = country.dialCode;
    },

    onApplyPromocode: function onApplyPromocode() {
      var _this8 = this;

      var payload = {
        voucher_code: this.promocode,
        cinema_id: this.showDetails.cine_id,
        cinema_name: this.showDetails.cine_name,
        isTicket: true,
        md_id: this.showDetails.md_id,
        net_amount: this.showDetails.net_amount,
        total_amount: this.showDetails.amount,
        total_ticket: this.showDetails.ticket_count,
        voucher_title: this.promocode
      };

      __WEBPACK_IMPORTED_MODULE_16__services_PromotionServices_js___default.a.VerifyVoucherCode(payload).then(function (response) {
        var data = response.data;

        if (data.status) {
          _this8.promocodeSuccesMessage = data.message;
          _this8.promocodeErrorMessage = "";
          _this8.promoApplied = true;
          var selectedVoucher = data.BoxOffice;
          _this8.offerData = data.Records[0];
          _this8.offerData["t_offer_price"] = selectedVoucher.TotalOfferPrice;
          _this8.offerData["oc_discount_value"] = selectedVoucher.TotalOfferPrice;
          _this8.offerData["is_on_net_amount"] = selectedVoucher.isOfferAppliedonNet;
          _this8.offerData["is_offer_for"] = "vouchers";
          _this8.offerData["is_offer_applied"] = true;
          _this8.offerData.voucher_discount = selectedVoucher.TotalOfferPrice;
          _this8.DiscountValue = parseFloat(selectedVoucher.TotalOfferPrice);
        } else {
          _this8.promocodeSuccesMessage = "";
          _this8.DiscountValue = 0;
          _this8.promoApplied = false;
          _this8.promocodeErrorMessage = data.message;
        }
      }).catch(function (err) {
        console.log("Error", err);
      });
      // makeRequest("/Payment/VerifyCoupon/", "POST", null, payload)
      //   .then(response => {
      //     const { error, res } = response;
      //     if (res.data.Status) {
      //       this.promocodeSuccesMessage = res.data.Message;
      //       this.promocodeErrorMessage = "";
      //       this.promoApplied = true;
      //       this.showDetails.TotalPrice = res.data.TicketValue.toFixed(2);
      //       this.DiscountValue = res.data.DiscountValue;
      //     } else {
      //       this.promocodeSuccesMessage = "";
      //       this.showDetails.TotalPrice = this.OGtotalAmount;
      //       this.DiscountValue = "";
      //       this.promoApplied = false;
      //       this.promocodeErrorMessage = res.data.Message;
      //     }
      //   })
      //   .catch(error => {
      //     console.log("Error", error);
      //   });
    },

    calculateVoucherDiscount: function calculateVoucherDiscount(_ref3) {
      var selectedVoucher = _ref3.selectedVoucher,
          totalAmount = _ref3.totalAmount,
          netAmount = _ref3.netAmount;

      var voucherDiscount = 0;

      if (selectedVoucher.voucher_is_percentage === "Y") {
        voucherDiscount = selectedVoucher.voucher_redeem_on_gross === "Y" ? selectedVoucher.voucher_amount / 100 * totalAmount : selectedVoucher.voucher_redeem_on_net === "Y" ? selectedVoucher.voucher_amount / 100 * netAmount : 0;
      } else {
        voucherDiscount = selectedVoucher.voucher_amount;
      }

      if (voucherDiscount > selectedVoucher.voucher_max_redemption_amount) {
        voucherDiscount = selectedVoucher.voucher_max_redemption_amount;
      } else if (voucherDiscount < selectedVoucher.voucher_min_redemption_amount) {
        voucherDiscount = selectedVoucher.voucher_min_redemption_amount;
      }

      voucherDiscount = __WEBPACK_IMPORTED_MODULE_12_lodash___default.a.round(voucherDiscount, 2);

      return voucherDiscount;
    },

    onCollapse: function onCollapse(params) {
      this.statusFlag.paymentActive = "active";
      this.$root.$emit("bv::toggle::collapse", params);
    },
    OTPonKeyUp: function OTPonKeyUp(item, e) {
      if (this.OTP[item].length > 1) {
        this.OTP[item] = this.OTP[item][this.OTP[item].length];
      }
      if (e.keyCode < 58 && e.keyCode > 47) {
        var value = "otp" + (item + 2);
        this.$refs[value].focus();
      }
    },
    getAllGetCountryList: function getAllGetCountryList() {
      var _this9 = this;

      __WEBPACK_IMPORTED_MODULE_14__services_mainService_js___default.a.GetCountries().then(function (response) {
        var data = response.data;

        if (data.data.length > 0) {
          _this9.CountryCodeList = data.data;
          _this9.countries = data.data;
        }
      }).catch(function (err) {
        console.log("error:", err);
      });
    },
    _getAllGetCountryList: function _getAllGetCountryList() {
      var _this10 = this;

      Object(__WEBPACK_IMPORTED_MODULE_4__helper_internet_js__["makeRequest"])("/AllGetCountryList/", "POST", null, {}).then(function (response) {
        var error = response.error,
            res = response.res;

        if (res.data.Status) {
          _this10.CountryCodeList = res.data.Country;
          // this.userDetails.CountryCode = this.CountryCodeList[0].CountryISOCode;
          // this.signUpUserDetails.CountryCode = this.CountryCodeList[0].CountryISOCode;
        }
      }).catch(function (error) {
        console.log("Error", error);
        //   resolve(null);
      });
    },
    onChangeCountry: function onChangeCountry(country) {
      this.userDetails.CountryCode = country.country_mob_code;
      this.userDetails.country_mob_code = country.country_mob_code;
      this.signUpUserDetails.country_mob_code = country.country_mob_code;
      this.signUpUserDetails.country_id = country.country_id;
    },
    getReservationDetails: function getReservationDetails() {
      var _this11 = this;

      this.showLoading();
      var payload = {
        reservation_id: this.ReservationID,
        category_id: this.CategoryID
      };
      __WEBPACK_IMPORTED_MODULE_14__services_mainService_js___default.a.GetCreateShowReservationDetails(payload).then(function (response) {
        var data = response.data;

        if (data.status) {
          console.log("response", response);
          _this11.showDetails = data.Records[0];
          _this11.timer.minutes = parseInt(_this11.showDetails.timer_minutes);
          _this11.timer.seconds = parseInt(_this11.showDetails.timer_second);
        } else {
          _this11.showMessage = data.message;
          _this11.$refs.SeatRealeased.show();
        }
      }).catch(function (err) {
        console.log("error:", err);
      }).finally(function () {
        _this11.startTimer();
        _this11.hideLoading();
      });

      function tConvert(time) {
        // Check correct time format and split into components
        time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

        if (time.length > 1) {
          // If time format correct
          time = time.slice(1); // Remove full string match value
          time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
          time[0] = +time[0] % 12 || 12; // Adjust hours
        }
        return time.join(""); // return adjusted time or original string
      }
    },
    hideModal: function hideModal() {
      this.$refs.SeatRealeased.hide();
      this.$router.go(-1);
    },

    fetchShowDetails: function fetchShowDetails() {
      var _this12 = this;

      var payload = {
        CategoryID: this.CategoryID,
        CinemaScheduleID: this.CinemaScheduleID,
        ShowType: this.ShowType,
        Version: "1"
      };
      if (this.ShowType != "Private") {
        payload.BookSeats = this.BookSeats;
      }
      Object(__WEBPACK_IMPORTED_MODULE_4__helper_internet_js__["makeRequest"])("/GetShowDetails", "POST", null, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        _this12.showDetails = res.data;
        console.log(_this12.showDetails, "dsads");
        if (res.data.hasOwnProperty("DateTime")) {
          _this12.checkKey = true;
        }
        var parts = _this12.showDetails.Date.split("-"),
            year = parseInt(parts[0], 10),
            month = parseInt(parts[1], 10) - 1,
            // NB: month is zero-based!
        day = parseInt(parts[2], 10);
        var date1 = new Date(year, month, day);
        _this12.showDetails.day = _this12.days[date1.getDay()].substring(0, 3);
        _this12.showDetails.date = date1.getDate();
        _this12.showDetails.month = _this12.months[date1.getMonth()].substring(0, 3);
        _this12.showDetails.year = year;
        _this12.OGtotalAmount = _this12.showDetails.TotalPrice;
        _this12.showDetails.Timing = tConvert(_this12.showDetails.Time);
        console.log(_this12.showDetails.Timer);
        _this12.timer.minutes = parseInt(_this12.showDetails.Timer / 60);
        _this12.timer.seconds = parseInt(_this12.showDetails.Timer % 60);
      }).catch(function (error) {
        console.log("Error", error);
      });

      function tConvert(time) {
        // Check correct time format and split into components
        time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

        if (time.length > 1) {
          // If time format correct
          time = time.slice(1); // Remove full string match value
          time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
          time[0] = +time[0] % 12 || 12; // Adjust hours
        }
        return time.join(""); // return adjusted time or original string
      }
    },
    fetchUserDetails: function fetchUserDetails() {
      var _this13 = this;

      var token = __WEBPACK_IMPORTED_MODULE_7__services_storage_service__["TokenService"].getToken();
      var user = JSON.parse(window.localStorage.getItem("user")) || {};
      console.log("USER fetchUserDetails", user);
      if (user) {
        this.userDetails.email = user.cust_email;
        this.userDetails.phone_no = user.cust_mobile;
        this.userDetails.country_mob_code = user.country_mob_code;
      }
      if (false) {
        makeRequest("/Account/GetUserProfile/", "POST", token, null).then(function (response) {
          var error = response.error,
              res = response.res;

          _this13.userDetails = res.data;
          _this13.UserToken = true;
          // let phoneCode = "+" + String(this.userDetails.CountryCode);
          // this.userDetails.PhoneCode = countryArray.filter(x => {
          //   return x.dial_code === phoneCode;
          // })[0].code;
          _this13.errorMessage.login = "";
        }).catch(function (error) {
          console.log("Errorwewew", error);
        });
      }
    },
    validateBeforeSubmit: function validateBeforeSubmit(scope) {
      var _this14 = this;

      var token = __WEBPACK_IMPORTED_MODULE_7__services_storage_service__["TokenService"].getToken();
      if (scope == "UserSignIn") {
        var payload = {
          email: this.userDetails.email,
          password: this.userDetails.password
        };
        __WEBPACK_IMPORTED_MODULE_15__services_AuthServices_js___default.a.Login(payload).then(function (response) {
          var data = response.data;

          if (data.status) {
            _this14.ShowLogin = false;
            _this14.tabs.collapse1 = false;
            _this14.tabs.collapse2 = true;
            window.localStorage.setItem("user", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data.Records[0]));
            _this14.userLoggedIn = true;
            _this14.fetchUserDetails();
            _this14.$root.$emit("bv::toggle::collapse", "accordion2");
            __WEBPACK_IMPORTED_MODULE_9__eventBus_js___default.a.$emit("MakeUserLogin");
          } else {
            _this14.errorMessage.login = data.message;
          }
        }).catch(function (err) {
          console.log("error:", err);
        });
      }
      if (scope == "verifyUserDetails") {
        this.$validator.validateAll(scope).then(function (result) {
          console.log("result", result);
          if (result) {
            _this14.tabs.collapse1 = false;
            _this14.tabs.collapse2 = true;
            _this14.$root.$emit("bv::toggle::collapse", "accordion2");
            // this.getReserveBookinId();
            // this.showProceedForLogin = true;
            return;
          }
        });
      } else if (scope == "verifyOtp") {
        this.confirmBooking();
      }
      if (scope == "signUp") {
        this.$validator.validateAll(scope).then(function (result) {
          if (result && _this14.signUpUserDetails.termsAndConditions && _this14.signUpUserDetails.country_mob_code) {
            console.log(_this14.signUpUserDetails, "fdsf");
            __WEBPACK_IMPORTED_MODULE_9__eventBus_js___default.a.$emit("onSingnUp", _this14.signUpUserDetails);
            return;
          } else {
            _this14.errorMessage.signUp = "Please fill in all the details";
          }
        });
      }
    },
    onSignUp: function onSignUp() {
      __WEBPACK_IMPORTED_MODULE_9__eventBus_js___default.a.$emit("onSingnUp");
    },

    //google
    onGoogleSignInSuccess: function onGoogleSignInSuccess(googleUser) {
      __WEBPACK_IMPORTED_MODULE_9__eventBus_js___default.a.$emit("OnGoogleSignIn", googleUser);
    },
    onGoogleSignInError: function onGoogleSignInError(error) {
      var _this15 = this;

      // `error` contains any error occurred.
      console.log("OH NOES", error);
      this.errorMessage.socialLoginError = "Whoops, !Something went wrong";
      setTimeout(function () {
        _this15.errorMessage.socialLoginError = "";
      }, 5000);
    },

    //fb
    onSignFBInSuccess: function onSignFBInSuccess(response) {
      __WEBPACK_IMPORTED_MODULE_9__eventBus_js___default.a.$emit("OnFacebookSignIn", googleUser);
    },
    onSignFBInError: function onSignFBInError(error) {
      var _this16 = this;

      this.errorMessage.socialLoginError = "Whoops, !Something went wrong";
      setTimeout(function () {
        _this16.errorMessage.socialLoginError = "";
      }, 5000);
    },
    getReserveBookinId: function getReserveBookinId() {
      var _this17 = this;

      this.showLoading();
      var token = __WEBPACK_IMPORTED_MODULE_7__services_storage_service__["TokenService"].getToken();
      var payload = {
        BookSeats: this.BookSeats,

        CategoryID: this.CategoryID,
        CinemaScheduleID: this.CinemaScheduleID,
        Coupon: this.promocode,
        Email: this.userDetails.Email,
        Mobile: this.userDetails.MobileNo,
        CountryCode: this.userDetails.CountryCode,
        ShowType: this.ShowType,
        ReserveID: this.ReserveId,
        Version: "1"
      };
      Object(__WEBPACK_IMPORTED_MODULE_4__helper_internet_js__["makeRequest"])("/Booking/ReserveBooking", "POST", token, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        _this17.hideLoading();
        _this17.showCoupon = false;
        setTimeout(function () {
          VueScrollTo.scrollTo("#PaymentShow", "1000");
        }, 1000);
        if (_this17.showDetails.TotalPrice != 0) {
          if (res.data.Status == true) {
            _this17.bookingDetails = res.data;
            _this17.tabs.collapse1 = false;
            _this17.tabs.collapse2 = true;
            _this17.$root.$emit("bv::toggle::collapse", "accordion2");
            _this17.getPaymentOptions();
          } else {
            _this17.errorMessage.reserveBooking = "Sorry the seats have been released, Please go back and select the seats again";
            _this17.$root.$emit("bv::toggle::collapse", "accordion2");
          }
        } else {
          if (res.data.Status == true) {
            _this17.FreemakePayment();
          }
        }
      }).catch(function (error) {
        console.log("Error", error);
      });
    },

    getPaymentOptions: function getPaymentOptions() {
      var _this18 = this;

      var payload = {
        ReserveID: this.ReserveId,
        gogoStripe: 1
      };
      var token = __WEBPACK_IMPORTED_MODULE_7__services_storage_service__["TokenService"].getToken();

      Object(__WEBPACK_IMPORTED_MODULE_4__helper_internet_js__["makeRequest"])("/Booking/GetPaymentOptions", "POST", token, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        if (res.data.Status == true) {
          _this18.paymetOptions = res.data.Paymentoptions;
          if (_this18.paymetOptions.length == 1) {
            _this18.selectPayment(_this18.paymetOptions[0]);
            _this18.proceedStripePayment();
          }
          _this18.paymetOptions.map(function (x) {
            x.Image = x["Img-url"];
            if (x.PaymentID == 3) {
              _this18.stripeCards = x.savedCards.data;
            }
          });
        } else {
          _this18.errorMessage.reserveBooking = res.data.Message;
        }
      });
    },
    onSelectPayment: function onSelectPayment(payment) {
      if (payment.PaymentID == 1) {
        this.SendOTP();
      } else {
        this.errorMessage.payment = "Something Went Wrong";
      }
      if (payment.PaymentID == 3) {
        this.getSinglePaymentOptions();
      }
    },

    SendOTP: function SendOTP() {
      var _this19 = this;

      this.showLoading();
      var token = __WEBPACK_IMPORTED_MODULE_7__services_storage_service__["TokenService"].getToken();
      var payload = {
        ReserveID: this.ReserveId
      };
      this.PaymentId = 1;
      Object(__WEBPACK_IMPORTED_MODULE_4__helper_internet_js__["makeRequest"])("/Payment/CheckWallet", "POST", token, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        if (res.data.Status === true) {
          _this19.hideLoading();
          _this19.showOtpSection = true;
        } else {
          _this19.hideLoading();
          _this19.errorMessage.payment = res.data.Message;
        }
      });
    },
    getBrainTreeToken: function getBrainTreeToken() {
      var _this20 = this;

      var self = this;
      this.showLoading();
      var token = __WEBPACK_IMPORTED_MODULE_7__services_storage_service__["TokenService"].getToken();
      var payload = {
        ReserveID: this.ReserveId
      };
      this.PaymentId = 2;
      Object(__WEBPACK_IMPORTED_MODULE_4__helper_internet_js__["makeRequest"])("/pgapi/braintree/getToken", "POST", token, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        _this20.hideLoading();
        if (res.data.Status === true) {
          _this20.showBrainTreeContainer = true;
          _this20.showOtpSection = false;
          var clientToken = res.data.Token;
          _this20.paymentToken = clientToken;
          braintree.dropin.create({
            authorization: clientToken,
            selector: "#dropin-container",
            threeDSecure: {
              amount: self.showDetails.TotalPrice
            }
          }, function (err, dropinInstance) {
            if (err) {
              // Handle any errors that might've occurred when creating Drop-in
              console.error(err);
              return;
            }
            self.$refs.submitButton.addEventListener("click", function () {
              dropinInstance.requestPaymentMethod(function (err, payload) {
                if (err) {
                  // Handle errors in requesting payment method
                } else {
                  self.nonce = payload.nonce;
                  self.makePayment();
                }
                // Send payload.nonce to your server
              });
            });
          });
        } else {
          _this20.hideLoading();
          _this20.errorMessage.payment = res.data.Message;
        }
      });
    },

    FreemakePayment: function FreemakePayment() {
      var _this21 = this;

      this.showLoading();
      var token = __WEBPACK_IMPORTED_MODULE_7__services_storage_service__["TokenService"].getToken();

      var payload = {
        PaymentID: 0,
        ReserveID: this.ReserveId
      };
      Object(__WEBPACK_IMPORTED_MODULE_4__helper_internet_js__["makeRequest"])("/Booking/ConfirmBooking/", "POST", token, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        _this21.hideLoading();
        if (res.data.Status) {
          _this21.showProceedButton = true;
          _this21.tabs.collapse2 = false;
          // this.tabs.collapse3 = true;
          // this.$root.$emit("bv::toggle::collapse", "accordion3");
          _this21.confirmDetails = res.data;

          _this21.$router.replace({
            name: "confirmScreen",
            params: {
              bookingId: _this21.confirmDetails.BookingID || 0,
              paymentId: _this21.PaymentId || 2
            }
          });
        } else {
          _this21.$router.push({
            name: "failedPayment",
            params: {
              ss_id: _this21.showDetails.MovieID,
              screen_id: _this21.CategoryID,
              md_id: _this21.CinemaScheduleID
            }
          });
          _this21.errorMessage.payment = res.data.Message;
        }
      });
    },

    payNow: function payNow() {
      var _this22 = this;

      this.showLoading();
      var payload = {
        isGroupRateCard: true,
        MyCinema: true,
        reservation_id: this.ReservationID,
        isSplitPayment: false,
        unpaid_booking: false,
        cinema_id: 1,
        payment_mode_id: 16,
        approverId: null,
        order_code: null,
        oldCustomer: true,
        customer_id: this.userInfo.cust_id,
        cust_id: this.userInfo.cust_id,
        email: this.userInfo.cust_email,
        payment_mode: {
          bs_id: 1,
          bs_source: "Box Office",
          bs_is_active: "Y",
          created_by: null,
          created_at: null,
          updated_by: 4,
          updated_at: "2020-07-16T04:20:00.000Z",
          bspm_id: 20,
          booking_source_id: 1,
          mapping_is_active: "Y",
          payment_mode_id: 16,
          pm_payment_mode: "BrainTree",
          pm_icon_url: null,
          pm_is_active: "Y",
          pm_id: 16,
          amount: 0
        },
        isLoyaltyApplied: false,
        offer: this.offerData
      };
      __WEBPACK_IMPORTED_MODULE_14__services_mainService_js___default.a.BookSeats(payload).then(function (response) {
        var data = response.data;

        if (data.status) {
          console.log("data", data);
          _this22.showProceedButton = true;
          _this22.tabs.collapse2 = false;
          _this22.confirmDetails = data;
          _this22.$router.replace({
            name: "confirmScreen",
            params: {
              show_booking_id: data.sb_booking_code,
              category_id: _this22.CategoryID
            }
          });
        } else {
          _this22.$router.push({
            name: "failedPayment"
          });
          _this22.errorMessage.payment = data.message;
        }
      }).catch(function (err) {
        console.log("error", err);
      }).finally(function () {
        _this22.hideLoading();
      });
    },


    //---
    makePayment: function makePayment() {
      var _this23 = this;

      this.showLoading();
      var token = __WEBPACK_IMPORTED_MODULE_7__services_storage_service__["TokenService"].getToken();
      var payload = {
        CountryID: "195",
        nonce: this.nonce,
        PaymentID: this.PaymentId,
        ReserveID: this.ReserveId
      };
      Object(__WEBPACK_IMPORTED_MODULE_4__helper_internet_js__["makeRequest"])("/Booking/ConfirmBooking/", "POST", token, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        _this23.hideLoading();
        if (res.data.Status) {
          _this23.showProceedButton = true;
          _this23.tabs.collapse2 = false;
          // this.tabs.collapse3 = true;
          // this.$root.$emit("bv::toggle::collapse", "accordion3");
          _this23.confirmDetails = res.data;
          _this23.$router.replace({
            name: "confirmScreen",
            params: {
              bookingId: _this23.confirmDetails.BookingID || 0,
              paymentId: _this23.PaymentId || 2
            }
          });
        } else {
          _this23.$router.push({
            name: "failedPayment",
            params: {
              movieId: _this23.showDetails.MovieID,
              categoryId: _this23.CategoryID,
              scheduleId: _this23.CinemaScheduleID
            }
          });
          _this23.errorMessage.payment = res.data.Message;
        }
      });
    },
    confirmBooking: function confirmBooking() {
      var _this24 = this;

      this.showLoading();
      var token = __WEBPACK_IMPORTED_MODULE_7__services_storage_service__["TokenService"].getToken();
      var payload = {
        OTP: this.OTP.toString().replace(/,/g, ""),
        PaymentID: this.PaymentId,
        ReserveID: this.ReserveId
      };
      Object(__WEBPACK_IMPORTED_MODULE_4__helper_internet_js__["makeRequest"])("/Booking/ConfirmBooking/", "POST", token, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        _this24.hideLoading();
        if (res.data.Status) {
          _this24.showProceedButton = true;
          _this24.tabs.collapse2 = false;
          // this.tabs.collapse3 = true;
          // this.$root.$emit("bv::toggle::collapse", "accordion3");
          _this24.confirmDetails = res.data;
          _this24.$router.push({
            name: "confirmScreen",
            params: {
              bookingId: _this24.confirmDetails.BookingID || 0,
              paymentId: _this24.PaymentId || 2
            }
          });
        } else {
          _this24.$router.push({
            name: "failedPayment",
            params: {
              movieId: _this24.showDetails.MovieID,
              categoryId: _this24.CategoryID,
              scheduleId: _this24.CinemaScheduleID
            }
          });
          _this24.errorMessage.payment = res.data.Message;
        }
      });
    }
  }
});

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slick__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_date_pick__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_date_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_date_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_date_pick_dist_vueDatePick_css__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_date_pick_dist_vueDatePick_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_date_pick_dist_vueDatePick_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper_internet_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__helper_internet_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_storage_service__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_storage_service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__services_storage_service__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_navigator_share__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_mainService_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_mainService_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__services_mainService_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_AuthServices_js__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_AuthServices_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__services_AuthServices_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_PromotionServices_js__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_PromotionServices_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__services_PromotionServices_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






//import { dragscroll } from 'vue-dragscroll'








/* harmony default export */ __webpack_exports__["a"] = ({
  name: "confirmScreen",
  directives: {
    //'dragscroll':dragscroll
  },

  components: {
    Slick: __WEBPACK_IMPORTED_MODULE_1_vue_slick__["default"],
    DatePick: __WEBPACK_IMPORTED_MODULE_2_vue_date_pick___default.a,
    NavigatorShare: __WEBPACK_IMPORTED_MODULE_6_vue_navigator_share__["a" /* default */]
  },

  data: function data() {
    return {
      legacySystemHTML: "",
      bookingDetails: {},
      bookingId: "",
      paymentId: "",
      friendemail: "",
      errorMessage: "",
      reserveID: "",
      counter: 0,
      show_booking_id: null,
      category_id: null,

      isSocialShareVisible: false,
      shareDetails: {
        url: "https://cinemacon.gogocinema.com/",
        title: "Movie DETAILS" || this.bookingDetails.movie_title
      }
    };
  },


  filters: {
    moment: function moment(date) {
      return __WEBPACK_IMPORTED_MODULE_7_moment___default()(date).format("DD-MMM-YYYY");
    },
    datetime: function datetime(date) {
      return __WEBPACK_IMPORTED_MODULE_7_moment___default()(date).format("DD-MMM-YYYY HH:mm");
    }
  },
  computed: {
    totalPayableAmount: function totalPayableAmount() {
      var total = this.bookingDetails.sb_total_amount - this.bookingDetails.offer_price - this.bookingDetails.TaxOffer;
      return total;
    },
    curr_code: function curr_code() {
      return this.$store.getters.getCurrCode;
    },
    userInfo: function userInfo() {
      if (localStorage.getItem("user")) {
        var user = JSON.parse(localStorage.getItem("user"));
        this.userLoggedIn = true;
        return user;
      } else {
        return false;
      }
    }
  },
  beforeMount: function beforeMount() {
    // if (this.$route.params.paymentId == 3) {
    //   this.reserveID = this.$route.params.bookingId;
    //   this.confirmBookingStatus();
    // } else {

    this.show_booking_id = this.$route.params.show_booking_id;
    this.category_id = this.$route.params.category_id || 1;
    console.log(this.$route.params.category_id);
    this.fetchBookingDetails();
  },

  methods: {
    screeningType: function screeningType() {
      var categoryId = parseInt(this.$route.params.category_id, 10); // Parse as integer

      switch (categoryId) {
        case 1:
          return "private";
        case 2:
          return "not_confirmed";
        case 3:
          return "crowdsource";
        default:
          return "undefined";
      }
    },
    getShareMessage: function getShareMessage() {
      var baseMessage = "Hey friends! I've booked tickets for " + this.bookingDetails.movie_title + " at GoGoCinema. Let's enjoy this movie night together!";
      console.log(this.screeningType());
      switch (this.screeningType()) {
        case "private":
          return "Calling all movie buffs! I'm hosting a Private Screening of " + this.bookingDetails.movie_title + " at GoGoCinema and YOU'RE invited! Get ready for an exclusive movie experience where we'll have the entire auditorium to ourselves! Let's make it a show night to remember! See you there! " + this.shareDetails.url + " #GoGoCinema #PrivateScreening #MovieNight #GoTime-ShowTime";
        case "not_confirmed":
          return baseMessage + " We still need more bookings to confirm the show. Don't miss out! Book now and spread the word! " + this.shareDetails.url + " #GoGoCinema #NotConfirmed #MovieNight";
        case "crowdsource":
          return "Exciting News! " + baseMessage + " This screening needs YOUR help to happen! Join me by booking your ticket now. Once we reach the minimum threshold, it's \u201CGoTime-Showtime!\u201D Book your seat here: " + this.shareDetails.url + " #GoGoCinema #MovieNight #Crowdsource #GoTime-ShowTime";
        default:
          return "";
      }
    },
    toggleSocialShareVisibility: function toggleSocialShareVisibility() {
      this.isSocialShareVisible = !this.isSocialShareVisible;
    },
    shareViaWhatsApp: function shareViaWhatsApp() {
      var message = this.getShareMessage();

      var whatsappUrl = "https://api.whatsapp.com/send?text=" + encodeURIComponent(message);
      window.open(whatsappUrl, "_blank");
    },
    shareOnFacebook: function shareOnFacebook() {
      var message = this.getShareMessage();
      var title = encodeURIComponent(this.shareDetails.title);
      var quote = encodeURIComponent(message); // Using getShareMessage() as the quote
      var url = encodeURIComponent(this.shareDetails.url);
      var facebookUrl = "https://www.facebook.com/sharer/sharer.php?u=" + url + "&quote=" + quote + "&hashtag=" + encodeURIComponent("#vuejs,#vite");

      console.log("Opening Facebook URL:", facebookUrl);
      window.open(facebookUrl, "_blank");
    },
    shareOnX: function shareOnX() {
      var message = this.getShareMessage();
      var twitterUrl = "https://twitter.com/intent/tweet?url=" + encodeURIComponent(this.shareDetails.url) + "&text=" + encodeURIComponent(message) + "&hashtags=GoGoCinema,MovieNight";
      window.open(twitterUrl, "_blank");
    },
    shareOnLinkedIn: function shareOnLinkedIn() {
      var message = this.getShareMessage();
      var linkedInUrl = "https://www.linkedin.com/shareArticle?mini=true&url=" + this.shareDetails.url + "&text=" + encodeURIComponent(message);
      window.open(linkedInUrl, "_blank");
    },
    showDateHandlaler: function showDateHandlaler(date) {
      return __WEBPACK_IMPORTED_MODULE_7_moment___default()(date).format("MMMM DD, YYYY");
    },
    copyToClipboard: function copyToClipboard() {
      var message = this.getShareMessage();

      navigator.clipboard.writeText(message).then(function () {
        alert('Link copied! Paste it in your post or story.');
      }, function (err) {
        console.error('Failed to copy text: ', err);
      });
    },
    copyTextShare: function copyTextShare() {
      var copyText = document.getElementById("copyText");
      copyText.select();
      document.execCommand("copy");
      var self = this;
      this.bookingDetails["Title"] = this.bookingDetails["Title"] + "  ";
      this.bookingDetails.show = true;
      setTimeout(function () {
        self.bookingDetails.show = false;
        self.bookingDetails["Title"] = self.bookingDetails["Title"] + " ";
      }, 2000);
    },
    onError: function onError(err) {
      alert(err);
      console.log(err);
    },
    onSuccess: function onSuccess(err) {
      console.log(err);
    },

    confirmBookingStatus: function confirmBookingStatus() {
      var _this = this;

      var payload = {
        PaymentID: 3,
        ReserveID: this.reserveID
      };
      if (this.counter > 30) {
        window.location = window.location.origin + "/failedPayment/" + this.$route.query.MovieID + "/" + this.$route.query.CategoryID + "/" + this.$route.query.CinemaScheduleID;
        return;
      }

      Object(__WEBPACK_IMPORTED_MODULE_4__helper_internet_js__["makeRequest"])("/getBookingStatus/", "POST", null, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        _this.counter++;
        if (res.data.Status == false) {
          setTimeout(_this.confirmBookingStatus, 2000);
        } else {
          _this.paymentId = _this.$route.params.paymentId;
          _this.bookingId = res.data.BookingID;
          _this.fetchBookingDetails();
        }
      }).catch(function (error) {
        console.log("Error", error);
      });
    },
    print: function print() {
      var _this2 = this;

      this.legacySystemHTML = " <div id=\"printMe1\" marginwidth=\"0\" marginheight=\"0\" style=\"display:none;font-family:Arial,sans-serif;background:#fff\">\n    <table style=\"  margin: 0 auto;min-width: 650px;max-width: 650px;border: 1px solid #e5e5e5;border-spacing: 0;\">\n        <tbody>\n            <tr>\n                <td\n                    style=\"height: 25px;font-size:16px;font-family:Arial,sans-serif;text-align:center;vertical-align:top;background: linear-gradient(91.93deg, #E70B01 1.07%, #FA5302 106.59%);border:0;\">\n                </td>\n            </tr>\n            <tr>\n                <td\n                    style=\"padding:15px 25px 15px 25px;font-size:16px;font-family:Arial,sans-serif;text-align:center;vertical-align:top;border:0;background: linear-gradient(91.93deg, #E70B01 1.07%, #FA5302 106.59%);color:#828282\">\n                    <img src=\"https://img.gogocinema.com/assets/images/organization/5d59922b95715.png\">\n                </td>\n            </tr>\n            <tr>\n                <td\n                    style=\"padding:20px 25px 20px 25px;font-size:16px;font-weight:bold;font-family:Arial,sans-serif;text-align:center;vertical-align:top;background-color:#ffffff;color:#2B2D42\">\n                    <span\n                        style=\"font-size: 30px; text-align: center; letter-spacing: -0.5px; color: #2B2D42;\">Congratulations!</span>\n                </td>\n            </tr>\n\n            <tr>\n                <td\n                    style=\"padding:10px 25px 10px 25px;font-size: 14px;text-align: center;color: #2B2D42;font-family:Arial,sans-serif;text-align:center;vertical-align:top;background-color:#ffffff;\">\n                    Your tickets for <span style=\"color: #45BB4D\">" + this.bookingDetails.Title + " </span>are confirmed.\n                </td>\n            </tr>\n            <tr>\n                <td\n                    style=\"padding:5px 25px 25px 25px;font-size:16px;font-family:Arial,sans-serif;text-align:center;vertical-align:top;background-color:#ffffff;color: #2B2D42\">\n                    Your Booking ID <span style=\"font-size: 18px;text-align: center;color: #2B2D42;\"> " + parseInt(this.bookingId) + "</span>\n                </td>\n            </tr>\n            <tr>\n                <td>\n                    <table\n                        style=\"font-family: Arial,sans-serif; width: 360px;background-color:#E70D00;display: block;margin: 0 auto;\">\n                        <tr>\n                            <td style=\"width: 360px;padding-top:15px;padding-bottom: 15px;\">\n                                <table\n                                    style=\"width: 330px; margin: 0 auto;background-color: #fff;border-radius: 15px;border-spacing: 0;\">\n                                    <tr>\n                                        <td colspan=\"2\" style=\"vertical-align: top; padding: 0; text-align: center;\">\n                                            <img src=\"https://i.imgur.com/u8YQEpM.png\" width=\"70\">\n                                        </td>\n                                    </tr>\n\n                                    <tr>\n                                        <td style=\"width: 60%;padding-left: 15px;padding-bottom: 15px;\">\n                                            <img src=\"https://i.imgur.com/rC3q0us.png\" height=\"33\" width=\"65\" alt=\"\">\n                                        </td>\n                                        <td\n                                            style=\"width: 40%;vertical-align: bottom; padding-right: 15px;padding-bottom: 15px;\">\n                                            <p style=\"font-size: 10px;margin: 0;\">Ticket No : " + parseInt(this.bookingId) + "</p>\n                                        </td>\n                                    </tr>\n\n                                    <tr>\n                                        <td colspan=\"2\"\n                                            style=\"padding-left: 15px;padding-right:15px;padding-bottom: 10px;  \">\n                                            <p\n                                                style=\"font-size: 20px;font-weight: bold; color:#2B2D42;margin: 0;padding-bottom: 5px;\">\n                                               " + this.bookingDetails.Title + "\n                                            </p>\n                                            <p\n                                                style=\"font-size: 12px;font-weight: bold; color:#252525;margin: 0; padding-bottom: 8px;\">\n                                                <span>" + this.bookingDetails.Rated + "</span> |\n                                                <span>" + this.bookingDetails.Language + " </span> |\n                                                <span>" + this.bookingDetails.Format + "</span>\n                                            </p>\n                                            <p style=\"font-size: 12px;font-weight: bold; color:#252525;margin: 0;\">\n                                                " + this.bookingDetails.CinemaName + "\n                                            </p>\n                                        </td>\n                                    </tr>\n\n                                    <tr>\n                                        <td colspan=\"2\"\n                                            style=\"padding-left: 15px;padding-right: 15px;padding-bottom: 10px;\">\n                                            <p style=\"width: 100%;border-bottom: 1px solid #8D99AF;margin:0;\"></p>\n                                        </td>\n                                    </tr>\n\n                                    <tr>\n                                        <td\n                                            style=\"width: 60%;padding-left: 15px;padding-right: 15px; padding-bottom: 15px;\">\n                                            <p style=\"font-size: 12px;color: #8D99AE;margin:0;padding-bottom: 4px;\">Date\n                                            </p>\n                                            <p style=\"font-size: 14px;font-weight: bold; color: #252525;margin: 0;\">\n                                                 " + this.bookingDetails.ShowDate + "\n                                            </p>\n                                        </td>\n                                        <td\n                                            style=\"width: 40%;vertical-align: top;padding-right: 15px;padding-bottom: 15px;\">\n                                            <p style=\"font-size: 12px;color: #8D99AE;margin: 0;padding-bottom: 5px;\">\n                                                Time</p>\n                                            <p style=\"font-size: 14px;font-weight: bold; color: #252525;margin: 0;\">\n                                                  " + this.bookingDetails.ShowTime + " </p>\n                                        </td>\n                                    </tr>\n\n\n                                    <tr>\n                                        <td\n                                            style=\"width: 60%;vertical-align: top;padding-left: 15px;padding-right: 15px;padding-bottom: 15px;\">\n                                            <p style=\"font-size: 12px;color: #8D99AE;margin: 0;padding-bottom: 5px;\">\n                                                Seats : -\n                                                (" + this.bookingDetails.SeatsCount + ")\n                                            </p>\n                                            <p style=\"font-size: 14px;font-weight: bold; color: #252525;margin:0;word-break:break-all;\">\n                                                " + this.bookingDetails.Seats + "\n                                            </p>\n                                        </td>\n                                        <td\n                                            style=\"width: 40%;vertical-align: top;padding-right: 15px;padding-bottom: 15px;\">\n                                            <p style=\"font-size: 12px;color: #8D99AE;margin: 0;padding-bottom: 5px;\">\n                                                Screen No.</p>\n                                            <p style=\"font-size:14px;font-weight: bold;color:#252525;margin: 0;\"> " + this.bookingDetails.ScreenNo + "\n                                            </p>\n                                        </td>\n                                    </tr>\n\n                                    <tr>\n                                        <td style=\"width: 60%;padding-left: 15px;padding-right: 15px;\">\n                                            <p style=\"font-size: 12px;color:#8D99AE;margin:0;padding-bottom:8px;\">Ticket\n                                                Price</p>\n                                            <p style=\"font-size: 12px;color:#8D99AE;margin:0;padding-bottom:8px;\">GST\n                                            </p>\n                                            <p style=\"font-size: 12px;color:#8D99AE;margin:0;padding-bottom:8px;\">\n                                                Service Charge</p>\n                                            <p style=\"font-size: 12px;color:#8D99AE;margin:0;padding-bottom:8px;\">\n                                                Discount</p>\n                                        </td>\n                               <td style=\"width: 40%;padding-right: 15px;\">\n                                <p style=\"font-size: 12px;color: #8D99AE;margin:0;padding-bottom:8px;\">" + this.bookingDetails.Currency + " " + this.bookingDetails.TotalPrice + " </p>\n                                <p style=\"font-size: 12px;color: #8D99AE;margin:0;padding-bottom:8px;\">" + this.bookingDetails.Currency + " " + this.bookingDetails.GST + "</p>\n                                <p style=\"font-size: 12px;color: #8D99AE;margin:0;padding-bottom:8px;\">" + this.bookingDetails.Currency + " " + this.bookingDetails.TicketHandling + "</p>\n                                <p style=\"font-size: 12px;color: #8D99AE;margin:0;padding-bottom:8px;\">" + this.bookingDetails.Currency + " " + this.bookingDetails.Discount + "</p>\n                            </td>\n                                    </tr>\n\n                                    <tr>\n                                        <td colspan=\"2\" style=\"padding-left: 15px;padding-right: 15px;\">\n                                            <p style=\"width: 100%;border-bottom: 1px solid #8D99AF;margin:0;\"></p>\n                                        </td>\n                                    </tr>\n\n                                    <tr>\n                                        <td style=\"width: 60%;padding: 5px 10px 10px 15px;\">\n                                            <p style=\"font-size: 12px;color: #8D99AE;margin: 0;\">Total</p>\n                                        </td>\n                                        <td style=\"width: 40%;padding: 5px 10px 10px 0px;\">\n                                            <p style=\"font-size: 14px;color: #252525;margin: 0;\">" + this.bookingDetails.Currency + " " + this.bookingDetails.Total + "</p>\n                                        </td>\n                                    </tr>\n\n                                    <!-- <tr>\n                                <td colspan=\"2\" style=\"border-bottom: 1px dashed #252525;\"></td>\n                            </tr> -->\n\n                                    <tr>\n                                        <td colspan=\"2\" style=\"padding:0;\">\n                                            <img src=\"https://i.imgur.com/JN4vNty.png\" style=\"width: 100%\" alt=\"\">\n                                        </td>\n                                    </tr>\n\n                                    <tr>\n                                      <td colspan=\"2\"\n                                            style=\"text-align: center;padding-left: 15px;padding-right: 15px;padding-bottom: 15px;\">\n                                            " + (this.bookingDetails.ShowType == "Private" ? "" : "<p style=\"font-size: 14px;color:#2B2D42;font-weight: bold;\" >" + this.bookingDetails.ShowStatusMsg + "</p>") + "\n\n                                            <p\n                                                style=\"height: 20px;background:  #e4e4e4;border-radius: 5px; " + (this.bookingDetails.ShowType == "Private" ? "margin-left:23%;width: 51%" : "width:100%") + " \">\n                                                <span\n                                                    style=\"font-size: 12px; font-weight: bold; display: block;text-align: center; color:#000; height: 20px; width: 100%;background: " + (this.bookingDetails.ShowType == "Private" ? "#ffc107" : this.bookingDetails.ShowStatusMsg == "CONFIRMED" ? "#45bb4d" : this.bookingDetails.ShowStatusMsg == "UNCONFIRMED" ? "#E70D00" : "#000") + ";border-radius: 5px;\">\n\n                                                    <span style=\"display:block;padding-top:3px;\"> " + (this.bookingDetails.ShowType != "Private" ? this.bookingDetails.ExpiryMsg : "Private Screening") + "</span>\n                                                </span>\n                                            </p>\n\n                                            <p style=\"font-size: 12px;color:#252525;\">Use this QR Code to Enter the\n                                                Cinema</p>\n\n                                            <p>\n                                                <img src=\"" + this.bookingDetails.qrcode + "\" height=\"100px\" width=\"100px\">\n                                            </p>\n                                             </td>\n                                    </tr>\n                                    <tr>\n                                        <td colspan=\"2\" style=\"vertical-align: bottom; padding: 0;\">\n                                            <img src=\"https://i.imgur.com/qd4gKqH.png\" width=\"70\"\n                                                style=\"margin-bottom:-1px;display: block; margin: 0 auto;\">\n                                        </td>\n                                    </tr>\n                                 </table>\n                            </td>\n                        </tr>\n                    </table>\n                </td>\n            </tr>\n\n            <tr>\n                <td align=\"center\"\n                    style=\"padding:15px 0 0px 0; font-weight: bold; font-size: 18px;line-height: 28px;letter-spacing: -0.5px;color: #252525;font-family:Arial,sans-serif;vertical-align:top;background-color:#ffffff;\">\n                    <a href=\"http://test.gogocinema.com/terms-condition-ticket\"\n                        style=\"font-size: 12px;font-weight: 300;text-decoration: none;\" target=\"_blank\">Click Here For\n                        Terms and Conditions</a>\n                </td>\n            </tr>\n            <tr>\n                <td\n                    style=\"height: 25px;font-size:16px;font-family:Arial,sans-serif;text-align:center;vertical-align:top;background: linear-gradient(91.93deg, #E70B01 1.07%, #FA5302 106.59%);border:0;\">\n                </td>\n            </tr>\n        </tbody>\n\n    </table>\n</div>";
      // Pass the element id here

      this.$nextTick(function () {
        _this2.$htmlToPaper("printMe1");
      });
    },

    fetchBookingDetails: function fetchBookingDetails() {
      var _this3 = this;

      // this.showLoading();
      var payload = {
        sb_id: this.show_booking_id,
        category_id: this.category_id
      };
      __WEBPACK_IMPORTED_MODULE_8__services_mainService_js___default.a.GetBookingDetails(payload).then(function (response) {
        var data = response.data;

        if (data.status) {
          console.log("data booking", data);
          _this3.bookingDetails = data.Records[0];
          _this3.bookingDetails["show"] = false;
        }
      }).catch(function (err) {
        console.log("Error:", err);
      }).finally(function () {
        _this3.hideLoading();
      });
      // makeRequest("/Booking/GetBookingDetails", "POST", token, payload)
      //   .then(response => {
      //     const { error, res } = response;
      //     this.hideLoading();

      //     this.bookingDetails = res.data;
      //     this.bookingDetails.Seats = this.bookingDetails.Seats.split(",").join(
      //       ", "
      //     );
      //     this.bookingDetails.SeatsLeft =
      //       parseInt(this.bookingDetails.TotalSeat) -
      //       parseInt(this.bookingDetails.SeatsBooked);
      //     this.bookingDetails["show"] = false;
      //   })
      //   .catch(error => {
      //     console.log("Error", error);
      //   });
    },
    validateBeforeSubmit: function validateBeforeSubmit(scope) {
      var _this4 = this;

      if (scope == "inviteFriend") {
        this.$validator.validateAll(scope).then(function (result) {
          if (result) {
            // this.showLoading();
            var token = __WEBPACK_IMPORTED_MODULE_5__services_storage_service__["TokenService"].getToken();
            var payload = {
              FriendEmail: _this4.friendemail,
              BookingID: _this4.bookingId
            };
            Object(__WEBPACK_IMPORTED_MODULE_4__helper_internet_js__["makeRequest"])("/Booking/ResendTickets", "POST", token, payload).then(function (response) {
              var error = response.error,
                  res = response.res;

              _this4.hideLoading();
              if (!error && res.data.Status) {
                _this4.errorMessage = "Ticekt has been sent to your friend's email address";
              } else {
                _this4.errorMessage = res.data.Message;
              }
              setTimeout(function () {
                _this4.$refs.invitemodal.hide();
              }, 3000);
            }).catch(function (error) {
              _this4.errorMessage = "Something went wrong!";
              console.log("Error", error);
            });
            return;
          }
        });
      }
    }
  }
});

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: String,
    text: String,
    url: {
      type: String,
      required: true
    },
    onError: Function,
    onSuccess: Function
  },
  methods: {
    hasSlot: function hasSlot() {
      return !!this.$slots['clickable'];
    },
    share: function share() {
      var _this = this;

      var data = {
        title: this.title,
        text: this.text,
        url: this.url
      };

      if (navigator.share) {
        navigator.share(data).then(function (succ) {
          if (succ) {
            _this.onSuccess(succ);
          }
        }).catch(function (err) {
          if (onError) {
            _this.onError(err);
          }
        });
      } else {
        if (this.onError) {
          this.onError('method not supported');
        }
      }
    }
  }
});

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slick__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_date_pick__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_date_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_date_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_date_pick_dist_vueDatePick_css__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_date_pick_dist_vueDatePick_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_date_pick_dist_vueDatePick_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_internet_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__helper_internet_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_storage_service__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_storage_service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__services_storage_service__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_navigator_share__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_mainService_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_mainService_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__services_mainService_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_AuthServices_js__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_AuthServices_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__services_AuthServices_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_PromotionServices_js__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_PromotionServices_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__services_PromotionServices_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




//import { dragscroll } from 'vue-dragscroll'








/* harmony default export */ __webpack_exports__["a"] = ({
  name: "confirmScreen",
  directives: {
    //'dragscroll':dragscroll
  },

  components: {
    Slick: __WEBPACK_IMPORTED_MODULE_0_vue_slick__["default"],
    DatePick: __WEBPACK_IMPORTED_MODULE_1_vue_date_pick___default.a,
    NavigatorShare: __WEBPACK_IMPORTED_MODULE_5_vue_navigator_share__["a" /* default */]
  },

  data: function data() {
    return {
      legacySystemHTML: "",
      bookingDetails: {},
      bookingId: "",
      paymentId: "",
      friendemail: "",
      errorMessage: "",
      reserveID: "",
      counter: 0,
      show_booking_id: null,
      category_id: null
    };
  },

  filters: {
    moment: function moment(date) {
      return __WEBPACK_IMPORTED_MODULE_6_moment___default()(date).format("DD-MMM-YYYY");
    },
    datetime: function datetime(date) {
      return __WEBPACK_IMPORTED_MODULE_6_moment___default()(date).format("DD-MMM-YYYY HH:mm");
    }
  },
  computed: {
    totalPayableAmount: function totalPayableAmount() {
      var total = this.bookingDetails.sb_total_amount - this.bookingDetails.offer_price - this.bookingDetails.TaxOffer;
      return total;
    },
    curr_code: function curr_code() {
      return this.$store.getters.getCurrCode;
    },
    userInfo: function userInfo() {
      if (localStorage.getItem("user")) {
        var user = JSON.parse(localStorage.getItem("user"));
        this.userLoggedIn = true;
        return user;
      } else {
        return false;
      }
    }
  },
  beforeMount: function beforeMount() {
    // if (this.$route.params.paymentId == 3) {
    //   this.reserveID = this.$route.params.bookingId;
    //   this.confirmBookingStatus();
    // } else {
    this.show_booking_id = this.$route.params.show_booking_id;
    this.category_id = this.$route.params.category_id || 1;
    this.fetchBookingDetails();
  },

  methods: {
    copyTextShare: function copyTextShare() {
      var copyText = document.getElementById("copyText");
      copyText.select();
      document.execCommand("copy");
      var self = this;
      this.bookingDetails["Title"] = this.bookingDetails["Title"] + "  ";
      this.bookingDetails.show = true;
      setTimeout(function () {
        self.bookingDetails.show = false;
        self.bookingDetails["Title"] = self.bookingDetails["Title"] + " ";
      }, 2000);
    },
    onError: function onError(err) {
      alert(err);
      console.log(err);
    },
    onSuccess: function onSuccess(err) {
      console.log(err);
    },

    confirmBookingStatus: function confirmBookingStatus() {
      var _this = this;

      var payload = {
        PaymentID: 3,
        ReserveID: this.reserveID
      };
      if (this.counter > 30) {
        window.location = window.location.origin + "/failedPayment/" + this.$route.query.MovieID + "/" + this.$route.query.CategoryID + "/" + this.$route.query.CinemaScheduleID;
        return;
      }

      Object(__WEBPACK_IMPORTED_MODULE_3__helper_internet_js__["makeRequest"])("/getBookingStatus/", "POST", null, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        _this.counter++;
        if (res.data.Status == false) {
          setTimeout(_this.confirmBookingStatus, 2000);
        } else {
          _this.paymentId = _this.$route.params.paymentId;
          _this.bookingId = res.data.BookingID;
          _this.fetchBookingDetails();
        }
      }).catch(function (error) {
        console.log("Error", error);
      });
    },
    print: function print() {
      var _this2 = this;

      this.legacySystemHTML = " <div id=\"printMe1\" marginwidth=\"0\" marginheight=\"0\" style=\"display:none;font-family:Arial,sans-serif;background:#fff\">\n    <table style=\"  margin: 0 auto;min-width: 650px;max-width: 650px;border: 1px solid #e5e5e5;border-spacing: 0;\">\n        <tbody>\n            <tr>\n                <td\n                    style=\"height: 25px;font-size:16px;font-family:Arial,sans-serif;text-align:center;vertical-align:top;background: linear-gradient(91.93deg, #E70B01 1.07%, #FA5302 106.59%);border:0;\">\n                </td>\n            </tr>\n            <tr>\n                <td\n                    style=\"padding:15px 25px 15px 25px;font-size:16px;font-family:Arial,sans-serif;text-align:center;vertical-align:top;border:0;background: linear-gradient(91.93deg, #E70B01 1.07%, #FA5302 106.59%);color:#828282\">\n                    <img src=\"https://img.gogocinema.com/assets/images/organization/5d59922b95715.png\">\n                </td>\n            </tr>\n            <tr>\n                <td\n                    style=\"padding:20px 25px 20px 25px;font-size:16px;font-weight:bold;font-family:Arial,sans-serif;text-align:center;vertical-align:top;background-color:#ffffff;color:#2B2D42\">\n                    <span\n                        style=\"font-size: 30px; text-align: center; letter-spacing: -0.5px; color: #2B2D42;\">Congratulations!</span>\n                </td>\n            </tr>\n            <tr>\n                <td\n                    style=\"padding:10px 25px 10px 25px;font-size: 14px;text-align: center;color: #2B2D42;font-family:Arial,sans-serif;text-align:center;vertical-align:top;background-color:#ffffff;\">\n                    Your tickets for <span style=\"color: #45BB4D\">" + this.bookingDetails.Title + " </span>are confirmed.\n                </td>\n            </tr>\n            <tr>\n                <td\n                    style=\"padding:5px 25px 25px 25px;font-size:16px;font-family:Arial,sans-serif;text-align:center;vertical-align:top;background-color:#ffffff;color: #2B2D42\">\n                    Your Booking ID <span style=\"font-size: 18px;text-align: center;color: #2B2D42;\"> " + parseInt(this.bookingId) + "</span>\n                </td>\n            </tr>\n            <tr>\n                <td>\n                    <table\n                        style=\"font-family: Arial,sans-serif; width: 360px;background-color:#E70D00;display: block;margin: 0 auto;\">\n                        <tr>\n                            <td style=\"width: 360px;padding-top:15px;padding-bottom: 15px;\">\n                                <table\n                                    style=\"width: 330px; margin: 0 auto;background-color: #fff;border-radius: 15px;border-spacing: 0;\">\n                                    <tr>\n                                        <td colspan=\"2\" style=\"vertical-align: top; padding: 0; text-align: center;\">\n                                            <img src=\"https://i.imgur.com/u8YQEpM.png\" width=\"70\">\n                                        </td>\n                                    </tr>\n\n                                    <tr>\n                                        <td style=\"width: 60%;padding-left: 15px;padding-bottom: 15px;\">\n                                            <img src=\"https://i.imgur.com/rC3q0us.png\" height=\"33\" width=\"65\" alt=\"\">\n                                        </td>\n                                        <td\n                                            style=\"width: 40%;vertical-align: bottom; padding-right: 15px;padding-bottom: 15px;\">\n                                            <p style=\"font-size: 10px;margin: 0;\">Ticket No : " + parseInt(this.bookingId) + "</p>\n                                        </td>\n                                    </tr>\n\n                                    <tr>\n                                        <td colspan=\"2\"\n                                            style=\"padding-left: 15px;padding-right:15px;padding-bottom: 10px;  \">\n                                            <p\n                                                style=\"font-size: 20px;font-weight: bold; color:#2B2D42;margin: 0;padding-bottom: 5px;\">\n                                               " + this.bookingDetails.Title + "\n                                            </p>\n                                            <p\n                                                style=\"font-size: 12px;font-weight: bold; color:#252525;margin: 0; padding-bottom: 8px;\">\n                                                <span>" + this.bookingDetails.Rated + "</span> |\n                                                <span>" + this.bookingDetails.Language + " </span> |\n                                                <span>" + this.bookingDetails.Format + "</span>\n                                            </p>\n                                            <p style=\"font-size: 12px;font-weight: bold; color:#252525;margin: 0;\">\n                                                " + this.bookingDetails.CinemaName + "\n                                            </p>\n                                        </td>\n                                    </tr>\n\n                                    <tr>\n                                        <td colspan=\"2\"\n                                            style=\"padding-left: 15px;padding-right: 15px;padding-bottom: 10px;\">\n                                            <p style=\"width: 100%;border-bottom: 1px solid #8D99AF;margin:0;\"></p>\n                                        </td>\n                                    </tr>\n\n                                    <tr>\n                                        <td\n                                            style=\"width: 60%;padding-left: 15px;padding-right: 15px; padding-bottom: 15px;\">\n                                            <p style=\"font-size: 12px;color: #8D99AE;margin:0;padding-bottom: 4px;\">Date\n                                            </p>\n                                            <p style=\"font-size: 14px;font-weight: bold; color: #252525;margin: 0;\">\n                                                 " + this.bookingDetails.ShowDate + "\n                                            </p>\n                                        </td>\n                                        <td\n                                            style=\"width: 40%;vertical-align: top;padding-right: 15px;padding-bottom: 15px;\">\n                                            <p style=\"font-size: 12px;color: #8D99AE;margin: 0;padding-bottom: 5px;\">\n                                                Time</p>\n                                            <p style=\"font-size: 14px;font-weight: bold; color: #252525;margin: 0;\">\n                                                  " + this.bookingDetails.ShowTime + " </p>\n                                        </td>\n                                    </tr>\n\n\n                                    <tr>\n                                        <td\n                                            style=\"width: 60%;vertical-align: top;padding-left: 15px;padding-right: 15px;padding-bottom: 15px;\">\n                                            <p style=\"font-size: 12px;color: #8D99AE;margin: 0;padding-bottom: 5px;\">\n                                                Seats : -\n                                                (" + this.bookingDetails.SeatsCount + ")\n                                            </p>\n                                            <p style=\"font-size: 14px;font-weight: bold; color: #252525;margin:0;word-break:break-all;\">\n                                                " + this.bookingDetails.Seats + "\n                                            </p>\n                                        </td>\n                                        <td\n                                            style=\"width: 40%;vertical-align: top;padding-right: 15px;padding-bottom: 15px;\">\n                                            <p style=\"font-size: 12px;color: #8D99AE;margin: 0;padding-bottom: 5px;\">\n                                                Screen No.</p>\n                                            <p style=\"font-size:14px;font-weight: bold;color:#252525;margin: 0;\"> " + this.bookingDetails.ScreenNo + "\n                                            </p>\n                                        </td>\n                                    </tr>\n\n                                    <tr>\n                                        <td style=\"width: 60%;padding-left: 15px;padding-right: 15px;\">\n                                            <p style=\"font-size: 12px;color:#8D99AE;margin:0;padding-bottom:8px;\">Ticket\n                                                Price</p>\n                                            <p style=\"font-size: 12px;color:#8D99AE;margin:0;padding-bottom:8px;\">GST\n                                            </p>\n                                            <p style=\"font-size: 12px;color:#8D99AE;margin:0;padding-bottom:8px;\">\n                                                Service Charge</p>\n                                            <p style=\"font-size: 12px;color:#8D99AE;margin:0;padding-bottom:8px;\">\n                                                Discount</p>\n                                        </td>\n                               <td style=\"width: 40%;padding-right: 15px;\">\n                                <p style=\"font-size: 12px;color: #8D99AE;margin:0;padding-bottom:8px;\">" + this.bookingDetails.Currency + " " + this.bookingDetails.TotalPrice + " </p>\n                                <p style=\"font-size: 12px;color: #8D99AE;margin:0;padding-bottom:8px;\">" + this.bookingDetails.Currency + " " + this.bookingDetails.GST + "</p>\n                                <p style=\"font-size: 12px;color: #8D99AE;margin:0;padding-bottom:8px;\">" + this.bookingDetails.Currency + " " + this.bookingDetails.TicketHandling + "</p>\n                                <p style=\"font-size: 12px;color: #8D99AE;margin:0;padding-bottom:8px;\">" + this.bookingDetails.Currency + " " + this.bookingDetails.Discount + "</p>\n                            </td>\n                                    </tr>\n\n                                    <tr>\n                                        <td colspan=\"2\" style=\"padding-left: 15px;padding-right: 15px;\">\n                                            <p style=\"width: 100%;border-bottom: 1px solid #8D99AF;margin:0;\"></p>\n                                        </td>\n                                    </tr>\n\n                                    <tr>\n                                        <td style=\"width: 60%;padding: 5px 10px 10px 15px;\">\n                                            <p style=\"font-size: 12px;color: #8D99AE;margin: 0;\">Total</p>\n                                        </td>\n                                        <td style=\"width: 40%;padding: 5px 10px 10px 0px;\">\n                                            <p style=\"font-size: 14px;color: #252525;margin: 0;\">" + this.bookingDetails.Currency + " " + this.bookingDetails.Total + "</p>\n                                        </td>\n                                    </tr>\n\n                                    <!-- <tr>\n                                <td colspan=\"2\" style=\"border-bottom: 1px dashed #252525;\"></td>\n                            </tr> -->\n\n                                    <tr>\n                                        <td colspan=\"2\" style=\"padding:0;\">\n                                            <img src=\"https://i.imgur.com/JN4vNty.png\" style=\"width: 100%\" alt=\"\">\n                                        </td>\n                                    </tr>\n\n                                    <tr>\n                                      <td colspan=\"2\"\n                                            style=\"text-align: center;padding-left: 15px;padding-right: 15px;padding-bottom: 15px;\">\n                                            " + (this.bookingDetails.ShowType == "Private" ? "" : "<p style=\"font-size: 14px;color:#2B2D42;font-weight: bold;\" >" + this.bookingDetails.ShowStatusMsg + "</p>") + "\n\n                                            <p\n                                                style=\"height: 20px;background:  #e4e4e4;border-radius: 5px; " + (this.bookingDetails.ShowType == "Private" ? "margin-left:23%;width: 51%" : "width:100%") + " \">\n                                                <span\n                                                    style=\"font-size: 12px; font-weight: bold; display: block;text-align: center; color:#000; height: 20px; width: 100%;background: " + (this.bookingDetails.ShowType == "Private" ? "#ffc107" : this.bookingDetails.ShowStatusMsg == "CONFIRMED" ? "#45bb4d" : this.bookingDetails.ShowStatusMsg == "UNCONFIRMED" ? "#E70D00" : "#000") + ";border-radius: 5px;\">\n\n                                                    <span style=\"display:block;padding-top:3px;\"> " + (this.bookingDetails.ShowType != "Private" ? this.bookingDetails.ExpiryMsg : "Private Screening") + "</span>\n                                                </span>\n                                            </p>\n\n                                            <p style=\"font-size: 12px;color:#252525;\">Use this QR Code to Enter the\n                                                Cinema</p>\n\n                                            <p>\n                                                <img src=\"" + this.bookingDetails.qrcode + "\" height=\"100px\" width=\"100px\">\n                                            </p>\n                                             </td>\n                                    </tr>\n                                    <tr>\n                                        <td colspan=\"2\" style=\"vertical-align: bottom; padding: 0;\">\n                                            <img src=\"https://i.imgur.com/qd4gKqH.png\" width=\"70\"\n                                                style=\"margin-bottom:-1px;display: block; margin: 0 auto;\">\n                                        </td>\n                                    </tr>\n                                 </table>\n                            </td>\n                        </tr>\n                    </table>\n                </td>\n            </tr>\n\n            <tr>\n                <td align=\"center\"\n                    style=\"padding:15px 0 0px 0; font-weight: bold; font-size: 18px;line-height: 28px;letter-spacing: -0.5px;color: #252525;font-family:Arial,sans-serif;vertical-align:top;background-color:#ffffff;\">\n                    <a href=\"http://test.gogocinema.com/terms-condition-ticket\"\n                        style=\"font-size: 12px;font-weight: 300;text-decoration: none;\" target=\"_blank\">Click Here For\n                        Terms and Conditions</a>\n                </td>\n            </tr>\n            <tr>\n                <td\n                    style=\"height: 25px;font-size:16px;font-family:Arial,sans-serif;text-align:center;vertical-align:top;background: linear-gradient(91.93deg, #E70B01 1.07%, #FA5302 106.59%);border:0;\">\n                </td>\n            </tr>\n        </tbody>\n\n    </table>\n</div>";
      // Pass the element id here

      this.$nextTick(function () {
        _this2.$htmlToPaper("printMe1");
      });
    },

    fetchBookingDetails: function fetchBookingDetails() {
      var _this3 = this;

      this.showLoading();
      var payload = {
        sb_id: this.show_booking_id
      };
      __WEBPACK_IMPORTED_MODULE_7__services_mainService_js___default.a.GetBookingDetailsVista(payload).then(function (response) {
        var data = response.data;

        if (data.status) {
          console.log("data booking", data);
          _this3.bookingDetails = data.Records[0];
          _this3.bookingDetails["show"] = false;
        }
      }).catch(function (err) {
        console.log("Error:", err);
      }).finally(function () {
        _this3.hideLoading();
      });
      // makeRequest("/Booking/GetBookingDetails", "POST", token, payload)
      //   .then(response => {
      //     const { error, res } = response;
      //     this.hideLoading();

      //     this.bookingDetails = res.data;
      //     this.bookingDetails.Seats = this.bookingDetails.Seats.split(",").join(
      //       ", "
      //     );
      //     this.bookingDetails.SeatsLeft =
      //       parseInt(this.bookingDetails.TotalSeat) -
      //       parseInt(this.bookingDetails.SeatsBooked);
      //     this.bookingDetails["show"] = false;
      //   })
      //   .catch(error => {
      //     console.log("Error", error);
      //   });
    },
    validateBeforeSubmit: function validateBeforeSubmit(scope) {
      var _this4 = this;

      if (scope == "inviteFriend") {
        this.$validator.validateAll(scope).then(function (result) {
          if (result) {
            _this4.showLoading();
            var token = __WEBPACK_IMPORTED_MODULE_4__services_storage_service__["TokenService"].getToken();
            var payload = {
              FriendEmail: _this4.friendemail,
              BookingID: _this4.bookingId
            };
            Object(__WEBPACK_IMPORTED_MODULE_3__helper_internet_js__["makeRequest"])("/Booking/ResendTickets", "POST", token, payload).then(function (response) {
              var error = response.error,
                  res = response.res;

              _this4.hideLoading();
              if (!error && res.data.Status) {
                _this4.errorMessage = "Ticekt has been sent to your friend's email address";
              } else {
                _this4.errorMessage = res.data.Message;
              }
              setTimeout(function () {
                _this4.$refs.invitemodal.hide();
              }, 3000);
            }).catch(function (error) {
              _this4.errorMessage = "Something went wrong!";
              console.log("Error", error);
            });
            return;
          }
        });
      }
    }
  }
});

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_slick__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_date_pick__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_date_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_date_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_date_pick_dist_vueDatePick_css__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_date_pick_dist_vueDatePick_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_date_pick_dist_vueDatePick_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper_internet_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__helper_internet_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_storage_service__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_storage_service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__services_storage_service__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_navigator_share__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_mainService_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_mainService_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__services_mainService_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_AuthServices_js__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_AuthServices_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__services_AuthServices_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_PromotionServices_js__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_PromotionServices_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__services_PromotionServices_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_rtsServices__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_rtsServices___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__services_rtsServices__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
  name: "confirmScreen",
  directives: {},

  components: {
    Slick: __WEBPACK_IMPORTED_MODULE_2_vue_slick__["default"],
    DatePick: __WEBPACK_IMPORTED_MODULE_3_vue_date_pick___default.a,
    NavigatorShare: __WEBPACK_IMPORTED_MODULE_7_vue_navigator_share__["a" /* default */]
  },

  data: function data() {
    return {
      legacySystemHTML: "",
      bookingDetails: {},
      bookingId: "",
      paymentId: "",
      friendemail: "",
      errorMessage: "",
      reserveID: "",
      counter: 0,
      rts_reserve_id: null,
      category_id: null
    };
  },

  filters: {
    moment: function moment(date) {
      return __WEBPACK_IMPORTED_MODULE_8_moment___default()(date).format("DD-MMM-YYYY");
    },
    datetime: function datetime(date) {
      return __WEBPACK_IMPORTED_MODULE_8_moment___default()(date).format("DD-MMM-YYYY HH:mm");
    }
  },
  computed: {
    totalPayableAmount: function totalPayableAmount() {
      var total = this.bookingDetails.sb_total_amount - this.bookingDetails.offer_price - this.bookingDetails.TaxOffer;
      return total;
    },
    curr_code: function curr_code() {
      return this.$store.getters.getCurrCode;
    },
    userInfo: function userInfo() {
      if (localStorage.getItem("user")) {
        var user = JSON.parse(localStorage.getItem("user"));
        this.userLoggedIn = true;
        return user;
      } else {
        return false;
      }
    }
  },
  beforeMount: function beforeMount() {
    this.hideLoading();
    this.rts_reserve_id = this.$route.params.rts_reserve_id;
    this.category_id = this.$route.params.category_id || 1;
    this.fetchBookingDetails();
  },

  methods: {
    copyTextShare: function copyTextShare() {
      var copyText = document.getElementById("copyText");
      copyText.select();
      document.execCommand("copy");
      var self = this;
      this.bookingDetails["Title"] = this.bookingDetails["Title"] + "  ";
      this.bookingDetails.show = true;
      setTimeout(function () {
        self.bookingDetails.show = false;
        self.bookingDetails["Title"] = self.bookingDetails["Title"] + " ";
      }, 2000);
    },
    onError: function onError(err) {
      alert(err);
      console.log(err);
    },
    onSuccess: function onSuccess(err) {
      console.log(err);
    },
    fetchBookingDetails: function fetchBookingDetails() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var payload, response, data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.showLoading();
                payload = {
                  reserve_id: _this.rts_reserve_id
                };
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_12__services_rtsServices___default.a.getBookingDetails(payload);

              case 5:
                response = _context.sent;
                data = response.data;

                if (data.status) {
                  _this.bookingDetails = data.Records[0];
                  _this.bookingDetails["show"] = false;
                }
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);

                console.log("Error:", _context.t0);

              case 13:
                _this.hideLoading();

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 10]]);
      }))();
    },
    validateBeforeSubmit: function validateBeforeSubmit(scope) {
      var _this2 = this;

      if (scope == "inviteFriend") {
        this.$validator.validateAll(scope).then(function (result) {
          if (result) {
            // this.showLoading();
            var token = __WEBPACK_IMPORTED_MODULE_6__services_storage_service__["TokenService"].getToken();
            var payload = {
              FriendEmail: _this2.friendemail,
              BookingID: _this2.bookingId
            };
            Object(__WEBPACK_IMPORTED_MODULE_5__helper_internet_js__["makeRequest"])("/Booking/ResendTickets", "POST", token, payload).then(function (response) {
              var error = response.error,
                  res = response.res;

              if (!error && res.data.Status) {
                _this2.errorMessage = "Ticekt has been sent to your friend's email address";
              } else {
                _this2.errorMessage = res.data.Message;
              }
              setTimeout(function () {
                _this2.$refs.invitemodal.hide();
              }, 3000);
            }).catch(function (error) {
              _this2.errorMessage = "Something went wrong!";
              console.log("Error", error);
              _this2.hideLoading();
            });
            return;
          }
        });
      }
    }
  }
});

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slick__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_date_pick__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_date_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_date_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_date_pick_dist_vueDatePick_css__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_date_pick_dist_vueDatePick_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_date_pick_dist_vueDatePick_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_internet_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__helper_internet_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_storage_service__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_storage_service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__services_storage_service__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "confirmScreen",
  directives: {
    // 'dragscroll': dragscroll
  },

  components: {
    Slick: __WEBPACK_IMPORTED_MODULE_0_vue_slick__["default"],
    DatePick: __WEBPACK_IMPORTED_MODULE_1_vue_date_pick___default.a
  },

  data: function data() {
    return {
      legacySystemHTML: "",
      bookingDetails: {},
      bookingId: "",
      paymentId: "",
      friendemail: "",
      errorMessage: "",
      CategoryID: "",
      CinemaScheduleID: "",
      movieId: "",
      ss_id: null,
      screen_id: null,
      md_id: null
    };
  },
  beforeMount: function beforeMount() {},

  methods: {
    onClickHere: function onClickHere() {
      var country = __WEBPACK_IMPORTED_MODULE_4__services_storage_service__["CountryService"].getCountry();
      this.$router.push({
        name: "seatLayout",
        params: {
          categoryId: this.CategoryID,
          movieId: this.movieId,
          cinemaScheduleId: this.CinemaScheduleID,
          countryId: country.CountryID
        }
      });
    },
    print: function print() {
      var _this = this;

      // Pass the element id here
      this.legacySystemHTML = "\n        <div id=\"printMe\" marginwidth=\"0\" marginheight=\"0\" style=\"display:none;font-family:Arial,sans-serif;background:#fff\">\n    <table bgcolor=\"#fff\" cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" border=\"0\" align=\"center\" style=\"padding:10px 0 25px 0;margin:0 auto;background:#fff\">\n      <tbody><tr>\n        <td width=\"100%\" valign=\"top\">\n          <table cellpadding=\"0\" cellspacing=\"0\" width=\"600\" border=\"0\" align=\"center\" bgcolor=\"ffffff\" style=\"margin:0 auto;min-width:650px;max-width:650px; border: 1px solid #e5e5e5;\">\n            <tbody><tr>\n              <td colspan=\"3\" style=\"width:600px;background-color:#ffffff\">\n                <a href=\"\" style=\"text-decoration:none;color:#010101\" rel=\"noreferrer\" target=\"_blank\"  style=\"margin:0 auto;padding:0 10px 10px 10px;display:block;background-color:#ffffff;color:#010101\" border=\"0\" width=\"150\">\n                </a>\n              </td>\n            </tr>\n            <tr>\n              <td align=\"center\" style=\"height: 25px;font-size:16px;font-family:Arial,sans-serif;text-align:center;vertical-align:top;background: linear-gradient(91.93deg, #E70B01 1.07%, #FA5302 106.59%);border:0;\">\n              </td>\n            </tr>\n            <tr>\n              <td align=\"center\" style=\"padding:15px 25px 15px 25px;font-size:16px;font-family:Arial,sans-serif;text-align:center;vertical-align:top;border:0;background: linear-gradient(91.93deg, #E70B01 1.07%, #FA5302 106.59%);color:#828282\">\n                <img src=\"http://developmentgogocinema.binarynumbers.io/assets/img/logo-name.png\">\n\n              </td>\n            </tr>\n           <tr>\n              <td align=\"center\" style=\"padding:20px 25px 20px 25px;font-size:16px;font-weight:bold;font-family:Arial,sans-serif;text-align:center;vertical-align:top;background-color:#ffffff;color:#2B2D42\">\n                  <span style=\"font-size: 30px; text-align: center; letter-spacing: -0.5px; color: #2B2D42;\">Congratulations!</span>\n\n              </td>\n            </tr>\n\n            <tr>\n              <td align=\"center\" style=\"padding:10px 25px 10px 25px;font-size: 14px;text-align: center;color: #2B2D42;font-family:Arial,sans-serif;text-align:center;vertical-align:top;background-color:#ffffff;\">Your tickets for <span style=\"color: #45BB4D\">" + this.bookingDetails.Title + "</span> are confirmed.\n              </td>\n            </tr>\n            <tr>\n              <td align=\"center\" style=\"padding:5px 25px 5px 25px;font-size:16px;font-family:Arial,sans-serif;text-align:center;vertical-align:top;background-color:#ffffff;color: #2B2D42\">Your Transaction ID : <span style=\"font-size: 18px;text-align: center;color: #2B2D42;\">" + parseInt(this.bookingId) + "</span>\n              </td>\n            </tr>\n\n\n            <tr>\n              <td align=\"center\" style=\"width:600px;padding:25px 10px 0 10px;text-align:left;background-color:#ffffff\">\n                <table align=\"center\" cellpadding=\"0\" cellspacing=\"0\" style=\"width:580px;margin:0 auto;background-color:#ffffff\">\n                  <tbody><tr>\n                    <td>\n                      <table align=\"center\" cellpadding=\"0\" cellspacing=\"0\" style=\"width:580px;margin:0 auto;background-color:#f5f5f5;border-radius:5px\">\n                        <tbody><tr>\n                          <td>\n                            <table align=\"center\" cellpadding=\"0\" cellspacing=\"0\" style=\"width:580px;margin:0 auto;padding:10px;background-color:#f5f5f5;border-top-left-radius:5px;border-top-right-radius:5px\">\n                              <tbody><tr>\n                                <td valign=\"top\" align=\"center\" style=\"width:580px;background-color:#f5f5f5\">\n                                  <table cellspacing=\"0\" cellpadding=\"0\" align=\"center\" style=\"width:100%;background-color:#f5f5f5;margin:0px auto\">\n                                    <tbody>\n                                        <tr>\n                                      <td valign=\"top\" align=\"center\" style=\"width:60px;background-color:#f5f5f5;padding:10px 10px 0px 10px;\">\n\n                                        <img src=\"" + this.bookingDetails.Image1 + "\" width=\"auto\" height=\"auto\" style=\"max-width:100%;display:block;background-color:#f5f5f5;color:#010101;border-radius:5px;height:auto; border:0;\">\n\n                                      </td>\n\n                                      <td valign=\"top\" align=\"center\" style=\"width:370px;background-color:#f5f5f5;padding:10px\">\n                                        <table cellspacing=\"0\" cellpadding=\"0\" align=\"center\" style=\"width:100%;background-color:#f5f5f5;margin:0px auto\">\n                                          <tbody><tr>\n                                            <td valign=\"top\" align=\"left\" style=\"padding:0px 5px 0px 0px;height:50px;font-family:Arial,sans-serif;text-align:left;vertical-align:top;background-color:#f5f5f5;\">\n                                              <span style=\"font-size:20px;font-weight:bold;color:#252525;padding-bottom: 5px\">" + this.bookingDetails.Title + "</span>\n                                              <ul style=\"list-style: none; padding: 0px; margin:6px 0px 0px 0px; font-size: 14px;color: #252525\">\n                                                <li style=\"display: inline;\">" + this.bookingDetails.Rated + " |</li>\n                                                <li style=\"display: inline;\">" + this.bookingDetails.Language + " |</li>\n                                                <li style=\"display: inline;\">" + this.bookingDetails.Format + "</li>\n                                              </ul>\n                                              <hr style=\"background: linear-gradient(91.93deg, #E70B01 1.07%, #FA5302 106.59%); height: 1px; border:0;\">\n                                            </td>\n                                          </tr>\n\n\n                                          <tr>\n                                            <td valign=\"bottom\" align=\"left\" style=\"padding:10px 5px 10px 0px;font-size:16px;font-family:Arial,sans-serif;text-align:left;vertical-align:top;background-color:#f5f5f5;color:#25AAD3\">" + this.bookingDetails.CinemaName + "</td>\n                                          </tr>\n                                          <tr>\n                                            <td valign=\"bottom\" align=\"left\" style=\"padding:10px 5px 10px 0px;font-size: 18px;line-height: 28px;letter-spacing: -0.5px;color: #252525;font-weight: bold;margin: 0px; font-family:Arial,sans-serif;text-align:left;vertical-align:top;background-color:#f5f5f5;\">" + this.bookingDetails.ShowTime + " | " + this.bookingDetails.ShowDate + " </td>\n                                            <td>\n\n                                            </td>\n                                          </tr>\n                                           <tr>\n                                            <td valign=\"bottom\" align=\"left\" style=\" width: 50%; padding:10px 5px 10px 0px;font-family:Arial,sans-serif;text-align:left;vertical-align:top;background-color:#f5f5f5;\">\n                                              <p style=\"font-size: 12px;line-height: 14px;color: #8D99AF;margin: 0;\">Show Category: </p>\n                                                 <p style=\"font-size: 18px;line-height: 28px;letter-spacing: -0.5px;color: #252525;font-weight: bold;margin: 0px;float: left;\">" + this.bookingDetails.CategoryName + " </p>\n\n                                            </td>\n\n                                               <td valign=\"bottom\" align=\"left\" style=\" width: 50%; padding:10px 5px 10px 0px;font-family:Arial,sans-serif;text-align:left;vertical-align:top;background-color:#f5f5f5;\">\n\n                                              <p style=\"font-size: 12px;line-height: 14px;color: #8D99AF;margin: 0;\">Show Status</p>\n                                                <p style=\"float: left;font-size: 18px;color: " + (this.bookingDetails.ShowStatusMsg == "CONFIRMED" ? "#45bb4d" : this.bookingDetails.ShowStatusMsg == "UNCONFIRMED" ? "#dc3545" : "#000") + ";font-weight: bold;font-family:Arial,sans-serif;  margin-top:5px;\">\n                                                  " + this.bookingDetails.ShowStatusMsg + "\n                                                </p>\n\n                                               </td>\n                                          </tr>\n                                        </tbody></table>\n                                      </td>\n                                    </tr>\n                                  </tbody></table>\n                                </td>\n                              </tr>\n                            </tbody></table>\n                          </td>\n                        </tr>\n                        <tr>\n                          <td valign=\"top\" style=\"width:580px;background-color:#f5f5f5;border:0\">\n                            <table cellspacing=\"0\" cellpadding=\"0\" align=\"center\" style=\"width:580px;margin:0px auto;border:0\">\n                                      <tbody>\n                                        <tr>\n                                         <td valign=\"top\" align=\"left\" style=\"width:60px;height:40px;padding:10px 10px 0px 15px;vertical-align:top;font-family:Arial,sans-serif;text-align:center; color:#828282;font-weight:400;border:0\">\n                                            <p style=\"font-size: 18px; color: #252525;font-weight: bold;margin: 0px\">" + this.bookingDetails.SeatsCount + "</p>\n                                            <span style=\"font-size: 12px;line-height: 14px;color: #8D99AF; margin: 0px\">Tickets</span>\n                                          </td>\n                                          <td valign=\"top\" align=\"left\" style=\"width:270px; padding:10px 10px 0px 15px;vertical-align:top;font-family:Arial,sans-serif;text-align:left; border:0\">\n                                            <p style=\"font-size: 12px;line-height: 14px;color: #8D99AF; margin: 0px\">Seats selected:</p>\n                                              <p style=\"font-size: 18px;line-height: 28px;letter-spacing: -0.5px;color: #252525;font-weight: bold;margin: 0px\">" + this.bookingDetails.Seats + "</p>\n                                          </td>\n                                          <td valign=\"top\" style=\"width:120px;border:0;height:107px;\">\n\n                                          </td>\n                                        </tr>\n                                      </tbody>\n                                    </table>\n                          </td>\n                        </tr>\n                      </tbody></table>\n                    </td>\n                  </tr>\n                </tbody></table>\n              </td>\n            </tr>\n            <tr>\n              <td valign=\"top\" align=\"left\" style=\"font-size:14px;font-family:Arial,sans-serif;text-align:left;vertical-align:top;background-color:#ffffff;color:#828282\">\n                <table align=\"center\" cellpadding=\"0\" cellspacing=\"0\" style=\"width:600px;font-family:Arial,sans-serif;margin:0 auto\">\n                  <tbody><tr>\n                    <td align=\"left\" style=\"width:580px;padding:15px 10px 15px 10px;font-size: 18px;text-align: right;color: #252525;font-family:Arial,sans-serif;text-align:left;vertical-align:top;background-color:#ffffff;font-weight:600;\">Order Summary</td>\n                  </tr>\n                </tbody></table>\n              </td>\n            </tr>\n            <tr>\n              <td align=\"left\" style=\"text-align:center;background-color:#ffffff\">\n                <table cellpadding=\"0\" cellspacing=\"0\" style=\"width:580px;padding:15px 25px 15px 25px;border:2px solid #f1f1f1;border-bottom:0px!important;border-top-left-radius:5px;border-top-right-radius:5px;font-family:Arial,sans-serif;margin:0 auto\">\n                  <tbody>\n                  <tr>\n                    <td valign=\"top\" align=\"left\" style=\"width:100%;font-size:14px;font-family:Arial,sans-serif;text-align:left;vertical-align:top;background-color:#ffffff;color:#828282\">\n                      <table cellpadding=\"0\" cellspacing=\"0\" style=\"width:100%;padding:20px 0px;font-family:Arial,sans-serif;margin:0 auto\">\n                        <tbody><tr>\n                          <td align=\"left\"  style=\"width:50%;font-size:13px;font-family:Arial,sans-serif;text-align:left;vertical-align:bottom;background-color:#ffffff;color:#3c3c3c\">\n                            <p style=\"color:#828282;font-size:13px;margin:0;padding:0 0 4px 0;\"></p>\n                            <p style=\"font-size: 14px;line-height: 22px;color: #252525;margin:0;padding:0 0 4px 0\">Tickets (" + this.bookingDetails.SeatsCount + ") :</p>\n                            <!--<p style=\"font-size: 14px;line-height: 22px;color: #252525;margin:0;padding:0 0 4px 0\">Promocode Discount :</p>\n                            <p style=\"color:#828282;font-size:13px;margin:0;padding:0 0 4px 0\">HappyGOGO</p>-->\n                          </td>\n                          <td align=\"right\" style=\"width:50%;font-size:13px;font-family:Arial,sans-serif;text-align:right;vertical-align:bottom;background-color:#ffffff;color:#3c3c3c\">\n                            <p style=\"color:#828282;font-size:13px;margin:0;padding:0 0 4px 0\"></p>\n                            <p style=\"font-size: 18px;line-height: 28px;text-align: right;letter-spacing: -0.5px;color: #252525;margin:0;padding:0 0 4px 0\">" + this.bookingDetails.Currency + " " + this.bookingDetails.Total + "</p>\n                            <!--<p style=\"font-size: 18px;line-height: 28px;text-align: right;letter-spacing: -0.5px;color: #E70D01;margin:0;padding:0 0 4px 0\">- $2.00</p>-->\n                          </td>\n                        </tr>\n                      </tbody></table>\n                    </td>\n                  </tr>\n                  <tr>\n                    <td valign=\"top\" align=\"left\" style=\"width:100%;font-size:14px;font-family:Arial,sans-serif;text-align:left;vertical-align:top;background-color:#ffffff;color:#828282\">\n                  </td></tr>\n                  <tr>\n                  </tr><tr>\n                </tr></tbody></table>\n              </td>\n            </tr>\n            <tr>\n              <td align=\"center\" style=\"width:580px;text-align:center;background-color:#ffffff\">\n                <table cellpadding=\"0\" cellspacing=\"0\" style=\"width:580px;margin:0 auto;background-color:#ffffff\">\n                  <tbody><tr>\n                    <td valign=\"top\" align=\"left\" style=\"font-size:14px;font-family:Arial,sans-serif;text-align:left;vertical-align:top;background-color:#f1f1f1;color:#828282\">\n                      <table cellpadding=\"0\" cellspacing=\"0\" style=\"width:100%;padding:20px 25px 10px 25px;border-bottom:2px dashed #f1f1f1;font-family:Arial,sans-serif;margin:0 auto\">\n                        <tbody><tr>\n                          <td align=\"left\" style=\"font-size:16px;font-family:Arial,sans-serif;text-align:left;vertical-align:top;font-weight:bold;background-color:#f1f1f1;color:#333333\">AMOUNT PAID</td>\n                          <td align=\"left\" style=\"font-size:16px;font-family:Arial,sans-serif;text-align:right;vertical-align:top;font-weight:bold;background-color:#f1f1f1;color:#333333\">" + this.bookingDetails.Currency + " " + this.bookingDetails.Total + "</td>\n                        </tr>\n                      </tbody></table>\n                    </td>\n                  </tr>\n\n                  <tr>\n                    <td valign=\"top\" align=\"center\" style=\"width:580px;padding:20px 0;background-color:#ffffff\">\n                      <table cellspacing=\"0\" cellpadding=\"0\" align=\"center\" style=\"width:100%;background-color:#ffffff;margin:0px auto\">\n                        <tbody><tr>\n                          <td valign=\"top\" align=\"left\" style=\"width:260px;font-size:13px;font-weight:bold;font-family:Arial,sans-serif;text-align:left;vertical-align:top;background-color:#ffffff;color:#3f474e\">\n                            <p style=\"font-size: 10px;line-height: 14px;color: #8D99AF;margin-bottom: 0px;\">Booking Date & Time:</p>\n                            <p style=\"color:#252525;font-size:14px;margin:0;padding:0 0 4px 0\">" + this.bookingDetails.BookingDate + "</td>\n                          <td valign=\"top\" align=\"left\" style=\"width:240px;font-size:13px;font-weight:bold;font-family:Arial,sans-serif;text-align:left;vertical-align:top;background-color:#ffffff;color:#3f474e\">\n                            <p style=\"font-size: 10px;line-height: 14px;color: #8D99AF;margin-bottom: 0px;\">Payment Method:</p>\n                            <p style=\"color:#252525;font-size:14px;margin:0;padding:0 0 4px 0\">" + this.bookingDetails.PaymentMethod + "</td>\n                          <td valign=\"top\" align=\"left\" style=\"width:100px;font-size:13px;font-weight:bold;font-family:Arial,sans-serif;text-align:left;vertical-align:top;background-color:#ffffff;color:#3f474e\">\n                            <p style=\"font-size: 10px;line-height: 14px;color: #8D99AF;margin-bottom: 0px;\">Ticket ID: </p>\n                            <p style=\"color:#252525;font-size:14px;margin:0;padding:0 0 4px 0\">" + parseInt(this.bookingId) + "</td>\n                        </tr>\n                      </tbody></table>\n                    </td>\n                  </tr>\n                </tbody></table>\n              </td>\n            </tr>\n            <tr>\n              <td align=\"center\" style=\"width:580px;text-align:center;background-color:#ffffff\">\n                <table cellpadding=\"0\" cellspacing=\"0\" style=\"width:580px;margin:0 auto;background-color:#ffffff\">\n                  <tbody>\n\n                   <tr>\n                      <td align=\"center\" style=\"padding:15px 0 6px 0;font-size:11px;font-family:Arial,sans-serif;text-align:left;vertical-align:top;background-color:#fff;color:#787878\">\n                      <p style=\"padding:0 0 4px 0;margin:0; text-align: center\"><img src=\"" + this.bookingDetails.QRCode + "\" height=\"100px\" width=\"100px\"></p>\n                      <p style=\"font-size: 10px;line-height: 14px;color: #8D99AF;margin-bottom: 0px;text-align: center;\">(Show this code at the gate)</p>\n                    </td>\n                </tbody></table>\n              </td>\n            </tr>\n             <tr>\n            <td align=\"center\" style=\"height: 25px;font-size:16px;font-family:Arial,sans-serif;text-align:center;vertical-align:top;background: linear-gradient(91.93deg, #E70B01 1.07%, #FA5302 106.59%);border:0;\">\n\n                <table cellspacing=\"0\" cellpadding=\"0\" align=\"center\" style=\"width:25%;padding:5px 10px 5px 10px\">\n                        <tbody>\n                        <tr>\n                          <td style=\"vertical-align:top;text-align:center;border:0;\">\n                            <a href=\"#\">\n                             <img src=\"img/facebook-f-brands.svg\" height=\"12px\" width=\"12px\">\n                            </a>\n                          </td>\n                          <td style=\"vertical-align:top;text-align:center;border:0;\">\n                            <a href=\"#\">\n                              <img src=\"img/twitter-brands.svg\" height=\"12px\" width=\"12px\">\n                            </a>\n                          </td>\n                          <td style=\"vertical-align:top;text-align:center;border:0;\">\n                            <a href=\"#\">\n                             <img src=\"img/instagram-brands.svg\" height=\"12px\" width=\"12px\">\n                            </a>\n                          </td>\n                          <td style=\"vertical-align:top;text-align:center;border:0;\">\n                            <a href=\"#\">\n                              <img src=\"img/youtube-brands.svg\" height=\"12px\" width=\"12px\">\n                            </a>\n                          </td>\n                          <td style=\"vertical-align:top;text-align:center;border:0;\">\n                            <a href=\"#\">\n                              <img src=\"img/snapchat-ghost-brands.svg\" height=\"12px\" width=\"12px\">\n                            </a>\n                          </td>\n                        </tr>\n                      </tbody></table>\n\n              </td>\n            </tr>\n          </tbody></table>\n        </td>\n      </tr>\n    </tbody>\n  </table>\n </div>\n      ";
      this.$nextTick(function () {
        _this.$htmlToPaper("printMe");
      });
    },

    fetchBookingDetails: function fetchBookingDetails() {
      var _this2 = this;

      var token = __WEBPACK_IMPORTED_MODULE_4__services_storage_service__["TokenService"].getToken() || "2bbad34b53aaeeb27d28f69068e32e3081d8defe4c738d3c50a53f822816a507";
      var payload = {
        BookingID: this.bookingId,
        PaymentID: this.paymentId
      };
      Object(__WEBPACK_IMPORTED_MODULE_3__helper_internet_js__["makeRequest"])("/Booking/GetBookingDetails", "POST", token, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        _this2.hideLoading();

        _this2.bookingDetails = res.data;
        _this2.bookingDetails.Seats = _this2.bookingDetails.Seats.split(",").join(", ");
        _this2.bookingDetails.SeatsLeft = parseInt(_this2.bookingDetails.TotalSeat) - parseInt(_this2.bookingDetails.SeatsBooked);
      }).catch(function (error) {
        console.log("Error", error);
      });
    },
    validateBeforeSubmit: function validateBeforeSubmit(scope) {
      var _this3 = this;

      if (scope == "inviteFriend") {
        this.$validator.validateAll(scope).then(function (result) {
          if (result) {
            _this3.showLoading();
            var token = __WEBPACK_IMPORTED_MODULE_4__services_storage_service__["TokenService"].getToken();
            var payload = {
              FriendEmail: _this3.friendemail,
              BookingID: _this3.bookingId
            };
            Object(__WEBPACK_IMPORTED_MODULE_3__helper_internet_js__["makeRequest"])("/Booking/ResendTickets", "POST", token, payload).then(function (response) {
              var error = response.error,
                  res = response.res;

              _this3.hideLoading();

              if (!error && res.data.Status) {
                _this3.errorMessage = "Ticekt has been sent to your friend's email address";
              } else {
                _this3.errorMessage = res.data.Message;
              }
              setTimeout(function () {
                _this3.$refs.invitemodal.hide();
              }, 3000);
            }).catch(function (error) {
              _this3.errorMessage = "Something went wrong!";
              console.log("Error", error);
            });
            return;
          }
        });
      }
    }
  }
});

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper_internet_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__helper_internet_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_slick__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_date_pick__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_date_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_date_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_date_pick_dist_vueDatePick_css__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_date_pick_dist_vueDatePick_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_date_pick_dist_vueDatePick_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_partials_calendar_vue__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__main__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services_mainService_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services_mainService_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__services_mainService_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_cloneDeep__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_moment__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









// import { dragscroll } from 'vue-dragscroll'



var VueScrollTo = __webpack_require__(129);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "MyComponent",
  directives: {
    // 'dragscroll': dragscroll
  },

  components: {
    Slick: __WEBPACK_IMPORTED_MODULE_6_vue_slick__["default"],
    DatePick: __WEBPACK_IMPORTED_MODULE_8_vue_date_pick___default.a,
    calendar: __WEBPACK_IMPORTED_MODULE_11__components_partials_calendar_vue__["default"]
  },

  data: function data() {
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({
      count: 0,
      showTick1: false,
      showTick2: false,
      showTick3: false,
      showProceedToPayment: false,
      promoApplied: false,
      currentDate: new Date(),
      sSlider: {
        dots: false,
        arrows: true,
        slidesToShow: 3.5,
        infinite: false,
        slidesToScroll: 3,
        centerPadding: "50px",
        loop: false,
        responsive: [{
          breakpoint: 1100,
          settings: {
            arrows: true,
            dots: false,
            slidesToShow: 3,
            slidesToScroll: 1
          }
        }, {
          breakpoint: 480,
          settings: {
            arrows: true,
            dots: false,
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }]
      },
      date: "2019-01-01",
      movieDetails: {},
      MovieID: "",
      UniqueKey: false,
      NewShowTimeArray: [],
      LangFormat: "",
      ScreenName: "",
      screen_id: "",
      Currency: "",
      CategoryID: "",
      CinemaScheduleID: "",
      CinemaList: [],
      CinemaListCopy: [],
      selectedCinemaObject: {},
      ShowDates: [],
      ShowTimes: [],
      ShowTimesV1: {},
      ShowTypes: {},
      CinemaTimeScheduleID: "",
      selectedTime: "",
      ScreeningType: "",
      showMessage: "",
      seatLayout: [],
      seatTypes: [],
      numberOfSeatsSelected: 0,
      totalNumberOfSeats: 0,
      selectedSeats: [],
      row: "",
      column: "",
      newSeatLayout: [],
      NewShowTimeArray1: [],
      totalAmount: "",
      checkSize: "",
      ticketPrice: "",
      ServiceFee: "", // Added by Yogesh@2019-09-10 | @Description => To show the service tax
      searchValue: "",
      promocode: "",
      DiscountValue: "",
      promocodeSuccesMessage: "",
      promocodeErrorMessage: "",
      showDetails: {
        day: "",
        month: "",
        date: "",
        year: ""
      },
      days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      collapse1: true,
      collapse2: false,
      collapse3: false,
      collapse4: false,
      filterListCinema: [],
      CityArray: [],
      loadingContent: true,
      loadingShowType: false,
      loaderSeatLayout: false,
      priceTypeArray: [],
      remainingTicket: 0,
      TotalPriceNew: 0,
      showModalPrice: false,
      TaxRate: 0,
      TaxAmount: 0,
      ServiceFeePer: 0,
      ServiceFeeNew: 0,
      TaxAmountNew: 0.9,
      content_lang_id: 0,
      ScheduleDetailAll: [],
      cinema_id: null,
      fromDate: null,
      createSchedulePayload: {
        mrrdr_runtime: 0,
        start_time: "",
        schedule_date: "",
        cinema_ss_id: 0,
        guest_user_id: ""
      },

      //
      seatsSelectedRateGroupNew: [],
      totalAmountPrice: 0,
      totalSeatBooked: 0,
      totalNetAmout: 0,
      checkPopupExist: false,
      errorMessage: "",
      CinemaID: ""
    }, "cinema_id", "");
  },
  beforeMount: function beforeMount() {
    this.MovieID = this.$route.params.movieId;
    this.CategoryID = this.$route.params.categoryId;
    this.CinemaID = this.$route.params.cinemaId;
    this.cinema_id = this.$route.params.cinemaId;
    this.content_lang_id = this.$route.params.content_lang_id;
    this.onResetSeatLayout();
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.fetchMovieDetails();

            case 2:
              _context.next = 4;
              return _this.GetCreateShowDetails();

            case 4:
              //  await  this.fetchCinemasList();
              _this.$root.$on("bv::collapse::state", function (collapseId, isJustShown) {
                if (collapseId === "accordion1" && isJustShown) {
                  _this.collapse1 = true;
                  _this.collapse2 = false;
                  _this.collapse3 = false;
                  _this.collapse4 = false;
                }
                if (collapseId === "accordion2" && isJustShown) {
                  _this.collapse1 = false;
                  _this.collapse2 = true;
                  _this.collapse3 = false;
                  _this.collapse4 = false;
                }
                if (collapseId === "accordion3" && isJustShown) {
                  _this.collapse1 = false;
                  _this.collapse2 = false;
                  _this.collapse3 = true;
                  _this.collapse4 = false;
                }
                if (collapseId === "accordion4" && isJustShown) {
                  _this.collapse1 = false;
                  _this.collapse2 = false;
                  _this.collapse3 = false;
                  _this.collapse4 = true;
                }
              });
              if (_this.CinemaID == "" || _this.CinemaID == null) {
                setTimeout(function () {
                  VueScrollTo.scrollTo("#scrollToSection", "1000");
                }, 1000);
              }

              __WEBPACK_IMPORTED_MODULE_12__main__["EventBus"].$on("currentDate", function (currentDate) {
                var date = dateFns.format(currentDate, "YYYY-MM-DD");
                var parts = date.split("-"),
                    year = parseInt(parts[0], 10),
                    month = parseInt(parts[1], 10) - 1,
                    // NB: month is zero-based!
                day = parseInt(parts[2], 10);
                var date1 = new Date(year, month, day);
                _this.showDetails.day = _this.days[date1.getDay()].substring(0, 3);
                _this.showDetails.date = date1.getDate();
                _this.showDetails.month = _this.months[date1.getMonth()].substring(0, 3);
                _this.showDetails.year = year;
                _this.fromDate = date;
                _this.selectedTime = "";
                _this.GetCreateShowDetails();
              });

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    chargeTypeArray: function chargeTypeArray() {
      var selectedSeats = this.$store.getters.seatsSelected;
      var tempArr = [];
      var testObj = {};
      var finalArr = [];

      if (selectedSeats.length > 0) {
        selectedSeats.forEach(function (x) {
          if (x.hasOwnProperty("chargeTypeArray")) {
            x.chargeTypeArray.forEach(function (y) {
              tempArr.push(y);
            });
          }
        });
      }

      if (tempArr.length > 0) {
        tempArr.forEach(function (o) {
          if (!testObj[o.ct_id]) {
            testObj[o.ct_id] = {
              ct_id: o.ct_id,
              ct_name: o.ct_name,
              tax_amount: 0,
              quantity: o.quantity
            };
            finalArr.push(testObj[o.ct_id]);
          }
          testObj[o.ct_id].tax_amount += +o.tax_amount;
        });
      }
      console.log("this.$store.getters.SELECTED_SEATS", this.$store.getters.SELECTED_SEATS);
      console.log("finalArr", finalArr);
      return finalArr;
    },
    pickSeats: function pickSeats() {
      var tempArray = [];
      var selectedSeats = this.$store.getters.seatsSelected;
      if (selectedSeats && selectedSeats.length > 0) {
        selectedSeats.map(function (x) {
          tempArray.push(x.sl_seat_name);
        });
      }
      if (tempArray.length > 0) {
        return tempArray.join(", ");
      } else {
        return "";
      }
    },
    curr_code: function curr_code() {
      return this.$store.getters.getCurrCode;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["mapGetters"])(["getNowShowingDates", "getMovieDetailsScheduleList", "seatType", "seatsSelected", "totalPrice", "totalGrossPrice",
  // "getselectedDate",
  "getMovieDetailsScheduleList", "getMovieDetailsObject", "schedule_details_obj", "getGlobalCurrency", "getMovieDates", "getMovieId", "getCurrentLangIsoCode", "totalNumberOfSeats"]), {
    formattedDate: function formattedDate() {
      console.log("this.currentDate :", this.selectedMainDate);
      // let dateValue = dateFns.format(this.currentDate, "YYYY-MM-DD")
      // this.filterDate(dateValue)
      // return dateFns.format(this.currentDate, "MM/DD/YYYY");
      return this.selectedMainDate;
    },
    ShowProceed: function ShowProceed() {
      var count = 0;
      this.priceTypeArray.map(function (x) {
        x.PriceType.map(function (y) {
          count = count + y.Selected;
        });
      });
      if (this.selectedSeats.length == count) {
        this.remainingTicket = 0;
        return true;
      } else {
        this.remainingTicket = this.selectedSeats.length - count;
        return false;
      }
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    screeningMessage: function screeningMessage(screening) {
      if (screening.booking_type_id == 1) {
        return "Purchase " + screening["min_seats"] + " tickets or more to confirm your screening immediately.";
      } else if (screening.booking_type_id == 2) {
        return "Purchase less than " + screening["min_seats"] + " tickets and invite your friends to crowdsource. Once the screening is confirmed, we will notify you!";
      } else if (screening.booking_type_id == 3) {
        return "Book an exclusive private screening for your friends and family.";
      } else {
        return screening.message;
      }
    },
    checkMinimumSeats: function checkMinimumSeats(seat) {
      var selectedSeats = this.$store.getters.seatsSelected;
      if (this.totalNumberOfSeats) {
        var tempCheck = selectedSeats.filter(function (x) {
          return x.sl_id == seat.sl_id;
        });
        if (tempCheck && tempCheck.length > 0) {
          return true;
        } else if (parseInt(selectedSeats.length) == parseInt(this.totalNumberOfSeats)) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    checkSelectedSeats: function checkSelectedSeats(seat) {
      var selectedSeats = this.$store.getters.seatsSelected;
      if (this.totalNumberOfSeats && this.createSchedulePayload["booking_type_id"] == 2) {
        var tempCheck = selectedSeats.filter(function (x) {
          return x.sl_id == seat.sl_id;
        });
        if (tempCheck && tempCheck.length > 0) {
          return true;
        } else if (parseInt(selectedSeats.length) == parseInt(this.totalNumberOfSeats)) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },

    fetchCinemasList: function fetchCinemasList() {
      var _this2 = this;

      var payload = {
        cinema_id: this.$route.params.cinemaId,
        movie_id: this.$route.params.movieId
      };
      __WEBPACK_IMPORTED_MODULE_13__services_mainService_js___default.a.GetCinemaList(payload).then(function (response) {

        console.log(response, "res >>>>>>>>>>>>>>>>>>>>");

        var error = response.error,
            data = response.data;


        _this2.CinemaList = data.Records;
        _this2.CinemaListCopy = data.Records;
        _this2.loadingContent = false;
        _this2.loadingFirst = false;
        if (_this2.cinema_id) {
          _this2.onSelectCinema(_this2.CinemaList[0]);
          _this2.fetchShowDates();
        }
      }).catch(function (error) {
        console.log("Error", error);
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["mapActions"])(["getSeats", "getMovieDetailsSelectedFilter", "SelectNumberOfSeats", "seatHandler", "RESERVE_SEATS", "onResetSeatLayout", "getAdditionalCharges",
  // "getselectedDate",
  "onSetDefaultFilter", "getScheduleDetails", "setScheduleObj", "onGetAllMoviesSchedulesSeatPage", "onSetCompleteRateCard", "onSetCompleteNewTotalAmount", "getVouchersList", "fetchStripePublisherKey", "getAllShowDates", "onGetMovieShowDates", "onGetMovieDetails"]), {
    totalCount: function totalCount(rg, index, rg_index, type) {
      console.log("selected seats", this.$store.getters.SELECTED_SEATS);
      var seatsSelectedRateGroupCopy = __WEBPACK_IMPORTED_MODULE_14_lodash_cloneDeep___default()(this.seatsSelectedRateGroupNew);
      var x = seatsSelectedRateGroupCopy[index]["rate_card_group"][rg_index];
      if (type == "increment" && seatsSelectedRateGroupCopy[index].totalSelected == seatsSelectedRateGroupCopy[index].AllSeats.length) {
        return false;
      }

      if (type == "increment" && this.totalSeatBooked + 1 <= this.$store.getters.SELECTED_SEATS.length && x["totalSeatSelected"] <= this.$store.getters.SELECTED_SEATS.length) {
        console.log("line 743");
        x["totalSeatSelected"] = x["totalSeatSelected"] + 1;
        seatsSelectedRateGroupCopy[index].totalSelected = seatsSelectedRateGroupCopy[index].totalSelected + 1;
      } else if (seatsSelectedRateGroupCopy[index].totalSelected >= 1 && type == "decrement" && x["totalSeatSelected"] >= 1) {
        console.log("line 752");
        x["totalSeatSelected"] = x["totalSeatSelected"] - 1;
        seatsSelectedRateGroupCopy[index].totalSelected = seatsSelectedRateGroupCopy[index].totalSelected - 1;
      }

      var totalAmount = 0;
      var totalSeatBooked2 = 0;
      var totalNetAmout2 = 0;
      seatsSelectedRateGroupCopy.map(function (z) {
        z.rate_card_group.map(function (y) {
          totalAmount = parseFloat(totalAmount) + parseFloat(y.totalSeatSelected) * parseFloat(y.rc_total_amount);

          totalNetAmout2 = parseFloat(totalNetAmout2) + parseFloat(y.totalSeatSelected) * parseFloat(y.rc_net_amount);
        });

        totalSeatBooked2 = parseInt(totalSeatBooked2) + parseInt(z.totalSelected);
      });
      this.totalAmountPrice = totalAmount;
      this.totalSeatBooked = totalSeatBooked2;
      this.totalNetAmout = totalNetAmout2;
      // x["tt_name"] = x["tt_name"] + " ";
      if (totalSeatBooked2 == this.$store.getters.SELECTED_SEATS.length) {
        console.log("line 779");
        // this.$store.dispatch("onSetCompleteRateCard", {
        //   status: true,
        //   seatGroup: this.seatsSelectedRateGroupNew,
        // });
        // this.$store.dispatch("onSetCompleteNewTotalAmount", {
        //   totalAmount: this.totalAmountPrice,
        //   netAmount: this.totalNetAmout,
        // });
      } else {
        console.log("line 789");
        this.$store.dispatch("onSetCompleteRateCard", {
          status: false,
          seatGroup: __WEBPACK_IMPORTED_MODULE_14_lodash_cloneDeep___default()(seatsSelectedRateGroupCopy)
        });
      }
      this.seatsSelectedRateGroupNew = seatsSelectedRateGroupCopy;
      console.log(this.seatsSelectedRateGroupNew);
      console.log("fdsfdsfdsf");
      if (this.totalSeatBooked == this.$store.getters.SELECTED_SEATS.length) {
        this.errorMessage = "";
      } else {
        this.errorMessage = "Please Select All Seats";
      }
    },
    hidePriceModal: function hidePriceModal() {
      this.$refs.gogoModal.hide();
    },
    IncrementSelected: function IncrementSelected(item, index2, index1) {
      console.log(item);
      this.priceTypeArray[index1]["PriceType"][index2]["Selected"]++;
      this.priceTypeArray[index1]["NoOfSeatSelected"]++;
      this.ServiceFeeNew = parseFloat(+parseFloat(this.ServiceFeeNew) + parseFloat(item.ServiceFee)).toFixed(2);
      this.TaxAmountNew = parseFloat(+parseFloat(this.TaxAmountNew) + parseFloat(item.TaxAmountPer)).toFixed(2);
      this.ServiceFeePerNew = parseFloat(+parseFloat(this.ServiceFeePerNew) + parseFloat(item.ServiceFeePer)).toFixed(2);

      this.ticketPriceNew = parseFloat(+parseFloat(this.ticketPriceNew) + parseFloat(item.Price)).toFixed(2);
      this.TotalPriceNew = parseFloat(+parseFloat(this.ticketPriceNew) + parseFloat(this.ServiceFeeNew)).toFixed(2);
    },
    DecrementSelected: function DecrementSelected(item, index2, index1) {
      if (this.priceTypeArray[index1]["PriceType"][index2]["Selected"] > 0) {
        this.priceTypeArray[index1]["PriceType"][index2]["Selected"]--;
        this.priceTypeArray[index1]["NoOfSeatSelected"]--;
        this.ServiceFeeNew = parseFloat(parseFloat(this.ServiceFeeNew) - parseFloat(item.ServiceFee)).toFixed(2);

        this.TaxAmountNew = parseFloat(parseFloat(this.TaxAmountNew) - parseFloat(item.TaxAmountPer)).toFixed(2);
        this.ServiceFeePerNew = parseFloat(parseFloat(this.ServiceFeePerNew) - parseFloat(item.ServiceFeePer)).toFixed(2);
        this.ticketPriceNew = parseFloat(parseFloat(this.ticketPriceNew) - parseFloat(item.Price)).toFixed(2);
        this.TotalPriceNew = parseFloat(this.TotalPriceNew - parseFloat(item.Price) - parseFloat(item.ServiceFee)).toFixed(2);
      }
    },
    filterListAll: function filterListAll(org, index2, index1) {
      this.filterListCinema[index1]["list"].map(function (x) {
        x["Show"] = false;
      });

      this.filterListCinema[index1]["list"][index2]["Show"] = true;
      this.closeFilter();

      this.fetchCinemasList();
    },
    showFilter: function showFilter(index) {
      if (this.checkSize != "" && this.filterListCinema[index]["Show"]) {
        this.filterListCinema[index]["Show"] = false;

        this.closeFilter();
        return false;
      }

      this.filterListCinema.map(function (x) {
        x["Show"] = false;
      });
      this.filterListCinema[index]["Show"] = true;
      if (screen.width > 992) {
        this.checkSize = "2";
      } else {
        this.checkSize = "1";
      }
      var element = document.getElementsByTagName("body")[0];

      element.classList.add("overflow-hidden");
    },
    closeFilter: function closeFilter() {
      this.checkSize = "";
      var element = document.getElementsByTagName("body")[0];
      element.classList.remove("overflow-hidden");
      this.filterListCinema.map(function (x) {
        x["Show"] = false;
      });
      this.selectedCinemaObject = {};
    },
    clearAllState: function clearAllState(index1) {
      this.filterListCinema[index1]["list"].map(function (x) {
        x["Show"] = false;
      });

      this.CityArray = [];
      this.loadingContent = true;
      this.closeFilter();
      this.fetchCinemasList();
    },
    FilterAllState: function FilterAllState(index1) {
      this.filterListCinema[index1]["list"].map(function (x) {
        x["Show"] = false;
      });
      this.loadingContent = true;
      this.closeFilter();
      this.fetchCinemasList();
    },
    CityList: function CityList(state, index2, index1) {
      this.filterListCinema[index1]["list"].map(function (x) {
        x["Show"] = false;
      });
      //  console.log( this.filterListCinema[index1]["list"][index2]["Show"],"sfdfsdfdsfdsf");
      this.filterListCinema[index1]["list"][index2]["Show"] = true;
      this.CityArray = state.CityList;
    },
    DistrictList: function DistrictList(city, index3, index1) {
      this.CityArray.map(function (x) {
        x["Show"] = false;
      });
      //  console.log( this.CityArray[index3]["Show"],"sfdfsdfdsfdsf");
      this.CityArray[index3]["Show"] = true;
      this.closeFilter();
      this.fetchCinemasList();
    },
    hideModal: function hideModal() {
      var _this3 = this;

      this.$refs.SeatRealeased.hide();
      this.collapse1 = true;
      this.collapse2 = false;
      this.collapse3 = false;
      this.collapse4 = false;
      this.$root.$emit("bv::toggle::collapse", "accordion1");
      this.onChangeCinema();
      this.GetCreateShowDetails();
      this.showTick1 = true;
      this.showTick2 = false;
      this.showTick3 = false, this.$root.$on("bv::collapse::state", function (collapseId, isJustShown) {
        if (collapseId === "accordion1" && isJustShown) {
          _this3.collapse1 = true;
          _this3.collapse2 = false;
          _this3.collapse3 = false;
          _this3.collapse4 = false;
        }
        if (collapseId === "accordion2" && isJustShown) {
          _this3.collapse1 = false;
          _this3.collapse2 = true;
          _this3.collapse3 = false;
          _this3.collapse4 = false;
        }
        if (collapseId === "accordion3" && isJustShown) {
          _this3.collapse1 = false;
          _this3.collapse2 = false;
          _this3.collapse3 = true;
          _this3.collapse4 = false;
        }
        if (collapseId === "accordion4" && isJustShown) {
          _this3.collapse1 = false;
          _this3.collapse2 = false;
          _this3.collapse3 = false;
          _this3.collapse4 = true;
        }
      });
      if (this.CinemaID == "" || this.CinemaID == null) {
        setTimeout(function () {
          VueScrollTo.scrollTo("#scrollToSection", "1000");
        }, 1000);
      }
      this.onResetSeatLayout();
      this.totalNumberOfSeats = 0;

      this.editNumberOfSeats(0);
      // if (this.ScreeningType != "Private Screening") {
      //   this.$root.$emit("bv::toggle::collapse", "accordion4");
      // }
    },

    onClickOk: function onClickOk() {
      this.count = 0;
      this.$refs.WheelChairModal.hide();
    },

    //Change function
    onChangeCinema: function onChangeCinema() {
      this.selectedCinemaObject = {};
      this.selectedTime = "";
      this.ShowTypes = {};
      this.ScreeningType = "";
      this.totalAmount = "";
      this.selectedSeats = [];
      this.CinemaTimeScheduleID = "";
      this.ScreenName = "";
      this.screen_id = "";
    },

    onChangeDateTime: function onChangeDateTime() {
      this.selectedTime = "";
      this.ShowTypes = {};
      this.ScreeningType = "";
      this.totalAmount = "";
      this.selectedSeats = [];
    },

    onChangeScreeningType: function onChangeScreeningType() {
      this.ScreeningType = "";
      this.totalAmount = "";
      this.selectedSeats = [];
    },

    onApplyPromocode: function onApplyPromocode() {
      var _this4 = this;

      var payload = {
        CouponCode: this.promocode,
        Total: this.totalAmount
      };
      Object(__WEBPACK_IMPORTED_MODULE_4__helper_internet_js__["makeRequest"])("/Payment/VerifyCoupon/", "POST", null, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        if (res.data.Status) {
          _this4.promocodeSuccesMessage = res.data.Message;
          _this4.promocodeErrorMessage = "";
          _this4.promoApplied = true;
          _this4.totalAmount = res.data.TicketValue;
          _this4.DiscountValue = res.data.DiscountValue;
        } else {
          _this4.promocodeErrorMessage = res.data.Message;
          _this4.promocodeSuccesMessage = "";
        }
      }).catch(function (error) {
        console.log("Error", error);
      });
    },
    searchData: function searchData() {
      var _this5 = this;

      this.selectedCinemaObject = {};
      this.CinemaList = this.CinemaListCopy;
      if (this.searchValue.length > 0) {
        this.CinemaList = this.CinemaList.filter(function (cinema) {
          var str = _this5.searchValue.toLowerCase();
          var cinemaName = cinema.cinema_name.toLowerCase();
          if (cinemaName.includes(str)) {
            return cinema;
          }
        });
      } else {
        this.CinemaList = this.CinemaListCopy;
      }
      // this.$refs.cinemaSlick.destroy();
      // this.$nextTick(() => {
      //   this.$refs.cinemaSlick.create();
      //   this.$refs.cinemaSlick.goTo(0, true);
      // });
    },
    onEdit: function onEdit() {
      // this.$root.$on("bv::collapse::state", (collapseId, isJustShown) => {
      //   console.log("collapseId:", collapseId);
      //   console.log("isJustShown:", isJustShown);
      //   if (collapseId == 4 && isJustShown) {

      //   }
      // });
      this.totalAmount = "";
      this.totalNumberOfSeats = 0;
      this.editNumberOfSeats(0);
    },
    fetchMovieDetails: function fetchMovieDetails() {
      var _this6 = this;

      var payload = {
        movie_id: this.MovieID,
        content_lang_id: this.content_lang_id,
        category_id: 1,
        cinema_id: this.cinema_id,
        md_for_ondemand: "Y",
        guest_user_id: null,
        cust_id: 1
      };
      __WEBPACK_IMPORTED_MODULE_13__services_mainService_js___default.a.GetMovieDetails(payload).then(function (response) {
        var data = response.data;

        if (data.status) {
          console.log("responseMovie", response);
          _this6.movieDetails = data.Records[0];
          var trailer = data.Records[0].trailer_array.filter(function (x) {
            return x.lang_id == 1;
          });
          var directors = data.Records[0].castCrewDetails.filter(function (z) {
            return z.crew_title.includes("Director");
          });
          var Actors = data.Records[0].castCrewDetails.filter(function (z) {
            return z.crew_title.includes("Actor");
          });
          console.log(Actors, directors);
          _this6.movieDetails["Actors"] = [];
          _this6.movieDetails["Directors"] = [];
          _this6.movieDetails["mrrdr_release_date_year"] = __WEBPACK_IMPORTED_MODULE_15_moment___default()(_this6.movieDetails.mrrdr_release_date).format("YYYY");
          if (directors.length > 0) {
            _this6.movieDetails["Directors"] = directors[0]["Crew"];
          }
          if (Actors.length > 0) {
            _this6.movieDetails["Actors"] = Actors[0]["Crew"];
          }

          if (trailer.length > 0) {
            _this6.movieDetails.original_trailer = trailer[0].mt_link;
          }
          _this6.hideLoading();
        }
      }).catch(function (err) {
        console.log("error", err);
      });
    },
    GetCreateShowDetails: function GetCreateShowDetails() {
      var _this7 = this;

      this.showLoading();
      var payload = {
        movie_id: this.MovieID,
        guest_user_id: localStorage.getItem("guest_user_id"),
        category_id: 1,
        cinema_id: this.cinema_id ? this.cinema_id : null,
        fromDate: this.fromDate ? this.fromDate : null
      };
      __WEBPACK_IMPORTED_MODULE_13__services_mainService_js___default.a.GetCreateShowDetails(payload).then(function (response) {
        var data = response.data;

        if (!_this7.fromDate) {
          _this7.ScheduleDetailAll = data;
          _this7.fetchCinemasList();
        } else {
          var NewShowTIme = data.MovieListArray.length > 0 ? data.MovieListArray[0].CinemaList.length > 0 ? data.MovieListArray[0].CinemaList[0].format_list : [] : [];
          _this7.ShowTimes = [];
          if (NewShowTIme.length > 0) {
            NewShowTIme.map(function (x) {
              x.screen_list.map(function (y) {
                y["version_name"] = x.version_name;
                _this7.ShowTimes.push(y);
              });
            });
          }
          console.log(_this7.ShowTimes, "fsddfdsf");
        }
        _this7.hideLoading();
      }).catch(function (err) {
        console.log("error", err);
      });
    },

    onSelectCinema: function onSelectCinema(cinemaObject) {
      this.selectedCinemaObject = cinemaObject;
      this.cinema_id = cinemaObject.cinema_id;
      this.selectedTime = "";
    },

    fetchShowDates: function fetchShowDates() {
      this.$root.$emit("bv::toggle::collapse", "accordion2");
      // this.showLoading();
      console.log(this.ScheduleDetailAll, "fsfsf");
      this.ShowDates = this.ScheduleDetailAll.dateList.filter(function (x) {
        return x.isDateAvailable == true;
      });

      this.date = this.ShowDates[0].dateShow;
      this.fromDate = this.ShowDates[0].dateShow;
      this.GetCreateShowDetails();
      __WEBPACK_IMPORTED_MODULE_12__main__["EventBus"].$emit("showDates", this.ShowDates);
      var parts = this.date.split("-"),
          year = parseInt(parts[0], 10),
          month = parseInt(parts[1], 10) - 1,
          // NB: month is zero-based!
      day = parseInt(parts[2], 10);
      var date1 = new Date(year, month, day);
      this.showDetails.day = this.days[date1.getDay()].substring(0, 3);
      this.showDetails.date = date1.getDate();
      this.showDetails.month = this.months[date1.getMonth()].substring(0, 3);
      this.showDetails.year = year;
      __WEBPACK_IMPORTED_MODULE_12__main__["EventBus"].$emit("showDate", this.date);

      // let payload = {
      //   MovieID: this.MovieID,
      //   CinemaID: this.selectedCinemaObject.CinemaID,
      //   CategoryID: this.CategoryID,
      //   Version: "1"
      // };

      // makeRequest("/GetShowDate/", "POST", null, payload)
      //   .then(response => {
      //     const { error, res } = response;
      //     if (res.data.Cinema.length > 0) {
      //       this.ShowDates = res.data.Cinema;
      //       this.date = this.ShowDates[0].SchTDate;

      //       EventBus.$emit("showDates", this.ShowDates);
      //       EventBus.$emit("showDate", this.date);
      //       this.showTick1 = true;
      //       this.fetchShowTimes(this.ShowDates[0].CinemaScheduleID);
      //       setTimeout(() => {
      //         VueScrollTo.scrollTo("#showDateTime");
      //       }, 500);
      //     } else {
      //       this.hideLoading();
      //       this.ShowTimes = [];
      //     }
      //   })
      //   .catch(error => {
      //     console.log("Error", error);
      //   });
    },
    filterDate: function filterDate(date) {
      var _this8 = this;

      this.ShowDates.filter(function (dates) {
        if (dates.SchTDate === date) {
          _this8.fetchShowTimes(dates.CinemaScheduleID);
          _this8.selectedTime = "";
        } else {
          _this8.ShowTimes = [];
        }
      });
    },
    fetchShowTimes: function fetchShowTimes(CinemaScheduleID) {
      var _this9 = this;

      var payload = {
        CategoryID: this.CategoryID,
        CinemaID: this.selectedCinemaObject.CinemaID,
        CinemaScheduleID: CinemaScheduleID,
        MovieID: this.MovieID,
        Version: "1"
      };
      Object(__WEBPACK_IMPORTED_MODULE_4__helper_internet_js__["makeRequest"])("/GetShowTime/", "POST", null, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        _this9.hideLoading();
        var _times = res.data.Cinema;

        if (res.data.hasOwnProperty("Version") && res.data.Version) {
          _this9.UniqueKey = res.data.Version;
          _this9.NewShowTimeArray = res.data.CinemaNewList;
          // for(show in this.NewShowTimeArray){
          _this9.NewShowTimeArray1 = [];
          // this.NewShowTimeArray1.push
          // }
          console.log(_this9.NewShowTimeArray);
          _this9.NewShowTimeArray.map(function (shows) {
            console.log("shows :", shows);
            shows.CinemaList.map(function (show) {
              show.Key = shows.Key;
              _this9.NewShowTimeArray1.push(show);
            });
          });
          console.log(_this9.NewShowTimeArray1);
        }
        _this9.NewShowTimeArray1 = _this9.NewShowTimeArray1.sort(function (a, b) {
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          console.log("b.ShowDate :", b.ShowDate, a.ShowDate, new Date(b.ShowDate) - new Date(a.ShowDate));
          return new Date(a.ShowDate) - new Date(b.ShowDate);
        });

        _times = _times.map(function (x) {
          x.CinemaTimings = tConvert(x.CinemaTimings);
          return x;
        });
        _this9.ShowTimes = _times;
        // this.ShowTimes = res.data.Cinema;
        _this9.ShowTimesV1 = _times;
        console.log("ShowTimesV1 :", _this9.ShowTimesV1);
        _this9.ShowTimes = __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.groupBy(_this9.ShowTimes, "Format");
      }).catch(function (error) {
        console.log("Error", error);
      });

      function tConvert(time) {
        // Check correct time format and split into components
        time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

        if (time.length > 1) {
          // If time format correct
          time = time.slice(1); // Remove full string match value
          time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
          time[0] = +time[0] % 12 || 12; // Adjust hours
        }
        return time.join(""); // return adjusted time or original string
      }
    },
    setCinemaTimeId: function setCinemaTimeId(mTime, LangFormat) {
      console.log(LangFormat);
      this.selectedTime = mTime.showTime;
      this.CinemaTimeScheduleID = mTime;
      // this.LangFormat = LangFormat;
      this.LangFormat = LangFormat;
      this.ScreenName = mTime.screen_name;
      this.screen_id = mTime.screen_id;
      var obj = {
        mrrdr_runtime: mTime.lengthMinutes,
        start_time: mTime.showTime,
        schedule_date: this.fromDate,
        cinema_ss_id: mTime.cinema_ss_id,
        guest_user_id: localStorage.getItem("guest_user_id")
      };
      console.log(obj);
      this.createSchedulePayload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, obj);
      console.log(this.createSchedulePayload, obj);
    },
    fetchShowTypes: function fetchShowTypes() {
      var _this10 = this;

      this.loadingShowType = true;
      var payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.createSchedulePayload);
      __WEBPACK_IMPORTED_MODULE_13__services_mainService_js___default.a.ReserveShowsMyCinema(payload).then(function (resNew) {
        console.log(resNew);
        if (resNew.data.status) {
          _this10.createSchedulePayload["mycinema_ss_d_id"] = resNew.data.mycinema_ss_d_id;
          var payloadNew = { mycinema_ss_d_id: resNew.data.mycinema_ss_d_id };
          __WEBPACK_IMPORTED_MODULE_13__services_mainService_js___default.a.GetScreeningType(payloadNew).then(function (resBookingType) {
            if (resBookingType.data.status) {
              _this10.ShowTypes = resBookingType.data.Records;

              // console.log(resBookingType.data.Records, "resBookingType.data.Records >>>>>>>>>>>>>>>")
              // console.log(this.ShowTypes, "this.ShowTypes >>>>>>>>>>>>>>>")
              _this10.showTick2 = true;
              setTimeout(function () {
                VueScrollTo.scrollTo("#showScreening");
              }, 500);
            }

            _this10.loadingShowType = false;
          }).catch(function (err) {
            _this10.loadingShowType = false;
            _this10.showMessage = "Something Went Wrong";
            _this10.$refs.SeatRealeased.show();
          });
        } else {
          _this10.loadingShowType = false;
          _this10.showMessage = resNew.data.message;
          _this10.$refs.SeatRealeased.show();
        }
      }).catch(function (err) {
        _this10.loadingShowType = false;
        _this10.showMessage = "Something Went Wrong";
        _this10.$refs.SeatRealeased.show();
      });

      // makeRequest("/GetShowType/", "POST", null, payload)
      //   .then(response => {
      //     const { error, res } = response;
      //     this.ShowTypes = res.data.ShowType;
      //     delete this.ShowTypes["Public_N"];
      //     this.showTick2 = true;
      //     setTimeout(() => {
      //       VueScrollTo.scrollTo("#showScreening");
      //     }, 500);
      //     this.loadingShowType = false;
      //   })
      //   .catch(error => {
      //     console.log("Error", error);
      //   });
    },
    getSeatLayout: function getSeatLayout(seatType) {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var ShowType, reservation_id, payloadPrivate;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log(seatType);
                _this11.onResetSeatLayout();
                _this11.loaderSeatLayout = true;
                _this11.totalNumberOfSeats = 0;
                _this11.selectedSeats = [];
                _this11.showTick3 = true;

                ShowType = "";

                _this11.createSchedulePayload["booking_type_id"] = seatType.booking_type_id;

                if (!(seatType.booking_type_id == "3")) {
                  _context2.next = 16;
                  break;
                }

                _this11.showLoading();
                reservation_id = Math.floor(100000000 + Math.random() * 900000000);
                payloadPrivate = {
                  groupRateCard: true,
                  seat_layout_id: [],
                  schedule_show_id: 0,
                  cinema_reservation_id: reservation_id,
                  isVipOrBlockSeats: false,
                  cinema_id: _this11.cinema_id,
                  screen_id: _this11.screen_id,
                  mycinema_ss_d_id: _this11.createSchedulePayload.mycinema_ss_d_id,
                  mycinema_booking_type_id: 3,
                  newSeatLayout: [],
                  seat_type_id: [],
                  specialRequest: ""
                };

                console.log(payloadPrivate);
                __WEBPACK_IMPORTED_MODULE_13__services_mainService_js___default.a.ReserveSeatsCreateShow(payloadPrivate).then(function (responsePrivate) {
                  if (responsePrivate.data.status) {
                    _this11.hideLoading();
                    _this11.$router.push({
                      path: "/payment/" + reservation_id + "/2"
                    });
                  } else {
                    _this11.showMessage = responsePrivate.data.message;
                    _this11.$refs.SeatRealeased.show();
                    _this11.hideLoading();
                  }
                }).catch(function (err) {
                  _this11.showMessage = "Something Went Wrong";
                  _this11.$refs.SeatRealeased.show();
                  _this11.hideLoading();
                });
                _context2.next = 29;
                break;

              case 16:
                setTimeout(function () {
                  VueScrollTo.scrollTo("#seatScreen");
                }, 500);
                _this11.ScreeningType = seatType.screening_name;
                _this11.secureStore.set("SCRTN", _this11.ScreeningType);
                _this11.secureStore.set("SCRT", "Public");
                ShowType = "Public";
                _this11.loaderSeatLayout = false;
                _this11.totalNumberOfSeats = seatType.booking_type_id == "1" ? seatType.min_seats : 0;
                if (_this11.totalNumberOfSeats > 0) {
                  _this11.editNumberOfSeats(_this11.totalNumberOfSeats);
                }
                console.log("Waiting", _this11.createSchedulePayload["mycinema_ss_d_id"], _this11.totalNumberOfSeats);
                _context2.next = 27;
                return _this11.getSeats({
                  mycinema_ss_d_id: _this11.createSchedulePayload["mycinema_ss_d_id"]
                });

              case 27:
                console.log("get Seat Layout Occurs", _this11.seatType);

                if (_this11.seatType.length == 0) {
                  _this11.showMessage = "Sorry, your show is already reserved.";
                  _this11.$refs.SeatRealeased.show();
                }

              case 29:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this11);
      }))();
    },
    getSeatLayoutOld: function getSeatLayoutOld(seatType) {
      var _this12 = this;

      this.loaderSeatLayout = true;
      this.totalNumberOfSeats = 0;
      this.selectedSeats = [];
      this.showTick3 = true;

      var ShowType = "";
      if (seatType.title == "Private Screening") {
        this.ScreeningType = seatType.title;
        this.secureStore.set("SCRTN", this.ScreeningType);
        this.secureStore.set("SCRT", "Private");
        ShowType = "Private";
        this.selectedSeats = new Array(100);
        this.Currency = seatType.CurrencyType;
        this.totalAmount = seatType.TotalSeatPrice;
        this.ticketPrice = seatType.Price;
        this.ServiceFee = seatType.ServiceFee;
        // this.showModalPrice=false;

        // this.totalAmount =
        this.setBookingSeats();
      } else if (seatType.title1 == "Crowdsourced Screening") {
        setTimeout(function () {
          VueScrollTo.scrollTo("#seatScreen");
        }, 500);
        this.ScreeningType = seatType.title1;
        this.secureStore.set("SCRTN", this.ScreeningType);
        this.secureStore.set("SCRT", "Public");
        ShowType = "Public";
        var payload = {
          CinemaScheduleID: this.CinemaTimeScheduleID,
          CategoryID: this.CategoryID,
          ShowType: ShowType
        };
        Object(__WEBPACK_IMPORTED_MODULE_4__helper_internet_js__["makeRequest"])("/GetSeatLayout/", "POST", null, payload).then(function (response) {
          console.log(_this12.newSeatLayout);

          var error = response.error,
              res = response.res;

          _this12.priceTypeArray = res.data.SeatTypes;
          // this.seatLayout = res.data.SeatLayouts;
          _this12.seatTypes = res.data.SeatTypes;
          _this12.row = res.data.Row;
          _this12.column = res.data.Column;
          _this12.Currency = res.data.Currency;
          // this.newSeatLayout.push(_.chunk(this.seatLayout[0].Seats,this.column ))
          // this.newSeatLayout.push(_.chunk(this.seatLayout[1].Seats,this.column ))
          // this.newSeatLayout = this.seatLayout.map(singleLayout => {
          //   return _.chunk(singleLayout.Seats, this.column);
          // });
          // this.newSeatLayout.map(seatType => {
          //   seatType.map(seatRow => {
          //     seatRow.map(seat => {
          //       seat.SelectStatusFlag = false;
          //       seat.SelectStatus = false;
          //     });
          //   });
          // });
          ///////////////something
          var seatArray = res.data.SeatLayouts;
          if (seatArray[0].Seats) {
            seatArray.map(function (x) {
              x.Seats.map(function (y) {
                y.SelectStatus = false;
                y.SelectStatusFlag = false;
                return y;
              });
              x.Seats = __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.chunk(x.Seats, _this12.column);
              x.SeatClass = _this12.seatTypes;
              return x;
            });
          }
          _this12.seatLayout = seatArray;
          _this12.loaderSeatLayout = false;
        }).catch(function (error) {
          console.log("Error", error);
        });
      } else if (seatType.title1 == "Confirmed Screening") {
        setTimeout(function () {
          VueScrollTo.scrollTo("#seatScreen");
        }, 500);
        this.totalNumberOfSeats = seatType.MinSeats;
        this.ScreeningType = seatType.title1;
        console.log(ScreeningType, "ScreeningType >>>>>>>>>>>>>>>>>>");
        this.secureStore.set("SCRTN", this.ScreeningType);
        this.secureStore.set("SCRT", "Public");
        ShowType = "Public";
        var _payload = {
          CinemaScheduleID: this.CinemaTimeScheduleID,
          CategoryID: this.CategoryID,
          ShowType: ShowType
        };
        Object(__WEBPACK_IMPORTED_MODULE_4__helper_internet_js__["makeRequest"])("/GetSeatLayout/", "POST", null, _payload).then(function (response) {
          console.log(_this12.newSeatLayout);
          var error = response.error,
              res = response.res;
          // this.seatLayout = res.data.SeatLayouts;

          _this12.priceTypeArray = res.data.SeatTypes;
          _this12.seatTypes = res.data.SeatTypes;
          _this12.row = res.data.Row;
          _this12.column = res.data.Column;
          _this12.Currency = res.data.Currency;
          // this.newSeatLayout.push(_.chunk(this.seatLayout[0].Seats,this.column ))
          // this.newSeatLayout.push(_.chunk(this.seatLayout[1].Seats,this.column ))
          // this.newSeatLayout = this.seatLayout.map(singleLayout => {
          //   return _.chunk(singleLayout.Seats, this.column);
          // });
          // this.newSeatLayout.map(seatType => {
          //   seatType.map(seatRow => {
          //     seatRow.map(seat => {
          //       seat.SelectStatusFlag = false;
          //       seat.SelectStatus = false;
          //     });
          //   });
          // });
          ///////////////something
          var seatArray = res.data.SeatLayouts;
          if (seatArray[0].Seats) {
            seatArray.map(function (x) {
              x.Seats.map(function (y) {
                y.SelectStatus = false;
                y.SelectStatusFlag = false;
                return y;
              });
              x.Seats = __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.chunk(x.Seats, _this12.column);
              x.SeatClass = _this12.seatTypes;
              return x;
            });
          }
          _this12.seatLayout = seatArray;
          _this12.loaderSeatLayout = false;
        }).catch(function (error) {
          console.log("Error", error);
        });
      }
    },

    editNumberOfSeats: function editNumberOfSeats(number) {
      var _this13 = this;

      this.SelectNumberOfSeats(number);
      this.totalNumberOfSeats = number;
      //deselect all
      this.selectedSeats.map(function (x, index) {
        _this13.seatLayout[x.mainIndex].Seats[x.rowIndex][x.seatIndex].SelectStatus = false;
        _this13.seatLayout[x.mainIndex].Seats[x.rowIndex][x.seatIndex].SelectStatusFlag = false;
      });
      this.selectedSeats = [];
    },
    handlerSeatSelected: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(seat, rowIndex, seatIndex, originalIndex, backward, e, type) {
        var payload;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(seat.seat_reserve_type_id == 9)) {
                  _context3.next = 3;
                  break;
                }

                this.$toasted.show($t("Sorry! These seats can be booked from Box Office only"));
                return _context3.abrupt("return");

              case 3:
                payload = {
                  seat: seat,
                  rowIndex: rowIndex,
                  seatIndex: seatIndex,
                  originalIndex: originalIndex,
                  backward: backward,
                  e: e,
                  type: type
                };

                console.log("seat payload", payload);
                _context3.next = 7;
                return this.seatHandler(payload);

              case 7:
                if (seat.srt_id == 3 && seat.selectStatus) {
                  this.$refs.WheelChairModal.show();
                }

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function handlerSeatSelected(_x, _x2, _x3, _x4, _x5, _x6, _x7) {
        return _ref2.apply(this, arguments);
      }

      return handlerSeatSelected;
    }(),
    seatsSelectedRateGroup: function seatsSelectedRateGroup() {
      var _this14 = this;

      var array = [];
      if (this.checkPopupExist == false) {
        this.totalSeatBooked = 0;
        this.totalAmountPrice = 0;
        this.totalNetAmout = 0;
        var checkCheckoutRateCardNeeded = 0;
        if (this.$store.getters.SELECTED_SEATS.length > 0) {
          this.$store.getters.SELECTED_SEATS.map(function (x) {
            var find_In = array.findIndex(function (new1) {
              return new1.sst_id == x.sst_id;
            });
            if (find_In >= 0) {
              array[find_In]["AllSeats"].push(x);
              if (array[find_In]["rate_card_group"].length == 1) {
                array[find_In]["totalSelected"] = array[find_In]["totalSelected"] + 1;
                array[find_In]["rate_card_group"][0].totalSeatSelected = array[find_In]["rate_card_group"][0].totalSeatSelected + 1;
                // console.log(x.rc_total_amount, "test");
                _this14.totalAmountPrice = parseFloat(_this14.totalAmountPrice) + parseFloat(array[find_In]["rate_card_group"][0].rc_total_amount);
                _this14.totalNetAmout = parseFloat(_this14.totalNetAmout) + parseFloat(array[find_In]["rate_card_group"][0].rc_net_amount);
                _this14.totalSeatBooked = _this14.totalSeatBooked + 1;
              } else if (array[find_In]["rate_card_group"].length > 1) {
                checkCheckoutRateCardNeeded = checkCheckoutRateCardNeeded + 1;
              }
            } else {
              var arrayCardGroup = [];
              x.rate_card_group.map(function (rg) {
                rg["totalSeatSelected"] = 0;
                arrayCardGroup.push(rg);
              });
              console.log(x, "Seats");
              var obj = {
                srt_name: x.sst_seat_type,
                sst_id: x.sst_id,
                AllSeats: [x],
                totalSelected: 0,
                rate_card_group: arrayCardGroup
              };
              if (arrayCardGroup.length == 1) {
                obj["totalSelected"] = 1;
                obj["rate_card_group"][0].totalSeatSelected = 1;
                _this14.totalAmountPrice = parseFloat(_this14.totalAmountPrice) + parseFloat(obj["rate_card_group"][0].rc_total_amount);
                _this14.totalNetAmout = parseFloat(_this14.totalNetAmout) + parseFloat(obj["rate_card_group"][0].rc_net_amount);
                _this14.totalSeatBooked = _this14.totalSeatBooked + 1;
              } else if (arrayCardGroup.length > 1) {
                checkCheckoutRateCardNeeded = checkCheckoutRateCardNeeded + 1;
              }

              array.push(obj);
            }
          });
          this.seatsSelectedRateGroupNew = array;

          if (checkCheckoutRateCardNeeded == 0 && array[0]["rate_card_group"].length > 0) {
            console.log("Group Card Not Needed");
            this.$store.dispatch("onSetCompleteRateCard", {
              status: true,
              seatGroup: __WEBPACK_IMPORTED_MODULE_14_lodash_cloneDeep___default()(this.seatsSelectedRateGroupNew)
            });
            this.$store.dispatch("onSetCompleteNewTotalAmount", {
              totalAmount: this.totalAmountPrice,
              netAmount: this.totalNetAmout
            });
          } else if (checkCheckoutRateCardNeeded > 0) {
            this.$store.dispatch("onSetCompleteRateCard", {
              status: false,
              seatGroup: __WEBPACK_IMPORTED_MODULE_14_lodash_cloneDeep___default()(this.seatsSelectedRateGroupNew)
            });
          }

          console.log("seats organized into rcg", array);
          return array;
        } else {
          this.seatsSelectedRateGroupNew = [];
          return array;
        }
      } else {
        return this.seatsSelectedRateGroupNew;
      }
    },

    setBookingSeats: function setBookingSeats() {
      if (this.totalSeatBooked == this.$store.getters.SELECTED_SEATS.length) {
        // this.errorMessage=`Please Select All Seats`
        this.onSubmitFromRateCardModal();
      } else {
        this.$refs.showRateCard.show();
      }
    },
    onSubmitFromRateCardModal: function onSubmitFromRateCardModal() {
      if (!(this.totalSeatBooked == this.$store.getters.SELECTED_SEATS.length)) {
        // this.errorMessage=`Please Select All Seats`
        return false;
      }
      // let totalSelectedSeats = this.seatsSelectedRateGroupNew.reduce(
      //   ratecardGroup => ratecardGroup.totalSelected
      // );
      // console.log("onSubmitFromRateCardModal", totalSelectedSeats);
      // if (totalSelectedSeats === this.$store.getters.SELECTED_SEATS.length) {
      //   this.reserveSeats();
      // } else {
      //   this.$toasted.show("select prices for all tickets");
      // }

      this.$store.dispatch("onSetCompleteRateCard", {
        status: true,
        seatGroup: this.seatsSelectedRateGroupNew
      });
      this.$store.dispatch("onSetCompleteNewTotalAmount", {
        totalAmount: this.totalAmountPrice,
        netAmount: this.totalNetAmout
      });
      this.reserveSeats();
      this.$refs.showRateCard.hide();
    },
    reserveSeats: function reserveSeats() {
      var _this15 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var reservation_id;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this15.showLoading();
                reservation_id = Math.floor(100000000 + Math.random() * 900000000);
                _context4.next = 4;
                return _this15.$store.dispatch("RESERVE_SEATS_CREATE_SHOW", {
                  seat_layout_id: _this15.$store.getters.seatsSelected,

                  cinema_reservation_id: reservation_id,
                  aggregator_cinema: _this15.movieDetails.cine_id,
                  cinema_id: _this15.cinema_id,
                  seatGroup: _this15.seatsSelectedRateGroupNew,
                  mycinema_booking_type_id: _this15.createSchedulePayload.booking_type_id,
                  specialRequest: "",
                  mycinema_ss_d_id: _this15.createSchedulePayload.mycinema_ss_d_id
                });

              case 4:

                // const { ss_id } = this.$route.params;
                if (_this15.$store.getters.seatsSelected.length > 0) {
                  _this15.hideLoading();
                  // await this.getAdditionalCharges({
                  //   movieDetails: this.schedule_details_obj,
                  //   selected_seats: this.seatsSelected,
                  //   showDetails: this.schedule_details_obj
                  // });
                  _this15.$router.push({
                    path: "/payment/" + reservation_id + "/2"
                  });
                } else {
                  _this15.$refs.showRateCard.hide();
                  _this15.showMessage = "Sorry, those seats have already been reserved. Please choose new seats.";
                  _this15.$refs.SeatRealeased.show();
                  _this15.hideLoading();
                }

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this15);
      }))();
    },


    checkForWheelChair: function checkForWheelChair() {
      var _this16 = this;

      var popUpStatus = 0;
      var self = this;
      this.selectedSeats.map(function (x, index) {
        if (x.Status == 3 && popUpStatus == 0) {
          //TODO showpopup
          // alert("test");
          _this16.$refs.WheelChairModal.show();
          // this.count = 0;
          popUpStatus = 1;
          self.count = 0;
        }
      });
    }
  })
});

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_calendar_vue__ = __webpack_require__(635);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e14f041_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_calendar_vue__ = __webpack_require__(1265);
function injectStyle (ssrContext) {
  __webpack_require__(1264)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2e14f041"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_calendar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e14f041_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_calendar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var DAY_LABELS = ["S", "M", "T", "W", "Th", "F", "S"];
var MONTH_LABELS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "calendar",

  data: function data() {
    return {
      today: null,
      selectedDate: null,
      currDateCursor: null,
      dayLabels: null,
      showDates: []
    };
  },
  created: function created() {
    this.dayLabels = DAY_LABELS.slice();
    this.today = new Date();
    this.selectedDate = this.today;
    this.currDateCursor = this.today;
  },

  props: {
    startDate: {
      required: false,
      type: Date
    }
  },
  computed: {
    currentMonth: function currentMonth() {
      return this.currDateCursor.getMonth();
    },
    currentYear: function currentYear() {
      return this.currDateCursor.getFullYear();
    },
    currentMonthLabel: function currentMonthLabel() {
      return MONTH_LABELS[this.currentMonth];
    },
    daysArray: function daysArray() {
      var _this = this;

      var date = this.currDateCursor;
      var startOfMonth = dateFns.startOfMonth(date);
      var endOfMonth = dateFns.endOfMonth(date);
      //const days = dateFns.eachDay(startOfMonth, endOfMonth);

      var days = dateFns.eachDay(startOfMonth, endOfMonth).map(function (day) {
        return {
          date: day,
          newDate: dateFns.format(day, "YYYY-MM-DD"),
          isCurrentMonth: dateFns.isSameMonth(new Date(_this.currentYear, _this.currentMonth), day),
          isToday: dateFns.isToday(day),
          isSelected: dateFns.isSameDay(_this.selectedDate, day)
        };
      });

      // gen the days from last month
      var previousMonthCursor = dateFns.lastDayOfMonth(dateFns.addMonths(date, -1));
      var begIndex = dateFns.getDay(days[0].date);
      for (var i = begIndex; i > 0; i--) {
        days.unshift({
          date: previousMonthCursor,
          newDate: dateFns.format(previousMonthCursor, "YYYY-MM-DD"),
          isCurrentMonth: false,
          isToday: dateFns.isToday(previousMonthCursor),
          isSelected: dateFns.isSameDay(this.selectedDate, previousMonthCursor)
        });
        previousMonthCursor = dateFns.addDays(previousMonthCursor, -1);
      }

      // gen days for next month
      var daysNeededAtEnd = days.length % 7 > 0 ? 7 - days.length % 7 : 0;
      var nextMonthCursor = dateFns.addMonths(date, 1);
      nextMonthCursor = dateFns.setDate(nextMonthCursor, 1);
      for (var x = 1; x <= daysNeededAtEnd; x++) {
        days.push({
          date: nextMonthCursor,
          newDate: dateFns.format(nextMonthCursor, "YYYY-MM-DD"),
          isCurrentMonth: false,
          isToday: dateFns.isToday(nextMonthCursor),
          isSelected: dateFns.isSameDay(this.selectedDate, nextMonthCursor)
        });
        nextMonthCursor = dateFns.addDays(nextMonthCursor, 1);
      }
      return days;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_0__main__["EventBus"].$on("showDate", function (showDate) {
      var dateString = showDate.replace(/-/g, "");
      var year = dateString.substring(0, 4);
      var month = dateString.substring(4, 6);
      var day = dateString.substring(6, 8);

      var date = new Date(year, month - 1, day);
      _this2.currDateCursor = date;
      _this2.selectedDate = date;
    });

    __WEBPACK_IMPORTED_MODULE_0__main__["EventBus"].$on("showDates", function (showDates) {
      showDates.map(function (singleDate) {
        _this2.showDates.push(singleDate.dateShow);
      });
    });
    console.log("this.showDates :", this.showDates);
  },

  methods: {
    dayClassObj: function dayClassObj(day) {
      return {
        today: day.isToday,
        current: day.isCurrentMonth,
        selected: day.isSelected
      };
    },
    nextMonth: function nextMonth() {
      this.currDateCursor = dateFns.addMonths(this.currDateCursor, 1);
    },
    previousMonth: function previousMonth() {
      this.currDateCursor = dateFns.addMonths(this.currDateCursor, -1);
    },
    setSelectedDate: function setSelectedDate(day) {
      this.selectedDate = day.date;
      // console.log("this.selectedDate :", this.selectedDate);
      __WEBPACK_IMPORTED_MODULE_0__main__["EventBus"].$emit("currentDate", this.selectedDate);
      this.$emit("input", this.selectedDate);
    }
  },
  filters: {
    formatDateToDay: function formatDateToDay(val) {
      return dateFns.format(val, "D");
    }
  }
});
// });

/***/ }),
/* 636 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(1276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_slick__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_internet_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__helper_internet_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_partials_OwnScreeningSlider_vue__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




//   import NowShowing from "@/components/partials/nowShowingSlider.vue";
//   import SpecialScreenings from "@/components/partials/SpecialScreeningsSlider.vue";

//   import UpcomingFestivals from "@/components/partials/UpcomingMiniFestivals.vue";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "home",
  directives: {
    // 'dragscroll': dragscroll
  },
  components: {
    Slick: __WEBPACK_IMPORTED_MODULE_2_vue_slick__["default"],
    OwnScreening: __WEBPACK_IMPORTED_MODULE_5__components_partials_OwnScreeningSlider_vue__["a" /* default */]
  },

  data: function data() {
    var _dateTimeSlider;

    return {
      dateTimeSlider: (_dateTimeSlider = {
        dots: false,
        infinite: false,
        speed: 300,
        arrows: false,
        slidesToShow: 9,
        slidesToScroll: 6
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_dateTimeSlider, "dots", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_dateTimeSlider, "responsive", [{
        breakpoint: 1900,
        settings: {
          slidesToShow: 7,
          slidesToScroll: 4,
          infinite: true,
          dots: false
        }
      }, {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3.1,
          slidesToScroll: 3,
          infinite: true,
          dots: false
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 480,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2
        }
      }]), _dateTimeSlider),
      days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      movieDetails: {},
      selectedDate: "",
      MovieID: "",
      CategoryID: "",
      CinemaList: [],
      ShowDates: [],
      selectedCinemaObject: {},
      ShowTimes: [],
      ShowTimesCopy: [],
      selectedTime: "",
      CinemaTimeScheduleID: "",
      selectedShowType: "All",
      content_lang_id: null
    };
  },
  beforeMount: function beforeMount() {
    this.MovieID = this.$route.params.movie_id;
    this.content_lang_id = this.$route.params.content_lang_id;
    this.fetchMovieDetails();
    // this.fetchCinemasList();
    this.showLoading();
  },

  watch: {
    $route: function $route(to, from) {
      this.MovieID = this.$route.params.movie_id;
      this.content_lang_id = this.$route.params.content_lang_id;
      this.fetchMovieDetails();
      // this.fetchCinemasList();
    }
  },
  methods: {
    fetchMovieDetails: function fetchMovieDetails() {
      var _this = this;

      var payload = {
        movie_id: this.MovieID,
        content_lang_id: this.content_lang_id,
        category_id: 1,
        cinema_id: this.cinema_id,
        md_for_ondemand: "Y",
        guest_user_id: null,
        cust_id: 1
      };
      MainServices.GetMovieDetails(payload).then(function (response) {
        var data = response.data;

        if (data.status) {
          console.log("response", response);
          _this.movieDetails = data.Records;
        }
      });
      Object(__WEBPACK_IMPORTED_MODULE_3__helper_internet_js__["makeRequest"])("/GetMovieDetails/", "POST", null, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        _this.movieDetails = res.data;
        _this.movieDetails.Trailer = _this.movieDetails.Trailers[0].URI;
      }).catch(function (error) {
        console.log("Error", error);
      });
    },

    fetchCinemasList: function fetchCinemasList() {
      var _this2 = this;

      var payload = {
        MovieID: this.MovieID
      };
      Object(__WEBPACK_IMPORTED_MODULE_3__helper_internet_js__["makeRequest"])("/GetCinemaList/", "POST", null, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        _this2.CinemaList = res.data.Cinema;
        _this2.selectedCinemaObject = _this2.CinemaList[0];
        _this2.CinemaList.map(function (cinema) {
          _this2.fetchShowDates(cinema);
        });
      }).catch(function (error) {
        console.log("Error", error);
      });
    },
    fetchShowDates: function fetchShowDates(cinema) {
      var _this3 = this;

      var payload = {
        MovieID: this.MovieID,
        CinemaID: cinema.CinemaID,
        CategoryID: this.CategoryID
      };
      Object(__WEBPACK_IMPORTED_MODULE_3__helper_internet_js__["makeRequest"])("/GetShowDate/", "POST", null, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        _this3.ShowDates = res.data.Cinema;
        _this3.selectedDate = _this3.ShowDates[0];
        _this3.fetchShowTimes(_this3.ShowDates[0].CinemaScheduleID);
        _this3.ShowDates.map(function (date) {
          var parts = date.SchTDate.split("-"),
              year = parseInt(parts[0], 10),
              month = parseInt(parts[1], 10) - 1,
              // NB: month is zero-based!
          day = parseInt(parts[2], 10);
          var date1 = new Date(year, month, day);
          date.day = _this3.days[date1.getDay()].substring(0, 3);
          date.date = date1.getDate();
          date.year = year;
          date.month = _this3.months[date1.getMonth()].substring(0, 3);
        });
        _this3.$refs.dateSlider.destroy();
        _this3.$nextTick(function () {
          _this3.$refs.dateSlider.create();
          _this3.$refs.dateSlider.goTo(1, true);
        });
      }).catch(function (error) {
        console.log("Error", error);
      });
    },
    fetchShowTimes: function fetchShowTimes(CinemaScheduleID) {
      var _this4 = this;

      var payload = {
        CategoryID: this.CategoryID,
        CinemaID: this.selectedCinemaObject.CinemaID,
        CinemaScheduleID: CinemaScheduleID,
        MovieID: this.MovieID
      };
      Object(__WEBPACK_IMPORTED_MODULE_3__helper_internet_js__["makeRequest"])("/GetShowTime/", "POST", null, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        _this4.hideLoading();

        var _times = res.data.Cinema;
        _times = _times.map(function (x) {
          x.CinemaTimings = tConvert(x.CinemaTimings);
          return x;
        });
        _this4.ShowTimes = _times;
        _this4.ShowTimes = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.groupBy(_this4.ShowTimes, "Format");
        _this4.ShowTimesCopy = _times;
        _this4.ShowTimesCopy = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.groupBy(_this4.ShowTimesCopy, "Format");
      }).catch(function (error) {
        console.log("Error", error);
      });
      function tConvert(time) {
        // Check correct time format and split into components
        time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

        if (time.length > 1) {
          // If time format correct
          time = time.slice(1); // Remove full string match value
          time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
          time[0] = +time[0] % 12 || 12; // Adjust hours
        }
        return time.join(""); // return adjusted time or original string
      }
    },
    onSelectDate: function onSelectDate(date) {
      this.selectedDate = date;
      this.fetchShowTimes(date.CinemaScheduleID);
      this.onSelectShowType("All");
    },
    setCinemaTimeId: function setCinemaTimeId(mTime) {
      this.selectedTime = mTime.CinemaTimings;
      this.CinemaTimeScheduleID = mTime.CinemaScheduleID;
      var showDetails = {
        CinemaName: this.selectedCinemaObject.CinemaName,
        CinemaAddress: this.selectedCinemaObject.Address,
        ShowDateTime: this.selectedDate.month + " " + this.selectedDate.date + ", " + this.selectedDate.year + " | " + this.selectedTime
      };
      this.secureStore.set("STD", showDetails);
    },
    onSelectShowType: function onSelectShowType(showTimingsRange) {
      var _this5 = this;

      var obj = {};
      this.ShowTimes = this.ShowTimesCopy;
      this.selectedShowType = showTimingsRange;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.ShowTimes).map(function (singleShow, index) {
        var array = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.filter(singleShow, function (time) {
          var timing = parseInt(time.CinemaTimings.split(":")[0]);
          if (time.CinemaTimings.slice(-2) == "PM") {
            timing = timing + 12;
          }
          if (showTimingsRange == "Morning") {
            if (timing < 12) {
              return singleShow;
            }
          } else if (showTimingsRange == "Afternoon") {
            if (timing < 18 && timing >= 12) {
              return singleShow;
            }
          } else if (showTimingsRange == "Evening") {
            if (timing >= 18) {
              return singleShow;
            }
          } else if (showTimingsRange == "All") {
            return singleShow;
          }
        });
        if (showTimingsRange == "All") {
          _this5.ShowTimes = _this5.ShowTimesCopy;
        } else {
          obj["name"] = array;
          _this5.ShowTimes = obj;
        }
      });
    }
  }
});

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slick__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_partials_nowShowingSlider_vue__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_partials_OwnScreeningSlider_vue__ = __webpack_require__(149);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




//   import SpecialScreenings from "@/components/partials/SpecialScreeningsSlider.vue";

//   import UpcomingFestivals from "@/components/partials/UpcomingMiniFestivals.vue";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'searchResult',
  directives: {
    // 'dragscroll': dragscroll
  },
  components: {
    Slick: __WEBPACK_IMPORTED_MODULE_1_vue_slick__["default"],
    OwnScreening: __WEBPACK_IMPORTED_MODULE_3__components_partials_OwnScreeningSlider_vue__["a" /* default */],
    NowShowing: __WEBPACK_IMPORTED_MODULE_2__components_partials_nowShowingSlider_vue__["a" /* default */]
  },

  data: function data() {
    var _dateTimeSlider, _movieSlider;

    return {
      dateTimeSlider: (_dateTimeSlider = {
        dots: false,
        infinite: false,
        speed: 300,
        arrows: false,
        slidesToShow: 9,
        slidesToScroll: 6
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_dateTimeSlider, "dots", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_dateTimeSlider, "responsive", [{
        breakpoint: 1900,
        settings: {
          slidesToShow: 7,
          slidesToScroll: 4,
          infinite: true,
          dots: false
        }
      }, {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3.1,
          slidesToScroll: 3,
          infinite: true,
          dots: false
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 480,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2
        }
      }]), _dateTimeSlider),
      movieSlider: (_movieSlider = {
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 5.5,
        slidesToScroll: 4
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_movieSlider, "dots", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_movieSlider, "responsive", [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 3.5,
          slidesToScroll: 3,
          infinite: true,
          dots: false
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }]), _movieSlider)
    };
  }
});

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/movieposter1.e6d60bb.jpg";

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slick__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_internet_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__helper_internet_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_storage_service__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_storage_service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__services_storage_service__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_mainService_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_mainService_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__services_mainService_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helper_constants__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helper_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__helper_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_partials_OwnScreeningSlider_vue__ = __webpack_require__(149);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








//   import NowShowing from "@/components/partials/nowShowingSlider.vue";
//   import SpecialScreenings from "@/components/partials/SpecialScreeningsSlider.vue";

//   import UpcomingFestivals from "@/components/partials/UpcomingMiniFestivals.vue";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "createScreen",
  directives: {
    // 'dragscroll': dragscroll
  },
  components: {
    Slick: __WEBPACK_IMPORTED_MODULE_1_vue_slick__["default"],
    OwnScreening: __WEBPACK_IMPORTED_MODULE_7__components_partials_OwnScreeningSlider_vue__["a" /* default */]
  },
  computed: {
    Actors: function Actors() {
      var TempArray = [];
      this.movieDetails.Actors.map(function (x) {
        TempArray.push(x.mcc_cast_name);
      });
      return TempArray.join(", ");
    },
    Directors: function Directors() {
      var TempArray = [];
      this.movieDetails.Directors.map(function (x) {
        TempArray.push(x.mcc_cast_name);
      });
      return TempArray.join(", ");
    },
    checkFilterExist: function checkFilterExist() {
      var obj = false;
      this.showFilter.map(function (x) {
        x.all_filter.map(function (y) {
          if (y.isActiveFilter == "1") {
            obj = true;
          }
        });
      });
      return obj;
    }
  },

  data: function data() {
    var _dateTimeSlider;

    return {
      showFilter: [],
      poster: "",
      checkAmPm: true,
      dateTimeSlider: (_dateTimeSlider = {
        dots: false,
        infinite: false,
        speed: 300,
        arrows: false,
        slidesToShow: 9,
        slidesToScroll: 6
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_dateTimeSlider, "dots", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_dateTimeSlider, "responsive", [{
        breakpoint: 1900,
        settings: {
          slidesToShow: 7,
          slidesToScroll: 4,
          infinite: true,
          dots: false
        }
      }, {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3.1,
          slidesToScroll: 3,
          infinite: true,
          dots: false
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 480,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2
        }
      }]), _dateTimeSlider),
      movieDetails: {},
      screeningDetails: [],
      days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      movie_format: [],
      movie_language: [],
      cinema_name: [],
      sub_regions: [],
      show_time: [],
      confirm: [],
      content_lang_id: 0,
      AvailableShowInCinema: 0
    };
  },
  beforeMount: function beforeMount() {
    this.MovieID = this.$route.params.movie_id;
    this.content_lang_id = this.$route.params.content_lang_id;
    this.showLoading();
    this.fetchMovieDetails();
    this.getConfirmedMovie();
    // this.fetchScreeningDetails();
    // this.fetchFilterDetails();
  },

  watch: {
    $route: function $route(to, from) {
      this.MovieID = this.$route.params.movie_id;
      this.content_lang_id = this.$route.params.content_lang_id;
      this.fetchMovieDetails();
      // this.fetchScreeningDetails();
    }
  },
  methods: {
    GetYear: function GetYear(date) {
      return __WEBPACK_IMPORTED_MODULE_5_moment___default()(date).format("YYYY");
    },

    resetFilter: function resetFilter() {
      var _this = this;

      this.showFilter.map(function (x) {
        _this[x.filter_key] = [];
      });

      this.showFilter = [];
      this.getConfirmedMovie();
      this.hideFilter();

      // this.fetchScreeningDetails();
      // this.fetchFilterDetails();
    },
    getFilterVal: function getFilterVal(movie, data, index1, index2, val) {
      var _this2 = this;

      var i = this[movie.filter_key].indexOf(data.value);
      this[movie.filter_key] = [];
      this.showFilter[index1].all_filter.map(function (y) {
        y.isActive = "0";
        y.isActiveFilter = "0";
      });
      if (i >= 0) {
        if (val == "1") {
          this.getConfirmedMovie();
        }
        return false;
      }

      this.showFilter[index1].all_filter.map(function (y) {
        y.isActive = "0";
        y.isActiveFilter = "0";
      });

      setTimeout(function (x) {
        if (i >= 0) {
          _this2[movie.filter_key].splice(i, 1);
          _this2.showFilter[index1].all_filter[index2].isActive = "0";
          if (val == "1") {
            _this2.showFilter[index1].all_filter[index2].isActiveFilter = "0";
          }
        } else {
          _this2[movie.filter_key].push(data.value);
          _this2.showFilter[index1].all_filter[index2].isActive = "1";
        }
        if (val == "1") {
          // this.fetchScreeningDetails();
        }
      }, 100);

      // let i = this[movie.filter_key].indexOf(data.value);
      // if (i >= 0) {
      //   this[movie.filter_key].splice(i, 1);
      //   this.showFilter[index1].all_filter[index2].isActive = "0";
      // } else {
      //   this[movie.filter_key].push(data.value);
      //   this.showFilter[index1].all_filter[index2].isActive = "1";
      // }
    },
    showFilterModal: function showFilterModal() {
      this.$refs["filterModalRef"].show();
    },
    hideFilter: function hideFilter() {
      this.$refs["filterModalRef"].hide();
    },

    // fetchFilterDetails: function() {
    //   let payload = {
    //     MovieID: this.MovieID
    //   };
    //   makeRequest("/GetShowFilters/", "POST", null, payload)
    //     .then(response => {
    //       const { error, res } = response;
    //       res.data.Filters.map(x => {
    //         x.all_filter.map(y => {
    //           y["isActive"] = "0";
    //           y["isActiveFilter"] = "0";
    //         });
    //       });
    //       this.showFilter = res.data.Filters;
    //     })
    //     .catch(error => {
    //       console.log("Error", error);
    //     });
    // },
    fetchMovieDetails: function fetchMovieDetails() {
      var _this3 = this;

      var payload = {
        movie_id: this.MovieID,
        content_lang_id: this.content_lang_id,
        category_id: 1,
        cinema_id: this.cinema_id,
        md_for_ondemand: "Y",
        guest_user_id: null,
        cust_id: 1
      };
      __WEBPACK_IMPORTED_MODULE_4__services_mainService_js___default.a.GetMovieDetails(payload).then(function (response) {
        var data = response.data;

        if (data.status) {
          // console.log("responseMovie", response);
          _this3.movieDetails = data.Records[0];
          var trailer = data.Records[0].trailer_array.filter(function (x) {
            return x.lang_id == 1;
          });
          var directors = data.Records[0].castCrewDetails.filter(function (z) {
            return z.crew_title.includes("Director");
          });
          var Actors = data.Records[0].castCrewDetails.filter(function (z) {
            return z.crew_title.includes("Actor");
          });
          _this3.poster = data.Records[0].mp_poster_url ? __WEBPACK_IMPORTED_MODULE_6__helper_constants__["URL_BASE"] + data.Records[0].mp_poster_url : data.Records[0].md_thumbnail_url;
          // console.log(Actors, directors);
          _this3.movieDetails["Actors"] = [];
          _this3.movieDetails["Directors"] = [];
          if (directors.length > 0) {
            _this3.movieDetails["Directors"] = directors[0]["Crew"];
          }
          if (Actors.length > 0) {
            _this3.movieDetails["Actors"] = Actors[0]["Crew"];
          }
          if (trailer.length > 0) {
            _this3.movieDetails.original_trailer = trailer[0].mt_link;
          }
          _this3.hideLoading();
        }
      }).catch(function (err) {
        console.log("error", err);
      });
    },
    getConfirmedMovie: function getConfirmedMovie() {
      var _this4 = this;

      var payload = {
        movie_id: this.MovieID,
        cinema_id: ""
      };
      if (this.showFilter.length > 0) {
        this.showFilter.map(function (x) {
          if (_this4[x.filter_key].length > 0) {
            payload[x.query_id] = _this4[x.filter_key][0];
          }
        });
      }
      __WEBPACK_IMPORTED_MODULE_4__services_mainService_js___default.a.getMovieConfirmedList(payload).then(function (response) {
        var data = response.data;

        if (data.status) {
          // console.log("responseMovieConfirmed", response);
          if (data.MovieListArrayNew.length > 0) {
            _this4.AvailableShowInCinema = data.MovieListArrayNew[0].CinemaList.length;

            if (_this4.showFilter.length == 0) {
              data.FilterData.map(function (x) {
                x.all_filter.map(function (y) {
                  y["isActive"] = "0";
                  y["isActiveFilter"] = "0";
                });
              });
              _this4.showFilter = data.FilterData;
            }
          } else {
            _this4.AvailableShowInCinema = 0;
          }

          if (data.Records.data.length > 0) {
            _this4.screeningDetails = data.Records.data;
          } else {
            _this4.screeningDetails = [];
          }
          _this4.hideLoading();
        }
      }).catch(function (err) {
        console.log("error", err);
      });
    },
    applyFilter: function applyFilter() {
      this.showFilter.map(function (x) {
        x.all_filter.map(function (y) {
          if (y.isActive == "1") {
            y.isActiveFilter = "1";
          }
        });
      });

      this.getConfirmedMovie();
      this.hideFilter();
    },

    fetchScreeningDetails: function fetchScreeningDetails() {
      var _this5 = this;

      var payload = {
        MovieID: this.MovieID,
        Version: "1"
      };
      if (this.showFilter.length > 0) {
        this.showFilter.map(function (x) {
          if (_this5[x.filter_key].length > 0) {
            payload[x.filter_key] = _this5[x.filter_key].toString();
          }
        });
      }
      Object(__WEBPACK_IMPORTED_MODULE_2__helper_internet_js__["makeRequest"])("/GetSpecialScreening/", "POST", null, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        _this5.hideLoading();
        _this5.screeningDetails = res.data;
        _this5.screeningDetails.map(function (date) {
          var _CinemaTimings = void 0;
          if (date.hasOwnProperty("CinemaTimingsNew")) {
            _CinemaTimings = tConvert(date.CinemaTimingsNew);
          } else {
            _CinemaTimings = tConvert(date.CinemaTimings);
          }
          if (date.hasOwnProperty("ShowAmPm")) {
            // console.log("fsdfdsfdsfdsf");
            _this5.checkAmPm = date.ShowAmPm;
          }
          date.CinemaTimings = date.CinemaTimings;
          date.ampm = _CinemaTimings.split(" ")[1];
          var parts = date.MovieDate.split("-"),
              year = parseInt(parts[0], 10),
              month = parseInt(parts[1], 10) - 1,
              // NB: month is zero-based!
          day = parseInt(parts[2], 10);
          var date1 = new Date(year, month, day);
          date.day = _this5.days[date1.getDay()];
          date.date = date1.getDate();
          date.year = year;
          date._CinemaTimings = date.CinemaTimings;
          date.month = _this5.months[date1.getMonth()].substring(0, 3);
          date.SeatsBooked = parseInt(date.SeatsBooked);
          date.SeatsLeft = parseInt(date.TotalSeat) - parseInt(date.SeatsBooked);
          // console.log(date.SeatsLeft, "test");

          return date;
        });

        _this5.$refs["filterModalRef"].hide();
      }).catch(function (error) {
        console.log("Error", error);
      });
      function tConvert(time) {
        // Check correct time format and split into components
        time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

        if (time.length > 1) {
          // If time format correct
          time = time.slice(1); // Remove full string match value
          time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
          time[0] = +time[0] % 12 || 12; // Adjust hours
        }
        return time.join(""); // return adjusted time or original string
      }
    },
    onClickNext: function onClickNext(cinemaDetails, CategoryID) {
      console.log({ cinemaDetails: cinemaDetails });
      var showDetails = {
        CinemaName: cinemaDetails.cine_name,
        CinemaAddress: cinemaDetails.cine_address,
        ShowDateTime: cinemaDetails.monthName + " " + cinemaDetails.day + ", " + cinemaDetails.Year + " | " + cinemaDetails.ss_start_show_time
      };
      // let country = CountryService.getCountry();
      this.secureStore.set("STD", showDetails);

      var query = {};

      if (cinemaDetails.vista_schedule_id) query.vista_schedule_id = cinemaDetails.vista_schedule_id;
      if (cinemaDetails.rts_performance_id) query.rts_performance_id = cinemaDetails.rts_performance_id;

      query.rts_performance_id = this.$router.push({
        name: "seatLayout",
        params: {
          ss_id: cinemaDetails.ss_id,
          screen_id: cinemaDetails.screen_id,
          md_id: cinemaDetails.movie_details_id
        },
        query: query
      });
    }
  }
});

/***/ }),
/* 641 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjYiIGhlaWdodD0iNjYiIHZpZXdCb3g9IjAgMCA2NiA2NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zMyA2NkM1MS4yMjU0IDY2IDY2IDUxLjIyNTQgNjYgMzNDNjYgMTQuNzc0NiA1MS4yMjU0IDAgMzMgMEMxNC43NzQ2IDAgMCAxNC43NzQ2IDAgMzNDMCA1MS4yMjU0IDE0Ljc3NDYgNjYgMzMgNjZaTTUxLjA2NiAzNC4xNjg3QzUyLjMxOTIgMzIuOTM1MyA1Mi4zMDk0IDMwLjkzMzYgNTEuMDQ4MiAyOS43MDE4TDM2LjExMzggMTUuMTE1MkMzMi42MjU5IDExLjczMzUgMjcuMzkzOCAxNi44MDY1IDMwLjg4MTYgMjAuMTg4MkwzNy4zOTczIDI2LjUwNTdDMzguNDgzOSAyNy41NTkzIDM4LjExODcgMjguNDEzNCAzNi41OTkzIDI4LjQxMzRIMTguNjk5NkMxNi42NTU2IDI4LjQxMzQgMTUgMzAuMDE4NiAxNSAzMi4wMDA1QzE1IDMzLjk4MTQgMTYuNjU1NiAzNS41ODc1IDE4LjY5OTYgMzUuNTg3NUgzNi41OTkzQzM4LjEyNjYgMzUuNTg3NSAzOC40ODg5IDM2LjQzNjcgMzcuMzk3MyAzNy40OTVMMzAuODgxNiA0My44MTE4QzI3LjM5MzggNDcuMTkzNSAzMi42MjU5IDUyLjI2NjYgMzYuMTEzOCA0OC44ODQ4TDUxLjA2NiAzNC4xNjg3WiIgZmlsbD0iI0U3MEQwMCIvPgo8L3N2Zz4K"

/***/ }),
/* 642 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjYiIGhlaWdodD0iNjYiIHZpZXdCb3g9IjAgMCA2NiA2NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zMyA2NkM1MS4yMjU0IDY2IDY2IDUxLjIyNTQgNjYgMzNDNjYgMTQuNzc0NiA1MS4yMjU0IDAgMzMgMEMxNC43NzQ2IDAgMCAxNC43NzQ2IDAgMzNDMCA1MS4yMjU0IDE0Ljc3NDYgNjYgMzMgNjZaTTUxLjA2NiAzNC4xNjg3QzUyLjMxOTIgMzIuOTM1MyA1Mi4zMDk0IDMwLjkzMzYgNTEuMDQ4MiAyOS43MDE4TDM2LjExMzggMTUuMTE1MkMzMi42MjU5IDExLjczMzUgMjcuMzkzOCAxNi44MDY1IDMwLjg4MTYgMjAuMTg4MkwzNy4zOTczIDI2LjUwNTdDMzguNDgzOSAyNy41NTkzIDM4LjExODcgMjguNDEzNCAzNi41OTkzIDI4LjQxMzRIMTguNjk5NkMxNi42NTU2IDI4LjQxMzQgMTUgMzAuMDE4NiAxNSAzMi4wMDA1QzE1IDMzLjk4MTQgMTYuNjU1NiAzNS41ODc1IDE4LjY5OTYgMzUuNTg3NUgzNi41OTkzQzM4LjEyNjYgMzUuNTg3NSAzOC40ODg5IDM2LjQzNjcgMzcuMzk3MyAzNy40OTVMMzAuODgxNiA0My44MTE4QzI3LjM5MzggNDcuMTkzNSAzMi42MjU5IDUyLjI2NjYgMzYuMTEzOCA0OC44ODQ4TDUxLjA2NiAzNC4xNjg3WiIgZmlsbD0iIzQzYmI0YyIvPgo8L3N2Zz4K"

/***/ }),
/* 643 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTkiIGhlaWdodD0iNTkiIHZpZXdCb3g9IjAgMCA1OSA1OSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yOS41IDU5QzQ1Ljc5MjQgNTkgNTkgNDUuNzkyNCA1OSAyOS41QzU5IDEzLjIwNzYgNDUuNzkyNCAwIDI5LjUgMEMxMy4yMDc2IDAgMCAxMy4yMDc2IDAgMjkuNUMwIDQ1Ljc5MjQgMTMuMjA3NiA1OSAyOS41IDU5WiIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyKSIvPgo8cGF0aCBkPSJNMjAuNSAyNUgxNy41QzE1LjAxNDcgMjUgMTMgMjcuMDE0NyAxMyAyOS41QzEzIDMxLjk4NTMgMTUuMDE0NyAzNCAxNy41IDM0SDIwLjVDMjIuOTg1MyAzNCAyNSAzNi4wMTQ3IDI1IDM4LjVWNDEuNUMyNSA0My45ODUzIDI3LjAxNDcgNDYgMjkuNSA0NkMzMS45ODUzIDQ2IDM0IDQzLjk4NTMgMzQgNDEuNVYzOC41QzM0IDM2LjAxNDcgMzYuMDE0NyAzNCAzOC41IDM0SDQxLjVDNDMuOTg1MyAzNCA0NiAzMS45ODUzIDQ2IDI5LjVDNDYgMjcuMDE0NyA0My45ODUzIDI1IDQxLjUgMjVIMzguNUMzNi4wMTQ3IDI1IDM0IDIyLjk4NTMgMzQgMjAuNVYxNy41QzM0IDE1LjAxNDcgMzEuOTg1MyAxMyAyOS41IDEzQzI3LjAxNDcgMTMgMjUgMTUuMDE0NyAyNSAxNy41VjIwLjVDMjUgMjIuOTg1MyAyMi45ODUzIDI1IDIwLjUgMjVaIiBmaWxsPSJ3aGl0ZSIvPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyIiB4MT0iLTguNTQxNDQiIHkxPSIyMS4xMzgxIiB4Mj0iMzMuNzM0OCIgeTI9Ijk3LjIyMSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjRTcwRDAwIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI0ZBNTQwMiIvPgo8L2xpbmVhckdyYWRpZW50Pgo8L2RlZnM+Cjwvc3ZnPgo="

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_slick__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper_internet_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__helper_internet_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_storage_service__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_storage_service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__services_storage_service__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_partials_OwnScreeningSlider_vue__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_mainService_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_mainService_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__services_mainService_js__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





//   import NowShowing from "@/components/partials/nowShowingSlider.vue";
//   import SpecialScreenings from "@/components/partials/SpecialScreeningsSlider.vue";


//   import UpcomingFestivals from "@/components/partials/UpcomingMiniFestivals.vue";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "createScreen",
  directives: {
    // 'dragscroll': dragscroll
  },
  components: {
    Slick: __WEBPACK_IMPORTED_MODULE_3_vue_slick__["default"],
    OwnScreening: __WEBPACK_IMPORTED_MODULE_6__components_partials_OwnScreeningSlider_vue__["a" /* default */]
  },
  computed: {
    checkFilterExist: function checkFilterExist() {
      var obj = false;
      this.showFilter.map(function (x) {
        x.all_filter.map(function (y) {
          if (y.isActiveFilter == "1") {
            obj = true;
          }
        });
      });
      return obj;
    }
  },

  data: function data() {
    var _movieSlider, _dateTimeSlider;

    return {
      CinemaId: "",
      movieSlider: (_movieSlider = {
        dots: true,
        infinite: false,
        speed: 300,
        arrows: false,
        slidesToShow: 55,
        slidesToScroll: 4
      }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_movieSlider, "dots", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_movieSlider, "responsive", [{
        breakpoint: 1700,
        settings: {
          slidesToShow: 5.5,
          slidesToScroll: 1
        }
      }, {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 1
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 1
        }
      }, {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1
        }
      }]), _movieSlider),
      showFilter: [],
      dateTimeSlider: (_dateTimeSlider = {
        dots: false,
        infinite: false,
        speed: 300,
        arrows: false,
        slidesToShow: 9,
        slidesToScroll: 6
      }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_dateTimeSlider, "dots", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_dateTimeSlider, "responsive", [{
        breakpoint: 1900,
        settings: {
          slidesToShow: 7,
          slidesToScroll: 4,
          infinite: true,
          dots: false
        }
      }, {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3.1,
          slidesToScroll: 3,
          infinite: true,
          dots: false
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 480,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2
        }
      }]), _dateTimeSlider),
      movieDetails: {},
      screeningDetails: [],
      days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      loader: true,
      movie_format: [],
      movie_language: [],
      cinema_name: [],
      sub_regions: [],
      show_time: [],
      loadingData: false,
      OwnScreening: [],
      CinemaList: [],
      currentSlideInd: 0,
      CategoryID: "2",
      content_lang_id: 0,
      cinema_id: 0,
      AvailableShowInCinema: 0
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.CinemaId = _this.$route.params.cinemaId;
              _this.cinema_id = _this.$route.params.cinemaId;
              _this.showLoading();

              _this.fetchCinemasList();
              // this.fetchScreeningDetails();
              // this.fetchFilterDetails();
              _context.next = 6;
              return _this.getNowShowingData();

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  // watch: {
  //   $route(to, from) {
  //     this.MovieID = this.$route.params.movieId;
  //     this.fetchMovieDetails();
  //     this.fetchScreeningDetails();
  //   }
  // },
  methods: {
    goToRoute: function goToRoute(item, index) {
      this.$refs.movieSlicknew.goTo(index, true);
      this.currentSlideInd = index;
      this.MovieID = item.movie_id;
      this.content_lang_id = item.content_lang_id;
      // alert("csdfsdf1222")
      this.fetchMovieDetails();
      this.showFilter = [];

      this.fetchScreeningDetails();
    },
    handleAfterChange: function handleAfterChange(event, slick, currentSlide) {
      this.currentSlideInd = currentSlide;
      // alert("csdfsdf22")
      var array = this.OwnScreening[currentSlide];
      this.MovieID = array.movie_id;
      this.content_lang_id = array.content_lang_id;
      this.showFilter = [];

      this.fetchScreeningDetails();

      this.fetchMovieDetails();
    },

    fetchMovieDetails: function fetchMovieDetails() {
      var _this2 = this;

      var payload = {
        movie_id: this.MovieID,
        content_lang_id: this.content_lang_id,
        category_id: 1,
        cinema_id: this.cinema_id,
        md_for_ondemand: "Y",
        guest_user_id: null,
        cust_id: 1

      };
      __WEBPACK_IMPORTED_MODULE_7__services_mainService_js___default.a.GetMovieDetails(payload).then(function (response) {
        var data = response.data;

        if (data.status) {
          console.log("responseMovie", response);
          _this2.movieDetails = data.Records[0];
          var trailer = data.Records[0].trailer_array.filter(function (x) {
            return x.lang_id == 1;
          });
          var directors = data.Records[0].castCrewDetails.filter(function (z) {
            return z.crew_title.includes("Director");
          });
          var Actors = data.Records[0].castCrewDetails.filter(function (z) {
            return z.crew_title.includes("Actor");
          });
          console.log(Actors, directors);
          _this2.movieDetails["Actors"] = [];
          _this2.movieDetails["Directors"] = [];

          if (directors.length > 0) {
            _this2.movieDetails["Directors"] = directors[0]["Crew"];
          }
          if (Actors.length > 0) {
            _this2.movieDetails["Actors"] = Actors[0]["Crew"];
          }

          if (trailer.length > 0) {
            _this2.movieDetails.original_trailer = trailer[0].mt_link;
          }
          _this2.hideLoading();
        }
      }).catch(function (err) {
        console.log("error", err);
      });
    },
    fetchCinemasList: function fetchCinemasList() {
      var _this3 = this;

      var payload = {
        cinema_id: this.$route.params.cinemaId
      };
      __WEBPACK_IMPORTED_MODULE_7__services_mainService_js___default.a.GetCinemaList(payload).then(function (response) {
        var error = response.error,
            data = response.data;

        _this3.CinemaList = data.Records;
      }).catch(function (error) {
        console.log("Error", error);
      });
    },
    getNowShowingData: function getNowShowingData() {
      var _this4 = this;

      this.loadingData = true;
      var payload = {
        CategoryID: 1,
        Version: "1",
        cinema_name: this.$route.params.cinemaId
      };
      if (this.showFilter.length > 0) {
        this.showFilter.map(function (x) {
          if (_this4.filterObj[x.filter_key].length > 0) {
            payload[x.filter_key] = _this4.filterObj[x.filter_key].toString();
          } else {
            delete payload[x.filter_key];
          }
        });
      }
      __WEBPACK_IMPORTED_MODULE_7__services_mainService_js___default.a.GetTodaysScreening({ cinema_id: this.cinema_id }).then(function (response) {
        var error = response.error,
            data = response.data;

        if (data.status) {
          if (data.Records.data.length > 0) {
            _this4.getCreatShowDataData(data.Records.data);
          } else {
            _this4.getCreatShowDataData([]);
          }
        } else {
          _this4.getCreatShowDataData([]);
        }
      }).catch(function (error) {
        console.log("Error", error);
      });
    },

    getCreatShowDataData: function getCreatShowDataData(array) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_7__services_mainService_js___default.a.GetCreateOwnShow({ cinema_id: this.cinema_id }).then(function (response) {
        var error = response.error,
            data = response.data;


        var newArray = array.concat(data.Records.data);
        newArray.map(function (x) {
          var findIndexNew = _this5.OwnScreening.findIndex(function (y) {
            return y.movie_id == x.movie_id;
          });
          if (findIndexNew < 0) {
            _this5.OwnScreening.push(x);
          }
        });
        console.log(_this5.OwnScreening, " this.OwnScreening");
        if (_this5.OwnScreening.length > 0) {
          _this5.loadingData = false;

          _this5.$nextTick(function () {
            _this5.$refs["movieSlicknew"].destroy();
            _this5.$refs.movieSlicknew.create();

            _this5.$refs.movieSlicknew.goTo(0, true);
          });
          _this5.MovieID = _this5.OwnScreening[0].movie_id;
          _this5.content_lang_id = _this5.OwnScreening[0].content_lang_id;

          _this5.fetchMovieDetails();
        } else {
          // this.$refs.movieSlicknew.destroy();
          _this5.OwnScreening = [];
          _this5.loader = false;
          _this5.hideLoading();
        }
        _this5.loadingData = false;

        _this5.hideFilter();
      }).catch(function (error) {
        console.log("Error", error);
      });
    },
    // resetFilter: function() {
    //   this.showFilter.map(x => {
    //     this[x.filter_key] = [];
    //   });
    //   this.fetchScreeningDetails();
    //   this.fetchFilterDetails();
    // },
    resetFilter: function resetFilter() {
      var _this6 = this;

      this.showFilter.map(function (x) {
        _this6[x.filter_key] = [];
      });

      this.showFilter = [];
      this.fetchScreeningDetails();
      this.hideFilter();

      // this.fetchScreeningDetails();
      // this.fetchFilterDetails();
    },
    getFilterVal: function getFilterVal(movie, data, index1, index2, val) {
      var _this7 = this;

      var i = this[movie.filter_key].indexOf(data.value);
      this[movie.filter_key] = [];
      this.showFilter[index1].all_filter.map(function (y) {
        y.isActive = "0";
        y.isActiveFilter = "0";
      });
      if (i >= 0) {

        if (val == "1") {
          this.fetchScreeningDetails();
        }
        return false;
      }
      this.showFilter[index1].all_filter.map(function (y) {
        y.isActive = "0";
        y.isActiveFilter = "0";
      });

      setTimeout(function (x) {

        if (i >= 0) {
          _this7[movie.filter_key].splice(i, 1);
          _this7.showFilter[index1].all_filter[index2].isActive = "0";
          if (val == "1") {
            _this7.showFilter[index1].all_filter[index2].isActiveFilter = "0";
          }
        } else {
          _this7[movie.filter_key].push(data.value);
          _this7.showFilter[index1].all_filter[index2].isActive = "1";
        }
        if (val == "1") {
          // this.fetchScreeningDetails();
        }
      }, 100);

      // let i = this[movie.filter_key].indexOf(data.value);
      // if (i >= 0) {
      //   this[movie.filter_key].splice(i, 1);
      //   this.showFilter[index1].all_filter[index2].isActive = "0";
      // } else {
      //   this[movie.filter_key].push(data.value);
      //   this.showFilter[index1].all_filter[index2].isActive = "1";
      // }
    },
    showFilterModal: function showFilterModal() {
      this.$refs["filterModalRef"].show();
    },
    hideFilter: function hideFilter() {
      this.$refs["filterModalRef"].hide();
    },

    fetchFilterDetails: function fetchFilterDetails() {
      var _this8 = this;

      var payload = {
        CinemaList: false
      };
      Object(__WEBPACK_IMPORTED_MODULE_4__helper_internet_js__["makeRequest"])("/GetShowFilters/", "POST", null, payload).then(function (response) {
        var error = response.error,
            res = response.res;


        res.data.Filters.map(function (x) {
          x.all_filter.map(function (y) {
            y["isActive"] = "0";
            y["isActiveFilter"] = "0";
          });
        });
        _this8.showFilter = res.data.Filters;
      }).catch(function (error) {
        console.log("Error", error);
      });
    },

    applyFilter: function applyFilter() {
      this.showFilter.map(function (x) {
        x.all_filter.map(function (y) {
          if (y.isActive == "1") {
            y.isActiveFilter = "1";
          }
        });
      });

      this.fetchScreeningDetails();
      this.hideFilter();
    },

    fetchScreeningDetails: function fetchScreeningDetails() {
      var _this9 = this;

      var payload = {
        movie_id: this.MovieID,
        cinema_id: this.cinema_id
      };
      // alert("csdfsdf")
      if (this.showFilter.length > 0) {
        this.showFilter.map(function (x) {
          if (_this9[x.query_id].length > 0) {
            payload[x.query_id] = _this9[x.filter_key].toString();
          }
        });
      }
      __WEBPACK_IMPORTED_MODULE_7__services_mainService_js___default.a.getMovieConfirmedList(payload).then(function (response) {
        var error = response.error,
            data = response.data;

        _this9.hideLoading();
        _this9.loader = false;
        if (data.MovieListArrayNew.length > 0) {
          _this9.AvailableShowInCinema = data.MovieListArrayNew[0].CinemaList.length;

          if (_this9.showFilter.length == 0) {
            data.FilterData.map(function (x) {
              x.all_filter.map(function (y) {
                y["isActive"] = "0";
                y["isActiveFilter"] = "0";
              });
            });
            _this9.showFilter = data.FilterData;
          }
        } else {
          _this9.AvailableShowInCinema = 0;
        }

        if (data.Records.data.length > 0) {
          _this9.screeningDetails = data.Records.data;
        } else {
          _this9.screeningDetails = [];
        }

        _this9.$refs["filterModalRef"].hide();
      }).catch(function (error) {
        console.log("Error", error);
      });
      function tConvert(time) {
        // Check correct time format and split into components
        time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

        if (time.length > 1) {
          // If time format correct
          time = time.slice(1); // Remove full string match value
          time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
          time[0] = +time[0] % 12 || 12; // Adjust hours
        }
        return time.join(""); // return adjusted time or original string
      }
    },
    onClickNext: function onClickNext(cinemaDetails, CategoryID) {
      var showDetails = {
        CinemaName: cinemaDetails.cine_name,
        CinemaAddress: cinemaDetails.cine_address,
        ShowDateTime: cinemaDetails.monthName + " " + cinemaDetails.day + ", " + cinemaDetails.Year + " | " + cinemaDetails.ss_start_show_time
      };
      // let country = CountryService.getCountry();
      this.secureStore.set("STD", showDetails);
      console.log({
        ss_id: cinemaDetails.ss_id,
        screen_id: cinemaDetails.screen_id,
        md_id: cinemaDetails.movie_details_id
      }, "cinemaDetails", cinemaDetails);
      this.$router.push({
        name: "seatLayout",
        params: {
          ss_id: cinemaDetails.ss_id,
          screen_id: cinemaDetails.screen_id,
          md_id: cinemaDetails.movie_details_id
        }
      });
    }
  }
});

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slick__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_internet_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__helper_internet_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_partials_SpecialScreeningsSlider_vue__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_partials_loader_vue__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_mainService_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_mainService_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__services_mainService_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helper_constants__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helper_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__helper_constants__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




//   import NowShowing from "@/components/partials/nowShowingSlider.vue";




//   import OwnScreening from "@/components/partials/OwnScreeningSlider.vue";
//   import UpcomingFestivals from "@/components/partials/UpcomingMiniFestivals.vue";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "searchResult",
  directives: {
    // 'dragscroll': dragscroll
  },
  components: {
    Slick: __WEBPACK_IMPORTED_MODULE_1_vue_slick__["default"],
    loader: __WEBPACK_IMPORTED_MODULE_4__components_partials_loader_vue__["a" /* default */],
    SpecialScreenings: __WEBPACK_IMPORTED_MODULE_3__components_partials_SpecialScreeningsSlider_vue__["a" /* default */]
  },

  data: function data() {
    var _dateTimeSlider, _movieSlider;

    return {
      showModal: false,
      dateTimeSlider: (_dateTimeSlider = {
        dots: false,
        infinite: false,
        speed: 300,
        arrows: false,
        slidesToShow: 9,
        slidesToScroll: 6
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_dateTimeSlider, "dots", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_dateTimeSlider, "responsive", [{
        breakpoint: 1900,
        settings: {
          slidesToShow: 7,
          slidesToScroll: 4,
          infinite: true,
          dots: false
        }
      }, {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3.1,
          slidesToScroll: 3,
          infinite: true,
          dots: false
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 480,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2
        }
      }]), _dateTimeSlider),
      movieSlider: (_movieSlider = {
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 5.5,
        slidesToScroll: 4
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_movieSlider, "dots", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_movieSlider, "responsive", [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 3.5,
          slidesToScroll: 3,
          infinite: true,
          dots: false
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }]), _movieSlider),
      PageNo: 1,
      lastPage: 1,
      NextPage: true,
      OwnScreening: [],
      loadingData: true
    };
  },
  mounted: function mounted() {
    this.getNowShowingData();
  },

  methods: {
    loadMore: function loadMore() {
      var _this = this;

      if (this.NextPage && this.PageNo > 0) {
        // this.loadingData = false;
        setTimeout(function () {
          _this.getNowShowingData();
        }, 1000);
      }
    },
    getNowShowingData: function getNowShowingData() {
      var _this2 = this;

      var payloadNew = { limit: 500, currentPage: this.PageNo };
      this.loadingData = true;
      __WEBPACK_IMPORTED_MODULE_5__services_mainService_js___default.a.GetCreateOwnShow(payloadNew).then(function (response) {
        var data = response.data;

        console.log("response", response);
        var uniqueArray = [];
        if (data.status && data.Records.data.length > 0) {
          if (_this2.PageNo > 1) {
            //  this.OwnScreening=[...this.MobileData.NowShowing,...data.Records.data]
            console.log("harhal >>>>>>>>>>");

            var concatOwnScreening = _this2.OwnScreening.concat(data.Records.data);

            var filterArray = concatOwnScreening.filter(function (item) {
              if (!uniqueArray.includes(item.movie_title)) {

                uniqueArray.push(item.movie_title);
                return true;
              } else {
                return false;
              }
            });

            _this2.OwnScreening = filterArray;
          } else {

            _this2.lastPage = data.Records.pagination.lastPage;

            var filterArrayOne = data.Records.data.filter(function (item) {
              if (!uniqueArray.includes(item.movie_title)) {

                uniqueArray.push(item.movie_title);
                return true;
              } else {
                return false;
              }
            });

            _this2.OwnScreening = filterArrayOne;
          }

          console.log(_this2.OwnScreening, "OwnScreening >>>>>>>>>>");
          _this2.PageNo = _this2.PageNo + 1;
          _this2.NextPage = _this2.lastPage >= _this2.PageNo;
          // this.loadingData=true;
        }
      }).catch(function (error) {
        console.log("Error", error);
      }).finally(function () {
        _this2.loadingData = false;
      });
    }
  }
});

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slick__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_internet_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__helper_internet_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_partials_SpecialScreeningsSlider_vue__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_partials_loader_vue__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_mainService_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_mainService_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__services_mainService_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helper_constants__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helper_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__helper_constants__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




//   import NowShowing from "@/components/partials/nowShowingSlider.vue";




//   import OwnScreening from "@/components/partials/OwnScreeningSlider.vue";
//   import UpcomingFestivals from "@/components/partials/UpcomingMiniFestivals.vue";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "searchResult",
  directives: {
    // 'dragscroll': dragscroll
  },
  components: {
    Slick: __WEBPACK_IMPORTED_MODULE_1_vue_slick__["default"],
    loader: __WEBPACK_IMPORTED_MODULE_4__components_partials_loader_vue__["a" /* default */],
    SpecialScreenings: __WEBPACK_IMPORTED_MODULE_3__components_partials_SpecialScreeningsSlider_vue__["a" /* default */]
  },

  data: function data() {
    var _dateTimeSlider, _movieSlider;

    return {
      showModal: false,
      dateTimeSlider: (_dateTimeSlider = {
        dots: false,
        infinite: false,
        speed: 300,
        arrows: false,
        slidesToShow: 9,
        slidesToScroll: 6
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_dateTimeSlider, "dots", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_dateTimeSlider, "responsive", [{
        breakpoint: 1900,
        settings: {
          slidesToShow: 7,
          slidesToScroll: 4,
          infinite: true,
          dots: false
        }
      }, {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3.1,
          slidesToScroll: 3,
          infinite: true,
          dots: false
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 480,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2
        }
      }]), _dateTimeSlider),
      movieSlider: (_movieSlider = {
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 5.5,
        slidesToScroll: 4
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_movieSlider, "dots", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_movieSlider, "responsive", [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 3.5,
          slidesToScroll: 3,
          infinite: true,
          dots: false
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }]), _movieSlider),
      PageNo: 1,
      lastPage: 1,
      NextPage: true,
      OwnScreening: [],
      loadingData: true
    };
  },
  mounted: function mounted() {
    this.getNowShowingData();
  },

  methods: {
    loadMore: function loadMore() {
      var _this = this;

      if (this.NextPage && this.PageNo > 0) {
        setTimeout(function () {
          _this.getNowShowingData();
        }, 1000);
      }
    },
    getNowShowingData: function getNowShowingData() {
      var _this2 = this;

      var payloadNew = { limit: __WEBPACK_IMPORTED_MODULE_6__helper_constants__["LIMIT"], currentPage: this.PageNo };
      this.loadingData = true;
      __WEBPACK_IMPORTED_MODULE_5__services_mainService_js___default.a.GetTodaysScreening(payloadNew).then(function (response) {
        var data = response.data;

        console.log("response", response);
        if (data.status && data.Records.data.length > 0) {
          if (_this2.PageNo > 1) {
            //  this.OwnScreening=[...this.MobileData.NowShowing,...data.Records.data]
            _this2.OwnScreening = _this2.OwnScreening.concat(data.Records.data);
          } else {
            _this2.lastPage = data.Records.pagination.lastPage;
            _this2.OwnScreening = data.Records.data;
          }

          _this2.PageNo = _this2.PageNo + 1;
          _this2.NextPage = _this2.lastPage >= _this2.PageNo;
        }
      }).catch(function (error) {
        console.log("Error", error);
      }).finally(function () {
        _this2.loadingData = false;
      });
    }
  }
});

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slick__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_internet_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__helper_internet_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_partials_SpecialScreeningsSlider_vue__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_partials_OwnScreeningSlider_vue__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_partials_UpcomingMiniFestivals_vue__ = __webpack_require__(590);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




//   import NowShowing from "@/components/partials/nowShowingSlider.vue";




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "searchResult",
  directives: {
    // 'dragscroll': dragscroll
  },
  components: {
    Slick: __WEBPACK_IMPORTED_MODULE_1_vue_slick__["default"],
    OwnScreeningSlider: __WEBPACK_IMPORTED_MODULE_4__components_partials_OwnScreeningSlider_vue__["a" /* default */],
    UpcomingFestivals: __WEBPACK_IMPORTED_MODULE_5__components_partials_UpcomingMiniFestivals_vue__["a" /* default */]
  },

  data: function data() {
    var _dateTimeSlider, _movieSlider;

    return {
      showModal: false,
      dateTimeSlider: (_dateTimeSlider = {
        dots: false,
        infinite: false,
        speed: 300,
        arrows: false,
        slidesToShow: 9,
        slidesToScroll: 6
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_dateTimeSlider, "dots", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_dateTimeSlider, "responsive", [{
        breakpoint: 1900,
        settings: {
          slidesToShow: 7,
          slidesToScroll: 4,
          infinite: true,
          dots: false
        }
      }, {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3.1,
          slidesToScroll: 3,
          infinite: true,
          dots: false
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 480,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2
        }
      }]), _dateTimeSlider),
      movieSlider: (_movieSlider = {
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 5.5,
        slidesToScroll: 4
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_movieSlider, "dots", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_movieSlider, "responsive", [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 3.5,
          slidesToScroll: 3,
          infinite: true,
          dots: false
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }]), _movieSlider),
      OwnScreening: []
    };
  },
  mounted: function mounted() {
    // this.getNowShowingData();
  },

  methods: {
    getNowShowingData: function getNowShowingData() {
      var _this = this;

      Object(__WEBPACK_IMPORTED_MODULE_2__helper_internet_js__["makeRequest"])("/GetAllShow/", "POST", null, null).then(function (response) {
        var error = response.error,
            res = response.res;

        _this.OwnScreening = res.data.shows[1].Movies;
      }).catch(function (error) {
        console.log("Error", error);
      });
    }
  }
});

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slick__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_internet_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__helper_internet_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_partials_SpecialScreeningsSlider_vue__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_partials_loader_vue__ = __webpack_require__(174);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




//   import NowShowing from "@/components/partials/nowShowingSlider.vue";


//   import OwnScreening from "@/components/partials/OwnScreeningSlider.vue";
//   import UpcomingFestivals from "@/components/partials/UpcomingMiniFestivals.vue";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "searchResult",
  directives: {
    // 'dragscroll': dragscroll
  },
  components: {
    Slick: __WEBPACK_IMPORTED_MODULE_1_vue_slick__["default"],
    loader: __WEBPACK_IMPORTED_MODULE_4__components_partials_loader_vue__["a" /* default */],
    SpecialScreenings: __WEBPACK_IMPORTED_MODULE_3__components_partials_SpecialScreeningsSlider_vue__["a" /* default */]
  },

  data: function data() {
    var _dateTimeSlider, _movieSlider;

    return {
      showModal: false,
      dateTimeSlider: (_dateTimeSlider = {
        dots: false,
        infinite: false,
        speed: 300,
        arrows: false,
        slidesToShow: 9,
        slidesToScroll: 6
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_dateTimeSlider, "dots", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_dateTimeSlider, "responsive", [{
        breakpoint: 1900,
        settings: {
          slidesToShow: 7,
          slidesToScroll: 4,
          infinite: true,
          dots: false
        }
      }, {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3.1,
          slidesToScroll: 3,
          infinite: true,
          dots: false
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 480,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2
        }
      }]), _dateTimeSlider),
      movieSlider: (_movieSlider = {
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 5.5,
        slidesToScroll: 4
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_movieSlider, "dots", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_movieSlider, "responsive", [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 3.5,
          slidesToScroll: 3,
          infinite: true,
          dots: false
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }]), _movieSlider),
      PageNo: 0,
      NextPage: true,
      OwnScreening: [],
      loadingData: true,
      SubTitle: "Gog Library",
      Title: ""
    };
  },
  mounted: function mounted() {
    this.getNowShowingData();
  },

  methods: {
    loadMore: function loadMore() {
      var _this = this;

      if (this.loadingData && this.NextPage && this.PageNo > 0) {
        this.loadingData = false;
        setTimeout(function () {
          _this.getNowShowingData();
        }, 1000);
      }
    },
    getNowShowingData: function getNowShowingData() {
      var _this2 = this;

      var payload = {
        CategoryID: 3,
        Version: "1"
      };
      payload["PageNo"] = this.PageNo;
      Object(__WEBPACK_IMPORTED_MODULE_2__helper_internet_js__["makeRequest"])("/GetShows/", "POST", null, payload).then(function (response) {
        var error = response.error,
            res = response.res;
        // this.OwnScreening = res.data.shows[2].Movies;

        if (_this2.PageNo == 0) {
          _this2.OwnScreening = res.data.Shows.Movies;
        } else {
          res.data.Shows.Movies.map(function (x) {
            _this2.OwnScreening.push(x);
          });
        }
        _this2.Title = res.data.Categories[2].CategoryName.toUpperCase();
        _this2.PageNo = res.data.Shows.PageNo;
        _this2.NextPage = res.data.Shows.Next;
        _this2.loadingData = true;
      }).catch(function (error) {
        console.log("Error", error);
      });
    }
  }
});

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "howItsWorks",

  data: function data() {
    return {};
  }
});

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/howitworks.016949d.svg";

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mac2.a21e14c.png";

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mac4.cda01b2.png";

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/gogo-people.481a0f2.png";

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "howItsWorks",

  data: function data() {
    return {};
  }
});

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Laptop.a4014ec.png";

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_partials_nowShowingSlider_vue__ = __webpack_require__(172);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "noSearchFound",
  directives: {
    // 'dragscroll': dragscroll
  },
  components: {
    NowShowing: __WEBPACK_IMPORTED_MODULE_0__components_partials_nowShowingSlider_vue__["a" /* default */]
  },

  data: function data() {
    return {};
  }
});

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_internet_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__helper_internet_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eventBus_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eventBus_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__eventBus_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_partials_loader_vue__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_mainService_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_mainService_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__services_mainService_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      searchValue: "",
      loadingContent: true,
      CinemaList: [],
      CinemaListCopy: [],
      filterListCinema: [],
      filterObj: {},
      checkSize: "",
      CityArray: [],
      selectedCinemaObject: {}
    };
  },

  components: {
    loader: __WEBPACK_IMPORTED_MODULE_2__components_partials_loader_vue__["a" /* default */]
  },
  computed: {
    curr_code: function curr_code() {
      return this.$store.getters.getCurrCode;
    }
  },
  beforeMount: function beforeMount() {
    this.fetchCinemasList();
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__eventBus_js___default.a.$emit("FOOTERSET", false);
    __WEBPACK_IMPORTED_MODULE_1__eventBus_js___default.a.$emit("CHECKROUTE", false);
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1__eventBus_js___default.a.$emit("CHECKROUTE", true);
    __WEBPACK_IMPORTED_MODULE_1__eventBus_js___default.a.$emit("BOTTOMTABCHANGE", "5");
  },

  methods: {
    searchData: function searchData() {
      var _this = this;

      this.selectedCinemaObject = {};
      this.CinemaList = this.CinemaListCopy;
      if (this.searchValue.length > 0) {
        this.CinemaList = this.CinemaList.filter(function (cinema) {
          var str = _this.searchValue.toLowerCase();
          var cinemaName = cinema.cinema_name.toLowerCase();
          if (cinemaName.includes(str)) {
            return cinema;
          }
        });
      } else {
        this.CinemaList = this.CinemaListCopy;
      }
    },
    filterListAll: function filterListAll(org, index2, index1) {
      this.filterListCinema[index1]["list"].map(function (x) {
        x["Show"] = false;
      });
      this.filterListCinema[index1]["list"][index2]["Show"] = true;
      this.loadingContent = true;
      this.closeFilter();
      this.fetchCinemasList();
    },
    showFilter: function showFilter(index) {
      if (this.checkSize != "" && this.filterListCinema[index]["Show"]) {
        this.filterListCinema[index]["Show"] = false;

        this.closeFilter();
        return false;
      }

      this.filterListCinema.map(function (x) {
        x["Show"] = false;
      });
      this.filterListCinema[index]["Show"] = true;
      if (screen.width > 992) {
        this.checkSize = "2";
      } else {
        this.checkSize = "1";
      }
      var element = document.getElementsByTagName("body")[0];

      element.classList.add("overflow-hidden");
    },
    closeFilter: function closeFilter() {
      this.checkSize = "";
      var element = document.getElementsByTagName("body")[0];
      element.classList.remove("overflow-hidden");
      this.filterListCinema.map(function (x) {
        x["Show"] = false;
      });
    },
    clearAllState: function clearAllState(index1) {
      this.filterListCinema[index1]["list"].map(function (x) {
        x["Show"] = false;
      });
      this.loadingContent = true;
      this.CityArray = [];
      this.closeFilter();
      this.fetchCinemasList();
    },
    FilterAllState: function FilterAllState(index1) {
      this.filterListCinema[index1]["list"].map(function (x) {
        x["Show"] = false;
      });
      this.loadingContent = true;
      this.closeFilter();
      this.fetchCinemasList();
    },
    CityList: function CityList(state, index2, index1) {
      this.filterListCinema[index1]["list"].map(function (x) {
        x["Show"] = false;
      });
      //  console.log( this.filterListCinema[index1]["list"][index2]["Show"],"sfdfsdfdsfdsf");
      this.filterListCinema[index1]["list"][index2]["Show"] = true;
      this.CityArray = state.CityList;
    },
    DistrictList: function DistrictList(city, index3, index1) {
      this.CityArray.map(function (x) {
        x["Show"] = false;
      });
      //  console.log( this.CityArray[index3]["Show"],"sfdfsdfdsfdsf");
      this.CityArray[index3]["Show"] = true;
      this.closeFilter();
      this.fetchCinemasList();
    },
    onSelectCinema: function onSelectCinema(listing) {
      this.$router.push({
        path: "/cinemaScreen/" + listing.cinema_id
      });
    },

    fetchCinemasList: function fetchCinemasList() {
      var _this2 = this;

      this.loadingContent = true;

      __WEBPACK_IMPORTED_MODULE_3__services_mainService_js___default.a.GetCinemaList({}).then(function (response) {
        var error = response.error,
            data = response.data;

        console.log(data.Records);
        _this2.CinemaList = data.Records;
        _this2.CinemaListCopy = data.Records;
        // if (count == 0) {
        //   this.filterListCinema = res.data.FilterList.FilterList;
        // }
        _this2.loadingContent = false;
      }).catch(function (error) {
        console.log("Error", error);
      });
    }
  }
});

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "aboutus",
  directives: {
    // 'dragscroll': dragscroll
  },
  // beforeMount() {
  //   this.$router.replace({
  //     path: "/coming-soon"
  //   });
  // },

  components: {},

  data: function data() {
    return {};
  }
});

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Help-page",
  directives: {
    // 'dragscroll': dragscroll
  },

  components: {},

  data: function data() {
    return {};
  }
});

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "faqs",
  directives: {
    // 'dragscroll': dragscroll
  },

  components: {},

  data: function data() {
    return {};
  }
});

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "privacy-policy",
  directives: {
    // 'dragscroll': dragscroll
  },

  components: {},
  mounted: function mounted() {
    // remove style tags
    var elements = document.querySelectorAll(".privacy_policy *");
    elements.forEach(function (element) {
      element.style = "";
      //  detect if an element only has white space in it, not any characters
      if (element.innerText.match(/\S/m) === null) {
        //   element.innerText="";
        element.remove();
      }
    });
  },
  data: function data() {
    return {};
  }
});

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "privacy-policy",
  directives: {
    // 'dragscroll': dragscroll
  },

  components: {},
  mounted: function mounted() {
    // remove style tags
    var elements = document.querySelectorAll(".cookies_privacy_policy *");
    elements.forEach(function (element) {
      element.style = "";
      //  detect if an element only has white space in it, not any characters
      if (element.innerText.match(/\S/m) === null) {
        //   element.innerText="";
        element.remove();
      }
    });
  },
  data: function data() {
    return {};
  }
});

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "privacy-policy",
    directives: {
        // 'dragscroll': dragscroll
    },

    components: {},
    mounted: function mounted() {
        // remove style tags
        var elements = document.querySelectorAll(".termsCondition *");
        elements.forEach(function (element) {
            element.style = "";
            //  detect if an element only has white space in it, not any characters
            if (element.innerText.match(/\S/m) === null) {
                //   element.innerText="";
                element.remove();
            }
        });
    },
    data: function data() {
        return {};
    }
});

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'privacy-policy',
  directives: {
    // 'dragscroll': dragscroll
  },

  components: {},

  data: function data() {
    return {};
  }
});

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'terms-condition-ticket',
  directives: {
    // 'dragscroll': dragscroll
  },

  components: {},

  data: function data() {
    return {};
  }
});

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },


  computed: {
    getPath: function getPath() {
      var array = this.$route.path.split("/");
      return array[array.length - 1];
    }
  },

  components: {},
  methods: {}
});

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_internet_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__helper_internet_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_storage_service__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_storage_service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__services_storage_service__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper_constants_js__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper_constants_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__helper_constants_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__eventBus_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__eventBus_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__eventBus_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_mainService_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_mainService_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__services_mainService_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_AuthServices_js__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_AuthServices_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__services_AuthServices_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_debounce__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      fbSignInParams: {
        scope: "email",
        return_scopes: false
      },
      googleSignInParams: {
        client_id: "911938447926-kls328d23otm80v12n1jq13h8ajeh57f.apps.googleusercontent.com"
      },
      countries: [],
      CountryCodeList: [],
      countriesCopy: [],
      userDetails: {
        UserName: "",
        Email: "",
        MobileNo: "",
        ProfileURl: ""
      },
      errorMessage: {
        updateProfile: "",
        error: ""
      },
      countryDetails: {},
      isEmailDisabled: true,
      isPhoneNumberDisabled: true,
      isPasswordDisbaled: true,
      isUserNameDisabled: true,
      searchCode: ""
    };
  },

  computed: {
    getCountries: function getCountries() {
      return this.$store.getters.getCountries;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.getAllGetCountryList();
    __WEBPACK_IMPORTED_MODULE_5__eventBus_js___default.a.$emit("CHECKROUTE", true);
    __WEBPACK_IMPORTED_MODULE_5__eventBus_js___default.a.$on("onProfileSuccess", function () {
      _this.updateUserProfile();
    });
    __WEBPACK_IMPORTED_MODULE_5__eventBus_js___default.a.$emit("FOOTERSET", true);
    __WEBPACK_IMPORTED_MODULE_5__eventBus_js___default.a.$emit("BOTTOMTABCHANGE", "4");
  },
  beforeMount: function beforeMount() {
    this.fetchUserDetails();
    this.countryDetails = __WEBPACK_IMPORTED_MODULE_3__services_storage_service__["CountryService"].getCountry();
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_5__eventBus_js___default.a.$emit("FOOTERSET", false);
    __WEBPACK_IMPORTED_MODULE_5__eventBus_js___default.a.$emit("CHECKROUTE", false);
  },

  methods: {
    getAllGetCountryList: function getAllGetCountryList() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_6__services_mainService_js___default.a.GetCountries().then(function (response) {
        var data = response.data;

        if (data.data.length > 0) {
          _this2.CountryCodeList = data.data;
          _this2.countries = data.data;
          _this2.countriesCopy = data.data;
        }
      }).catch(function (err) {
        console.log("error:", err);
      });
    },
    onSearchCode: function onSearchCode() {
      var _this3 = this;

      if (this.searchCode && this.searchCode.length > 0) {
        this.CountryCodeList = this.countriesCopy.filter(function (x) {
          if (x.country_mob_code && x.country_mob_code.toLowerCase().includes(_this3.searchCode.toLowerCase())) {
            return x;
          } else if (x.country_name && x.country_name.toLowerCase().includes(_this3.searchCode.toLowerCase())) {
            return x;
          }
        });
      } else {
        this.CountryCodeList = this.countriesCopy;
      }
    },

    _getAllGetCountryList: function _getAllGetCountryList() {
      var _this4 = this;

      Object(__WEBPACK_IMPORTED_MODULE_2__helper_internet_js__["makeRequest"])("/AllGetCountryList/", "POST", null, {}).then(function (response) {
        var error = response.error,
            res = response.res;

        if (res.data.Status) {
          _this4.CountryCodeList = res.data.Country;
        }
      }).catch(function (error) {
        console.log("Error", error);
        //   resolve(null);
      });
    },

    onChangeCountryCode: function onChangeCountryCode(country) {
      this.userDetails.CountryCode = country.country_mob_code;
      this.userDetails.country_mob_code = country.country_mob_code;
      this.$forceUpdate();
    },

    onChangeCountry: function onChangeCountry() {
      var _this5 = this;

      console.log("sdhsbdub");
      Object(__WEBPACK_IMPORTED_MODULE_2__helper_internet_js__["makeRequest"])("/GetCountryList/", "POST", null, {}).then(function (response) {
        var error = response.error,
            res = response.res;

        if (!error && res.data.Status) {
          _this5.$refs.countryModalRef.show();
          _this5.countries = res.data.Country;
        }
      }).catch(function (error) {
        console.log("Error", error);
        //   resolve(null);
      });
    },
    setCountry: function setCountry(country) {
      __WEBPACK_IMPORTED_MODULE_3__services_storage_service__["CountryService"].saveCountry(country);
      window.location.reload();
    },
    fetchUserDetails: function fetchUserDetails() {
      var user = JSON.parse(window.localStorage.getItem("user")) || {};
      console.log("USER fetchUserDetails", user);
      if (user) {
        this.userDetails.Email = user.cust_email;
        this.userDetails.phone_no = user.cust_mobile;
        this.userDetails.country_mob_code = user.country_mob_code || user.country_code;
        this.userDetails.UserName = user.first_name;
        this.userDetails.MobileNo = user.cust_mobile;
      }
      this.$forceUpdate();
      // makeRequest("/Account/GetUserProfile", "POST", token, null)
      //   .then(result => {
      //     if (!result.error && result.res && result.res.data) {
      //       this.userDetails = result.res.data;
      //       this.userDetails.MobileNo = this.userDetails.MobileNo.trim().replace(
      //         /" "/g,
      //         ""
      //       );
      //     } else {
      //       TokenService.removeToken();
      //       window.location.pathname = "/";
      //     }
      //   })
      //   .catch(error => {
      //     TokenService.removeToken();
      //     window.location.pathname = "/";

      //     console.log("Error", error);
      //   });
    },

    onFileChanged: function onFileChanged(event) {
      var _this6 = this;

      var token = __WEBPACK_IMPORTED_MODULE_3__services_storage_service__["TokenService"].getToken();
      this.testImageData = event.target.files[0];
      var payload = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        UserName: this.userDetails.email,
        Email: this.userDetails.Email,
        MobileNo: this.userDetails.MobileNo
      }, "UserName", this.userDetails.UserName);
      payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload);
      var formData = new FormData();
      formData.append("profilepic", this.testImageData);
      formData.append("access_token", token);
      formData.append("data", payload);
      __WEBPACK_IMPORTED_MODULE_9_axios___default.a.post("" + __WEBPACK_IMPORTED_MODULE_4__helper_constants_js__["URL_BASE"] + "/Account/UpdateProfile", formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }).then(function (res) {
        if (res && res.data.Status) {
          _this6.userDetails.ProfileURl = res.data.UpdatePic1;
        } else {
          _this6.$refs.errorModal.show();
          _this6.errorMessage.updateProfile = res.data.Message;
        }
      }).catch(function (error) {
        _this6.$refs.errorModal.show();
        _this6.errorMessage.updateProfile = "Something went wrong";
      });
    },

    validateBeforeSubmit: function validateBeforeSubmit(scope) {
      var _this7 = this;

      if (scope == "updateProfile") {
        this.$validator.validateAll(scope).then(function (result) {
          console.log("RESULR validateAll", result);
          if (result) {
            console.log("i am here");
            // this.$refs.enterPassword.show();
            _this7.updateUserProfile();
          } else {
            _this7.errorMessage.updateProfile = "Something went wrong";
          }
          return;
        });
      }
      if (scope == "verifyPassword") {
        this.$validator.validateAll(scope).then(function (result) {
          if (result) {
            var payload = {
              UserName: _this7.userDetails.Email,
              Password: _this7.userDetails.password
            };
            Object(__WEBPACK_IMPORTED_MODULE_2__helper_internet_js__["makeRequest"])("/Account/login", "POST", null, payload).then(function (response) {
              var error = response.error,
                  res = response.res;

              if (!error && res.data.Status) {
                __WEBPACK_IMPORTED_MODULE_3__services_storage_service__["TokenService"].saveToken(res.data.access_token);
                _this7.updateUserProfile();
              } else {
                _this7.errorMessage.error = res.data.Message;
              }
            }).catch(function (error) {
              console.log("Error", error);
            });
          }
          return;
        });
      }
    },

    //google
    onGoogleSignInSuccess: function onGoogleSignInSuccess(googleUser) {
      __WEBPACK_IMPORTED_MODULE_5__eventBus_js___default.a.$emit("OnGoogleSignIn", googleUser);
    },
    onGoogleSignInError: function onGoogleSignInError(error) {
      var _this8 = this;

      this.errorMessage.error = error;
      setTimeout(function () {
        _this8.errorMessage.error = "";
      }, 5000);
    },

    //fb
    onSignFBInSuccess: function onSignFBInSuccess(response) {
      __WEBPACK_IMPORTED_MODULE_5__eventBus_js___default.a.$emit("OnFacebookSignIn", response);
    },
    onSignFBInError: function onSignFBInError(error) {
      var _this9 = this;

      this.errorMessage.error = error;
      setTimeout(function () {
        _this9.errorMessage.error = "";
      }, 5000);
    },
    updateUserProfile: function updateUserProfile() {
      var _this10 = this;

      this.showLoading();
      var payload = {
        email: this.userDetails.Email,
        phone_no: this.userDetails.MobileNo,
        first_name: this.userDetails.UserName,
        country_mob_code: this.userDetails.country_mob_code
      };
      __WEBPACK_IMPORTED_MODULE_7__services_AuthServices_js___default.a.UpdateUser(payload).then(function (response) {
        var data = response.data;

        if (data.status) {
          localStorage.removeItem("user");
          localStorage.setItem("user", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data.Records[0]));
          _this10.errorMessage.updateProfile = data.message;
          _this10.fetchUserDetails();
          __WEBPACK_IMPORTED_MODULE_5__eventBus_js___default.a.$emit("profileUpdate");
        } else {
          _this10.errorMessage.updateProfile = data.message;
        }
      }).catch(function (err) {
        console.log("Error:", err);
      }).finally(function () {
        _this10.hideLoading();
      });
    },
    _updateUserProfile: function _updateUserProfile() {
      var _this11 = this;

      var token = __WEBPACK_IMPORTED_MODULE_3__services_storage_service__["TokenService"].getToken();
      var payload = {
        Email: this.userDetails.Email,
        MobileNo: this.userDetails.MobileNo,
        UserName: this.userDetails.UserName,
        CountryCode: this.userDetails.CountryCode
      };
      Object(__WEBPACK_IMPORTED_MODULE_2__helper_internet_js__["makeRequest"])("/Account/UpdateProfile", "POST", token, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        if (!error && res.data.Status) {
          _this11.$refs.enterPassword.hide();
          _this11.errorMessage.updateProfile = res.data.Message;
        } else {
          _this11.errorMessage.error = res.data.Message;
        }
      }).catch(function (error) {
        console.log("Error", error);
      });
    }
  }
});

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      value: 75,
      variant: "danger"
    };
  }
});

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_internet_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__helper_internet_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_storage_service__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_storage_service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__services_storage_service__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      obj: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        name: "here",
        name1: "here"
      }, "name1", "here"),
      notifications: {}
    };
  },
  beforeMount: function beforeMount() {
    this.fetchNotifications();
  },

  methods: {
    fetchNotifications: function fetchNotifications() {
      var _this = this;

      var token = __WEBPACK_IMPORTED_MODULE_2__services_storage_service__["TokenService"].getToken();
      Object(__WEBPACK_IMPORTED_MODULE_1__helper_internet_js__["makeRequest"])("/GetNotificationsList", "POST", token, null).then(function (result) {
        // this.notifications = result.res.data.List;
        _this.notifications = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.groupBy(result.res.data.List, 'Date');
        console.log('this.notifications :', _this.notifications);
      }).catch(function (error) {
        console.log("Error", error);
      });
    }
  }
});

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_internet_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__helper_internet_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_storage_service__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_storage_service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__services_storage_service__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_navigator_share__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__eventBus_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__eventBus_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__eventBus_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_datepicker__ = __webpack_require__(1361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_mainService_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_mainService_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__services_mainService_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_AuthServices_js__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_AuthServices_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__services_AuthServices_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_debounce__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue2_datepicker_index_css__ = __webpack_require__(1365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue2_datepicker_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue2_datepicker_index_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      show: true,
      transctions: [],
      ticketMessage: "",
      days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      loading: true,
      time3: [new Date(), new Date()],
      TabTransacton: [{
        text: "Upcoming",
        val: "Confirmed",
        status: 16
      }, {
        text: "Pending",
        val: "Unconfirmed",
        status: 20
      }, {
        text: "Expired",
        val: "Expired",
        status: 13
      }, {
        text: "Cancelled",
        val: "Cancelled",
        status: 14
      }],
      tabVal: "Confirmed",
      tempTransactions: []
    };
  },

  computed: {
    curr_code: function curr_code() {
      return this.$store.getters.getCurrCode;
    },
    userInfo: function userInfo() {
      if (localStorage.getItem("user")) {
        var user = JSON.parse(localStorage.getItem("user"));
        return user;
      } else {
        return false;
      }
    }
  },
  beforeMount: function beforeMount() {
    var date = __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(30, "days");
    this.time3 = [new Date(), date._d];
    // this.fetchNotifications();
    this.fetchUserHistory();
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_4__eventBus_js___default.a.$emit("FOOTERSET", false);
    __WEBPACK_IMPORTED_MODULE_4__eventBus_js___default.a.$emit("CHECKROUTE", false);
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_4__eventBus_js___default.a.$emit("CHECKROUTE", true);
    __WEBPACK_IMPORTED_MODULE_4__eventBus_js___default.a.$emit("BOTTOMTABCHANGE", "3");
  },

  filters: {
    moment: function moment(date) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(date).format("DD-MMM-YYYY");
    },
    datetime: function datetime(date) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(date).format("DD-MMM-YYYY HH:mm");
    },
    date: function date(_date) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(_date).format("DD-MMM-YYYY");
    }
  },
  components: {
    NavigatorShare: __WEBPACK_IMPORTED_MODULE_2_vue_navigator_share__["a" /* default */],
    DatePicker: __WEBPACK_IMPORTED_MODULE_5_vue2_datepicker__["a" /* default */]
  },
  methods: {
    show_status: function show_status(transaction) {
      var tempObj = void 0;
      if (transaction.booking_type_id == 2) {
        if (transaction.booked_seats >= transaction.min_seats) {
          var obj = {
            status: "Confirmed",
            message: "Confirmed",
            percent: 100,
            max: 100,
            value: 100,
            isPrivate: false,
            isConfirmed: "Y",
            screen_total_seats: transaction.screen_total_seats
          };
          tempObj = obj;
        } else {
          var remainingSeats = transaction.min_seats - transaction.booked_seats;
          var _obj = {
            status: "Not Confirmed",
            message: "Need " + remainingSeats + " seats to confirm",
            percent: remainingSeats,
            max: parseInt(transaction.min_seats),
            value: parseInt(transaction.booked_seats),
            isPrivate: false,
            isConfirmed: "N",
            screen_total_seats: parseInt(transaction.screen_total_seats)
          };
          tempObj = _obj;
        }
      } else if (transaction.booking_type_id == 3) {
        var _obj2 = {
          status: "Private Screening",
          message: "Private Screening",
          percent: 100,
          max: 100,
          value: 100,
          isPrivate: true,
          isConfirmed: "Y",
          screen_total_seats: parseInt(transaction.screen_total_seats)
        };
        tempObj = _obj2;
      } else {
        var _obj3 = {
          status: "Confirmed",
          message: "Confirmed",
          percent: 100,
          max: 100,
          value: 100,
          isPrivate: false,
          isConfirmed: "Y",
          screen_total_seats: parseInt(transaction.screen_total_seats)
        };
        tempObj = _obj3;
      }
      return tempObj;
    },
    GetTime: function GetTime(date) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(date).format("HH:mm");
    },
    dateChange: function dateChange() {
      if (this.time3[0] != null) {
        this.transctions = [];
        this.loading = true;
        this.fetchNotifications();
      }
    },
    showTransaction: function showTransaction(val) {
      var _this = this;

      if (val.val != this.tabVal) {
        this.transctions = [];
        this.loading = true;
        this.tabVal = val.val;
        setTimeout(function () {
          _this.transctions = _this.tempTransactions.filter(function (x) {
            return x.ss_show_status == val.status;
          });
          _this.loading = false;
        }, 500);
      }
    },
    copyTextShare: function copyTextShare(index) {
      var copyText = document.getElementById("copyText" + index);
      copyText.select();
      document.execCommand("copy");
      var self = this;

      this.transctions[index]["Title"] = this.transctions[index]["Title"] + "  ";
      this.transctions[index].show = true;
      setTimeout(function () {
        self.transctions[index].show = false;
        self.transctions[index]["Title"] = self.transctions[index]["Title"] + " ";
      }, 2000);
    },
    onError: function onError(err) {
      alert(err);
      console.log(err);
    },
    onSuccess: function onSuccess(err) {
      console.log(err);
    },
    fetchUserHistory: function fetchUserHistory() {
      var _this2 = this;

      this.showLoading();
      console.log("this.userInfo", this.userInfo);
      var payload = {
        customer_id: this.userInfo ? this.userInfo.cust_id : null
      };
      __WEBPACK_IMPORTED_MODULE_7__services_AuthServices_js___default.a.GetUserHistory(payload).then(function (response) {
        var data = response.data;

        if (data.status && data.Records.length > 0) {
          __WEBPACK_IMPORTED_MODULE_4__eventBus_js___default.a.$emit("FOOTERSET", true);
          _this2.tempTransactions = data.Records;
          _this2.transctions = data.Records.filter(function (x) {
            return x.ss_show_status == 16;
          });
          console.log("this.transctions", _this2.transctions);
        }
      }).catch(function (err) {
        console.log("Error:", err);
      }).finally(function () {
        _this2.hideLoading();
        _this2.loading = false;
      });
    },
    sortSeatsString: function sortSeatsString(a, b) {
      var reA = /[^a-zA-Z]/g;
      var reN = /[^0-9]/g;
      var aA = a.replace(reA, "");
      var bA = b.replace(reA, "");
      if (aA === bA) {
        var aN = parseInt(a.replace(reN, ""), 10);
        var bN = parseInt(b.replace(reN, ""), 10);
        return aN === bN ? 0 : aN > bN ? 1 : -1;
      } else {
        return aA > bA ? 1 : -1;
      }
    },


    fetchNotifications: function fetchNotifications() {
      var _this3 = this;

      var payload = {
        fromDate: this.time3[0],
        toDate: this.time3[1],
        type: screen.width < 991 ? "mobile" : "desktop"
      };

      var token = __WEBPACK_IMPORTED_MODULE_1__services_storage_service__["TokenService"].getToken();
      Object(__WEBPACK_IMPORTED_MODULE_0__helper_internet_js__["makeRequest"])("/Booking/GetBookingHistory", "POST", token, payload).then(function (result) {
        if (result.res.data.length > 0) {
          _this3.tempTransactions = result.res.data;
          _this3.tempTransactions.map(function (date) {
            date.ShowStatusMsg = date.ShowStatusMsg.toLowerCase();
            date.ShowStatusMsg = date.ShowStatusMsg.charAt(0).toUpperCase() + date.ShowStatusMsg.slice(1);
            date.Seats = date.Seats.split(",").join(", ");
            var parts = date.MovieDate.replace(/,/g, "").split(" ");
            var year = parseInt(parts[2], 10);
            var month = getMonthFromString(parts[1]);
            var day = parseInt(parts[0], 10);
            var date1 = new Date(year, month, day);
            date.day = _this3.days[date1.getDay()];
            date.date = date1.getDate();
            date.year = year;
            date.month = _this3.months[date1.getMonth()];
            date.timing = date.MovieTiming.split(" ");
            date["show"] = false;
            __WEBPACK_IMPORTED_MODULE_4__eventBus_js___default.a.$emit("FOOTERSET", true);
          });

          _this3.transctions = _this3.tempTransactions.filter(function (x) {
            return x.ShowStatusMsg == _this3.tabVal;
          });
        }
        _this3.loading = false;
      }).catch(function (error) {
        console.log("Error", error);
      });

      function getMonthFromString(mon) {
        return new Date(Date.parse(mon + " 1, 2012")).getMonth();
      }
    },
    onResendTicket: function onResendTicket(BookingID) {
      var _this4 = this;

      this.showLoading();
      var token = __WEBPACK_IMPORTED_MODULE_1__services_storage_service__["TokenService"].getToken();
      var payload = {
        BookingID: BookingID
      };
      Object(__WEBPACK_IMPORTED_MODULE_0__helper_internet_js__["makeRequest"])("/Booking/ResendBookingDetails", "POST", token, payload).then(function (result) {
        _this4.hideLoading();
        var error = result.error,
            res = result.res;

        if (!error) {
          _this4.$refs.resendTicket.show();
          setTimeout(function () {
            _this4.$refs.resendTicket.hide();
          }, 5000);
        }
      }).catch(function (error) {
        console.log("error :", error);
        _this4.hideLoading();
      });
    }
  }
});

/***/ }),
/* 672 */,
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_internet_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__helper_internet_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_storage_service__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_storage_service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__services_storage_service__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      walletsDetails: [],
      recentProfiles: [],
      walletAmount: "",
      errorMessage: "",
      successMessage: "",
      user: {
        email: "",
        amount: "",
        OTP: ["", "", "", ""]
      },
      Currency: "",
      TransactionID: ""
    };
  },
  beforeMount: function beforeMount() {
    this.fetchNotifications();
  },

  methods: {
    OTPonKeyUp: function OTPonKeyUp(item, e) {
      if (this.user.OTP[item].length > 1) {
        this.user.OTP[item] = this.user.OTP[item][this.user.OTP[item].length];
      }
      if (e.keyCode < 58 && e.keyCode > 47) {
        var value = "otp" + (item + 2);
        this.$refs[value].focus();
      }
    },
    fetchNotifications: function fetchNotifications() {
      var _this = this;

      var token = __WEBPACK_IMPORTED_MODULE_1__services_storage_service__["TokenService"].getToken();
      Object(__WEBPACK_IMPORTED_MODULE_0__helper_internet_js__["makeRequest"])("/Payment/GetWalletInfo", "POST", token, null).then(function (result) {
        _this.walletsDetails = result.res.data.Data.Log;
        _this.walletAmount = result.res.data.Currency + " " + result.res.data.Amount;
        _this.Currency = result.res.data.Currency;
      }).catch(function (error) {
        console.log("Error", error);
      });
    },

    validateBeforeSubmit: function validateBeforeSubmit(scope) {
      var _this2 = this;

      if (scope == "transfer") {
        var token = __WEBPACK_IMPORTED_MODULE_1__services_storage_service__["TokenService"].getToken();
        var payload = { Email: this.user.email, Amount: this.user.amount };
        Object(__WEBPACK_IMPORTED_MODULE_0__helper_internet_js__["makeRequest"])("/Payment/WalletTransfer", "POST", token, payload).then(function (result) {
          if (result.res.data.Status) {
            _this2.$refs.OTPModal.show();
            _this2.TransactionID = result.res.data.TransactionID;
          } else {
            _this2.errorMessage = result.res.data.Message;
            _this2.successMessage = "";
          }
        }).catch(function (error) {
          console.log("Error", error);
        });
        return;
      }
      if (scope == "verifyOTP") {
        var _token = __WEBPACK_IMPORTED_MODULE_1__services_storage_service__["TokenService"].getToken();
        var _payload = {
          Email: this.user.email,
          Amount: this.user.amount,
          TransactionID: this.TransactionID,
          OTP: this.user.OTP.toString().replace(/,/g, "")
        };
        Object(__WEBPACK_IMPORTED_MODULE_0__helper_internet_js__["makeRequest"])("/Payment/WalletTransfer", "POST", _token, _payload).then(function (result) {
          if (result.res.data.Status) {
            _this2.$refs.OTPModal.hide();
            _this2.successMessage = result.res.data.Message;
            _this2.errorMessage = "";
          } else {
            _this2.$refs.OTPModal.hide();
            _this2.successMessage = "";
            _this2.errorMessage = result.res.data.Message;
          }
        }).catch(function (error) {
          console.log("Error", error);
        });
      }
    },
    verifyOTP: function verifyOTP(data) {}
  }
});

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_internet_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__helper_internet_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_storage_service__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_storage_service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__services_storage_service__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eventBus_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eventBus_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__eventBus_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      offersPromo: [],
      offers: {},
      loading: false
    };
  },
  beforeMount: function beforeMount() {
    this.fetchOffers();
  },
  beforeDestroy: function beforeDestroy() {
    // EventBus.$emit("FOOTERSET", false);
    // EventBus.$emit("CHECKROUTE", false);
  },
  mounted: function mounted() {
    // EventBus.$emit("CHECKROUTE", true);
    // EventBus.$emit("BOTTOMTABCHANGE", "2");
  },

  methods: {
    onClickModal: function onClickModal(data) {
      this.offers = data;
    },
    fetchOffers: function fetchOffers() {
      var _this = this;

      var token = __WEBPACK_IMPORTED_MODULE_1__services_storage_service__["TokenService"].getToken();
      var payload = {
        CityID: 0
      };
      this.loading = true;
      Object(__WEBPACK_IMPORTED_MODULE_0__helper_internet_js__["makeRequest"])("/Payment/GetPromotionDetails", "POST", token, payload).then(function (result) {
        _this.offersPromo = result.res.data.Promotions;
        _this.loading = false;
        //  EventBus.$emit("FOOTERSET", true);
      }).catch(function (error) {
        console.log("Error", error);
        _this.loading = false;
      });
    }
  }
});

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slick__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_partials_nowShowingSlider_vue__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_internet_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__helper_internet_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "homepage",
  components: {
    Slick: __WEBPACK_IMPORTED_MODULE_0_vue_slick__["default"],
    NowShowing: __WEBPACK_IMPORTED_MODULE_1__components_partials_nowShowingSlider_vue__["a" /* default */]
  }
});

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slick__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_partials_nowShowingSlider_vue__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_internet_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__helper_internet_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "homepage",
  components: {
    Slick: __WEBPACK_IMPORTED_MODULE_0_vue_slick__["default"],
    NowShowing: __WEBPACK_IMPORTED_MODULE_1__components_partials_nowShowingSlider_vue__["a" /* default */]
  }
});

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "contactUs"
});

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "newsroom",

  data: function data() {
    return {};
  },
  mounted: function mounted() {
    var articles = document.querySelectorAll(".news-article");
    articles && articles.forEach(function (article) {
      if (article) {
        var content = article.querySelector(".news-article-text");
        content.innerText = content.innerText.slice(0, 200);
      }
    });
  }
});

/***/ }),
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * The file enables `@/store/index.js` to import all vuex modules
 * in a one-shot manner. There should not be any reason to edit this file.
 */

var files = __webpack_require__(1428);
var modules = {};
files.keys().forEach(function (key) {
  if (key === "./index.js") return;
  modules[key.replace(/(\.\/|\.js)/g, "")] = files(key).default;
});

exports.default = modules;

/***/ }),
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(414);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55290278_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(1113);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55290278_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1027 */,
/* 1028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__ = __webpack_require__(415);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7de353f5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__ = __webpack_require__(1100);
function injectStyle (ssrContext) {
  __webpack_require__(1029)
  __webpack_require__(1031)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7de353f5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7de353f5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1029 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1030 */,
/* 1031 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 436,
	"./af.js": 436,
	"./ar": 437,
	"./ar-dz": 438,
	"./ar-dz.js": 438,
	"./ar-kw": 439,
	"./ar-kw.js": 439,
	"./ar-ly": 440,
	"./ar-ly.js": 440,
	"./ar-ma": 441,
	"./ar-ma.js": 441,
	"./ar-ps": 442,
	"./ar-ps.js": 442,
	"./ar-sa": 443,
	"./ar-sa.js": 443,
	"./ar-tn": 444,
	"./ar-tn.js": 444,
	"./ar.js": 437,
	"./az": 445,
	"./az.js": 445,
	"./be": 446,
	"./be.js": 446,
	"./bg": 447,
	"./bg.js": 447,
	"./bm": 448,
	"./bm.js": 448,
	"./bn": 449,
	"./bn-bd": 450,
	"./bn-bd.js": 450,
	"./bn.js": 449,
	"./bo": 451,
	"./bo.js": 451,
	"./br": 452,
	"./br.js": 452,
	"./bs": 453,
	"./bs.js": 453,
	"./ca": 454,
	"./ca.js": 454,
	"./cs": 455,
	"./cs.js": 455,
	"./cv": 456,
	"./cv.js": 456,
	"./cy": 457,
	"./cy.js": 457,
	"./da": 458,
	"./da.js": 458,
	"./de": 459,
	"./de-at": 460,
	"./de-at.js": 460,
	"./de-ch": 461,
	"./de-ch.js": 461,
	"./de.js": 459,
	"./dv": 462,
	"./dv.js": 462,
	"./el": 463,
	"./el.js": 463,
	"./en-au": 464,
	"./en-au.js": 464,
	"./en-ca": 465,
	"./en-ca.js": 465,
	"./en-gb": 466,
	"./en-gb.js": 466,
	"./en-ie": 467,
	"./en-ie.js": 467,
	"./en-il": 468,
	"./en-il.js": 468,
	"./en-in": 469,
	"./en-in.js": 469,
	"./en-nz": 470,
	"./en-nz.js": 470,
	"./en-sg": 471,
	"./en-sg.js": 471,
	"./eo": 472,
	"./eo.js": 472,
	"./es": 473,
	"./es-do": 474,
	"./es-do.js": 474,
	"./es-mx": 475,
	"./es-mx.js": 475,
	"./es-us": 476,
	"./es-us.js": 476,
	"./es.js": 473,
	"./et": 477,
	"./et.js": 477,
	"./eu": 478,
	"./eu.js": 478,
	"./fa": 479,
	"./fa.js": 479,
	"./fi": 480,
	"./fi.js": 480,
	"./fil": 481,
	"./fil.js": 481,
	"./fo": 482,
	"./fo.js": 482,
	"./fr": 483,
	"./fr-ca": 484,
	"./fr-ca.js": 484,
	"./fr-ch": 485,
	"./fr-ch.js": 485,
	"./fr.js": 483,
	"./fy": 486,
	"./fy.js": 486,
	"./ga": 487,
	"./ga.js": 487,
	"./gd": 488,
	"./gd.js": 488,
	"./gl": 489,
	"./gl.js": 489,
	"./gom-deva": 490,
	"./gom-deva.js": 490,
	"./gom-latn": 491,
	"./gom-latn.js": 491,
	"./gu": 492,
	"./gu.js": 492,
	"./he": 493,
	"./he.js": 493,
	"./hi": 494,
	"./hi.js": 494,
	"./hr": 495,
	"./hr.js": 495,
	"./hu": 496,
	"./hu.js": 496,
	"./hy-am": 497,
	"./hy-am.js": 497,
	"./id": 498,
	"./id.js": 498,
	"./is": 499,
	"./is.js": 499,
	"./it": 500,
	"./it-ch": 501,
	"./it-ch.js": 501,
	"./it.js": 500,
	"./ja": 502,
	"./ja.js": 502,
	"./jv": 503,
	"./jv.js": 503,
	"./ka": 504,
	"./ka.js": 504,
	"./kk": 505,
	"./kk.js": 505,
	"./km": 506,
	"./km.js": 506,
	"./kn": 507,
	"./kn.js": 507,
	"./ko": 508,
	"./ko.js": 508,
	"./ku": 509,
	"./ku-kmr": 510,
	"./ku-kmr.js": 510,
	"./ku.js": 509,
	"./ky": 511,
	"./ky.js": 511,
	"./lb": 512,
	"./lb.js": 512,
	"./lo": 513,
	"./lo.js": 513,
	"./lt": 514,
	"./lt.js": 514,
	"./lv": 515,
	"./lv.js": 515,
	"./me": 516,
	"./me.js": 516,
	"./mi": 517,
	"./mi.js": 517,
	"./mk": 518,
	"./mk.js": 518,
	"./ml": 519,
	"./ml.js": 519,
	"./mn": 520,
	"./mn.js": 520,
	"./mr": 521,
	"./mr.js": 521,
	"./ms": 522,
	"./ms-my": 523,
	"./ms-my.js": 523,
	"./ms.js": 522,
	"./mt": 524,
	"./mt.js": 524,
	"./my": 525,
	"./my.js": 525,
	"./nb": 526,
	"./nb.js": 526,
	"./ne": 527,
	"./ne.js": 527,
	"./nl": 528,
	"./nl-be": 529,
	"./nl-be.js": 529,
	"./nl.js": 528,
	"./nn": 530,
	"./nn.js": 530,
	"./oc-lnc": 531,
	"./oc-lnc.js": 531,
	"./pa-in": 532,
	"./pa-in.js": 532,
	"./pl": 533,
	"./pl.js": 533,
	"./pt": 534,
	"./pt-br": 535,
	"./pt-br.js": 535,
	"./pt.js": 534,
	"./ro": 536,
	"./ro.js": 536,
	"./ru": 537,
	"./ru.js": 537,
	"./sd": 538,
	"./sd.js": 538,
	"./se": 539,
	"./se.js": 539,
	"./si": 540,
	"./si.js": 540,
	"./sk": 541,
	"./sk.js": 541,
	"./sl": 542,
	"./sl.js": 542,
	"./sq": 543,
	"./sq.js": 543,
	"./sr": 544,
	"./sr-cyrl": 545,
	"./sr-cyrl.js": 545,
	"./sr.js": 544,
	"./ss": 546,
	"./ss.js": 546,
	"./sv": 547,
	"./sv.js": 547,
	"./sw": 548,
	"./sw.js": 548,
	"./ta": 549,
	"./ta.js": 549,
	"./te": 550,
	"./te.js": 550,
	"./tet": 551,
	"./tet.js": 551,
	"./tg": 552,
	"./tg.js": 552,
	"./th": 553,
	"./th.js": 553,
	"./tk": 554,
	"./tk.js": 554,
	"./tl-ph": 555,
	"./tl-ph.js": 555,
	"./tlh": 556,
	"./tlh.js": 556,
	"./tr": 557,
	"./tr.js": 557,
	"./tzl": 558,
	"./tzl.js": 558,
	"./tzm": 559,
	"./tzm-latn": 560,
	"./tzm-latn.js": 560,
	"./tzm.js": 559,
	"./ug-cn": 561,
	"./ug-cn.js": 561,
	"./uk": 562,
	"./uk.js": 562,
	"./ur": 563,
	"./ur.js": 563,
	"./uz": 564,
	"./uz-latn": 565,
	"./uz-latn.js": 565,
	"./uz.js": 564,
	"./vi": 566,
	"./vi.js": 566,
	"./x-pseudo": 567,
	"./x-pseudo.js": 567,
	"./yo": 568,
	"./yo.js": 568,
	"./zh-cn": 569,
	"./zh-cn.js": 569,
	"./zh-hk": 570,
	"./zh-hk.js": 570,
	"./zh-mo": 571,
	"./zh-mo.js": 571,
	"./zh-tw": 572,
	"./zh-tw.js": 572
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1069;

/***/ }),
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"NowShowingSlider"},[_c('div',{staticClass:"row py-2 menu-tab"},[_c('div',{staticClass:"col-3 text-center px-1",on:{"click":function($event){return _vm.bottomTab('1')}}},[_c('svg',{staticStyle:{"enable-background":"new 0 0 512 512","width":"25px"},attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 512 512","fill":_vm.selectedBottomTab.indexOf('1') >= 0 ? '#E70D01' : '#777',"xml:space":"preserve"}},[_c('g',[_c('g',[_c('path',{attrs:{"d":"M506.555,208.064L263.859,30.367c-4.68-3.426-11.038-3.426-15.716,0L5.445,208.064\n\t\t\tc-5.928,4.341-7.216,12.665-2.875,18.593s12.666,7.214,18.593,2.875L256,57.588l234.837,171.943c2.368,1.735,5.12,2.57,7.848,2.57\n\t\t\tc4.096,0,8.138-1.885,10.744-5.445C513.771,220.729,512.483,212.405,506.555,208.064z"}})])]),_vm._v(" "),_c('g',[_c('g',[_c('path',{attrs:{"d":"M442.246,232.543c-7.346,0-13.303,5.956-13.303,13.303v211.749H322.521V342.009c0-36.68-29.842-66.52-66.52-66.52\n\t\t\ts-66.52,29.842-66.52,66.52v115.587H83.058V245.847c0-7.347-5.957-13.303-13.303-13.303s-13.303,5.956-13.303,13.303v225.053\n\t\t\tc0,7.347,5.957,13.303,13.303,13.303h133.029c6.996,0,12.721-5.405,13.251-12.267c0.032-0.311,0.052-0.651,0.052-1.036v-128.89\n\t\t\tc0-22.009,17.905-39.914,39.914-39.914s39.914,17.906,39.914,39.914v128.89c0,0.383,0.02,0.717,0.052,1.024\n\t\t\tc0.524,6.867,6.251,12.279,13.251,12.279h133.029c7.347,0,13.303-5.956,13.303-13.303V245.847\n\t\t\tC455.549,238.499,449.593,232.543,442.246,232.543z"}})])])]),_vm._v(" "),_c('div',{staticClass:"menu-text",class:_vm.selectedBottomTab.indexOf('1') >= 0 ? 'active' : ''},[_vm._v("\n          Movies\n        ")])]),_vm._v(" "),_c('div',{staticClass:"col-3 text-center px-1",on:{"click":function($event){return _vm.bottomTab('5')}}},[_c('svg',{attrs:{"height":"20pt","viewBox":"0 -66 512 512","width":"20pt","xmlns":"http://www.w3.org/2000/svg","fill":_vm.selectedBottomTab.indexOf('5') >= 0 ? '#E70D01' : '#777'}},[_c('path',{attrs:{"d":"m69.785156 20c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-.019531c-5.523437 0-9.992187 4.476562-9.992187 10s4.488281 10 10.011718 10zm0 0"}}),_vm._v(" "),_c('path',{attrs:{"d":"m502 284c5.523438 0 10-4.476562 10-10v-264c0-5.523438-4.476562-10-10-10h-392c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10h382v244h-44.960938c-4.5-18.34375-21.074218-32-40.789062-32h-57.5c-12.808594 0-24.289062 5.769531-32 14.839844-7.710938-9.070313-19.191406-14.839844-32-14.839844h-57.5c-12.808594 0-24.289062 5.769531-32 14.839844-7.710938-9.070313-19.191406-14.839844-32-14.839844h-57.5c-19.714844 0-36.289062 13.652344-40.789062 32h-44.960938v-244h21.035156c5.519532 0 10-4.476562 10-10s-4.480468-10-10-10h-31.035156c-5.523438 0-10 4.476562-10 10v264c0 5.523438 4.476562 10 10 10h53.75v12h-15.75c-23.15625 0-42 18.839844-42 42v32c0 5.523438 4.480469 10 10 10h386c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-11.5v-22c0-12.128906 9.871094-22 22-22h57.5c12.132812 0 22 9.867188 22 22v22h-21.035156c-5.519532 0-10 4.476562-10 10s4.480468 10 10 10h31.035156c5.523438 0 10-4.476562 10-10v-32c0-23.160156-18.839844-42-42-42h-21.75v-12zm-274.75-32h57.5c12.132812 0 22 9.871094 22 22v22h-15.75c-12.808594 0-24.289062 5.769531-32 14.839844-7.710938-9.070313-19.191406-14.839844-32-14.839844h-21.75v-22c0-12.128906 9.867188-22 22-22zm-143.5 22c0-12.128906 9.867188-22 22-22h57.5c12.128906 0 22 9.871094 22 22v22h-15.75c-12.808594 0-24.289062 5.769531-32 14.839844-7.710938-9.070313-19.191406-14.839844-32-14.839844h-21.75zm-57.75 86v-22c0-12.128906 9.871094-22 22-22h57.5c12.132812 0 22 9.867188 22 22v22zm121.5 0v-22c0-12.128906 9.871094-22 22-22h57.5c12.132812 0 22 9.867188 22 22v22zm121.5 0v-22c0-12.128906 9.871094-22 22-22h57.5c12.132812 0 22 9.867188 22 22v22zm143.5-64c-12.808594 0-24.289062 5.769531-32 14.839844-7.710938-9.070313-19.191406-14.839844-32-14.839844h-21.75v-22c0-12.128906 9.871094-22 22-22h57.5c12.132812 0 22 9.871094 22 22v22zm0 0"}}),_vm._v(" "),_c('path',{attrs:{"d":"m442.214844 360c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10h.019531c5.523437 0 9.992187-4.476562 9.992187-10s-4.488281-10-10.011718-10zm0 0"}}),_vm._v(" "),_c('path',{attrs:{"d":"m210.078125 202.378906c3.125 1.808594 6.554687 2.710938 9.984375 2.710938 3.417969 0 6.832031-.898438 9.949219-2.691406l91.984375-53.105469c6.144531-3.550781 9.957031-10.183594 9.953125-17.308594-.007813-7.207031-3.742188-13.664063-9.988281-17.261719-15.21875-8.785156-30.4375-17.578125-45.65625-26.371094-15.132813-8.742187-30.265626-17.484374-45.402344-26.222656-6.078125-3.933594-13.792969-4.265625-20.238282-.847656-6.546874 3.476562-10.613281 10.238281-10.613281 17.652344l.042969 106.164062c-.007812 7.199219 3.726562 13.660156 9.984375 17.28125zm9.988281-123.441406c.1875.128906.382813.25.582032.363281 15.21875 8.789063 30.4375 17.578125 45.652343 26.371094 15.1875 8.773437 30.371094 17.542969 45.613281 26.347656l-91.820312 53.011719-.039062-106.089844c.003906 0 .007812-.003906.011718-.003906zm0 0"}})]),_vm._v(" "),_c('div',{staticClass:"menu-text",class:_vm.selectedBottomTab.indexOf('5') >= 0 ? 'active' : ''},[_vm._v("\n          Cinema\n        ")])]),_vm._v(" "),_c('div',{staticClass:"col-3 text-center px-1",on:{"click":function($event){return _vm.bottomTab('3')}}},[_c('svg',{staticStyle:{"enable-background":"new 0 0 349.158 349.158","width":"25px"},attrs:{"version":"1.1","id":"Capa_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 349.158 349.158","xml:space":"preserve","fill":_vm.selectedBottomTab.indexOf('3') >= 0 ? '#E70D01' : '#777'}},[_c('g',[_c('g',[_c('path',{attrs:{"d":"M341.658,6.227H83.455c-4.143,0-7.5,3.357-7.5,7.5V162.83H7.5c-4.143,0-7.5,3.357-7.5,7.5v127.123\n\t\t\tc0,25.076,20.4,45.479,45.477,45.479c0.646,0,258.203,0,258.203,0c25.076,0,45.479-20.402,45.479-45.479V13.727\n\t\t\tC349.158,9.584,345.801,6.227,341.658,6.227z M15,297.453V177.83h60.955v119.623c0,16.805-13.672,30.479-30.479,30.479\n\t\t\tC28.672,327.932,15,314.258,15,297.453z M334.158,297.453c0,16.805-13.672,30.479-30.479,30.479H79.203\n\t\t\tc7.299-8.07,11.752-18.766,11.752-30.479V21.227h243.203V297.453z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M202.023,92.855h96.127c4.143,0,7.5-3.357,7.5-7.5c0-4.143-3.357-7.5-7.5-7.5h-96.127c-4.143,0-7.5,3.357-7.5,7.5\n\t\t\tC194.523,89.498,197.881,92.855,202.023,92.855z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M202.023,175.248h96.127c4.143,0,7.5-3.357,7.5-7.5c0-4.143-3.357-7.5-7.5-7.5h-96.127c-4.143,0-7.5,3.357-7.5,7.5\n\t\t\tC194.523,171.891,197.881,175.248,202.023,175.248z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M202.023,257.643h96.127c4.143,0,7.5-3.357,7.5-7.5c0-4.143-3.357-7.5-7.5-7.5h-96.127c-4.143,0-7.5,3.357-7.5,7.5\n\t\t\tC194.523,254.285,197.881,257.643,202.023,257.643z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M132.814,101.295c1.418,1.5,3.391,2.35,5.453,2.35c0.02,0,0.041,0,0.063,0c2.086-0.018,4.07-0.902,5.477-2.443\n\t\t\tl41.197-45.121c2.793-3.059,2.576-7.803-0.482-10.596c-3.059-2.791-7.803-2.576-10.596,0.482l-35.752,39.156l-11.129-11.785\n\t\t\tc-2.846-3.012-7.594-3.146-10.604-0.303c-3.012,2.844-3.146,7.59-0.303,10.602L132.814,101.295z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M173.926,131.941l-35.752,39.154l-11.131-11.783c-2.844-3.014-7.592-3.148-10.602-0.303\n\t\t\tc-3.012,2.844-3.146,7.59-0.303,10.602l16.676,17.656c1.418,1.5,3.391,2.35,5.453,2.35c0.02,0,0.041,0,0.063,0\n\t\t\tc2.086-0.018,4.07-0.902,5.477-2.443l41.197-45.119c2.791-3.059,2.576-7.803-0.482-10.596S176.719,128.881,173.926,131.941z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M173.926,217.914l-35.752,39.154l-11.131-11.783c-2.844-3.014-7.592-3.149-10.602-0.303\n\t\t\tc-3.012,2.844-3.146,7.59-0.303,10.602l16.676,17.656c1.418,1.5,3.391,2.35,5.453,2.35c0.02,0,0.041,0,0.063,0\n\t\t\tc2.086-0.018,4.07-0.902,5.477-2.443l41.197-45.119c2.791-3.059,2.576-7.803-0.482-10.596\n\t\t\tC181.463,214.639,176.719,214.855,173.926,217.914z"}})])])]),_vm._v(" "),_c('div',{staticClass:"menu-text",class:_vm.selectedBottomTab.indexOf('3') >= 0 ? 'active' : ''},[_vm._v("\n          My transaction\n        ")])]),_vm._v(" "),_c('div',{staticClass:"col-3 text-center px-1",on:{"click":function($event){return _vm.bottomTab('4')}}},[_c('svg',{staticStyle:{"enable-background":"new 0 0 512.003 512.003"},attrs:{"height":"25","viewBox":"0 0 480 480","width":"30","xmlns":"http://www.w3.org/2000/svg","fill":_vm.selectedBottomTab.indexOf('4') >= 0 ? '#E70D01' : '#777'}},[_c('path',{attrs:{"d":"m240 0c-132.546875 0-240 107.453125-240 240s107.453125 240 240 240c7.230469 0 14.433594-.324219 21.601562-.96875 6.664063-.597656 13.269532-1.511719 19.824219-2.65625l2.519531-.445312c121.863282-22.742188 206.359376-134.550782 194.960938-257.996094-11.398438-123.445313-114.9375-217.8945315-238.90625-217.933594zm-19.28125 463.152344h-.566406c-6.222656-.550782-12.398438-1.382813-18.519532-2.449219-.351562-.0625-.703124-.101563-1.046874-.167969-5.984376-1.070312-11.90625-2.398437-17.769532-3.949218l-1.417968-.363282c-5.71875-1.550781-11.375-3.351562-16.949219-5.351562-.578125-.207032-1.160157-.390625-1.738281-.605469-5.464844-2.007813-10.832032-4.257813-16.117188-6.691406-.65625-.292969-1.3125-.574219-1.96875-.886719-5.183594-2.398438-10.265625-5.101562-15.25-7.945312-.703125-.398438-1.414062-.796876-2.117188-1.191407-4.90625-2.863281-9.699218-5.933593-14.402343-9.175781-.710938-.496094-1.429688-.976562-2.136719-1.472656-4.621094-3.277344-9.125-6.757813-13.511719-10.398438l-1.207031-1.054687v-67.449219c.058594-48.578125 39.421875-87.941406 88-88h112c48.578125.058594 87.941406 39.421875 88 88v67.457031l-1.0625.886719c-4.472656 3.734375-9.0625 7.265625-13.777344 10.601562-.625.4375-1.257812.855469-1.878906 1.285157-4.757812 3.304687-9.632812 6.414062-14.625 9.335937-.625.363282-1.265625.707032-1.886719 1.066406-5.058593 2.878907-10.203125 5.597657-15.449219 8.046876-.601562.28125-1.207031.542968-1.816406.800781-5.328125 2.457031-10.742187 4.71875-16.246094 6.742187-.546874.203125-1.097656.378906-1.601562.570313-5.601562 2.007812-11.28125 3.824219-17.03125 5.382812l-1.378906.34375c-5.871094 1.550781-11.796875 2.886719-17.789063 3.960938-.34375.0625-.6875.105469-1.03125.160156-6.128906 1.070313-12.3125 1.902344-18.539062 2.457031h-.566407c-6.398437.550782-12.800781.847656-19.28125.847656-6.480468 0-12.933593-.242187-19.320312-.792968zm179.28125-66.527344v-52.625c-.066406-57.410156-46.589844-103.933594-104-104h-112c-57.410156.066406-103.933594 46.589844-104 104v52.617188c-86.164062-87.941407-85.203125-228.9375 2.148438-315.699219 87.351562-86.757813 228.351562-86.757813 315.703124 0 87.351563 86.761719 88.3125 227.757812 2.148438 315.699219zm0 0"}}),_vm._v(" "),_c('path',{attrs:{"d":"m240 64c-44.183594 0-80 35.816406-80 80s35.816406 80 80 80 80-35.816406 80-80c-.046875-44.164062-35.835938-79.953125-80-80zm0 144c-35.347656 0-64-28.652344-64-64s28.652344-64 64-64 64 28.652344 64 64c-.039062 35.328125-28.671875 63.960938-64 64zm0 0"}})]),_vm._v(" "),_c('div',{staticClass:"menu-text",class:_vm.selectedBottomTab.indexOf('4') >= 0 ? 'active' : ''},[_vm._v("\n          My Profile\n        ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sticky-top"},[_c('cookie-law',{attrs:{"theme":"dark-lime","position":"top","buttonText":""},scopedSlots:_vm._u([{key:"default",fn:function(props){return _c('div',{staticClass:"width-100"},[_c('div',[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-12 col-lg-4"},[_c('h4',[_vm._v("This website uses cookies")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6"},[_c('p',{staticClass:"cookie-text"},[_vm._v("\n              By continuing to browse this website you are agreeing to our use\n              of cookies. Find out more by reading our\n              "),_c('router-link',{staticStyle:{"color":"white"},attrs:{"to":"/cookiesprivacyPolicy"}},[_c('u',[_vm._v("Cookie Policy")]),_vm._v(".\n              ")])],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-2"},[_c('img',{attrs:{"src":__webpack_require__(1101),"height":"30","width":"30"},on:{"click":props.accept}})])])])])}}])}),_vm._v(" "),_c('b-modal',{ref:"countryModalRef",attrs:{"id":"countryModal","hide-header":"","hide-footer":""}},[_c('div',{staticClass:"modal-title"},[_vm._v("Choose your country")]),_vm._v(" "),_c('div',{staticClass:"p-3"},[_c('div',{staticClass:"row"},_vm._l((_vm.countries),function(country,index){return _c('div',{key:index,staticClass:"text-center col",attrs:{"index":index}},[_c('h6',{staticClass:"pt-3"},[_vm._v(_vm._s(country.country_name))])])}),0)])]),_vm._v(" "),_c('aside',{staticClass:"d-lg-none w-90",style:({ right: _vm.rightOpen })},[_c('svg',{staticClass:"c-pointer",attrs:{"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},on:{"click":function($event){return _vm.openSideNav()}}},[_c('path',{attrs:{"d":"M0.353415 6.15663C-0.120763 6.63629 -0.117059 7.41472 0.360136 7.89374L6.011 13.5663C7.33072 14.8814 9.31047 12.9086 7.99075 11.5935L5.52536 9.13668C5.11419 8.72695 5.2524 8.3948 5.8273 8.3948H12.6001C13.3736 8.3948 14 7.77055 14 6.99983C14 6.22945 13.3736 5.60485 12.6001 5.60485H5.8273C5.24938 5.60485 5.1123 5.27462 5.52536 4.86305L7.99075 2.40652C9.31047 1.09141 7.33072 -0.881435 6.011 0.433678L0.353415 6.15663Z","fill":"white"}})]),_vm._v(" "),(_vm.isUserLoggedIn)?_c('div',{staticClass:"d-flex justify-content-between align-items-center"}):_vm._e(),_vm._v(" "),(!_vm.isUserLoggedIn)?_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-4 mt-3"},[_c('h6',{staticClass:"mb-0 font-weight-bold"},[_vm._v("Hello Friend !")]),_vm._v(" "),_c('div',[_c('router-link',{staticClass:"small text-white",attrs:{"to":"#"},nativeOn:{"click":function($event){_vm.openSideNav();
            _vm.showSignUp();}}},[_vm._v("Sign Up")]),_vm._v(" "),_c('span',[_vm._v("|")]),_vm._v(" "),_c('router-link',{staticClass:"small text-white",attrs:{"to":"#"},nativeOn:{"click":function($event){_vm.openSideNav();
            _vm.checkSignIn();}}},[_vm._v("Sign In")])],1)]):_vm._e(),_vm._v(" "),_c('ul',{staticClass:"profileMenu-list"},[_c('li',[_c('router-link',{class:[_vm.$route.path == 'myaccount' ? 'active' : ''],attrs:{"to":_vm.isUserLoggedIn ? '/profile/myaccount' : '#'},nativeOn:{"click":function($event){_vm.openSideNav();
            _vm.checkSignIn();}}},[_c('div',[_c('svg',{attrs:{"width":"16","height":"16","viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0.577834 5.00569C1.7963 1.97785 4.73412 -0.00409475 7.99771 1.35e-05C11.2621 -0.00596662 14.2017 1.9753 15.4213 5.00357C16.641 8.03183 15.8952 11.4976 13.538 13.7561C13.5358 13.7583 13.5342 13.761 13.5327 13.7637C13.5318 13.7654 13.5308 13.767 13.5298 13.7686C13.529 13.7696 13.5281 13.7706 13.5271 13.7715C13.5012 13.7965 13.474 13.8193 13.4469 13.842L13.4469 13.842L13.4469 13.8421C13.4256 13.8599 13.4043 13.8778 13.3838 13.8966C13.2552 14.0154 13.1267 14.1308 12.9913 14.2394C12.9494 14.273 12.9066 14.3044 12.8636 14.3359C12.8321 14.3589 12.8005 14.382 12.7691 14.4062L12.7691 14.4062C12.6411 14.5016 12.5132 14.597 12.3795 14.6849C12.3172 14.7277 12.2536 14.7656 12.1897 14.8036C12.1604 14.821 12.1312 14.8384 12.1019 14.8563L12.0698 14.8757L12.0698 14.8757C11.9572 14.9436 11.8447 15.0113 11.7284 15.0734C11.6481 15.1159 11.5665 15.154 11.4848 15.1921C11.4567 15.2052 11.4286 15.2183 11.4005 15.2316L11.3252 15.2674L11.3251 15.2674C11.2304 15.3125 11.1356 15.3576 11.0395 15.3973C10.9404 15.4383 10.8341 15.4754 10.7351 15.51L10.735 15.51L10.6687 15.5333C10.6351 15.5452 10.6015 15.5573 10.5678 15.5695C10.4852 15.5995 10.4023 15.6295 10.3174 15.6555C10.2102 15.6878 10.1008 15.7143 9.99147 15.7407L9.9073 15.7612C9.85839 15.7722 9.80947 15.7848 9.76055 15.7974L9.76053 15.7974L9.76042 15.7974C9.69514 15.8142 9.62985 15.831 9.56457 15.844C9.42702 15.8715 9.28773 15.8902 9.14821 15.9089L9.08703 15.9172C9.05027 15.9223 9.01383 15.9282 8.97741 15.934L8.9774 15.934L8.97738 15.934C8.9159 15.944 8.85448 15.9539 8.79171 15.96C8.53009 15.9857 8.26618 16 8 16C7.73381 16 7.4699 15.9857 7.20828 15.96C7.14551 15.9539 7.08409 15.944 7.02261 15.934L7.02257 15.934C6.98616 15.9282 6.94972 15.9223 6.91296 15.9172L6.85179 15.9089C6.71227 15.8902 6.57298 15.8715 6.43542 15.844C6.35415 15.8283 6.27615 15.8081 6.19803 15.7879L6.19798 15.7879L6.19787 15.7879L6.19778 15.7879C6.16287 15.7789 6.12794 15.7698 6.09269 15.7612L6.00851 15.7407L6.00849 15.7407L6.00847 15.7407C5.8992 15.7143 5.78979 15.6878 5.68255 15.6555C5.59165 15.6277 5.50771 15.5972 5.41786 15.5646L5.41783 15.5646L5.33125 15.5333C5.2984 15.5215 5.26563 15.5101 5.23292 15.4987L5.23282 15.4986L5.2328 15.4986L5.23278 15.4986C5.14157 15.4668 5.05089 15.4351 4.96053 15.3973C4.84926 15.3507 4.74175 15.2995 4.63331 15.2478L4.59952 15.2316C4.57142 15.2183 4.54328 15.2052 4.51515 15.1921C4.4335 15.154 4.35194 15.1159 4.27164 15.0734C4.15533 15.0113 4.04283 14.9436 3.93023 14.8757L3.89806 14.8563L3.85165 14.8279L3.85149 14.8278C3.77381 14.7802 3.69614 14.7326 3.62044 14.6849C3.4868 14.597 3.35887 14.5016 3.23094 14.4062L3.23092 14.4062L3.2309 14.4062L3.23087 14.4062C3.15661 14.3536 3.08121 14.2965 3.00867 14.2394C2.90314 14.1534 2.80177 14.0626 2.70132 13.9726L2.61624 13.8966C2.59564 13.8778 2.57439 13.8599 2.5531 13.8421L2.55307 13.842L2.55306 13.842C2.52594 13.8193 2.49878 13.7965 2.47286 13.7715C2.47049 13.7694 2.46889 13.7666 2.46726 13.7637C2.46574 13.761 2.46421 13.7583 2.46201 13.7561C0.10539 11.4982 -0.640628 8.03353 0.577834 5.00569ZM9.10759 7.69552C9.11102 7.69209 9.11445 7.69209 9.1173 7.69209C10.0229 7.18283 10.471 6.12662 10.2078 5.12145C9.94458 4.11629 9.03641 3.41526 7.99743 3.41526C6.95845 3.41526 6.05027 4.11629 5.78707 5.12145C5.52387 6.12662 5.97192 7.18283 6.87755 7.69209L6.88783 7.69552C7.0393 7.77985 7.1994 7.84765 7.36537 7.89775C7.37982 7.90169 7.39331 7.90624 7.40661 7.91072L7.40664 7.91073L7.40665 7.91074C7.42224 7.916 7.43758 7.92116 7.45391 7.92517C7.50578 7.9384 7.55947 7.948 7.61093 7.9572L7.62985 7.96059C7.74065 7.97996 7.85271 7.99122 7.96515 7.99429H8.03027C8.14271 7.99122 8.25478 7.97996 8.36558 7.96059L8.37228 7.95942C8.42896 7.94952 8.48656 7.93946 8.54151 7.92517C8.56023 7.92075 8.57753 7.9149 8.59474 7.90909C8.60642 7.90514 8.61805 7.90121 8.63005 7.89775C8.79602 7.84765 8.95612 7.77985 9.10759 7.69552ZM9.45261 8.81177C11.2936 9.43416 12.5419 11.1501 12.5675 13.0934L12.5441 13.1148C12.5283 13.1293 12.5126 13.1438 12.4961 13.158C12.3921 13.2494 12.2847 13.3362 12.1762 13.4202C12.1122 13.4693 12.0482 13.5179 11.9825 13.5647C11.8792 13.6395 11.7741 13.7104 11.6672 13.7784C11.5896 13.8281 11.5101 13.876 11.4302 13.9229C11.3296 13.98 11.2274 14.0371 11.124 14.0943C11.0326 14.1411 10.9395 14.1851 10.8458 14.2285C10.7521 14.2719 10.6487 14.3182 10.5476 14.3588C10.4465 14.3993 10.3391 14.4376 10.2335 14.473L10.1839 14.4901C10.1039 14.5177 10.0237 14.5454 9.94272 14.5696C9.84003 14.6004 9.73318 14.6261 9.62675 14.6517L9.59085 14.6604C9.56177 14.6672 9.53281 14.6743 9.50385 14.6814C9.44065 14.6969 9.37748 14.7124 9.31323 14.7249C9.18537 14.7498 9.05496 14.7674 8.92393 14.7852L8.90081 14.7883C8.87026 14.7923 8.8398 14.7969 8.80932 14.8015L8.80929 14.8015C8.76114 14.8088 8.71295 14.816 8.66433 14.8209C8.44498 14.842 8.22277 14.8546 7.99828 14.8546C7.77379 14.8546 7.55159 14.842 7.33224 14.8209C7.28362 14.816 7.23543 14.8088 7.18727 14.8015L7.18724 14.8015C7.15677 14.7969 7.1263 14.7923 7.09575 14.7883L7.07264 14.7852C6.94161 14.7674 6.81119 14.7498 6.68333 14.7249C6.61909 14.7124 6.55592 14.6969 6.49272 14.6814L6.49261 14.6814C6.46369 14.6743 6.43476 14.6672 6.40572 14.6604C6.28748 14.6318 6.1698 14.6033 6.05385 14.5696C5.97288 14.5454 5.8927 14.5177 5.81265 14.4901L5.81264 14.4901L5.76309 14.473C5.65742 14.4364 5.55174 14.3993 5.44892 14.3588C5.3461 14.3182 5.249 14.2736 5.15075 14.2285C5.0525 14.1834 4.96396 14.1411 4.87256 14.0943C4.76917 14.0406 4.66692 13.984 4.56639 13.9229C4.48642 13.876 4.40702 13.8281 4.32933 13.7784C4.22251 13.7104 4.11741 13.6395 4.01402 13.5647C3.94832 13.5179 3.88435 13.4693 3.82037 13.4202C3.71184 13.3362 3.60445 13.2488 3.50049 13.158C3.48411 13.1457 3.4687 13.1312 3.45315 13.1166C3.44485 13.1088 3.4365 13.101 3.42794 13.0934C3.45349 11.1501 4.70181 9.43416 6.54281 8.81177C7.46332 9.24971 8.5321 9.24971 9.45261 8.81177ZM10.5225 8.02286C12.0884 8.80112 13.2143 10.2507 13.5808 11.9606C14.4078 10.8047 14.8524 9.419 14.8524 7.99772C14.8539 5.03815 12.9551 2.4121 10.1443 1.48631C7.33347 0.56051 4.24595 1.54424 2.48864 3.92552C0.731331 6.30679 0.701469 9.54733 2.4146 11.9606C2.78117 10.2507 3.90702 8.80112 5.47291 8.02286C4.21856 6.65635 4.27887 4.53984 5.60899 3.24698C6.93911 1.95413 9.05631 1.95413 10.3864 3.24698C11.7166 4.53984 11.7769 6.65635 10.5225 8.02286Z"}})]),_vm._v("\n            "+_vm._s(_vm.usernameInfo || "My Account")+"\n          ")])])],1),_vm._v(" "),_c('li',[_c('router-link',{class:[_vm.$route.path == 'myNotification' ? 'active' : ''],attrs:{"to":_vm.isUserLoggedIn ? '/profile/myNotification' : '#'},nativeOn:{"click":function($event){_vm.openSideNav();
            _vm.checkSignIn();}}},[_c('div',[_c('svg',{attrs:{"width":"16","height":"18","viewBox":"0 0 16 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16 11.6923C16 12.7112 15.1714 13.5385 14.1508 13.5385H1.8492C0.827975 13.5385 0 12.7124 0 11.6923C0 10.6736 0.827281 9.84615 1.8468 9.84615C1.8456 9.84615 1.84615 6.15361 1.84615 6.15361C1.84615 2.75418 4.6009 0 8 0C11.3991 0 14.1538 2.75484 14.1538 6.15361V9.84562C15.1712 9.84615 16 10.6733 16 11.6923ZM14.1532 11.0769C13.4732 11.0769 12.9231 10.5271 12.9231 9.84562V6.15361C12.9231 3.43456 10.7194 1.23077 8 1.23077C5.28058 1.23077 3.07692 3.43398 3.07692 6.15361V9.84562C3.07692 10.5252 2.5255 11.0769 1.8468 11.0769C1.50709 11.0769 1.23077 11.3533 1.23077 11.6923C1.23077 12.032 1.50709 12.3077 1.8492 12.3077H14.1508C14.4921 12.3077 14.7692 12.031 14.7692 11.6923C14.7692 11.3536 14.492 11.0769 14.1532 11.0769ZM6.46154 14.4615H5.23077C5.23077 15.9909 6.4706 17.2308 8 17.2308C9.5294 17.2308 10.7692 15.9909 10.7692 14.4615H9.53846C9.53846 15.3112 8.84967 16 8 16C7.15033 16 6.46154 15.3112 6.46154 14.4615Z"}})]),_vm._v("\n            Notification\n          ")])])],1),_vm._v(" "),_c('li',[_c('router-link',{class:[_vm.$route.path == 'myTransaction' ? 'active' : ''],attrs:{"to":_vm.isUserLoggedIn ? '/profile/myTransaction' : '#'},nativeOn:{"click":function($event){_vm.openSideNav();
            _vm.checkSignIn();}}},[_c('div',[_c('svg',{attrs:{"width":"19","height":"16","viewBox":"0 0 19 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.97927 0H15.9739C17.2369 0.00205197 18.2602 1.02539 18.2623 2.28838V3.54624C18.2623 3.80353 18.0537 4.01211 17.7964 4.01211H14.6154V13.7116C14.6134 14.9746 13.59 15.9979 12.327 16H2.28838C1.02539 15.9979 0.00205197 14.9746 0 13.7116V12.4538C0 12.1965 0.208579 11.9879 0.465875 11.9879H2.66853V2.31074C2.66956 1.03498 3.70351 0.0010276 4.97927 0ZM0.931749 13.7116C0.932776 14.4604 1.53956 15.0672 2.28838 15.0683H10.4859C10.1952 14.6757 10.0384 14.2001 10.0387 13.7116V12.9196H0.931749V13.7116ZM13.6837 2.28838V13.7116C13.6837 14.4614 13.0759 15.0692 12.3261 15.0692C11.5764 15.0692 10.9686 14.4614 10.9686 13.7116V12.4538C10.9686 12.1965 10.76 11.9879 10.5027 11.9879H3.59469V2.31074C3.59572 1.54957 4.21251 0.932776 4.97368 0.931749H14.1346C13.8423 1.3237 13.6842 1.79944 13.6837 2.28838ZM14.6154 3.08036H17.3305V2.28838C17.3305 1.53862 16.7227 0.930818 15.973 0.930818C15.2232 0.930818 14.6154 1.53862 14.6154 2.28838V3.08036ZM8.03913 5.34265C8.1096 5.4442 8.13682 5.5696 8.1148 5.69122C8.09278 5.81285 8.02333 5.92074 7.92173 5.99115C7.30352 6.42047 6.76708 6.95691 6.33776 7.57512C6.25259 7.6986 6.11317 7.77351 5.9632 7.77638H5.9427C5.78329 7.76959 5.63845 7.6817 5.55882 7.54344C5.40162 7.26823 5.17391 7.03988 4.89914 6.8819C4.67821 6.75239 4.60325 6.46883 4.7313 6.24706C4.85934 6.02528 5.14239 5.94843 5.36501 6.07501C5.58536 6.20209 5.78673 6.35954 5.9632 6.54274C6.38066 6.04147 6.86395 5.59892 7.39995 5.22711C7.60916 5.08626 7.89247 5.13747 8.03913 5.34265ZM12.1481 6.92662C12.4054 6.92662 12.614 6.71805 12.614 6.46075C12.614 6.20345 12.4054 5.99488 12.1481 5.99488H9.52434C9.26705 5.99488 9.05847 6.20345 9.05847 6.46075C9.05847 6.71805 9.26705 6.92662 9.52434 6.92662H12.1481ZM4.7277 3.33007C4.78869 3.22253 4.88993 3.14365 5.00912 3.11079C5.12831 3.07794 5.25567 3.09381 5.36315 3.1549C5.58386 3.28078 5.78584 3.43697 5.9632 3.61891C6.38064 3.11763 6.86393 2.67508 7.39995 2.30328C7.61145 2.15663 7.90179 2.20919 8.04845 2.42068C8.19511 2.63218 8.14255 2.92252 7.93105 3.06918C7.30948 3.49525 6.76924 4.02918 6.3359 4.6457C6.25234 4.77077 6.11354 4.84781 5.9632 4.85255H5.9427C5.78329 4.84576 5.63845 4.75787 5.55882 4.61961C5.40218 4.3478 5.17655 4.12216 4.90473 3.96553C4.79687 3.90484 4.71759 3.80374 4.68438 3.68453C4.65117 3.56531 4.66675 3.43778 4.7277 3.33007ZM12.1481 3.99348C12.4054 3.99348 12.614 3.7849 12.614 3.5276C12.614 3.27031 12.4054 3.06173 12.1481 3.06173H9.52434C9.26705 3.06173 9.05847 3.27031 9.05847 3.5276C9.05847 3.7849 9.26705 3.99348 9.52434 3.99348H12.1481ZM8.03913 8.26648C8.18625 8.47748 8.13453 8.76777 7.9236 8.91498C7.30541 9.34433 6.76898 9.88077 6.33962 10.499C6.25407 10.623 6.11383 10.6979 5.9632 10.7002H5.9427C5.78329 10.6934 5.63845 10.6055 5.55882 10.4673C5.40211 10.1955 5.17649 9.96989 4.90473 9.81318C4.7594 9.73056 4.66948 9.57639 4.66912 9.40922C4.66875 9.24204 4.75799 9.08748 4.90295 9.00422C5.04792 8.92095 5.22638 8.92174 5.3706 9.00629C5.58849 9.13155 5.78792 9.28646 5.9632 9.46657C6.38012 8.96546 6.86277 8.52292 7.39809 8.15094C7.60766 8.00886 7.89235 8.06017 8.03913 8.26648ZM12.1481 9.85045C12.4054 9.85045 12.614 9.64188 12.614 9.38458V9.38272C12.613 9.12615 12.4047 8.9187 12.1481 8.9187H9.52434C9.26705 8.9187 9.05847 9.12728 9.05847 9.38458C9.05847 9.64188 9.26705 9.85045 9.52434 9.85045H12.1481Z"}})]),_vm._v("\n            My Transaction\n          ")])])],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('ul',{staticClass:"sidebar-list"},[_c('li',[_c('router-link',{attrs:{"to":"/hiw"},nativeOn:{"click":function($event){return _vm.openSideNav()}}},[_vm._v("How it Works")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/aboutUs"},nativeOn:{"click":function($event){return _vm.openSideNav()}}},[_vm._v("About Us")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/faqs"},nativeOn:{"click":function($event){return _vm.openSideNav()}}},[_vm._v("FAQs")])],1),_vm._v(" "),_c('li',[(_vm.isUserLoggedIn)?_c('router-link',{attrs:{"to":"#"},nativeOn:{"click":function($event){return _vm.onLogout()}}},[_vm._v("Logout")]):_vm._e()],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"small text-center"},[_vm._v("\n      © "+_vm._s(_vm.DATEYEAR)+" "+_vm._s(_vm.TITLE)+", All Rights Reserved\n    ")])]),_vm._v(" "),(_vm.backdrop)?_c('div',{staticClass:"backdrop",on:{"click":function($event){return _vm.openSideNav()}}}):_vm._e(),_vm._v(" "),_c('section',{staticClass:"containier-fluid bg-color"},[_c('header',[_c('b-navbar',{attrs:{"toggleable":"lg","type":"dark"}},[_c('b-navbar-brand',{staticStyle:{"cursor":"pointer"},on:{"click":_vm.Redirect}},[_c('img',{staticStyle:{"max-width":"110px"},attrs:{"src":__webpack_require__(1102)}})]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center d-lg-none"},[(false)?_c('div',{staticClass:"d-flex align-items-center sc-dropdown"},[_c('b-dropdown',{staticClass:"countrySelectionDropdown",attrs:{"text":_vm.CountryText,"variant":"transparent","right":""}},_vm._l((_vm.countries),function(country,index){return _c('b-dropdown-item',{key:index,attrs:{"index":index},on:{"click":function($event){return _vm.setCountry(country)}}},[_vm._v("\n                "+_vm._s(country.country_name)+"\n              ")])}),1)],1):_vm._e(),_vm._v(" "),_c('img',{staticClass:"mr-2",attrs:{"src":__webpack_require__(1103),"width":"25px","height":"auto"},on:{"click":function($event){return _vm.openSearch(true)}}}),_vm._v(" "),_c('button',{staticClass:"navbar-toggler",staticStyle:{"border":"none !important"},on:{"click":function($event){return _vm.openSideNav()}}},[_c('span',{staticClass:"navbar-toggler-icon"})])]),_vm._v(" "),_c('b-collapse',{attrs:{"is-nav":"","id":"nav_collapse"}},[_c('div',{staticClass:"col-12 col-md-5 col-lg-4 col-xl-4 ml-md-4 ml-lg-3 ml-xl-5 px-0 grp-drop"},[_c('b-input-group',{staticClass:"pr-3"},[_c('b-button',{staticClass:"pr-1",attrs:{"variant":"default"}},[_c('img',{attrs:{"src":__webpack_require__(295),"height":"19","width":"19"}})]),_vm._v(" "),_c('b-form-input',{directives:[{name:"debounce",rawName:"v-debounce:500",value:(_vm.searchData),expression:"searchData",arg:"500"}],staticClass:"px-1",attrs:{"placeholder":"Search for movie"},model:{value:(_vm.searchValue),callback:function ($$v) {_vm.searchValue=$$v},expression:"searchValue"}}),_vm._v(" "),(_vm.Regions)?_c('b-dropdown',{staticClass:"d-none d-md-block",attrs:{"slot":"append","text":_vm.selectedRegion,"variant":"default"},slot:"append"},_vm._l((_vm.Regions),function(region,regionIndex){return _c('b-dropdown-item',{key:regionIndex,on:{"click":function($event){return _vm.onChangeRegion(region)}}},[_vm._v(_vm._s(region.region_name))])}),1):_vm._e()],1),_vm._v(" "),(_vm.searchValue)?_c('ul',{staticClass:"searchListData"},_vm._l((_vm.movieListSearch),function(movie,movieListIndex){return _c('li',{key:movieListIndex},[_c('router-link',{attrs:{"to":{
                    name: 'createScreen',
                    params: {
                      movie_id: movie.movie_id,
                      content_lang_id: movie.content_lang_id,
                    },
                  }},nativeOn:{"click":function($event){return (function () { return (_vm.searchValue = null); }).apply(null, arguments)}}},[_vm._v(_vm._s(movie.movie_title))])],1)}),0):_vm._e()],1),_vm._v(" "),_c('b-navbar-nav',{staticClass:"ml-auto"},[_c('router-link',{staticClass:"px-lg-1 px-xl-2 text-white hA",attrs:{"to":""},nativeOn:{"click":function($event){return _vm.Redirect.apply(null, arguments)}}},[_vm._v("Home")]),_vm._v(" "),_c('router-link',{staticClass:"px-lg-1 px-xl-2 text-white hA",attrs:{"to":"/aboutUs"}},[_vm._v("About Us")]),_vm._v(" "),_c('router-link',{staticClass:"px-lg-1 px-xl-2 text-white hA",attrs:{"to":"/hiw"}},[_vm._v("How it Works")]),_vm._v(" "),_c('router-link',{staticClass:"px-lg-1 px-xl-2 text-white hA",attrs:{"to":"/faqs"}},[_vm._v("FAQs")]),_vm._v(" "),(false)?_c('div',{staticClass:"d-flex align-items-center ml-3 sc-dropdown"},[_c('b-dropdown',{staticClass:"countrySelectionDropdown",attrs:{"text":_vm.CountryText,"variant":"transparent","right":""}},_vm._l((_vm.countries),function(country,index){return _c('b-dropdown-item',{key:index,attrs:{"index":index},on:{"click":function($event){return _vm.setCountry(country)}}},[_vm._v("\n                  "+_vm._s(country.country_name)+"\n                ")])}),1)],1):_vm._e(),_vm._v(" "),(!_vm.isUserLoggedIn)?_c('div',{staticClass:"d-flex align-items-center cus-log-sign"},[_c('div',{staticClass:"px-lg-1 px-xl-2"},[_c('img',{staticClass:"img-fluid signIn-icon",attrs:{"src":__webpack_require__(579)}})]),_vm._v(" "),_c('div',{directives:[{name:"b-modal",rawName:"v-b-modal.signup",modifiers:{"signup":true}}],staticClass:"px-0 text-white mr-1 c-pointer hA header-link",attrs:{"to":""}},[_vm._v("\n                Signup /\n              ")]),_vm._v(" "),_c('div',{directives:[{name:"b-modal",rawName:"v-b-modal.login",modifiers:{"login":true}}],staticClass:"px-0 text-white c-pointer hA header-link",attrs:{"to":""}},[_vm._v("\n                Login\n              ")])]):_vm._e(),_vm._v(" "),(_vm.isUserLoggedIn)?_c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"pl-2"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(579)}})]),_vm._v(" "),_c('div',{staticClass:"px-2 text-white accDrop"},[_c('b-dropdown',{ref:"hovermenu",staticClass:"py-0",attrs:{"slot":"trigger","variant":"default","right":"","no-caret":"","text":_vm.usernameInfo || 'My Account'},slot:"trigger"},[_c('ul',{staticClass:"profileMenu-list"},[_c('li',[_c('router-link',{class:[
                          _vm.$route.path == 'myaccount' ? 'active' : '' ],attrs:{"to":"/profile/myaccount"},nativeOn:{"click":function($event){return _vm.closeMenu()}}},[_c('div',[_c('svg',{attrs:{"width":"16","height":"16","viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0.577834 5.00569C1.7963 1.97785 4.73412 -0.00409475 7.99771 1.35e-05C11.2621 -0.00596662 14.2017 1.9753 15.4213 5.00357C16.641 8.03183 15.8952 11.4976 13.538 13.7561C13.5358 13.7583 13.5342 13.761 13.5327 13.7637C13.5318 13.7654 13.5308 13.767 13.5298 13.7686C13.529 13.7696 13.5281 13.7706 13.5271 13.7715C13.5012 13.7965 13.474 13.8193 13.4469 13.842L13.4469 13.842L13.4469 13.8421C13.4256 13.8599 13.4043 13.8778 13.3838 13.8966C13.2552 14.0154 13.1267 14.1308 12.9913 14.2394C12.9494 14.273 12.9066 14.3044 12.8636 14.3359C12.8321 14.3589 12.8005 14.382 12.7691 14.4062L12.7691 14.4062C12.6411 14.5016 12.5132 14.597 12.3795 14.6849C12.3172 14.7277 12.2536 14.7656 12.1897 14.8036C12.1604 14.821 12.1312 14.8384 12.1019 14.8563L12.0698 14.8757L12.0698 14.8757C11.9572 14.9436 11.8447 15.0113 11.7284 15.0734C11.6481 15.1159 11.5665 15.154 11.4848 15.1921C11.4567 15.2052 11.4286 15.2183 11.4005 15.2316L11.3252 15.2674L11.3251 15.2674C11.2304 15.3125 11.1356 15.3576 11.0395 15.3973C10.9404 15.4383 10.8341 15.4754 10.7351 15.51L10.735 15.51L10.6687 15.5333C10.6351 15.5452 10.6015 15.5573 10.5678 15.5695C10.4852 15.5995 10.4023 15.6295 10.3174 15.6555C10.2102 15.6878 10.1008 15.7143 9.99147 15.7407L9.9073 15.7612C9.85839 15.7722 9.80947 15.7848 9.76055 15.7974L9.76053 15.7974L9.76042 15.7974C9.69514 15.8142 9.62985 15.831 9.56457 15.844C9.42702 15.8715 9.28773 15.8902 9.14821 15.9089L9.08703 15.9172C9.05027 15.9223 9.01383 15.9282 8.97741 15.934L8.9774 15.934L8.97738 15.934C8.9159 15.944 8.85448 15.9539 8.79171 15.96C8.53009 15.9857 8.26618 16 8 16C7.73381 16 7.4699 15.9857 7.20828 15.96C7.14551 15.9539 7.08409 15.944 7.02261 15.934L7.02257 15.934C6.98616 15.9282 6.94972 15.9223 6.91296 15.9172L6.85179 15.9089C6.71227 15.8902 6.57298 15.8715 6.43542 15.844C6.35415 15.8283 6.27615 15.8081 6.19803 15.7879L6.19798 15.7879L6.19787 15.7879L6.19778 15.7879C6.16287 15.7789 6.12794 15.7698 6.09269 15.7612L6.00851 15.7407L6.00849 15.7407L6.00847 15.7407C5.8992 15.7143 5.78979 15.6878 5.68255 15.6555C5.59165 15.6277 5.50771 15.5972 5.41786 15.5646L5.41783 15.5646L5.33125 15.5333C5.2984 15.5215 5.26563 15.5101 5.23292 15.4987L5.23282 15.4986L5.2328 15.4986L5.23278 15.4986C5.14157 15.4668 5.05089 15.4351 4.96053 15.3973C4.84926 15.3507 4.74175 15.2995 4.63331 15.2478L4.59952 15.2316C4.57142 15.2183 4.54328 15.2052 4.51515 15.1921C4.4335 15.154 4.35194 15.1159 4.27164 15.0734C4.15533 15.0113 4.04283 14.9436 3.93023 14.8757L3.89806 14.8563L3.85165 14.8279L3.85149 14.8278C3.77381 14.7802 3.69614 14.7326 3.62044 14.6849C3.4868 14.597 3.35887 14.5016 3.23094 14.4062L3.23092 14.4062L3.2309 14.4062L3.23087 14.4062C3.15661 14.3536 3.08121 14.2965 3.00867 14.2394C2.90314 14.1534 2.80177 14.0626 2.70132 13.9726L2.61624 13.8966C2.59564 13.8778 2.57439 13.8599 2.5531 13.8421L2.55307 13.842L2.55306 13.842C2.52594 13.8193 2.49878 13.7965 2.47286 13.7715C2.47049 13.7694 2.46889 13.7666 2.46726 13.7637C2.46574 13.761 2.46421 13.7583 2.46201 13.7561C0.10539 11.4982 -0.640628 8.03353 0.577834 5.00569ZM9.10759 7.69552C9.11102 7.69209 9.11445 7.69209 9.1173 7.69209C10.0229 7.18283 10.471 6.12662 10.2078 5.12145C9.94458 4.11629 9.03641 3.41526 7.99743 3.41526C6.95845 3.41526 6.05027 4.11629 5.78707 5.12145C5.52387 6.12662 5.97192 7.18283 6.87755 7.69209L6.88783 7.69552C7.0393 7.77985 7.1994 7.84765 7.36537 7.89775C7.37982 7.90169 7.39331 7.90624 7.40661 7.91072L7.40664 7.91073L7.40665 7.91074C7.42224 7.916 7.43758 7.92116 7.45391 7.92517C7.50578 7.9384 7.55947 7.948 7.61093 7.9572L7.62985 7.96059C7.74065 7.97996 7.85271 7.99122 7.96515 7.99429H8.03027C8.14271 7.99122 8.25478 7.97996 8.36558 7.96059L8.37228 7.95942C8.42896 7.94952 8.48656 7.93946 8.54151 7.92517C8.56023 7.92075 8.57753 7.9149 8.59474 7.90909C8.60642 7.90514 8.61805 7.90121 8.63005 7.89775C8.79602 7.84765 8.95612 7.77985 9.10759 7.69552ZM9.45261 8.81177C11.2936 9.43416 12.5419 11.1501 12.5675 13.0934L12.5441 13.1148C12.5283 13.1293 12.5126 13.1438 12.4961 13.158C12.3921 13.2494 12.2847 13.3362 12.1762 13.4202C12.1122 13.4693 12.0482 13.5179 11.9825 13.5647C11.8792 13.6395 11.7741 13.7104 11.6672 13.7784C11.5896 13.8281 11.5101 13.876 11.4302 13.9229C11.3296 13.98 11.2274 14.0371 11.124 14.0943C11.0326 14.1411 10.9395 14.1851 10.8458 14.2285C10.7521 14.2719 10.6487 14.3182 10.5476 14.3588C10.4465 14.3993 10.3391 14.4376 10.2335 14.473L10.1839 14.4901C10.1039 14.5177 10.0237 14.5454 9.94272 14.5696C9.84003 14.6004 9.73318 14.6261 9.62675 14.6517L9.59085 14.6604C9.56177 14.6672 9.53281 14.6743 9.50385 14.6814C9.44065 14.6969 9.37748 14.7124 9.31323 14.7249C9.18537 14.7498 9.05496 14.7674 8.92393 14.7852L8.90081 14.7883C8.87026 14.7923 8.8398 14.7969 8.80932 14.8015L8.80929 14.8015C8.76114 14.8088 8.71295 14.816 8.66433 14.8209C8.44498 14.842 8.22277 14.8546 7.99828 14.8546C7.77379 14.8546 7.55159 14.842 7.33224 14.8209C7.28362 14.816 7.23543 14.8088 7.18727 14.8015L7.18724 14.8015C7.15677 14.7969 7.1263 14.7923 7.09575 14.7883L7.07264 14.7852C6.94161 14.7674 6.81119 14.7498 6.68333 14.7249C6.61909 14.7124 6.55592 14.6969 6.49272 14.6814L6.49261 14.6814C6.46369 14.6743 6.43476 14.6672 6.40572 14.6604C6.28748 14.6318 6.1698 14.6033 6.05385 14.5696C5.97288 14.5454 5.8927 14.5177 5.81265 14.4901L5.81264 14.4901L5.76309 14.473C5.65742 14.4364 5.55174 14.3993 5.44892 14.3588C5.3461 14.3182 5.249 14.2736 5.15075 14.2285C5.0525 14.1834 4.96396 14.1411 4.87256 14.0943C4.76917 14.0406 4.66692 13.984 4.56639 13.9229C4.48642 13.876 4.40702 13.8281 4.32933 13.7784C4.22251 13.7104 4.11741 13.6395 4.01402 13.5647C3.94832 13.5179 3.88435 13.4693 3.82037 13.4202C3.71184 13.3362 3.60445 13.2488 3.50049 13.158C3.48411 13.1457 3.4687 13.1312 3.45315 13.1166C3.44485 13.1088 3.4365 13.101 3.42794 13.0934C3.45349 11.1501 4.70181 9.43416 6.54281 8.81177C7.46332 9.24971 8.5321 9.24971 9.45261 8.81177ZM10.5225 8.02286C12.0884 8.80112 13.2143 10.2507 13.5808 11.9606C14.4078 10.8047 14.8524 9.419 14.8524 7.99772C14.8539 5.03815 12.9551 2.4121 10.1443 1.48631C7.33347 0.56051 4.24595 1.54424 2.48864 3.92552C0.731331 6.30679 0.701469 9.54733 2.4146 11.9606C2.78117 10.2507 3.90702 8.80112 5.47291 8.02286C4.21856 6.65635 4.27887 4.53984 5.60899 3.24698C6.93911 1.95413 9.05631 1.95413 10.3864 3.24698C11.7166 4.53984 11.7769 6.65635 10.5225 8.02286Z"}})]),_vm._v("\n                          My Account\n                        ")])])],1),_vm._v(" "),_c('li',[_c('router-link',{class:[
                          _vm.$route.path == 'myNotification' ? 'active' : '' ],attrs:{"to":"/profile/myNotification"},nativeOn:{"click":function($event){return _vm.closeMenu()}}},[_c('div',[_c('svg',{attrs:{"width":"16","height":"18","viewBox":"0 0 16 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16 11.6923C16 12.7112 15.1714 13.5385 14.1508 13.5385H1.8492C0.827975 13.5385 0 12.7124 0 11.6923C0 10.6736 0.827281 9.84615 1.8468 9.84615C1.8456 9.84615 1.84615 6.15361 1.84615 6.15361C1.84615 2.75418 4.6009 0 8 0C11.3991 0 14.1538 2.75484 14.1538 6.15361V9.84562C15.1712 9.84615 16 10.6733 16 11.6923ZM14.1532 11.0769C13.4732 11.0769 12.9231 10.5271 12.9231 9.84562V6.15361C12.9231 3.43456 10.7194 1.23077 8 1.23077C5.28058 1.23077 3.07692 3.43398 3.07692 6.15361V9.84562C3.07692 10.5252 2.5255 11.0769 1.8468 11.0769C1.50709 11.0769 1.23077 11.3533 1.23077 11.6923C1.23077 12.032 1.50709 12.3077 1.8492 12.3077H14.1508C14.4921 12.3077 14.7692 12.031 14.7692 11.6923C14.7692 11.3536 14.492 11.0769 14.1532 11.0769ZM6.46154 14.4615H5.23077C5.23077 15.9909 6.4706 17.2308 8 17.2308C9.5294 17.2308 10.7692 15.9909 10.7692 14.4615H9.53846C9.53846 15.3112 8.84967 16 8 16C7.15033 16 6.46154 15.3112 6.46154 14.4615Z"}})]),_vm._v("\n                          Notifications\n                        ")])])],1),_vm._v(" "),_c('li',[_c('router-link',{class:[
                          _vm.$route.path == 'myTransaction' ? 'active' : '' ],attrs:{"to":"/profile/myTransaction"},nativeOn:{"click":function($event){return _vm.closeMenu()}}},[_c('div',[_c('svg',{attrs:{"width":"19","height":"16","viewBox":"0 0 19 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.97927 0H15.9739C17.2369 0.00205197 18.2602 1.02539 18.2623 2.28838V3.54624C18.2623 3.80353 18.0537 4.01211 17.7964 4.01211H14.6154V13.7116C14.6134 14.9746 13.59 15.9979 12.327 16H2.28838C1.02539 15.9979 0.00205197 14.9746 0 13.7116V12.4538C0 12.1965 0.208579 11.9879 0.465875 11.9879H2.66853V2.31074C2.66956 1.03498 3.70351 0.0010276 4.97927 0ZM0.931749 13.7116C0.932776 14.4604 1.53956 15.0672 2.28838 15.0683H10.4859C10.1952 14.6757 10.0384 14.2001 10.0387 13.7116V12.9196H0.931749V13.7116ZM13.6837 2.28838V13.7116C13.6837 14.4614 13.0759 15.0692 12.3261 15.0692C11.5764 15.0692 10.9686 14.4614 10.9686 13.7116V12.4538C10.9686 12.1965 10.76 11.9879 10.5027 11.9879H3.59469V2.31074C3.59572 1.54957 4.21251 0.932776 4.97368 0.931749H14.1346C13.8423 1.3237 13.6842 1.79944 13.6837 2.28838ZM14.6154 3.08036H17.3305V2.28838C17.3305 1.53862 16.7227 0.930818 15.973 0.930818C15.2232 0.930818 14.6154 1.53862 14.6154 2.28838V3.08036ZM8.03913 5.34265C8.1096 5.4442 8.13682 5.5696 8.1148 5.69122C8.09278 5.81285 8.02333 5.92074 7.92173 5.99115C7.30352 6.42047 6.76708 6.95691 6.33776 7.57512C6.25259 7.6986 6.11317 7.77351 5.9632 7.77638H5.9427C5.78329 7.76959 5.63845 7.6817 5.55882 7.54344C5.40162 7.26823 5.17391 7.03988 4.89914 6.8819C4.67821 6.75239 4.60325 6.46883 4.7313 6.24706C4.85934 6.02528 5.14239 5.94843 5.36501 6.07501C5.58536 6.20209 5.78673 6.35954 5.9632 6.54274C6.38066 6.04147 6.86395 5.59892 7.39995 5.22711C7.60916 5.08626 7.89247 5.13747 8.03913 5.34265ZM12.1481 6.92662C12.4054 6.92662 12.614 6.71805 12.614 6.46075C12.614 6.20345 12.4054 5.99488 12.1481 5.99488H9.52434C9.26705 5.99488 9.05847 6.20345 9.05847 6.46075C9.05847 6.71805 9.26705 6.92662 9.52434 6.92662H12.1481ZM4.7277 3.33007C4.78869 3.22253 4.88993 3.14365 5.00912 3.11079C5.12831 3.07794 5.25567 3.09381 5.36315 3.1549C5.58386 3.28078 5.78584 3.43697 5.9632 3.61891C6.38064 3.11763 6.86393 2.67508 7.39995 2.30328C7.61145 2.15663 7.90179 2.20919 8.04845 2.42068C8.19511 2.63218 8.14255 2.92252 7.93105 3.06918C7.30948 3.49525 6.76924 4.02918 6.3359 4.6457C6.25234 4.77077 6.11354 4.84781 5.9632 4.85255H5.9427C5.78329 4.84576 5.63845 4.75787 5.55882 4.61961C5.40218 4.3478 5.17655 4.12216 4.90473 3.96553C4.79687 3.90484 4.71759 3.80374 4.68438 3.68453C4.65117 3.56531 4.66675 3.43778 4.7277 3.33007ZM12.1481 3.99348C12.4054 3.99348 12.614 3.7849 12.614 3.5276C12.614 3.27031 12.4054 3.06173 12.1481 3.06173H9.52434C9.26705 3.06173 9.05847 3.27031 9.05847 3.5276C9.05847 3.7849 9.26705 3.99348 9.52434 3.99348H12.1481ZM8.03913 8.26648C8.18625 8.47748 8.13453 8.76777 7.9236 8.91498C7.30541 9.34433 6.76898 9.88077 6.33962 10.499C6.25407 10.623 6.11383 10.6979 5.9632 10.7002H5.9427C5.78329 10.6934 5.63845 10.6055 5.55882 10.4673C5.40211 10.1955 5.17649 9.96989 4.90473 9.81318C4.7594 9.73056 4.66948 9.57639 4.66912 9.40922C4.66875 9.24204 4.75799 9.08748 4.90295 9.00422C5.04792 8.92095 5.22638 8.92174 5.3706 9.00629C5.58849 9.13155 5.78792 9.28646 5.9632 9.46657C6.38012 8.96546 6.86277 8.52292 7.39809 8.15094C7.60766 8.00886 7.89235 8.06017 8.03913 8.26648ZM12.1481 9.85045C12.4054 9.85045 12.614 9.64188 12.614 9.38458V9.38272C12.613 9.12615 12.4047 8.9187 12.1481 8.9187H9.52434C9.26705 8.9187 9.05847 9.12728 9.05847 9.38458C9.05847 9.64188 9.26705 9.85045 9.52434 9.85045H12.1481Z"}})]),_vm._v("\n                          My Transactions\n                        ")])])],1)])])],1),_vm._v(" "),_c('div',{staticClass:"px-2 text-white logout-text c-pointer",on:{"click":function($event){return _vm.onLogout()}}},[_vm._v("\n                Logout\n              ")])]):_vm._e()],1)],1)],1)],1)]),_vm._v(" "),_c('section',{staticClass:"search-section",style:({ right: _vm.hideSearch })},[_c('div',{staticClass:"ml-auto"},[_c('button',{staticClass:"close mb-3",on:{"click":function($event){return _vm.openSearch(true)}}},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(1104)}})])]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"d-flex w-100"},[_c('div',{staticClass:"grp-drop w-100"},[_c('b-input-group',{staticClass:"px-2"},[_c('b-form-input',{directives:[{name:"debounce",rawName:"v-debounce:500",value:(_vm.searchData),expression:"searchData",arg:"500"}],staticClass:"px-1",attrs:{"placeholder":"Search for movie"},model:{value:(_vm.searchValue),callback:function ($$v) {_vm.searchValue=$$v},expression:"searchValue"}}),_vm._v(" "),(_vm.countryData)?_c('b-dropdown',{attrs:{"slot":"append","text":_vm.selectedCityName,"variant":"default"},slot:"append"},_vm._l((_vm.countryData.City),function(city,cityIndex){return _c('b-dropdown-item',{key:cityIndex,on:{"click":function($event){return _vm.onChangeCityName(city)}}},[_vm._v(_vm._s(city.CityName))])}),1):_vm._e()],1),_vm._v(" "),(_vm.searchValue)?_c('ul',{staticClass:"searchListData"},_vm._l((_vm.movieListSearch),function(movie,movieListIndex){return _c('li',{key:movieListIndex,on:{"click":function($event){return _vm.openSearch(true)}}},[_c('router-link',{attrs:{"to":{
                  name: 'createScreen',
                  params: {
                    movie_id: movie.movie_id,
                    content_lang_id: movie.content_lang_id,
                  },
                }}},[_vm._v(_vm._s(movie.movie_title))])],1)}),0):_vm._e()],1)])])]),_vm._v(" "),(_vm.showBottom)?_c('section',{staticClass:"container-fluid menu-bottom-fix d-md-none"},[_c('BOTTOMBAR')],1):_vm._e(),_vm._v(" "),_c('b-modal',{ref:"countryModalRef",attrs:{"no-close-on-esc":"","no-close-on-backdrop":"","hide-header-close":"","id":"countryModal","hide-header":"","hide-footer":""}},[_c('div',{staticClass:"modal-title"},[_vm._v("Choose your Country")]),_vm._v(" "),_c('div',{staticClass:"p-3"},[_c('div',{staticClass:"row"},_vm._l((_vm.countries),function(country,index){return _c('div',{key:index,staticClass:"text-center col",attrs:{"index":index}},[_c('h6',{staticClass:"pt-3"},[_vm._v(_vm._s(country.country_name))])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"welcome-b"},[(_vm.modal.signIn.info)?_c('b-modal',{ref:"signInModal",attrs:{"hide-header-close":"","hide-footer":"","id":"login","title":"Welcome Back!","modal-class":"welcome-b"}},[_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){return _vm.hideSignIn()}}},[_vm._v("\n        ×\n      ")]),_vm._v(" "),_c('div',{staticClass:"col-12 loginmodal"},[_c('div',{staticClass:"mob-login-box"},[_c('b-form',{attrs:{"data-vv-scope":"signIn"},on:{"submit":function($event){$event.preventDefault();return _vm.validateBeforeSubmit('signIn')}}},[_c('b-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],staticClass:"mt-3 npm mr-sm-2 pc-input",attrs:{"name":"email","id":"email","placeholder":"Enter Your Email Address"},on:{"input":function($event){return _vm.resetError()}},model:{value:(_vm.userDetails.email),callback:function ($$v) {_vm.$set(_vm.userDetails, "email", $$v)},expression:"userDetails.email"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signIn.email')),expression:"errors.has('signIn.email')"}],staticClass:"py-1 text-danger font-weight-bold small"},[_vm._v("\n              "+_vm._s(_vm.errors.first("signIn.email"))+"\n            ")]),_vm._v(" "),_c('b-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:6'),expression:"'required|min:6'"}],staticClass:"mt-3 mr-sm-2 pc-input",attrs:{"type":"password","name":"password","id":"inlineFormpassword","placeholder":"Enter Your Password"},on:{"input":function($event){return _vm.resetError()}},model:{value:(_vm.userDetails.password),callback:function ($$v) {_vm.$set(_vm.userDetails, "password", $$v)},expression:"userDetails.password"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signIn.password')),expression:"errors.has('signIn.password')"}],staticClass:"py-1 text-danger font-weight-bold small"},[_vm._v("\n              "+_vm._s(_vm.errors.first("signIn.password"))+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"text-danger small font-weight-bold text-center"},[_vm._v("\n              "+_vm._s(_vm.errorMessage.login)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"my-3"},[_c('input',{staticClass:"btn btn-danger gogo-btn",attrs:{"type":"submit","value":"Login"}})])],1),_vm._v(" "),_c('router-link',{attrs:{"to":""},nativeOn:{"click":function($event){return _vm.showForgotPassword()}}},[_vm._v("Forgot Password?")])],1)]),_vm._v(" "),_c('p',{staticClass:"grey-text text-center pt-4"},[_vm._v("\n        Don’t have an account with us?\n        "),_c('router-link',{attrs:{"to":""},nativeOn:{"click":function($event){return _vm.showSignUp.apply(null, arguments)}}},[_vm._v("Sign Up")])],1)]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"welcome-b"},[(_vm.modal.forgotpassword.email)?_c('b-modal',{ref:"forgotpasswordEmailModal",attrs:{"hide-header-close":"","id":"forgotpassword","title":"Forgot Password?","modal-class":"welcome-b"}},[_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){return _vm.hideForgotPassword()}}},[_vm._v("\n        ×\n      ")]),_vm._v(" "),_c('div',{staticClass:"row mx-4 my-4"},[_c('div',{staticClass:"col-md-12 loginmodal"},[_c('div',{staticClass:"mob-login-box"},[_c('b-form',{attrs:{"data-vv-scope":"signIn"},on:{"submit":function($event){$event.preventDefault();return _vm.validateBeforeSubmit('forgotPassword')}}},[_c('b-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],staticClass:"mb-2 mt-1 mr-sm-2 pc-input",attrs:{"name":"email","id":"inlineFormInputpassword1","placeholder":"Enter Your Email Address"},model:{value:(_vm.userDetails.email),callback:function ($$v) {_vm.$set(_vm.userDetails, "email", $$v)},expression:"userDetails.email"}}),_vm._v(" "),_c('div',{staticClass:"text-danger small font-weight-bold"},[_vm._v("\n                "+_vm._s(_vm.errorMessage.forgotpassword)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_c('input',{staticClass:"btn btn-danger gogo-btn",attrs:{"type":"submit","value":"Send OTP"}})])],1)],1)])])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"welcome-b"},[_c('b-modal',{ref:"ForgotPasswordOTPModal",attrs:{"hide-header-close":"","id":"ForgotPasswordOTP","title":"Enter OTP","modal-class":"welcome-b"}},[_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){return _vm.hideForgotPasswordOTPModal()}}},[_vm._v("\n        ×\n      ")]),_vm._v(" "),_c('div',{staticClass:"row mx-4 my-4"},[_c('div',{staticClass:"col-md-12 loginmodal"},[_c('div',{staticClass:"mob-login-box"},[_c('form',{attrs:{"data-vv-scope":"fortpasswordVerifyOtp"},on:{"submit":function($event){$event.preventDefault();return _vm.validateBeforeSubmit('fortpasswordVerifyOtp')}}},[_c('div',{staticClass:"p-2"},[_c('p',{staticClass:"otp-text text-center mb-0"},[_vm._v("\n                  Please enter the 6 digit verification code you might have\n                  just received via email / SMS.\n                ")]),_vm._v(" "),_c('div',{staticClass:"my-4 otp-section"},[_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"d-flex otp-mob mx-auto"},[_c('div',{staticClass:"col px-2 px-md-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.OTP[0]),expression:"userDetails.OTP[0]"}],ref:"fotp1",staticClass:"form-control text-center otp_height",attrs:{"type":"number","id":"otp1","btnNumber":"1","placeholder":"","maxlength":"1","pattern":"([12345])\\w{0}"},domProps:{"value":(_vm.userDetails.OTP[0])},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails.OTP, 0, $event.target.value)},function($event){return _vm.OTPonKeyUp(0, $event)}]}})]),_vm._v(" "),_c('div',{staticClass:"col px-2 px-md-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.OTP[1]),expression:"userDetails.OTP[1]"}],ref:"fotp2",staticClass:"form-control text-center otp_height",attrs:{"type":"number","id":"otp2","placeholder":"","maxlength":"1","pattern":"([12345])\\w{0}"},domProps:{"value":(_vm.userDetails.OTP[1])},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails.OTP, 1, $event.target.value)},function($event){return _vm.OTPonKeyUp(1, $event)}]}})]),_vm._v(" "),_c('div',{staticClass:"col px-2 px-md-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.OTP[2]),expression:"userDetails.OTP[2]"}],ref:"fotp3",staticClass:"form-control text-center otp_height",attrs:{"type":"number","id":"otp2","placeholder":"","maxlength":"1","pattern":"([12345])\\w{0}"},domProps:{"value":(_vm.userDetails.OTP[2])},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails.OTP, 2, $event.target.value)},function($event){return _vm.OTPonKeyUp(2, $event)}]}})]),_vm._v(" "),_c('div',{staticClass:"col px-2 px-md-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.OTP[3]),expression:"userDetails.OTP[3]"}],ref:"fotp4",staticClass:"form-control text-center otp_height",attrs:{"type":"number","id":"otp2","placeholder":"","maxlength":"1","pattern":"([12345])\\w{0}"},domProps:{"value":(_vm.userDetails.OTP[3])},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails.OTP, 3, $event.target.value)},function($event){return _vm.OTPonKeyUp(3, $event)}]}})]),_vm._v(" "),_c('div',{staticClass:"col px-2 px-md-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.OTP[4]),expression:"userDetails.OTP[4]"}],ref:"fotp5",staticClass:"form-control text-center otp_height",attrs:{"type":"number","id":"otp2","placeholder":"","maxlength":"1","pattern":"([12345])\\w{0}"},domProps:{"value":(_vm.userDetails.OTP[4])},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails.OTP, 4, $event.target.value)},function($event){return _vm.OTPonKeyUp(4, $event)}]}})]),_vm._v(" "),_c('div',{staticClass:"col px-2 px-md-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.OTP[5]),expression:"userDetails.OTP[5]"}],ref:"fotp6",staticClass:"form-control text-center otp_height",attrs:{"type":"number","id":"otp2","placeholder":"","maxlength":"1","pattern":"([12345])\\w{0}"},domProps:{"value":(_vm.userDetails.OTP[5])},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails.OTP, 5, $event.target.value)},function($event){return _vm.OTPonKeyUp(5, $event)}]}})])])])]),_vm._v(" "),_c('p',{staticClass:"grey-text text-center mb-4"},[_vm._v("\n                  Haven't received it yet?\n                  "),_c('router-link',{attrs:{"to":"#"},nativeOn:{"click":function($event){return _vm.sendResetOTP()}}},[_vm._v("Resend code")])],1),_vm._v(" "),_c('div',[_c('div',{staticClass:"text-danger small font-weight-bold"},[_vm._v("\n                    "+_vm._s(_vm.errorMessage.otp)+"\n                  ")]),_vm._v(" "),_c('input',{staticClass:"btn btn-danger gogo-btn",attrs:{"type":"submit","value":"Submit"}})])])])])])])])],1),_vm._v(" "),_c('div',{staticClass:"welcome-b"},[_c('b-modal',{ref:"resetPassword",attrs:{"hide-header-close":"","id":"resetPassword","title":"Enter New Password","modal-class":"welcome-b"}},[_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){return _vm.hideresetPassword()}}},[_vm._v("\n        ×\n      ")]),_vm._v(" "),_c('div',{staticClass:"row mx-4 my-4"},[_c('div',{staticClass:"col-md-12 loginmodal"},[_c('div',{staticClass:"mob-login-box"},[_c('b-form',{attrs:{"data-vv-scope":"resetPasswordForm"},on:{"submit":function($event){$event.preventDefault();return _vm.validateBeforeSubmit('resetPasswordForm')}}},[_c('b-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:6'),expression:"'required|min:6'"}],staticClass:"mb-2 mt-1 mr-sm-2 pc-input",attrs:{"type":"password","name":"Password","id":"password1","placeholder":"Enter Your Password"},model:{value:(_vm.userDetails.password),callback:function ($$v) {_vm.$set(_vm.userDetails, "password", $$v)},expression:"userDetails.password"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('resetPasswordForm.Password')),expression:"errors.has('resetPasswordForm.Password')"}],staticClass:"py-1 text-danger font-weight-bold small"},[_vm._v("\n                "+_vm._s(_vm.errors.first("resetPasswordForm.Password"))+"\n              ")]),_vm._v(" "),_c('b-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:6'),expression:"'required|min:6'"}],staticClass:"mb-2 mt-1 mr-sm-2 pc-input",attrs:{"type":"password","name":"Confirm Password","id":"password2","placeholder":"Enter Your Confirm Password"},model:{value:(_vm.userDetails.ConfirmPassword),callback:function ($$v) {_vm.$set(_vm.userDetails, "ConfirmPassword", $$v)},expression:"userDetails.ConfirmPassword"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('resetPasswordForm.Confirm Password')),expression:"errors.has('resetPasswordForm.Confirm Password')"}],staticClass:"py-1 text-danger font-weight-bold small"},[_vm._v("\n                "+_vm._s(_vm.errors.first("resetPasswordForm.Confirm Password"))+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"text-danger small font-weight-bold"},[_vm._v("\n                "+_vm._s(_vm.errorMessage.resetPassword)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_c('input',{staticClass:"btn btn-danger gogo-btn",attrs:{"type":"submit","value":"Submit"}})])],1)],1)])])])],1),_vm._v(" "),_c('div',{staticClass:"verify-c"},[_c('b-modal',{ref:"resetPasswordSuccessModal",attrs:{"id":"resetPasswordSuccessModal","title":"Success!","modal-class":"verify-c"}},[_c('div',{staticClass:"p-5"},[_c('div',{staticClass:"text-center mb-3"},[_c('img',{attrs:{"width":"47","height":"auto","src":__webpack_require__(56)}})]),_vm._v(" "),_c('div',{staticClass:"text-center text-success mt-3 mt-md-0"},[_vm._v("\n          Awesome! Your Password has been reset successfully.\n        ")])])])],1),_vm._v(" "),_c('div',{staticClass:"hello-s"},[(_vm.modal.signUp.info)?_c('b-modal',{ref:"signUp",attrs:{"hide-header-close":"","hide-footer":"","id":"signup","title":"Hello Friend!","modal-class":"hello-s"}},[_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){return _vm.hideSignUp()}}},[_vm._v("\n        ×\n      ")]),_vm._v(" "),_c('b-form',{attrs:{"data-vv-scope":"signUp"},on:{"submit":function($event){$event.preventDefault();return _vm.validateBeforeSubmit('signUp')}}},[_c('div',{},[_c('div',{staticClass:"col-md-12 loginmodal"},[_c('div',{staticClass:"mob-login-box"},[_c('b-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],staticClass:"mt-3 mr-sm-2 pc-input",attrs:{"autocomplete":"false","name":"email","type":"email","id":"inlineFormInputNamemail","placeholder":"Enter Your Email Address"},model:{value:(_vm.userDetails.email),callback:function ($$v) {_vm.$set(_vm.userDetails, "email", $$v)},expression:"userDetails.email"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signUp.email')),expression:"errors.has('signUp.email')"}],staticClass:"py-1 text-danger font-weight-bold small"},[_vm._v("\n                "+_vm._s(_vm.errors.first("signUp.email"))+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-3 pr-0 pr-xl-2 country-code-drop"},[(_vm.CountryCodeList.length > 0)?_c('b-dropdown',{staticClass:"pc-input form-control mt-3",attrs:{"slot":"append","text":_vm.userDetails.CountryCode.toString() || 'Code',"variant":"default"},slot:"append"},[_c('div',{staticClass:"px-2 pb-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchCode),expression:"searchCode"}],staticClass:"form-control form-control-sm",attrs:{"type":"search","placeholder":"Search Code"},domProps:{"value":(_vm.searchCode)},on:{"keyup":function($event){return _vm.onSearchCode($event.target.value)},"keydown":function($event){return _vm.onSearchCode($event.target.value)},"search":function($event){return _vm.onSearchCode($event.target.value)},"input":function($event){if($event.target.composing){ return; }_vm.searchCode=$event.target.value}}})]),_vm._v(" "),_vm._l((_vm.CountryCodeList),function(country,countryIndex){return _c('b-dropdown-item',{key:countryIndex,on:{"click":function($event){return _vm.onChangeCountry(country)}}},[_vm._v(_vm._s(country.country_mob_code)+" \n                      "+_vm._s(country.country_name))])})],2):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('b-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:8|max:12'),expression:"'required|min:8|max:12'"}],staticClass:"mt-3 mr-sm-2 pc-input",attrs:{"name":"Phone Number","type":"number","min":0,"pattern":"","placeholder":"Enter Your Phone Number"},on:{"keyup":_vm.checkValidPhone},model:{value:(_vm.userDetails.phoneNumber),callback:function ($$v) {_vm.$set(_vm.userDetails, "phoneNumber", $$v)},expression:"userDetails.phoneNumber"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signUp.Phone Number')),expression:"errors.has('signUp.Phone Number')"}],staticClass:"py-1 px-3 text-danger font-weight-bold small"},[_vm._v("\n                  The Phone Number field\n                  "+_vm._s(_vm.userDetails.phoneNumber.toString().length < 9
                      ? "must be atleast 8 digits"
                      : _vm.userDetails.phoneNumber.toString().length > 12
                      ? "may not be  greater than  12 digits"
                      : "")+"\n                ")])]),_vm._v(" "),_c('b-input',{directives:[{name:"validate",rawName:"v-validate",value:({
                  required: 'required',
                  regex:
                    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z0-9!@#$%^&*]{6,}$/,
                }),expression:"{\n                  required: 'required',\n                  regex:\n                    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z0-9!@#$%^&*]{6,}$/,\n                }"}],staticClass:"mt-3 mr-sm-2 pc-input",attrs:{"type":"password","name":"password","id":"inlineFormInputNamepassword1","placeholder":"Enter Your Password"},model:{value:(_vm.userDetails.password),callback:function ($$v) {_vm.$set(_vm.userDetails, "password", $$v)},expression:"userDetails.password"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signUp.password')),expression:"errors.has('signUp.password')"}],staticClass:"py-1 text-danger font-weight-bold small"},[_vm._v("\n                "+_vm._s(!_vm.userDetails.password
                    ? _vm.passwordRequiredMessage
                    : _vm.passwordValidationMessage)+"\n                ")])],1),_vm._v(" "),_c('b-form-checkbox',{staticClass:"grey-text pc-radio mt-2 mb-2 mt-md-2 mb-md-2",attrs:{"id":"checkbox-1","name":"checkbox-1","value":"accepted","unchecked-value":"not_accepted"},model:{value:(_vm.userDetails.termsAndConditions),callback:function ($$v) {_vm.$set(_vm.userDetails, "termsAndConditions", $$v)},expression:"userDetails.termsAndConditions"}},[_vm._v("\n            I agree to receive text messages from GOGO Cinema\n              "),_c('router-link',{staticClass:"tnc-class",attrs:{"to":"/termsCondition","target":"_blank"}},[_vm._v("Terms & Conditions")])],1),_vm._v(" "),_c('b-form-checkbox',{staticClass:"grey-text pc-radio mt-2 mb-2 mt-md-2 mb-md-2",attrs:{"id":"checkbox-1","name":"checkbox-1","value":"accepted","unchecked-value":"not_accepted"},model:{value:(_vm.userDetails.termsAndConditions),callback:function ($$v) {_vm.$set(_vm.userDetails, "termsAndConditions", $$v)},expression:"userDetails.termsAndConditions"}},[_vm._v("\n              I'd like to receive marketing emails\n           \n            ")]),_vm._v(" "),_c('div',{staticClass:"py-2 text-danger font-weight-bold small"},[_vm._v("\n              "+_vm._s(_vm.errorMessage.signUp)+"\n            ")]),_vm._v(" "),_c('input',{staticClass:"btn btn-danger gogo-btn",attrs:{"type":"submit","value":"Create an Account"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-7 px-0 pr-md-5 mt-3 mt-md-0"},[_c('div')])])]),_vm._v(" "),_c('p',{staticClass:"grey-text text-center mb-0 py-4"},[_vm._v("\n        Already a user?\n        "),_c('router-link',{attrs:{"to":""},nativeOn:{"click":function($event){return _vm.showSignIn.apply(null, arguments)}}},[_vm._v("Sign In")])],1)],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"verify-c"},[_c('b-modal',{ref:"verifyContact",attrs:{"id":"verifyContact","title":"Verify Your Contact Detail","modal-class":"verify-c"}},[_c('div',{staticClass:"p-5"},[_c('div',{staticClass:"text-center mb-3"},[_c('img',{attrs:{"width":"47","height":"auto","src":__webpack_require__(56)}})]),_vm._v(" "),_c('div',{staticClass:"text-center text-success mt-3 mt-md-0"},[_vm._v("\n          Awesome! Your verification is complete and your account has been\n          created!\n        ")])])])],1),_vm._v(" "),_c('div',{staticClass:"verify-otp"},[_c('b-modal',{ref:"OTPModal",attrs:{"hide-header-close":"","id":"otp","title":"Verify Your Contact Detail","modal-class":"verify-otp"}},[_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){return _vm.hideSignUpOTP()}}},[_vm._v("\n        ×\n      ")]),_vm._v(" "),_c('form',{attrs:{"data-vv-scope":"verifyOtp"},on:{"submit":function($event){$event.preventDefault();return _vm.validateBeforeSubmit('verifyOtp')}}},[_c('div',{staticClass:"p-5"},[_c('p',{staticClass:"otp-text text-center mb-0"},[_vm._v("\n            Almost there! Please enter the 6 digit verification code you might\n            have just received via email / SMS.\n          ")]),_vm._v("\n          "+_vm._s(_vm.errorMessage.otp)+"\n          "),_c('div',{staticClass:"my-4 otp-section"},[_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"d-flex otp-mob mx-auto"},[_c('div',{staticClass:"col px-2 px-md-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.OTP[0]),expression:"userDetails.OTP[0]"}],ref:"sotp0",staticClass:"form-control text-center otp_height",attrs:{"type":"number","id":"otp1","btnNumber":"1","placeholder":"","maxlength":"1","pattern":"([12345])\\w{0}"},domProps:{"value":(_vm.userDetails.OTP[0])},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails.OTP, 0, $event.target.value)},function($event){return _vm.OTPonKeyUp1(0, $event)}]}})]),_vm._v(" "),_c('div',{staticClass:"col px-2 px-md-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.OTP[1]),expression:"userDetails.OTP[1]"}],ref:"sotp1",staticClass:"form-control text-center otp_height",attrs:{"type":"number","id":"otp2","placeholder":"","maxlength":"1","pattern":"([12345])\\w{0}"},domProps:{"value":(_vm.userDetails.OTP[1])},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails.OTP, 1, $event.target.value)},function($event){return _vm.OTPonKeyUp1(1, $event)}]}})]),_vm._v(" "),_c('div',{staticClass:"col px-2 px-md-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.OTP[2]),expression:"userDetails.OTP[2]"}],ref:"sotp2",staticClass:"form-control text-center otp_height",attrs:{"type":"number","id":"otp2","placeholder":"","maxlength":"1","pattern":"([12345])\\w{0}"},domProps:{"value":(_vm.userDetails.OTP[2])},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails.OTP, 2, $event.target.value)},function($event){return _vm.OTPonKeyUp1(2, $event)}]}})]),_vm._v(" "),_c('div',{staticClass:"col px-2 px-md-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.OTP[3]),expression:"userDetails.OTP[3]"}],ref:"sotp3",staticClass:"form-control text-center otp_height",attrs:{"type":"number","id":"otp2","placeholder":"","maxlength":"1","pattern":"([12345])\\w{0}"},domProps:{"value":(_vm.userDetails.OTP[3])},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails.OTP, 3, $event.target.value)},function($event){return _vm.OTPonKeyUp1(3, $event)}]}})])])])]),_vm._v(" "),_c('p',{staticClass:"grey-text text-center mb-4"},[_vm._v("\n            Haven't received it yet?\n            "),_c('router-link',{attrs:{"to":"#"},nativeOn:{"click":function($event){return _vm.validateBeforeSubmit('signUp')}}},[_vm._v("Resend code")])],1),_vm._v(" "),_c('div',{staticClass:"text-danger my-2 text-center"},[_vm._v("\n            "+_vm._s(_vm.errorMessage.signUp)+"\n          ")]),_vm._v(" "),_c('div',[_c('input',{staticClass:"gogo-btn btn btn-danger",attrs:{"type":"submit","value":"Confirm your details"}})])])])]),_vm._v(" "),_c('b-modal',{ref:"registerMsg",staticClass:"text-center",attrs:{"no-close-on-esc":"","no-close-on-backdrop":"","hide-header-close":"","hide-footer":"","id":"registerMsg","title":"Register SuccessFully !"}},[_c('div',{staticClass:"p-5"},[_c('div',{staticClass:"text-center mt-3 mt-md-0"},[_vm._v("Thanks For Joining Us.")]),_vm._v(" "),_c('div',{staticClass:"d-flex w-100 mx-auto"},[_c('b-button',{staticClass:"w-50 mr-2 gogo-btn btn btn-danger mt-3 d-flex-inline justify-content-center align-items-center",on:{"click":function($event){return _vm.validateBeforeSubmit('signIn')}}},[_vm._v("Login")]),_vm._v(" "),_c('b-button',{staticClass:"w-50 ml-2 gogo-btn btn btn-danger mt-3 d-flex-inline justify-content-center align-items-center",on:{"click":function($event){return _vm.hideModal()}}},[_vm._v("Cancel")])],1)])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1101 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIj8+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQ3NS4yIDQ3NS4yIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0NzUuMiA0NzUuMjsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSI1MTJweCIgaGVpZ2h0PSI1MTJweCIgY2xhc3M9IiI+PGc+PGc+Cgk8Zz4KCQk8cGF0aCBkPSJNNDA1LjYsNjkuNkMzNjAuNywyNC43LDMwMS4xLDAsMjM3LjYsMHMtMTIzLjEsMjQuNy0xNjgsNjkuNlMwLDE3NC4xLDAsMjM3LjZzMjQuNywxMjMuMSw2OS42LDE2OHMxMDQuNSw2OS42LDE2OCw2OS42ICAgIHMxMjMuMS0yNC43LDE2OC02OS42czY5LjYtMTA0LjUsNjkuNi0xNjhTNDUwLjUsMTE0LjUsNDA1LjYsNjkuNnogTTM4Ni41LDM4Ni41Yy0zOS44LDM5LjgtOTIuNyw2MS43LTE0OC45LDYxLjcgICAgcy0xMDkuMS0yMS45LTE0OC45LTYxLjdjLTgyLjEtODIuMS04Mi4xLTIxNS43LDAtMjk3LjhDMTI4LjUsNDguOSwxODEuNCwyNywyMzcuNiwyN3MxMDkuMSwyMS45LDE0OC45LDYxLjcgICAgQzQ2OC42LDE3MC44LDQ2OC42LDMwNC40LDM4Ni41LDM4Ni41eiIgZGF0YS1vcmlnaW5hbD0iIzAwMDAwMCIgY2xhc3M9ImFjdGl2ZS1wYXRoIiBkYXRhLW9sZF9jb2xvcj0iIzAwMDAwMCIgZmlsbD0iI0ZGRkZGRiIvPgoJCTxwYXRoIGQ9Ik0zNDIuMywxMzIuOWMtNS4zLTUuMy0xMy44LTUuMy0xOS4xLDBsLTg1LjYsODUuNkwxNTIsMTMyLjljLTUuMy01LjMtMTMuOC01LjMtMTkuMSwwYy01LjMsNS4zLTUuMywxMy44LDAsMTkuMSAgICBsODUuNiw4NS42bC04NS42LDg1LjZjLTUuMyw1LjMtNS4zLDEzLjgsMCwxOS4xYzIuNiwyLjYsNi4xLDQsOS41LDRzNi45LTEuMyw5LjUtNGw4NS42LTg1LjZsODUuNiw4NS42YzIuNiwyLjYsNi4xLDQsOS41LDQgICAgYzMuNSwwLDYuOS0xLjMsOS41LTRjNS4zLTUuMyw1LjMtMTMuOCwwLTE5LjFsLTg1LjQtODUuNmw4NS42LTg1LjZDMzQ3LjYsMTQ2LjcsMzQ3LjYsMTM4LjIsMzQyLjMsMTMyLjl6IiBkYXRhLW9yaWdpbmFsPSIjMDAwMDAwIiBjbGFzcz0iYWN0aXZlLXBhdGgiIGRhdGEtb2xkX2NvbG9yPSIjMDAwMDAwIiBmaWxsPSIjRkZGRkZGIi8+Cgk8L2c+CjwvZz48L2c+IDwvc3ZnPgo="

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/gogo-logo.561cbe6.svg";

/***/ }),
/* 1103 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAxOSAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMy4yODM4IDEyLjIyNDlMMTguNzgwNiAxNy43MjJDMTkuMDczMSAxOC4wMTQ1IDE5LjA3MzEgMTguNDg4MiAxOC43ODA2IDE4Ljc4MDdDMTguNDg4MiAxOS4wNzMxIDE4LjAxNDQgMTkuMDczMSAxNy43MjIgMTguNzgwN0wxMi4yMjUgMTMuMjgzNkM5LjI4NDQzIDE1LjY5MzMgNC45Mzc4OCAxNS41MjU3IDIuMTkyNTYgMTIuNzgwNkMtMC43MzA5MzIgOS44NTcwMyAtMC43MzA5MzIgNS4xMTY0IDIuMTkzMDMgMi4xOTI4NUM1LjExNjU3IC0wLjczMDkxMSA5Ljg1NzExIC0wLjczMDkxMSAxMi43ODA2IDIuMTkyNjJDMTUuNTI1OSA0LjkzNzY5IDE1LjY5MzUgOS4yODQyNCAxMy4yODM4IDEyLjIyNDlaTTMuNjEwNjIgMy42MTA2NkMxLjQ2MzEzIDUuNzU4ODcgMS40NjMxMyA5LjI0MTEzIDMuNjEwNjIgMTEuMzg4OUM1Ljc1ODk5IDEzLjUzNjkgOS4yNDExNyAxMy41MzcxIDExLjM4OTEgMTEuMzg5MUMxMy41MzcgOS4yNDExMyAxMy41MzcgNS43NTg4NyAxMS4zODg3IDMuNjEwNjZDOS4yNDExNyAxLjQ2MzExIDUuNzU5MDEgMS40NjMxMSAzLjYxMDYyIDMuNjEwNjZaIiBmaWxsPSIjRURGMkY0Ii8+Cjwvc3ZnPgo="

/***/ }),
/* 1104 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgZmlsbD0iI2ZmZiIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiCgl5PSIwcHgiIHZpZXdCb3g9IjAgMCA0Ny45NzEgNDcuOTcxIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0Ny45NzEgNDcuOTcxOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+Cgk8Zz4KCQk8cGF0aCBkPSJNMjguMjI4LDIzLjk4Nkw0Ny4wOTIsNS4xMjJjMS4xNzItMS4xNzEsMS4xNzItMy4wNzEsMC00LjI0MmMtMS4xNzItMS4xNzItMy4wNy0xLjE3Mi00LjI0MiwwTDIzLjk4NiwxOS43NDRMNS4xMjEsMC44OAoJCWMtMS4xNzItMS4xNzItMy4wNy0xLjE3Mi00LjI0MiwwYy0xLjE3MiwxLjE3MS0xLjE3MiwzLjA3MSwwLDQuMjQybDE4Ljg2NSwxOC44NjRMMC44NzksNDIuODVjLTEuMTcyLDEuMTcxLTEuMTcyLDMuMDcxLDAsNC4yNDIKCQlDMS40NjUsNDcuNjc3LDIuMjMzLDQ3Ljk3LDMsNDcuOTdzMS41MzUtMC4yOTMsMi4xMjEtMC44NzlsMTguODY1LTE4Ljg2NEw0Mi44NSw0Ny4wOTFjMC41ODYsMC41ODYsMS4zNTQsMC44NzksMi4xMjEsMC44NzkKCQlzMS41MzUtMC4yOTMsMi4xMjEtMC44NzljMS4xNzItMS4xNzEsMS4xNzItMy4wNzEsMC00LjI0MkwyOC4yMjgsMjMuOTg2eiIgLz4KCTwvZz4KCTxnPgoJPC9nPgoJPGc+Cgk8L2c+Cgk8Zz4KCTwvZz4KCTxnPgoJPC9nPgoJPGc+Cgk8L2c+Cgk8Zz4KCTwvZz4KCTxnPgoJPC9nPgoJPGc+Cgk8L2c+Cgk8Zz4KCTwvZz4KCTxnPgoJPC9nPgoJPGc+Cgk8L2c+Cgk8Zz4KCTwvZz4KCTxnPgoJPC9nPgoJPGc+Cgk8L2c+Cgk8Zz4KCTwvZz4KPC9zdmc+"

/***/ }),
/* 1105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__ = __webpack_require__(580);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f4754ec_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__ = __webpack_require__(1107);
function injectStyle (ssrContext) {
  __webpack_require__(1106)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0f4754ec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f4754ec_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1106 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('footer',{staticClass:"pt-4 pb-4",class:_vm.pathname ? 'footer-margin' : ''},[_c('div',{staticClass:"footer-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 d-md-none"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"text-white"},[_vm._v(_vm._s(_vm.message))])]),_vm._v(" "),_c('div',{staticClass:"col-6 col-sm-6 col-md col-lg-3 col-xl-3"},[_c('ul',{staticClass:"p-0"},[_c('li',[_c('router-link',{attrs:{"to":"/hiw"}},[_vm._v("How It Works")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/offers-promotions"}},[_vm._v("Offers & Promotions")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/aboutUs"}},[_vm._v("About Us")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/newsroom"}},[_vm._v("Newsroom")])],1)])]),_vm._v(" "),_c('div',{staticClass:"col-6 col-sm-6 col-md col-lg-3 col-xl-3"},[_c('ul',{staticClass:"p-0"},[_c('li',[_c('router-link',{attrs:{"to":"/termsCondition"}},[_vm._v("Terms & Conditions")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/privacyPolicy"}},[_vm._v("Privacy Policy")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/cookiesprivacyPolicy"}},[_vm._v("Cookies")])],1),_vm._v(" "),_c('li',{staticClass:"d-md-none"},[_c('router-link',{staticStyle:{"cursor":"pointer"},attrs:{"to":"/feedback"}},[_vm._v("Contact Us")])],1),_vm._v(" "),_c('li',{staticClass:"d-md-none"},[_c('router-link',{attrs:{"to":"/faqs"}},[_vm._v("FAQ")])],1)])]),_vm._v(" "),_c('div',{staticClass:"col-6 col-sm-6 col-md-2 col-lg-2 col-xl-3 d-none d-md-block"},[_c('ul',{staticClass:"p-0"},[_c('li',[_c('router-link',{staticStyle:{"cursor":"pointer"},attrs:{"to":"/feedback"}},[_vm._v("Contact Us")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/faqs"}},[_vm._v("FAQ")])],1)])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-12 col-md-5 col-lg-4 col-xl-3"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"text-white d-none d-md-block"},[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),(false)?_c('div',{staticClass:"py-3 py-md-0 border-mobile-top"},[_c('div',{staticClass:"text-white"},[_vm._v("Enjoy "+_vm._s(_vm.TITLE)+" on the go")]),_vm._v(" "),_vm._m(2)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"border-top border-light"}),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between align-items-center py-2"},[_c('p',{staticClass:"text-white mb-0"},[_vm._v("Ⓒ "+_vm._s(_vm.dateYear)+" "+_vm._s(_vm.TITLE))])])]),_vm._v(" "),(_vm.pop)?_c('div',{staticClass:"popUp",on:{"click":function($event){return _vm.show()}}},[_c('div',{staticClass:"content"},[_vm._v("\n            Lorem ipsum dolor sit amet consectetur adipisicing elit.\n            Doloremque ratione esse possimus assumenda, tempore nihil\n            molestiae. Qui quos ratione expedita, amet voluptatum tenetur\n            assumenda atque cumque sint laboriosam quibusdam error?\n          ")])]):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mc_embed_signup "}},[_c('form',{staticClass:"validate",attrs:{"action":"https://gdc-tech.us3.list-manage.com/subscribe/post?u=17de026eae3d5830383759c75&id=22a268fd8e","method":"post","id":"mc-embedded-subscribe-form","name":"mc-embedded-subscribe-form","target":"_blank","novalidate":""}},[_c('div',{staticClass:"input-group subscribe-box mb-1",attrs:{"id":"mc_embed_signup_scroll"}},[_c('input',{staticClass:"email form-control susbscribe-input py-4",staticStyle:{"border-top-left-radius":"5px","border-bottom-left-radius":"5px"},attrs:{"type":"email","value":"","name":"EMAIL","id":"mce-EMAIL","placeholder":"Enter your email","required":""}}),_vm._v(" "),_c('div',{staticStyle:{"position":"absolute","left":"-5000px"},attrs:{"aria-hidden":"true"}},[_c('input',{attrs:{"type":"text","name":"b_17de026eae3d5830383759c75_22a268fd8e","tabindex":"-1","value":""}})]),_vm._v(" "),_c('div',{staticClass:"clear"},[_c('input',{staticClass:"button subscribe-new",attrs:{"type":"submit","value":"Subscribe","name":"subscribe","id":"mc-embedded-subscribe"}})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-none d-md-block",attrs:{"id":"mc_embed_signup "}},[_c('form',{staticClass:"validate",attrs:{"action":"https://gdc-tech.us3.list-manage.com/subscribe/post?u=17de026eae3d5830383759c75&id=22a268fd8e","method":"post","id":"mc-embedded-subscribe-form","name":"mc-embedded-subscribe-form","target":"_blank","novalidate":""}},[_c('div',{staticClass:"input-group subscribe-box mb-1",attrs:{"id":"mc_embed_signup_scroll"}},[_c('input',{staticClass:"email form-control susbscribe-input py-4",staticStyle:{"border-top-left-radius":"5px","border-bottom-left-radius":"5px"},attrs:{"type":"email","value":"","name":"EMAIL","id":"mce-EMAIL","placeholder":"Enter your email","required":""}}),_vm._v(" "),_c('div',{staticStyle:{"position":"absolute","left":"-5000px"},attrs:{"aria-hidden":"true"}},[_c('input',{attrs:{"type":"text","name":"b_17de026eae3d5830383759c75_22a268fd8e","tabindex":"-1","value":""}})]),_vm._v(" "),_c('div',{staticClass:"clear"},[_c('input',{staticClass:"button subscribe-new",attrs:{"type":"submit","value":"Subscribe","name":"subscribe","id":"mc-embedded-subscribe"}})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"mr-2"},[_c('a',{attrs:{"href":"https://play.google.com/store/apps/details?id=com.gogo.cinema&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1","target":"_blank"}},[_c('img',{staticClass:"img-fluid",staticStyle:{"max-width":"150px","margin-left":"-10px"},attrs:{"alt":"Get it on Google Play","src":"https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"}})])]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"9px"}},[_c('a',{attrs:{"href":"https://apps.apple.com/sg/app/gogocinema/id1477479261?mt=8","target":"_blank"}},[_c('img',{staticClass:"img-fluid",staticStyle:{"max-width":"135px"},attrs:{"src":"https://linkmaker.itunes.apple.com/en-gb/badge-lrg.svg?releaseDate=2019-09-26&kind=iossoftware&bubble=ios_apps"}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1108 */,
/* 1109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cc28e5d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_connectionLost_vue__ = __webpack_require__(1111);
function injectStyle (ssrContext) {
  __webpack_require__(1110)
}
var normalizeComponent = __webpack_require__(8)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cc28e5d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_connectionLost_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1110 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section-connection-lost"},[_c('div',{staticClass:"text-center"},[_c('img',{attrs:{"src":__webpack_require__(1112),"height":"75","width":"75","alt":"Connection Lost"}}),_vm._v(" "),_c('h6',{staticClass:"mb-1"},[_vm._v("Oops!")]),_vm._v(" "),_c('h6',{staticClass:"mb-5"},[_vm._v("Connection Lost")]),_vm._v(" "),_c('div',{staticClass:"proceed-btn"},[_c('button',{staticClass:"btn py-md-2 px-md-3",attrs:{"type":"button"}},[_vm._v("Retry")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1112 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.onLine)?_c('div',[(
        ['/terms-condition'].indexOf(_vm.$route.path) < 0 &&
          ['/help-page'].indexOf(_vm.$route.path) < 0 &&
          ['/terms-condition-ticket'].indexOf(_vm.$route.path) < 0 &&
          ['/how-it-works'].indexOf(_vm.$route.path) < 0
      )?_c('Header'):_vm._e(),_vm._v(" "),_c('router-view'),_vm._v(" "),(
        ['/terms-condition'].indexOf(_vm.$route.path) < 0 &&
          ['/help-page'].indexOf(_vm.$route.path) < 0 &&
          ['/terms-condition-ticket'].indexOf(_vm.$route.path) < 0 &&
          ['/how-it-works'].indexOf(_vm.$route.path) < 0
      )?_c('Footer'):_vm._e()],1):_c('div',[_c('connectionLost')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__ = __webpack_require__(582);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75f50cc8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__ = __webpack_require__(1142);
function injectStyle (ssrContext) {
  __webpack_require__(1115)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-75f50cc8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75f50cc8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1115 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1116 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"NowShowingSlider"},[_c('div',{staticClass:"sdHome"},[(_vm.routeName === '/')?_c('div',{staticClass:"col-12 sliderDetails px-0 pr-md-3 px-lg-3"},[_c('p',{staticClass:"movieCat"},[_vm._v("\n         Confirmed Screenings "),_c('span',{staticClass:"text-dark"},[_vm._v("(Join or choose your own)")]),_vm._v(" "),_c('span',{staticClass:"txt-link"},[_c('button',{staticClass:"btn btn-danger viewmore-btn mr-4",on:{"click":function($event){_vm.showModal = true}}},[_vm._v("Know more")]),_vm._v(" "),_c('b-modal',{attrs:{"ok-variant":"danger"},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('ul',[_c('li',[_vm._v("\n                Choose your favourite movie.\n\n              ")]),_vm._v(" "),_c('li',[_vm._v("Choose the cinema and Screening type.\n              ")]),_vm._v(" "),_c('li',[_vm._v("\n                Choose the date and time.\n              ")])])]),_vm._v(" "),_c('b-tooltip',{attrs:{"target":"tooltip-1","placement":"right"}})],1)]),_vm._v(" "),_c('p',{staticClass:"link"},[_c('router-link',{attrs:{"to":{ name: 'nowShowingList' }}},[_vm._v("(See All)")])],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"sd"},[(_vm.routeName !== '/')?_c('div',{staticClass:"col-12 sliderDetails px-0 px-md-3"},[_c('p',{staticClass:"movieCat"},[_vm._v("\n        NOW SHOWING\n        "),_c('span',{staticClass:"link ml-2"},[_c('router-link',{attrs:{"to":{ name: 'nowShowingList' }}},[_vm._v("(See All)")])],1)])]):_vm._e()]),_vm._v(" "),_c('Slick',{ref:"slick1",staticClass:"now-showing",attrs:{"options":_vm.movieSlider}},_vm._l((_vm.NowShowing),function(singleMovie,singleindex){return _c('div',{key:singleindex},[_c('router-link',{attrs:{"to":{
        name: 'createScreen',
        params: {
          movie_id: singleMovie.movie_id,
          content_lang_id: singleMovie.content_lang_id
        }
      }}},[_c('div',{staticClass:"movieSlider-container mx-auto text-center"},[_c('div',{staticClass:"img-container"},[_c('router-link',{attrs:{"to":{
              name: 'createScreen',
              params: {
                movie_id: singleMovie.movie_id,
                content_lang_id: singleMovie.content_lang_id
              }
            }}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(singleMovie.md_thumbnail_url),expression:"singleMovie.md_thumbnail_url"}],staticClass:"img-fluid mx-auto banner",attrs:{"alt":""}})])],1),_vm._v(" "),_c('div',{staticClass:"text-center mx-auto pt-2 pt-md-3 movieSliderInfo"},[_c('p',{staticClass:"mb-0 title"},[_vm._v(_vm._s(singleMovie.movie_title))]),_vm._v(" "),_c('ul',{staticClass:"list-inline mb-0 mInfo"},[_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(singleMovie.mf_name))]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v("|")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(singleMovie.rating))])])])])])],1)}),0)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1118 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"SpecialScreeningsSlider"},[_c('div',{staticClass:"sdHome"},[(
        _vm.routeName === '/' ||
          _vm.routeName === '/nowShowingList' ||
          _vm.routeName === '/miniFestivalList'
      )?_c('div',{staticClass:"col-12 sliderDetails px-0 pr-md-3 px-lg-3"},[_c('p',{staticClass:"movieCat"},[_vm._v("\n        SPECIAL SCREENINGS\n        "),_c('span',{staticClass:"txt-link"},[_c('router-link',{staticClass:"ml-3 ml-lg-4 mr-2",attrs:{"to":""}},[_vm._v("Watch Movies on Demand")])],1),_vm._v(" "),_c('b-modal',{attrs:{"ok-variant":"danger"},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('ul',[_c('li',[_vm._v("\n              Select the favorite movie you want to watch by clicking on the\n              movie image.\n            ")]),_vm._v(" "),_c('li',[_vm._v("\n              These movies are special screening created exclusively for fans\n              like you to enjoy.\n            ")]),_vm._v(" "),_c('li',[_vm._v("Join the screening by completing the booking process.")]),_vm._v(" "),_c('li',[_vm._v("Enjoy Exclusive screening of your favorite movie.")])])]),_vm._v(" "),_c('b-tooltip',{attrs:{"target":"tooltip-2","placement":"right"}})],1),_vm._v(" "),_c('p',{staticClass:"link"},[_c('router-link',{attrs:{"to":{ name: 'specialScreeningList' }}},[_vm._v("(See All)")])],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"sd"},[(
        _vm.routeName !== '/' &&
          _vm.routeName !== '/nowShowingList' &&
          _vm.routeName !== '/miniFestivalList'
      )?_c('div',{staticClass:"col-12 sliderDetails px-0 px-md-3"},[_c('p',{staticClass:"movieCat"},[_vm._v("\n        SPECIAL SCREENINGS\n        "),_c('span',{staticClass:"link ml-2"},[_c('router-link',{attrs:{"to":{ name: 'specialScreeningList' }}},[_vm._v("(See All)")])],1)])]):_vm._e()]),_vm._v(" "),_c('Slick',{ref:"slick2",attrs:{"options":_vm.movieSlider}},[_vm._l((10),function(singleMovie,singleindex){return (_vm.SpecialScreening.length == 0)?_c('div',{key:singleindex},[_c('div',{staticClass:"movieSlider-container mx-auto text-center"},[_c('div',{staticClass:"img-container"},[_c('img',{staticClass:"img-fluid mx-auto banner",attrs:{"src":__webpack_require__(585),"alt":""}})])])]):_vm._e()}),_vm._v(" "),_vm._l((_vm.SpecialScreening),function(singleMovie,singleMovieIndex){return (_vm.SpecialScreening.length > 0)?_c('div',{key:singleMovieIndex},[_c('router-link',{attrs:{"to":{
          name: 'createScreen',
          params: { movieId: singleMovie.ID, categoryId: 2 }
        }}},[_c('div',{staticClass:"movieSlider-container mx-auto text-center"},[_c('div',{staticClass:"img-container"},[_c('router-link',{attrs:{"to":{
                name: 'createScreen',
                params: { movieId: singleMovie.ID, categoryId: 2 }
              }}},[_c('img',{staticClass:"img-fluid mx-auto banner",attrs:{"src":singleMovie.Image,"alt":""}})])],1),_vm._v(" "),_c('div',{staticClass:"text-center mx-auto pt-2 pt-md-3 movieSliderInfo"},[_c('p',{staticClass:"mb-0 title"},[_vm._v(_vm._s(singleMovie.Name))]),_vm._v(" "),_c('ul',{staticClass:"list-inline mb-0 mInfo"},[_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(singleMovie.Year))]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v("|")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(singleMovie.Rated))])])])])])],1):_vm._e()})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1120 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"OwnScreening"},[_c('div',{staticClass:"sdHome"},[(_vm.routeName === '/')?_c('div',{staticClass:"col-12 sliderDetails px-0 pr-md-3 px-lg-3"},[_c('p',{staticClass:"movieCat"},[_vm._v("CHOOSE YOUR MOVIE\n        "),_c('span',{staticClass:"txt-link"},[_c('router-link',{staticClass:"ml-3 ml-lg-4 mr-2",attrs:{"to":""}},[_vm._v("Watch Movies on Demand")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger viewmore-btn mr-4",on:{"click":function($event){_vm.showModal = true}}},[_vm._v("Know more")])],1),_vm._v(" "),_c('b-modal',{attrs:{"ok-variant":"danger"},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('ul',[_c('li',[_vm._v("Creating your own cinema screening is simple.")]),_vm._v(" "),_c('li',[_vm._v("\n              Just pick the movie you like from a large library of the movies\n              available.\n            ")]),_vm._v(" "),_c('li',[_vm._v("Complete the booking by selecting")]),_vm._v("\n            -Private Screening: Book the entire Cinema right now just for\n            yourself.\n            "),_c('br'),_vm._v("-Confirmed Screening: Book the tickets for a crowdsourced\n            screening to be confirmed\n            "),_c('br'),_vm._v("-Confirmed Screening: Book the minimum tickets and confirm\n            the screening right now\n            "),_c('br'),_vm._v(" "),_c('li',[_vm._v("and Invite your friends.")]),_vm._v(" "),_c('li',[_vm._v("If enough people book tickets by the date stated.")]),_vm._v(" "),_c('li',[_vm._v("Your screening is confirmed.")]),_vm._v(" "),_c('li',[_vm._v("\n              Don’t worry if the screening isn’t confirmed which rarely\n              happens, you get the refund within 48 hours\n            ")])])]),_vm._v(" "),_c('b-tooltip',{attrs:{"target":"tooltip-3","placement":"right"}})],1),_vm._v(" "),_c('p',{staticClass:"link"},[_c('router-link',{attrs:{"to":{ name: 'createScreenList' }}},[_vm._v("(See All)")])],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"sd"},[(_vm.routeName !== '/')?_c('div',{staticClass:"col-12 sliderDetails px-0 px-md-3"},[_c('p',{staticClass:"movieCat"},[_vm._v("\n        CREATE YOUR OWN SCREENING\n        "),_c('span',{staticClass:"link ml-2"},[_c('router-link',{attrs:{"to":{ name: 'createScreenList' }}},[_vm._v("(See All)")])],1)])]):_vm._e()]),_vm._v(" "),_c('Slick',{ref:"slick3",attrs:{"options":_vm.movieSlider}},_vm._l((_vm.OwnScreening),function(singleMovie,singleMovieIndex){return _c('div',{key:singleMovieIndex},[_c('div',{staticClass:"movieSlider-container mx-auto text-center"},[_c('div',{staticClass:"img-container"},[_c('router-link',{attrs:{"to":""},nativeOn:{"click":function($event){return _vm.goToRoute(singleMovie)}}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(singleMovie.md_thumbnail_url),expression:"singleMovie.md_thumbnail_url"}],staticClass:"img-fluid mx-auto banner",attrs:{"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"img-logo"},[_c('router-link',{attrs:{"to":""},nativeOn:{"click":function($event){return _vm.goToRoute(singleMovie)}}})],1)],1),_vm._v(" "),_c('div',{staticClass:"text-center mx-auto pt-2 pt-md-3 movieSliderInfo"},[_c('p',{staticClass:"mb-0 title"},[_vm._v(_vm._s(singleMovie.movie_title))]),_vm._v(" "),_c('ul',{staticClass:"list-inline mb-0 mInfo"},[_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(singleMovie.mf_name))]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v("|")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(singleMovie.rating))])])])])])}),0)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nowShowingSliderMobile_vue__ = __webpack_require__(587);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a60dcb6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nowShowingSliderMobile_vue__ = __webpack_require__(1123);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nowShowingSliderMobile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a60dcb6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nowShowingSliderMobile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"NowShowingSlider",attrs:{"id":"scroll-to"}},[(_vm.NowShowing.length > 0)?_c('div',{staticClass:"row"},_vm._l((_vm.NowShowing),function(singleMovie,singleindex){return _c('div',{key:singleindex,staticClass:"col-6 px-1 my-2"},[_c('router-link',{attrs:{"to":""}},[_c('div',{staticClass:"movieSlider-container mx-auto text-center"},[_c('div',{staticClass:"img-container"},[_c('router-link',{attrs:{"to":{
                  name: 'createScreen',
                  params: {
                    movie_id: singleMovie.movie_id,
                    content_lang_id: singleMovie.content_lang_id
                  }
                }}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(singleMovie.md_thumbnail_url),expression:"singleMovie.md_thumbnail_url"}],staticClass:"img-fluid mx-auto banner",attrs:{"alt":""}})])],1),_vm._v(" "),_c('div',{staticClass:"text-center mx-auto pt-2 pt-md-3 movieSliderInfo"},[_c('p',{staticClass:"mb-0 title"},[_vm._v(_vm._s(singleMovie.movie_title))]),_vm._v(" "),_c('ul',{staticClass:"list-inline mb-0 mInfo"},[_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(singleMovie.mf_name))]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v("|")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(singleMovie.rating))])])])])])],1)}),0):(_vm.loadingNow == false)?_c('div',{staticClass:"row"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.loadingNow)?_c('div',{staticClass:"row d-md-none"},[_vm._m(1)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 text-center"},[_c('h5',[_vm._v("\nRevolutionize the way you see movies! Create Your Own Show.\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 text-center"},[_c('img',{staticClass:"load-more",attrs:{"src":__webpack_require__(61)}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpecialScreeningsSliderMobile_vue__ = __webpack_require__(588);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c510c70_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpecialScreeningsSliderMobile_vue__ = __webpack_require__(1126);
function injectStyle (ssrContext) {
  __webpack_require__(1125)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpecialScreeningsSliderMobile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c510c70_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpecialScreeningsSliderMobile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1125 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"SpecialScreeningsSlider"},[_c('div',{staticClass:"sdHome"},[(
      _vm.routeName === '/' ||
      _vm.routeName === '/nowShowingList' ||
      _vm.routeName === '/miniFestivalList'
    )?_c('div',{staticClass:"col-12 sliderDetails px-0 pr-md-3 px-lg-3"},[_c('p',{staticClass:"movieCat"},[_vm._v("\n        SPECIAL SCREENINGS\n        "),_c('span',{staticClass:"txt-link"},[_c('router-link',{staticClass:"ml-3 ml-lg-4 mr-2",attrs:{"to":""}},[_vm._v("Watch Movies on Demand")])],1),_vm._v(" "),_c('b-modal',{attrs:{"ok-variant":"danger"},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('ul',[_c('li',[_vm._v("\n              Select the favorite movie you want to watch by clicking on the\n              movie image.\n            ")]),_vm._v(" "),_c('li',[_vm._v("\n              These movies are special screening created exclusively for fans\n              like you to enjoy.\n            ")]),_vm._v(" "),_c('li',[_vm._v("Join the screening by completing the booking process.")]),_vm._v(" "),_c('li',[_vm._v("Enjoy Exclusive screening of your favorite movie.")])])]),_vm._v(" "),_c('b-tooltip',{attrs:{"target":"tooltip-2","placement":"right"}})],1),_vm._v(" "),_c('p',{staticClass:"link"},[_c('router-link',{attrs:{"to":{ name: 'specialScreeningList' }}},[_vm._v("(See All)")])],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"sd"},[(
      _vm.routeName !== '/' &&
      _vm.routeName !== '/nowShowingList' &&
      _vm.routeName !== '/miniFestivalList'
    )?_c('div',{staticClass:"col-12 sliderDetails px-0 px-md-3"},[_c('p',{staticClass:"movieCat"},[_vm._v("\n        SPECIAL SCREENINGS\n        "),_c('span',{staticClass:"link ml-2"},[_c('router-link',{attrs:{"to":{ name: 'specialScreeningList' }}},[_vm._v("(See All)")])],1)])]):_vm._e()]),_vm._v(" "),_c('Slick',{ref:"slick2",attrs:{"options":_vm.movieSlider}},[_vm._l((10),function(singleMovie,singleindex){return (_vm.SpecialScreening.length == 0)?_c('div',{key:singleindex},[_c('div',{staticClass:"movieSlider-container mx-auto text-center"},[_c('div',{staticClass:"img-container"},[_c('img',{staticClass:"img-fluid mx-auto banner",attrs:{"src":__webpack_require__(585),"alt":""}})])])]):_vm._e()}),_vm._v(" "),_vm._l((_vm.SpecialScreening),function(singleMovie,singleMovieIndex){return (_vm.SpecialScreening.length > 0)?_c('div',{key:singleMovieIndex},[_c('router-link',{attrs:{"to":{
        name: 'createScreen',
        params: { movieId: singleMovie.ID, categoryId: 2 }
      }}},[_c('div',{staticClass:"movieSlider-container mx-auto text-center"},[_c('div',{staticClass:"img-container"},[_c('router-link',{attrs:{"to":{
              name: 'createScreen',
              params: { movieId: singleMovie.ID, categoryId: 2 }
            }}},[_c('img',{staticClass:"img-fluid mx-auto banner",attrs:{"src":singleMovie.Image,"alt":""}})])],1),_vm._v(" "),_c('div',{staticClass:"text-center mx-auto pt-2 pt-md-3 movieSliderInfo"},[_c('p',{staticClass:"mb-0 title"},[_vm._v(_vm._s(singleMovie.Name))]),_vm._v(" "),_c('ul',{staticClass:"list-inline mb-0 mInfo"},[_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(singleMovie.Year))]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v("|")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(singleMovie.Rated))])])])])])],1):_vm._e()})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OwnScreeningSliderMobile_vue__ = __webpack_require__(589);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c62aab0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OwnScreeningSliderMobile_vue__ = __webpack_require__(1128);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OwnScreeningSliderMobile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c62aab0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OwnScreeningSliderMobile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ownScreeningSlider",attrs:{"id":"scroll-to"}},[(_vm.ownScreening.length > 0)?_c('div',{staticClass:"row"},_vm._l((_vm.ownScreening),function(singleMovie,singleindex){return _c('div',{key:singleindex,staticClass:"col-6 px-1 my-2"},[_c('router-link',{attrs:{"to":""}},[_c('div',{staticClass:"movieSlider-container mx-auto text-center"},[_c('div',{staticClass:"img-container"},[_c('router-link',{attrs:{"to":{
                name: 'createScreen',
                params: {
                  movie_id: singleMovie.movie_id,
                  content_lang_id: singleMovie.content_lang_id
                }
              }}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(singleMovie.md_thumbnail_url),expression:"singleMovie.md_thumbnail_url"}],staticClass:"img-fluid mx-auto banner",attrs:{"alt":""}})])],1),_vm._v(" "),_c('div',{staticClass:"text-center mx-auto pt-2 pt-md-3 movieSliderInfo"},[_c('p',{staticClass:"mb-0 title"},[_vm._v(_vm._s(singleMovie.movie_title))]),_vm._v(" "),_c('ul',{staticClass:"list-inline mb-0 mInfo"},[_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(singleMovie.mf_name))]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v("|")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(singleMovie.rating))])])])])])],1)}),0):(_vm.loadingNow == false)?_c('div',{staticClass:"row"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.loadingNow)?_c('div',{staticClass:"row d-md-none"},[_vm._m(1)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 text-center"},[_c('h5',[_vm._v("No Movie Found")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 text-center"},[_c('img',{staticClass:"load-more",attrs:{"src":__webpack_require__(61)}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1129 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"NowShowingSlider"},_vm._l((_vm.MiniFestivals),function(festival,festIndex){return _c('div',{key:festIndex},[_c('div',{staticClass:"sdHome"},[(_vm.routeName === '/')?_c('div',{staticClass:"col-12 sliderDetails px-0 pr-md-3 px-lg-3"},[_c('p',{staticClass:"movieCat"},[_vm._v("\n          "+_vm._s(festival.category_link_name)+"\n\n          "),_c('span',{staticClass:"txt-link"}),_vm._v(" "),_c('b-modal',{attrs:{"hide-backdrop":""},model:{value:(_vm.showModal[festIndex]),callback:function ($$v) {_vm.$set(_vm.showModal, festIndex, $$v)},expression:"showModal[festIndex]"}},[_c('ul',[_c('li',[_vm._v("\n                "+_vm._s(festival.category_link_description)+"\n              ")])])]),_vm._v(" "),_c('b-tooltip',{attrs:{"target":'tooltip-mini' + festIndex,"placement":"right"}})],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"sd"},[(_vm.routeName !== '/')?_c('div',{staticClass:"col-12 sliderDetails px-0 px-md-3"},[_c('p',{staticClass:"movieCat"},[_vm._v("\n          "+_vm._s(festival.category_link_name)+"\n          ")])]):_vm._e()]),_vm._v(" "),_c('Slick',{ref:"slick1",refInFor:true,staticClass:"now-showing",attrs:{"options":_vm.movieSlider}},_vm._l((festival.movie_data.data),function(singleMovie,singleindex){return _c('div',{key:singleindex},[_c('router-link',{attrs:{"to":{
          name: 'createScreen',
          params: {
            movie_id: singleMovie.movie_id,
            content_lang_id: singleMovie.content_lang_id
          }
        }}},[_c('div',{staticClass:"movieSlider-container mx-auto text-center"},[_c('div',{staticClass:"img-container"},[_c('router-link',{attrs:{"to":{
                name: 'createScreen',
                params: {
                  movie_id: singleMovie.movie_id,
                  content_lang_id: singleMovie.content_lang_id
                }
              }}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(singleMovie.md_thumbnail_url),expression:"singleMovie.md_thumbnail_url"}],staticClass:"img-fluid mx-auto banner",attrs:{"alt":""}})])],1),_vm._v(" "),_c('div',{staticClass:"text-center mx-auto pt-2 pt-md-3 movieSliderInfo"},[_c('p',{staticClass:"mb-0 title"},[_vm._v(_vm._s(singleMovie.movie_title))]),_vm._v(" "),_c('ul',{staticClass:"list-inline mb-0 mInfo"},[_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(singleMovie.mf_name))]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v("|")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(singleMovie.rating))])])])])])],1)}),0)],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpcomingMiniFestivalsone_vue__ = __webpack_require__(592);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d74cdff8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UpcomingMiniFestivalsone_vue__ = __webpack_require__(1133);
function injectStyle (ssrContext) {
  __webpack_require__(1132)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpcomingMiniFestivalsone_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d74cdff8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UpcomingMiniFestivalsone_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1132 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"NowShowingSlider"},_vm._l((_vm.MiniFestivals),function(festival,festIndex){return _c('div',{key:festIndex},[_c('div',{staticClass:"sdHome"},[(_vm.routeName === '/')?_c('div',{staticClass:"col-12 sliderDetails px-0 pr-md-3 px-lg-3"},[_c('p',{staticClass:"movieCat"},[_vm._v("\n          "+_vm._s(festival.category_link_name)+"\n\n          "),_c('span',{staticClass:"txt-link"}),_vm._v(" "),_c('b-modal',{attrs:{"hide-backdrop":""},model:{value:(_vm.showModal[festIndex]),callback:function ($$v) {_vm.$set(_vm.showModal, festIndex, $$v)},expression:"showModal[festIndex]"}},[_c('ul',[_c('li',[_vm._v("\n                "+_vm._s(festival.category_link_description)+"\n              ")])])]),_vm._v(" "),_c('b-tooltip',{attrs:{"target":'tooltip-mini' + festIndex,"placement":"right"}})],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"sd"},[(_vm.routeName !== '/')?_c('div',{staticClass:"col-12 sliderDetails px-0 px-md-3"},[_c('p',{staticClass:"movieCat"},[_vm._v("\n          "+_vm._s(festival.category_link_name)+"\n          ")])]):_vm._e()]),_vm._v(" "),_c('Slick',{ref:"slick1",refInFor:true,staticClass:"now-showing",attrs:{"options":_vm.movieSlider}},_vm._l((festival.movie_data.data),function(singleMovie,singleindex){return _c('div',{key:singleindex},[_c('router-link',{attrs:{"to":{
          name: 'createScreen',
          params: {
            movie_id: singleMovie.movie_id,
            content_lang_id: singleMovie.content_lang_id
          }
        }}},[_c('div',{staticClass:"movieSlider-container mx-auto text-center"},[_c('div',{staticClass:"img-container"},[_c('router-link',{attrs:{"to":{
                name: 'createScreen',
                params: {
                  movie_id: singleMovie.movie_id,
                  content_lang_id: singleMovie.content_lang_id
                }
              }}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(singleMovie.md_thumbnail_url),expression:"singleMovie.md_thumbnail_url"}],staticClass:"img-fluid mx-auto banner",attrs:{"alt":""}})])],1),_vm._v(" "),_c('div',{staticClass:"text-center mx-auto pt-2 pt-md-3 movieSliderInfo"},[_c('p',{staticClass:"mb-0 title"},[_vm._v(_vm._s(singleMovie.movie_title))]),_vm._v(" "),_c('ul',{staticClass:"list-inline mb-0 mInfo"},[_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(singleMovie.mf_name))]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v("|")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(singleMovie.rating))])])])])])],1)}),0)],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpcomingMiniFestivalsMobile_vue__ = __webpack_require__(593);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a9e8cc8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UpcomingMiniFestivalsMobile_vue__ = __webpack_require__(1135);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpcomingMiniFestivalsMobile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a9e8cc8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UpcomingMiniFestivalsMobile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.MiniFestivalsArray.length > 0)?_c('div',_vm._l((_vm.MiniFestivalsArray),function(festival,festIndex){return _c('div',{key:festIndex},[_c('section',{staticClass:".filter-sticky-top-heading pt-1"},[_c('section',{staticClass:"container-fluid my-1"},[_c('div',{staticClass:"download-app"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 pr-0 align-self-center"},[_c('div',{staticClass:"d-flex align-slef-center mb-2"},[_c('div',{},[_c('strong',{staticClass:"text_theme"},[_vm._v(" "+_vm._s(festival.category_link_name))])]),_vm._v(" "),_c('b-modal',{attrs:{"hide-backdrop":""},model:{value:(_vm.showModal[festIndex]),callback:function ($$v) {_vm.$set(_vm.showModal, festIndex, $$v)},expression:"showModal[festIndex]"}},[_c('ul',[_c('li',[_vm._v("\n                        "+_vm._s(festival.category_link_description)+"\n                      ")])])]),_vm._v(" "),_c('b-tooltip',{attrs:{"target":'tooltip_mini' + festIndex,"placement":"bottom","triggers":"click"}})],1)])])])])]),_vm._v(" "),_c('section',{staticClass:"ownScreen-color"},[_c('div',{staticClass:"container-fluid mb-4"},[(festival.movie_data.data.length > 0)?_c('div',{staticClass:"OwnScreening"},[_c('Slick',{ref:"slick1",refInFor:true,staticClass:"now-showing",attrs:{"options":_vm.movieSlider}},_vm._l((festival.movie_data.data),function(singleMovie,singleindex){return _c('div',{key:singleindex},[_c('router-link',{attrs:{"to":{
                  name: 'createScreen',
                  params: {
                    movie_id: singleMovie.movie_id,
                    content_lang_id: singleMovie.content_lang_id
                  }
                }}},[_c('div',{staticClass:"movieSlider-container mx-auto text-center"},[_c('div',{staticClass:"img-container"},[_c('router-link',{attrs:{"to":{
                        name: 'createScreen',
                        params: {
                          movie_id: singleMovie.movie_id,
                          content_lang_id: singleMovie.content_lang_id
                        }
                      }}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(singleMovie.md_thumbnail_url),expression:"singleMovie.md_thumbnail_url"}],staticClass:"img-fluid mx-auto banner",attrs:{"alt":""}})])],1),_vm._v(" "),_c('div',{staticClass:"text-center mx-auto pt-2 pt-md-3 movieSliderInfo"},[_c('p',{staticClass:"mb-0 title"},[_vm._v(_vm._s(singleMovie.movie_title))]),_vm._v(" "),_c('ul',{staticClass:"list-inline mb-0 mInfo"},[_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                          "+_vm._s(singleMovie.mf_name)+"\n                        ")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v("|")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                          "+_vm._s(singleMovie.rating)+"\n                        ")])])])])])],1)}),0)],1):_vm._e()])])])}),0):(_vm.loadingMini == false)?_c('div',{staticClass:"row"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.loadingMini)?_c('div',{staticClass:"row d-md-none"},[_vm._m(1)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 text-center",staticStyle:{"color":"#8d99af"}},[_c('h5',[_vm._v("No Movie Found")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 text-center"},[_c('img',{staticClass:"load-more",attrs:{"src":__webpack_require__(61)}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpcomingMiniFestivalsMobileOne_vue__ = __webpack_require__(594);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b472a812_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UpcomingMiniFestivalsMobileOne_vue__ = __webpack_require__(1137);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpcomingMiniFestivalsMobileOne_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b472a812_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UpcomingMiniFestivalsMobileOne_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.MiniFestivalsArray.length > 0)?_c('div',_vm._l((_vm.MiniFestivalsArray),function(festival,festIndex){return _c('div',{key:festIndex},[_c('section',{staticClass:"filter-sticky-top-heading pt-1"},[_c('section',{staticClass:"container-fluid my-1"},[_c('div',{staticClass:"download-app"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 pr-0 align-self-center"},[_c('div',{staticClass:"d-flex align-slef-center mb-2"},[_c('div',{},[_c('strong',{staticClass:"text_theme"},[_vm._v(" "+_vm._s(festival.category_link_name))])]),_vm._v(" "),_c('b-modal',{attrs:{"hide-backdrop":""},model:{value:(_vm.showModal[festIndex]),callback:function ($$v) {_vm.$set(_vm.showModal, festIndex, $$v)},expression:"showModal[festIndex]"}},[_c('ul',[_c('li',[_vm._v("\n                        "+_vm._s(festival.category_link_description)+"\n                      ")])])]),_vm._v(" "),_c('b-tooltip',{attrs:{"target":'tooltip_mini' + festIndex,"placement":"bottom","triggers":"click"}})],1)])])])])]),_vm._v(" "),_c('section',{staticClass:"ownScreen-color"},[_c('div',{staticClass:"container-fluid mb-4"},[(festival.movie_data.data.length > 0)?_c('div',{staticClass:"OwnScreening"},[_c('Slick',{ref:"slick1",refInFor:true,staticClass:"now-showing",attrs:{"options":_vm.movieSlider}},_vm._l((festival.movie_data.data),function(singleMovie,singleindex){return _c('div',{key:singleindex},[_c('router-link',{attrs:{"to":{
                  name: 'createScreen',
                  params: {
                    movie_id: singleMovie.movie_id,
                    content_lang_id: singleMovie.content_lang_id
                  }
                }}},[_c('div',{staticClass:"movieSlider-container mx-auto text-center"},[_c('div',{staticClass:"img-container"},[_c('router-link',{attrs:{"to":{
                        name: 'createScreen',
                        params: {
                          movie_id: singleMovie.movie_id,
                          content_lang_id: singleMovie.content_lang_id
                        }
                      }}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(singleMovie.md_thumbnail_url),expression:"singleMovie.md_thumbnail_url"}],staticClass:"img-fluid mx-auto banner",attrs:{"alt":""}})])],1),_vm._v(" "),_c('div',{staticClass:"text-center mx-auto pt-2 pt-md-3 movieSliderInfo"},[_c('p',{staticClass:"mb-0 title"},[_vm._v(_vm._s(singleMovie.movie_title))]),_vm._v(" "),_c('ul',{staticClass:"list-inline mb-0 mInfo"},[_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                          "+_vm._s(singleMovie.mf_name)+"\n                        ")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v("|")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                          "+_vm._s(singleMovie.rating)+"\n                        ")])])])])])],1)}),0)],1):_vm._e()])])])}),0):(_vm.loadingMini == false)?_c('div',{staticClass:"row"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.loadingMini)?_c('div',{staticClass:"row d-md-none"},[_vm._m(1)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 text-center",staticStyle:{"color":"#8d99af"}},[_c('h5',[_vm._v("No Movie Found")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 text-center"},[_c('img',{staticClass:"load-more",attrs:{"src":__webpack_require__(61)}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1138 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-container"},[_c('div',{staticClass:"loader"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1140 */,
/* 1141 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container-fluid py-0 px-0 d-md-none d-block"},[_c('VueSlickCarousel',_vm._b({staticClass:"show-on-small-devices",style:({ paddingTop: '8px', paddingBottom: '3px' }),attrs:{"arrows":false}},'VueSlickCarousel',_vm.homeSliderNew,false),[_vm._l((3),function(singleBanner,bannerKey1){return (_vm.Banners.length == 0)?_c('div',{key:bannerKey1},[_c('div',{staticClass:"slider-container mx-auto 22"},[_c('img',{staticClass:"img-fluid pt-2 cus-img object-fit-contain",attrs:{"src":__webpack_require__(596),"alt":""}})])]):_vm._e()}),_vm._v(" "),_vm._l((_vm.Banners),function(singleBanner,bannerKey){return (_vm.Banners.length > 0)?_c('div',{key:bannerKey},[_c('div',{staticClass:"slider-container mx-auto 111"},[_c('transition',{attrs:{"name":"fade px-4  image-border "}},[_c('div',{staticClass:"centered-image-container"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(singleBanner.banner_image_url),expression:"singleBanner.banner_image_url"}],staticClass:"img-fluid cus-img banners px-4 object-fit-contain hloo",style:({  height: '140px' }),attrs:{"alt":""}})])])],1)]):_vm._e()})],2)],1),_vm._v(" "),_c('section',{class:['filter-sticky-top  pt-1 show-on-small-devices', { 'is-sticky': _vm.isSticky }]},[_c('section',{staticClass:"container-fluid my-3"},[_c('div',{staticClass:"row tab-showing"},_vm._l((_vm.tabArray),function(item,index){return _c('div',{key:index,staticClass:"col-4 px-2",on:{"click":function($event){return _vm.TabChange(item.position, item.payload)}}},[_c('div',{staticClass:"h-100 category-btn d-flex align-items-center justify-content-center text-center px-3 py-2",class:_vm.selectedTab.indexOf(item.position) >= 0 ? 'active' : ''},[_vm._v("\n              "+_vm._s(item.title)+"\n            ")])])}),0)]),_vm._v(" "),(!_vm.checkFilterExist)?_c('section',{staticClass:"container-fluid",class:_vm.checkFilterExist == false ? 'my-3' : ''},[_c('div',{staticClass:"d-flex justify-content-center align-items-center"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"filter-new-btn mx-2",on:{"click":_vm.showFilterModal}},[_c('div',[_vm._v("Filters")]),_vm._v(" "),_c('svg',{staticClass:"svg-inline--fa fa-sliders-h fa-w-16",attrs:{"aria-hidden":"true","focusable":"false","data-prefix":"fas","data-icon":"sliders-h","role":"img","height":"20","width":"20","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"fill":"#000","d":"M496 384H160v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h80v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h336c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160h-80v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h336v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h80c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160H288V48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h208v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16z"}})])]),_vm._v(" "),_vm._m(1)])]):_vm._e(),_vm._v(" "),_c('section',{staticClass:"container-fluid",class:_vm.checkFilterExist ? 'my-3' : ''},[(_vm.checkFilterExist)?_c('div',{staticClass:"filter-tabs"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-1"},[_c('span',{staticClass:"mr-3 ml-2",on:{"click":_vm.showFilterModal}},[_c('svg',{staticClass:"svg-inline--fa fa-sliders-h fa-w-16",attrs:{"aria-hidden":"true","focusable":"false","data-prefix":"fas","data-icon":"sliders-h","role":"img","height":"17","width":"17","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"fill":"#000","d":"M496 384H160v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h80v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h336c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160h-80v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h336v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h80c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160H288V48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h208v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16z"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-11"},[_c('ul',{staticClass:"list-inline filter-list mb-0"},_vm._l((_vm.showFilter),function(data,index2){return _c('span',{key:index2},_vm._l((data.all_filter),function(item,index){return (item.isActiveFilter == '1')?_c('li',{key:index,staticClass:"list-inline-item active mr-2"},[_c('div',{staticClass:"d-flex justify-content-center align-items-center",on:{"click":function($event){return _vm.getFilterVal(data, item, index2, index, '1')}}},[_c('div',[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('div',{staticClass:"filter-close"},[_vm._v("x")])])]):_vm._e()}),0)}),0)])])]):_vm._e()])]),_vm._v(" "),_c('section',{staticClass:"bg-light py-1 d-none d-md-block"},[_c('div',{staticClass:"container-fluid py-0 px-0"},[_c('VueSlickCarousel',_vm._b({ref:"slickCarousel",staticClass:"hide-on-small-devices",style:({ paddingTop: '8px', paddingBottom: '3px' })},'VueSlickCarousel',_vm.homeSliderNew,false),[_vm._l((3),function(singleBanner,bannerKey1){return (_vm.Banners.length == 0)?_c('div',{key:bannerKey1},[_c('div',{staticClass:"slider-container mx-auto 22"},[_c('img',{staticClass:"img-fluid pt-2 cus-img object-fit-contain",attrs:{"src":__webpack_require__(596),"alt":""}})])]):_vm._e()}),_vm._v(" "),_vm._l((_vm.Banners),function(singleBanner,bannerKey){return (_vm.Banners.length > 0)?_c('div',{key:bannerKey},[_c('div',{staticClass:"slider-container mx-auto 111"},[_c('transition',{attrs:{"name":"fade image-border"}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(singleBanner.banner_image_url),expression:"singleBanner.banner_image_url"}],staticClass:"img-fluid cus-img banners object-fit-contain hloo",attrs:{"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"filterBox"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center w-100 pl-4 pl-xl-5 detailBox nidhi111"},[_c('div',{staticClass:"movieDetails text-white"},[(singleBanner.banner_type_id == 1)?_c('p',{staticClass:"mTitle"},[_vm._v("\n                  "+_vm._s(singleBanner.banner_name)+"\n                ")]):_vm._e(),_vm._v(" "),(singleBanner.banner_type_id == 1)?_c('ul',{staticClass:"list-inline mInfo"},[_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                    "+_vm._s(singleBanner.lang_name)+"\n                  ")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                    "+_vm._s(singleBanner.mrrdr_runtime)+" min\n                  ")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                    "+_vm._s(_vm.GetYear(singleBanner.mrrdr_release_date))+"\n                  ")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                    "+_vm._s(singleBanner.rating)+"\n                  ")])]):_vm._e()]),_vm._v(" "),(singleBanner.banner_type_id == 1)?_c('div',[(singleBanner.button_enabled == 'Y')?_c('div',[_c('router-link',{attrs:{"to":{
                    name: 'createScreen',
                    params: {
                      movie_id: singleBanner.movie_id,
                      content_lang_id: singleBanner.content_lang_id
                    }
                  }}},[_c('img',{staticClass:"img-fluid ms-cs-img",attrs:{"src":__webpack_require__(1143)}})])],1):_c('div',{staticClass:"mr-4"},[_c('router-link',{attrs:{"to":{
                    name: 'createScreen',
                    params: {
                      movie_id: singleBanner.movie_id,
                      content_lang_id: singleBanner.content_lang_id
                    }
                  }}},[_c('div',[_c('button',{staticClass:"btn btn-danger gogo-btn mr-4"},[_vm._v("\n                        Book Now\n                      ")])])])],1)]):_vm._e()])])],1)]):_vm._e()})],2)],1)]),_vm._v(" "),_c('section',[_c('div',{staticClass:"container-fluid mb-4 mt-2 d-md-block d-none"},[_c('NowShowing')],1),_vm._v(" "),_c('div',{staticClass:"container-fluid mb-4 d-md-none",class:_vm.selectedTab.indexOf('1') >= 0 ? '' : 'd-none'},[_c('NowShowingMobile')],1)]),_vm._v(" "),_c('section',{staticClass:"d-none"},[_c('div',{staticClass:"container-fluid my-4 px-0"},[_c('div',{staticClass:"gogo-container"},[_c('img',{staticClass:"img-fluid w-100",attrs:{"src":__webpack_require__(1144)}}),_vm._v(" "),_c('div',{staticClass:"gogo-platform"},[_c('div',{staticClass:"col-6"},[_c('p',{staticClass:"title pb-2 pb-md-4"},[_vm._v("GoGo on the GO!")]),_vm._v(" "),_c('p',{staticClass:"txt pb-4 pb-md-5"},[_vm._v("\n                Download the App and book tickets to your favorite films\n                whenever, where ever!\n              ")]),_vm._v(" "),_c('div',[_c('router-link',{attrs:{"to":""}},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(1145)}})]),_vm._v(" "),_c('router-link',{staticClass:"bg-white py-2",attrs:{"to":""}},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(1146)}})])],1)])])])])]),_vm._v(" "),_c('section',{staticClass:"d-md-block"},[_c('div',{staticClass:"container-fluid my-4 d-md-block d-none"},[_c('UpcomingFestivals')],1),_vm._v(" "),_c('div',{staticClass:"container-fluid mb-4 d-md-none",class:_vm.selectedTab.indexOf('3') >= 0 ? '' : 'd-none'},[_c('UpcomingFestivalsMobile')],1),_vm._v(" "),_c('div')]),_vm._v(" "),_c('div',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadMore),expression:"loadMore"}],staticClass:"d-md-none",attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"0"}}),_vm._v(" "),_c('b-modal',{ref:"filterModalRef",attrs:{"hide-header-close":"","hide-footer":"","id":"filterModal","title":"Choose Any Filter","modal-class":"welcome-b"}},[_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){return _vm.hideFilter()}}},[_vm._v("\n        ×\n      ")]),_vm._v(" "),_c('div',{staticClass:"col-12 loginmodal p-3 p-md-4"},[_vm._l((_vm.showFilter),function(movie,index1){return _c('div',{key:index1,staticClass:"filter-tabs"},[_c('p',{staticClass:"border-bottom pb-2"},[_vm._v(_vm._s(movie.filter_name))]),_vm._v(" "),_c('ul',{staticClass:"list-inline"},_vm._l((movie.all_filter),function(data,index2){return (data.value)?_c('li',{key:index2,staticClass:"list-inline-item",class:data.isActive == '1' ? 'active' : '',on:{"click":function($event){return _vm.getFilterVal(movie, data, index1, index2, '2')}}},[_vm._v("\n              "+_vm._s(data.title)+"\n            ")]):_vm._e()}),0)])}),_vm._v(" "),_c('div',{staticClass:"row proceed-btn-filter text-center mt-5 mx-auto"},[_c('div',{staticClass:"col-6 mx-0 mx-auto"},[_c('button',{staticClass:"btn",attrs:{"type":"button","name":"","id":""},on:{"click":_vm.resetFilter}},[_vm._v("\n              Reset\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-6 mx-0 mx-auto"},[_c('button',{staticClass:"btn apply-filter",attrs:{"type":"button","name":"","id":""},on:{"click":_vm.applyFilter}},[_vm._v("\n              Apply Filters\n            ")])])])],2)]),_vm._v(" "),_c('section',{staticClass:"bg-light ownScreen-color py-2 d-md-block d-none"},[_c('div',{staticClass:"container-fluid mb-4"},[_c('OwnScreening')],1)]),_vm._v(" "),_c('section',{staticClass:"py-2 d-md-none"},[_c('div',{staticClass:"container-fluid mb-4 d-md-none",class:_vm.selectedTab.indexOf('2') >= 0 ? '' : 'd-none'},[_c('OwnScreeningMobile')],1)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hr',{staticClass:"hr-line"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hr',{staticClass:"hr-line"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1143 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/GogoOnGobg.7ba5723.svg";

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/GooglePlay-icon.1423f8f.svg";

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/AppStore-icon.c73900e.svg";

/***/ }),
/* 1147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_movieDetails_vue__ = __webpack_require__(597);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_995432c8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_movieDetails_vue__ = __webpack_require__(1149);
function injectStyle (ssrContext) {
  __webpack_require__(1148)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_movieDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_995432c8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_movieDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1148 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('h1',[_vm._v(_vm._s(_vm.msg))]),_vm._v(" "),_c('h2',[_vm._v("Essential Links")]),_vm._v(" "),_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.modal1",modifiers:{"modal1":true}}]},[_vm._v("Launch demo modal")]),_vm._v(" "),_c('b-modal',{attrs:{"id":"modal1","title":"Bootstrap-Vue"},on:{"hidden":_vm.stopYoutube}},[_c('p',{staticClass:"my-4"},[_vm._v("Youtube trailer")]),_vm._v(" "),_c('youtube',{staticStyle:{"width":"100%"},attrs:{"video-id":_vm.youtubeURL,"player-width":"100%"},on:{"ready":_vm.ready}})],1),_vm._v("\n  "+_vm._s(_vm.movieDetails)+"\n")],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_movieListing_vue__ = __webpack_require__(598);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1b8a6c4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_movieListing_vue__ = __webpack_require__(1152);
function injectStyle (ssrContext) {
  __webpack_require__(1151)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a1b8a6c4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_movieListing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1b8a6c4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_movieListing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1151 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('h1',[_vm._v(_vm._s(_vm.msg))]),_vm._v(" "),_c('h2',[_vm._v("Essential Links")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Go to fierfuer")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('h2',[_vm._v("Ecosystem")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_c('a',{attrs:{"href":"https://vuejs.org","target":"_blank","rel":"noopener"}},[_vm._v("Core Docs")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://forum.vuejs.org","target":"_blank","rel":"noopener"}},[_vm._v("Forum")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"http://chat.vuejs.org/","target":"_blank","rel":"noopener"}},[_vm._v("Vue Community Chat")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://twitter.com/vuejs","target":"_blank","rel":"noopener"}},[_vm._v("Twitter")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"http://vuejs-templates.github.io/webpack/","target":"_blank","rel":"noopener"}},[_vm._v("Docs for This Template")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_c('a',{attrs:{"href":"http://router.vuejs.org/","target":"_blank","rel":"noopener"}},[_vm._v("vue-router")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"http://vuex.vuejs.org/","target":"_blank","rel":"noopener"}},[_vm._v("vuex")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"http://vue-loader.vuejs.org/","target":"_blank","rel":"noopener"}},[_vm._v("vue-loader")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://github.com/vuejs/awesome-vue","target":"_blank","rel":"noopener"}},[_vm._v("awesome-vue")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_seatlayout_vue__ = __webpack_require__(599);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_525e81b2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_seatlayout_vue__ = __webpack_require__(1232);
function injectStyle (ssrContext) {
  __webpack_require__(1154)
  __webpack_require__(1155)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-525e81b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_seatlayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_525e81b2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_seatlayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1154 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1155 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row px-0 px-md-2 my-4 back-txt"},[_c('div',{staticClass:"col-6"},[_c('router-link',{attrs:{"to":"/"}},[_c('span',{staticClass:"mr-1"},[_vm._v("‹")]),_vm._v("Go back to movie list\n      ")])],1)]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-lg-3 p-3 p-xl-3 cs-scr-ticket h-75 mx-auto mb-5 mb-lg-0"},[_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"col-5 col-md-6 col-xl-5 pr-xl-2 pr-lg-0 pr-1 pl-0 pl-md-2 rounded"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.movieDetails.md_thumbnail_url),expression:"movieDetails.md_thumbnail_url"}],staticClass:"img-fluid",staticStyle:{"border-radius":"7px"}})]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column justify-content-between pl-3"},[_c('div',[_c('p',{staticClass:"mb-1"},[_vm._v(_vm._s(_vm.movieDetails.movie_title))]),_vm._v(" "),_c('ul',{staticClass:"list-inline movie-tickDetails"},[_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                  "+_vm._s(_vm.movieDetails.mrrdr_runtime)+"\n                ")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                  "+_vm._s(_vm.movieDetails.mrrdr_release_date_year)+"\n                ")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                  "+_vm._s(_vm.movieDetails.lang_name)+" ("+_vm._s(_vm.movieDetails.mf_name)+")\n                ")])])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"rt-txt2"},[_c('span',{staticClass:"d-block small"},[_vm._v("Rating")]),_vm._v("\n                "+_vm._s(_vm.movieDetails.rating)+"\n              ")])])])]),_vm._v(" "),_c('hr',{staticClass:"topLine my-2"}),_vm._v(" "),_c('div',[_c('small',{staticClass:"vCont"},[_vm._v("Cinema:")]),_vm._v(" "),_c('p',{staticClass:"hCont"},[_vm._v("\n            "+_vm._s(_vm.movieDetails.cine_name)+", "+_vm._s(_vm.movieDetails.cine_address)+"\n          ")]),_vm._v(" "),_c('small',{staticClass:"vCont"},[_vm._v("Screen:")]),_vm._v(" "),_c('p',{staticClass:"hCont"},[_vm._v("\n            "+_vm._s(_vm.movieDetails.screen_name)+"\n          ")])]),_vm._v(" "),_c('div',[_c('small',{staticClass:"vCont"},[_vm._v("Date & Time:")]),_vm._v(" "),_c('ul',{staticClass:"list-inline dateTime hCont"},[_c('li',{staticClass:"list-inline-item"},[_vm._v("\n              "+_vm._s(_vm.showDateHandlaler(_vm.movieDetails.ss_start_date))+"\n              "+_vm._s(_vm.timeFormat(_vm.movieDetails.ss_start_show_time))+"\n            ")])])]),_vm._v(" "),(_vm.CategoryID == 2 || _vm.CategoryID == 3)?_c('div',[_c('small',{staticClass:"vCont"},[_vm._v("Screening Type:")]),_vm._v(" "),_c('p',{staticClass:"hCont"},[_vm._v("Crowdsourced Screening")])]):_vm._e(),_vm._v(" "),_c('div',{},[_c('small',{staticClass:"vCont"},[_vm._v("Pick Seats:")]),_vm._v(" "),(_vm.getSeatsSelected)?_c('ul',{staticClass:"list-inline seatList hCont"},_vm._l((_vm.getSeatsSelected),function(singleSeat,singleSeatIndex){return _c('li',{key:singleSeatIndex,staticClass:"list-inline-item"},[(_vm.vista_schedule_id)?_c('span',[_vm._v("\n                "+_vm._s(("" + (singleSeat.rowLabel) + (singleSeat.seatLabel)))+"\n              ")]):(_vm.rts_performance_id)?_c('span',[_vm._v("\n                "+_vm._s(("" + (singleSeat.RowDes._text) + (singleSeat.ColDes._text)))+"\n              ")]):_c('span',[_vm._v("\n                "+_vm._s(singleSeat.sl_seat_name)+"\n              ")])])}),0):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"amount-box my-4",class:{ hide: this.$store.getters.SELECTED_SEATS.length === 0 }},[_c('div',{staticClass:"ticketAmount"},[_c('div',{staticClass:"d-flex justify-content-between"},[_c('p',[_c('span',[_vm._v("Tickets ("+_vm._s(this.$store.getters.SELECTED_SEATS.length))]),_vm._v(") :\n              ")]),_vm._v(" "),(this.$store.getters.SELECTED_SEATS.length > 0)?_c('p',[_vm._v("\n                "+_vm._s(_vm.curr_code)+" "+_vm._s(_vm.currFormat(_vm.totalNetAmout))+"\n              ")]):_vm._e()]),_vm._v(" "),(_vm.chargeTypeArray && _vm.chargeTypeArray.length > 0)?_c('div',{},_vm._l(([].concat( _vm.chargeTypeArray ).reverse()),function(charge,chargeIndex){return _c('div',{key:chargeIndex,staticClass:"d-flex justify-content-between"},[_c('p',[_vm._v(_vm._s(charge.ct_name)+" :")]),_vm._v(" "),_c('p',[_vm._v("\n                  "+_vm._s(_vm.curr_code)+"\n                  "+_vm._s(_vm.currFormat(charge.tax_amount))+"\n                ")])])}),0):_vm._e(),_vm._v(" "),_c('hr',{staticClass:"bottomLine my-4"})]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between",class:{ hide: this.$store.getters.SELECTED_SEATS.length === 0 }},[_vm._m(0),_vm._v(" "),_c('p',{staticClass:"hCont"},[_vm._v("\n              "+_vm._s(_vm.curr_code)+" "+_vm._s(_vm.currFormat(_vm.totalAmountPrice))+"\n            ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-lg-9 px-0 px-lg-3 modalCus"},[_c('div',{attrs:{"role":"tablist"}},[_c('b-card',{staticClass:"seat-selection mb-1",attrs:{"no-body":"","id":"scrollToSection"}},[_c('b-card-header',{staticClass:"accordion-header",attrs:{"header-tag":"header","role":"tab"},on:{"click":function($event){return _vm.onClickTab()}}},[_c('div',{staticClass:"d-flex align-items-center header-box"},[_c('b-button',{staticClass:"py-md-3",class:_vm.showCollapseSeatLayout ? 'active' : '',attrs:{"block":"","href":"#","variant":"default"}},[_vm._v("\n                  1. Select Seats\n                  "),(!_vm.showCollapseSeatLayout)?_c('span',{staticClass:"check-markIcon"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(21)}})]):_vm._e(),_vm._v(" "),(_vm.showCollapseSeatLayout)?_c('span',{staticClass:"check-markIcon"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(50)}})]):_vm._e()])],1)]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion4","accordion":"my-accordion","role":"tabpanel"},model:{value:(_vm.showCollapseSeatLayout),callback:function ($$v) {_vm.showCollapseSeatLayout=$$v},expression:"showCollapseSeatLayout"}},[_c('b-card-body',[_c('div',{staticClass:"col-12 mx-auto text-center px-0"},[_c('div',{staticClass:"text-center"},[_c('img',{staticClass:"img-fluid d-none d-md-block mx-auto",attrs:{"src":__webpack_require__(617)}}),_vm._v(" "),_c('img',{staticClass:"mob-img-fluid d-md-none",attrs:{"src":__webpack_require__(618)}})]),_vm._v(" "),_c('div',{staticClass:"seat-count mt-0 mb-4 my-md-4"},[(_vm.totalNumberOfSeats == 0)?_c('p',{staticClass:"text-center mt-3"},[_vm._v("\n                      HOW MANY SEATS?\n                    ")]):_vm._e(),_vm._v(" "),(
                        _vm.totalNumberOfSeats !== 0 && _vm.totalNumberOfSeats == 1
                      )?_c('p',{staticClass:"text-center mt-3"},[_vm._v("\n                      Selected :\n                      "),_c('span',[_vm._v(_vm._s(this.$store.getters.SELECTED_SEATS.length)+" /\n                        "+_vm._s(_vm.totalNumberOfSeats)+" Seat")]),_vm._v("  \n                      "),_c('span',{staticClass:"edit-class",on:{"click":function($event){return _vm.onEdit()}}},[_vm._v("(Edit)")])]):_vm._e(),_vm._v(" "),(
                        _vm.totalNumberOfSeats !== 0 && _vm.totalNumberOfSeats != 1
                      )?_c('p',{staticClass:"text-center mt-3"},[_vm._v("\n                      Selected :\n                      "),_c('span',[_vm._v(_vm._s(this.$store.getters.SELECTED_SEATS.length)+" /\n                        "+_vm._s(_vm.totalNumberOfSeats)+" Seats")]),_vm._v("  \n                      "),_c('span',{staticClass:"edit-class",on:{"click":function($event){return _vm.onEdit()}}},[_vm._v("(Edit)")])]):_vm._e(),_vm._v(" "),_c('ul',{staticClass:"list-inline pick-seats mt-4"},_vm._l((8),function(number,a){return (_vm.totalNumberOfSeats == 0)?_c('li',{key:a,staticClass:"list-inline-item",class:{ active: number == _vm.totalNumberOfSeats },on:{"click":function($event){return _vm.editNumberOfSeats(number)}}},[_vm._v("\n                        "+_vm._s(number)+"\n                      ")]):_vm._e()}),0)]),_vm._v(" "),_c('div',{staticClass:"seat-layout table-responsive"},_vm._l((_vm.seatType),function(singleSeatLayout,seatIndex){return (_vm.totalNumberOfSeats > 0 && _vm.seatType.length > 0)?_c('div',{key:seatIndex,staticClass:"mx-auto text-center"},[(singleSeatLayout.seatsFinal.length > 0)?_c('div',{staticClass:"mt-4 mb-2 seat-formatTxt"},[_c('div',{staticClass:"seat-catg screen-class",staticStyle:{"margin-top":"10px"}},[_c('div',[_vm._v("("+_vm._s(singleSeatLayout.seatType)+")")]),_vm._v(" "),_c('div',[_vm._v("\n                            Ticket Price : "+_vm._s(_vm.curr_code)+"\n                            "+_vm._s(_vm.currFormat(singleSeatLayout.seat_net_price) ||
                              _vm.currFormat(singleSeatLayout.seat_price))+"\n                          ")])])]):_vm._e(),_vm._v(" "),_c('table',{staticClass:"mx-auto seat-table"},_vm._l((singleSeatLayout.seatsFinal),function(seatArray,seatRowIndex){return _c('tr',{key:seatRowIndex},_vm._l((seatArray),function(singleSeat,singleSeatIndex){return _c('td',{key:singleSeatIndex},[(singleSeat.srt_id == 2)?_c('div',{staticClass:"hide py-2"}):_c('div',[(_vm.vista_schedule_id)?_c('div',{class:_vm.getVistaSeatClass(singleSeat),on:{"click":function ($event) {
                                    _vm.handlerSeatSelected(
                                      singleSeat,
                                      seatRowIndex,
                                      singleSeatIndex,
                                      null,
                                      null,
                                      $event,
                                      seatIndex
                                    );
                                    _vm.seatsSelectedRateGroup();
                                  }}}):(_vm.rts_performance_id)?_c('div',{class:_vm.getRtsSeatClass(singleSeat),on:{"click":function ($event) {
                                    _vm.handlerSeatSelected(
                                      singleSeat,
                                      seatRowIndex,
                                      singleSeatIndex,
                                      null,
                                      null,
                                      $event,
                                      seatIndex
                                    );
                                    _vm.seatsSelectedRateGroup();
                                  }}}):_c('div',{class:singleSeat.selectStatus == true
                                    ? singleSeat.srt_id == 3
                                      ? 'wheel active'
                                      : 'seat active'
                                    : singleSeat.seat_reserve_type_id == 1
                                    ? 'seat'
                                    : singleSeat.seat_reserve_type_id == 3
                                    ? 'wheel'
                                    : singleSeat.seat_reserve_type_id == 6
                                    ? 'seat'
                                    : singleSeat.seat_reserve_type_id == 7
                                    ? 'seat'
                                    : singleSeat.seat_reserve_type_id == 8
                                    ? singleSeat.srt_id == 3
                                      ? 'wheel disabled seat'
                                      : 'seat disabled'
                                    : singleSeat.seat_reserve_type_id == 9
                                    ? 'seat disabled'
                                    : singleSeat.seat_reserve_type_id == 10
                                    ? 'seat'
                                    : singleSeat.seat_reserve_type_id == 11
                                    ? 'seat'
                                    : singleSeat.seat_reserve_type_id == 12
                                    ? 'seat disabled'
                                    : singleSeat.seat_reserve_type_id == 13
                                    ? 'seat disabled'
                                    : 'seat',on:{"click":function ($event) {
                                    _vm.handlerSeatSelected(
                                      singleSeat,
                                      seatRowIndex,
                                      singleSeatIndex,
                                      null,
                                      null,
                                      $event,
                                      seatIndex
                                    );
                                    _vm.seatsSelectedRateGroup();
                                  }}})])])}),0)}),0)]):_vm._e()}),0),_vm._v(" "),_c('ul',{staticClass:"list-inline seat-info my-4 my-md-5"},[_c('li',{staticClass:"list-inline-item"},[_c('img',{staticClass:"pb-1 mr-2",attrs:{"src":__webpack_require__(619)}}),_vm._v("Available\n                    ")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_c('img',{staticClass:"pb-1 mr-2",attrs:{"src":__webpack_require__(620)}}),_vm._v("Unavailable\n                    ")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_c('img',{staticClass:"pb-1 mr-2",staticStyle:{"width":"17px"},attrs:{"src":__webpack_require__(621)}}),_vm._v("Wheelchair\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"text-danger my-2"}),_vm._v(" "),_c('div',{attrs:{"to":""},on:{"click":function($event){return _vm.setBookingSeats()}}},[(
                        this.$store.getters.SELECTED_SEATS.length > 0 &&
                        this.$store.getters.SELECTED_SEATS.length ==
                          _vm.totalNumberOfSeats
                      )?_c('div',{staticClass:"proceed-btn"},[_c('button',{staticClass:"btn btn-danger py-md-2 px-md-4 my-3",attrs:{"type":"button","name":"","id":""}},[_vm._v("\n                        Confirm\n                      ")])]):_vm._e()])])])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"verify-c"},[_c('b-modal',{ref:"WheelChairModal",staticClass:"text-center",attrs:{"hide-footer":"","no-close-on-esc":"","no-close-on-backdrop":"","hide-header-close":"","id":"WheelChairModal","title":"Wheel Chair"}},[_c('div',{staticClass:"p-5"},[_c('div',{staticClass:"text-center mb-3"},[_c('img',{attrs:{"width":"47","height":"auto","src":__webpack_require__(622)}})]),_vm._v(" "),_c('div',{staticClass:"text-center mt-3 mt-md-0 font-weight-bold"},[_vm._v("\n                Notice\n              ")]),_vm._v(" "),_c('div',{staticClass:"text-center mt-3 mt-md-0"},[_vm._v("\n                You have selected a wheelchair space which is for wheelchair\n                user only.\n              ")]),_vm._v(" "),_c('b-button',{staticClass:"w-50 mx-auto gogo-btn btn btn-danger mt-3 d-flex justify-content-center align-items-center",on:{"click":function($event){return _vm.onClickOk()}}},[_vm._v("OK\n              ")])],1)])],1),_vm._v(" "),_c('b-modal',{ref:"SeatRealeased",staticClass:"text-center",attrs:{"no-close-on-esc":"","no-close-on-backdrop":"","hide-header-close":"","hide-footer":"","id":"minimumPayment","title":"FAILED !"}},[_c('div',{staticClass:"p-5"},[_c('div',{staticClass:"text-center mt-3 mt-md-0"},[_vm._v(_vm._s(_vm.showMessage))]),_vm._v(" "),_c('b-button',{staticClass:"w-50 mx-auto gogo-btn btn btn-danger mt-3 d-flex justify-content-center align-items-center",on:{"click":_vm.hideModal}},[_vm._v("Go Back")])],1)])],1)])]),_vm._v(" "),_c('b-modal',{ref:"showRateCard",attrs:{"hide-footer":"","hide-header":"","id":"showRateCard","title":"Show Rate Card","size":"lg"}},[_c('div',{staticClass:"container px-2 px-md-3"},[_c('div',{staticClass:"select-seat-container-myticket"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mx-auto"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 py-3 bg-light rounded"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-4"},[_c('strong',[_vm._v("TICKET ")])]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('strong',[_vm._v(" PRICE ")])]),_vm._v(" "),_c('div',{staticClass:"col-5"},[_c('strong',[_vm._v("No of Seats ")])])])]),_vm._v(" "),_vm._l((_vm.seatsSelectedRateGroupNew),function(item,index){return (_vm.seatsSelectedRateGroupNew)?_c('div',{key:index,staticClass:"col-12 py-2 border-bottom"},[_c('div',{staticClass:"st-name"},[_vm._v(_vm._s(item.srt_name))]),_vm._v(" "),_c('div',{staticClass:"row align-self-center"},[_vm._l((item.rate_card_group),function(rg,rg_index){return _c('div',{staticClass:"col-12 row my-2 p-0"},[_c('div',{staticClass:"col-4 align-self-center",staticStyle:{"line-break":"anywhere"}},[_c('strong',[_vm._v("\n                      "+_vm._s(rg.tt_name)+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-3 align-self-center"},[_c('strong',[_vm._v("\n                      "+_vm._s(_vm.curr_code)+" "+_vm._s(_vm.currFormat(rg.rc_total_amount))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-5"},[_c('div',{staticClass:"d-flex align-items-center justify-content-center w-100 h-100"},[_c('button',{staticClass:"cursor-pointer btn-subtract-myticket",class:rg.totalSeatSelected == 0 ? 'disabled' : '',on:{"click":function($event){return _vm.totalCount(rg, index, rg_index, 'decrement')}}},[_vm._v("\n                        -\n                      ")]),_vm._v(" "),_c('strong',{staticClass:"w-100px"},[_vm._v(_vm._s(rg.totalSeatSelected))]),_vm._v(" "),_c('button',{staticClass:"cursor-pointer btn-add-myticket",class:item.totalSelected == item.AllSeats.length
                            ? 'disabled'
                            : '',on:{"click":function($event){return _vm.totalCount(rg, index, rg_index, 'increment')}}},[_vm._v("\n                        +\n                      ")])])])])}),_vm._v(" "),_c('div',{staticClass:"col-12 py-3 bg-light rounded"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-4"},[_c('strong',[_vm._v("Total Seat Selected")])]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('strong')]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('strong',[_vm._v(_vm._s(item.totalSelected)+"/"+_vm._s(item.AllSeats.length))])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 py-3 my-2 bg-light rounded"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-4"},[_c('strong',[_vm._v("Total Amoun1t")])]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('strong')]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('strong',[_vm._v(_vm._s(_vm.curr_code)+"\n                        "+_vm._s(_vm.currFormat(_vm.totalAmountPrice)))])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 py-4"},[_c('button',{staticClass:"btn btn-danger py-2 px-5 mt-3",attrs:{"disabled":_vm.errorMessage ? true : false},on:{"click":_vm.onSubmitFromRateCardModal}},[_vm._v("\n                    Proceed\n                  ")])])],2)]):_vm._e()})],2)])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"mb-0 vCont"},[_vm._v("Total Amount Payable :")]),_vm._v(" "),_c('small',{staticClass:"vCont"},[_vm._v("(Amount inclusive of all service fees and taxes)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_payment_vue__ = __webpack_require__(623);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ae8e54e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_payment_vue__ = __webpack_require__(1237);
function injectStyle (ssrContext) {
  __webpack_require__(1234)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5ae8e54e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_payment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ae8e54e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_payment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1234 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1235 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timer-circle d-flex justify-content-center align-items-center"},[_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.timer.minutes)+":"+_vm._s(_vm.timer.seconds))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showPayPalConformationBlur)?_c('div',{class:"loader-paypal"}):_vm._e(),_vm._v(" "),_c('div',{class:("container-fluid " + (_vm.showPayPalConformationBlur ?  "blur-updated-class" : null) + " ")},[_c('div',{staticClass:"row px-0 px-md-2 my-3 back-txt"},[_c('div',{staticClass:"col-5 col-md-6 align-self-center"},[_c('router-link',{attrs:{"to":"/"}},[_c('span',{staticClass:"mr-1"},[_vm._v("‹")]),_vm._v("Go back to movie list\n       ")])],1),_vm._v(" "),_c('div',{staticClass:"col-7 col-md-6 pr-3 pr-lg-4 align-self-center"},[_c('div',{staticClass:"timer-circle ml-auto mb-0"},[_vm._v("\n         Time Remaining :  \n         "),_c('span',[_vm._v("\n           "+_vm._s(_vm.timer.minutes.toString().length == "1"
               ? "0" + _vm.timer.minutes
               : _vm.timer.minutes)+":"+_vm._s(_vm.timer.seconds.toString().length == "1"
               ? "0" + _vm.timer.seconds
               : _vm.timer.seconds))])])])]),_vm._v(" "),_c('div',{staticClass:"verify-c"},[_c('b-modal',{ref:"errorCard",attrs:{"no-close-on-esc":"","no-close-on-backdrop":"","hide-footer":"","hide-header-close":"","id":"errorCard","title":"FAILED!"}},[_c('div',{staticClass:"p-5"},[_c('div',{staticClass:"text-center mt-3 mt-md-0"},[_vm._v("Sorry, "+_vm._s(_vm.msgError))]),_vm._v(" "),_c('b-button',{staticClass:"w-50 mx-auto gogo-btn btn btn-danger mt-3 d-flex justify-content-center align-items-center",on:{"click":_vm.hideModal}},[_vm._v("Cancel\n         ")])],1)])],1),_vm._v(" "),_c('div',{staticClass:"verify-c"},[_c('b-modal',{ref:"sessionTimeOut",staticClass:"text-center",attrs:{"no-close-on-esc":"","no-close-on-backdrop":"","hide-header-close":"","hide-footer":"","id":"sessionTimeOut","title":"HURRY UP!"}},[_c('div',{staticClass:"p-5"},[_c('div',{staticClass:"text-center mt-3 mt-md-0"},[_vm._v("\n           Your booking has timed out!\n         ")]),_vm._v(" "),_c('div',{staticClass:"text-center mt-3 mt-md-0"},[_vm._v("\n           Click Here to restart the booking\n         ")]),_vm._v(" "),_c('b-button',{staticClass:"w-50 mx-auto gogo-btn btn btn-danger mt-3 d-flex justify-content-center align-items-center",on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("Go Back\n         ")])],1)])],1),_vm._v(" "),_c('div',{staticClass:"verify-c"},[_c('b-modal',{ref:"apiKeyfailed",staticClass:"text-center",attrs:{"no-close-on-esc":"","no-close-on-backdrop":"","hide-header-close":"","hide-footer":"","id":"apiKeyfailed","title":"Failed!"}},[_c('div',{staticClass:"p-5"},[_c('div',{staticClass:"text-center mt-3 mt-md-0"},[_vm._v("API key is invalid !")]),_vm._v(" "),_c('div',{staticClass:"text-center mt-3 mt-md-0"},[_vm._v("\n           Click Here to restart the booking\n         ")]),_vm._v(" "),_c('b-button',{staticClass:"w-50 mx-auto gogo-btn btn btn-danger mt-3 d-flex justify-content-center align-items-center",on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("Go Back\n         ")])],1)])],1),_vm._v(" "),_c('div',{staticClass:"verify-c"},[_c('b-modal',{ref:"minimumPayment",staticClass:"text-center",attrs:{"no-close-on-esc":"","no-close-on-backdrop":"","hide-header-close":"","hide-footer":"","id":"minimumPayment","title":"HURRY UP!"}},[_c('div',{staticClass:"p-5"},[_c('div',{staticClass:"text-center mt-3 mt-md-0"},[_vm._v("Sorry, the payment failed.")]),_vm._v(" "),_c('div',{staticClass:"text-center mt-3 mt-md-0"},[_vm._v("\n           Click Here to restart the booking\n         ")]),_vm._v(" "),_c('b-button',{staticClass:"w-50 mx-auto gogo-btn btn btn-danger mt-3 d-flex justify-content-center align-items-center",on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("Go Back\n         ")])],1)])],1),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-lg-3 h-75 mx-auto mb-4 px-0 mb-lg-2"},[_c('div',{staticClass:"cs-scr-ticket p-3 p-xl-3 mb-4"},[_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"col-5 col-md-6 col-xl-5 pr-xl-2 pr-lg-0 pr-1 pl-0 pl-md-2 rounded"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.showDetails.md_thumbnail_url),expression:"showDetails.md_thumbnail_url"}],staticClass:"img-fluid"})]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column justify-content-between pl-3"},[_c('div',[_c('p',{staticClass:"mb-1"},[_vm._v(_vm._s(_vm.showDetails.movie_title))]),_vm._v(" "),_c('ul',{staticClass:"list-inline movie-tickDetails"},[_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                     "+_vm._s(_vm.showDetails.mrrdr_runtime)+"\n                   ")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(_vm.showDetails.rating))]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                     "+_vm._s(_vm.showDetails.lang_name)+"\n                   ")])])]),_vm._v(" "),(false)?_c('div',[_c('p',{staticClass:"rt-txt1"},[_c('span',{staticClass:"d-block small"},[_vm._v("IMDB")]),_vm._v("\n                   "+_vm._s(_vm.showDetails.imdb_link)+"\n                 ")]),_vm._v(" "),_c('p',{staticClass:"rt-txt2"},[_c('span',{staticClass:"d-block small"},[_vm._v("Rating")]),_vm._v("\n                   "+_vm._s(_vm.showDetails.rating)+"\n                 ")])]):_vm._e()])]),_vm._v(" "),_c('hr',{staticClass:"topLine my-2"}),_vm._v(" "),_c('div',{},[_c('small',{staticClass:"vCont"},[_vm._v("\n               Cinema:\n               ")]),_vm._v(" "),_c('p',{staticClass:"hCont"},[_vm._v("\n               "+_vm._s(_vm.showDetails.cine_name)+",  \n               "+_vm._s(_vm.showDetails.cine_address)+"\n             ")]),_vm._v(" "),_c('small',{staticClass:"vCont"},[_vm._v("\n               Screen:\n               ")]),_vm._v(" "),_c('p',{staticClass:"hCont"},[_vm._v(_vm._s(_vm.showDetails.screen_name))])]),_vm._v(" "),_c('div',{},[_c('small',{staticClass:"vCont"},[_vm._v("\n               Date & Time:\n               ")]),_vm._v(" "),_c('ul',{staticClass:"list-inline dateTime hCont"},[(_vm.checkKey == false)?_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                 "+_vm._s(_vm.showDateHandlaler(_vm.showDetails.ss_start_date))+" |\n                 "+_vm._s(_vm.timeFormat(_vm.showDetails.ss_start_show_time))+"\n               ")]):_vm._e(),_vm._v(" "),(_vm.checkKey)?_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                 "+_vm._s(_vm.showDetails.DateTime)+"\n               ")]):_vm._e()])]),_vm._v(" "),(
               _vm.CategoryID === '2' ||
                 _vm.CategoryID === '4' ||
                 _vm.CategoryID == 2 ||
                 _vm.CategoryID === 4
             )?_c('div',[_c('small',{staticClass:"vCont"},[_vm._v("\n               Screening Type:\n               ")]),_vm._v(" "),_c('p',{staticClass:"hCont"},[_vm._v(_vm._s(_vm.showDetails.booking_type_name))])]):_vm._e(),_vm._v(" "),_c('div',[_c('p',{staticClass:"hCont"},[_vm._v(_vm._s(_vm.showDetails.text_desc))])]),_vm._v(" "),(_vm.ShowType != 'Private')?_c('div',{},[_c('small',{staticClass:"vCont"},[_vm._v("\n               Pick Seats:\n               ")]),_vm._v(" "),_c('ul',{staticClass:"list-inline seatList hCont"},[_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                 "+_vm._s(_vm.showDetails.seat_name.replace("Hall", "Auditorium"))+"\n               ")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"amount-box my-4"},[_c('div',{staticClass:"ticketAmount"},[_c('div',{staticClass:"d-flex justify-content-between"},[_c('p',[_vm._v("\n                   Tickets\n                   "),_c('span',[_vm._v("("+_vm._s(this.CategoryID == 2
                         ? _vm.showDetails.booking_type_id == 3
                           ? _vm.showDetails.screen_no_of_seats
                           : _vm.showDetails.ticket_count
                         : _vm.showDetails.ticket_count))]),_vm._v(") :\n                 ")]),_vm._v(" "),_c('p',[_vm._v("\n                   "+_vm._s(_vm.curr_code)+" "+_vm._s(_vm.currFormat(_vm.showDetails.net_amount))+"\n                 ")])]),_vm._v(" "),(
                   _vm.showDetails.chargeTypeArray &&
                     _vm.showDetails.chargeTypeArray.length > 0
                 )?_c('div',{},_vm._l(([].concat( _vm.showDetails.chargeTypeArray ).reverse()),function(charge,chargeIndex){return _c('div',{key:chargeIndex,staticClass:"d-flex justify-content-between"},[_c('p',[_vm._v(_vm._s(charge.ct_name)+" :")]),_vm._v(" "),_c('p',[_vm._v("\n                     "+_vm._s(_vm.curr_code)+"\n                     "+_vm._s(_vm.currFormat(charge.tax_amount))+"\n                   ")])])}),0):_vm._e(),_vm._v(" "),(_vm.promoApplied)?_c('div',{staticClass:"d-flex justify-content-between"},[_c('div',[_c('p',{staticClass:"mb-0"},[_vm._v("\n                     Promocode Discount :\n                     ")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.promocode))])]),_vm._v(" "),_c('p',{staticClass:"text-success"},[_c('span',[_vm._v("-")]),_vm._v("  \n                   "+_vm._s(_vm.curr_code)+" "+_vm._s(_vm.currFormat(_vm.DiscountValue))+"\n                 ")])]):_vm._e(),_vm._v(" "),_c('hr',{staticClass:"bottomLine my-4",attrs:{"id":"totalPayment"}})]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between"},[_vm._m(0),_vm._v(" "),_c('p',{staticClass:"hCont"},[_vm._v("\n                 "+_vm._s(_vm.curr_code)+" "+_vm._s(_vm.currFormat(_vm.totalPayableAmount))+"\n               ")])]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),(_vm.showCoupon)?_c('div',{staticClass:"promoCode-box"},[_c('p',{staticClass:"vCont"},[_vm._v("\n               Apply Promo Code:\n               ")]),_vm._v(" "),_c('b-input-group',[_c('b-form-input',{staticClass:"promo-code-text",attrs:{"type":"text","placeholder":"Apply Your Promo Code"},model:{value:(_vm.promocode),callback:function ($$v) {_vm.promocode=$$v},expression:"promocode"}}),_vm._v(" "),_c('b-input-group-append',[_c('b-button',{staticClass:"promo-btn",attrs:{"variant":"default"},on:{"click":function($event){return _vm.onApplyPromocode()}}},[_vm._v("APPLY")])],1)],1),_vm._v(" "),_c('small',{staticClass:"mt-2 text-danger"},[_vm._v(_vm._s(this.promocodeErrorMessage))]),_vm._v(" "),_c('small',{staticClass:"mt-2 text-success"},[_vm._v(_vm._s(this.promocodeSuccesMessage))])],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-lg-9 px-0 px-lg-3 mb-5 mb-md-0"},[_c('div',{attrs:{"role":"tablist"}},[_c('b-card',{staticClass:"mb-1",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"accordion-header",attrs:{"header-tag":"header","role":"tab"},on:{"click":function($event){_vm.tabs.collapse1 = !_vm.tabs.collapse1}}},[_c('div',{staticClass:"d-flex align-items-center header-box"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion1",modifiers:{"accordion1":true}}],staticClass:"py-md-3 cus-btn",class:Object.values(_vm.bookingDetails).length == 0 &&
                     _vm.tabs.collapse1
                       ? 'active'
                       : '',attrs:{"block":"","href":"#","variant":"default"}},[_vm._v("\n                   1. Contact Information\n                   "),(Object.values(_vm.bookingDetails).length > 0)?_c('img',{staticClass:"img-fluid ml-2",attrs:{"src":__webpack_require__(56)}}):_vm._e(),_vm._v(" "),(!_vm.tabs.collapse1)?_c('span',{staticClass:"check-markIcon"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(21)}})]):_vm._e(),_vm._v(" "),(_vm.tabs.collapse1)?_c('span',{staticClass:"check-markIcon"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(50)}})]):_vm._e()])],1)]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion1","visible":"","accordion":"my-accordion","role":"tabpanel"}},[_c('b-card-body',[_c('div',{staticClass:"col-12 p-0 p-md-3"},[_c('div',{staticClass:"row"},[(_vm.userInfo || _vm.userLoggedIn)?_c('div',{staticClass:"col-md-6 mx-auto login-box"},[_c('div',{staticClass:"mob-login-box pr-md-5"},[_c('b-form',{attrs:{"data-vv-scope":"verifyUserDetails"}},[_c('b-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"mt-1 mr-sm-2 pc-input",attrs:{"id":"inlineFormInputName22","placeholder":"Enter your Email Address"},model:{value:(_vm.userDetails.email),callback:function ($$v) {_vm.$set(_vm.userDetails, "email", $$v)},expression:"userDetails.email"}}),_vm._v(" "),_c('div',{staticClass:"row align-items-center mt-3"},[_c('div',{staticClass:"col-3 pr-0 pr-xl-2 country-code-drop"},[(_vm.CountryCodeList.length > 0)?_c('b-dropdown',{staticClass:"pc-input form-control",attrs:{"slot":"append","text":_vm.userDetails.country_mob_code || 'Code',"variant":"default"},slot:"append"},[_c('div',{staticClass:"px-2 pb-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchCode),expression:"searchCode"}],staticClass:"form-control form-control-sm",attrs:{"required":"","autofocus":"","type":"search","placeholder":"Search Code"},domProps:{"value":(_vm.searchCode)},on:{"keyup":function($event){return _vm.onSearchCode($event.target.value)},"keydown":function($event){return _vm.onSearchCode($event.target.value)},"search":function($event){return _vm.onSearchCode($event.target.value)},"input":function($event){if($event.target.composing){ return; }_vm.searchCode=$event.target.value}}})]),_vm._v(" "),_vm._l((_vm.CountryCodeList),function(country,countryIndex){return _c('b-dropdown-item',{key:countryIndex,on:{"click":function($event){return _vm.onChangeCountry(country)}}},[_vm._v(_vm._s(country.country_mob_code)+"  \n                                   "+_vm._s(country.country_name))])})],2):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('b-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"mr-sm-2 pc-input",attrs:{"name":"phonenumber","type":"number","id":"inlineFormInputName10","placeholder":"Enter Your Phone Number"},model:{value:(_vm.userDetails.phone_no),callback:function ($$v) {_vm.$set(_vm.userDetails, "phone_no", $$v)},expression:"userDetails.phone_no"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(
                                 _vm.errors.has('verifyUserDetails.phonenumber')
                               ),expression:"\n                                 errors.has('verifyUserDetails.phonenumber')\n                               "}],staticClass:"text-danger text-center my-2 pl-3"},[_vm._v("\n                               "+_vm._s(_vm.errors.first("verifyUserDetails.phonenumber"))+"\n                             ")])]),_vm._v(" "),_c('div',{staticClass:"small text-muted mt-2"},[_vm._v("\n                             * Tickets will be sent to the above contact\n                             details\n                           ")]),_vm._v(" "),_c('div',{staticClass:"mt-2"},[_c('b-button',{staticClass:"gogo-btn btn btn-danger",on:{"click":function($event){return _vm.validateBeforeSubmit('verifyUserDetails')}}},[_vm._v("\n                               Confirm Your Details\n                             ")])],1)],1)],1)]):_vm._e(),_vm._v(" "),(_vm.ShowSignUp && !_vm.userLoggedIn)?_c('div',{staticClass:"col-md-6 mx-auto loginmodal"},[(!_vm.userInfo && !_vm.ShowLogin)?_c('p',{staticClass:"mb-2 log-text"},[_vm._v("\n                         Sign Up\n                       ")]):_vm._e(),_vm._v(" "),(!_vm.userInfo && !_vm.ShowLogin)?_c('b-form',{attrs:{"data-vv-scope":"signUp","name":"signUpForm"},on:{"submit":function($event){$event.preventDefault();return _vm.validateBeforeSubmit('signUp')}}},[_c('div',{staticClass:"mob-login-box"},[_c('b-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],staticClass:"mt-1 mr-sm-2 pc-input",attrs:{"autocomplete":"false","name":"email","type":"email","id":"inlineFormInputNameemail2","placeholder":"Enter Your Email Address"},model:{value:(_vm.signUpUserDetails.email),callback:function ($$v) {_vm.$set(_vm.signUpUserDetails, "email", $$v)},expression:"signUpUserDetails.email"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signUp.email')),expression:"errors.has('signUp.email')"}],staticClass:"py-1 text-danger font-weight-bold small"},[_vm._v("\n                             "+_vm._s(_vm.errors.first("signUp.email"))+"\n                           ")]),_vm._v(" "),_c('div',{staticClass:"row align-items-center mt-3"},[_c('div',{staticClass:"col-3 pr-0 pr-xl-2 country-code-drop"},[(_vm.CountryCodeList.length > 0)?_c('b-dropdown',{staticClass:"pc-input form-control",attrs:{"slot":"append","text":_vm.signUpUserDetails.country_mob_code || 'Code',"variant":"default"},slot:"append"},[_c('div',{staticClass:"px-2 pb-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchCode),expression:"searchCode"}],staticClass:"form-control form-control-sm",attrs:{"type":"search","placeholder":"Search Code","name":"countryCode"},domProps:{"value":(_vm.searchCode)},on:{"keyup":function($event){return _vm.onSearchCode($event.target.value)},"keydown":function($event){return _vm.onSearchCode($event.target.value)},"search":function($event){return _vm.onSearchCode($event.target.value)},"input":function($event){if($event.target.composing){ return; }_vm.searchCode=$event.target.value}}})]),_vm._v(" "),_vm._l((_vm.CountryCodeList),function(country,countryIndex){return _c('b-dropdown-item',{key:countryIndex,on:{"click":function($event){return _vm.onChangeCountry(country)}}},[_vm._v(_vm._s(country.country_mob_code)+" \n                                   "+_vm._s(country.country_name))])})],2):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('b-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:8|max:12'),expression:"'required|min:8|max:12'"}],staticClass:"mr-sm-2 pc-input",attrs:{"name":"phonenumber","type":"number","min":0,"id":"inlineFormInputName11","placeholder":"Enter Your Phone Number"},model:{value:(_vm.signUpUserDetails.phoneNumber),callback:function ($$v) {_vm.$set(_vm.signUpUserDetails, "phoneNumber", $$v)},expression:"signUpUserDetails.phoneNumber"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(
                                   _vm.errors.has('signUpUserDetails.phonenumber')
                                 ),expression:"\n                                   errors.has('signUpUserDetails.phonenumber')\n                                 "}],staticClass:"text-danger text-center my-2"},[_vm._v("\n                                 "+_vm._s(_vm.errors.first(
                                     "signUpUserDetails.phonenumber"
                                   ))+"\n                               ")])],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signUp.phonenumber')),expression:"errors.has('signUp.phonenumber')"}],staticClass:"py-1 text-danger font-weight-bold small"},[_vm._v("\n                             "+_vm._s(_vm.errors.first("signUp.phonenumber"))+"\n                           ")]),_vm._v(" "),_c('b-input',{directives:[{name:"validate",rawName:"v-validate",value:({
                               required: 'required',
                               regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z0-9!@#$%^&*]{6,}$/
                             }),expression:"{\n                               required: 'required',\n                               regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z0-9!@#$%^&*]{6,}$/\n                             }"}],staticClass:"mt-3 mr-sm-2 pc-input",attrs:{"type":"password","name":"password","id":"inlineFormInputNamepassword","placeholder":"Enter Your Password"},model:{value:(_vm.signUpUserDetails.password),callback:function ($$v) {_vm.$set(_vm.signUpUserDetails, "password", $$v)},expression:"signUpUserDetails.password"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signUp.password')),expression:"errors.has('signUp.password')"}],staticClass:"py-1 text-danger font-weight-bold small"},[_vm._v("\n                             "+_vm._s(!_vm.signUpUserDetails.password
                                 ? _vm.passwordRequiredMessage
                                 : _vm.passwordValidationMessage)+"\n                             ")])],1),_vm._v(" "),_c('b-form-checkbox',{staticClass:"grey-text pc-radio mt-2 mb-2 mt-md-2 mb-md-2",attrs:{"id":"checkbox-tandc","name":"checkbox-tandc","value":"accepted","unchecked-value":"not_accepted"},model:{value:(_vm.signUpUserDetails.termsAndConditions),callback:function ($$v) {_vm.$set(_vm.signUpUserDetails, "termsAndConditions", $$v)},expression:"signUpUserDetails.termsAndConditions"}},[_vm._v("\n                           I agree to all\n                           "),_c('router-link',{staticClass:"tnc-class",attrs:{"to":"/termsCondition","target":"_blank"}},[_vm._v("Terms & Conditions\n                           ")])],1),_vm._v(" "),_c('div',{staticClass:"small text-muted mt-2 cursor-pointer",on:{"click":function($event){return _vm.onClickLogin()}}},[_vm._v("\n                           Already have an account? Click here to\n                           "),_c('u',[_c('b',[_vm._v("Sign In")])])]),_vm._v(" "),_c('div',{staticClass:"py-2 text-danger font-weight-bold small"},[_vm._v("\n                           "+_vm._s(_vm.errorMessage.signUp)+"\n                         ")]),_vm._v(" "),_c('input',{staticClass:"btn btn-danger gogo-btn mt-2",attrs:{"type":"submit","name":"submitBtn","value":"Create an account"}})],1):_vm._e()],1):(_vm.ShowLogin && !_vm.userLoggedIn)?_c('div',{staticClass:"col-md-6 mb-5 mb-md-0 mx-auto login-box"},[_c('p',{staticClass:"log-text mb-2"},[_vm._v("LOGIN")]),_vm._v(" "),_c('div',{staticClass:"mob-login-box pr-md-5"},[_c('b-form',{attrs:{"data-vv-scope":"UserSignIn"}},[_c('b-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],staticClass:"mt-1 mr-sm-2 pc-input",attrs:{"type":"email","id":"inlineFormInputName4","placeholder":"Enter Your Email Address"},model:{value:(_vm.userDetails.email),callback:function ($$v) {_vm.$set(_vm.userDetails, "email", $$v)},expression:"userDetails.email"}}),_vm._v(" "),_c('b-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"mt-3 mr-sm-2 pc-input",attrs:{"type":"password","id":"inlineFormInputName5","placeholder":"Enter Your Password"},model:{value:(_vm.userDetails.password),callback:function ($$v) {_vm.$set(_vm.userDetails, "password", $$v)},expression:"userDetails.password"}}),_vm._v(" "),_c('div',{staticClass:"py-2 text-danger font-weight-bold small"},[_vm._v("\n                             "+_vm._s(_vm.errorMessage.login)+"\n                           ")]),_vm._v(" "),_c('div',{staticClass:"small text-muted mb-2 cursor-pointer",on:{"click":function($event){return _vm.onClickForgotPassword()}}},[_vm._v("\n                             Forgot Password?\n                           ")]),_vm._v(" "),_c('div',{staticClass:"small text-muted mt-2 cursor-pointer",on:{"click":function($event){return _vm.onClickSignUp()}}},[_vm._v("\n                             Do not have an account? Click here to\n                             "),_c('u',[_c('b',[_vm._v("Sign Up")])])]),_vm._v(" "),_c('div',[_c('b-button',{staticClass:"my-2 btn btn-danger gogo-btn",on:{"click":function($event){return _vm.validateBeforeSubmit('UserSignIn')}}},[_vm._v("Login")])],1)],1)],1)]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-12 px-0 d-none"},[_c('div',{staticClass:"text-success font-weight-bold d-md-flex"},[_c('div',{staticClass:"text-mob mt-3 mt-md-0"},[_vm._v("\n                       Awesome! Your verification is complete and your account\n                       has been created! You’ll get a link to reset your\n                       password which you can do later if you’d like as well.\n                     ")])])])])],1)],1),_vm._v(" "),_c('b-card',{staticClass:"mb-1",attrs:{"no-body":"","id":"PaymentShow"}},[_c('b-card-header',{staticClass:"accordion-header",attrs:{"header-tag":"header","role":"tab"}},[_c('div',{staticClass:"d-flex align-items-center header-box"},[_c('b-button',{staticClass:"py-md-3",class:[
                     Object.values(_vm.bookingDetails).length == 0
                       ? 'disabled'
                       : _vm.tabs.collapse2
                       ? 'active'
                       : ''
                   ],attrs:{"href":"#","block":"","variant":"default"}},[_vm._v("\n                   2. Payment Mode\n                   "),(_vm.showProceedButton)?_c('img',{staticClass:"img-fluid ml-2",attrs:{"src":__webpack_require__(56)}}):_vm._e(),_vm._v(" "),(!_vm.tabs.collapse2)?_c('span',{staticClass:"check-markIcon"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(21)}})]):_vm._e(),_vm._v(" "),(_vm.tabs.collapse2)?_c('span',{staticClass:"check-markIcon"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(50)}})]):_vm._e()])],1)]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion2","accordion":"my-accordion","role":"tabpanel"}},[(_vm.directPay)?_c('b-card-body',[_c('div',{attrs:{"id":"dropin-container"}}),_vm._v(" "),_c('b-button',{ref:"submitButton",staticClass:"btn py-md-2 px-md-5 btn-danger",attrs:{"id":"submit-button"},on:{"click":function($event){return _vm.payNow()}}},[_vm._v("PAY\n                   "+_vm._s(_vm.curr_code)+"\n                   "+_vm._s(_vm.currFormat(_vm.totalPayableAmount)))])],1):(_vm.isBrainTreeActive && _vm.bt_client_token && !_vm.slect_payment_mode && _vm.is_branin_tree_active)?_c('b-card-body',[_c('div',{attrs:{"id":"dropin-container"}},[_c('v-braintree',{attrs:{"authorization":_vm.bt_client_token,"btnText":("Pay " + _vm.curr_code + " " + (_vm.currFormat(_vm.totalPayableAmount))),"btnClass":"btn btn-danger","vaultManager":true},on:{"load":_vm.onLoad,"loadFail":_vm.onLoadFail,"success":_vm.bt_makePayment,"error":_vm.onError}})],1)]):(!_vm.PaymentOptionsLoading && !_vm.slect_payment_mode && _vm.is_branin_tree_active)?_c('b-card-body',[_c('div',{staticClass:"w-100 text-center mt-5 text-muted",attrs:{"id":"no-payment-modes"}},[_c('p',[_vm._v("No Active Payment Modes. Contact Support Team")]),_vm._v(" "),_c('router-link',{staticClass:"mt-3 btn btn-danger text-light",attrs:{"to":{
                       name: 'Home'
                     }}},[_vm._v("Home")])],1)]):_vm._e(),_vm._v(" "),_c('b-button',{ref:"submitButton",staticClass:"btn btn-danger btn py-md-2 px-md-5 m-2 btn-danger",attrs:{"id":"submit-button"},on:{"click":function($event){return _vm.paypal_makePayment()}}},[_vm._v("Pay\n                   "+_vm._s(_vm.curr_code)+"\n                   "+_vm._s(_vm.currFormat(_vm.totalPayableAmount)))])],1)],1),_vm._v(" "),_c('b-card',{staticClass:"d-none mb-1",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"accordion-header",attrs:{"header-tag":"header","role":"tab"},on:{"click":function($event){_vm.tabs.collapse3 = !_vm.tabs.collapse3}}},[_c('div',{staticClass:"d-flex align-items-center header-box"},[_c('b-button',{staticClass:"py-md-3",class:[
                     _vm.tabs.collapse3 && _vm.showProceedButton
                       ? 'active'
                       : _vm.showProceedButton
                       ? ''
                       : 'disabled'
                   ],attrs:{"block":"","href":"#","variant":"default"}},[_vm._v("\n                   3. Confirmation\n                   "),(!_vm.tabs.collapse3 && !_vm.showProceedButton)?_c('span',{staticClass:"check-markIcon"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(21)}})]):(_vm.tabs.collapse3 && _vm.showProceedButton)?_c('span',{staticClass:"check-markIcon"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(50)}})]):(_vm.tabs.collapse3)?_c('span',{staticClass:"check-markIcon"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(21)}})]):_vm._e()])],1)]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion3","accordion":"my-accordion","role":"tabpanel"}},[_c('b-card-body',[_c('div',{staticClass:"col-sm-4 px-0 px-md-3 mb-3 col-lg-4 mx-auto text-center"},[(_vm.confirmDetails)?_c('router-link',{attrs:{"to":{
                       name: 'confirmScreen',
                       params: {
                         bookingId: _vm.confirmDetails.BookingID || 0,
                         paymentId: _vm.PaymentId || 2
                       }
                     }}},[(_vm.showProceedButton)?_c('b-button',{staticClass:"gogo-btn btn btn-danger"},[_vm._v("Confirm")]):_vm._e()],1):_vm._e()],1)])],1)],1)],1)])])]),_vm._v(" "),_c('b-modal',{ref:"SeatRealeased",staticClass:"text-center",attrs:{"no-close-on-esc":"","no-close-on-backdrop":"","hide-header-close":"","hide-footer":"","id":"minimumPayment","title":"FAILED !"}},[_c('div',{staticClass:"p-5"},[_c('div',{staticClass:"text-center mt-3 mt-md-0"},[_vm._v(_vm._s(_vm.showMessage))]),_vm._v(" "),_c('b-button',{staticClass:"w-50 mx-auto gogo-btn btn btn-danger mt-3 d-flex justify-content-center align-items-center",on:{"click":_vm.hideModal}},[_vm._v("Go Back")])],1)])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"mb-0 vCont"},[_vm._v("\n                   Total Amount Payable :\n                   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('small',{staticClass:"vCont"},[_vm._v("(Amount inclusive of all service fees and taxes)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VistaPayment_vue__ = __webpack_require__(625);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ccc9a5d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VistaPayment_vue__ = __webpack_require__(1240);
function injectStyle (ssrContext) {
  __webpack_require__(1239)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3ccc9a5d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VistaPayment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ccc9a5d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VistaPayment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1239 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row px-0 px-md-2 my-3 back-txt"},[_c('div',{staticClass:"col-5 col-md-6 align-self-center"},[_c('router-link',{attrs:{"to":"/"}},[_c('span',{staticClass:"mr-1"},[_vm._v("‹")]),_vm._v("Go back to movie list\n      ")])],1),_vm._v(" "),_c('div',{staticClass:"col-7 col-md-6 pr-3 pr-lg-4 align-self-center"},[_c('div',{staticClass:"timer-circle ml-auto mb-0"},[_vm._v("\n        Time Remaining :  \n        "),_c('span',[_vm._v("\n          "+_vm._s(_vm.timer.minutes.toString().length == "1"
              ? "0" + _vm.timer.minutes
              : _vm.timer.minutes)+":"+_vm._s(_vm.timer.seconds.toString().length == "1"
              ? "0" + _vm.timer.seconds
              : _vm.timer.seconds))])])])]),_vm._v(" "),_c('div',{staticClass:"verify-c"},[_c('b-modal',{ref:"errorCard",attrs:{"no-close-on-esc":"","no-close-on-backdrop":"","hide-footer":"","hide-header-close":"","id":"errorCard","title":"FAILED!"}},[_c('div',{staticClass:"p-5"},[_c('div',{staticClass:"text-center mt-3 mt-md-0"},[_vm._v("Sorry, "+_vm._s(_vm.msgError))]),_vm._v(" "),_c('b-button',{staticClass:"w-50 mx-auto gogo-btn btn btn-danger mt-3 d-flex justify-content-center align-items-center",on:{"click":_vm.hideModal}},[_vm._v("Cancel\n        ")])],1)])],1),_vm._v(" "),_c('div',{staticClass:"verify-c"},[_c('b-modal',{ref:"sessionTimeOut",staticClass:"text-center",attrs:{"no-close-on-esc":"","no-close-on-backdrop":"","hide-header-close":"","hide-footer":"","id":"sessionTimeOut","title":"HURRY UP!"}},[_c('div',{staticClass:"p-5"},[_c('div',{staticClass:"text-center mt-3 mt-md-0"},[_vm._v("\n          Your booking has timed out!\n        ")]),_vm._v(" "),_c('div',{staticClass:"text-center mt-3 mt-md-0"},[_vm._v("\n          Click Here to restart the booking\n        ")]),_vm._v(" "),_c('b-button',{staticClass:"w-50 mx-auto gogo-btn btn btn-danger mt-3 d-flex justify-content-center align-items-center",on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("Go Back\n        ")])],1)])],1),_vm._v(" "),_c('div',{staticClass:"verify-c"},[_c('b-modal',{ref:"apiKeyfailed",staticClass:"text-center",attrs:{"no-close-on-esc":"","no-close-on-backdrop":"","hide-header-close":"","hide-footer":"","id":"apiKeyfailed","title":"Failed!"}},[_c('div',{staticClass:"p-5"},[_c('div',{staticClass:"text-center mt-3 mt-md-0"},[_vm._v("API key is invalid !")]),_vm._v(" "),_c('div',{staticClass:"text-center mt-3 mt-md-0"},[_vm._v("\n          Click Here to restart the booking\n        ")]),_vm._v(" "),_c('b-button',{staticClass:"w-50 mx-auto gogo-btn btn btn-danger mt-3 d-flex justify-content-center align-items-center",on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("Go Back\n        ")])],1)])],1),_vm._v(" "),_c('div',{staticClass:"verify-c"},[_c('b-modal',{ref:"minimumPayment",staticClass:"text-center",attrs:{"no-close-on-esc":"","no-close-on-backdrop":"","hide-header-close":"","hide-footer":"","id":"minimumPayment","title":"HURRY UP!"}},[_c('div',{staticClass:"p-5"},[_c('div',{staticClass:"text-center mt-3 mt-md-0"},[_vm._v("Sorry, the payment failed.")]),_vm._v(" "),_c('div',{staticClass:"text-center mt-3 mt-md-0"},[_vm._v("\n          Click Here to restart the booking\n        ")]),_vm._v(" "),_c('b-button',{staticClass:"w-50 mx-auto gogo-btn btn btn-danger mt-3 d-flex justify-content-center align-items-center",on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("Go Back\n        ")])],1)])],1),_vm._v(" "),(_vm.showDetails.hasOwnProperty('md_thumbnail_url'))?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-lg-3 h-75 mx-auto mb-4 px-0 mb-lg-2"},[_c('div',{staticClass:"cs-scr-ticket p-3 p-xl-3 mb-4"},[_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"col-5 col-md-6 col-xl-5 pr-xl-2 pr-lg-0 pr-1 pl-0 pl-md-2 rounded"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.showDetails.md_thumbnail_url),expression:"showDetails.md_thumbnail_url"}],staticClass:"img-fluid"})]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column justify-content-between pl-3"},[_c('div',[_c('p',{staticClass:"mb-1"},[_vm._v(_vm._s(_vm.showDetails.movie_title))]),_vm._v(" "),_c('ul',{staticClass:"list-inline movie-tickDetails"},[_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                    "+_vm._s(_vm.showDetails.mrrdr_runtime)+"\n                  ")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(_vm.showDetails.rating))]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                    "+_vm._s(_vm.showDetails.lang_name)+"\n                  ")])])]),_vm._v(" "),(false)?_c('div',[_c('p',{staticClass:"rt-txt1"},[_c('span',{staticClass:"d-block small"},[_vm._v("IMDB")]),_vm._v("\n                  "+_vm._s(_vm.showDetails.imdb_link)+"\n                ")]),_vm._v(" "),_c('p',{staticClass:"rt-txt2"},[_c('span',{staticClass:"d-block small"},[_vm._v("Rating")]),_vm._v("\n                  "+_vm._s(_vm.showDetails.rating)+"\n                ")])]):_vm._e()])]),_vm._v(" "),_c('hr',{staticClass:"topLine my-2"}),_vm._v(" "),_c('div',{},[_c('small',{staticClass:"vCont"},[_vm._v("\n              Cinema:\n            ")]),_vm._v(" "),_c('p',{staticClass:"hCont"},[_vm._v("\n              "+_vm._s(_vm.showDetails.cine_name)+",  \n              "+_vm._s(_vm.showDetails.cine_address)+"\n            ")]),_vm._v(" "),_c('small',{staticClass:"vCont"},[_vm._v("\n              Screen:\n            ")]),_vm._v(" "),_c('p',{staticClass:"hCont"},[_vm._v(_vm._s(_vm.showDetails.screen_name))])]),_vm._v(" "),_c('div',{},[_c('small',{staticClass:"vCont"},[_vm._v("\n              Date & Time:\n            ")]),_vm._v(" "),_c('ul',{staticClass:"list-inline dateTime hCont"},[(_vm.checkKey == false)?_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                "+_vm._s(_vm.GetDate(_vm.showDetails.ss_start_date, "full"))+" |\n                "+_vm._s(_vm.timeFormat(_vm.showDetails.ss_start_show_time))+"\n              ")]):_vm._e(),_vm._v(" "),(_vm.checkKey)?_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                "+_vm._s(_vm.showDetails.DateTime)+"\n              ")]):_vm._e()])]),_vm._v(" "),(
              _vm.CategoryID === '2' ||
                _vm.CategoryID === '4' ||
                _vm.CategoryID == 2 ||
                _vm.CategoryID === 4
            )?_c('div',[_c('small',{staticClass:"vCont"},[_vm._v("\n              Screening Type:\n            ")]),_vm._v(" "),_c('p',{staticClass:"hCont"},[_vm._v(_vm._s(_vm.showDetails.booking_type_name))])]):_vm._e(),_vm._v(" "),(_vm.ShowType != 'Private')?_c('div',{},[_c('small',{staticClass:"vCont"},[_vm._v("\n              Pick Seats:\n            ")]),_vm._v(" "),_c('ul',{staticClass:"list-inline seatList hCont"},[_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                "+_vm._s(_vm.showDetails.seat_name.replace("Hall", "Auditorium"))+"\n              ")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"amount-box my-4"},[_c('div',{staticClass:"ticketAmount"},[_c('div',{staticClass:"d-flex justify-content-between"},[_c('p',[_vm._v("\n                  Tickets\n                  "),_c('span',[_vm._v("("+_vm._s(this.CategoryID == 2
                        ? _vm.showDetails.booking_type_id == 3
                          ? _vm.showDetails.screen_no_of_seats
                          : _vm.showDetails.ticket_count
                        : _vm.showDetails.ticket_count))]),_vm._v(") :\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                  "+_vm._s(_vm.curr_code)+" "+_vm._s(_vm.currFormat(_vm.showDetails.net_amount))+"\n                ")])]),_vm._v(" "),(
                  _vm.showDetails.chargeTypeArray &&
                    _vm.showDetails.chargeTypeArray.length > 0
                )?_c('div',{},_vm._l((_vm.showDetails.chargeTypeArray),function(charge,chargeIndex){return _c('div',{key:chargeIndex,staticClass:"d-flex justify-content-between"},[_c('p',[_vm._v(_vm._s(charge.ct_name)+" :")]),_vm._v(" "),_c('p',[_vm._v("\n                    "+_vm._s(_vm.curr_code)+"\n                    "+_vm._s(_vm.currFormat(charge.tax_amount))+"\n                  ")])])}),0):_vm._e(),_vm._v(" "),(_vm.promoApplied)?_c('div',{staticClass:"d-flex justify-content-between"},[_c('div',[_c('p',{staticClass:"mb-0"},[_vm._v("\n                    Promocode Discount :\n                  ")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.promocode))])]),_vm._v(" "),_c('p',{staticClass:"text-success"},[_c('span',[_vm._v("-")]),_vm._v("  \n                  "+_vm._s(_vm.curr_code)+" "+_vm._s(_vm.currFormat(_vm.DiscountValue))+"\n                ")])]):_vm._e(),_vm._v(" "),_c('hr',{staticClass:"bottomLine my-4",attrs:{"id":"totalPayment"}})]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between"},[_vm._m(0),_vm._v(" "),_c('p',{staticClass:"hCont"},[_vm._v("\n                "+_vm._s(_vm.curr_code)+" "+_vm._s(_vm.currFormat(_vm.totalPayableAmount))+"\n              ")])]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),(_vm.showCoupon)?_c('div',{staticClass:"promoCode-box"},[_c('p',{staticClass:"vCont"},[_vm._v("\n              Apply Promo Code:\n              ")]),_vm._v(" "),_c('b-input-group',[_c('b-form-input',{staticClass:"promo-code-text",attrs:{"type":"text","placeholder":"Apply Your Promo Code"},model:{value:(_vm.promocode),callback:function ($$v) {_vm.promocode=$$v},expression:"promocode"}}),_vm._v(" "),_c('b-input-group-append',[_c('b-button',{staticClass:"promo-btn",attrs:{"variant":"default"},on:{"click":function($event){return _vm.onApplyPromocode()}}},[_vm._v("APPLY")])],1)],1),_vm._v(" "),_c('small',{staticClass:"mt-2 text-danger"},[_vm._v(_vm._s(this.promocodeErrorMessage))]),_vm._v(" "),_c('small',{staticClass:"mt-2 text-success"},[_vm._v(_vm._s(this.promocodeSuccesMessage))])],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-lg-9 px-0 px-lg-3 mb-5 mb-md-0"},[_c('div',{attrs:{"role":"tablist"}},[_c('b-card',{staticClass:"mb-1",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"accordion-header",attrs:{"header-tag":"header","role":"tab"},on:{"click":function($event){_vm.tabs.collapse1 = !_vm.tabs.collapse1}}},[_c('div',{staticClass:"d-flex align-items-center header-box"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion1",modifiers:{"accordion1":true}}],staticClass:"py-md-3 cus-btn",class:Object.values(_vm.bookingDetails).length == 0 &&
                    _vm.tabs.collapse1
                      ? 'active'
                      : '',attrs:{"block":"","href":"#","variant":"default"}},[_vm._v("\n                  1. Contact Information\n                  "),(Object.values(_vm.bookingDetails).length > 0)?_c('img',{staticClass:"img-fluid ml-2",attrs:{"src":__webpack_require__(56)}}):_vm._e(),_vm._v(" "),(!_vm.tabs.collapse1)?_c('span',{staticClass:"check-markIcon"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(21)}})]):_vm._e(),_vm._v(" "),(_vm.tabs.collapse1)?_c('span',{staticClass:"check-markIcon"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(50)}})]):_vm._e()])],1)]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion1","visible":"","accordion":"my-accordion","role":"tabpanel"}},[_c('b-card-body',[_c('div',{staticClass:"col-12 p-0 p-md-3"},[_c('div',{staticClass:"row"},[(_vm.userInfo || _vm.userLoggedIn)?_c('div',{staticClass:"col-md-6 mx-auto login-box"},[_c('div',{staticClass:"mob-login-box pr-md-5"},[_c('b-form',{attrs:{"data-vv-scope":"verifyUserDetails"}},[_c('b-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"mt-1 mr-sm-2 pc-input",attrs:{"id":"inlineFormInputName22","placeholder":"Enter your Email Address"},model:{value:(_vm.userDetails.email),callback:function ($$v) {_vm.$set(_vm.userDetails, "email", $$v)},expression:"userDetails.email"}}),_vm._v(" "),_c('div',{staticClass:"row align-items-center mt-3"},[_c('div',{staticClass:"col-3 pr-0 pr-xl-2 country-code-drop"},[(_vm.CountryCodeList.length > 0)?_c('b-dropdown',{staticClass:"pc-input form-control",attrs:{"slot":"append","text":_vm.userDetails.country_mob_code || 'Code',"variant":"default"},slot:"append"},[_c('div',{staticClass:"px-2 pb-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchCode),expression:"searchCode"}],staticClass:"form-control form-control-sm",attrs:{"required":"","autofocus":"","type":"search","placeholder":"Search Code"},domProps:{"value":(_vm.searchCode)},on:{"keyup":function($event){return _vm.onSearchCode($event.target.value)},"keydown":function($event){return _vm.onSearchCode($event.target.value)},"search":function($event){return _vm.onSearchCode($event.target.value)},"input":function($event){if($event.target.composing){ return; }_vm.searchCode=$event.target.value}}})]),_vm._v(" "),_vm._l((_vm.CountryCodeList),function(country,countryIndex){return _c('b-dropdown-item',{key:countryIndex,on:{"click":function($event){return _vm.onChangeCountry(country)}}},[_vm._v(_vm._s(country.country_mob_code)+"  \n                                  "+_vm._s(country.country_name))])})],2):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('b-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"mr-sm-2 pc-input",attrs:{"name":"phonenumber","type":"number","id":"inlineFormInputName10","placeholder":"Enter Your Phone Number"},model:{value:(_vm.userDetails.phone_no),callback:function ($$v) {_vm.$set(_vm.userDetails, "phone_no", $$v)},expression:"userDetails.phone_no"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(
                                _vm.errors.has('verifyUserDetails.phonenumber')
                              ),expression:"\n                                errors.has('verifyUserDetails.phonenumber')\n                              "}],staticClass:"text-danger text-center my-2 pl-3"},[_vm._v("\n                              "+_vm._s(_vm.errors.first("verifyUserDetails.phonenumber"))+"\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"small text-muted mt-2"},[_vm._v("\n                            * Tickets will be sent to the above contact\n                            details\n                          ")]),_vm._v(" "),_c('div',{staticClass:"mt-2"},[_c('b-button',{staticClass:"gogo-btn btn btn-danger",on:{"click":function($event){return _vm.validateBeforeSubmit('verifyUserDetails')}}},[_vm._v("\n                              Confirm Your Details\n                            ")])],1)],1)],1)]):_vm._e(),_vm._v(" "),(_vm.ShowSignUp && !_vm.userLoggedIn)?_c('div',{staticClass:"col-md-6 mx-auto loginmodal"},[(!_vm.userInfo && !_vm.ShowLogin)?_c('p',{staticClass:"mb-2 log-text"},[_vm._v("\n                        Sign Up\n                      ")]):_vm._e(),_vm._v(" "),(!_vm.userInfo && !_vm.ShowLogin)?_c('b-form',{attrs:{"data-vv-scope":"signUp","name":"signUpForm"},on:{"submit":function($event){$event.preventDefault();return _vm.validateBeforeSubmit('signUp')}}},[_c('div',{staticClass:"mob-login-box"},[_c('b-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],staticClass:"mt-1 mr-sm-2 pc-input",attrs:{"autocomplete":"false","name":"email","type":"email","id":"inlineFormInputNameemail2","placeholder":"Enter Your Email Address"},model:{value:(_vm.signUpUserDetails.email),callback:function ($$v) {_vm.$set(_vm.signUpUserDetails, "email", $$v)},expression:"signUpUserDetails.email"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signUp.email')),expression:"errors.has('signUp.email')"}],staticClass:"py-1 text-danger font-weight-bold small"},[_vm._v("\n                            "+_vm._s(_vm.errors.first("signUp.email"))+"\n                          ")]),_vm._v(" "),_c('div',{staticClass:"row align-items-center mt-3"},[_c('div',{staticClass:"col-3 pr-0 pr-xl-2 country-code-drop"},[(_vm.CountryCodeList.length > 0)?_c('b-dropdown',{staticClass:"pc-input form-control",attrs:{"slot":"append","text":_vm.signUpUserDetails.country_mob_code || 'Code',"variant":"default"},slot:"append"},[_c('div',{staticClass:"px-2 pb-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchCode),expression:"searchCode"}],staticClass:"form-control form-control-sm",attrs:{"type":"search","placeholder":"Search Code","name":"countryCode"},domProps:{"value":(_vm.searchCode)},on:{"keyup":function($event){return _vm.onSearchCode($event.target.value)},"keydown":function($event){return _vm.onSearchCode($event.target.value)},"search":function($event){return _vm.onSearchCode($event.target.value)},"input":function($event){if($event.target.composing){ return; }_vm.searchCode=$event.target.value}}})]),_vm._v(" "),_vm._l((_vm.CountryCodeList),function(country,countryIndex){return _c('b-dropdown-item',{key:countryIndex,on:{"click":function($event){return _vm.onChangeCountry(country)}}},[_vm._v(_vm._s(country.country_mob_code)+" \n                                  "+_vm._s(country.country_name))])})],2):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('b-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:8|max:12'),expression:"'required|min:8|max:12'"}],staticClass:"mr-sm-2 pc-input",attrs:{"name":"phonenumber","type":"number","min":0,"id":"inlineFormInputName11","placeholder":"Enter Your Phone Number"},model:{value:(_vm.signUpUserDetails.phoneNumber),callback:function ($$v) {_vm.$set(_vm.signUpUserDetails, "phoneNumber", $$v)},expression:"signUpUserDetails.phoneNumber"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(
                                  _vm.errors.has('signUpUserDetails.phonenumber')
                                ),expression:"\n                                  errors.has('signUpUserDetails.phonenumber')\n                                "}],staticClass:"text-danger text-center my-2"},[_vm._v("\n                                "+_vm._s(_vm.errors.first(
                                    "signUpUserDetails.phonenumber"
                                  ))+"\n                              ")])],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signUp.phonenumber')),expression:"errors.has('signUp.phonenumber')"}],staticClass:"py-1 text-danger font-weight-bold small"},[_vm._v("\n                            "+_vm._s(_vm.errors.first("signUp.phonenumber"))+"\n                          ")]),_vm._v(" "),_c('b-input',{directives:[{name:"validate",rawName:"v-validate",value:({
                              required: 'required',
                              regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z0-9!@#$%^&*]{6,}$/
                            }),expression:"{\n                              required: 'required',\n                              regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z0-9!@#$%^&*]{6,}$/\n                            }"}],staticClass:"mt-3 mr-sm-2 pc-input",attrs:{"type":"password","name":"password","id":"inlineFormInputNamepassword","placeholder":"Enter Your Password"},model:{value:(_vm.signUpUserDetails.password),callback:function ($$v) {_vm.$set(_vm.signUpUserDetails, "password", $$v)},expression:"signUpUserDetails.password"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signUp.password')),expression:"errors.has('signUp.password')"}],staticClass:"py-1 text-danger font-weight-bold small"},[_vm._v("\n                            "+_vm._s(!_vm.signUpUserDetails.password
                                ? _vm.passwordRequiredMessage
                                : _vm.passwordValidationMessage)+"\n                            ")])],1),_vm._v(" "),_c('b-form-checkbox',{staticClass:"grey-text pc-radio mt-2 mb-2 mt-md-2 mb-md-2",attrs:{"id":"checkbox-tandc","name":"checkbox-tandc","value":"accepted","unchecked-value":"not_accepted"},model:{value:(_vm.signUpUserDetails.termsAndConditions),callback:function ($$v) {_vm.$set(_vm.signUpUserDetails, "termsAndConditions", $$v)},expression:"signUpUserDetails.termsAndConditions"}},[_vm._v("\n                          I agree to all\n                          "),_c('router-link',{staticClass:"tnc-class",attrs:{"to":"/termsCondition","target":"_blank"}},[_vm._v("Terms & Conditions\n                          ")])],1),_vm._v(" "),_c('div',{staticClass:"small text-muted mt-2 cursor-pointer",on:{"click":function($event){return _vm.onClickLogin()}}},[_vm._v("\n                          Already have an account? Click here to\n                          "),_c('u',[_c('b',[_vm._v("Sign In")])])]),_vm._v(" "),_c('div',{staticClass:"py-2 text-danger font-weight-bold small"},[_vm._v("\n                          "+_vm._s(_vm.errorMessage.signUp)+"\n                        ")]),_vm._v(" "),_c('input',{staticClass:"btn btn-danger gogo-btn mt-2",attrs:{"type":"submit","name":"submitBtn","value":"Create an account"}})],1):_vm._e()],1):(_vm.ShowLogin && !_vm.userLoggedIn)?_c('div',{staticClass:"col-md-6 mb-5 mb-md-0 mx-auto login-box"},[_c('p',{staticClass:"log-text mb-2"},[_vm._v("LOGIN")]),_vm._v(" "),_c('div',{staticClass:"mob-login-box pr-md-5"},[_c('b-form',{attrs:{"data-vv-scope":"UserSignIn"}},[_c('b-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],staticClass:"mt-1 mr-sm-2 pc-input",attrs:{"type":"email","id":"inlineFormInputName4","placeholder":"Enter Your Email Address"},model:{value:(_vm.userDetails.email),callback:function ($$v) {_vm.$set(_vm.userDetails, "email", $$v)},expression:"userDetails.email"}}),_vm._v(" "),_c('b-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"mt-3 mr-sm-2 pc-input",attrs:{"type":"password","id":"inlineFormInputName5","placeholder":"Enter Your Password"},model:{value:(_vm.userDetails.password),callback:function ($$v) {_vm.$set(_vm.userDetails, "password", $$v)},expression:"userDetails.password"}}),_vm._v(" "),_c('div',{staticClass:"py-2 text-danger font-weight-bold small"},[_vm._v("\n                            "+_vm._s(_vm.errorMessage.login)+"\n                          ")]),_vm._v(" "),_c('div',{staticClass:"small text-muted mb-2 cursor-pointer",on:{"click":function($event){return _vm.onClickForgotPassword()}}},[_vm._v("\n                            Forgot Password?\n                          ")]),_vm._v(" "),_c('div',{staticClass:"small text-muted mt-2 cursor-pointer",on:{"click":function($event){return _vm.onClickSignUp()}}},[_vm._v("\n                            Do not have an account? Click here to\n                            "),_c('u',[_c('b',[_vm._v("Sign Up")])])]),_vm._v(" "),_c('div',[_c('b-button',{staticClass:"my-2 btn btn-danger gogo-btn",on:{"click":function($event){return _vm.validateBeforeSubmit('UserSignIn')}}},[_vm._v("Login")])],1)],1)],1)]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-12 px-0 d-none"},[_c('div',{staticClass:"text-success font-weight-bold d-md-flex"},[_c('div',{staticClass:"text-mob mt-3 mt-md-0"},[_vm._v("\n                      Awesome! Your verification is complete and your account\n                      has been created! You’ll get a link to reset your\n                      password which you can do later if you’d like as well.\n                    ")])])])])],1)],1),_vm._v(" "),_c('b-card',{staticClass:"mb-1",attrs:{"no-body":"","id":"PaymentShow"}},[_c('b-card-header',{staticClass:"accordion-header",attrs:{"header-tag":"header","role":"tab"}},[_c('div',{staticClass:"d-flex align-items-center header-box"},[_c('b-button',{staticClass:"py-md-3",class:[
                    Object.values(_vm.bookingDetails).length == 0
                      ? 'disabled'
                      : _vm.tabs.collapse2
                      ? 'active'
                      : ''
                  ],attrs:{"href":"#","block":"","variant":"default"}},[_vm._v("\n                  2. Choose Payment Mode\n                  "),(_vm.showProceedButton)?_c('img',{staticClass:"img-fluid ml-2",attrs:{"src":__webpack_require__(56)}}):_vm._e(),_vm._v(" "),(!_vm.tabs.collapse2)?_c('span',{staticClass:"check-markIcon"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(21)}})]):_vm._e(),_vm._v(" "),(_vm.tabs.collapse2)?_c('span',{staticClass:"check-markIcon"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(50)}})]):_vm._e()])],1)]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion2","accordion":"my-accordion","role":"tabpanel"}},[(_vm.directPay)?_c('b-card-body',[_c('div',{attrs:{"id":"dropin-container"}}),_vm._v(" "),_c('b-button',{ref:"submitButton",staticClass:"btn py-md-2 px-md-5 btn-danger",attrs:{"id":"submit-button"},on:{"click":function($event){return _vm.payNow()}}},[_vm._v("PAY\n                  "+_vm._s(_vm.curr_code)+"\n                  "+_vm._s(_vm.currFormat(_vm.totalPayableAmount)))])],1):(_vm.isBrainTreeActive && _vm.bt_client_token)?_c('b-card-body',[_c('div',{attrs:{"id":"dropin-container"}},[_c('v-braintree',{attrs:{"authorization":_vm.bt_client_token,"btnText":("Pay " + _vm.curr_code + " " + (_vm.currFormat(_vm.totalPayableAmount))),"btnClass":"btn btn-danger","vaultManager":true},on:{"load":_vm.onLoad,"loadFail":_vm.onLoadFail,"success":_vm.bt_makePayment,"error":_vm.onError}})],1)]):(!_vm.PaymentOptionsLoading)?_c('b-card-body',[_c('div',{staticClass:"w-100 text-center mt-5 text-muted",attrs:{"id":"no-payment-modes"}},[_c('p',[_vm._v("No Active Payment Modes. Contact Support Team")]),_vm._v(" "),_c('router-link',{staticClass:"mt-3 btn btn-danger text-light",attrs:{"to":{
                      name: 'Home'
                    }}},[_vm._v("Home")])],1)]):_vm._e()],1)],1),_vm._v(" "),_c('b-card',{staticClass:"d-none mb-1",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"accordion-header",attrs:{"header-tag":"header","role":"tab"},on:{"click":function($event){_vm.tabs.collapse3 = !_vm.tabs.collapse3}}},[_c('div',{staticClass:"d-flex align-items-center header-box"},[_c('b-button',{staticClass:"py-md-3",class:[
                    _vm.tabs.collapse3 && _vm.showProceedButton
                      ? 'active'
                      : _vm.showProceedButton
                      ? ''
                      : 'disabled'
                  ],attrs:{"block":"","href":"#","variant":"default"}},[_vm._v("\n                  3. Confirmation\n                  "),(!_vm.tabs.collapse3 && !_vm.showProceedButton)?_c('span',{staticClass:"check-markIcon"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(21)}})]):(_vm.tabs.collapse3 && _vm.showProceedButton)?_c('span',{staticClass:"check-markIcon"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(50)}})]):(_vm.tabs.collapse3)?_c('span',{staticClass:"check-markIcon"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(21)}})]):_vm._e()])],1)]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion3","accordion":"my-accordion","role":"tabpanel"}},[_c('b-card-body',[_c('div',{staticClass:"col-sm-4 px-0 px-md-3 mb-3 col-lg-4 mx-auto text-center"},[(_vm.confirmDetails)?_c('router-link',{attrs:{"to":{
                      name: 'confirmScreen',
                      params: {
                        bookingId: _vm.confirmDetails.BookingID || 0,
                        paymentId: _vm.PaymentId || 2
                      }
                    }}},[(_vm.showProceedButton)?_c('b-button',{staticClass:"gogo-btn btn btn-danger"},[_vm._v("Confirm")]):_vm._e()],1):_vm._e()],1)])],1)],1)],1)])])]):_vm._e(),_vm._v(" "),_c('b-modal',{ref:"SeatRealeased",staticClass:"text-center",attrs:{"no-close-on-esc":"","no-close-on-backdrop":"","hide-header-close":"","hide-footer":"","id":"SeatRealeased","title":"FAILED !"}},[_c('div',{staticClass:"p-5"},[_c('div',{staticClass:"text-center mt-3 mt-md-0"},[_vm._v(_vm._s(_vm.showMessage))]),_vm._v(" "),_c('b-button',{staticClass:"w-50 mx-auto gogo-btn btn btn-danger mt-3 d-flex justify-content-center align-items-center",on:{"click":_vm.hideModal}},[_vm._v("Go Back")])],1)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"mb-0 vCont"},[_vm._v("\n                  Total Amount Payable :\n                ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('small',{staticClass:"vCont"},[_vm._v("(Amount inclusive of all service fees and taxes)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RtsPayment_vue__ = __webpack_require__(626);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c448edb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RtsPayment_vue__ = __webpack_require__(1243);
function injectStyle (ssrContext) {
  __webpack_require__(1242)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3c448edb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RtsPayment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c448edb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RtsPayment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1242 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row px-0 px-md-2 my-3 back-txt"},[_c('div',{staticClass:"col-5 col-md-6 align-self-center"},[_c('router-link',{attrs:{"to":"/"}},[_c('span',{staticClass:"mr-1"},[_vm._v("‹")]),_vm._v("Go back to movie list\n      ")])],1),_vm._v(" "),_c('div',{staticClass:"col-7 col-md-6 pr-3 pr-lg-4 align-self-center"},[_c('div',{staticClass:"timer-circle ml-auto mb-0"},[_vm._v("\n        Time Remaining :  \n        "),_c('span',[_vm._v("\n          "+_vm._s(_vm.timer.minutes.toString().length == "1"
              ? "0" + _vm.timer.minutes
              : _vm.timer.minutes)+":"+_vm._s(_vm.timer.seconds.toString().length == "1"
              ? "0" + _vm.timer.seconds
              : _vm.timer.seconds))])])])]),_vm._v(" "),_c('div',{staticClass:"verify-c"},[_c('b-modal',{ref:"errorCard",attrs:{"no-close-on-esc":"","no-close-on-backdrop":"","hide-footer":"","hide-header-close":"","id":"errorCard","title":"FAILED!"}},[_c('div',{staticClass:"p-5"},[_c('div',{staticClass:"text-center mt-3 mt-md-0"},[_vm._v("Sorry, "+_vm._s(_vm.msgError))]),_vm._v(" "),_c('b-button',{staticClass:"w-50 mx-auto gogo-btn btn btn-danger mt-3 d-flex justify-content-center align-items-center",on:{"click":_vm.hideModal}},[_vm._v("Cancel\n        ")])],1)])],1),_vm._v(" "),_c('div',{staticClass:"verify-c"},[_c('b-modal',{ref:"sessionTimeOut",staticClass:"text-center",attrs:{"no-close-on-esc":"","no-close-on-backdrop":"","hide-header-close":"","hide-footer":"","id":"sessionTimeOut","title":"HURRY UP!"}},[_c('div',{staticClass:"p-5"},[_c('div',{staticClass:"text-center mt-3 mt-md-0"},[_vm._v("\n          Your booking has timed out!\n        ")]),_vm._v(" "),_c('div',{staticClass:"text-center mt-3 mt-md-0"},[_vm._v("\n          Click Here to restart the booking\n        ")]),_vm._v(" "),_c('b-button',{staticClass:"w-50 mx-auto gogo-btn btn btn-danger mt-3 d-flex justify-content-center align-items-center",on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("Go Back\n        ")])],1)])],1),_vm._v(" "),_c('div',{staticClass:"verify-c"},[_c('b-modal',{ref:"apiKeyfailed",staticClass:"text-center",attrs:{"no-close-on-esc":"","no-close-on-backdrop":"","hide-header-close":"","hide-footer":"","id":"apiKeyfailed","title":"Failed!"}},[_c('div',{staticClass:"p-5"},[_c('div',{staticClass:"text-center mt-3 mt-md-0"},[_vm._v("API key is invalid !")]),_vm._v(" "),_c('div',{staticClass:"text-center mt-3 mt-md-0"},[_vm._v("\n          Click Here to restart the booking\n        ")]),_vm._v(" "),_c('b-button',{staticClass:"w-50 mx-auto gogo-btn btn btn-danger mt-3 d-flex justify-content-center align-items-center",on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("Go Back\n        ")])],1)])],1),_vm._v(" "),_c('div',{staticClass:"verify-c"},[_c('b-modal',{ref:"minimumPayment",staticClass:"text-center",attrs:{"no-close-on-esc":"","no-close-on-backdrop":"","hide-header-close":"","hide-footer":"","id":"minimumPayment","title":"HURRY UP!"}},[_c('div',{staticClass:"p-5"},[_c('div',{staticClass:"text-center mt-3 mt-md-0"},[_vm._v("Sorry, the payment failed.")]),_vm._v(" "),_c('div',{staticClass:"text-center mt-3 mt-md-0"},[_vm._v("\n          Click Here to restart the booking\n        ")]),_vm._v(" "),_c('b-button',{staticClass:"w-50 mx-auto gogo-btn btn btn-danger mt-3 d-flex justify-content-center align-items-center",on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("Go Back\n        ")])],1)])],1),_vm._v(" "),(_vm.showDetails.hasOwnProperty('md_thumbnail_url'))?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-lg-3 h-75 mx-auto mb-4 px-0 mb-lg-2"},[_c('div',{staticClass:"cs-scr-ticket p-3 p-xl-3 mb-4"},[_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"col-5 col-md-6 col-xl-5 pr-xl-2 pr-lg-0 pr-1 pl-0 pl-md-2 rounded"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.showDetails.md_thumbnail_url),expression:"showDetails.md_thumbnail_url"}],staticClass:"img-fluid"})]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column justify-content-between pl-3"},[_c('div',[_c('p',{staticClass:"mb-1"},[_vm._v(_vm._s(_vm.showDetails.movie_title))]),_vm._v(" "),_c('ul',{staticClass:"list-inline movie-tickDetails"},[_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                    "+_vm._s(_vm.showDetails.mrrdr_runtime)+"\n                  ")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(_vm.showDetails.rating))]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                    "+_vm._s(_vm.showDetails.lang_name)+"\n                  ")])])]),_vm._v(" "),(false)?_c('div',[_c('p',{staticClass:"rt-txt1"},[_c('span',{staticClass:"d-block small"},[_vm._v("IMDB")]),_vm._v("\n                  "+_vm._s(_vm.showDetails.imdb_link)+"\n                ")]),_vm._v(" "),_c('p',{staticClass:"rt-txt2"},[_c('span',{staticClass:"d-block small"},[_vm._v("Rating")]),_vm._v("\n                  "+_vm._s(_vm.showDetails.rating)+"\n                ")])]):_vm._e()])]),_vm._v(" "),_c('hr',{staticClass:"topLine my-2"}),_vm._v(" "),_c('div',{},[_c('small',{staticClass:"vCont"},[_vm._v("\n              Cinema:\n              ")]),_vm._v(" "),_c('p',{staticClass:"hCont"},[_vm._v("\n              "+_vm._s(_vm.showDetails.cine_name)+",  \n              "+_vm._s(_vm.showDetails.cine_address)+"\n            ")]),_vm._v(" "),_c('small',{staticClass:"vCont"},[_vm._v("\n              Screen:\n              ")]),_vm._v(" "),_c('p',{staticClass:"hCont"},[_vm._v(_vm._s(_vm.showDetails.screen_name))])]),_vm._v(" "),_c('div',{},[_c('small',{staticClass:"vCont"},[_vm._v(" Date & Time: ")]),_vm._v(" "),_c('ul',{staticClass:"list-inline dateTime hCont"},[(_vm.checkKey == false)?_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                "+_vm._s(_vm.GetDate(_vm.showDetails.ss_start_date, "full"))+" |\n                "+_vm._s(_vm.timeFormat(_vm.showDetails.ss_start_show_time))+"\n              ")]):_vm._e(),_vm._v(" "),(_vm.checkKey)?_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                "+_vm._s(_vm.showDetails.DateTime)+"\n              ")]):_vm._e()])]),_vm._v(" "),(
              _vm.CategoryID === '2' ||
              _vm.CategoryID === '4' ||
              _vm.CategoryID == 2 ||
              _vm.CategoryID === 4
            )?_c('div',[_c('small',{staticClass:"vCont"},[_vm._v(" Screening Type: ")]),_vm._v(" "),_c('p',{staticClass:"hCont"},[_vm._v(_vm._s(_vm.showDetails.booking_type_name))])]):_vm._e(),_vm._v(" "),(_vm.ShowType != 'Private')?_c('div',{},[_c('small',{staticClass:"vCont"},[_vm._v(" Pick Seats: ")]),_vm._v(" "),_c('ul',{staticClass:"list-inline seatList hCont"},[_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                "+_vm._s(_vm.showDetails.seat_name.replace("Hall", "Auditorium"))+"\n              ")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"amount-box my-4"},[_c('div',{staticClass:"ticketAmount"},[_c('div',{staticClass:"d-flex justify-content-between"},[_c('p',[_vm._v("\n                  Tickets\n                  "),_c('span',[_vm._v("("+_vm._s(this.CategoryID == 2
                        ? _vm.showDetails.booking_type_id == 3
                          ? _vm.showDetails.screen_no_of_seats
                          : _vm.showDetails.ticket_count
                        : _vm.showDetails.ticket_count))]),_vm._v(") :\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                  "+_vm._s(_vm.curr_code)+" "+_vm._s(_vm.currFormat(_vm.showDetails.net_amount))+"\n                ")])]),_vm._v(" "),(
                  _vm.showDetails.chargeTypeArray &&
                  _vm.showDetails.chargeTypeArray.length > 0
                )?_c('div',{},_vm._l((_vm.showDetails.chargeTypeArray),function(charge,chargeIndex){return _c('div',{key:chargeIndex,staticClass:"d-flex justify-content-between"},[_c('p',[_vm._v(_vm._s(charge.ct_name)+" :")]),_vm._v(" "),_c('p',[_vm._v("\n                    "+_vm._s(_vm.curr_code)+"\n                    "+_vm._s(_vm.currFormat(charge.tax_amount))+"\n                  ")])])}),0):_vm._e(),_vm._v(" "),(_vm.promoApplied)?_c('div',{staticClass:"d-flex justify-content-between"},[_c('div',[_c('p',{staticClass:"mb-0"},[_vm._v("Promocode Discount :")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.promocode))])]),_vm._v(" "),_c('p',{staticClass:"text-success"},[_c('span',[_vm._v("-")]),_vm._v("\n                  "+_vm._s(_vm.curr_code)+" "+_vm._s(_vm.currFormat(_vm.DiscountValue))+"\n                ")])]):_vm._e(),_vm._v(" "),_c('hr',{staticClass:"bottomLine my-4",attrs:{"id":"totalPayment"}})]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between"},[_vm._m(0),_vm._v(" "),_c('p',{staticClass:"hCont"},[_vm._v("\n                "+_vm._s(_vm.curr_code)+" "+_vm._s(_vm.currFormat(_vm.totalPayableAmount))+"\n              ")])]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),(_vm.showCoupon)?_c('div',{staticClass:"promoCode-box"},[_c('p',{staticClass:"vCont"},[_vm._v("Apply Promo Code:")]),_vm._v(" "),_c('b-input-group',[_c('b-form-input',{staticClass:"promo-code-text",attrs:{"type":"text","placeholder":"Apply Your Promo Code"},model:{value:(_vm.promocode),callback:function ($$v) {_vm.promocode=$$v},expression:"promocode"}}),_vm._v(" "),_c('b-input-group-append',[_c('b-button',{staticClass:"promo-btn",attrs:{"variant":"default"},on:{"click":function($event){return _vm.onApplyPromocode()}}},[_vm._v("APPLY")])],1)],1),_vm._v(" "),_c('small',{staticClass:"mt-2 text-danger"},[_vm._v(_vm._s(this.promocodeErrorMessage))]),_vm._v(" "),_c('small',{staticClass:"mt-2 text-success"},[_vm._v(_vm._s(this.promocodeSuccesMessage))])],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-lg-9 px-0 px-lg-3 mb-5 mb-md-0"},[_c('div',{attrs:{"role":"tablist"}},[_c('b-card',{staticClass:"mb-1",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"accordion-header",attrs:{"header-tag":"header","role":"tab"},on:{"click":function($event){_vm.tabs.collapse1 = !_vm.tabs.collapse1}}},[_c('div',{staticClass:"d-flex align-items-center header-box"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion1",modifiers:{"accordion1":true}}],staticClass:"py-md-3 cus-btn",class:Object.values(_vm.bookingDetails).length == 0 &&
                    _vm.tabs.collapse1
                      ? 'active'
                      : '',attrs:{"block":"","href":"#","variant":"default"}},[_vm._v("\n                  1. Contact Information\n                  "),(Object.values(_vm.bookingDetails).length > 0)?_c('img',{staticClass:"img-fluid ml-2",attrs:{"src":__webpack_require__(56)}}):_vm._e(),_vm._v(" "),(!_vm.tabs.collapse1)?_c('span',{staticClass:"check-markIcon"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(21)}})]):_vm._e(),_vm._v(" "),(_vm.tabs.collapse1)?_c('span',{staticClass:"check-markIcon"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(50)}})]):_vm._e()])],1)]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion1","visible":"","accordion":"my-accordion","role":"tabpanel"}},[_c('b-card-body',[_c('div',{staticClass:"col-12 p-0 p-md-3"},[_c('div',{staticClass:"row"},[(_vm.userInfo || _vm.userLoggedIn)?_c('div',{staticClass:"col-md-6 mx-auto login-box"},[_c('div',{staticClass:"mob-login-box pr-md-5"},[_c('b-form',{attrs:{"data-vv-scope":"verifyUserDetails"}},[_c('b-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"mt-1 mr-sm-2 pc-input",attrs:{"id":"inlineFormInputName22","placeholder":"Enter your Email Address"},model:{value:(_vm.userDetails.email),callback:function ($$v) {_vm.$set(_vm.userDetails, "email", $$v)},expression:"userDetails.email"}}),_vm._v(" "),_c('div',{staticClass:"row align-items-center mt-3"},[_c('div',{staticClass:"col-3 pr-0 pr-xl-2 country-code-drop"},[(_vm.CountryCodeList.length > 0)?_c('b-dropdown',{staticClass:"pc-input form-control",attrs:{"slot":"append","text":_vm.userDetails.country_mob_code || 'Code',"variant":"default"},slot:"append"},[_c('div',{staticClass:"px-2 pb-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchCode),expression:"searchCode"}],staticClass:"form-control form-control-sm",attrs:{"required":"","autofocus":"","type":"search","placeholder":"Search Code"},domProps:{"value":(_vm.searchCode)},on:{"keyup":function($event){return _vm.onSearchCode($event.target.value)},"keydown":function($event){return _vm.onSearchCode($event.target.value)},"search":function($event){return _vm.onSearchCode($event.target.value)},"input":function($event){if($event.target.composing){ return; }_vm.searchCode=$event.target.value}}})]),_vm._v(" "),_vm._l((_vm.CountryCodeList),function(country,countryIndex){return _c('b-dropdown-item',{key:countryIndex,on:{"click":function($event){return _vm.onChangeCountry(country)}}},[_vm._v(_vm._s(country.country_mob_code)+"  \n                                  "+_vm._s(country.country_name))])})],2):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('b-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"mr-sm-2 pc-input",attrs:{"name":"phonenumber","type":"number","id":"inlineFormInputName10","placeholder":"Enter Your Phone Number"},model:{value:(_vm.userDetails.phone_no),callback:function ($$v) {_vm.$set(_vm.userDetails, "phone_no", $$v)},expression:"userDetails.phone_no"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(
                                _vm.errors.has('verifyUserDetails.phonenumber')
                              ),expression:"\n                                errors.has('verifyUserDetails.phonenumber')\n                              "}],staticClass:"text-danger text-center my-2 pl-3"},[_vm._v("\n                              "+_vm._s(_vm.errors.first("verifyUserDetails.phonenumber"))+"\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"small text-muted mt-2"},[_vm._v("\n                            * Tickets will be sent to the above contact\n                            details\n                          ")]),_vm._v(" "),_c('div',{staticClass:"mt-2"},[_c('b-button',{staticClass:"gogo-btn btn btn-danger",on:{"click":function($event){return _vm.validateBeforeSubmit('verifyUserDetails')}}},[_vm._v("\n                              Confirm Your Details\n                            ")])],1)],1)],1)]):_vm._e(),_vm._v(" "),(_vm.ShowSignUp && !_vm.userLoggedIn)?_c('div',{staticClass:"col-md-6 mx-auto loginmodal"},[(!_vm.userInfo && !_vm.ShowLogin)?_c('p',{staticClass:"mb-2 log-text"},[_vm._v("\n                        Sign Up\n                      ")]):_vm._e(),_vm._v(" "),(!_vm.userInfo && !_vm.ShowLogin)?_c('b-form',{attrs:{"data-vv-scope":"signUp","name":"signUpForm"},on:{"submit":function($event){$event.preventDefault();return _vm.validateBeforeSubmit('signUp')}}},[_c('div',{staticClass:"mob-login-box"},[_c('b-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],staticClass:"mt-1 mr-sm-2 pc-input",attrs:{"autocomplete":"false","name":"email","type":"email","id":"inlineFormInputNameemail2","placeholder":"Enter Your Email Address"},model:{value:(_vm.signUpUserDetails.email),callback:function ($$v) {_vm.$set(_vm.signUpUserDetails, "email", $$v)},expression:"signUpUserDetails.email"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signUp.email')),expression:"errors.has('signUp.email')"}],staticClass:"py-1 text-danger font-weight-bold small"},[_vm._v("\n                            "+_vm._s(_vm.errors.first("signUp.email"))+"\n                          ")]),_vm._v(" "),_c('div',{staticClass:"row align-items-center mt-3"},[_c('div',{staticClass:"col-3 pr-0 pr-xl-2 country-code-drop"},[(_vm.CountryCodeList.length > 0)?_c('b-dropdown',{staticClass:"pc-input form-control",attrs:{"slot":"append","text":_vm.signUpUserDetails.country_mob_code || 'Code',"variant":"default"},slot:"append"},[_c('div',{staticClass:"px-2 pb-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchCode),expression:"searchCode"}],staticClass:"form-control form-control-sm",attrs:{"type":"search","placeholder":"Search Code","name":"countryCode"},domProps:{"value":(_vm.searchCode)},on:{"keyup":function($event){return _vm.onSearchCode($event.target.value)},"keydown":function($event){return _vm.onSearchCode($event.target.value)},"search":function($event){return _vm.onSearchCode($event.target.value)},"input":function($event){if($event.target.composing){ return; }_vm.searchCode=$event.target.value}}})]),_vm._v(" "),_vm._l((_vm.CountryCodeList),function(country,countryIndex){return _c('b-dropdown-item',{key:countryIndex,on:{"click":function($event){return _vm.onChangeCountry(country)}}},[_vm._v(_vm._s(country.country_mob_code)+" \n                                  "+_vm._s(country.country_name))])})],2):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('b-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:8|max:12'),expression:"'required|min:8|max:12'"}],staticClass:"mr-sm-2 pc-input",attrs:{"name":"phonenumber","type":"number","min":0,"id":"inlineFormInputName11","placeholder":"Enter Your Phone Number"},model:{value:(_vm.signUpUserDetails.phoneNumber),callback:function ($$v) {_vm.$set(_vm.signUpUserDetails, "phoneNumber", $$v)},expression:"signUpUserDetails.phoneNumber"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(
                                  _vm.errors.has('signUpUserDetails.phonenumber')
                                ),expression:"\n                                  errors.has('signUpUserDetails.phonenumber')\n                                "}],staticClass:"text-danger text-center my-2"},[_vm._v("\n                                "+_vm._s(_vm.errors.first(
                                    "signUpUserDetails.phonenumber"
                                  ))+"\n                              ")])],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signUp.phonenumber')),expression:"errors.has('signUp.phonenumber')"}],staticClass:"py-1 text-danger font-weight-bold small"},[_vm._v("\n                            "+_vm._s(_vm.errors.first("signUp.phonenumber"))+"\n                          ")]),_vm._v(" "),_c('b-input',{directives:[{name:"validate",rawName:"v-validate",value:({
                              required: 'required',
                              regex:
                                /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z0-9!@#$%^&*]{6,}$/,
                            }),expression:"{\n                              required: 'required',\n                              regex:\n                                /^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z0-9!@#$%^&*]{6,}$/,\n                            }"}],staticClass:"mt-3 mr-sm-2 pc-input",attrs:{"type":"password","name":"password","id":"inlineFormInputNamepassword","placeholder":"Enter Your Password"},model:{value:(_vm.signUpUserDetails.password),callback:function ($$v) {_vm.$set(_vm.signUpUserDetails, "password", $$v)},expression:"signUpUserDetails.password"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signUp.password')),expression:"errors.has('signUp.password')"}],staticClass:"py-1 text-danger font-weight-bold small"},[_vm._v("\n                            "+_vm._s(!_vm.signUpUserDetails.password
                                ? _vm.passwordRequiredMessage
                                : _vm.passwordValidationMessage)+"\n                          ")])],1),_vm._v(" "),_c('b-form-checkbox',{staticClass:"grey-text pc-radio mt-2 mb-2 mt-md-2 mb-md-2",attrs:{"id":"checkbox-tandc","name":"checkbox-tandc","value":"accepted","unchecked-value":"not_accepted"},model:{value:(_vm.signUpUserDetails.termsAndConditions),callback:function ($$v) {_vm.$set(_vm.signUpUserDetails, "termsAndConditions", $$v)},expression:"signUpUserDetails.termsAndConditions"}},[_vm._v("\n                          I agree to all\n                          "),_c('router-link',{staticClass:"tnc-class",attrs:{"to":"/termsCondition","target":"_blank"}},[_vm._v("Terms & Conditions\n                          ")])],1),_vm._v(" "),_c('div',{staticClass:"small text-muted mt-2 cursor-pointer",on:{"click":function($event){return _vm.onClickLogin()}}},[_vm._v("\n                          Already have an account? Click here to\n                          "),_c('u',[_c('b',[_vm._v("Sign In")])])]),_vm._v(" "),_c('div',{staticClass:"py-2 text-danger font-weight-bold small"},[_vm._v("\n                          "+_vm._s(_vm.errorMessage.signUp)+"\n                        ")]),_vm._v(" "),_c('input',{staticClass:"btn btn-danger gogo-btn mt-2",attrs:{"type":"submit","name":"submitBtn","value":"Create an account"}})],1):_vm._e()],1):(_vm.ShowLogin && !_vm.userLoggedIn)?_c('div',{staticClass:"col-md-6 mb-5 mb-md-0 mx-auto login-box"},[_c('p',{staticClass:"log-text mb-2"},[_vm._v("LOGIN")]),_vm._v(" "),_c('div',{staticClass:"mob-login-box pr-md-5"},[_c('b-form',{attrs:{"data-vv-scope":"UserSignIn"}},[_c('b-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],staticClass:"mt-1 mr-sm-2 pc-input",attrs:{"type":"email","id":"inlineFormInputName4","placeholder":"Enter Your Email Address"},model:{value:(_vm.userDetails.email),callback:function ($$v) {_vm.$set(_vm.userDetails, "email", $$v)},expression:"userDetails.email"}}),_vm._v(" "),_c('b-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"mt-3 mr-sm-2 pc-input",attrs:{"type":"password","id":"inlineFormInputName5","placeholder":"Enter Your Password"},model:{value:(_vm.userDetails.password),callback:function ($$v) {_vm.$set(_vm.userDetails, "password", $$v)},expression:"userDetails.password"}}),_vm._v(" "),_c('div',{staticClass:"py-2 text-danger font-weight-bold small"},[_vm._v("\n                            "+_vm._s(_vm.errorMessage.login)+"\n                          ")]),_vm._v(" "),_c('div',{staticClass:"small text-muted mb-2 cursor-pointer",on:{"click":function($event){return _vm.onClickForgotPassword()}}},[_vm._v("\n                            Forgot Password?\n                          ")]),_vm._v(" "),_c('div',{staticClass:"small text-muted mt-2 cursor-pointer",on:{"click":function($event){return _vm.onClickSignUp()}}},[_vm._v("\n                            Do not have an account? Click here to\n                            "),_c('u',[_c('b',[_vm._v("Sign Up")])])]),_vm._v(" "),_c('div',[_c('b-button',{staticClass:"my-2 btn btn-danger gogo-btn",on:{"click":function($event){return _vm.validateBeforeSubmit('UserSignIn')}}},[_vm._v("Login")])],1)],1)],1)]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-12 px-0 d-none"},[_c('div',{staticClass:"text-success font-weight-bold d-md-flex"},[_c('div',{staticClass:"text-mob mt-3 mt-md-0"},[_vm._v("\n                      Awesome! Your verification is complete and your account\n                      has been created! You’ll get a link to reset your\n                      password which you can do later if you’d like as well.\n                    ")])])])])],1)],1),_vm._v(" "),_c('b-card',{staticClass:"mb-1",attrs:{"no-body":"","id":"PaymentShow"}},[_c('b-card-header',{staticClass:"accordion-header",attrs:{"header-tag":"header","role":"tab"}},[_c('div',{staticClass:"d-flex align-items-center header-box"},[_c('b-button',{staticClass:"py-md-3",class:[
                    Object.values(_vm.bookingDetails).length == 0
                      ? 'disabled'
                      : _vm.tabs.collapse2
                      ? 'active'
                      : '' ],attrs:{"href":"#","block":"","variant":"default"}},[_vm._v("\n                  2. Choose Payment Mode\n                  "),(_vm.showProceedButton)?_c('img',{staticClass:"img-fluid ml-2",attrs:{"src":__webpack_require__(56)}}):_vm._e(),_vm._v(" "),(!_vm.tabs.collapse2)?_c('span',{staticClass:"check-markIcon"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(21)}})]):_vm._e(),_vm._v(" "),(_vm.tabs.collapse2)?_c('span',{staticClass:"check-markIcon"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(50)}})]):_vm._e()])],1)]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion2","accordion":"my-accordion","role":"tabpanel"}},[(_vm.directPay)?_c('b-card-body',[_c('div',{attrs:{"id":"dropin-container"}}),_vm._v(" "),_c('b-button',{ref:"submitButton",staticClass:"btn py-md-2 px-md-5 btn-danger",attrs:{"id":"submit-button"},on:{"click":function($event){return _vm.payNow()}}},[_vm._v("PAY\n                  "+_vm._s(_vm.curr_code)+"\n                  "+_vm._s(_vm.currFormat(_vm.totalPayableAmount)))])],1):(_vm.isBrainTreeActive && _vm.bt_client_token)?_c('b-card-body',[_c('div',{attrs:{"id":"dropin-container"}},[_c('v-braintree',{attrs:{"authorization":_vm.bt_client_token,"btnText":("Pay " + _vm.curr_code + " " + (_vm.currFormat(
                      _vm.totalPayableAmount
                    ))),"btnClass":"btn btn-danger","vaultManager":true},on:{"load":_vm.onLoad,"loadFail":_vm.onLoadFail,"success":_vm.bt_makePayment,"error":_vm.onError}})],1)]):(!_vm.PaymentOptionsLoading)?_c('b-card-body',[_c('div',{staticClass:"w-100 text-center mt-5 text-muted",attrs:{"id":"no-payment-modes"}},[_c('p',[_vm._v("No Active Payment Modes. Contact Support Team")]),_vm._v(" "),_c('router-link',{staticClass:"mt-3 btn btn-danger text-light",attrs:{"to":{
                      name: 'Home',
                    }}},[_vm._v("Home")])],1)]):_vm._e()],1)],1),_vm._v(" "),_c('b-card',{staticClass:"d-none mb-1",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"accordion-header",attrs:{"header-tag":"header","role":"tab"},on:{"click":function($event){_vm.tabs.collapse3 = !_vm.tabs.collapse3}}},[_c('div',{staticClass:"d-flex align-items-center header-box"},[_c('b-button',{staticClass:"py-md-3",class:[
                    _vm.tabs.collapse3 && _vm.showProceedButton
                      ? 'active'
                      : _vm.showProceedButton
                      ? ''
                      : 'disabled' ],attrs:{"block":"","href":"#","variant":"default"}},[_vm._v("\n                  3. Confirmation\n                  "),(!_vm.tabs.collapse3 && !_vm.showProceedButton)?_c('span',{staticClass:"check-markIcon"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(21)}})]):(_vm.tabs.collapse3 && _vm.showProceedButton)?_c('span',{staticClass:"check-markIcon"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(50)}})]):(_vm.tabs.collapse3)?_c('span',{staticClass:"check-markIcon"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(21)}})]):_vm._e()])],1)]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion3","accordion":"my-accordion","role":"tabpanel"}},[_c('b-card-body',[_c('div',{staticClass:"col-sm-4 px-0 px-md-3 mb-3 col-lg-4 mx-auto text-center"},[(_vm.confirmDetails)?_c('router-link',{attrs:{"to":{
                      name: 'confirmScreen',
                      params: {
                        bookingId: _vm.confirmDetails.BookingID || 0,
                        paymentId: _vm.PaymentId || 2,
                      },
                    }}},[(_vm.showProceedButton)?_c('b-button',{staticClass:"gogo-btn btn btn-danger"},[_vm._v("Confirm")]):_vm._e()],1):_vm._e()],1)])],1)],1)],1)])])]):_vm._e(),_vm._v(" "),_c('b-modal',{ref:"SeatRealeased",staticClass:"text-center",attrs:{"no-close-on-esc":"","no-close-on-backdrop":"","hide-header-close":"","hide-footer":"","id":"SeatRealeased","title":"FAILED !"}},[_c('div',{staticClass:"p-5"},[_c('div',{staticClass:"text-center mt-3 mt-md-0"},[_vm._v(_vm._s(_vm.showMessage))]),_vm._v(" "),_c('b-button',{staticClass:"w-50 mx-auto gogo-btn btn btn-danger mt-3 d-flex justify-content-center align-items-center",on:{"click":_vm.hideModal}},[_vm._v("Go Back")])],1)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"mb-0 vCont"},[_vm._v("Total Amount Payable :")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('small',{staticClass:"vCont"},[_vm._v("(Amount inclusive of all service fees and taxes)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_createShowpayment_vue__ = __webpack_require__(627);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d790f0c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_createShowpayment_vue__ = __webpack_require__(1246);
function injectStyle (ssrContext) {
  __webpack_require__(1245)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5d790f0c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_createShowpayment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d790f0c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_createShowpayment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1245 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row px-0 px-md-2 my-3 back-txt"},[_c('div',{staticClass:"col-5 col-md-6 align-self-center"},[_c('router-link',{attrs:{"to":"/"}},[_c('span',{staticClass:"mr-1"},[_vm._v("‹")]),_vm._v("Go back to movie list\n      ")])],1),_vm._v(" "),_c('div',{staticClass:"col-7 col-md-6 pr-3 pr-lg-4 align-self-center"},[_c('div',{staticClass:"timer-circle ml-auto mb-0"},[_vm._v("\n        Time Remaining :  \n        "),_c('span',[_vm._v("\n          "+_vm._s(_vm.timer.minutes.toString().length == "1"
              ? "0" + _vm.timer.minutes
              : _vm.timer.minutes)+":"+_vm._s(_vm.timer.seconds.toString().length == "1"
              ? "0" + _vm.timer.seconds
              : _vm.timer.seconds))])])])]),_vm._v(" "),_c('div',{staticClass:"verify-c"},[_c('b-modal',{ref:"errorCard",attrs:{"no-close-on-esc":"","no-close-on-backdrop":"","hide-footer":"","hide-header-close":"","id":"errorCard","title":"FAILED!"}},[_c('div',{staticClass:"p-5"},[_c('div',{staticClass:"text-center mt-3 mt-md-0"},[_vm._v("Sorry, "+_vm._s(_vm.msgError))]),_vm._v(" "),_c('b-button',{staticClass:"w-50 mx-auto gogo-btn btn btn-danger mt-3 d-flex justify-content-center align-items-center",on:{"click":_vm.hideModal}},[_vm._v("Cancel\n        ")])],1)])],1),_vm._v(" "),_c('div',{staticClass:"verify-c"},[_c('b-modal',{ref:"sessionTimeOut",staticClass:"text-center",attrs:{"no-close-on-esc":"","no-close-on-backdrop":"","hide-header-close":"","hide-footer":"","id":"sessionTimeOut","title":"HURRY UP!"}},[_c('div',{staticClass:"p-5"},[_c('div',{staticClass:"text-center mt-3 mt-md-0"},[_vm._v("\n          Your booking has timed out!\n        ")]),_vm._v(" "),_c('div',{staticClass:"text-center mt-3 mt-md-0"},[_vm._v("\n          Click Here to restart the booking\n        ")]),_vm._v(" "),_c('b-button',{staticClass:"w-50 mx-auto gogo-btn btn btn-danger mt-3 d-flex justify-content-center align-items-center",on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("Go Back\n        ")])],1)])],1),_vm._v(" "),_c('div',{staticClass:"verify-c"},[_c('b-modal',{ref:"apiKeyfailed",staticClass:"text-center",attrs:{"no-close-on-esc":"","no-close-on-backdrop":"","hide-header-close":"","hide-footer":"","id":"apiKeyfailed","title":"Failed!"}},[_c('div',{staticClass:"p-5"},[_c('div',{staticClass:"text-center mt-3 mt-md-0"},[_vm._v("API key is invalid !")]),_vm._v(" "),_c('div',{staticClass:"text-center mt-3 mt-md-0"},[_vm._v("\n          Click Here to restart the booking\n        ")]),_vm._v(" "),_c('b-button',{staticClass:"w-50 mx-auto gogo-btn btn btn-danger mt-3 d-flex justify-content-center align-items-center",on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("Go Back\n        ")])],1)])],1),_vm._v(" "),_c('div',{staticClass:"verify-c"},[_c('b-modal',{ref:"minimumPayment",staticClass:"text-center",attrs:{"no-close-on-esc":"","no-close-on-backdrop":"","hide-header-close":"","hide-footer":"","id":"minimumPayment","title":"HURRY UP!"}},[_c('div',{staticClass:"p-5"},[_c('div',{staticClass:"text-center mt-3 mt-md-0"},[_vm._v("Sorry, the payment failed.")]),_vm._v(" "),_c('div',{staticClass:"text-center mt-3 mt-md-0"},[_vm._v("\n          Click Here to restart the booking\n        ")]),_vm._v(" "),_c('b-button',{staticClass:"w-50 mx-auto gogo-btn btn btn-danger mt-3 d-flex justify-content-center align-items-center",on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("Go Back\n        ")])],1)])],1),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-lg-3 h-75 mx-auto mb-4 px-0 mb-lg-2"},[_c('div',{staticClass:"cs-scr-ticket p-3 p-xl-3 mb-4"},[_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"col-5 col-md-6 col-xl-5 pr-xl-2 pr-lg-0 pr-1 pl-0 pl-md-2 rounded"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.showDetails.md_thumbnail_url),expression:"showDetails.md_thumbnail_url"}],staticClass:"img-fluid"})]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column justify-content-between pl-3"},[_c('div',[_c('p',{staticClass:"mb-1"},[_vm._v(_vm._s(_vm.showDetails.movie_title))]),_vm._v(" "),_c('ul',{staticClass:"list-inline movie-tickDetails"},[_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                    "+_vm._s(_vm.showDetails.mrrdr_runtime)+"\n                  ")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(_vm.showDetails.rating))]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                    "+_vm._s(_vm.showDetails.lang_name)+"\n                  ")])])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"rt-txt1"},[_c('span',{staticClass:"d-block small"},[_vm._v("IMDB")]),_vm._v("\n                  "+_vm._s(_vm.showDetails.imdb_link)+"\n                ")]),_vm._v(" "),_c('p',{staticClass:"rt-txt2"},[_c('span',{staticClass:"d-block small"},[_vm._v("Rating")]),_vm._v("\n                  "+_vm._s(_vm.showDetails.rating)+"\n                ")])])])]),_vm._v(" "),_c('hr',{staticClass:"topLine my-2"}),_vm._v(" "),_c('div',{},[_c('small',{staticClass:"vCont"},[_vm._v("\n              Cinema:\n              ")]),_vm._v(" "),_c('p',{staticClass:"hCont"},[_vm._v("\n              "+_vm._s(_vm.showDetails.cine_name)+",  \n              "+_vm._s(_vm.showDetails.cine_address)+"\n            ")]),_vm._v(" "),_c('small',{staticClass:"vCont"},[_vm._v("\n              Screen:\n              ")]),_vm._v(" "),_c('p',{staticClass:"hCont"},[_vm._v(_vm._s(_vm.showDetails.screen_name))])]),_vm._v(" "),_c('div',{},[_c('small',{staticClass:"vCont"},[_vm._v("\n              Date & Time:\n              ")]),_vm._v(" "),_c('ul',{staticClass:"list-inline dateTime hCont"},[(_vm.checkKey == false)?_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                "+_vm._s(_vm.GetDate(_vm.showDetails.date, "full"))+" |\n                "+_vm._s(_vm.showDetails.ss_start_show_time)+"\n              ")]):_vm._e(),_vm._v(" "),(_vm.checkKey)?_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                "+_vm._s(_vm.showDetails.DateTime)+"\n              ")]):_vm._e()])]),_vm._v(" "),(
              _vm.CategoryID === '2' ||
                _vm.CategoryID === '4' ||
                _vm.CategoryID == 2 ||
                _vm.CategoryID === 4
            )?_c('div',[_c('small',{staticClass:"vCont"},[_vm._v("\n              Screening Type:\n              ")]),_vm._v(" "),_c('p',{staticClass:"hCont"},[_vm._v(_vm._s(_vm.showDetails.booking_type_name))])]):_vm._e(),_vm._v(" "),(_vm.ShowType != 'Private')?_c('div',{},[_c('small',{staticClass:"vCont"},[_vm._v("\n              Pick Seats:\n              ")]),_vm._v(" "),_c('ul',{staticClass:"list-inline seatList hCont"},[_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(_vm.showDetails.seat_name))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"amount-box my-4"},[_c('div',{staticClass:"ticketAmount"},[_c('div',{staticClass:"d-flex justify-content-between"},[_c('p',[_vm._v("\n                  Tickets\n                  "),_c('span',[_vm._v("("+_vm._s(_vm.showDetails.ticket_count))]),_vm._v(") :\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                  "+_vm._s(_vm.curr_code)+" "+_vm._s(_vm.currFormat(_vm.showDetails.net_amount))+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between"},[_c('p',[_vm._v("Service Fees and Taxes :")]),_vm._v(" "),_c('p',[_vm._v("\n                  "+_vm._s(_vm.curr_code)+"\n                  "+_vm._s(_vm.currFormat(_vm.showDetails.amount - _vm.showDetails.net_amount))+"\n                ")])]),_vm._v(" "),(_vm.promoApplied)?_c('div',{staticClass:"d-flex justify-content-between"},[_c('div',[_c('p',{staticClass:"mb-0"},[_vm._v("\n                    Promocode Discount :\n                    ")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.promocode))])]),_vm._v(" "),_c('p',{staticClass:"text-success"},[_c('span',[_vm._v("-")]),_vm._v("\n                  "+_vm._s(_vm.curr_code)+" "+_vm._s(_vm.currFormat(_vm.DiscountValue))+"\n                ")])]):_vm._e(),_vm._v(" "),_c('hr',{staticClass:"bottomLine my-4",attrs:{"id":"totalPayment"}})]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between"},[_vm._m(0),_vm._v(" "),_c('p',{staticClass:"hCont"},[_vm._v("\n                "+_vm._s(_vm.curr_code)+" "+_vm._s(_vm.currFormat(_vm.totalPayableAmount))+"\n              ")])]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),(_vm.showCoupon)?_c('div',{staticClass:"promoCode-box"},[_c('p',{staticClass:"vCont"},[_vm._v("\n              Apply Promo Code:\n              ")]),_vm._v(" "),_c('b-input-group',[_c('b-form-input',{staticClass:"promo-code-text",attrs:{"type":"text","placeholder":"Apply Your Promo Code"},model:{value:(_vm.promocode),callback:function ($$v) {_vm.promocode=$$v},expression:"promocode"}}),_vm._v(" "),_c('b-input-group-append',[_c('b-button',{staticClass:"promo-btn",attrs:{"variant":"default"},on:{"click":function($event){return _vm.onApplyPromocode()}}},[_vm._v("APPLY")])],1)],1),_vm._v(" "),_c('small',{staticClass:"mt-2 text-danger"},[_vm._v(_vm._s(this.promocodeErrorMessage))]),_vm._v(" "),_c('small',{staticClass:"mt-2 text-success"},[_vm._v(_vm._s(this.promocodeSuccesMessage))])],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-lg-9 px-0 px-lg-3 mb-5 mb-md-0"},[_c('div',{attrs:{"role":"tablist"}},[_c('b-card',{staticClass:"mb-1",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"accordion-header",attrs:{"header-tag":"header","role":"tab"},on:{"click":function($event){_vm.tabs.collapse1 = !_vm.tabs.collapse1}}},[_c('div',{staticClass:"d-flex align-items-center header-box"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion1",modifiers:{"accordion1":true}}],staticClass:"py-md-3 cus-btn",class:Object.values(_vm.bookingDetails).length == 0 &&
                    _vm.tabs.collapse1
                      ? 'active'
                      : '',attrs:{"block":"","href":"#","variant":"default"}},[_vm._v("\n                  1. Contact Information\n                  "),(Object.values(_vm.bookingDetails).length > 0)?_c('img',{staticClass:"img-fluid ml-2",attrs:{"src":__webpack_require__(56)}}):_vm._e(),_vm._v(" "),(!_vm.tabs.collapse1)?_c('span',{staticClass:"check-markIcon"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(21)}})]):_vm._e(),_vm._v(" "),(_vm.tabs.collapse1)?_c('span',{staticClass:"check-markIcon"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(50)}})]):_vm._e()])],1)]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion1","visible":"","accordion":"my-accordion","role":"tabpanel"}},[_c('b-card-body',[_c('div',{staticClass:"col-12 p-0 p-md-3"},[_c('div',{staticClass:"row"},[(_vm.userInfo || _vm.userLoggedIn)?_c('div',{staticClass:"col-md-6 mx-auto login-box"},[_c('div',{staticClass:"mob-login-box pr-md-5"},[_c('b-form',{attrs:{"data-vv-scope":"verifyUserDetails"}},[_c('b-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"mt-1 mr-sm-2 pc-input",attrs:{"id":"inlineFormInputName22","placeholder":"Enter your Email Address"},model:{value:(_vm.userDetails.email),callback:function ($$v) {_vm.$set(_vm.userDetails, "email", $$v)},expression:"userDetails.email"}}),_vm._v(" "),_c('div',{staticClass:"row align-items-center mt-3"},[_c('div',{staticClass:"col-3 pr-0 pr-xl-2 country-code-drop"},[(_vm.CountryCodeList.length > 0)?_c('b-dropdown',{staticClass:"pc-input form-control",attrs:{"slot":"append","text":_vm.userDetails.country_mob_code,"variant":"default"},slot:"append"},_vm._l((_vm.CountryCodeList),function(country,countryIndex){return _c('b-dropdown-item',{key:countryIndex,on:{"click":function($event){return _vm.onChangeCountry(country)}}},[_vm._v(_vm._s(country.country_mob_code)+"  \n                                  "+_vm._s(country.country_name))])}),1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('b-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"mr-sm-2 pc-input",attrs:{"name":"phonenumber","type":"number","id":"inlineFormInputName10","placeholder":"Enter Your Phone Number"},model:{value:(_vm.userDetails.phone_no),callback:function ($$v) {_vm.$set(_vm.userDetails, "phone_no", $$v)},expression:"userDetails.phone_no"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(
                                _vm.errors.has('verifyUserDetails.phonenumber')
                              ),expression:"\n                                errors.has('verifyUserDetails.phonenumber')\n                              "}],staticClass:"text-danger text-center my-2 pl-3"},[_vm._v("\n                              "+_vm._s(_vm.errors.first("verifyUserDetails.phonenumber"))+"\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"small text-muted mt-2"},[_vm._v("\n                            * Tickets will be sent to the above contact\n                            details\n                          ")]),_vm._v(" "),_c('div',{staticClass:"mt-2"},[_c('b-button',{staticClass:"gogo-btn btn btn-danger",on:{"click":function($event){return _vm.validateBeforeSubmit('verifyUserDetails')}}},[_vm._v("\n                              Confirm Your Details\n                            ")])],1)],1)],1)]):_vm._e(),_vm._v(" "),(_vm.ShowLogin && !_vm.userInfo)?_c('div',{staticClass:"col-md-6 mb-5 mb-md-0 mx-auto login-box"},[_c('p',{staticClass:"log-text mb-2"},[_vm._v("LOGIN")]),_vm._v(" "),_c('div',{staticClass:"mob-login-box pr-md-5"},[_c('b-form',{attrs:{"data-vv-scope":"UserSignIn"}},[_c('b-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],staticClass:"mt-1 mr-sm-2 pc-input",attrs:{"type":"email","id":"inlineFormInputName4","placeholder":"Enter Your Email Address"},model:{value:(_vm.userDetails.email),callback:function ($$v) {_vm.$set(_vm.userDetails, "email", $$v)},expression:"userDetails.email"}}),_vm._v(" "),_c('b-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"mt-3 mr-sm-2 pc-input",attrs:{"type":"password","id":"inlineFormInputName5","placeholder":"Enter Your Password"},model:{value:(_vm.userDetails.password),callback:function ($$v) {_vm.$set(_vm.userDetails, "password", $$v)},expression:"userDetails.password"}}),_vm._v(" "),_c('div',{staticClass:"py-2 text-danger font-weight-bold small"},[_vm._v("\n                            "+_vm._s(_vm.errorMessage.login)+"\n                          ")]),_vm._v(" "),_c('div',{staticClass:"small text-muted mb-2 cursor-pointer",on:{"click":function($event){return _vm.onClickForgotPassword()}}},[_vm._v("\n                            Forgot Password?\n                          ")]),_vm._v(" "),_c('div',{staticClass:"small text-muted mt-2 cursor-pointer",on:{"click":function($event){return _vm.onClickSignUp()}}},[_vm._v("\n                            Do not have an account? Click here to\n                            "),_c('u',[_c('b',[_vm._v("Sign Up")])])]),_vm._v(" "),_c('div',[_c('b-button',{staticClass:"my-2 btn btn-danger gogo-btn",on:{"click":function($event){return _vm.validateBeforeSubmit('UserSignIn')}}},[_vm._v("Login")])],1)],1)],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-6 mx-auto loginmodal",class:{
                        'd-none': _vm.ShowLogin || _vm.userInfo || _vm.userLoggedIn
                      }},[(!_vm.userInfo && !_vm.ShowLogin)?_c('p',{staticClass:"mb-2 log-text"},[_vm._v("\n                        Sign Up\n                      ")]):_vm._e(),_vm._v(" "),(!_vm.userInfo && !_vm.ShowLogin)?_c('b-form',{attrs:{"data-vv-scope":"signUp"},on:{"submit":function($event){$event.preventDefault();return _vm.validateBeforeSubmit('signUp')}}},[_c('div',{staticClass:"mob-login-box"},[_c('b-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],staticClass:"mt-1 mr-sm-2 pc-input",attrs:{"autocomplete":"false","name":"email","type":"email","id":"inlineFormInputNameemail2","placeholder":"Enter Your Email Address"},model:{value:(_vm.signUpUserDetails.email),callback:function ($$v) {_vm.$set(_vm.signUpUserDetails, "email", $$v)},expression:"signUpUserDetails.email"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signUp.email')),expression:"errors.has('signUp.email')"}],staticClass:"py-1 text-danger font-weight-bold small"},[_vm._v("\n                            "+_vm._s(_vm.errors.first("signUp.email"))+"\n                          ")]),_vm._v(" "),_c('div',{staticClass:"row align-items-center mt-3"},[_c('div',{staticClass:"col-3 pr-0 pr-xl-2 country-code-drop"},[(_vm.CountryCodeList.length > 0)?_c('b-dropdown',{staticClass:"pc-input form-control",attrs:{"slot":"append","text":_vm.signUpUserDetails.country_mob_code,"variant":"default"},slot:"append"},_vm._l((_vm.CountryCodeList),function(country,countryIndex){return _c('b-dropdown-item',{key:countryIndex,on:{"click":function($event){return _vm.onChangeCountry(country)}}},[_vm._v(_vm._s(country.country_mob_code)+" \n                                  "+_vm._s(country.country_name))])}),1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('b-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:8|max:12'),expression:"'required|min:8|max:12'"}],staticClass:"mr-sm-2 pc-input",attrs:{"name":"phonenumber","type":"number","id":"inlineFormInputName11","placeholder":"Enter Your Phone Number"},model:{value:(_vm.signUpUserDetails.phoneNumber),callback:function ($$v) {_vm.$set(_vm.signUpUserDetails, "phoneNumber", $$v)},expression:"signUpUserDetails.phoneNumber"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(
                                  _vm.errors.has('signUpUserDetails.phonenumber')
                                ),expression:"\n                                  errors.has('signUpUserDetails.phonenumber')\n                                "}],staticClass:"text-danger text-center my-2"},[_vm._v("\n                                "+_vm._s(_vm.errors.first(
                                    "signUpUserDetails.phonenumber"
                                  ))+"\n                              ")])],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signUp.phonenumber')),expression:"errors.has('signUp.phonenumber')"}],staticClass:"py-1 text-danger font-weight-bold small"},[_vm._v("\n                            "+_vm._s(_vm.errors.first("signUp.phonenumber"))+"\n                          ")]),_vm._v(" "),_c('b-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:6'),expression:"'required|min:6'"}],staticClass:"mt-3 mr-sm-2 pc-input",attrs:{"type":"password","name":"password","id":"inlineFormInputNamepassword","placeholder":"Enter Your Password"},model:{value:(_vm.signUpUserDetails.password),callback:function ($$v) {_vm.$set(_vm.signUpUserDetails, "password", $$v)},expression:"signUpUserDetails.password"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('signUp.password')),expression:"errors.has('signUp.password')"}],staticClass:"py-1 text-danger font-weight-bold small"},[_vm._v("\n                            "+_vm._s(_vm.errors.first("signUp.password"))+"\n                          ")])],1),_vm._v(" "),_c('b-form-checkbox',{staticClass:"grey-text pc-radio mt-2 mb-2 mt-md-2 mb-md-2",attrs:{"id":"checkbox-tandc","name":"checkbox-tandc","value":"accepted","unchecked-value":"not_accepted"},model:{value:(_vm.signUpUserDetails.termsAndConditions),callback:function ($$v) {_vm.$set(_vm.signUpUserDetails, "termsAndConditions", $$v)},expression:"signUpUserDetails.termsAndConditions"}},[_vm._v("\n                          I agree to all\n                          "),_c('router-link',{staticClass:"tnc-class",attrs:{"to":"/termsCondition","target":"_blank"}},[_vm._v("Terms & Conditions\n                          ")])],1),_vm._v(" "),_c('div',{staticClass:"small text-muted mt-2 cursor-pointer",on:{"click":function($event){return _vm.onClickLogin()}}},[_vm._v("\n                          Already have an account? Click here to\n                          "),_c('u',[_c('b',[_vm._v("Sign In")])])]),_vm._v(" "),_c('div',{staticClass:"py-2 text-danger font-weight-bold small"},[_vm._v("\n                          "+_vm._s(_vm.errorMessage.signUp)+"\n                        ")]),_vm._v(" "),_c('input',{staticClass:"btn btn-danger gogo-btn mt-2",attrs:{"type":"submit","value":"Create an account"}})],1):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"col-12 px-0 d-none"},[_c('div',{staticClass:"text-success font-weight-bold d-md-flex"},[_c('div',{staticClass:"text-mob mt-3 mt-md-0"},[_vm._v("\n                      Awesome! Your verification is complete and your account\n                      has been created! You’ll get a link to reset your\n                      password which you can do later if you’d like as well.\n                    ")])])])])],1)],1),_vm._v(" "),_c('b-card',{staticClass:"mb-1",attrs:{"no-body":"","id":"PaymentShow"}},[_c('b-card-header',{staticClass:"accordion-header",attrs:{"header-tag":"header","role":"tab"}},[_c('div',{staticClass:"d-flex align-items-center header-box"},[_c('b-button',{staticClass:"py-md-3",class:[
                    Object.values(_vm.bookingDetails).length == 0
                      ? 'disabled'
                      : _vm.tabs.collapse2
                      ? 'active'
                      : ''
                  ],attrs:{"href":"#","block":"","variant":"default"}},[_vm._v("\n                  2. Choose Payment Mode\n                  "),(_vm.showProceedButton)?_c('img',{staticClass:"img-fluid ml-2",attrs:{"src":__webpack_require__(56)}}):_vm._e(),_vm._v(" "),(!_vm.tabs.collapse2)?_c('span',{staticClass:"check-markIcon"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(21)}})]):_vm._e(),_vm._v(" "),(_vm.tabs.collapse2)?_c('span',{staticClass:"check-markIcon"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(50)}})]):_vm._e()])],1)]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion2","accordion":"my-accordion","role":"tabpanel"}},[(_vm.showOtpSection && !_vm.showBrainTreeContainer)?_c('b-card-body',[_c('div',{staticClass:"col-md-6 login-box px-md-3 px-0"},[_c('div',{staticClass:"mob-login-box p-md-2 pr-md-5"},[_c('p',{staticClass:"otp-text mb-0"},[_vm._v("\n                      Almost there! Please enter the 4 digit verification code\n                      you might have just received via email / SMS.\n                    ")]),_vm._v(" "),_c('div',{staticClass:"my-4 otp-section"},[_c('form',{attrs:{"data-vv-scope":"verifyOtp","id":"otpForm","action":""}},[_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"d-flex otp-mob"},[_c('div',{staticClass:"col px-2 px-md-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.OTP[0]),expression:"OTP[0]"}],ref:"otp1",staticClass:"form-control text-center py-4",attrs:{"type":"number","maxlength":"1","pattern":"([12345])\\w{0}","id":"otp1","btnNumber":"0","placeholder":"","required":""},domProps:{"value":(_vm.OTP[0])},on:{"keyup":function($event){return _vm.OTPonKeyUp(0, $event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.OTP, 0, $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col px-2 px-md-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.OTP[1]),expression:"OTP[1]"}],ref:"otp2",staticClass:"form-control text-center py-4",attrs:{"type":"number","maxlength":"1","pattern":"([12345])\\w{0}","id":"otp2","placeholder":"","min":"0","max":"9","required":""},domProps:{"value":(_vm.OTP[1])},on:{"keyup":function($event){return _vm.OTPonKeyUp(1, $event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.OTP, 1, $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col px-2 px-md-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.OTP[2]),expression:"OTP[2]"}],ref:"otp3",staticClass:"form-control text-center py-4",attrs:{"type":"number","maxlength":"1","pattern":"([12345])\\w{0}","id":"otp3","placeholder":"","min":"0","max":"9","required":""},domProps:{"value":(_vm.OTP[2])},on:{"keyup":function($event){return _vm.OTPonKeyUp(2, $event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.OTP, 2, $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col px-2 px-md-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.OTP[3]),expression:"OTP[3]"}],ref:"otp4",staticClass:"form-control text-center py-4",attrs:{"type":"number","maxlength":"1","pattern":"([12345])\\w{0}","id":"otp4","placeholder":"","min":"0","max":"9","required":""},domProps:{"value":(_vm.OTP[3])},on:{"keyup":function($event){return _vm.OTPonKeyUp(3, $event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.OTP, 3, $event.target.value)}}})])])])])]),_vm._v(" "),_vm._v("\n                    Didn't receive the code yet?\n                    "),_c('router-link',{attrs:{"to":""},nativeOn:{"click":function($event){return _vm.SendOTP()}}},[_vm._v("Resend it")])],1),_vm._v(" "),_c('div',{staticClass:"text-danger p-md-2 pr-md-5 my-2"},[_vm._v("\n                    "+_vm._s(_vm.errorMessage.payment)+"\n                  ")]),_vm._v(" "),_c('div',{staticClass:"d-md-table d-block proceed-btn"},[_c('b-button',{staticClass:"btn py-md-2 px-md-5 btn-danger",on:{"click":function($event){return _vm.validateBeforeSubmit('verifyOtp')}}},[_vm._v("\n                      Proceed")])],1)])]):_vm._e(),_vm._v(" "),(_vm.showBrainTreeContainer)?_c('b-card-body',[_c('div',{attrs:{"id":"dropin-container"}}),_vm._v(" "),_c('b-button',{ref:"submitButton",staticClass:"btn py-md-2 px-md-5 btn-danger",attrs:{"id":"submit-button"}},[_vm._v("PAY\n                  "+_vm._s(_vm.showDetails.Currency)+"\n                  "+_vm._s(_vm.currFormat(_vm.showDetails.TotalPrice)))])],1):_vm._e(),_vm._v(" "),(_vm.directPay)?_c('b-card-body',[_c('div',{attrs:{"id":"dropin-container"}}),_vm._v(" "),_c('b-button',{ref:"submitButton",staticClass:"btn py-md-2 px-md-5 btn-danger",attrs:{"id":"submit-button"},on:{"click":function($event){return _vm.payNow()}}},[_vm._v("PAY\n                  "+_vm._s(_vm.curr_code)+"\n                  "+_vm._s(_vm.currFormat(_vm.totalPayableAmount)))])],1):_vm._e(),_vm._v(" "),(!_vm.showOtpSection && !_vm.showBrainTreeContainer)?_c('b-card-body',{staticClass:"p-2"},[_c('div',[_vm._v(_vm._s(_vm.errorMessage.reserveBooking))]),_vm._v(" "),_vm._l((_vm.paymetOptions),function(singlePayment,paymentIndex){return (!(_vm.selectedPaymentOptionID == 3))?_c('div',{key:paymentIndex,staticClass:"col-12 col-md-10 col-lg-9 col-xl-7 px-2 px-lg-3 py-2 py-md-3 py-lg-4 mb-3 paymentMethod"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center"},[_c('div',{staticClass:"mr-4 text-center payment-logo"},[_c('img',{staticClass:"img-fluid",attrs:{"src":singlePayment.Image}})]),_vm._v(" "),_c('div',{staticClass:"flex-grow-1"},[_c('p',[_vm._v(_vm._s(singlePayment.Name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(singlePayment.Message))])]),_vm._v(" "),_c('div',{staticClass:"px-md-3 px-2"},[_c('div',{staticClass:"cus-checkbox",class:{
                          active: _vm.PaymentId == singlePayment.PaymentID
                        },on:{"click":function($event){return _vm.selectPayment(singlePayment)}}},[_c('img',{attrs:{"src":__webpack_require__(309)}})])])])]):_vm._e()}),_vm._v(" "),_vm._l((_vm.stripeCards),function(singleCard,singleCardIndex){return (_vm.selectedPaymentOptionID == 3)?_c('div',{key:singleCardIndex,staticClass:"col-12 col-md-10 col-lg-9 col-xl-7 py-2 py-md-3 py-lg-4 mb-3 paymentMethod px-2"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center"},[_c('div',{staticClass:"mr-4 text-center payment-logo"},[(singleCard.card.brand == 'visa')?_c('img',{staticClass:"img-fluid",attrs:{"src":"https://i.imgur.com/IrGyMve.jpg"}}):_vm._e(),_vm._v(" "),(singleCard.card.brand == 'mastercard')?_c('img',{staticClass:"img-fluid",attrs:{"src":"https://i.imgur.com/fLQ4rCq.jpg"}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"flex-grow-1"},[_c('p',[_vm._v("**** **** **** "+_vm._s(singleCard.card.last4))]),_vm._v(" "),_c('p',[_vm._v("\n                        Expiration : "+_vm._s(singleCard.card.exp_month)+"/"+_vm._s(singleCard.card.exp_year)+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"px-md-3 px-0"},[_c('div',{staticClass:"cus-checkbox",class:{
                          active: _vm.stripeCardSelected.id == singleCard.id
                        },on:{"click":function () { return (_vm.stripeCardSelected = singleCard); }}},[_c('img',{attrs:{"src":__webpack_require__(309)}})])])])]):_vm._e()}),_vm._v(" "),(_vm.selectedPaymentOptionID == 3)?_c('div',{staticClass:"col-12 col-md-10 col-lg-9 col-xl-7 py-2 py-md-3 py-lg-4 mb-3 paymentMethod px-2"},[_c('div',[_vm._v("New Card")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between align-items-center"},[_c('div',{staticClass:"flex-grow-1"},[_c('card',{staticClass:"stripe-card",class:{ complete: _vm.complete },attrs:{"stripe":_vm.stripePublicKey,"options":_vm.stripeOptions},on:{"change":function($event){_vm.complete = $event.complete}}})],1),_vm._v(" "),_c('div',{staticClass:"px-md-3 px-0"},[_c('div',{staticClass:"cus-checkbox",class:{
                          active: _vm.stripeCardSelected.type == 'new'
                        },on:{"click":function () { return (_vm.stripeCardSelected = { type: 'new' }); }}},[_c('img',{attrs:{"src":__webpack_require__(309)}})])])])]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"font-weight-bold"},[_c('img',{staticClass:"mx-3",attrs:{"src":"https://i.imgur.com/IrGyMve.jpg","height":"70px","width":"70px"}}),_vm._v(" "),_c('img',{staticClass:"mx-1",attrs:{"src":"https://i.imgur.com/fLQ4rCq.jpg","height":"70px","width":"70px"}})]),_vm._v(" "),_c('div',{staticClass:"d-md-block proceed-btn"},[(_vm.PaymentId == 1)?_c('b-button',{staticClass:"btn py-md-2 px-md-5 btn-danger",on:{"click":function($event){return _vm.SendOTP()}}},[_vm._v("\n                    Proceed")]):_vm._e(),_vm._v(" "),(_vm.PaymentId == 2)?_c('b-button',{staticClass:"btn py-md-2 px-md-5 btn-danger",on:{"click":function($event){return _vm.getBrainTreeToken()}}},[_vm._v("Proceed")]):_vm._e(),_vm._v(" "),(_vm.PaymentId == 3 && _vm.selectedPaymentOptionID != 3)?_c('b-button',{staticClass:"btn py-md-2 px-md-5 btn-danger",on:{"click":function($event){return _vm.proceedStripePayment()}}},[_vm._v("Proceed")]):_vm._e(),_vm._v(" "),(
                      _vm.PaymentId == 3 &&
                        _vm.selectedPaymentOptionID == 3 &&
                        _vm.stripeCardSelected.type != 'new' &&
                        _vm.stripeCardSelected.id
                    )?_c('b-button',{staticClass:"btn py-md-2 px-md-5 btn-danger",on:{"click":function($event){return _vm.confirmStripePaymentDetails()}}},[_vm._v("Submit Payment")]):_vm._e(),_vm._v(" "),(
                      _vm.PaymentId == 3 &&
                        _vm.selectedPaymentOptionID == 3 &&
                        _vm.stripeCardSelected.type == 'new' &&
                        _vm.complete
                    )?_c('b-button',{staticClass:"btn py-md-2 px-md-5 btn-danger",on:{"click":function($event){return _vm.startStripeWithoutSavedCard()}}},[_vm._v("Submit Payment")]):_vm._e()],1)],2):_vm._e()],1)],1),_vm._v(" "),_c('b-card',{staticClass:"d-none mb-1",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"accordion-header",attrs:{"header-tag":"header","role":"tab"},on:{"click":function($event){_vm.tabs.collapse3 = !_vm.tabs.collapse3}}},[_c('div',{staticClass:"d-flex align-items-center header-box"},[_c('b-button',{staticClass:"py-md-3",class:[
                    _vm.tabs.collapse3 && _vm.showProceedButton
                      ? 'active'
                      : _vm.showProceedButton
                      ? ''
                      : 'disabled'
                  ],attrs:{"block":"","href":"#","variant":"default"}},[_vm._v("\n                  3. Confirmation\n                  "),(!_vm.tabs.collapse3 && !_vm.showProceedButton)?_c('span',{staticClass:"check-markIcon"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(21)}})]):(_vm.tabs.collapse3 && _vm.showProceedButton)?_c('span',{staticClass:"check-markIcon"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(50)}})]):(_vm.tabs.collapse3)?_c('span',{staticClass:"check-markIcon"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(21)}})]):_vm._e()])],1)]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion3","accordion":"my-accordion","role":"tabpanel"}},[_c('b-card-body',[_c('div',{staticClass:"col-sm-4 px-0 px-md-3 mb-3 col-lg-4 mx-auto text-center"},[(_vm.confirmDetails)?_c('router-link',{attrs:{"to":{
                      name: 'confirmScreen',
                      params: {
                        bookingId: _vm.confirmDetails.BookingID || 0,
                        paymentId: _vm.PaymentId || 2
                      }
                    }}},[(_vm.showProceedButton)?_c('b-button',{staticClass:"gogo-btn btn btn-danger"},[_vm._v("Confirm")]):_vm._e()],1):_vm._e()],1)])],1)],1)],1)])])]),_vm._v(" "),_c('b-modal',{ref:"SeatRealeased",staticClass:"text-center",attrs:{"no-close-on-esc":"","no-close-on-backdrop":"","hide-header-close":"","hide-footer":"","id":"minimumPayment","title":"FAILED !"}},[_c('div',{staticClass:"p-5"},[_c('div',{staticClass:"text-center mt-3 mt-md-0"},[_vm._v(_vm._s(_vm.showMessage))]),_vm._v(" "),_c('b-button',{staticClass:"w-50 mx-auto gogo-btn btn btn-danger mt-3 d-flex justify-content-center align-items-center",on:{"click":_vm.hideModal}},[_vm._v("Go Back")])],1)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"mb-0 vCont"},[_vm._v("\n                  Total Amount Payable :\n                  ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('small',{staticClass:"vCont"},[_vm._v("(Amount inclusive of all service fees and taxes)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_confirmScreen_vue__ = __webpack_require__(628);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a581ef8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_confirmScreen_vue__ = __webpack_require__(1250);
function injectStyle (ssrContext) {
  __webpack_require__(1248)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2a581ef8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_confirmScreen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a581ef8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_confirmScreen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1248 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":function($event){return _vm.share()}}},[(_vm.hasSlot())?_vm._t("clickable"):_c('p',[_vm._v("Share")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"col-12 col-md-8 col-lg-6 my-4 col-xl-4 px-0 px-md-3 mx-auto confirmScreenT"},[_c('div',{staticClass:"text-center"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(310),"width":"120px"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('p',{staticClass:"ntext my-3",attrs:{"data-v-23f776d6":""}},[_vm._v("\n          You will soon receive an email / SMS from us with details\n        ")]),_vm._v(" "),_c('p',{staticClass:"eTitle",attrs:{"data-v-23f776d6":""}}),_vm._v(" "),_c('p',{staticClass:"eTitle"},[_vm._v("\n          Booking ID :\n          "),_c('span',[_vm._v(_vm._s(_vm.bookingDetails.sb_booking_code))])]),_vm._v(" "),_c('div',{staticClass:"cus-spaceDiv pb-2"},[_c('button',{staticClass:"btn btn-danger w-100 gogo-cus-btn",on:{"click":_vm.toggleSocialShareVisibility}},[_vm._v("\n            Share\n          ")])]),_vm._v(" "),(_vm.isSocialShareVisible)?_c('div',{staticClass:"social-share-buttons my-2 d-flex justify-content-between"},[_c('button',{staticClass:"btn-lg d-flex align-items-center rounded-circle btn btn-primary w-auto",on:{"click":_vm.shareOnFacebook}},[_c('svg',{staticClass:"bi bi-facebook",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"currentColor","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951"}})])]),_vm._v(" "),_c('button',{staticClass:"btn-lg d-flex align-items-center rounded-circle btn btn-dark w-auto",on:{"click":_vm.shareOnX}},[_c('svg',{staticClass:"bi bi-twitter-x",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"currentColor","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"}})])]),_vm._v(" "),_c('button',{staticClass:"btn-lg d-flex align-items-center rounded-circle btn btn-secondary w-auto",on:{"click":_vm.shareOnLinkedIn}},[_c('svg',{staticClass:"bi bi-linkedin",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"currentColor","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854zm4.943 12.248V6.169H2.542v7.225zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248S2.4 3.226 2.4 3.934c0 .694.521 1.248 1.327 1.248zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016l.016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225z"}})])]),_vm._v(" "),_c('button',{staticClass:"btn-lg d-flex h-100 align-items-center rounded-circle btn btn-success w-auto",on:{"click":_vm.shareViaWhatsApp}},[_c('svg',{staticClass:"bi bi-whatsapp",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"currentColor","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"}})])]),_vm._v(" "),_c('button',{staticClass:"btn-lg d-flex h-100 align-items-center rounded-circle btn btn-primary w-auto",on:{"click":_vm.copyToClipboard}},[_c('svg',{staticClass:"bi bi-copy",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"currentColor","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"fill-rule":"evenodd","d":"M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"}})])])]):_vm._e()])]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.legacySystemHTML)}}),_vm._v(" "),(Object.keys(_vm.bookingDetails).length > 0)?_c('div',{staticClass:"col-12 col-md-12 col-lg-11 col-xl-9 px-0 px-md-3 mx-auto",attrs:{"id":"printMe2"}},[_c('div',{staticClass:"d-none d-lg-block"},[_c('div',{staticClass:"corner-circle-top mt-5 mx-2 ticket-shadow"},[_c('div',{staticClass:"corner-circle-bottom bg-light m-ticket-web"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-8 p-4 p-xl-5"},[_c('div',{staticClass:"h-100"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3 pr-0 pr-xl-3"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.bookingDetails.md_thumbnail_url),expression:"bookingDetails.md_thumbnail_url"}],staticClass:"img-fluid rounded"})]),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('div',{staticClass:"px-3"},[_c('div',{},[_c('p',{staticClass:"text-capitalize font-weight-bold mb-0 ticket-mtitle"},[_vm._v("\n                              "+_vm._s(_vm.bookingDetails.movie_title)+"\n                            ")]),_vm._v(" "),_c('ul',{staticClass:"list-inline m-tick-mInfo"},[_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                                "+_vm._s(_vm.bookingDetails.lang_name)+" ("+_vm._s(_vm.bookingDetails.mf_name)+")\n                              ")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                                "+_vm._s(_vm.showDateHandlaler(_vm.bookingDetails.show_date))+"\n                              ")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                                "+_vm._s(_vm.bookingDetails.rating)+"\n                              ")])])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between align-items-end my-3"},[_c('div',[_c('p',{staticClass:"mb-0 txt14-light-blue"},[_vm._v("\n                                "+_vm._s(_vm.bookingDetails.cine_name)+" -\n                                "+_vm._s(_vm.bookingDetails.screen_name)+"\n                              ")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center text-dark"},[_c('div',{staticClass:"mr-1"},[_c('span',[_vm._v(_vm._s(_vm.timeFormat(_vm.bookingDetails.show_time)))]),_vm._v("\n                                  |\n                                  ")]),_vm._v(" "),_c('div',{staticClass:"mr-1"},[_c('span',{},[_vm._v(_vm._s(_vm.showDateHandlaler(_vm.bookingDetails.show_date)))])])])])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between align-items-center my-3"},[(_vm.bookingDetails.seats)?_c('div',[_c('p',{staticClass:"text-muted mb-0 tiny"},[_vm._v("\n                                Seats:\n                                "+_vm._s(_vm.bookingDetails.booking_type_id != 3
                                    ? _vm.bookingDetails.seats.length
                                    : _vm.bookingDetails.screen_total_seats)+"\n                              ")]),_vm._v(" "),_c('ul',{staticClass:"list-inline mt-seat-list mb-0"},[_c('li',{staticClass:"list-inline-item mx-0"},[_vm._v("\n                                  "+_vm._s(_vm.bookingDetails.seats
                                      .join(", ")
                                      .replace("Hall", "Auditorium"))+"\n                                ")])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"m-ticket-details"},[_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-xl-7 text-muted tiny col-md-6"},[_vm._v("\n                                Ticket Price\n                              ")]),_vm._v(" "),_c('div',{staticClass:"col-xl-5 amt-text tiny col-md-6 d-flex justify-content-end"},[_vm._v("\n                                "+_vm._s(_vm.curr_code)+"\n                                "+_vm._s(_vm.currFormat(_vm.bookingDetails.sb_total_net_amount))+"\n                              ")])]),_vm._v(" "),(
                                _vm.bookingDetails.chargeTypeArray &&
                                  _vm.bookingDetails.chargeTypeArray.length > 0
                              )?_c('div',{},_vm._l(([].concat( _vm.bookingDetails.chargeTypeArray ).reverse()),function(charge,chargeIndex){return _c('div',{key:chargeIndex,staticClass:"row mb-2"},[_c('div',{staticClass:"col-xl-7 text-muted tiny col-md-6"},[_vm._v("\n                                  "+_vm._s(charge.ct_name)+"\n                                ")]),_vm._v(" "),_c('div',{staticClass:"col-xl-5 amt-text tiny col-md-6 d-flex justify-content-end"},[_vm._v("\n                                  "+_vm._s(_vm.curr_code)+"\n                                  "+_vm._s(_vm.currFormat(charge.tax_amount))+"\n                                ")])])}),0):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-xl-7 text-muted tiny col-md-6"},[_vm._v("\n                                Discount\n                              ")]),_vm._v(" "),_c('div',{staticClass:"col-xl-5 amt-text tiny col-md-6 d-flex justify-content-end"},[_vm._v("\n                                "+_vm._s(_vm.curr_code)+"\n                                "+_vm._s(_vm.currFormat(_vm.bookingDetails.offer_price))+"\n                              ")])])])]),_vm._v(" "),_c('div',{staticClass:"px-3 mt-2 pt-2 d-md-none d-lg-block mt-border-top"},[_c('div',{staticClass:"m-ticket-details"},[_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-xl-7 col-md-6 ticket-mtitle font-weight-bold"},[_vm._v("\n                                Total\n                              ")]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-xl-5 ticket-mtitle font-weight-bold pr-0 d-flex justify-content-end"},[_vm._v("\n                                "+_vm._s(_vm.curr_code)+"\n                                "+_vm._s(_vm.currFormat(_vm.totalPayableAmount))+"\n                              ")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-4 text-center p-3 p-xl-5 mt-border mt-qr-section"},[_c('div',{staticClass:"h-100 d-flex align-items-center justify-content-center"},[_c('div',{staticClass:"w-100"},[(true)?_c('p',{staticClass:"info"},[_vm._v("\n                        Use this QR Code to Enter the Cinema\n                      ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"pb-2"},[_c('img',{staticClass:"img-fluid qr-code",attrs:{"src":_vm.bookingDetails.qrcode,"alt":'name',"height":"150px","width":"150px"}})]),_vm._v(" "),_c('div',{staticClass:"pt-3 pb-4"},[(
                            _vm.bookingDetails.booking_type_id != 3 &&
                              _vm.bookingDetails.booking_type_id
                          )?_c('div',{staticClass:"pb-1 text-center"},[_c('p',{staticClass:"mb-0 font-weight-bold",style:(_vm.bookingDetails.booking_type_id == '2'
                                ? 'color:red'
                                : '')},[_vm._v("\n                            "+_vm._s(_vm.bookingDetails.booking_type_id == 2
                                ? "Not Confirmed"
                                : "Confirmed")+"\n                          ")])]):_vm._e(),_vm._v(" "),(
                            _vm.bookingDetails.booking_type_id != 3 &&
                              _vm.bookingDetails.booking_type_id
                          )?_c('div',[(_vm.bookingDetails.booking_type_id == 2)?_c('b-progress',{staticClass:"proBar ticket-proBar red mb-0",attrs:{"max":parseInt(_vm.bookingDetails.screen_total_seats)}},[_c('b-progress-bar',{attrs:{"value":_vm.bookingDetails.booked_seats}}),_vm._v(" "),_c('p',{staticClass:"mb-0 reqText mx-auto pr-2",class:_vm.bookingDetails.booking_type_id == 1
                                  ? 'd-none'
                                  : ''},[_vm._v("\n                              "+_vm._s(_vm.bookingDetails.booking_type_id == 2
                                  ? ("Need " + (_vm.bookingDetails.min_seats -
                                      _vm.bookingDetails.booked_seats) + " Seats to confirm")
                                  : ((_vm.bookingDetails.screen_total_seats -
                                      _vm.bookingDetails.booked_seats) + " seats left"))+"\n                            ")])],1):_vm._e(),_vm._v(" "),(_vm.bookingDetails.booking_type_id == 1)?_c('b-progress',{staticClass:"proBar ticket-proBar mb-0",attrs:{"max":parseInt(100)}},[_c('b-progress-bar',{attrs:{"value":parseInt(100)}},[_c('p',{staticClass:"mb-0 succ-text"},[_vm._v("\n                                "+_vm._s(_vm.bookingDetails.booking_type_id == 2
                                    ? ("Need " + (_vm.bookingDetails.min_seats -
                                        _vm.bookingDetails.booked_seats) + " seats to confirm")
                                    : ((_vm.bookingDetails.screen_total_seats -
                                        _vm.bookingDetails.booked_seats) + " seats left"))+"\n                              ")])])],1):_vm._e()],1):(_vm.bookingDetails.booking_type_id == 3)?_c('div',[_c('b-progress',{staticClass:"proBar ticket-proBar bg-warning mb-0",attrs:{"max":parseInt(_vm.bookingDetails.screen_total_seats)}},[_c('b-progress-bar'),_vm._v(" "),_c('p',{staticClass:"mb-0 reqText mx-auto pr-2"},[_vm._v("\n                              Private Screening\n                            ")])],1)],1):_c('div',[_c('b-progress',{staticClass:"proBar ticket-proBar bg-success mb-0",attrs:{"max":parseInt(100)}},[_c('b-progress-bar'),_vm._v(" "),_c('p',{staticClass:"mb-0 reqText mx-auto pr-2"},[_vm._v("\n                              Regular Screening\n                            ")])],1)],1),_vm._v(" "),_c('input',{staticStyle:{"opacity":"0","height":"1px"},attrs:{"type":"text","id":"copyText"},domProps:{"value":_vm.bookingDetails.ShowType != 'Private'
                              ? 'Join me on GoGoCinema to watch ' +
                                _vm.bookingDetails.movie_title +
                                ' at ' +
                                _vm.bookingDetails.cine_name +
                                ' on ' +
                                _vm.bookingDetails.show_date +
                                ' at ' +
                                _vm.timeFormat(_vm.bookingDetails.show_time) +
                                '. Click the below link to join: \n' +
                                _vm.bookingDetails.shortLinkPwa
                              : 'I have booked a private screening on GoGoCinema! Join me to watch ' +
                                _vm.bookingDetails.movie_title +
                                ' at ' +
                                _vm.bookingDetails.cine_name +
                                ' on ' +
                                _vm.bookingDetails.show_date +
                                ' at ' +
                                _vm.timeFormat(_vm.bookingDetails.show_time) +
                                '.'}}),_vm._v(" "),(
                            _vm.bookingDetails.ShowStatusMsg == 'UNCONFIRMED' ||
                              _vm.bookingDetails.ShowStatusMsg == 'CONFIRMED'
                          )?_c('div',[_c('div',{staticClass:"btn-share",attrs:{"id":"tooltip-button"},on:{"click":function($event){return _vm.copyTextShare()}}},[_c('p',{staticStyle:{"cursor":"pointer"}},[_vm._v("Share")])])]):_vm._e(),_vm._v(" "),_c('b-tooltip',{attrs:{"show":_vm.bookingDetails.show,"disabled":true,"target":"tooltip-button","placement":"bottom","variant":"outline-success","custom-class":"tool-tip-cop"}},[_c('strong',[_vm._v("Copied")])])],1)])])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-11 mx-auto mt-3"},[_c('ul',{staticClass:"list-inline"},[_c('li',{staticClass:"list-inline-item mr-md-3"},[_c('p',{staticClass:"mb-1 text-muted"},[_vm._v("Booking Date & Time:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.showDateHandlaler(_vm.bookingDetails.transaction_date_time)))])]),_vm._v(" "),_c('li',{staticClass:"list-inline-item mr-md-3"},[_c('p',{staticClass:"mb-1 text-muted"},[_vm._v("Payment Method")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.bookingDetails.pm_payment_mode || "-"))])]),_vm._v(" "),_c('li',{staticClass:"list-inline-item mr-md-3"},[_c('p',{staticClass:"mb-1 text-muted"},[_vm._v("Booking ID")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.bookingDetails.sb_booking_code))])])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 mx-auto px-0 d-block d-lg-none"},[_c('div',{staticClass:"new-mTicket bg-light"},[_c('div',{staticClass:"ticket-info"},[_c('div',{staticClass:"px-3 py-3"},[_c('div',{staticClass:"d-flex align-items-center justify-content-between mb-3"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"text-right"},[_c('p',{staticClass:"pt-2"},[_vm._v("\n                  Ticket No :"+_vm._s(_vm.bookingDetails.sb_booking_code)+"\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 px-0"},[_c('div',{staticClass:"border-bottom pb-2"},[_c('p',{staticClass:"movie-title"},[_vm._v(_vm._s(_vm.bookingDetails.movie_title))]),_vm._v(" "),_c('ul',{staticClass:"list-inline extra-movie-info py-1"},[_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s("300 min"))]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                    "+_vm._s(_vm.bookingDetails.lang_name)+"\n                  ")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(_vm.bookingDetails.mf_name))])]),_vm._v(" "),_c('p',{staticClass:"dark-txt"},[_vm._v(_vm._s(_vm.bookingDetails.cine_name))])]),_vm._v(" "),_c('div',{staticClass:"row pt-2"},[_c('div',{staticClass:"col-8"},[_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"light-txt"},[_vm._v("Date :")]),_vm._v(" "),_c('p',{staticClass:"dark-txt"},[_vm._v("\n                      "+_vm._s(_vm.showDateHandlaler(_vm.bookingDetails.show_date))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"light-txt"},[_vm._v("\n                      Seats : - ("+_vm._s(_vm.bookingDetails.seats.join(","))+")\n                    ")]),_vm._v(" "),_c('ul',{staticClass:"list-inline m-ticket-seats"},_vm._l((_vm.bookingDetails.seats),function(item,index){return _c('li',{key:index,staticClass:"list-inline-item"},[_vm._v("\n                        "+_vm._s(item)+"\n                      ")])}),0)])]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"light-txt"},[_vm._v("Time :")]),_vm._v(" "),_c('p',{staticClass:"dark-txt"},[_vm._v("\n                      "+_vm._s(_vm.timeFormat(_vm.bookingDetails.show_time))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"light-txt"},[_vm._v("Screen No.")]),_vm._v(" "),_c('p',{staticClass:"dark-txt"},[_vm._v(_vm._s(_vm.bookingDetails.screen_name))])])])]),_vm._v(" "),_c('div',{staticClass:"row pb-2"},[_c('div',{staticClass:"col-8"},[_c('p',{staticClass:"light-txt mb-1"},[_vm._v("Ticket Price")]),_vm._v(" "),(_vm.bookingDetails.total_tax)?_c('p',{staticClass:"light-txt mb-1"},[_vm._v("\n                    TAX\n                  ")]):_vm._e(),_vm._v(" "),(_vm.bookingDetails.internet_handling_fee)?_c('p',{staticClass:"light-txt mb-1"},[_vm._v("\n                    Service Charge\n                  ")]):_vm._e(),_vm._v(" "),(_vm.bookingDetails.offer_price)?_c('p',{staticClass:"light-txt mb-1"},[_vm._v("\n                    Discount\n                  ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('p',{staticClass:"normal-txt"},[_vm._v("\n                    "+_vm._s(_vm.curr_code)+"\n                    "+_vm._s(_vm.currFormat(_vm.bookingDetails.sb_total_net_amount))+"\n                  ")]),_vm._v(" "),(_vm.bookingDetails.total_tax)?_c('p',{staticClass:"normal-txt"},[_vm._v("\n                    "+_vm._s(_vm.curr_code)+"\n                    "+_vm._s(_vm.currFormat(
                        _vm.bookingDetails.sb_total_amount -
                          _vm.bookingDetails.sb_total_net_amount
                      ))+"\n                  ")]):_vm._e(),_vm._v(" "),(_vm.bookingDetails.internet_handling_fee)?_c('p',{staticClass:"normal-txt"},[_vm._v("\n                    "+_vm._s(_vm.curr_code)+"\n                    "+_vm._s(_vm.currFormat(_vm.bookingDetails.internet_handling_fee))+"\n                  ")]):_vm._e(),_vm._v(" "),(_vm.bookingDetails.offer_price)?_c('p',{staticClass:"normal-txt"},[_vm._v("\n                    "+_vm._s(_vm.curr_code)+" "+_vm._s(_vm.currFormat(_vm.bookingDetails.offer_price))+"\n                  ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row border-top pt-2"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('p',{staticClass:"dark-txt"},[_vm._v("\n                    "+_vm._s(_vm.curr_code)+" "+_vm._s(_vm.currFormat(_vm.totalPayableAmount))+"\n                  ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"qr-section qr-section pt-3 pb-5"},[_c('div',{staticClass:"pt-3 pb-0 px-3 px-md-4",style:(_vm.bookingDetails.ShowType == 'Private' ? 'margin: 2px 54px;' : '')},[(_vm.bookingDetails.ShowType != 'Private')?_c('div',{staticClass:"pb-1 text-center"},[(_vm.bookingDetails.ConfirmedStatus == false)?_c('p',{staticClass:"mb-0 font-weight-bold",style:(_vm.bookingDetails.ShowStatus == '2' ? 'color:red' : '')},[_vm._v("\n                "+_vm._s(_vm.bookingDetails.ShowStatusMsg)+"\n              ")]):_vm._e(),_vm._v(" "),(_vm.bookingDetails.ConfirmedStatus)?_c('p',{staticClass:"mb-0 font-weight-bold",style:(_vm.bookingDetails.ShowStatus == '3' ? 'color:red' : '')},[_vm._v("\n                "+_vm._s(_vm.bookingDetails.ShowStatusMsg)+"\n              ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.bookingDetails.ShowType != 'Private')?_c('div',[(
                  _vm.bookingDetails.ConfirmedStatus == false &&
                    _vm.bookingDetails.ShowStatus == '0'
                )?_c('div',{staticClass:"new-progress-bar unconfirmed"},[_c('b-progress',{staticStyle:{"width":"10%"},attrs:{"max":parseInt(_vm.bookingDetails.TotalSeat)}},[_c('b-progress-bar')],1),_vm._v(" "),_c('p',{staticClass:"proBar-text",domProps:{"innerHTML":_vm._s(_vm.bookingDetails.ExpiryMsg)}})],1):_vm._e(),_vm._v(" "),(
                  _vm.bookingDetails.ConfirmedStatus &&
                    _vm.bookingDetails.ShowStatus == '1'
                )?_c('div',{staticClass:"new-progress-bar confirmed"},[_c('b-progress',{staticStyle:{"width":"100%"},attrs:{"max":parseInt(_vm.bookingDetails.TotalSeat)}},[_c('b-progress-bar')],1),_vm._v(" "),_c('p',{staticClass:"proBar-text",domProps:{"innerHTML":_vm._s(_vm.bookingDetails.ExpiryMsg)}})],1):_vm._e()]):_c('div',{staticClass:"new-progress-bar bg-warning"},[_c('b-progress',{staticStyle:{"width":"0%"},attrs:{"max":parseInt(_vm.bookingDetails.TotalSeat)}},[_c('b-progress-bar')],1),_vm._v(" "),_c('p',{staticClass:"proBar-text"},[_vm._v("Private Screening")])],1)]),_vm._v(" "),_c('div',{staticClass:"align-self-center text-center"},[(_vm.bookingDetails.ShowStatus == '1')?_c('p',{staticClass:"qr-note"},[_vm._v("\n              Use this QR Code to Enter the Cinema\n            ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"py-3"},[_c('img',{staticClass:"img-fluid qr-code",attrs:{"src":_vm.bookingDetails.qrcode,"alt":"'name'","height":"150px","width":"150px"}})]),_vm._v(" "),(
                _vm.bookingDetails.ShowStatusMsg == 'UNCONFIRMED' ||
                  _vm.bookingDetails.ShowStatusMsg == 'CONFIRMED'
              )?_c('div',[_c('navigator-share',{staticClass:"btn-share",attrs:{"on-error":_vm.onError,"on-success":_vm.onSuccess,"text":_vm.bookingDetails.ShowType != 'Private'
                    ? 'Join me on GoGoCinema to watch ' +
                      _vm.bookingDetails.Title +
                      ' at ' +
                      _vm.bookingDetails.CinemaName +
                      ' on ' +
                      _vm.bookingDetails.ShowDate +
                      ' at ' +
                      _vm.bookingDetails.ShowTime +
                      '. Click the below link to join: \n' +
                      _vm.bookingDetails.shortLinkPwa
                    : 'I have booked a private screening on GoGoCinema! Join me to watch ' +
                      _vm.bookingDetails.Title +
                      ' at ' +
                      _vm.bookingDetails.CinemaName +
                      ' on ' +
                      _vm.bookingDetails.ShowDate +
                      ' at ' +
                      _vm.bookingDetails.ShowTime +
                      '.'}})],1):_vm._e()])])]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-10 col-lg-6 mx-auto my-5 d-none d-lg-block"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 col-lg-5 col-xl-4 mx-auto text-center"},[_c('router-link',{staticClass:"mt-3 btn btn-danger text-light",attrs:{"to":{
              name: 'Home'
            }}},[_vm._v("Home")])],1)])]),_vm._v(" "),_c('div',{staticClass:"invite-pop"},[_c('b-modal',{ref:"invitemodal",staticClass:"welcome-b header",attrs:{"title":"Invite Friend","id":"invite","hide-footer":""}},[_c('div',{staticClass:"p-4"},[_c('div',{staticClass:"invite-section"},[_c('p',{staticClass:"invite-txt mb-3"},[_vm._v("Send ticket to a friend")]),_vm._v(" "),_c('form',{staticClass:"d-md-flex w-100",attrs:{"data-vv-scope":"inviteFriend"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.friendemail),expression:"friendemail"},{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],staticClass:"form-control py-4 w-100",attrs:{"type":"text","name":"email","placeholder":"Enter Your Friend's Email Address"},domProps:{"value":(_vm.friendemail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.friendemail=$event.target.value}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('inviteFriend.email')),expression:"errors.has('inviteFriend.email')"}],staticClass:"py-1 text-danger font-weight-bold small"},[_vm._v("\n              "+_vm._s(_vm.errors.first("inviteFriend.email"))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"text-danger mt-3 small font-weight-bold"},[_vm._v("\n            "+_vm._s(_vm.errorMessage)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_c('input',{staticClass:"gogo-btn btn btn-danger",attrs:{"type":"submit","value":"Send"},on:{"click":function($event){$event.stopPropagation();return _vm.validateBeforeSubmit('inviteFriend')}}})])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"tTitle mt-3",attrs:{"data-v-23f776d6":""}},[_vm._v("\n          Good News! "),_c('br'),_vm._v("Ticket(s) Booked\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":__webpack_require__(214),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-8"},[_c('p',{staticClass:"light-txt"},[_vm._v("Total")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_confirmScreenVista_vue__ = __webpack_require__(630);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b6cf8c3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_confirmScreenVista_vue__ = __webpack_require__(1253);
function injectStyle (ssrContext) {
  __webpack_require__(1252)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1b6cf8c3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_confirmScreenVista_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b6cf8c3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_confirmScreenVista_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1252 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"col-12 col-md-8 col-lg-6 my-4 col-xl-4 px-0 px-md-3 mx-auto confirmScreenT"},[_c('div',{staticClass:"text-center"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(310),"width":"120px"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('p',{staticClass:"ntext my-3",attrs:{"data-v-23f776d6":""}},[_vm._v("\n        You will soon receive an email / SMS from us with details\n      ")]),_vm._v(" "),_c('p',{staticClass:"eTitle",attrs:{"data-v-23f776d6":""}}),_vm._v(" "),_c('p',{staticClass:"eTitle"},[_vm._v("\n        Booking ID :\n        "),_c('span',[_vm._v(_vm._s(_vm.bookingDetails.sb_booking_code))])])])]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.legacySystemHTML)}}),_vm._v(" "),(Object.keys(_vm.bookingDetails).length > 0)?_c('div',{staticClass:"col-12 col-md-12 col-lg-11 col-xl-9 px-0 px-md-3 mx-auto",attrs:{"id":"printMe2"}},[_c('div',{staticClass:"d-none d-lg-block"},[_c('div',{staticClass:"corner-circle-top mt-5 mx-2 ticket-shadow"},[_c('div',{staticClass:"corner-circle-bottom bg-light m-ticket-web"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-8 p-4 p-xl-5"},[_c('div',{staticClass:"h-100"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3 pr-0 pr-xl-3"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.bookingDetails.md_thumbnail_url),expression:"bookingDetails.md_thumbnail_url"}],staticClass:"img-fluid rounded"})]),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('div',{staticClass:"px-3"},[_c('div',{},[_c('p',{staticClass:"text-capitalize font-weight-bold mb-0 ticket-mtitle"},[_vm._v("\n                            "+_vm._s(_vm.bookingDetails.movie_title)+"\n                          ")]),_vm._v(" "),_c('ul',{staticClass:"list-inline m-tick-mInfo"},[_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                              "+_vm._s(_vm.bookingDetails.lang_name)+" ("+_vm._s(_vm.bookingDetails.mf_name)+")\n                            ")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                              "+_vm._s(_vm._f("moment")(_vm.bookingDetails.show_date))+"\n                            ")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                              "+_vm._s(_vm.bookingDetails.rating)+"\n                            ")])])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between align-items-end my-3"},[_c('div',[_c('p',{staticClass:"mb-0 txt14-light-blue"},[_vm._v("\n                              "+_vm._s(_vm.bookingDetails.cine_name)+" -\n                              "+_vm._s(_vm.bookingDetails.screen_name)+"\n                            ")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center text-dark"},[_c('div',{staticClass:"mr-1"},[_c('span',[_vm._v(_vm._s(_vm.timeFormat(_vm.bookingDetails.show_time)))]),_vm._v("\n                                |\n                                ")]),_vm._v(" "),_c('div',{staticClass:"mr-1"},[_c('span',{},[_vm._v(_vm._s(_vm._f("moment")((" " + _vm.bookingDetails.show_date))))])])])])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between align-items-center my-3"},[(_vm.bookingDetails.seats)?_c('div',[_c('p',{staticClass:"text-muted mb-0 tiny"},[_vm._v("\n                              Seats:\n                              "+_vm._s(_vm.bookingDetails.booking_type_id != 3
                                  ? _vm.bookingDetails.seats.length
                                  : _vm.bookingDetails.screen_total_seats)+"\n                            ")]),_vm._v(" "),_c('ul',{staticClass:"list-inline mt-seat-list mb-0"},[_c('li',{staticClass:"list-inline-item mx-0"},[_vm._v("\n                                "+_vm._s(_vm.bookingDetails.seats
                                    .join(", ")
                                    .replace("Hall", "Auditorium"))+"\n                              ")])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"m-ticket-details"},[_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-xl-7 text-muted tiny col-md-6"},[_vm._v("\n                              Ticket Price\n                            ")]),_vm._v(" "),_c('div',{staticClass:"col-xl-5 amt-text tiny col-md-6 d-flex justify-content-end"},[_vm._v("\n                              "+_vm._s(_vm.curr_code)+"\n                              "+_vm._s(_vm.currFormat(_vm.bookingDetails.sb_total_net_amount))+"\n                            ")])]),_vm._v(" "),(
                              _vm.bookingDetails.chargeTypeArray &&
                                _vm.bookingDetails.chargeTypeArray.length > 0
                            )?_c('div',{},_vm._l((_vm.bookingDetails.chargeTypeArray),function(charge,chargeIndex){return _c('div',{key:chargeIndex,staticClass:"row mb-2"},[_c('div',{staticClass:"col-xl-7 text-muted tiny col-md-6"},[_vm._v("\n                                "+_vm._s(charge.ct_name)+"\n                              ")]),_vm._v(" "),_c('div',{staticClass:"col-xl-5 amt-text tiny col-md-6 d-flex justify-content-end"},[_vm._v("\n                                "+_vm._s(_vm.curr_code)+"\n                                "+_vm._s(_vm.currFormat(charge.tax_amount))+"\n                              ")])])}),0):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-xl-7 text-muted tiny col-md-6"},[_vm._v("\n                              Discount\n                            ")]),_vm._v(" "),_c('div',{staticClass:"col-xl-5 amt-text tiny col-md-6 d-flex justify-content-end"},[_vm._v("\n                              "+_vm._s(_vm.curr_code)+"\n                              "+_vm._s(_vm.currFormat(_vm.bookingDetails.offer_price))+"\n                            ")])])])]),_vm._v(" "),_c('div',{staticClass:"px-3 mt-2 pt-2 d-md-none d-lg-block mt-border-top"},[_c('div',{staticClass:"m-ticket-details"},[_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-xl-7 col-md-6 ticket-mtitle font-weight-bold"},[_vm._v("\n                              Total\n                            ")]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-xl-5 ticket-mtitle font-weight-bold pr-0 d-flex justify-content-end"},[_vm._v("\n                              "+_vm._s(_vm.curr_code)+"\n                              "+_vm._s(_vm.currFormat(_vm.totalPayableAmount))+"\n                            ")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-4 text-center p-3 p-xl-5 mt-border mt-qr-section"},[_c('div',{staticClass:"h-100 d-flex align-items-center justify-content-center"},[_c('div',{staticClass:"w-100"},[(true)?_c('p',{staticClass:"info"},[_vm._v("\n                      Use this QR Code to Enter the Cinema\n                    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"pb-2"},[_c('img',{staticClass:"img-fluid qr-code",attrs:{"src":_vm.bookingDetails.qrcode,"alt":'name',"height":"150px","width":"150px"}})]),_vm._v(" "),_c('div',{staticClass:"pt-3 pb-4"},[(
                          _vm.bookingDetails.booking_type_id != 3 &&
                            _vm.bookingDetails.booking_type_id
                        )?_c('div',{staticClass:"pb-1 text-center"},[_c('p',{staticClass:"mb-0 font-weight-bold",style:(_vm.bookingDetails.booking_type_id == '2'
                              ? 'color:red'
                              : '')},[_vm._v("\n                          "+_vm._s(_vm.bookingDetails.booking_type_id == 2
                              ? "Not Confirmed"
                              : "Confirmed")+"\n                        ")])]):_vm._e(),_vm._v(" "),(
                          _vm.bookingDetails.booking_type_id != 3 &&
                            _vm.bookingDetails.booking_type_id
                        )?_c('div',[(_vm.bookingDetails.booking_type_id == 2)?_c('b-progress',{staticClass:"proBar ticket-proBar red mb-0",attrs:{"max":parseInt(_vm.bookingDetails.screen_total_seats)}},[_c('b-progress-bar',{attrs:{"value":_vm.bookingDetails.booked_seats}}),_vm._v(" "),_c('p',{staticClass:"mb-0 reqText mx-auto pr-2",class:_vm.bookingDetails.booking_type_id == 1
                                ? 'd-none'
                                : ''},[_vm._v("\n                            "+_vm._s(_vm.bookingDetails.booking_type_id == 2
                                ? ("Need " + (_vm.bookingDetails.min_seats -
                                    _vm.bookingDetails.booked_seats) + " Seats to confirm")
                                : ((_vm.bookingDetails.screen_total_seats -
                                    _vm.bookingDetails.booked_seats) + " seats left"))+"\n                          ")])],1):_vm._e(),_vm._v(" "),(_vm.bookingDetails.booking_type_id == 1)?_c('b-progress',{staticClass:"proBar ticket-proBar mb-0",attrs:{"max":parseInt(100)}},[_c('b-progress-bar',{attrs:{"value":parseInt(100)}},[_c('p',{staticClass:"mb-0 succ-text"},[_vm._v("\n                              "+_vm._s(_vm.bookingDetails.booking_type_id == 2
                                  ? ("Need " + (_vm.bookingDetails.min_seats -
                                      _vm.bookingDetails.booked_seats) + " seats to confirm")
                                  : ((_vm.bookingDetails.screen_total_seats -
                                      _vm.bookingDetails.booked_seats) + " seats left"))+"\n                            ")])])],1):_vm._e()],1):(_vm.bookingDetails.booking_type_id == 3)?_c('div',[_c('b-progress',{staticClass:"proBar ticket-proBar bg-warning mb-0",attrs:{"max":parseInt(_vm.bookingDetails.screen_total_seats)}},[_c('b-progress-bar'),_vm._v(" "),_c('p',{staticClass:"mb-0 reqText mx-auto pr-2"},[_vm._v("\n                            Private Screening\n                          ")])],1)],1):_c('div',[_c('b-progress',{staticClass:"proBar ticket-proBar bg-success mb-0",attrs:{"max":parseInt(100)}},[_c('b-progress-bar'),_vm._v(" "),_c('p',{staticClass:"mb-0 reqText mx-auto pr-2"},[_vm._v("\n                            Regular Screening\n                          ")])],1)],1),_vm._v(" "),_c('input',{staticStyle:{"opacity":"0","height":"1px"},attrs:{"type":"text","id":"copyText"},domProps:{"value":_vm.bookingDetails.ShowType != 'Private'
                            ? 'Join me on GoGoCinema to watch ' +
                              _vm.bookingDetails.movie_title +
                              ' at ' +
                              _vm.bookingDetails.cine_name +
                              ' on ' +
                              _vm.bookingDetails.show_date +
                              ' at ' +
                              _vm.timeFormat(_vm.bookingDetails.show_time) +
                              '. Click the below link to join: \n' +
                              _vm.bookingDetails.shortLinkPwa
                            : 'I have booked a private screening on GoGoCinema! Join me to watch ' +
                              _vm.bookingDetails.movie_title +
                              ' at ' +
                              _vm.bookingDetails.cine_name +
                              ' on ' +
                              _vm.bookingDetails.show_date +
                              ' at ' +
                              _vm.timeFormat(_vm.bookingDetails.show_time) +
                              '.'}}),_vm._v(" "),(
                          _vm.bookingDetails.ShowStatusMsg == 'UNCONFIRMED' ||
                            _vm.bookingDetails.ShowStatusMsg == 'CONFIRMED'
                        )?_c('div',[_c('div',{staticClass:"btn-share",attrs:{"id":"tooltip-button"},on:{"click":function($event){return _vm.copyTextShare()}}},[_c('p',{staticStyle:{"cursor":"pointer"}},[_vm._v("Share")])])]):_vm._e(),_vm._v(" "),_c('b-tooltip',{attrs:{"show":_vm.bookingDetails.show,"disabled":true,"target":"tooltip-button","placement":"bottom","variant":"outline-success","custom-class":"tool-tip-cop"}},[_c('strong',[_vm._v("Copied")])])],1)])])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-11 mx-auto mt-3"},[_c('ul',{staticClass:"list-inline"},[_c('li',{staticClass:"list-inline-item mr-md-3"},[_c('p',{staticClass:"mb-1 text-muted"},[_vm._v("Booking Date & Time:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("datetime")(_vm.bookingDetails.transaction_date_time)))])]),_vm._v(" "),_c('li',{staticClass:"list-inline-item mr-md-3"},[_c('p',{staticClass:"mb-1 text-muted"},[_vm._v("Payment Method")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.bookingDetails.pm_payment_mode || "-"))])]),_vm._v(" "),_c('li',{staticClass:"list-inline-item mr-md-3"},[_c('p',{staticClass:"mb-1 text-muted"},[_vm._v("Booking ID")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.bookingDetails.sb_booking_code))])])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 mx-auto px-0 d-block d-lg-none"},[_c('div',{staticClass:"new-mTicket bg-light"},[_c('div',{staticClass:"ticket-info"},[_c('div',{staticClass:"px-3 py-3"},[_c('div',{staticClass:"d-flex align-items-center justify-content-between mb-3"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"text-right"},[_c('p',{staticClass:"pt-2"},[_vm._v("\n                Ticket No :"+_vm._s(_vm.bookingDetails.sb_booking_code)+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 px-0"},[_c('div',{staticClass:"border-bottom pb-2"},[_c('p',{staticClass:"movie-title"},[_vm._v(_vm._s(_vm.bookingDetails.movie_title))]),_vm._v(" "),_c('ul',{staticClass:"list-inline extra-movie-info py-1"},[_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s("300 min"))]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                  "+_vm._s(_vm.bookingDetails.lang_name)+"\n                ")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(_vm.bookingDetails.mf_name))])]),_vm._v(" "),_c('p',{staticClass:"dark-txt"},[_vm._v(_vm._s(_vm.bookingDetails.cine_name))])]),_vm._v(" "),_c('div',{staticClass:"row pt-2"},[_c('div',{staticClass:"col-8"},[_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"light-txt"},[_vm._v("Date :")]),_vm._v(" "),_c('p',{staticClass:"dark-txt"},[_vm._v("\n                    "+_vm._s(_vm._f("moment")(_vm.bookingDetails.show_date))+"\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"light-txt"},[_vm._v("\n                    Seats : - ("+_vm._s(_vm.bookingDetails.seats.join(","))+")\n                  ")]),_vm._v(" "),_c('ul',{staticClass:"list-inline m-ticket-seats"},_vm._l((_vm.bookingDetails.seats),function(item,index){return _c('li',{key:index,staticClass:"list-inline-item"},[_vm._v("\n                      "+_vm._s(item)+"\n                    ")])}),0)])]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"light-txt"},[_vm._v("Time :")]),_vm._v(" "),_c('p',{staticClass:"dark-txt"},[_vm._v("\n                    "+_vm._s(_vm.timeFormat(_vm.bookingDetails.show_time))+"\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"light-txt"},[_vm._v("Screen No.")]),_vm._v(" "),_c('p',{staticClass:"dark-txt"},[_vm._v(_vm._s(_vm.bookingDetails.screen_name))])])])]),_vm._v(" "),_c('div',{staticClass:"row pb-2"},[_c('div',{staticClass:"col-8"},[_c('p',{staticClass:"light-txt mb-1"},[_vm._v("Ticket Price")]),_vm._v(" "),(_vm.bookingDetails.total_tax)?_c('p',{staticClass:"light-txt mb-1"},[_vm._v("\n                  TAX\n                ")]):_vm._e(),_vm._v(" "),(_vm.bookingDetails.internet_handling_fee)?_c('p',{staticClass:"light-txt mb-1"},[_vm._v("\n                  Service Charge\n                ")]):_vm._e(),_vm._v(" "),(_vm.bookingDetails.offer_price)?_c('p',{staticClass:"light-txt mb-1"},[_vm._v("\n                  Discount\n                ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('p',{staticClass:"normal-txt"},[_vm._v("\n                  "+_vm._s(_vm.curr_code)+"\n                  "+_vm._s(_vm.currFormat(_vm.bookingDetails.sb_total_net_amount))+"\n                ")]),_vm._v(" "),(_vm.bookingDetails.total_tax)?_c('p',{staticClass:"normal-txt"},[_vm._v("\n                  "+_vm._s(_vm.curr_code)+"\n                  "+_vm._s(_vm.currFormat(
                      _vm.bookingDetails.sb_total_amount -
                        _vm.bookingDetails.sb_total_net_amount
                    ))+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.bookingDetails.internet_handling_fee)?_c('p',{staticClass:"normal-txt"},[_vm._v("\n                  "+_vm._s(_vm.curr_code)+"\n                  "+_vm._s(_vm.currFormat(_vm.bookingDetails.internet_handling_fee))+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.bookingDetails.offer_price)?_c('p',{staticClass:"normal-txt"},[_vm._v("\n                  "+_vm._s(_vm.curr_code)+" "+_vm._s(_vm.currFormat(_vm.bookingDetails.offer_price))+"\n                ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row border-top pt-2"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('p',{staticClass:"dark-txt"},[_vm._v("\n                  "+_vm._s(_vm.curr_code)+" "+_vm._s(_vm.currFormat(_vm.totalPayableAmount))+"\n                ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"qr-section qr-section pt-3 pb-5"},[_c('div',{staticClass:"pt-3 pb-0 px-3 px-md-4",style:(_vm.bookingDetails.ShowType == 'Private' ? 'margin: 2px 54px;' : '')},[(_vm.bookingDetails.ShowType != 'Private')?_c('div',{staticClass:"pb-1 text-center"},[(_vm.bookingDetails.ConfirmedStatus == false)?_c('p',{staticClass:"mb-0 font-weight-bold",style:(_vm.bookingDetails.ShowStatus == '2' ? 'color:red' : '')},[_vm._v("\n              "+_vm._s(_vm.bookingDetails.ShowStatusMsg)+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.bookingDetails.ConfirmedStatus)?_c('p',{staticClass:"mb-0 font-weight-bold",style:(_vm.bookingDetails.ShowStatus == '3' ? 'color:red' : '')},[_vm._v("\n              "+_vm._s(_vm.bookingDetails.ShowStatusMsg)+"\n            ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.bookingDetails.ShowType != 'Private')?_c('div',[(
                _vm.bookingDetails.ConfirmedStatus == false &&
                  _vm.bookingDetails.ShowStatus == '0'
              )?_c('div',{staticClass:"new-progress-bar unconfirmed"},[_c('b-progress',{staticStyle:{"width":"10%"},attrs:{"max":parseInt(_vm.bookingDetails.TotalSeat)}},[_c('b-progress-bar')],1),_vm._v(" "),_c('p',{staticClass:"proBar-text",domProps:{"innerHTML":_vm._s(_vm.bookingDetails.ExpiryMsg)}})],1):_vm._e(),_vm._v(" "),(
                _vm.bookingDetails.ConfirmedStatus &&
                  _vm.bookingDetails.ShowStatus == '1'
              )?_c('div',{staticClass:"new-progress-bar confirmed"},[_c('b-progress',{staticStyle:{"width":"100%"},attrs:{"max":parseInt(_vm.bookingDetails.TotalSeat)}},[_c('b-progress-bar')],1),_vm._v(" "),_c('p',{staticClass:"proBar-text",domProps:{"innerHTML":_vm._s(_vm.bookingDetails.ExpiryMsg)}})],1):_vm._e()]):_c('div',{staticClass:"new-progress-bar bg-warning"},[_c('b-progress',{staticStyle:{"width":"0%"},attrs:{"max":parseInt(_vm.bookingDetails.TotalSeat)}},[_c('b-progress-bar')],1),_vm._v(" "),_c('p',{staticClass:"proBar-text"},[_vm._v("Private Screening")])],1)]),_vm._v(" "),_c('div',{staticClass:"align-self-center text-center"},[(_vm.bookingDetails.ShowStatus == '1')?_c('p',{staticClass:"qr-note"},[_vm._v("\n            Use this QR Code to Enter the Cinema\n          ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"py-3"},[_c('img',{staticClass:"img-fluid qr-code",attrs:{"src":_vm.bookingDetails.qrcode,"alt":"'name'","height":"150px","width":"150px"}})]),_vm._v(" "),(
              _vm.bookingDetails.ShowStatusMsg == 'UNCONFIRMED' ||
                _vm.bookingDetails.ShowStatusMsg == 'CONFIRMED'
            )?_c('div',[_c('navigator-share',{staticClass:"btn-share",attrs:{"on-error":_vm.onError,"on-success":_vm.onSuccess,"text":_vm.bookingDetails.ShowType != 'Private'
                  ? 'Join me on GoGoCinema to watch ' +
                    _vm.bookingDetails.Title +
                    ' at ' +
                    _vm.bookingDetails.CinemaName +
                    ' on ' +
                    _vm.bookingDetails.ShowDate +
                    ' at ' +
                    _vm.bookingDetails.ShowTime +
                    '. Click the below link to join: \n' +
                    _vm.bookingDetails.shortLinkPwa
                  : 'I have booked a private screening on GoGoCinema! Join me to watch ' +
                    _vm.bookingDetails.Title +
                    ' at ' +
                    _vm.bookingDetails.CinemaName +
                    ' on ' +
                    _vm.bookingDetails.ShowDate +
                    ' at ' +
                    _vm.bookingDetails.ShowTime +
                    '.'}})],1):_vm._e()])])]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-10 col-lg-6 mx-auto my-5 d-none d-lg-block"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 col-lg-5 col-xl-4 mx-auto text-center"},[_c('router-link',{staticClass:"mt-3 btn btn-danger text-light",attrs:{"to":{
            name: 'Home'
          }}},[_vm._v("Home")])],1)])]),_vm._v(" "),_c('div',{staticClass:"invite-pop"},[_c('b-modal',{ref:"invitemodal",staticClass:"welcome-b header",attrs:{"title":"Invite Friend","id":"invite","hide-footer":""}},[_c('div',{staticClass:"p-4"},[_c('div',{staticClass:"invite-section"},[_c('p',{staticClass:"invite-txt mb-3"},[_vm._v("Send ticket to a friend")]),_vm._v(" "),_c('form',{staticClass:"d-md-flex w-100",attrs:{"data-vv-scope":"inviteFriend"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.friendemail),expression:"friendemail"},{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],staticClass:"form-control py-4 w-100",attrs:{"type":"text","name":"email","placeholder":"Enter Your Friend's Email Address"},domProps:{"value":(_vm.friendemail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.friendemail=$event.target.value}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('inviteFriend.email')),expression:"errors.has('inviteFriend.email')"}],staticClass:"py-1 text-danger font-weight-bold small"},[_vm._v("\n            "+_vm._s(_vm.errors.first("inviteFriend.email"))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"text-danger mt-3 small font-weight-bold"},[_vm._v("\n          "+_vm._s(_vm.errorMessage)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_c('input',{staticClass:"gogo-btn btn btn-danger",attrs:{"type":"submit","value":"Send"},on:{"click":function($event){$event.stopPropagation();return _vm.validateBeforeSubmit('inviteFriend')}}})])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"tTitle mt-3",attrs:{"data-v-23f776d6":""}},[_vm._v("\n        Good News! "),_c('br'),_vm._v("Ticket(s) Booked\n      ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":__webpack_require__(214),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-8"},[_c('p',{staticClass:"light-txt"},[_vm._v("Total")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_confirmScreenRts_vue__ = __webpack_require__(631);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e8863b1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_confirmScreenRts_vue__ = __webpack_require__(1256);
function injectStyle (ssrContext) {
  __webpack_require__(1255)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e8863b1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_confirmScreenRts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e8863b1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_confirmScreenRts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1255 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"col-12 col-md-8 col-lg-6 my-4 col-xl-4 px-0 px-md-3 mx-auto confirmScreenT"},[_c('div',{staticClass:"text-center"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(310),"width":"120px"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('p',{staticClass:"ntext my-3",attrs:{"data-v-23f776d6":""}},[_vm._v("\n        You will soon receive an email / SMS from us with details\n      ")]),_vm._v(" "),_c('p',{staticClass:"eTitle",attrs:{"data-v-23f776d6":""}}),_vm._v(" "),_c('p',{staticClass:"eTitle"},[_vm._v("\n        Booking ID :\n        "),_c('span',[_vm._v(_vm._s(_vm.bookingDetails.sb_booking_code))])])])]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.legacySystemHTML)}}),_vm._v(" "),(Object.keys(_vm.bookingDetails).length > 0)?_c('div',{staticClass:"col-12 col-md-12 col-lg-11 col-xl-9 px-0 px-md-3 mx-auto",attrs:{"id":"printMe2"}},[_c('div',{staticClass:"d-none d-lg-block"},[_c('div',{staticClass:"corner-circle-top mt-5 mx-2 ticket-shadow"},[_c('div',{staticClass:"corner-circle-bottom bg-light m-ticket-web"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-8 p-4 p-xl-5"},[_c('div',{staticClass:"h-100"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3 pr-0 pr-xl-3"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.bookingDetails.md_thumbnail_url),expression:"bookingDetails.md_thumbnail_url"}],staticClass:"img-fluid rounded"})]),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('div',{staticClass:"px-3"},[_c('div',{},[_c('p',{staticClass:"text-capitalize font-weight-bold mb-0 ticket-mtitle"},[_vm._v("\n                            "+_vm._s(_vm.bookingDetails.movie_title)+"\n                          ")]),_vm._v(" "),_c('ul',{staticClass:"list-inline m-tick-mInfo"},[_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                              "+_vm._s(_vm.bookingDetails.lang_name)+" ("+_vm._s(_vm.bookingDetails.mf_name)+")\n                            ")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                              "+_vm._s(_vm._f("moment")(_vm.bookingDetails.show_date))+"\n                            ")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                              "+_vm._s(_vm.bookingDetails.rating)+"\n                            ")])])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between align-items-end my-3"},[_c('div',[_c('p',{staticClass:"mb-0 txt14-light-blue"},[_vm._v("\n                              "+_vm._s(_vm.bookingDetails.cine_name)+" -\n                              "+_vm._s(_vm.bookingDetails.screen_name)+"\n                            ")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center text-dark"},[_c('div',{staticClass:"mr-1"},[_c('span',[_vm._v(_vm._s(_vm.timeFormat(_vm.bookingDetails.show_time)))]),_vm._v("\n                                |\n                              ")]),_vm._v(" "),_c('div',{staticClass:"mr-1"},[_c('span',{},[_vm._v(_vm._s(_vm._f("moment")((" " + _vm.bookingDetails.show_date))))])])])])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between align-items-center my-3"},[(_vm.bookingDetails.seats)?_c('div',[_c('p',{staticClass:"text-muted mb-0 tiny"},[_vm._v("\n                              Seats:\n                              "+_vm._s(_vm.bookingDetails.booking_type_id != 3
                                  ? _vm.bookingDetails.seats.length
                                  : _vm.bookingDetails.screen_total_seats)+"\n                            ")]),_vm._v(" "),_c('ul',{staticClass:"list-inline mt-seat-list mb-0"},[_c('li',{staticClass:"list-inline-item mx-0"},[_vm._v("\n                                "+_vm._s(_vm.bookingDetails.seats
                                    .join(", ")
                                    .replace("Hall", "Auditorium"))+"\n                              ")])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"m-ticket-details"},[_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-xl-7 text-muted tiny col-md-6"},[_vm._v("\n                              Ticket Price\n                            ")]),_vm._v(" "),_c('div',{staticClass:"col-xl-5 amt-text tiny col-md-6 d-flex justify-content-end"},[_vm._v("\n                              "+_vm._s(_vm.curr_code)+"\n                              "+_vm._s(_vm.currFormat(_vm.bookingDetails.sb_total_net_amount))+"\n                            ")])]),_vm._v(" "),(
                              _vm.bookingDetails.chargeTypeArray &&
                              _vm.bookingDetails.chargeTypeArray.length > 0
                            )?_c('div',{},_vm._l((_vm.bookingDetails.chargeTypeArray),function(charge,chargeIndex){return _c('div',{key:chargeIndex,staticClass:"row mb-2"},[_c('div',{staticClass:"col-xl-7 text-muted tiny col-md-6"},[_vm._v("\n                                "+_vm._s(charge.ct_name)+"\n                              ")]),_vm._v(" "),_c('div',{staticClass:"col-xl-5 amt-text tiny col-md-6 d-flex justify-content-end"},[_vm._v("\n                                "+_vm._s(_vm.curr_code)+"\n                                "+_vm._s(_vm.currFormat(charge.tax_amount))+"\n                              ")])])}),0):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-xl-7 text-muted tiny col-md-6"},[_vm._v("\n                              Discount\n                            ")]),_vm._v(" "),_c('div',{staticClass:"col-xl-5 amt-text tiny col-md-6 d-flex justify-content-end"},[_vm._v("\n                              "+_vm._s(_vm.curr_code)+"\n                              "+_vm._s(_vm.currFormat(_vm.bookingDetails.offer_price))+"\n                            ")])])])]),_vm._v(" "),_c('div',{staticClass:"px-3 mt-2 pt-2 d-md-none d-lg-block mt-border-top"},[_c('div',{staticClass:"m-ticket-details"},[_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-xl-7 col-md-6 ticket-mtitle font-weight-bold"},[_vm._v("\n                              Total\n                            ")]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-xl-5 ticket-mtitle font-weight-bold pr-0 d-flex justify-content-end"},[_vm._v("\n                              "+_vm._s(_vm.curr_code)+"\n                              "+_vm._s(_vm.currFormat(_vm.totalPayableAmount))+"\n                            ")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-4 text-center p-3 p-xl-5 mt-border mt-qr-section"},[_c('div',{staticClass:"h-100 d-flex align-items-center justify-content-center"},[_c('div',{staticClass:"w-100"},[(true)?_c('p',{staticClass:"info"},[_vm._v("\n                      Use this QR Code to Enter the Cinema\n                    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"pb-2"},[_c('img',{staticClass:"img-fluid qr-code",attrs:{"src":_vm.bookingDetails.qrcode,"alt":'name',"height":"150px","width":"150px"}})]),_vm._v(" "),_c('div',{staticClass:"pt-3 pb-4"},[(
                          _vm.bookingDetails.booking_type_id != 3 &&
                          _vm.bookingDetails.booking_type_id
                        )?_c('div',{staticClass:"pb-1 text-center"},[_c('p',{staticClass:"mb-0 font-weight-bold",style:(_vm.bookingDetails.booking_type_id == '2'
                              ? 'color:red'
                              : '')},[_vm._v("\n                          "+_vm._s(_vm.bookingDetails.booking_type_id == 2
                              ? "Not Confirmed"
                              : "Confirmed")+"\n                        ")])]):_vm._e(),_vm._v(" "),(
                          _vm.bookingDetails.booking_type_id != 3 &&
                          _vm.bookingDetails.booking_type_id
                        )?_c('div',[(_vm.bookingDetails.booking_type_id == 2)?_c('b-progress',{staticClass:"proBar ticket-proBar red mb-0",attrs:{"max":parseInt(_vm.bookingDetails.screen_total_seats)}},[_c('b-progress-bar',{attrs:{"value":_vm.bookingDetails.booked_seats}}),_vm._v(" "),_c('p',{staticClass:"mb-0 reqText mx-auto pr-2",class:_vm.bookingDetails.booking_type_id == 1
                                ? 'd-none'
                                : ''},[_vm._v("\n                            "+_vm._s(_vm.bookingDetails.booking_type_id == 2
                                ? ("Need " + (_vm.bookingDetails.min_seats -
                                    _vm.bookingDetails.booked_seats) + " Seats to confirm")
                                : ((_vm.bookingDetails.screen_total_seats -
                                    _vm.bookingDetails.booked_seats) + " seats left"))+"\n                          ")])],1):_vm._e(),_vm._v(" "),(_vm.bookingDetails.booking_type_id == 1)?_c('b-progress',{staticClass:"proBar ticket-proBar mb-0",attrs:{"max":parseInt(100)}},[_c('b-progress-bar',{attrs:{"value":parseInt(100)}},[_c('p',{staticClass:"mb-0 succ-text"},[_vm._v("\n                              "+_vm._s(_vm.bookingDetails.booking_type_id == 2
                                  ? ("Need " + (_vm.bookingDetails.min_seats -
                                      _vm.bookingDetails.booked_seats) + " seats to confirm")
                                  : ((_vm.bookingDetails.screen_total_seats -
                                      _vm.bookingDetails.booked_seats) + " seats left"))+"\n                            ")])])],1):_vm._e()],1):(_vm.bookingDetails.booking_type_id == 3)?_c('div',[_c('b-progress',{staticClass:"proBar ticket-proBar bg-warning mb-0",attrs:{"max":parseInt(_vm.bookingDetails.screen_total_seats)}},[_c('b-progress-bar'),_vm._v(" "),_c('p',{staticClass:"mb-0 reqText mx-auto pr-2"},[_vm._v("\n                            Private Screening\n                          ")])],1)],1):_c('div',[_c('b-progress',{staticClass:"proBar ticket-proBar bg-success mb-0",attrs:{"max":parseInt(100)}},[_c('b-progress-bar'),_vm._v(" "),_c('p',{staticClass:"mb-0 reqText mx-auto pr-2"},[_vm._v("\n                            Regular Screening\n                          ")])],1)],1),_vm._v(" "),_c('input',{staticStyle:{"opacity":"0","height":"1px"},attrs:{"type":"text","id":"copyText"},domProps:{"value":_vm.bookingDetails.ShowType != 'Private'
                            ? 'Join me on GoGoCinema to watch ' +
                              _vm.bookingDetails.movie_title +
                              ' at ' +
                              _vm.bookingDetails.cine_name +
                              ' on ' +
                              _vm.bookingDetails.show_date +
                              ' at ' +
                              _vm.timeFormat(_vm.bookingDetails.show_time) +
                              '. Click the below link to join: \n' +
                              _vm.bookingDetails.shortLinkPwa
                            : 'I have booked a private screening on GoGoCinema! Join me to watch ' +
                              _vm.bookingDetails.movie_title +
                              ' at ' +
                              _vm.bookingDetails.cine_name +
                              ' on ' +
                              _vm.bookingDetails.show_date +
                              ' at ' +
                              _vm.timeFormat(_vm.bookingDetails.show_time) +
                              '.'}}),_vm._v(" "),(
                          _vm.bookingDetails.ShowStatusMsg == 'UNCONFIRMED' ||
                          _vm.bookingDetails.ShowStatusMsg == 'CONFIRMED'
                        )?_c('div',[_c('div',{staticClass:"btn-share",attrs:{"id":"tooltip-button"},on:{"click":function($event){return _vm.copyTextShare()}}},[_c('p',{staticStyle:{"cursor":"pointer"}},[_vm._v("Share")])])]):_vm._e(),_vm._v(" "),_c('b-tooltip',{attrs:{"show":_vm.bookingDetails.show,"disabled":true,"target":"tooltip-button","placement":"bottom","variant":"outline-success","custom-class":"tool-tip-cop"}},[_c('strong',[_vm._v("Copied")])])],1)])])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-11 mx-auto mt-3"},[_c('ul',{staticClass:"list-inline"},[_c('li',{staticClass:"list-inline-item mr-md-3"},[_c('p',{staticClass:"mb-1 text-muted"},[_vm._v("Booking Date & Time:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("datetime")(_vm.bookingDetails.transaction_date_time)))])]),_vm._v(" "),_c('li',{staticClass:"list-inline-item mr-md-3"},[_c('p',{staticClass:"mb-1 text-muted"},[_vm._v("Payment Method")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.bookingDetails.pm_payment_mode || "-"))])]),_vm._v(" "),_c('li',{staticClass:"list-inline-item mr-md-3"},[_c('p',{staticClass:"mb-1 text-muted"},[_vm._v("Booking ID")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.bookingDetails.sb_booking_code))])])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 mx-auto px-0 d-block d-lg-none"},[_c('div',{staticClass:"new-mTicket bg-light"},[_c('div',{staticClass:"ticket-info"},[_c('div',{staticClass:"px-3 py-3"},[_c('div',{staticClass:"d-flex align-items-center justify-content-between mb-3"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"text-right"},[_c('p',{staticClass:"pt-2"},[_vm._v("\n                Ticket No :"+_vm._s(_vm.bookingDetails.sb_booking_code)+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 px-0"},[_c('div',{staticClass:"border-bottom pb-2"},[_c('p',{staticClass:"movie-title"},[_vm._v(_vm._s(_vm.bookingDetails.movie_title))]),_vm._v(" "),_c('ul',{staticClass:"list-inline extra-movie-info py-1"},[_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s("300 min"))]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                  "+_vm._s(_vm.bookingDetails.lang_name)+"\n                ")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(_vm.bookingDetails.mf_name))])]),_vm._v(" "),_c('p',{staticClass:"dark-txt"},[_vm._v(_vm._s(_vm.bookingDetails.cine_name))])]),_vm._v(" "),_c('div',{staticClass:"row pt-2"},[_c('div',{staticClass:"col-8"},[_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"light-txt"},[_vm._v("Date :")]),_vm._v(" "),_c('p',{staticClass:"dark-txt"},[_vm._v("\n                    "+_vm._s(_vm._f("moment")(_vm.bookingDetails.show_date))+"\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"light-txt"},[_vm._v("\n                    Seats : - ("+_vm._s(_vm.bookingDetails.seats.join(","))+")\n                  ")]),_vm._v(" "),_c('ul',{staticClass:"list-inline m-ticket-seats"},_vm._l((_vm.bookingDetails.seats),function(item,index){return _c('li',{key:index,staticClass:"list-inline-item"},[_vm._v("\n                      "+_vm._s(item)+"\n                    ")])}),0)])]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"light-txt"},[_vm._v("Time :")]),_vm._v(" "),_c('p',{staticClass:"dark-txt"},[_vm._v("\n                    "+_vm._s(_vm.timeFormat(_vm.bookingDetails.show_time))+"\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"light-txt"},[_vm._v("Screen No.")]),_vm._v(" "),_c('p',{staticClass:"dark-txt"},[_vm._v(_vm._s(_vm.bookingDetails.screen_name))])])])]),_vm._v(" "),_c('div',{staticClass:"row pb-2"},[_c('div',{staticClass:"col-8"},[_c('p',{staticClass:"light-txt mb-1"},[_vm._v("Ticket Price")]),_vm._v(" "),(_vm.bookingDetails.total_tax)?_c('p',{staticClass:"light-txt mb-1"},[_vm._v("\n                  TAX\n                ")]):_vm._e(),_vm._v(" "),(_vm.bookingDetails.internet_handling_fee)?_c('p',{staticClass:"light-txt mb-1"},[_vm._v("\n                  Service Charge\n                ")]):_vm._e(),_vm._v(" "),(_vm.bookingDetails.offer_price)?_c('p',{staticClass:"light-txt mb-1"},[_vm._v("\n                  Discount\n                ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('p',{staticClass:"normal-txt"},[_vm._v("\n                  "+_vm._s(_vm.curr_code)+"\n                  "+_vm._s(_vm.currFormat(_vm.bookingDetails.sb_total_net_amount))+"\n                ")]),_vm._v(" "),(_vm.bookingDetails.total_tax)?_c('p',{staticClass:"normal-txt"},[_vm._v("\n                  "+_vm._s(_vm.curr_code)+"\n                  "+_vm._s(_vm.currFormat(
                      _vm.bookingDetails.sb_total_amount -
                        _vm.bookingDetails.sb_total_net_amount
                    ))+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.bookingDetails.internet_handling_fee)?_c('p',{staticClass:"normal-txt"},[_vm._v("\n                  "+_vm._s(_vm.curr_code)+"\n                  "+_vm._s(_vm.currFormat(_vm.bookingDetails.internet_handling_fee))+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.bookingDetails.offer_price)?_c('p',{staticClass:"normal-txt"},[_vm._v("\n                  "+_vm._s(_vm.curr_code)+" "+_vm._s(_vm.currFormat(_vm.bookingDetails.offer_price))+"\n                ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row border-top pt-2"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('p',{staticClass:"dark-txt"},[_vm._v("\n                  "+_vm._s(_vm.curr_code)+" "+_vm._s(_vm.currFormat(_vm.totalPayableAmount))+"\n                ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"qr-section qr-section pt-3 pb-5"},[_c('div',{staticClass:"pt-3 pb-0 px-3 px-md-4",style:(_vm.bookingDetails.ShowType == 'Private' ? 'margin: 2px 54px;' : '')},[(_vm.bookingDetails.ShowType != 'Private')?_c('div',{staticClass:"pb-1 text-center"},[(_vm.bookingDetails.ConfirmedStatus == false)?_c('p',{staticClass:"mb-0 font-weight-bold",style:(_vm.bookingDetails.ShowStatus == '2' ? 'color:red' : '')},[_vm._v("\n              "+_vm._s(_vm.bookingDetails.ShowStatusMsg)+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.bookingDetails.ConfirmedStatus)?_c('p',{staticClass:"mb-0 font-weight-bold",style:(_vm.bookingDetails.ShowStatus == '3' ? 'color:red' : '')},[_vm._v("\n              "+_vm._s(_vm.bookingDetails.ShowStatusMsg)+"\n            ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.bookingDetails.ShowType != 'Private')?_c('div',[(
                _vm.bookingDetails.ConfirmedStatus == false &&
                _vm.bookingDetails.ShowStatus == '0'
              )?_c('div',{staticClass:"new-progress-bar unconfirmed"},[_c('b-progress',{staticStyle:{"width":"10%"},attrs:{"max":parseInt(_vm.bookingDetails.TotalSeat)}},[_c('b-progress-bar')],1),_vm._v(" "),_c('p',{staticClass:"proBar-text",domProps:{"innerHTML":_vm._s(_vm.bookingDetails.ExpiryMsg)}})],1):_vm._e(),_vm._v(" "),(
                _vm.bookingDetails.ConfirmedStatus &&
                _vm.bookingDetails.ShowStatus == '1'
              )?_c('div',{staticClass:"new-progress-bar confirmed"},[_c('b-progress',{staticStyle:{"width":"100%"},attrs:{"max":parseInt(_vm.bookingDetails.TotalSeat)}},[_c('b-progress-bar')],1),_vm._v(" "),_c('p',{staticClass:"proBar-text",domProps:{"innerHTML":_vm._s(_vm.bookingDetails.ExpiryMsg)}})],1):_vm._e()]):_c('div',{staticClass:"new-progress-bar bg-warning"},[_c('b-progress',{staticStyle:{"width":"0%"},attrs:{"max":parseInt(_vm.bookingDetails.TotalSeat)}},[_c('b-progress-bar')],1),_vm._v(" "),_c('p',{staticClass:"proBar-text"},[_vm._v("Private Screening")])],1)]),_vm._v(" "),_c('div',{staticClass:"align-self-center text-center"},[(_vm.bookingDetails.ShowStatus == '1')?_c('p',{staticClass:"qr-note"},[_vm._v("\n            Use this QR Code to Enter the Cinema\n          ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"py-3"},[_c('img',{staticClass:"img-fluid qr-code",attrs:{"src":_vm.bookingDetails.qrcode,"alt":"'name'","height":"150px","width":"150px"}})]),_vm._v(" "),(
              _vm.bookingDetails.ShowStatusMsg == 'UNCONFIRMED' ||
              _vm.bookingDetails.ShowStatusMsg == 'CONFIRMED'
            )?_c('div',[_c('navigator-share',{staticClass:"btn-share",attrs:{"on-error":_vm.onError,"on-success":_vm.onSuccess,"text":_vm.bookingDetails.ShowType != 'Private'
                  ? 'Join me on GoGoCinema to watch ' +
                    _vm.bookingDetails.Title +
                    ' at ' +
                    _vm.bookingDetails.CinemaName +
                    ' on ' +
                    _vm.bookingDetails.ShowDate +
                    ' at ' +
                    _vm.bookingDetails.ShowTime +
                    '. Click the below link to join: \n' +
                    _vm.bookingDetails.shortLinkPwa
                  : 'I have booked a private screening on GoGoCinema! Join me to watch ' +
                    _vm.bookingDetails.Title +
                    ' at ' +
                    _vm.bookingDetails.CinemaName +
                    ' on ' +
                    _vm.bookingDetails.ShowDate +
                    ' at ' +
                    _vm.bookingDetails.ShowTime +
                    '.'}})],1):_vm._e()])])]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-10 col-lg-6 mx-auto my-5 d-none d-lg-block"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 col-lg-5 col-xl-4 mx-auto text-center"},[_c('router-link',{staticClass:"mt-3 btn btn-danger text-light",attrs:{"to":{
            name: 'Home',
          }}},[_vm._v("Home")])],1)])]),_vm._v(" "),_c('div',{staticClass:"invite-pop"},[_c('b-modal',{ref:"invitemodal",staticClass:"welcome-b header",attrs:{"title":"Invite Friend","id":"invite","hide-footer":""}},[_c('div',{staticClass:"p-4"},[_c('div',{staticClass:"invite-section"},[_c('p',{staticClass:"invite-txt mb-3"},[_vm._v("Send ticket to a friend")]),_vm._v(" "),_c('form',{staticClass:"d-md-flex w-100",attrs:{"data-vv-scope":"inviteFriend"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.friendemail),expression:"friendemail"},{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],staticClass:"form-control py-4 w-100",attrs:{"type":"text","name":"email","placeholder":"Enter Your Friend's Email Address"},domProps:{"value":(_vm.friendemail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.friendemail=$event.target.value}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('inviteFriend.email')),expression:"errors.has('inviteFriend.email')"}],staticClass:"py-1 text-danger font-weight-bold small"},[_vm._v("\n            "+_vm._s(_vm.errors.first("inviteFriend.email"))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"text-danger mt-3 small font-weight-bold"},[_vm._v("\n          "+_vm._s(_vm.errorMessage)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_c('input',{staticClass:"gogo-btn btn btn-danger",attrs:{"type":"submit","value":"Send"},on:{"click":function($event){$event.stopPropagation();return _vm.validateBeforeSubmit('inviteFriend')}}})])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"tTitle mt-3",attrs:{"data-v-23f776d6":""}},[_vm._v("\n        Good News! "),_c('br'),_vm._v("Ticket(s) Booked\n      ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":__webpack_require__(214),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-8"},[_c('p',{staticClass:"light-txt"},[_vm._v("Total")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_failedPayment_vue__ = __webpack_require__(632);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ec5dab2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_failedPayment_vue__ = __webpack_require__(1259);
function injectStyle (ssrContext) {
  __webpack_require__(1258)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6ec5dab2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_failedPayment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ec5dab2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_failedPayment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1258 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"col-12 col-md-8 col-lg-6 my-4 col-xl-4 px-0 px-md-3 mx-auto confirmScreenT"},[_c('div',{staticClass:"text-center"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(1260),"width":"120px"}}),_vm._v(" "),_c('p',{staticClass:"tTitle mt-3"},[_vm._v("Sorry, Your Transaction has failed!")]),_vm._v(" "),_c('router-link',{staticClass:"mt-3 btn btn-danger text-light",attrs:{"to":{
          name: 'Home'
        }}},[_vm._v("Home")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1260 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTM0IiBoZWlnaHQ9IjEzNCIgdmlld0JveD0iMCAwIDEzNCAxMzQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNjcgMTMxQzEwMi4zNDYgMTMxIDEzMSAxMDIuMzQ2IDEzMSA2N0MxMzEgMzEuNjUzOCAxMDIuMzQ2IDMgNjcgM0MzMS42NTM4IDMgMyAzMS42NTM4IDMgNjdDMyAxMDIuMzQ2IDMxLjY1MzggMTMxIDY3IDEzMVoiIHN0cm9rZT0iIzhEOTlBRSIgc3Ryb2tlLXdpZHRoPSI1Ii8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNjcgMTI3QzEwMC4xMzcgMTI3IDEyNyAxMDAuMTM3IDEyNyA2N0MxMjcgMzMuODYyOSAxMDAuMTM3IDcgNjcgN0MzMy44NjI5IDcgNyAzMy44NjI5IDcgNjdDNyAxMDAuMTM3IDMzLjg2MjkgMTI3IDY3IDEyN1oiIHN0cm9rZT0iI0VERjJGNCIgc3Ryb2tlLXdpZHRoPSI3Ii8+CjxwYXRoIGQ9Ik00Mi43OTA3IDQyLjc5MDdDNDUuMTc4NCA0MC40MDMxIDQ5LjA0OTMgNDAuNDAzMSA1MS40MzY5IDQyLjc5MDdMNjcgNTguMzUzOEw4Mi41NjMxIDQyLjc5MDdDODQuOTUwNyA0MC40MDMxIDg4LjgyMTYgNDAuNDAzMSA5MS4yMDkzIDQyLjc5MDdDOTMuNTk2OSA0NS4xNzg0IDkzLjU5NjkgNDkuMDQ5MyA5MS4yMDkzIDUxLjQzNjlMNzUuNjQ2MiA2N0w5MS4yMDkzIDgyLjU2MzFDOTMuNTk2OSA4NC45NTA3IDkzLjU5NjkgODguODIxNyA5MS4yMDkzIDkxLjIwOTRDODguODIxNiA5My41OTY5IDg0Ljk1MDcgOTMuNTk2OSA4Mi41NjMxIDkxLjIwOTJMNjcgNzUuNjQ2MUw1MS40MzY5IDkxLjIwOTRDNDkuMDQ5MyA5My41OTY5IDQ1LjE3ODQgOTMuNTk2OSA0Mi43OTA3IDkxLjIwOTJDNDAuNDAzMSA4OC44MjE3IDQwLjQwMzEgODQuOTUwNyA0Mi43OTA3IDgyLjU2MzFMNTguMzUzOCA2N0w0Mi43OTA3IDUxLjQzNjlDNDAuNDAzMSA0OS4wNDkzIDQwLjQwMzEgNDUuMTc4NCA0Mi43OTA3IDQyLjc5MDdaIiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXIpIi8+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXIiIHgxPSIzMy40NzIiIHkxPSI1OS42MzAyIiB4Mj0iNzAuNzMyMyIgeTI9IjEyNi42ODYiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iI0U3MEQwMCIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNGQTU0MDIiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K"

/***/ }),
/* 1261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_specialScreening_vue__ = __webpack_require__(633);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78a8510b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_specialScreening_vue__ = __webpack_require__(1266);
function injectStyle (ssrContext) {
  __webpack_require__(1262)
  __webpack_require__(1263)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-78a8510b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_specialScreening_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78a8510b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_specialScreening_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1262 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1263 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1264 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar"},[_c('header',{staticClass:"header"},[_c('button',{on:{"click":_vm.previousMonth}},[_vm._v("←")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.currentMonthLabel)+" "+_vm._s(_vm.currentYear))]),_vm._v(" "),_c('button',{on:{"click":_vm.nextMonth}},[_vm._v("→")])]),_vm._v(" "),_vm._l((_vm.dayLabels),function(dayLabel,dayLabelIndex){return _c('div',{key:dayLabelIndex+dayLabel,staticClass:"headings"},[_vm._v("\n    "+_vm._s(dayLabel)+"\n  ")])}),_vm._v(" "),_vm._l((_vm.daysArray),function(day,dateindex){return _c('div',{key:dateindex,staticClass:"day current",class:[_vm.dayClassObj(day), _vm.showDates.indexOf(day.newDate) < 0 ? 'disabled': '']},[_c('button',{key:dateindex,on:{"click":function($event){return _vm.setSelectedDate(day)}}},[_vm._v("\n      "+_vm._s(_vm._f("formatDateToDay")(day.date))+"\n    ")])])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row px-0 px-md-2 my-4 back-txt"},[_c('div',{staticClass:"col-6"},[_c('router-link',{attrs:{"to":"/"}},[_c('span',{staticClass:"mr-1"},[_vm._v("‹")]),_vm._v("Go back to movie list\n      ")])],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 mb-3"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-lg-3 p-3 p-xl-3 cs-scr-ticket h-75 mx-auto mb-5 mb-lg-0"},[_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"col-5 col-md-6 col-xl-5 pr-xl-2 pr-lg-0 pr-1 pl-0 pl-md-2 rounded"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.movieDetails.md_thumbnail_url),expression:"movieDetails.md_thumbnail_url"}],staticClass:"img-fluid",staticStyle:{"border-radius":"7px"}})]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column justify-content-between pl-3"},[_c('div',[_c('p',{staticClass:"mb-1"},[_vm._v(_vm._s(_vm.movieDetails.mc_title))]),_vm._v(" "),_c('ul',{staticClass:"list-inline movie-tickDetails"},[(_vm.movieDetails.mrrdr_runtime)?_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                  "+_vm._s(_vm.movieDetails.mrrdr_runtime)+" mins\n                ")]):_vm._e(),_vm._v(" "),(_vm.movieDetails.mrrdr_release_date_year)?_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                  "+_vm._s(_vm.movieDetails.mrrdr_release_date_year)+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.LangFormat)?_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                  "+_vm._s(_vm.LangFormat)+"\n                ")]):_vm._e()])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"rt-txt2"},[_c('span',{staticClass:"d-block small"},[_vm._v("Rating")]),_vm._v("\n                "+_vm._s(_vm.movieDetails.rating)+"\n              ")])])])]),_vm._v(" "),_c('hr',{staticClass:"topLine my-2"}),_vm._v(" "),_c('div',{class:{ hide: Object.entries(_vm.selectedCinemaObject).length === 0 }},[_c('small',{staticClass:"vCont"},[_vm._v("\n            Cinema:\n            "),_c('router-link',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion1",modifiers:{"accordion1":true}}],staticClass:"hCont",attrs:{"to":"#"},nativeOn:{"click":function($event){return _vm.onChangeCinema()}}},[_vm._v("(Change)")])],1),_vm._v(" "),_c('p',{staticClass:"hCont"},[_vm._v("\n            "+_vm._s(_vm.selectedCinemaObject.cinema_name)+",\n            "+_vm._s(_vm.selectedCinemaObject.cinema_address)+"\n            "+_vm._s(_vm.selectedCinemaObject.cinema_location
                ? (", " + (_vm.selectedCinemaObject.cinema_location))
                : _vm.selectedCinemaObject.cinema_location)+"\n          ")]),_vm._v(" "),_c('small',{staticClass:"vCont"},[_vm._v("\n            Screen:\n            ")]),_vm._v(" "),_c('p',{staticClass:"hCont"},[_vm._v(_vm._s(_vm.ScreenName))])]),_vm._v(" "),_c('div',{class:{ hide: _vm.selectedTime.length === 0 }},[_c('small',{staticClass:"vCont"},[_vm._v("\n            Date & Time:\n            ")]),_vm._v(" "),_c('ul',{staticClass:"list-inline dateTime hCont"},[_c('li',{staticClass:"list-inline-item"},[_vm._v("\n              "+_vm._s(_vm.showDetails.month)+" "+_vm._s(_vm.showDetails.date)+",\n              "+_vm._s(_vm.showDetails.year)+"\n            ")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v("|")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(_vm.timeFormat(_vm.selectedTime)))])])]),_vm._v(" "),_c('div',{class:{ hide: _vm.ScreeningType.length === 0 }},[_c('small',{staticClass:"vCont"},[_vm._v("\n            Screening Type:\n            ")]),_vm._v(" "),_c('p',{staticClass:"hCont"},[_vm._v(_vm._s(_vm.ScreeningType))])]),_vm._v(" "),_c('div',{class:{ hide: _vm.ScreeningType.length === 0 }},[_c('small',{staticClass:"vCont"},[_vm._v("\n           "+_vm._s(_vm.selectedCinemaObject.text_desc)+"\n            ")])]),_vm._v(" "),(_vm.ScreeningType !== 'Private Screening')?_c('div',{class:{ hide: _vm.selectedSeats.length === 0 }},[_c('small',{staticClass:"vCont"},[_vm._v("\n            Pick Seats:\n            ")]),_vm._v(" "),_c('ul',{staticClass:"list-inline seatList"},[_c('li',{staticClass:"list-inline-item"},[_vm._v("\n              "+_vm._s(_vm.pickSeats)+"\n            ")])])]):_vm._e(),_vm._v(" "),(parseInt(_vm.totalAmountPrice) > 0)?_c('div',{staticClass:"amount-box my-4",class:{ hide: this.$store.getters.SELECTED_SEATS.length === 0 }},[_c('div',{staticClass:"ticketAmount"},[_c('div',{staticClass:"d-flex justify-content-between"},[_c('p',[_c('span',[_vm._v("Tickets ("+_vm._s(this.$store.getters.SELECTED_SEATS.length))]),_vm._v(") :\n              ")]),_vm._v(" "),(this.$store.getters.SELECTED_SEATS.length > 0)?_c('p',[_vm._v("\n                "+_vm._s(_vm.curr_code)+" "+_vm._s(_vm.currFormat(_vm.totalNetAmout))+"\n              ")]):_vm._e()]),_vm._v(" "),(_vm.chargeTypeArray && _vm.chargeTypeArray.length > 0)?_c('div',{},_vm._l(([].concat( _vm.chargeTypeArray ).reverse()),function(charge,chargeIndex){return _c('div',{key:chargeIndex,staticClass:"d-flex justify-content-between"},[_c('p',[_vm._v(_vm._s(charge.ct_name)+" :")]),_vm._v(" "),_c('p',[_vm._v("\n                  "+_vm._s(_vm.curr_code)+"\n                  "+_vm._s(_vm.currFormat(charge.tax_amount))+"\n                ")])])}),0):_vm._e(),_vm._v(" "),_c('hr',{staticClass:"bottomLine my-4"})]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between",class:{ hide: this.$store.getters.SELECTED_SEATS.length === 0 }},[_vm._m(0),_vm._v(" "),_c('p',{staticClass:"hCont"},[_vm._v("\n              "+_vm._s(_vm.curr_code)+" "+_vm._s(_vm.currFormat(_vm.totalAmountPrice))+"\n            ")])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-lg-9 px-0 px-lg-3 mb-4 modalCus"},[_c('div',{attrs:{"role":"tablist","id":"scrollToSection"}},[_c('b-card',{staticClass:"mb-1",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"accordion-header",attrs:{"header-tag":"header","role":"tab"}},[_c('div',{staticClass:"d-flex align-items-center header-box"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion1",modifiers:{"accordion1":true}}],staticClass:"py-md-3 pr-5",class:{ active: _vm.collapse1 == true },attrs:{"block":"","href":"#","variant":"transparent"}},[_vm._v("\n                  1. Please Choose A Preferred Cinema\n                  "),(
                      Object.values(_vm.selectedCinemaObject).length > 0 &&
                        _vm.showTick1
                    )?_c('img',{staticClass:"img-fluid ml-2",attrs:{"src":__webpack_require__(56)}}):_vm._e(),_vm._v(" "),(!_vm.collapse1)?_c('span',{staticClass:"check-markIcon"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(21)}})]):(_vm.collapse1)?_c('span',{staticClass:"check-markIcon"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(50)}})]):_vm._e()])],1)]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion1","visible":"","accordion":"my-accordion","role":"tabpanel"}},[_c('b-card-body',[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-6 mb-md-4 mb-3 py-2 px-0 grp-drop"},[_c('b-input-group',[_c('b-button',{staticClass:"pr-1",attrs:{"variant":"default"}},[_c('img',{attrs:{"src":__webpack_require__(295),"height":"19","width":"19"}})]),_vm._v(" "),_c('b-form-input',{staticClass:"pl-1",attrs:{"placeholder":"Search for cinema"},nativeOn:{"keyup":function($event){return _vm.searchData()}},model:{value:(_vm.searchValue),callback:function ($$v) {_vm.searchValue=$$v},expression:"searchValue"}})],1)],1),_vm._v(" "),(_vm.loadingContent == false)?_c('div',{staticClass:"col-12"},[(_vm.loadingContent == false && _vm.CinemaList.length > 0)?_c('ul',{staticClass:"movie-listing-mobile mt-2"},_vm._l((_vm.CinemaList),function(listing,listingKey){return _c('li',{key:listingKey,class:{ active: _vm.selectedCinemaObject === listing },on:{"click":function($event){return _vm.onSelectCinema(listing)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-8 col-md-9 organisation-name"},[_vm._v("\n                          "+_vm._s(listing.cinema_name)+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"col-4 col-md-3 organisation-name align-self-end"},[_c('span',{staticClass:"font-small d-block"},[_vm._v("Starting From")])]),_vm._v(" "),_c('div',{staticClass:"col-8 col-md-9"},[_c('div',{staticClass:"organisation-address"},[_vm._v("\n                            "+_vm._s(listing.cinema_address)+"\n                            "+_vm._s(listing.cinema_location
                                ? (", " + (listing.cinema_location))
                                : listing.cinema_location)+"\n                          ")]),_vm._v(" "),(listing.mf_name.length > 0)?_c('ul',{staticClass:"organisation-features"},_vm._l((listing.mf_name),function(item,index){return _c('li',[_vm._v("\n                              "+_vm._s(item)+"\n                            ")])}),0):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-4 col-md-3"},[_c('div',{staticClass:"organisation-name"},[_c('span',{staticClass:"price"},[_vm._v("\n                              "+_vm._s(_vm.curr_code)+"\n                              "+_vm._s(String(listing.starting_price).split(".")[0])+"."+_vm._s(String(listing.starting_price).split(".")[1]
                                  .length == 1
                                  ? String(listing.starting_price).split(
                                      "."
                                    )[1] + "0"
                                  : String(listing.starting_price).split(
                                      "."
                                    )[1])+"\n                            ")])]),_vm._v(" "),(false)?_c('div',{staticClass:"organisation-distance text-left"},[_vm._v("\n                            "+_vm._s(listing.Distance)+"\n                          ")]):_vm._e()])])])}),0):(
                      _vm.CinemaList.length == 0 && _vm.loadingContent == false
                    )?_c('div',{staticClass:"my-4"},[_c('h5',{staticClass:"text-center"},[_vm._v("No Cinema Found")])]):_vm._e()]):(_vm.loadingContent)?_c('div',{staticClass:"row container-fluid"},[_c('div',{staticClass:"col-12 text-center"},[_c('img',{staticClass:"load-more",attrs:{"src":__webpack_require__(61)}})])]):_vm._e(),_vm._v(" "),(Object.entries(_vm.selectedCinemaObject).length > 0)?_c('div',{staticClass:"d-md-block proceed-btn"},[_c('button',{staticClass:"btn py-md-2 px-md-5",attrs:{"type":"button","name":"","id":"CinemaLink"},on:{"click":function($event){return _vm.fetchShowDates()}}},[_vm._v("\n                    Proceed\n                  ")])]):_vm._e()])],1)],1),_vm._v(" "),_c('b-card',{staticClass:"mb-1",attrs:{"no-body":"","id":"showDateTime"}},[_c('b-card-header',{staticClass:"accordion-header",attrs:{"header-tag":"header","role":"tab"}},[_c('div',{staticClass:"d-flex align-items-center header-box"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion2",modifiers:{"accordion2":true}}],staticClass:"py-md-3",class:_vm.collapse2
                      ? 'active'
                      : Object.values(_vm.selectedCinemaObject).length > 0
                      ? ''
                      : 'disabled',attrs:{"block":"","href":"#","variant":"transparent"}},[_vm._v("\n                  2. Choose Date & Time\n                  "),(_vm.selectedTime.length > 0 && _vm.showTick2)?_c('img',{staticClass:"img-fluid ml-2",attrs:{"src":__webpack_require__(56)}}):_vm._e(),_vm._v(" "),(!_vm.collapse2)?_c('span',{staticClass:"check-markIcon"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(21)}})]):_c('span',{staticClass:"check-markIcon"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(50)}})])])],1)]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion2","accordion":"my-accordion","role":"tabpanel"}},[_c('b-card-body',[_c('div',{staticClass:"p-2"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5 col-xl-5"},[_c('div',{staticClass:"p-1 mb-4 p-xl-3 m-xl-1 calendar-box"},[_c('calendar',{model:{value:(_vm.currentDate),callback:function ($$v) {_vm.currentDate=$$v},expression:"currentDate"}})],1)]),_vm._v(" "),(_vm.ShowTimes.length > 0 && _vm.UniqueKey == false)?_c('div',{staticClass:"col-md-7 col-xl-7"},[_vm._l((_vm.ShowTimes),function(singleShowTime,showtimeIndex){return _c('div',{key:showtimeIndex,staticClass:"movie-timing mb-4"},[_c('div',{},[_c('span',[_vm._v(_vm._s(singleShowTime.version_name.split("(")[0])+" -\n                            ("+_vm._s(singleShowTime.screen_name)+")")])]),_vm._v(" "),_c('hr'),_vm._v(" "),(singleShowTime.schedule_list.length > 0)?_c('div',{staticClass:"timing-box"},[_c('ul',{staticClass:"timing-box-list"},_vm._l((singleShowTime.schedule_list),function(mTime,mT){return _c('li',{key:mT,class:{
                                active: _vm.CinemaTimeScheduleID == mTime
                              },on:{"click":function($event){_vm.setCinemaTimeId(
                                  mTime,
                                  singleShowTime.version_name.split('(')[0]
                                )}}},[_vm._v("\n                              "+_vm._s(_vm.timeFormat(mTime.showTime))+"\n                            ")])}),0)]):_vm._e()])}),_vm._v(" "),(_vm.selectedTime)?_c('div',{staticClass:"proceed-btn ml-md-5 mt-md-3"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion3",modifiers:{"accordion3":true}}],staticClass:"ml-md-4 btn py-md-2 px-md-5",attrs:{"type":"button","name":"","id":""},on:{"click":function($event){return _vm.fetchShowTypes()}}},[_vm._v("\n                          Proceed\n                        ")])]):_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.ShowTimes.length == 0)?_c('div',{staticClass:"col-md-7"},[_vm._v("\n                      No Show Times\n                    ")]):_vm._e()])])])],1)],1),_vm._v(" "),_c('b-card',{staticClass:"mb-1",attrs:{"no-body":"","id":"showScreening"}},[_c('b-card-header',{staticClass:"accordion-header",attrs:{"header-tag":"header","role":"tab"}},[_c('div',{staticClass:"d-flex align-items-center header-box"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion3",modifiers:{"accordion3":true}}],staticClass:"py-md-3",class:_vm.collapse3 == true
                      ? 'active'
                      : Object.values(_vm.ShowTypes).length > 0
                      ? ''
                      : 'disabled',attrs:{"block":"","href":"#","variant":"transparent"}},[_vm._v("\n                  3. Choose Screening Type\n                  "),(_vm.ScreeningType.length > 0 && _vm.showTick3)?_c('img',{staticClass:"img-fluid ml-2",attrs:{"src":__webpack_require__(56)}}):_vm._e(),_vm._v(" "),(!_vm.collapse3)?_c('span',{staticClass:"check-markIcon"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(21)}})]):(_vm.collapse3)?_c('span',{staticClass:"check-markIcon"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(50)}})]):_vm._e()])],1)]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion3","accordion":"my-accordion","role":"tabpanel"}},[_c('b-card-body',[(Object.values(_vm.ShowTypes).length > 0)?_c('div',{staticClass:"row screen-type"},[_vm._l((_vm.ShowTypes),function(singleShow,showIndex){return (
                      singleShow.booking_type_id == '2' 
                    )?_c('div',{key:showIndex,staticClass:"col-md-4 align-items-end mb-3 mb-md-0 order-2 order-md-1"},[_c('div',{staticClass:"d-none overflow-hidden d-md-block"},[_c('div',{staticClass:"p-2 cs-screening h-100 text-center d-flex flex-column justify-content-between py-2 py-md-3 py-lg-5"},[_c('span',{staticClass:"tr-circle"}),_vm._v(" "),_c('span',{staticClass:"tl-circle"}),_vm._v(" "),_c('div',[_c('img',{staticClass:"img-fluid mb-2",attrs:{"src":__webpack_require__(1267)}}),_vm._v(" "),_c('p',{staticClass:"st-title"},[_vm._v("\n                            "+_vm._s(singleShow.screening_name)+"\n                          ")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.screeningMessage(singleShow)))])]),_vm._v(" "),_c('div',{staticClass:"mt-2"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion4",modifiers:{"accordion4":true}}],staticClass:"btn py-md-2 px-lg-4 px-xl-5 bg-info text-white",attrs:{"type":"button","name":"","id":"Crowd"},on:{"click":function($event){return _vm.getSeatLayout(singleShow)}}},[_vm._v("\n                            Book Now\n                          ")])]),_vm._v(" "),_c('span',{staticClass:"bl-circle"}),_vm._v(" "),_c('span',{staticClass:"br-circle"})])]),_vm._v(" "),_c('div',{staticClass:"d-block d-md-none"},[_c('div',{staticClass:"p-2 cs-screening st-mobile"},[_c('span',{staticClass:"tr-circle"}),_vm._v(" "),_c('span',{staticClass:"tl-circle"}),_vm._v(" "),_c('div',{staticClass:"d-flex d-flex justify-content-between align-items-center mt-3"},[_c('div',[_c('p',{staticClass:"st-title float-left ml-2 mt-2"},[_vm._v("\n                              "+_vm._s(singleShow.screening_name)+"\n                              ")])]),_vm._v(" "),_c('div',[_c('img',{attrs:{"src":__webpack_require__(1268),"height":"40"}})])]),_vm._v(" "),_c('p',{staticClass:"px-2 mt-2 st-txt"},[_vm._v("\n                          "+_vm._s(_vm.screeningMessage(singleShow))+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between align-items-center mt-2"},[_c('div'),_vm._v(" "),_c('div',[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion4",modifiers:{"accordion4":true}}],staticClass:"btn py-md-2 px-lg-4 px-xl-5 btn-white",attrs:{"type":"button","name":"","id":"Crowd"},on:{"click":function($event){return _vm.getSeatLayout(singleShow)}}},[_vm._v("\n                              Book Now\n                            ")])])]),_vm._v(" "),_c('span',{staticClass:"bl-circle"}),_vm._v(" "),_c('span',{staticClass:"br-circle"})])])]):_vm._e()}),_vm._v(" "),_vm._l((_vm.ShowTypes),function(singleShow,showIndex){return (
                      singleShow.booking_type_id == '1' &&
                        singleShow.isAvailable
                    )?_c('div',{key:showIndex,staticClass:"col-md-4 mb-3 order-3 order-md-2"},[_c('div',{staticClass:"d-none overflow-hidden d-md-block"},[_c('div',{staticClass:"p-2 confirm-screening h-100 text-center d-flex flex-column justify-content-between py-2 py-md-3 py-lg-5"},[_c('span',{staticClass:"tr-circle"}),_vm._v(" "),_c('span',{staticClass:"tl-circle"}),_vm._v(" "),_c('div',[_c('img',{staticClass:"img-fluid mb-2",attrs:{"src":__webpack_require__(1269)}}),_vm._v(" "),_c('p',{staticClass:"st-title"},[_vm._v("\n                            "+_vm._s(singleShow.screening_name)+"\n                          ")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.screeningMessage(singleShow)))])]),_vm._v(" "),_c('div',{staticClass:"mt-2"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion4",modifiers:{"accordion4":true}}],staticClass:"btn bg-success py-md-2 px-lg-4 px-xl-5 text-white",attrs:{"type":"button","name":"","id":"Confirmed"},on:{"click":function($event){return _vm.getSeatLayout(singleShow)}}},[_vm._v("\n                            Book Now\n                          ")])]),_vm._v(" "),_c('span',{staticClass:"bl-circle"}),_vm._v(" "),_c('span',{staticClass:"br-circle"})])]),_vm._v(" "),_c('div',{staticClass:"d-block d-md-none Confirmed Screening"},[_c('div',{staticClass:"p-2 confirm-screening st-mobile"},[_c('span',{staticClass:"tr-circle"}),_vm._v(" "),_c('span',{staticClass:"tl-circle"}),_vm._v(" "),_c('div',{staticClass:"d-flex d-flex justify-content-between align-items-center mt-3"},[_c('div',[_c('p',{staticClass:"st-title float-left ml-2 mt-2"},[_vm._v("\n                              "+_vm._s(singleShow.screening_name)+"\n                              ")])]),_vm._v(" "),_c('div',[_c('img',{attrs:{"src":__webpack_require__(1270),"height":"40"}})])]),_vm._v(" "),_c('p',{staticClass:"px-2 mt-3 st-txt"},[_vm._v("\n                          "+_vm._s(_vm.screeningMessage(singleShow))+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between align-items-center mt-2"},[_c('div'),_vm._v(" "),_c('div',[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion4",modifiers:{"accordion4":true}}],staticClass:"btn py-md-2 px-lg-4 px-xl-5 mt-3 btn-white",attrs:{"type":"button","name":"","id":"Confirmed"},on:{"click":function($event){return _vm.getSeatLayout(singleShow)}}},[_vm._v("\n                              Book Now\n                            ")])])]),_vm._v(" "),_c('span',{staticClass:"bl-circle"}),_vm._v(" "),_c('span',{staticClass:"br-circle"})])])]):_vm._e()}),_vm._v(" "),_vm._l((_vm.ShowTypes),function(singleShow,showIndex){return (
                      singleShow.booking_type_id == '3' &&
                        singleShow.isAvailable
                    )?_c('div',{key:showIndex,staticClass:"col-md-4 mb-3 order-1 order-md-3"},[_c('div',{staticClass:"d-none overflow-hidden d-md-block"},[_c('div',{staticClass:"p-2 private-screening h-100 text-center d-flex flex-column justify-content-between py-2 py-md-3 py-lg-5"},[_c('span',{staticClass:"tr-circle"}),_vm._v(" "),_c('span',{staticClass:"tl-circle"}),_vm._v(" "),_c('div',[_c('img',{staticClass:"img-fluid mb-2",attrs:{"src":__webpack_require__(636)}}),_vm._v(" "),_c('p',{staticClass:"st-title"},[_vm._v("\n                            "+_vm._s(singleShow.screening_name)+"\n                          ")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.screeningMessage(singleShow))+".")]),_vm._v(" "),_c('p',{staticClass:"st-title"},[_vm._v("\n                            "+_vm._s(_vm.curr_code)+"\n                            "+_vm._s(_vm.currFormat(singleShow.amount))+"\n                          ")]),_vm._v(" "),_c('p',[_vm._v("\n                            "+_vm._s(singleShow.screen_total_seats)+" Seats (Free\n                            Seating)\n                          ")]),_vm._v(" "),_c('p',[_vm._v("\n                            "+_vm._s(singleShow.cinema_desc)+" \n                          ")])]),_vm._v(" "),_c('div',{staticClass:"mt-2 d-none d-md-block"},[_c('button',{staticClass:"btn py-md-2 px-lg-4 px-xl-5 bg-warning text-white",attrs:{"type":"button","name":"","id":"Private"},on:{"click":function($event){return _vm.getSeatLayout(singleShow)}}},[_vm._v("\n                            Book Now\n                          ")])]),_vm._v(" "),_c('span',{staticClass:"bl-circle"}),_vm._v(" "),_c('span',{staticClass:"br-circle"})])]),_vm._v(" "),_c('div',{staticClass:"d-block d-md-none"},[_c('div',{staticClass:"p-2 private-screening st-mobile"},[_c('span',{staticClass:"tr-circle"}),_vm._v(" "),_c('span',{staticClass:"tl-circle"}),_vm._v(" "),_c('div',{staticClass:"d-flex d-flex justify-content-between align-items-center mt-3"},[_c('div',[_c('p',{staticClass:"st-title float-left ml-2 mt-2"},[_vm._v("\n                              "+_vm._s(singleShow.screening_name)+"\n                              "),_c('img',{staticClass:"ml-1",attrs:{"src":__webpack_require__(636),"width":"18"}})])]),_vm._v(" "),_c('div',[_c('img',{attrs:{"src":__webpack_require__(1271),"height":"40"}})])]),_vm._v(" "),_c('p',{staticClass:"px-2 mt-2 mb-0 st-txt"},[_vm._v("\n                          "+_vm._s(_vm.screeningMessage(singleShow))+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center justify-content-between mt-2"},[_c('div',[_c('p',{staticClass:"px-2 st-txt"},[_vm._v("\n                              "+_vm._s(singleShow.screen_total_seats)+" Seats (Free\n                              Seating)\n                            ")])]),_vm._v(" "),_c('div',[_c('button',{staticClass:"btn py-md-2 px-lg-4 px-xl-5 btn-white",attrs:{"type":"button","name":"","id":"Private"},on:{"click":function($event){return _vm.getSeatLayout(singleShow)}}},[_vm._v("\n                              Book Now\n                            ")])])]),_vm._v(" "),_c('span',{staticClass:"bl-circle"}),_vm._v(" "),_c('span',{staticClass:"br-circle"})])])]):_vm._e()})],2):(_vm.loadingShowType)?_c('div',[_c('div',{staticClass:"col-12 text-center"},[_c('img',{staticClass:"load-more",attrs:{"src":__webpack_require__(61)}})])]):_vm._e()])],1)],1),_vm._v(" "),_c('b-card',{staticClass:"seat-selection mb-1",attrs:{"no-body":"","id":"seatScreen"}},[_c('b-card-header',{staticClass:"accordion-header",attrs:{"header-tag":"header","role":"tab"}},[_c('div',{staticClass:"d-flex align-items-center header-box"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion4",modifiers:{"accordion4":true}}],staticClass:"py-md-3",class:_vm.collapse4 == true
                      ? 'active'
                      : _vm.ScreeningType.length > 0
                      ? ''
                      : 'disabled',attrs:{"block":"","href":"#","variant":"transparent"}},[_vm._v("\n                  4. Pick Seats\n                  "),(_vm.showProceedToPayment)?_c('img',{staticClass:"img-fluid ml-2",attrs:{"src":__webpack_require__(56)}}):_vm._e(),_vm._v(" "),(!_vm.collapse4)?_c('span',{staticClass:"check-markIcon"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(21)}})]):(_vm.collapse4)?_c('span',{staticClass:"check-markIcon"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(50)}})]):_vm._e()])],1)]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion4","accordion":"my-accordion","role":"tabpanel"}},[_c('b-card-body',[_c('div',{staticClass:"col-12 mx-auto text-center px-0"},[_c('div',{staticClass:"text-center"},[_c('img',{staticClass:"img-fluid d-none d-md-block mx-auto",attrs:{"src":__webpack_require__(617)}}),_vm._v(" "),_c('img',{staticClass:"mob-img-fluid d-md-none",attrs:{"src":__webpack_require__(618)}})]),_vm._v(" "),_c('div',{staticClass:"seat-count mt-0 mb-4 my-md-4"},[(_vm.totalNumberOfSeats == 0)?_c('p',{staticClass:"text-center mt-3"},[_vm._v("\n                      HOW MANY SEATS?\n                    ")]):_vm._e(),_vm._v(" "),(
                        _vm.totalNumberOfSeats !== 0 && _vm.totalNumberOfSeats == 1
                      )?_c('p',{staticClass:"text-center mt-3"},[_vm._v("\n                      Selected :\n                      "),_c('span',[_vm._v(_vm._s(this.$store.getters.SELECTED_SEATS.length)+" /\n                        "+_vm._s(_vm.totalNumberOfSeats)+" Seat")]),_vm._v("  \n                      "),_c('span',{staticClass:"edit-class",on:{"click":function($event){return _vm.onEdit()}}},[_vm._v("(Edit)")])]):_vm._e(),_vm._v(" "),(
                        _vm.totalNumberOfSeats !== 0 && _vm.totalNumberOfSeats != 1
                      )?_c('p',{staticClass:"text-center mt-3"},[_vm._v("\n                      Selected :\n                      "),(_vm.createSchedulePayload.booking_type_id == 1)?_c('span',[_vm._v(_vm._s(this.$store.getters.SELECTED_SEATS.length)+" seats\n                        "+_vm._s(this.createSchedulePayload["booking_type_id"] == 1
                            ? ("(Minimum " + _vm.totalNumberOfSeats + " Seats )")
                            : ""))]):_c('span',[_vm._v(_vm._s(this.$store.getters.SELECTED_SEATS.length)+" /\n                        "+_vm._s(_vm.totalNumberOfSeats)+"\n                        Seats ")]),_vm._v("  \n                      "),_c('span',{staticClass:"edit-class",on:{"click":function($event){return _vm.onEdit()}}},[_vm._v("(Edit)")])]):_vm._e(),_vm._v(" "),_c('ul',{staticClass:"list-inline pick-seats mt-4"},_vm._l((8),function(number,a){return (_vm.totalNumberOfSeats == 0)?_c('li',{key:a,staticClass:"list-inline-item",class:{ active: number == _vm.totalNumberOfSeats },on:{"click":function($event){return _vm.editNumberOfSeats(number)}}},[_vm._v("\n                        "+_vm._s(number)+"\n                      ")]):_vm._e()}),0)]),_vm._v(" "),_c('div',{staticClass:"seat-layout table-responsive"},_vm._l((_vm.seatType),function(singleSeatLayout,seatIndex){return (_vm.totalNumberOfSeats > 0 && _vm.seatType.length > 0)?_c('div',{key:seatIndex,staticClass:"mx-auto text-center"},[(singleSeatLayout.seatsFinal.length > 0)?_c('div',{staticClass:"mt-4 mb-2 seat-formatTxt"},[_c('div',{staticClass:"seat-catg screen-class",staticStyle:{"margin-top":"10px"}},[_c('div',[_vm._v("("+_vm._s(singleSeatLayout.seatType)+")")]),_vm._v(" "),_c('div',[_vm._v("\n                            Ticket Price : "+_vm._s(_vm.curr_code)+"\n                            "+_vm._s(_vm.currFormat(singleSeatLayout.seat_net_price) ||
                                _vm.currFormat(singleSeatLayout.seat_price))+"\n                          ")])])]):_vm._e(),_vm._v(" "),_c('table',{staticClass:"mx-auto seat-table"},_vm._l((singleSeatLayout.seatsFinal),function(seatArray,seatRowIndex){return _c('tr',{key:seatRowIndex},[_c('td',{staticClass:"px-3 mt-2"},[_vm._v("\n                            "+_vm._s(seatArray.filter(function (x) { return x.sl_seat_name != ""; })
                                .length > 0
                                ? seatArray
                                    .filter(function (x) { return x.sl_seat_name != ""; })[0]
                                    .sl_seat_name.replace(/[0-9]/g, "")
                                : "")+"\n                          ")]),_vm._v(" "),_vm._l((seatArray),function(singleSeat,singleSeatIndex){return _c('td',{key:singleSeatIndex},[(singleSeat.srt_id == 2)?_c('div',{staticClass:"hide py-2"}):_c('div',{class:singleSeat.selectStatus == true
                                  ? singleSeat.srt_id == 3
                                    ? 'wheel active'
                                    : 'seat active'
                                  : singleSeat.seat_reserve_type_id == 1
                                  ? 'seat'
                                  : singleSeat.seat_reserve_type_id == 3
                                  ? 'wheel'
                                  : singleSeat.seat_reserve_type_id == 6
                                  ? 'seat'
                                  : singleSeat.seat_reserve_type_id == 7
                                  ? 'seat'
                                  : singleSeat.seat_reserve_type_id == 8
                                  ? singleSeat.srt_id == 3
                                    ? 'wheel disabled seat'
                                    : 'seat disabled'
                                  : singleSeat.seat_reserve_type_id == 9
                                  ? 'seat disabled'
                                  : singleSeat.seat_reserve_type_id == 10
                                  ? 'seat'
                                  : singleSeat.seat_reserve_type_id == 11
                                  ? 'seat'
                                  : singleSeat.seat_reserve_type_id == 12
                                  ? 'seat disabled'
                                  : singleSeat.seat_reserve_type_id == 13
                                  ? 'seat disabled'
                                  : 'seat',on:{"click":function ($event) {
                                  if (_vm.checkSelectedSeats(singleSeat)) {
                                    _vm.handlerSeatSelected(
                                      singleSeat,
                                      seatRowIndex,
                                      singleSeatIndex,
                                      null,
                                      null,
                                      $event,
                                      seatIndex
                                    );
                                    _vm.seatsSelectedRateGroup();
                                  }
                                }}})])}),_vm._v(" "),_c('td',{staticClass:"px-3 mt-2"},[_vm._v("\n                            "+_vm._s(seatArray.filter(function (x) { return x.sl_seat_name != ""; })
                                .length > 0
                                ? seatArray
                                    .filter(function (x) { return x.sl_seat_name != ""; })[0]
                                    .sl_seat_name.replace(/[0-9]/g, "")
                                : "")+"\n                          ")])],2)}),0)]):_vm._e()}),0),_vm._v(" "),_c('ul',{staticClass:"list-inline seat-info my-4 my-md-5"},[_c('li',{staticClass:"list-inline-item"},[_c('img',{staticClass:"pb-1 mr-2",attrs:{"src":__webpack_require__(619)}}),_vm._v("Available\n                    ")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_c('img',{staticClass:"pb-1 mr-2",attrs:{"src":__webpack_require__(620)}}),_vm._v("Unavailable\n                    ")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_c('img',{staticClass:"pb-1 mr-2",staticStyle:{"width":"17px"},attrs:{"src":__webpack_require__(621)}}),_vm._v("Wheelchair\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"text-danger my-2"}),_vm._v(" "),_c('router-link',{attrs:{"to":""},nativeOn:{"click":function($event){return _vm.setBookingSeats()}}},[(
                        this.$store.getters.SELECTED_SEATS.length > 0 &&
                          this.$store.getters.SELECTED_SEATS.length >=
                            _vm.totalNumberOfSeats
                      )?_c('div',{staticClass:"proceed-btn"},[_c('button',{staticClass:"btn btn-danger py-md-2 px-md-4 my-3",attrs:{"type":"button","name":"","id":""}},[_vm._v("\n                        Confirm\n                      ")])]):_vm._e()])],1)])],1)],1)],1),_vm._v(" "),(_vm.showProceedToPayment)?_c('div',{staticClass:"col-12 col-md-9 col-xl-6 text-center mx-auto mt-5"},[_c('div',{staticClass:"d-flex flex-column justify-content-between"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"d-md-block proceed-btn"},[_c('div',{staticClass:"text-danger my-2"},[_vm._v(_vm._s(_vm.showMessage))]),_vm._v(" "),_c('router-link',{attrs:{"to":""},nativeOn:{"click":function($event){return _vm.setBookingSeats()}}},[_c('button',{staticClass:"btn py-md-2 px-md-5",attrs:{"type":"button","name":"","id":""}},[_vm._v("\n                  Proceed to Payment\n                ")])])],1),_vm._v(" "),_vm._m(2)])]):_vm._e(),_vm._v(" "),_c('b-modal',{ref:"SeatRealeased",staticClass:"text-center",attrs:{"no-close-on-esc":"","no-close-on-backdrop":"","hide-header-close":"","hide-footer":"","id":"minimumPayment","title":"FAILED !"}},[_c('div',{staticClass:"p-5"},[_c('div',{staticClass:"text-center mt-3 mt-md-0"},[_vm._v(_vm._s(_vm.showMessage))]),_vm._v(" "),_c('b-button',{staticClass:"w-50 mx-auto gogo-btn btn btn-danger mt-3 d-flex justify-content-center align-items-center",on:{"click":_vm.hideModal}},[_vm._v("Go Back")])],1)]),_vm._v(" "),_c('div',{staticClass:"verify-c"},[_c('b-modal',{ref:"WheelChairModal",staticClass:"text-center",attrs:{"hide-footer":"","no-close-on-esc":"","no-close-on-backdrop":"","hide-header-close":"","id":"WheelChairModal","title":"Wheel Chair"}},[_c('div',{staticClass:"p-5"},[_c('div',{staticClass:"text-center mb-3"},[_c('img',{attrs:{"width":"47","height":"auto","src":__webpack_require__(622)}})]),_vm._v(" "),_c('div',{staticClass:"text-center mt-3 mt-md-0 font-weight-bold"},[_vm._v("\n                Notice\n              ")]),_vm._v(" "),_c('div',{staticClass:"text-center mt-3 mt-md-0"},[_vm._v("\n                You have selected a wheelchair space which is for wheelchair\n                user only.\n              ")]),_vm._v(" "),_c('b-button',{staticClass:"w-50 mx-auto gogo-btn btn btn-danger mt-3 d-flex justify-content-center align-items-center",on:{"click":function($event){return _vm.onClickOk()}}},[_vm._v("OK")])],1)]),_vm._v(" "),_c('b-modal',{ref:"showRateCard",attrs:{"hide-footer":"","hide-header":"","id":"showRateCard","title":"Show Rate Card","size":"lg"}},[_c('div',{staticClass:"container px-2 px-md-3"},[_c('div',{staticClass:"select-seat-container-myticket"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mx-auto"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 py-3 bg-light rounded"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-4"},[_c('strong',[_vm._v("TICKET ")])]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('strong',[_vm._v(" PRICE ")])]),_vm._v(" "),_c('div',{staticClass:"col-5"},[_c('strong',[_vm._v("No of Seats ")])])])]),_vm._v(" "),_vm._l((_vm.seatsSelectedRateGroupNew),function(item,index){return (_vm.seatsSelectedRateGroupNew)?_c('div',{key:index,staticClass:"col-12 py-2 border-bottom"},[_c('div',{staticClass:"st-name"},[_vm._v(_vm._s(item.srt_name))]),_vm._v(" "),_c('div',{staticClass:"row align-self-center"},[_vm._l((item.rate_card_group),function(rg,rg_index){return _c('div',{staticClass:"col-12 row my-2 p-0"},[_c('div',{staticClass:"col-4 align-self-center",staticStyle:{"line-break":"anywhere"}},[_c('strong',[_vm._v("\n                              "+_vm._s(rg.tt_name)+"\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"col-3 align-self-center"},[_c('strong',[_vm._v("\n                              "+_vm._s(_vm.curr_code)+"\n                              "+_vm._s(_vm.currFormat(rg.rc_total_amount))+"\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"col-5"},[_c('div',{staticClass:"d-flex align-items-center justify-content-center w-100 h-100"},[_c('button',{staticClass:"cursor-pointer btn-subtract-myticket",class:rg.totalSeatSelected == 0 ? 'disabled' : '',on:{"click":function($event){return _vm.totalCount(rg, index, rg_index, 'decrement')}}},[_vm._v("\n                                -\n                              ")]),_vm._v(" "),_c('strong',{staticClass:"w-100px"},[_vm._v(_vm._s(rg.totalSeatSelected))]),_vm._v(" "),_c('button',{staticClass:"cursor-pointer btn-add-myticket",class:item.totalSelected == item.AllSeats.length
                                    ? 'disabled'
                                    : '',on:{"click":function($event){return _vm.totalCount(rg, index, rg_index, 'increment')}}},[_vm._v("\n                                +\n                              ")])])])])}),_vm._v(" "),_c('div',{staticClass:"col-12 py-3 bg-light rounded"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-4"},[_c('strong',[_vm._v("Total Seat Selected")])]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('strong')]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('strong',[_vm._v(_vm._s(item.totalSelected)+"/"+_vm._s(item.AllSeats.length))])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 py-3 my-2 bg-light rounded"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-4"},[_c('strong',[_vm._v("Total Amount")])]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('strong')]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('strong',[_vm._v(_vm._s(_vm.curr_code)+"\n                                "+_vm._s(_vm.currFormat(_vm.totalAmountPrice)))])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 py-4"},[_c('button',{staticClass:"btn btn-danger py-2 px-5 mt-3",attrs:{"disabled":_vm.errorMessage ? true : false},on:{"click":_vm.onSubmitFromRateCardModal}},[_vm._v("\n                            Proceed\n                          ")])])],2)]):_vm._e()})],2)])])])])],1)],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"mb-0 vCont"},[_vm._v("\n                Total Amount Payable :\n                ")]),_vm._v(" "),_c('small',{staticClass:"vCont"},[_vm._v("(Amount inclusive of all service fees and taxes)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-4"},[_c('img',{attrs:{"src":__webpack_require__(1272),"claas":"img-fluid"}}),_vm._v(" "),_c('p',{staticClass:"at-text pt-3"},[_vm._v("\n                Almost there! Just one last thing before\n                "),_c('br'),_vm._v("your screening is created!\n              ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(1273)}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1267 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1268 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1269 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1270 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1271 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icons-movie.c2854d5.svg";

/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bg-gogo.cf9a5aa.svg";

/***/ }),
/* 1274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_regularMovies_vue__ = __webpack_require__(637);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a3fd57b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_regularMovies_vue__ = __webpack_require__(1280);
function injectStyle (ssrContext) {
  __webpack_require__(1275)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_regularMovies_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a3fd57b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_regularMovies_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1275 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',[_c('div',{staticClass:"container-fluid px-0"},[_c('div',{staticClass:"movieDetailBanner d-none d-md-block",style:({
          background:
            'linear-gradient(1.01deg, rgba(0, 0, 0, 0.71) 8.89%, rgba(0, 0, 0, 0) 97.25%), linear-gradient(358.63deg, rgba(0, 0, 0, 0.71) 40.97%, rgba(0, 0, 0, 0) 97.07%), url(' +
            _vm.movieDetails.BannerImage1 +
            ')'
        })},[_c('a',{staticClass:"play-icon",attrs:{"href":'https://www.youtube.com/watch?v=' + _vm.movieDetails.Trailer,"data-fancybox":""}},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(215)}})]),_vm._v(" "),_c('div',{staticClass:"banner-content w-100 py-3 py-xl-4"},[_c('div',{staticClass:"d-md-flex align-items-center pl-md-5"},[_c('div',{staticClass:"movieDetails text-white mb-0 mb-lg-3"},[_c('p',{staticClass:"mTitle"},[_vm._v(_vm._s(_vm.movieDetails.Name))]),_vm._v(" "),_c('ul',{staticClass:"list-inline mInfo"},[_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(_vm.movieDetails.Lang))]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(_vm.movieDetails.Runtime))]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(_vm.movieDetails.Year))]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(_vm.movieDetails.Rated))])])])]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center pl-3 pl-md-5"},[_c('div',{staticClass:"mr-3"},[_c('p',{staticClass:"small mb-1 text-white"},[_vm._v("IMDB")]),_vm._v(" "),_c('ul',{staticClass:"list-inline imdb mb-0"},[_c('li',{staticClass:"list-inline-item mx-0"},[_vm._v("\n                  "+_vm._s(_vm.movieDetails.IMDBRating)+"\n                ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"movieDetailBanner d-block d-md-none",style:({
          background:
            'linear-gradient(1.01deg, rgba(0, 0, 0, 0.71) 8.89%, rgba(0, 0, 0, 0) 97.25%), linear-gradient(358.63deg, rgba(0, 0, 0, 0.71) 40.97%, rgba(0, 0, 0, 0) 97.07%), url(' +
            _vm.movieDetails.BannerImage +
            ')'
        })},[_c('a',{staticClass:"play-icon",attrs:{"href":'https://www.youtube.com/watch?v=' + _vm.movieDetails.Trailer,"data-fancybox":""}},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(215)}})]),_vm._v(" "),_c('div',{staticClass:"banner-content w-100 py-2 py-xl-4"},[_c('div',{staticClass:"d-md-flex align-items-center text-center text-md-left pl-xl-5"},[_c('div',{staticClass:"movieDetails text-white mb-3"},[_c('p',{staticClass:"mTitle"},[_vm._v(_vm._s(_vm.movieDetails.Name))]),_vm._v(" "),_c('ul',{staticClass:"list-inline mInfo"},[_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(_vm.movieDetails.Lang))]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(_vm.movieDetails.Runtime))]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(_vm.movieDetails.Year))]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(_vm.movieDetails.Rated))])])])]),_vm._v(" "),_c('div',{staticClass:"d-md-flex align-items-center text-center text-md-left pl-xl-5"},[_c('div',{staticClass:"text-center text-md-left"},[_c('p',{staticClass:"small mb-1 text-white"},[_vm._v("IMDB")]),_vm._v(" "),_c('ul',{staticClass:"list-inline imdb mb-0"},[_c('li',{staticClass:"list-inline-item mx-0"},[_vm._v("\n                  "+_vm._s(_vm.movieDetails.IMDBRating)+"\n                ")])])])])])])])]),_vm._v(" "),_c('section',{staticClass:"bg-light py-4 py-md-5"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 pl-3 pl-xl-4"},[_c('Slick',{ref:"dateSlider",attrs:{"options":_vm.dateTimeSlider}},_vm._l((_vm.ShowDates),function(singleDate,dateKey){return _c('div',{key:dateKey},[_c('div',{staticClass:"dtSlider-container"},[_c('div',{staticClass:"dt-box",class:{ active: _vm.selectedDate == singleDate },on:{"click":function($event){return _vm.onSelectDate(singleDate)}}},[_c('p',{staticClass:"month"},[_vm._v(_vm._s(singleDate.month))]),_vm._v(" "),_c('p',{staticClass:"date"},[_vm._v(_vm._s(singleDate.date))]),_vm._v(" "),_c('p',{staticClass:"day"},[_vm._v(_vm._s(singleDate.day))])])])])}),0)],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 text-md-right movieDetails-drop mt-3 pt-md-0"},[_c('b-dropdown',{staticClass:"m-2",attrs:{"id":"ddown-left","text":'Show type: ' + _vm.selectedShowType,"variant":"default"}},[_c('b-dropdown-item',{on:{"click":function($event){return _vm.onSelectShowType('All')}}},[_vm._v("All")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){return _vm.onSelectShowType('Morning')}}},[_vm._v("Morning")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){return _vm.onSelectShowType('Afternoon')}}},[_vm._v("Afternoon")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){return _vm.onSelectShowType('Evening')}}},[_vm._v("Evening")])],1)],1)])])]),_vm._v(" "),_c('section',[(Object.values(_vm.ShowTimes).length > 0)?_c('div',{staticClass:"container-fluid my-4 my-md-5"},_vm._l((_vm.CinemaList),function(singleCinema,cinemaKey){return _c('div',{key:cinemaKey,staticClass:"mb-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 pl-3 pl-xl-5"},[_c('p',{staticClass:"mb-0 movieTheatreTitles"},[_vm._v("\n              "+_vm._s(singleCinema.CinemaName)+"\n            ")]),_vm._v(" "),_c('p',{staticClass:"movieTheatreAdd"},[_vm._v(_vm._s(singleCinema.Address))])]),_vm._v(" "),_c('div',{staticClass:"col-md-9"},_vm._l((_vm.ShowTimes),function(singleShowTime,showtimeIndex){return (singleShowTime.length > 0)?_c('div',{key:showtimeIndex,staticClass:"movie-timing"},[_c('div',{staticClass:"m-format redRightLine"},[_c('span',[_vm._v(_vm._s(singleShowTime[0].Format))])]),_vm._v(" "),_c('div',{staticClass:"timing-box"},[_c('ul',{staticClass:"timing-box-list"},[_c('router-link',{attrs:{"to":{
                      name: 'seatLayout',
                      params: {
                        movieId: _vm.MovieID,
                        categoryId: _vm.CategoryID,
                        cinemaScheduleId: _vm.CinemaTimeScheduleID
                      }
                    }}},_vm._l((singleShowTime),function(mTime,mT){return _c('li',{key:mT,class:{ active: _vm.selectedTime == mTime.CinemaTimings },on:{"click":function($event){return _vm.setCinemaTimeId(mTime)}}},[_vm._v("\n                      "+_vm._s(mTime.CinemaTimings)+"\n                    ")])}),0)],1)])]):_vm._e()}),0),_vm._v(" "),_vm._l((_vm.ShowTimes),function(singleShowTime,showtimeIndex){return (singleShowTime.length == 0)?_c('div',{key:showtimeIndex,staticStyle:{"margin-left":"50px"}},[_vm._v("\n            No show time\n          ")]):_vm._e()})],2),_vm._v(" "),_c('hr',{staticClass:"bottomRedLine"})])}),0):_vm._e(),_vm._v(" "),(Object.values(_vm.ShowTimes).length == 0)?_c('div',{staticClass:"my-5 text-center h3",staticStyle:{"font-weight":"bold"}},[_vm._v("\n      No Show Timings Found\n    ")]):_vm._e()]),_vm._v(" "),_c('section',{staticClass:"bg-light py-5 py-md-4"},[_c('div',{staticClass:"container-fluid my-md-4 storylineSection"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 pl-3 pl-xl-5"},[_c('p',{staticClass:"pb-2 sTitle"},[_vm._v("Storyline")]),_vm._v(" "),_c('p',{staticClass:"sText"},[_vm._v(_vm._s(_vm.movieDetails.StoryLine))])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 text-left text-md-center"},[_c('p',{staticClass:"pb-2 sTitle"},[_vm._v("Director")]),_vm._v(" "),_c('ul',{staticClass:"list-inline sList mb-0"},_vm._l((_vm.movieDetails.Directors),function(director,directorKey){return _c('li',{key:directorKey,staticClass:"list-inline-item text-center"},[_c('img',{staticClass:"img-fluid rounded-circle",attrs:{"src":director.Image}}),_vm._v(" "),_c('p',{staticClass:"mb-0 sName"},[_vm._v(_vm._s(director.Name))])])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('p',{staticClass:"pb-2 sTitle"},[_vm._v("Cast")]),_vm._v(" "),_c('ul',{staticClass:"list-inline sList mb-0"},_vm._l((_vm.movieDetails.Actors),function(actor,actorKey1){return _c('li',{key:actorKey1,staticClass:"text-center"},[_c('img',{staticClass:"img-fluid rounded-circle",attrs:{"src":actor.Image}}),_vm._v(" "),_c('p',{staticClass:"mb-0 sName"},[_vm._v(_vm._s(actor.Name))])])}),0)])])])])])]),_vm._v(" "),_c('section',[_c('div',{staticClass:"container-fluid my-4"},[_c('OwnScreening')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_searchResultCinema_vue__ = __webpack_require__(638);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_803d918c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_searchResultCinema_vue__ = __webpack_require__(1283);
function injectStyle (ssrContext) {
  __webpack_require__(1282)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_searchResultCinema_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_803d918c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_searchResultCinema_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1282 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"bg-light py-5"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 pl-3 pl-xl-4"},[_c('Slick',{attrs:{"options":_vm.dateTimeSlider}},_vm._l((20),function(ssImg,ssImages){return _c('div',{key:ssImages},[_c('div',{staticClass:"dtSlider-container"},[_c('div',{staticClass:"dt-box"},[_c('p',{staticClass:"month"},[_vm._v("Sep")]),_vm._v(" "),_c('p',{staticClass:"date"},[_vm._v("05")]),_vm._v(" "),_c('p',{staticClass:"day"},[_vm._v("Wed")])])])])}),0)],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 text-md-right movieDetails-drop d-none"},[_c('b-dropdown',{staticClass:"m-2",attrs:{"id":"ddown-left","text":"Show Type: All","variant":"default"}},[_c('b-dropdown-item',{attrs:{"href":"#"}},[_vm._v("Action")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"}},[_vm._v("Another action")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"}},[_vm._v("Something else here")])],1),_vm._v(" "),_c('b-dropdown',{staticClass:"m-2",attrs:{"id":"ddown-right","right":"","text":"Filter By (Price, Show time)","variant":"default"}},[_c('b-dropdown-item',{attrs:{"href":"#"}},[_vm._v("Action")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"}},[_vm._v("Another action")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"}},[_vm._v("Something else here")])],1)],1)])])]),_vm._v(" "),_c('section',[_c('div',{staticClass:"container-fluid my-5"},_vm._l((2),function(showTime,st){return _c('div',{key:st,staticClass:"mb-4"},[_c('div',{staticClass:"row"},[_vm._m(1,true),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('div',{staticClass:"movie-timing"},[_vm._m(2,true),_vm._v(" "),_c('div',{staticClass:"timing-box"},[_c('ul',{staticClass:"timing-box-list"},_vm._l((15),function(mTime,mT){return _c('li',{key:mT},[_vm._v("\n                     09.00 AM\n                   ")])}),0)])])])]),_vm._v(" "),_c('hr',{staticClass:"bottomRedLine grey"})])}),0)]),_vm._v(" "),_c('section',{staticClass:"bg-light py-5"},[_c('div',{staticClass:"container-fluid my-4 csCusSlider"},[_c('Slick',{attrs:{"options":_vm.movieSlider}},[_vm._l((2),function(ssImg,ssImages){return _c('div',{key:ssImages},[_c('div',{staticClass:"movieSlider-container mx-auto text-center"},[_c('div',{staticClass:"img-container"},[_c('router-link',{attrs:{"to":""}},[_c('img',{staticClass:"img-fluid mx-auto banner",attrs:{"src":__webpack_require__(639),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"img-text py-2"},[_c('p',{staticClass:"mb-0"},[_c('span',[_vm._v("3")]),_vm._v(" Screenings")])])],1),_vm._v(" "),_c('div',{staticClass:"text-center mx-auto pt-3 movieSliderInfo"},[_c('p',{staticClass:"mb-0 title"},[_vm._v("Johnny English Strikes")]),_vm._v(" "),_c('ul',{staticClass:"list-inline mb-0 mInfo"},[_c('li',{staticClass:"list-inline-item"},[_vm._v("2018")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v("|")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v("PG13")])])])])])}),_vm._v(" "),_c('div',[_c('div',{staticClass:"movieSlider-container mx-auto text-center"},[_c('div',{staticClass:"addSlide-container"},[_c('router-link',{attrs:{"to":""}},[_c('img',{staticClass:"img-fluid mx-auto",attrs:{"src":__webpack_require__(639),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"addSlide"},[_c('span',[_c('img',{staticClass:"img-fluid addImg",attrs:{"src":__webpack_require__(1284)}})]),_vm._v(" "),_c('p',{staticClass:"mb-0 pt-2"},[_vm._v("Create Your Own Screening")])])],1)])])],2)],1)]),_vm._v(" "),_c('section',[_c('div',{staticClass:"container-fluid my-4"},[_c('NowShowing')],1)]),_vm._v(" "),_c('section',[_c('div',{staticClass:"container-fluid my-4"},[_c('OwnScreening')],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"container-fluid my-5"},[_c('div',{staticClass:"pl-3 pl-xl-4"},[_c('p',{staticClass:"mb-0 movieTheatreTitlel"},[_vm._v("Capitol Theatre")]),_vm._v(" "),_c('p',{staticClass:"movieTheatreAdd"},[_vm._v("13, Stamford Street")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-3 pl-3 pl-xl-5"},[_c('p',{staticClass:"mb-0 movieTheatreTitles"},[_vm._v("Capitol Theatre")]),_vm._v(" "),_c('p',{staticClass:"movieTheatreAdd"},[_vm._v("13, Stamford Street")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-format redRightLine"},[_c('span',[_vm._v("2D")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1284 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTkiIGhlaWdodD0iNTkiIHZpZXdCb3g9IjAgMCA1OSA1OSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yOS41IDU5QzQ1Ljc5MjQgNTkgNTkgNDUuNzkyNCA1OSAyOS41QzU5IDEzLjIwNzYgNDUuNzkyNCAwIDI5LjUgMEMxMy4yMDc2IDAgMCAxMy4yMDc2IDAgMjkuNUMwIDQ1Ljc5MjQgMTMuMjA3NiA1OSAyOS41IDU5WiIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyKSIvPgo8cGF0aCBkPSJNMjAuNSAyNUgxNy41QzE1LjAxNDcgMjUgMTMgMjcuMDE0NyAxMyAyOS41QzEzIDMxLjk4NTMgMTUuMDE0NyAzNCAxNy41IDM0SDIwLjVDMjIuOTg1MyAzNCAyNSAzNi4wMTQ3IDI1IDM4LjVWNDEuNUMyNSA0My45ODUzIDI3LjAxNDcgNDYgMjkuNSA0NkMzMS45ODUzIDQ2IDM0IDQzLjk4NTMgMzQgNDEuNVYzOC41QzM0IDM2LjAxNDcgMzYuMDE0NyAzNCAzOC41IDM0SDQxLjVDNDMuOTg1MyAzNCA0NiAzMS45ODUzIDQ2IDI5LjVDNDYgMjcuMDE0NyA0My45ODUzIDI1IDQxLjUgMjVIMzguNUMzNi4wMTQ3IDI1IDM0IDIyLjk4NTMgMzQgMjAuNVYxNy41QzM0IDE1LjAxNDcgMzEuOTg1MyAxMyAyOS41IDEzQzI3LjAxNDcgMTMgMjUgMTUuMDE0NyAyNSAxNy41VjIwLjVDMjUgMjIuOTg1MyAyMi45ODUzIDI1IDIwLjUgMjVaIiBmaWxsPSJ3aGl0ZSIvPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyIiB4MT0iLTguNTQxNDQiIHkxPSIyMS4xMzgxIiB4Mj0iMzMuNzM0OCIgeTI9Ijk3LjIyMSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjRTcwRDAwIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI0ZBNTQwMiIvPgo8L2xpbmVhckdyYWRpZW50Pgo8L2RlZnM+Cjwvc3ZnPgo="

/***/ }),
/* 1285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_createScreen_vue__ = __webpack_require__(640);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d69595fe_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_createScreen_vue__ = __webpack_require__(1286);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_createScreen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d69595fe_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_createScreen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',[_c('div',{staticClass:"container-fluid px-0"},[_c('div',{staticClass:"movieDetailBanner d-none d-md-block",style:({
          background:
            'linear-gradient(1.01deg, rgba(0, 0, 0, 0.71) 8.89%, rgba(0, 0, 0, 0) 97.25%), linear-gradient(358.63deg, rgba(0, 0, 0, 0.25) 40.97%, rgba(0, 0, 0, 0) 97.07%), url(' +
            _vm.poster +
            ')',
        })},[_c('a',{staticClass:"play-icon",attrs:{"href":_vm.movieDetails.original_trailer,"data-fancybox":""}},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(215)}})]),_vm._v(" "),_c('div',{staticClass:"banner-content w-100"},[_c('div',{staticClass:"d-md-flex align-items-center pl-md-5"},[_c('div',{staticClass:"movieDetails text-white mb-0 mb-lg-3"},[_c('p',{staticClass:"mTitle"},[_vm._v(_vm._s(_vm.movieDetails.mc_title))]),_vm._v(" "),_c('ul',{staticClass:"list-inline mInfo"},[_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                  "+_vm._s(_vm.movieDetails.mrrdr_runtime)+" mins\n                ")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                  "+_vm._s(_vm.GetYear(_vm.movieDetails.mrrdr_release_date))+"\n                ")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                  "+_vm._s(_vm.movieDetails.rating)+"\n                ")])])])]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center pl-3 pl-md-5"})])]),_vm._v(" "),_c('div',{staticClass:"movieDetailBanner d-block d-md-none",style:({
          background:
            'linear-gradient(1.01deg, rgba(0, 0, 0, 0.71) 8.89%, rgba(0, 0, 0, 0) 97.25%), linear-gradient(358.63deg, rgba(0, 0, 0, 0.25) 40.97%, rgba(0, 0, 0, 0) 97.07%), url(' +
            _vm.poster +
            ')',
        })},[_c('a',{staticClass:"play-icon",attrs:{"href":_vm.movieDetails.original_trailer,"data-fancybox":""}},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(215)}})]),_vm._v(" "),_c('div',{staticClass:"banner-content w-100 py-2 py-xl-4"},[_c('div',{staticClass:"d-md-flex align-items-center text-center text-md-left pl-xl-5"},[_c('div',{staticClass:"movieDetails text-white mb-3"},[_c('p',{staticClass:"mTitle"},[_vm._v(_vm._s(_vm.movieDetails.mc_title))]),_vm._v(" "),_c('ul',{staticClass:"list-inline mInfo"},[_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                  "+_vm._s(_vm.movieDetails.mrrdr_runtime)+"\n                ")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                  "+_vm._s(_vm.GetYear(_vm.movieDetails.mrrdr_release_date))+"\n                ")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(_vm.movieDetails.rating))])])])]),_vm._v(" "),_c('div',{staticClass:"d-md-flex align-items-center text-center text-md-left pl-xl-5"})])])])]),_vm._v(" "),(!_vm.checkFilterExist)?_c('section',{staticClass:"container-fluid d-md-none",class:_vm.checkFilterExist == false ? 'my-2' : ''},[_c('div',{staticClass:"d-flex justify-content-center align-items-center"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"filter-new-btn mx-2",on:{"click":_vm.showFilterModal}},[_c('div',[_vm._v("Filters")]),_vm._v(" "),_c('svg',{staticClass:"svg-inline--fa fa-sliders-h fa-w-16",attrs:{"aria-hidden":"true","focusable":"false","data-prefix":"fas","data-icon":"sliders-h","role":"img","height":"20","width":"20","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"fill":"#000","d":"M496 384H160v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h80v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h336c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160h-80v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h336v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h80c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160H288V48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h208v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16z"}})])]),_vm._v(" "),_vm._m(1)])]):_vm._e(),_vm._v(" "),_c('section',{staticClass:"container-fluid d-md-none",class:_vm.checkFilterExist ? 'my-3' : ''},[(_vm.checkFilterExist)?_c('div',{staticClass:"filter-tabs"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-1"},[_c('span',{staticClass:"mr-3 ml-2",on:{"click":_vm.showFilterModal}},[_c('svg',{staticClass:"svg-inline--fa fa-sliders-h fa-w-16",attrs:{"aria-hidden":"true","focusable":"false","data-prefix":"fas","data-icon":"sliders-h","role":"img","height":"17","width":"17","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"fill":"#000","d":"M496 384H160v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h80v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h336c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160h-80v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h336v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h80c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160H288V48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h208v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16z"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-11"},[_c('ul',{staticClass:"list-inline filter-list mb-0"},_vm._l((_vm.showFilter),function(data,index2){return _c('span',{key:index2},_vm._l((data.all_filter),function(item,index){return (item.isActiveFilter == '1')?_c('li',{key:index,staticClass:"list-inline-item active mr-2"},[_c('div',{staticClass:"d-flex justify-content-center align-items-center",on:{"click":function($event){return _vm.getFilterVal(data, item, index2, index, '1')}}},[_c('div',[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('div',{staticClass:"filter-close"},[_vm._v("x")])])]):_vm._e()}),0)}),0)])])]):_vm._e()]),_vm._v(" "),_c('section',[_c('div',{staticClass:"container-fluid mb-5 mt-3 storylineSection"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 order-2 order-md-1"},[(_vm.screeningDetails.length == 0)?_c('p',{staticClass:"sTitle"},[_vm._v("\n              You are welcome to create your own screening\n            ")]):(_vm.screeningDetails.length == 1)?_c('p',{staticClass:"sTitle"},[_vm._v("\n              Existing Special Screenings\n              "),_c('router-link',{staticClass:"link",attrs:{"to":""}},[_vm._v("\n                (Available in\n                "),_c('span',[_vm._v(_vm._s(_vm.AvailableShowInCinema))]),_vm._v(" Location)\n              ")])],1):(_vm.screeningDetails.length > 1)?_c('p',{staticClass:"sTitle"},[_vm._v("\n              Existing Special Screenings\n              "),_c('router-link',{staticClass:"link",attrs:{"to":""}},[_vm._v("\n                (Available in\n                "),_c('span',[_vm._v(_vm._s(_vm.AvailableShowInCinema))]),_vm._v(" Locations)\n              ")])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-2 order-1 order-md-2 mb-3 mb-md-0 d-none d-md-block"},[_c('div',{staticClass:"filter-new-btn ml-auto",on:{"click":_vm.showFilterModal}},[_c('div',[_vm._v("Filters")]),_vm._v(" "),_c('div',[_c('svg',{staticClass:"svg-inline--fa fa-sliders-h fa-w-16",attrs:{"aria-hidden":"true","focusable":"false","data-prefix":"fas","data-icon":"sliders-h","role":"img","height":"20","width":"20","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"fill":"#000","d":"M496 384H160v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h80v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h336c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160h-80v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h336v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h80c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160H288V48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h208v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16z"}})])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 px-0 px-md-3"},[_c('div',{staticClass:"row"},[_vm._l((_vm.screeningDetails),function(singleScreening,screeningIndex){return _c('div',{key:screeningIndex,staticClass:"col-12 col-md-6 col-xl-4 mb-3"},[_c('div',{staticClass:"h-100 d-flex justify-content-between flex-column createScreenBox"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center py-3 px-3 px-md-4"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center"},[_c('p',{staticClass:"mb-0 dtText"},[_vm._v(_vm._s(singleScreening.day))]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center flex-column pl-1"},[_c('p',{staticClass:"mb-0 mText"},[_vm._v(_vm._s(singleScreening.monthName))]),_vm._v(" "),_c('p',{staticClass:"mb-0 dayText"},[_vm._v(_vm._s(singleScreening.dayName))])])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"mb-0 dtText"},[_vm._v("\n                    "+_vm._s(_vm.timeFormat(singleScreening.ss_start_show_time).split(
                        " "
                      )[0])+"\n                    "),(
                        _vm.timeFormat(singleScreening.ss_start_show_time).split(
                          ' '
                        ).length > 1
                      )?_c('sup',{staticClass:"tfText"},[_vm._v(_vm._s(_vm.timeFormat(singleScreening.ss_start_show_time).split(
                          " "
                        )[1])+"\n                    ")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between align-items-center pb-3 px-3 px-md-4"},[_c('div',[_c('p',{staticClass:"mb-0 tName"},[_vm._v(_vm._s(singleScreening.cine_name))]),_vm._v(" "),_c('p',{staticClass:"mb-0 tAdd"},[_vm._v("\n                    "+_vm._s(singleScreening.screen_name)+" -\n                    "+_vm._s(singleScreening.lang_name)+" ("+_vm._s(singleScreening.mf_name)+")\n                  ")]),_vm._v(" "),_c('p',{staticClass:"mb-0 tAdd"},[_vm._v("\n                    "+_vm._s(singleScreening.cine_address)+"\n                    "+_vm._s(singleScreening.cine_location
                        ? (", " + (singleScreening.cine_location))
                        : "")+"\n                  ")])]),_vm._v(" "),(singleScreening.showType > 0)?_c('div',[(singleScreening.showType == 2)?_c('router-link',{attrs:{"to":""},nativeOn:{"click":function($event){return _vm.onClickNext(singleScreening)}}},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(641)}})]):_vm._e(),_vm._v(" "),(singleScreening.showType == 1)?_c('router-link',{attrs:{"to":""},nativeOn:{"click":function($event){return _vm.onClickNext(singleScreening)}}},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(642)}})]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-danger gogo-cus-btn d-none"},[_vm._v("\n                    Select Screening\n                  ")])],1):_vm._e(),_vm._v(" "),(singleScreening.showType == 3)?_c('div',[_c('p',{staticClass:"mb-0 confText"},[_vm._v("Fully Booked")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"progressBarBox pt-3 pb-4 px-3 px-md-4"},[_c('div',{staticClass:"d-flex justify-content-between align-content-center pb-1"},[(singleScreening.showType === 2)?_c('p',{staticClass:"mb-0 confText"},[_vm._v("\n                    NOT CONFIRMED\n                  ")]):_vm._e(),_vm._v(" "),(singleScreening.showType == 1)?_c('p',{staticClass:"mb-0 confText"},[_vm._v("\n                    CONFIRMED\n                  ")]):_vm._e()]),_vm._v(" "),_c('div',[(singleScreening.showType == 2)?_c('b-progress',{staticClass:"proBar red mb-0",attrs:{"max":parseInt(singleScreening.screen_total_seats)}},[_c('b-progress-bar',{attrs:{"value":singleScreening.booked_seats}}),_vm._v(" "),_c('p',{staticClass:"mb-0 reqText m-auto pr-2"},[_vm._v("\n                      Need\n                      "+_vm._s(parseInt(
                          singleScreening.min_seats -
                            singleScreening.booked_seats
                        ))+"\n                      Seats to Confirm\n                    ")])],1):_vm._e(),_vm._v(" "),(singleScreening.showType == 1)?_c('b-progress',{staticClass:"proBar mb-0",attrs:{"max":parseInt(singleScreening.screen_total_seats)}},[_c('b-progress-bar',{attrs:{"value":parseInt(singleScreening.screen_total_seats)}},[_c('p',{staticClass:"mb-0 succ-text"},[_vm._v("\n                        Available to Book\n                        ")])])],1):_vm._e()],1)])])])}),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-xl-4 mb-3"},[_c('router-link',{attrs:{"to":{
                name: 'specialScreening',
                params: {
                  movieId: _vm.MovieID,
                  categoryId: 2,
                  content_lang_id: _vm.content_lang_id,
                },
              }}},[_c('div',{staticClass:"h-100 d-flex justify-content-center flex-column createBlankBox"},[_c('div',{staticClass:"text-center pb-2"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(643)}})]),_vm._v(" "),_c('p',{staticClass:"text-center gogo-dtxt"},[_vm._v("Create Your Own Screening")])])])],1)],2)])])]),_vm._v(" "),_c('section',{staticClass:"bg-light py-5 py-md-4"},[_c('div',{staticClass:"container-fluid my-md-4 storylineSection"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 pl-3 pl-xl-5"},[_c('p',{staticClass:"pb-2 sTitle"},[_vm._v("Storyline")]),_vm._v(" "),_c('p',{staticClass:"sText"},[_vm._v(_vm._s(_vm.movieDetails.mc_plot))])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 text-left d-flex-inline mb-5"},[_c('p',{staticClass:"pb-2 sTitle d-inline"},[_vm._v("Director :  ")]),_vm._v(" "),_c('div',{staticClass:"list-inline sList d-inline fs-14"},[_vm._v("\n                "+_vm._s(_vm.Directors)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 text-left d-flex-inline mb-5"},[_c('p',{staticClass:"pb-2 sTitle d-inline"},[_vm._v("Cast :  ")]),_vm._v(" "),_c('div',{staticClass:"list-inline sList d-inline"},[_vm._v("\n                "+_vm._s(_vm.Actors)+"\n                ")])])])])])])]),_vm._v(" "),_c('section',[_c('div',{staticClass:"container-fluid my-4"},[_c('OwnScreening')],1)]),_vm._v(" "),_c('b-modal',{ref:"filterModalRef",attrs:{"hide-header-close":"","hide-footer":"","id":"filterModal","title":"Choose Any Filter","modal-class":"welcome-b"}},[_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){return _vm.hideFilter()}}},[_vm._v("\n      ×\n    ")]),_vm._v(" "),_c('div',{staticClass:"col-12 loginmodal p-3 p-md-4"},[_vm._l((_vm.showFilter),function(movie,index1){return _c('div',{key:index1,staticClass:"filter-tabs"},[_c('p',{staticClass:"border-bottom pb-2"},[_vm._v(_vm._s(movie.filter_name))]),_vm._v(" "),_c('ul',{staticClass:"list-inline"},_vm._l((movie.all_filter),function(data,index2){return (data.value)?_c('li',{key:index2,staticClass:"list-inline-item",class:data.isActive == '1' ? 'active' : '',on:{"click":function($event){return _vm.getFilterVal(movie, data, index1, index2, '2')}}},[_vm._v("\n            "+_vm._s(data.title)+"\n          ")]):_vm._e()}),0)])}),_vm._v(" "),_c('div',{staticClass:"row proceed-btn-filter text-center mt-5 mx-auto"},[_c('div',{staticClass:"col-6 mx-0 mx-auto"},[_c('button',{staticClass:"btn",attrs:{"type":"button","name":"","id":""},on:{"click":_vm.resetFilter}},[_vm._v("\n            Reset\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-6 mx-0 mx-auto"},[_c('button',{staticClass:"btn apply-filter",attrs:{"type":"button","name":"","id":""},on:{"click":_vm.applyFilter}},[_vm._v("\n            Apply Filters\n          ")])])])],2)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hr',{staticClass:"hr-line"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hr',{staticClass:"hr-line"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cinemaCreateScreen_vue__ = __webpack_require__(644);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41d13f44_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cinemaCreateScreen_vue__ = __webpack_require__(1288);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cinemaCreateScreen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41d13f44_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cinemaCreateScreen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"filter-sticky-top pt-1"},[_c('section',{staticClass:"container-fluid my-1"},[(_vm.CinemaList.length > 0)?_c('div',{staticClass:"download-app"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 pr-0 align-self-center"},[_c('div',{staticClass:"d-flex align-slef-center"},[_c('div',{staticClass:"mb-2"},[_c('strong',[_vm._v("\n                  "+_vm._s(_vm.CinemaList[0].cinema_name))]),_vm._v(" "),_c('div',{staticClass:"promo-line small"},[_vm._v("\n                  "+_vm._s(_vm.CinemaList[0].cinema_address)+"  "+_vm._s(_vm.CinemaList[0].cinema_location?(", " + (_vm.CinemaList[0].cinema_location)):_vm.CinemaList[0].cinema_location)+"\n                ")])])])])])]):_vm._e()])]),_vm._v(" "),(_vm.loadingData == false)?_c('section',{staticClass:"ownScreen-color"},[_c('div',{staticClass:"container-fluid mb-4"},[(_vm.OwnScreening.length > 0)?_c('div',{staticClass:"OwnScreening"},[_c('Slick',{ref:"movieSlicknew",attrs:{"options":_vm.movieSlider},on:{"afterChange":_vm.handleAfterChange}},_vm._l((_vm.OwnScreening),function(singleMovie,singleMovieIndex){return _c('div',{key:singleMovieIndex},[_c('div',{staticClass:"movieSlider-container-top mx-auto text-center"},[_c('div',{staticClass:"img-container",class:singleMovieIndex == _vm.currentSlideInd ? 'active' : ''},[_c('router-link',{attrs:{"to":""},nativeOn:{"click":function($event){return _vm.goToRoute(singleMovie, singleMovieIndex)}}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(singleMovie.md_thumbnail_url),expression:"singleMovie.md_thumbnail_url"}],staticClass:"img-fluid mx-auto banner",attrs:{"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"img-logo"},[_c('router-link',{attrs:{"to":""},nativeOn:{"click":function($event){return _vm.goToRoute(singleMovie, singleMovieIndex)}}})],1)],1),_vm._v(" "),_c('div',{staticClass:"text-center mx-auto pt-2 pt-md-3 movieSliderInfo"},[_c('p',{staticClass:"mb-0 title"},[_vm._v(_vm._s(singleMovie.movie_title))]),_vm._v(" "),_c('ul',{staticClass:"list-inline mb-0 mInfo"},[_c('li',{staticClass:"list-inline-item"},[_vm._v("|")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(singleMovie.rating))])])])])])}),0)],1):(_vm.loadingData == false)?_c('div',{staticClass:"row"},[_vm._m(0)]):_vm._e()])]):_vm._e(),_vm._v(" "),(!_vm.checkFilterExist && _vm.content_lang_id>0)?_c('section',{staticClass:"container-fluid d-md-none",class:_vm.checkFilterExist == false ? 'my-2' : ''},[_c('div',{staticClass:"d-flex justify-content-center align-items-center"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"filter-new-btn mx-2",on:{"click":_vm.showFilterModal}},[_c('div',[_vm._v("Filters")]),_vm._v(" "),_c('svg',{staticClass:"svg-inline--fa fa-sliders-h fa-w-16",attrs:{"aria-hidden":"true","focusable":"false","data-prefix":"fas","data-icon":"sliders-h","role":"img","height":"20","width":"20","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"fill":"#000","d":"M496 384H160v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h80v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h336c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160h-80v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h336v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h80c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160H288V48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h208v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16z"}})])]),_vm._v(" "),_vm._m(2)])]):_vm._e(),_vm._v(" "),(_vm.content_lang_id>0)?_c('section',{staticClass:"container-fluid d-md-none",class:_vm.checkFilterExist ? 'my-3' : ''},[(_vm.checkFilterExist)?_c('div',{staticClass:"filter-tabs"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-1"},[_c('span',{staticClass:"mr-3 ml-2",on:{"click":_vm.showFilterModal}},[_c('svg',{staticClass:"svg-inline--fa fa-sliders-h fa-w-16",attrs:{"aria-hidden":"true","focusable":"false","data-prefix":"fas","data-icon":"sliders-h","role":"img","height":"17","width":"17","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"fill":"#000","d":"M496 384H160v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h80v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h336c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160h-80v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h336v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h80c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160H288V48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h208v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16z"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-11"},[_c('ul',{staticClass:"list-inline filter-list mb-0"},_vm._l((_vm.showFilter),function(data,index2){return _c('span',{key:index2},_vm._l((data.all_filter),function(item,index){return (item.isActiveFilter == '1')?_c('li',{key:index,staticClass:"list-inline-item active mr-2"},[_c('div',{staticClass:"d-flex justify-content-center align-items-center",on:{"click":function($event){return _vm.getFilterVal(data, item, index2, index, '1')}}},[_c('div',[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('div',{staticClass:"filter-close"},[_vm._v("x")])])]):_vm._e()}),0)}),0)])])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.loader == false && _vm.content_lang_id>0)?_c('div',[_c('section',[_c('div',{staticClass:"container-fluid mb-5 mt-3 storylineSection"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 order-2 order-md-1"},[(_vm.screeningDetails.length == 0)?_c('p',{staticClass:"sTitle"},[_vm._v("\n              You are welcome to create your own screening\n            ")]):(_vm.screeningDetails.length == 1)?_c('p',{staticClass:"sTitle"},[_vm._v("\n              Existing Special Screenings\n              "),_c('router-link',{staticClass:"link",attrs:{"to":""}},[_vm._v("\n                (Available in\n                "),_c('span',[_vm._v(_vm._s(_vm.AvailableShowInCinema))]),_vm._v(" Location)\n              ")])],1):(_vm.screeningDetails.length > 1)?_c('p',{staticClass:"sTitle"},[_vm._v("\n              Existing Special Screenings\n              "),_c('router-link',{staticClass:"link",attrs:{"to":""}},[_vm._v("\n                (Available in\n                "),_c('span',[_vm._v(_vm._s(_vm.AvailableShowInCinema))]),_vm._v(" Locations)\n              ")])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-2 order-1 order-md-2 mb-3 mb-md-0 d-none d-md-block"},[_c('div',{staticClass:"filter-new-btn ml-auto",on:{"click":_vm.showFilterModal}},[_c('div',[_vm._v("Filters")]),_vm._v(" "),_c('div',[_c('svg',{staticClass:"svg-inline--fa fa-sliders-h fa-w-16",attrs:{"aria-hidden":"true","focusable":"false","data-prefix":"fas","data-icon":"sliders-h","role":"img","height":"20","width":"20","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"fill":"#000","d":"M496 384H160v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h80v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h336c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160h-80v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h336v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h80c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160H288V48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h208v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16z"}})])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 px-0 px-md-3"},[_c('div',{staticClass:"row"},[_vm._l((_vm.screeningDetails),function(singleScreening,screeningIndex){return _c('div',{key:screeningIndex,staticClass:"col-12 col-md-6 col-xl-4 mb-3"},[_c('div',{staticClass:"h-100 d-flex justify-content-between flex-column createScreenBox"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center py-3 px-3 px-md-4"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center"},[_c('p',{staticClass:"mb-0 dtText"},[_vm._v(_vm._s(singleScreening.day))]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center flex-column pl-1"},[_c('p',{staticClass:"mb-0 mText"},[_vm._v(_vm._s(singleScreening.monthName))]),_vm._v(" "),_c('p',{staticClass:"mb-0 dayText"},[_vm._v(_vm._s(singleScreening.dayName))])])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"mb-0 dtText"},[_vm._v("\n                    "+_vm._s(_vm.timeFormat(singleScreening.ss_start_show_time).split(" ")[0])+"\n                    "),(_vm.timeFormat(singleScreening.ss_start_show_time).split(' ').length>1)?_c('sup',{staticClass:"tfText"},[_vm._v(_vm._s(_vm.timeFormat(singleScreening.ss_start_show_time).split(' ')[1])+" ")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between align-items-center pb-3 px-3 px-md-4"},[_c('div',[_c('p',{staticClass:"mb-0 tName"},[_vm._v(_vm._s(singleScreening.cine_name))]),_vm._v(" "),_c('p',{staticClass:"mb-0 tAdd"},[_vm._v("\n                    "+_vm._s(singleScreening.screen_name)+" -\n                    "+_vm._s(singleScreening.lang_name)+" ("+_vm._s(singleScreening.mf_name)+")\n                  ")]),_vm._v(" "),_c('p',{staticClass:"mb-0 tAdd"},[_vm._v(_vm._s(singleScreening.cine_address)+" "+_vm._s(singleScreening.cine_location?(", " + (singleScreening.cine_location)):""))])]),_vm._v(" "),(singleScreening.showType > 0)?_c('div',[(singleScreening.showType == 2)?_c('router-link',{attrs:{"to":""},nativeOn:{"click":function($event){return _vm.onClickNext(singleScreening)}}},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(641)}})]):_vm._e(),_vm._v(" "),(singleScreening.showType==1)?_c('router-link',{attrs:{"to":""},nativeOn:{"click":function($event){return _vm.onClickNext(singleScreening)}}},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(642)}})]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-danger gogo-cus-btn d-none"},[_vm._v("\n                    Select Screening\n                  ")])],1):_vm._e(),_vm._v(" "),(singleScreening.showType == 3)?_c('div',[_c('p',{staticClass:"mb-0 confText"},[_vm._v("Fully Booked")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"progressBarBox pt-3 pb-4 px-3 px-md-4"},[_c('div',{staticClass:"d-flex justify-content-between align-content-center pb-1"},[(singleScreening.showType === 2)?_c('p',{staticClass:"mb-0 confText"},[_vm._v("\n                    NOT CONFIRMED\n                  ")]):_vm._e(),_vm._v(" "),(singleScreening.showType==1)?_c('p',{staticClass:"mb-0 confText"},[_vm._v("\n                    CONFIRMED\n                  ")]):_vm._e()]),_vm._v(" "),_c('div',[(singleScreening.showType == 2)?_c('b-progress',{staticClass:"proBar red mb-0",attrs:{"max":parseInt(singleScreening.screen_total_seats)}},[_c('b-progress-bar',{attrs:{"value":singleScreening.booked_seats}}),_vm._v(" "),_c('p',{staticClass:"mb-0 reqText m-auto pr-2"},[_vm._v("\n                        Need "+_vm._s(parseInt(singleScreening.min_seats-singleScreening.booked_seats))+" Seats for Confirmed\n                      ")])],1):_vm._e(),_vm._v(" "),(singleScreening.showType==1)?_c('b-progress',{staticClass:"proBar mb-0",attrs:{"max":parseInt(singleScreening.screen_total_seats)}},[_c('b-progress-bar',{attrs:{"value":parseInt(singleScreening.screen_total_seats)}},[_c('p',{staticClass:"mb-0 succ-text"},[_vm._v("\n                        "+_vm._s(parseInt(singleScreening.screen_total_seats-singleScreening.booked_seats))+" Seats Left\n                      ")])])],1):_vm._e()],1)])])])}),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-xl-4 mb-3"},[_c('router-link',{attrs:{"to":{
                name: 'specialScreening',
                params: { movieId: _vm.MovieID, categoryId: 2 ,content_lang_id:_vm.content_lang_id,cinemaId:_vm.cinema_id}
              }}},[_c('div',{staticClass:"h-100 d-flex justify-content-center flex-column createBlankBox"},[_c('div',{staticClass:"text-center pb-2"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(643)}})]),_vm._v(" "),_c('p',{staticClass:"text-center gogo-dtxt"},[_vm._v("Create Your Own Screening")])])])],1)],2)])])]),_vm._v(" "),_c('section',{staticClass:"bg-light py-5 py-md-4"},[_c('div',{staticClass:"container-fluid my-md-4 storylineSection"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 pl-3 pl-xl-5"},[_c('p',{staticClass:"pb-2 sTitle"},[_vm._v("Storyline")]),_vm._v(" "),_c('p',{staticClass:"sText"},[_vm._v(_vm._s(_vm.movieDetails.mc_plot))])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 text-md-center text-left"},[_c('p',{staticClass:"pb-2 sTitle"},[_vm._v("Director")]),_vm._v(" "),_c('ul',{staticClass:"list-inline sList"},_vm._l((_vm.movieDetails.Directors),function(director,directorKey){return _c('li',{key:directorKey,staticClass:"list-inline-item text-center"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(director.mcc_cast_name),expression:"director.mcc_cast_name"}],staticClass:"img-fluid rounded-circle",staticStyle:{"width":"100px","height":"100px"}}),_vm._v(" "),_c('p',{staticClass:"mb-0 sName"},[_vm._v(_vm._s(director.mcc_cast_name))])])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('p',{staticClass:"pb-2 sTitle"},[_vm._v("Cast")]),_vm._v(" "),_c('ul',{staticClass:"list-inline sList"},_vm._l((_vm.movieDetails.Actors),function(actor,actorKey1){return _c('li',{key:actorKey1,staticClass:"text-center"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(actor.mcc_cast_name),expression:"actor.mcc_cast_name"}],staticClass:"img-fluid rounded-circle",staticStyle:{"width":"100px","height":"100px"}}),_vm._v(" "),_c('p',{staticClass:"mb-0 sName"},[_vm._v(_vm._s(actor.mcc_cast_name))])])}),0)])])])])])]),_vm._v(" "),_c('section',[_c('div',{staticClass:"container-fluid my-4"},[_c('OwnScreening')],1)])]):_vm._e(),_vm._v(" "),(_vm.loader)?_c('div',{staticClass:"col-12 text-center"},[_c('img',{staticClass:"load-more",attrs:{"src":__webpack_require__(61)}})]):_vm._e(),_vm._v(" "),_c('b-modal',{ref:"filterModalRef",attrs:{"hide-header-close":"","hide-footer":"","id":"filterModal","title":"Choose Any Filter","modal-class":"welcome-b"}},[_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){return _vm.hideFilter()}}},[_vm._v("\n      ×\n    ")]),_vm._v(" "),_c('div',{staticClass:"col-12 loginmodal p-3 p-md-4"},[_vm._l((_vm.showFilter),function(movie,index1){return _c('div',{key:index1,staticClass:"filter-tabs"},[_c('p',{staticClass:"border-bottom pb-2"},[_vm._v(_vm._s(movie.filter_name))]),_vm._v(" "),_c('ul',{staticClass:"list-inline"},_vm._l((movie.all_filter),function(data,index2){return (data.value)?_c('li',{key:index2,staticClass:"list-inline-item",class:data.isActive == '1' ? 'active' : '',on:{"click":function($event){return _vm.getFilterVal(movie, data, index1, index2, '2')}}},[_vm._v("\n            "+_vm._s(data.title)+"\n          ")]):_vm._e()}),0)])}),_vm._v(" "),_c('div',{staticClass:"row proceed-btn-filter text-center mt-5 mx-auto"},[_c('div',{staticClass:"col-6 mx-0 mx-auto"},[_c('button',{staticClass:"btn",attrs:{"type":"button","name":"","id":""},on:{"click":_vm.resetFilter}},[_vm._v("\n            Reset\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-6 mx-0 mx-auto"},[_c('button',{staticClass:"btn apply-filter",attrs:{"type":"button","name":"","id":""},on:{"click":_vm.applyFilter}},[_vm._v("\n            Apply Filters\n          ")])])])],2)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 text-center",staticStyle:{"color":"#8d99af"}},[_c('h5',[_vm._v("No Movie Found")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hr',{staticClass:"hr-line"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hr',{staticClass:"hr-line"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_createScreenList_vue__ = __webpack_require__(645);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36b255fa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_createScreenList_vue__ = __webpack_require__(1291);
function injectStyle (ssrContext) {
  __webpack_require__(1290)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_createScreenList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36b255fa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_createScreenList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1290 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"py-5"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"col-12 sliderDetails"},[_c('p',{staticClass:"movieCat"},[_vm._v("\n          CREATE YOUR OWN SCREENING\n          "),_c('span',{staticClass:"txt-link"},[_c('router-link',{staticClass:"ml-4 mr-2",attrs:{"to":""}},[_vm._v("Watch Movies on Demand")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger viewmore-btn mr-4",on:{"click":function($event){_vm.showModal = true}}},[_vm._v("Know more")])],1),_vm._v(" "),_c('b-tooltip',{attrs:{"target":"tooltip-3","placement":"right"}})],1)]),_vm._v(" "),(_vm.OwnScreening.length > 0)?_c('div',{staticClass:"row"},_vm._l((_vm.OwnScreening),function(singleMovie,singleMovieIndex){return _c('div',{key:singleMovieIndex,staticClass:"col-6 col-md-4 col-lg-3 col-xl-2 mb-4"},[_c('div',{staticClass:"movieSlider-container mx-auto text-center"},[_c('div',{staticClass:"img-container"},[_c('router-link',{attrs:{"to":{
                name: 'createScreen',
                params: {
                  movie_id: singleMovie.movie_id,
                  content_lang_id: singleMovie.content_lang_id
                }
              }}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(singleMovie.md_thumbnail_url),expression:"singleMovie.md_thumbnail_url"}],staticClass:"img-fluid mx-auto banner",attrs:{"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"img-logo"},[_c('router-link',{attrs:{"to":{
                  name: 'createScreen',
                  params: {
                    movie_id: singleMovie.movie_id,
                    content_lang_id: singleMovie.content_lang_id
                  }
                }}})],1)],1),_vm._v(" "),_c('div',{staticClass:"text-center mx-auto pt-2 pt-md-3 movieSliderInfo"},[_c('p',{staticClass:"mb-0 title"},[_vm._v(_vm._s(singleMovie.movie_title))]),_vm._v(" "),_c('ul',{staticClass:"list-inline mb-0 mInfo"},[_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(singleMovie.mf_name))]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v("|")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(singleMovie.rating))])])])])])}),0):_vm._e(),_vm._v(" "),(_vm.NextPage && _vm.loadingData)?_c('div',{staticClass:"row container-fluid"},[_vm._m(0)]):_vm._e()])]),_vm._v(" "),_c('div',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadMore),expression:"loadMore"}],attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"10"}}),_vm._v(" "),_c('b-modal',{attrs:{"ok-variant":"danger"},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('ul',[_c('li',[_vm._v("Creating your own cinema screening is simple.")]),_vm._v(" "),_c('li',[_vm._v("\n        Just pick the movie you like from a large library of the movies available.\n      ")]),_vm._v(" "),_c('li',[_vm._v("Complete the booking by selecting")]),_vm._v(" "),_c('br'),_vm._v("-A. Private Screening: Book the entire Cinema right now just for yourself.\n      "),_c('br'),_vm._v("-B. Confirmed Screening: Book the minimum tickets and confirm the screening right now\n      and Invite your friends.\n      "),_c('br'),_vm._v(" "),_c('li',[_vm._v("Your screening is confirmed.")]),_vm._v(" "),_c('li',[_vm._v("\n        Don’t worry if the screening isn’t confirmed which rarely happens, you get the refund within 48 hours.\n      ")])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 text-center"},[_c('img',{staticClass:"load-more",attrs:{"src":__webpack_require__(61)}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NowShowingList_vue__ = __webpack_require__(646);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6686b7d2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NowShowingList_vue__ = __webpack_require__(1294);
function injectStyle (ssrContext) {
  __webpack_require__(1293)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NowShowingList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6686b7d2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NowShowingList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1293 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"py-5"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"col-12 sliderDetails"},[_c('p',{staticClass:"movieCat"},[_vm._v("\n          JOIN THIS SHOW\n          "),_c('span',{staticClass:"txt-link"},[_c('router-link',{staticClass:"ml-md-4 mr-2",attrs:{"to":""}},[_vm._v("Watch the latest Movies in a theatre near you")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger viewmore-btn mr-4",on:{"click":function($event){_vm.showModal = true}}},[_vm._v("Know more")])],1),_vm._v(" "),_c('b-modal',{attrs:{"ok-variant":"danger"},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('ul',[_c('li',[_vm._v("\n                Choose your favourite movie.\n\n              ")]),_vm._v(" "),_c('li',[_vm._v("Choose the cinema and Screening type.\n              ")]),_vm._v(" "),_c('li',[_vm._v("\n                Choose the date and time.\n              ")])])]),_vm._v(" "),_c('b-tooltip',{attrs:{"target":"tooltip-1","placement":"right"}})],1)]),_vm._v(" "),(_vm.OwnScreening.length > 0)?_c('div',{staticClass:"row"},_vm._l((_vm.OwnScreening),function(singleMovie,singleMovieIndex){return _c('div',{key:singleMovieIndex,staticClass:"col-6 col-md-4 col-lg-3 col-xl-2 mb-4"},[_c('div',{staticClass:"movieSlider-container mx-auto text-center"},[_c('div',{staticClass:"img-container"},[_c('router-link',{attrs:{"to":{
                name: 'createScreen',
                params: {
                  movie_id: singleMovie.movie_id,
                  content_lang_id: singleMovie.content_lang_id
                }
              }}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(singleMovie.md_thumbnail_url),expression:"singleMovie.md_thumbnail_url"}],staticClass:"img-fluid mx-auto banner",attrs:{"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"img-logo"},[_c('router-link',{attrs:{"to":{
                  name: 'createScreen',
                  params: {
                    movie_id: singleMovie.movie_id,
                    content_lang_id: singleMovie.content_lang_id
                  }
                }}})],1)],1),_vm._v(" "),_c('div',{staticClass:"text-center mx-auto pt-2 pt-md-3 movieSliderInfo"},[_c('p',{staticClass:"mb-0 title"},[_vm._v(_vm._s(singleMovie.movie_title))]),_vm._v(" "),_c('ul',{staticClass:"list-inline mb-0 mInfo"},[_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(singleMovie.mf_name))]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v("|")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(singleMovie.rating))])])])])])}),0):_c('div',[_c('h5',{staticClass:"text-center my-4"},[_vm._v("\n          Revolutionize the way you see movies! Create Your Own Show.\n        ")])]),_vm._v(" "),(_vm.NextPage && _vm.loadingData)?_c('div',{staticClass:"row container-fluid"},[_vm._m(0)]):_vm._e()])]),_vm._v(" "),_c('div',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadMore),expression:"loadMore"}],attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"10"}})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 text-center"},[_c('img',{staticClass:"load-more",attrs:{"src":__webpack_require__(61)}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_specialScreeningList_vue__ = __webpack_require__(647);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_903f0ea6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_specialScreeningList_vue__ = __webpack_require__(1297);
function injectStyle (ssrContext) {
  __webpack_require__(1296)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_specialScreeningList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_903f0ea6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_specialScreeningList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1296 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"py-5"},[_c('div',{staticClass:"container-fluid"},[(_vm.routeName !== '/')?_c('div',{staticClass:"col-12 sliderDetails"},[_c('p',{staticClass:"movieCat"},[_vm._v("\n          SPECIAL SCREENINGS\n          "),_c('span',{staticClass:"txt-link"},[_c('router-link',{staticClass:"ml-4 mr-2",attrs:{"to":""}},[_vm._v("Watch Movies on Demand")]),_vm._v(" "),_c('b-modal',{attrs:{"ok-variant":"danger"},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('ul',[_c('li',[_vm._v("Select the favorite movie you want to watch by clicking on the movie image.")]),_vm._v(" "),_c('li',[_vm._v("\n                  These movies are special screening created exclusively for fans like you to\n                  enjoy.\n                ")]),_vm._v(" "),_c('li',[_vm._v("Join the screening by completing the booking process.")]),_vm._v(" "),_c('li',[_vm._v("Enjoy Exclusive screening of your favorite movie.")])])]),_vm._v(" "),_c('b-tooltip',{attrs:{"target":"tooltip-2","placement":"right"}})],1)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.OwnScreening),function(singleMovie,singleMovieIndex){return _c('div',{key:singleMovieIndex,staticClass:"col-6 col-md-4 col-lg-3 col-xl-2 mb-4"},[_c('div',{staticClass:"movieSlider-container mx-auto text-center"},[_c('div',{staticClass:"img-container"},[_c('router-link',{attrs:{"to":{ name: 'createScreen', params: { movieId: singleMovie.ID,categoryId: 2 }}}},[_c('img',{staticClass:"img-fluid mx-auto banner",attrs:{"src":singleMovie.Image,"alt":""}})])],1),_vm._v(" "),_c('div',{staticClass:"text-center mx-auto pt-2 pt-md-3 movieSliderInfo"},[_c('p',{staticClass:"mb-0 title"},[_vm._v(_vm._s(singleMovie.Name))]),_vm._v(" "),_c('ul',{staticClass:"list-inline mb-0 mInfo"},[_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(singleMovie.Year))]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v("|")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(singleMovie.Rated))])])])])])}),0)])]),_vm._v(" "),_c('section',{staticClass:"bg-light py-2"},[_c('div',{staticClass:"container-fluid my-4"},[_c('UpcomingFestivals')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_miniFestivalsList_vue__ = __webpack_require__(648);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2eff6954_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_miniFestivalsList_vue__ = __webpack_require__(1300);
function injectStyle (ssrContext) {
  __webpack_require__(1299)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_miniFestivalsList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2eff6954_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_miniFestivalsList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1299 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"py-5"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"col-12 sliderDetails"},[_c('p',{staticClass:"movieCat"},[_vm._v("\n          "+_vm._s(_vm.Title)+"\n          "),_c('span',{staticClass:"txt-link"},[_c('router-link',{staticClass:"ml-4 mr-2",attrs:{"to":""}},[_vm._v(_vm._s(_vm.SubTitle))])],1),_vm._v(" "),_c('b-modal',{attrs:{"ok-variant":"danger"},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('ul',[_c('li',[_vm._v("\n                We have selected these movies for special occasion for you to\n                enjoy exclusively only for you.\n              ")]),_vm._v(" "),_c('li',[_vm._v("Join the screening by booking the tickets.")]),_vm._v(" "),_c('li',[_vm._v("Enjoy Exclusive screening of your favorite movie.")])])]),_vm._v(" "),_c('b-tooltip',{attrs:{"target":"tooltip-4","placement":"right"}})],1)]),_vm._v(" "),(_vm.OwnScreening.length > 0)?_c('div',{staticClass:"row"},_vm._l((_vm.OwnScreening),function(singleMovie,singleMovieIndex){return _c('div',{key:singleMovieIndex,staticClass:"col-6 col-md-4 col-lg-3 col-xl-2 mb-4"},[_c('div',{staticClass:"movieSlider-container mx-auto text-center"},[_c('div',{staticClass:"img-container"},[_c('router-link',{attrs:{"to":{
                name: 'createScreen',
                params: { movieId: singleMovie.ID, categoryId: 4 }
              }}},[_c('img',{staticClass:"img-fluid mx-auto banner",attrs:{"src":singleMovie.Image,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"img-logo"},[_c('router-link',{attrs:{"to":{
                  name: 'createScreen',
                  params: { movieId: singleMovie.ID, categoryId: 4 }
                }}})],1)],1),_vm._v(" "),_c('div',{staticClass:"text-center mx-auto pt-2 pt-md-3 movieSliderInfo"},[_c('p',{staticClass:"mb-0 title"},[_vm._v(_vm._s(singleMovie.Name))]),_vm._v(" "),_c('ul',{staticClass:"list-inline mb-0 mInfo"},[_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(singleMovie.Year))]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v("|")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(singleMovie.Rated))])])])])])}),0):_vm._e(),_vm._v(" "),(_vm.NextPage && _vm.loadingData == false)?_c('div',{staticClass:"row container-fluid"},[_vm._m(0)]):_vm._e()])]),_vm._v(" "),_c('div',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadMore),expression:"loadMore"}],attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"0"}})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 text-center"},[_c('img',{staticClass:"load-more",attrs:{"src":__webpack_require__(61)}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_howItsWorks_vue__ = __webpack_require__(649);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12a00f20_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_howItsWorks_vue__ = __webpack_require__(1303);
function injectStyle (ssrContext) {
  __webpack_require__(1302)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_howItsWorks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12a00f20_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_howItsWorks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1302 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',[_c('div',{staticClass:"hiw"},[_c('div',{staticClass:"howitworks-img text-center"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(650)}})]),_vm._v(" "),_c('div',{staticClass:"zig-zag-b1 d-none d-md-block"},[_c('div',{staticClass:"col-6 mb-5"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"box-zzb1"},[_c('div',{staticClass:"borders"})]),_vm._v(" "),_c('div',{staticClass:"box2-zzb1"},[_c('div',{staticClass:"borders2"})])])])]),_vm._v(" "),_c('div',{staticClass:"h-box d-block d-md-none"}),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"title"},[_vm._v("1. Create your event")]),_vm._v(" "),_c('div',{staticClass:"desc-1 float-right"},[_vm._v("\n              Create a special screening for any movie listed on Create\n              Screening list and create an event. Step 2 is simple. All you\n              have to do is select the movie, cinema, date and time from the\n              options available.\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 pr-0 d-none d-md-block"},[_c('div',{staticClass:"float-right"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(216)}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 mt-2 my-md-0 pr-0 d-block d-md-none"},[_c('div',{staticClass:"float-right"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(216)}})])])])]),_vm._v(" "),_c('div',{staticClass:"zig-zag-b2 d-none d-md-block"},[_c('div',{staticClass:"col-md-6 mb-5"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"box-zzb2"},[_c('div',{staticClass:"borders"})])]),_vm._v(" "),_c('div',{staticClass:"box2-zzb2"},[_c('div',{staticClass:"borderss2"})])])]),_vm._v(" "),_c('div',{staticClass:"h-box d-block d-md-none"}),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 pl-0 d-none d-md-block"},[_c('div',[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(651)}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"title"},[_vm._v("2. Set an event type")]),_vm._v(" "),_c('div',{staticClass:"desc-1 float-left"},[_vm._v("\n              We understand that our customers can have multiple ways they’d\n              like to catch up on their favorite movies. Small groups or even\n              large… and at times the entire cinema! Choose the Screening\n              type:\n              "),_c('div',{staticClass:"mt-3"},[_vm._v("- Crowdsourced Screening")]),_vm._v(" "),_c('div',{staticClass:"my-1"},[_vm._v("- Confirmed Screening")]),_vm._v(" "),_c('div',{staticClass:"my-1"},[_vm._v("- Private Screening")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 mt-2 my-md-0 pl-0 d-block d-md-none"},[_c('div',{staticClass:"img-sm"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(651)}})])])])]),_vm._v(" "),_c('div',{staticClass:"zig-zag-b3 d-none d-md-block"},[_c('div',{staticClass:"col-md-6 mb-5"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"box-zzb3"},[_c('div',{staticClass:"borders"})]),_vm._v(" "),_c('div',{staticClass:"box2-zzb3"},[_c('div',{staticClass:"bordersss2"})])])])]),_vm._v(" "),_c('div',{staticClass:"h-box d-block d-md-none"}),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"title"},[_vm._v("3. Choose Your Seat & Pay")]),_vm._v(" "),_c('div',{staticClass:"desc-1 float-right"},[_vm._v("\n              Just like any other regular movie booking choose your preferred\n              seats and proceed to pay with multiple payment options we’ve\n              provided!\n              "),_c('ul',{staticClass:"list-unstyled mt-3"})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 pr-0 d-none d-md-block"},[_c('div',{staticClass:"float-right"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(217)}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 mt-2 my-md-0 pr-0 d-block d-md-none"},[_c('div',{staticClass:"float-right img-sm"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(217)}})])])])]),_vm._v(" "),_c('div',{staticClass:"zig-zag-b4 d-none d-md-block"},[_c('div',{staticClass:"col-6 mb-5"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"box-zzb4"},[_c('div',{staticClass:"borders"})]),_vm._v(" "),_c('div',{staticClass:"box2-zzb4"},[_c('div',{staticClass:"borderssss2"})])])])]),_vm._v(" "),_c('div',{staticClass:"h-box d-block d-md-none"}),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"title"},[_vm._v("4. Wait for your event to get confirmed")]),_vm._v(" "),_c('div',{staticClass:"desc-box"},[_c('div',{staticClass:"desc"},[_vm._v("\n            Each screening and cinema have a very specific number of minimum\n            number of seats that have to be sold for the movie to be\n            confirmed. So make sure you tell your friends and family and\n            anyone everyone you know who’d love to watch your favourite movie\n            with you.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"container ticket-box text-center mt-5"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(652)}})]),_vm._v(" "),_c('div',{staticClass:"mt-4 mb-4 dash-line"}),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("EVENT CONFIRMED!")]),_vm._v(" "),_c('div',{staticClass:"desc"},[_vm._v("Perfect...Off you go!")]),_vm._v(" "),_c('div',{staticClass:"w-75 mx-auto my-3"},[_c('img',{staticClass:"img-fluid mx-auto d-block",attrs:{"src":__webpack_require__(653)}})])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_howItsWorkswebiste_vue__ = __webpack_require__(654);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8918809a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_howItsWorkswebiste_vue__ = __webpack_require__(1306);
function injectStyle (ssrContext) {
  __webpack_require__(1305)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8918809a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_howItsWorkswebiste_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8918809a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_howItsWorkswebiste_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1305 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',[_c('div',{staticClass:"hiw"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"h-box d-block d-md-none"}),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"h-box d-block d-md-none"}),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('div',{staticClass:"h-box d-block d-md-none"}),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('div',{staticClass:"h-box d-block d-md-none"}),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"title"},[_vm._v("4. Wait for your confirmed screening to get confirmed")]),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_c('div',{staticClass:"mt-4 mb-4 dash-line"}),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("EVENT CONFIRMED!")]),_vm._v(" "),_c('div',{staticClass:"desc"},[_vm._v("Perfect...Off you go!")]),_vm._v(" "),_vm._m(10),_vm._v(" "),_c('div',{staticClass:"text-center py-5"},[_c('router-link',{staticClass:"btn-gogo mx-auto",attrs:{"to":"/"}},[_vm._v("Browse Movies")])],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"howitworks-img text-center"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(650)}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zig-zag-b1 d-none d-md-block"},[_c('div',{staticClass:"col-6 mb-5"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"box-zzb1"},[_c('div',{staticClass:"borders"})]),_vm._v(" "),_c('div',{staticClass:"box2-zzb1"},[_c('div',{staticClass:"borders2"})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"title"},[_vm._v("1. Create your special screening")]),_vm._v(" "),_c('div',{staticClass:"desc-1 float-right"},[_vm._v("\n              You can create a special screening for any movie listed on GoGoCinema. It is very simple. All you need to do is select the cinema, movie, date and time. Then, select a screening type from the options available.\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 pr-0 d-none d-md-block"},[_c('div',{staticClass:"float-right"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(216)}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 mt-2 my-md-0 pr-0 d-block d-md-none"},[_c('div',{staticClass:"float-right"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(216)}})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zig-zag-b2 d-none d-md-block"},[_c('div',{staticClass:"col-md-6 mb-5"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"box-zzb2"},[_c('div',{staticClass:"borders"})])]),_vm._v(" "),_c('div',{staticClass:"box2-zzb2"},[_c('div',{staticClass:"borderss2"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 pl-0 d-none d-md-block"},[_c('div',[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(655)}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"title"},[_vm._v("2. Set the type of screening")]),_vm._v(" "),_c('div',{staticClass:"desc-1 float-left"},[_vm._v("\n              We understand that you are looking for choices, and we have them. There are three ways to experience your favorite movie with GoGoCinema. You either buy individual tickets, purchase the minimum required or book the entire theatre auditorium for your VIP private event. \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 mt-2 my-md-0 pl-0 d-block d-md-none"},[_c('div',{staticClass:"img-sm"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(655)}})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zig-zag-b3 d-none d-md-block"},[_c('div',{staticClass:"col-md-6 mb-5"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"box-zzb3"},[_c('div',{staticClass:"borders"})]),_vm._v(" "),_c('div',{staticClass:"box2-zzb3"},[_c('div',{staticClass:"bordersss2"})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"title"},[_vm._v("3. Choose your seats & pay")]),_vm._v(" "),_c('div',{staticClass:"desc-1 float-right"},[_vm._v("\n              Just as you would expect, GoGoCinema allows you to select your seats (or every seat for a true VIP private experience) and then pay with one of the provided payment options.\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n              "),_c('ul',{staticClass:"list-unstyled mt-3"})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 pr-0 d-none d-md-block"},[_c('div',{staticClass:"float-right"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(217)}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 mt-2 my-md-0 pr-0 d-block d-md-none"},[_c('div',{staticClass:"float-right img-sm"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(217)}})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zig-zag-b4 d-none d-md-block"},[_c('div',{staticClass:"col-6 mb-5"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"box-zzb4"},[_c('div',{staticClass:"borders"})]),_vm._v(" "),_c('div',{staticClass:"box2-zzb4"},[_c('div',{staticClass:"borderssss2"})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"desc-box"},[_c('div',{staticClass:"desc"},[_vm._v("\n            \t\t\t\tA confirmed Screening requires a very specific number of tickets to be purchased for your favorite movie to be confirmed.  Let's say it's 10 tickets. If you purchase two tickets, you need eight of your friends and family to confirm the movie. What are you waiting for? Tell everyone you know to join you so you can all enjoy your favorite movie.\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container ticket-box text-center mt-5"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(652)}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-75 mx-auto my-3"},[_c('img',{staticClass:"img-fluid mx-auto d-block",attrs:{"src":__webpack_require__(653)}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_noSearchFound_vue__ = __webpack_require__(656);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35de83ca_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_noSearchFound_vue__ = __webpack_require__(1309);
function injectStyle (ssrContext) {
  __webpack_require__(1308)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-35de83ca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_noSearchFound_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35de83ca_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_noSearchFound_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1308 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',[_c('div',{staticClass:"container-fluid text-center mx-auto pt-4"},[_c('div',{staticClass:"col-12 col-md-8 col-xl-6 noSearch mx-auto"},[_c('p',{staticClass:"title my-5"},[_vm._v("Whoops!")]),_vm._v(" "),_c('div',[_c('img',{staticClass:"img-fluid mb-4",attrs:{"src":__webpack_require__(1310)}}),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("You searched for "),_c('router-link',{attrs:{"to":""}},[_vm._v("Giftz")])],1),_vm._v(" "),_c('p',{staticClass:"title mb-0 mt-4"},[_vm._v("Nothing matched your search.")]),_vm._v(" "),_c('p',{staticClass:"text mb-4"},[_vm._v("Please try again with some other keywords.")])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('p',{staticClass:"text1 pb-3"},[_vm._v("Browse through trending films:")])])])]),_vm._v(" "),_c('section',[_c('div',{staticClass:"container-fluid my-4"},[_c('NowShowing')],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-5"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(311)}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1310 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTQiIGhlaWdodD0iOTQiIHZpZXdCb3g9IjAgMCA5NCA5NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTgwLjI1MDQgMTMuNzUzNkM2MS45MTQ3IC00LjU4MzggMzIuMDgzIC00LjU4MzggMTMuNzUwOSAxMy43NDkyQy00LjU4NDggMzIuMDgyMiAtNC41ODMwMyA2MS45MTQ4IDEzLjc1MjYgODAuMjUxNEMzMi4wODMgOTguNTgzNSA2MS45MTQ3IDk4LjU4MzUgODAuMjQ4NiA4MC4yNDc4Qzk4LjU4MjUgNjEuOTE0OCA5OC41ODE2IDMyLjA4NCA4MC4yNTA0IDEzLjc1MzZaTTc1LjExOTYgNzUuMTIwNkM1OS42MTQ4IDkwLjYyNTQgMzQuMzg1NSA5MC42MjcyIDE4Ljg3OTggNzUuMTIyNEMzLjM3MTQ2IDU5LjYxNDkgMy4zNzMyMyAzNC4zODMgMTguODc5OCAxOC44NzgyQzM0LjM4NDcgMy4zNzQyMyA1OS42MTMgMy4zNzI0NiA3NS4xMjE0IDE4Ljg3OTlDOTAuNjI2MiAzNC4zODQ4IDkwLjYyNDQgNTkuNjE2NyA3NS4xMTk2IDc1LjEyMDZaTTY4LjI1OTcgNjUuNTg2N0M2OC44NDI5IDY2LjkzNDggNjguMjIyNSA2OC40OTkxIDY2Ljg3NTMgNjkuMDgxNEM2NS41MjczIDY5LjY2NjQgNjMuOTYyOSA2OS4wNDQyIDYzLjM3OTggNjcuNjk3QzYwLjgxNTcgNjEuNzY4NiA1NC43NTYxIDU3LjkzNzEgNDcuOTM5NiA1Ny45MzcxQzQwLjk2NjMgNTcuOTM3MSAzNC44Njk1IDYxLjc2NSAzMi40MSA2Ny42ODk5QzMxLjk4NTUgNjguNzEyNyAzMC45OTU1IDY5LjMzMDUgMjkuOTU0MSA2OS4zMzA1QzI5LjYxMzcgNjkuMzMwNSAyOS4yNjkgNjkuMjY0OSAyOC45MzQ4IDY5LjEyNjZDMjcuNTc4OCA2OC41NjI5IDI2LjkzNjIgNjcuMDA2NiAyNy40OTkgNjUuNjUxNEMzMC43ODcyIDU3LjczNTEgMzguODExNyA1Mi42MjAzIDQ3LjkzOTYgNTIuNjIwM0M1Ni44NzcgNTIuNjIwMyA2NC44NTM3IDU3LjcwOTQgNjguMjU5NyA2NS41ODY3Wk0yOS40NjA0IDM0LjI3NEMyOS40NjA0IDMxLjIzOTMgMzEuOTIxNiAyOC43NzgxIDM0Ljk1NjMgMjguNzc4MUMzNy45OTAxIDI4Ljc3ODEgNDAuNDUxMyAzMS4yMzg0IDQwLjQ1MTMgMzQuMjc0QzQwLjQ1MTMgMzcuMzEwNCAzNy45OTAxIDM5Ljc3MDggMzQuOTU2MyAzOS43NzA4QzMxLjkyMTYgMzkuNzcwOCAyOS40NjA0IDM3LjMxMDQgMjkuNDYwNCAzNC4yNzRaTTU0LjM4MDMgMzQuMjc0QzU0LjM4MDMgMzEuMjM5MyA1Ni44NDMzIDI4Ljc3ODEgNTkuODc4IDI4Ljc3ODFDNjIuOTExOCAyOC43NzgxIDY1LjM3MyAzMS4yMzg0IDY1LjM3MyAzNC4yNzRDNjUuMzczIDM3LjMxMDQgNjIuOTEyNyAzOS43NzA4IDU5Ljg3OCAzOS43NzA4QzU2Ljg0MzMgMzkuNzcwOCA1NC4zODAzIDM3LjMxMDQgNTQuMzgwMyAzNC4yNzRaIiBmaWxsPSIjRkJCQzA1Ii8+Cjwvc3ZnPgo="

/***/ }),
/* 1311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cinemapage_vue__ = __webpack_require__(657);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5de4bbb8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cinemapage_vue__ = __webpack_require__(1313);
function injectStyle (ssrContext) {
  __webpack_require__(1312)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cinemapage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5de4bbb8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cinemapage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1312 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[(_vm.CinemaList.length == 0)?_c('div',{staticClass:"row container-fluid"},[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"movie-information bg-light py-0"}),_vm._v(" "),(_vm.CinemaList.length > 0)?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-6 mb-md-4 mb-3 py-2 px-0 grp-drop mt-3"},[_c('b-input-group',[_c('b-button',{staticClass:"pr-1",attrs:{"variant":"default"}},[_c('img',{attrs:{"src":__webpack_require__(295),"height":"19","width":"19"}})]),_vm._v(" "),_c('b-form-input',{staticClass:"pl-1",attrs:{"placeholder":"Search for cinema"},nativeOn:{"keyup":function($event){return _vm.searchData()}},model:{value:(_vm.searchValue),callback:function ($$v) {_vm.searchValue=$$v},expression:"searchValue"}})],1)],1),_vm._v(" "),(_vm.loadingContent == false && _vm.CinemaList.length > 0)?_c('ul',{staticClass:"movie-listing-mobile mt-2"},_vm._l((_vm.CinemaList),function(listing,listingKey){return _c('li',{key:listingKey,class:{ active: _vm.selectedCinemaObject === listing },on:{"click":function($event){return _vm.onSelectCinema(listing)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-8 col-md-9 organisation-name"},[_vm._v("\n                          "+_vm._s(listing.cinema_name)+" \n                        ")]),_vm._v(" "),_vm._m(1,true),_vm._v(" "),_c('div',{staticClass:"col-8 col-md-9"},[_c('div',{staticClass:"organisation-address"},[_vm._v("\n                            "+_vm._s(listing.cinema_address)+" "+_vm._s(listing.cinema_location?(", " + (listing.cinema_location)):listing.cinema_location)+"\n                          ")]),_vm._v(" "),(listing.mf_name.length > 0)?_c('ul',{staticClass:"organisation-features"},_vm._l((listing.mf_name),function(item,index){return _c('li',{key:index},[_vm._v("\n                              "+_vm._s(item)+"\n                            ")])}),0):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-4 col-md-3"},[_c('div',{staticClass:"organisation-name"},[_c('span',{staticClass:"price"},[_vm._v("\n                             "+_vm._s(_vm.curr_code)+"\n                              "+_vm._s(String(listing.starting_price).split(".")[0])+"."),_c('sup',[_vm._v(_vm._s(String(listing.starting_price).split(".")[1].length==1?String(listing.starting_price).split(".")[1]+'0':String(listing.starting_price).split(".")[1]))])])]),_vm._v(" "),(false)?_c('div',{staticClass:"organisation-distance text-left"},[_vm._v("\n                            "+_vm._s(listing.Distance)+"\n                          ")]):_vm._e()])])])}),0):(_vm.CinemaList.length == 0 && _vm.loadingContent == false)?_c('div',{staticClass:"my-4"},[_c('h5',{staticClass:"text-center"},[_vm._v("No Cinema Found")])]):(_vm.loadingContent && _vm.filterListCinema.length > 0)?_c('div',{staticClass:"row container-fluid"},[_vm._m(2)]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('b-modal',{ref:"filterModalRef",attrs:{"hide-header-close":"","hide-footer":"","id":"filterModal","title":"Choose Any Filter","modal-class":"welcome-b"}},[_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){return _vm.hideFilter()}}},[_vm._v("\n      ×\n    ")])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 text-center"},[_c('img',{staticClass:"load-more",attrs:{"src":__webpack_require__(61)}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-4 col-md-3 organisation-name align-self-end"},[_c('span',{staticClass:"font-small d-block"},[_vm._v("Starting From")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 text-center"},[_c('img',{staticClass:"load-more",attrs:{"src":__webpack_require__(61)}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aboutus_vue__ = __webpack_require__(658);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34f146c1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aboutus_vue__ = __webpack_require__(1316);
function injectStyle (ssrContext) {
  __webpack_require__(1315)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aboutus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34f146c1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aboutus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1315 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container my-5"},[_c('div',{staticClass:"text-center title-au font-weight-bold mb-4"},[_vm._v("About us")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('p',{staticClass:"text-au"},[_vm._v("\n    Going to movies is like viewing the world around us on a big screen. Whether it's fiction, comedy, action or drama, movies have helped shape our cultures, our ideologies and have inspired and entertained us for over 100 years. \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n  ")]),_vm._v(" "),_c('div',{staticClass:"col-md-10 mx-auto pt-md-5"},[_c('div',{staticClass:"row"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-md-8 text-center px-0"},[_c('p',{staticClass:"title-au font-weight-bold mb-0"},[_vm._v("Want to learn more?")]),_vm._v(" "),_c('p',{staticClass:"text-au font-weight-bold"},[_vm._v("Check out other links")]),_vm._v(" "),_c('div',{staticClass:"row mt-5"},[_c('div',{staticClass:"col-md-6"},[_c('b-button',{staticClass:"btn-gogo d-flex justify-content-center align-items-center",attrs:{"to":"/hiw","variant":"none"}},[_vm._v("How it works")])],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 mt-md-0 mt-3"},[_c('b-button',{staticClass:"btn-gogo justify-content-center d-flex align-items-center",attrs:{"to":"/faqs","variant":"none"}},[_vm._v("FAQs")])],1)])]),_vm._v(" "),_vm._m(2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text-au"},[_c('b',[_c('i',[_c('q',[_vm._v("\n    My most enjoyable moviegoing experiences have always been going to a movie theatre, sitting there and the lights go down and a film comes on the screen that you don't know everything about, and you don't know every plot turn and every character movement that's going to happen.\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n    ")]),_vm._v(" –-- \n    "),_vm._v("\n    Christopher Nolan, Director, Producer, Screenwriter\t\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-2"},[_c('img',{staticClass:"img-fluid d-block mx-auto",attrs:{"src":__webpack_require__(1317),"width":"169","height":"auto"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-2"},[_c('img',{staticClass:"img-fluid d-block mx-auto",attrs:{"src":__webpack_require__(1318),"width":"169","height":"auto"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1317 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJMAAACyCAYAAABGFf2GAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAABRaSURBVHgB7d0HeFRV2gDg79x7ZyY9mRRKCqQMLQRSEISlBRGEBYSolFV/F/tvgVVxLbv6g65dVxERRAUVQfAXQ1EpykpVQEINhBJSSQiEZFJIMpOZe+/Z794AUlMgIWT83uc5T4bhzmSeyTenfKcMACGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCXJAIpDn9HQvHkgcuQALSnMZg8cWyDYsKLZwApDltwtIDiw+4AAqm5rUVSwwWN3ABFEzNKwOLHYsfuAAKpuZVieU4lnBwARRMzcsDavpLMrgACqbm1R2LP5YDQMhVMGNZheVLcJEOOOWZGll4eHhniXOzkbGstOzs45e5zAvLi1CTY3oeajrhLR4FUyOKCAu71cfL+xUPd48Am60yv0N4ZKoqK0sUiW3Jzs4uPefSIVjuwvIklr3gImg6pRGZzeZRQUFBtz//wj/8e/bqFSKIQry1xDreYbcn+Pv4Kb7+fnmlpaVt8NJFWOZhmQMu0vnWUDA1osDAwBG2yoqBeblHhQceehhGJyVBv/79hcrKSkt2dtYw2SHfYLNVjVdUtRpqaqVyIORCERERsVHh4Ydff/U1/uB99/M+PXvxZcnJ3G63c83hw4d5bLfuXJIk3rZ12wVhYWHB+DAGLoRqpkYS6Ot/V7v27Sa8OG0qSxw0CCoqK2H+F1/AycJC6BIdDQaDAWZ++CEMHTIEFKezi8PuiPY1++3EZq8ICDkDR3BtunTsmLt48WKuqqpeEymKwjesX8/vvvNOPvSmwfzjOXP4rFmz+KlTpzgGGJ/06GM8tmtMgaV9+wfatm3rAS6AaqarJwb6+T0VGxs3dNKkSQZPT0/9TsYYtA8Ph779+gE2dTDv00/Bx9sbMHDA0qED3NinN9hsNq8DBw72E1RIt5aV7gfSOPZFRxt5C8zIW9q1i+4QEZX22bx5Z2ulC9mqqvj+1H1YGz3Kh9x0E5/+73f5/n37uNVq5YsWfsV79+yVic8zNjExsUWnapq9ZtKC6KVQ73gfUb2vItic93ZBiRVaELOf30OdOnca++SUKcwba55LkbC/FNSqFfTp2xf8zGZYvnQZrPphJVRXV0PXmK6QdzTPnJWdbcg7lv9dVVWVA0j9YQ3ECuItQcWxEUOL46KSS+I7FFnjLYq1f8Krx9es8YQWQhuRdesSXfb1okWXrZUupF1XVFTEP5s7V+9L9YiN4wnduhdFtW8/A/teLXpa5ZpXq9Zukd1KJXGQEfgEgYk9OANs3jhI3RPAdOf/TPa2RDrxsmlwnYvGGtVeUTU5MirKZ2Biot5Hqg/tuoCAAJh4333g4eEBL0+dVmpzVE9SGVuKWfIWPa3S5MGU36Oth1ny9K9yCJ0kUG/HWmkwBk8YvvXuYDSAGNYejMNGgWHwUODHj3k5Zr4zPK9zyAehB/OL4TpmP2XvLkhCUtJtSdCqdesGPRYrKMjKyoKFCxdWVFc7FrSLCP9m/fr1LT4T3iRJs3wc6nq09urIgHfgjPUDxgfh+9ft7AVGI0jR3UDq3RdMo5IAx8vgWLYEqpf9P2CWD99UNresxPlExHX8SY0Ka/9BTFz3x5etWAENdfLkSZj6wouw9qcf10iqeu+BnJwCcAGNVjOlWyymQC/og7XOzcCEAVgDhWFphZ9DD30zz2nGm4eB4ZaRYOgeD7y8DGyz3wd5Zwqox/LOeU18vK+PuB5vL4brUGhoqL/J3W3iuHHj4Up8jwG4bv26Yifnr6e7SCBprjiYrNGR7ZiRJWDN0wn/+Il4V2+ur2XWKrua6GGYcxHaRYAYGQWGvgNBir8BeFkpKGmpUPHMJJD37QFQlEs9vR8T2SsnYyN3Bu3JPAzXEa2TLKrwbv8BA7yG3DIUGmrzxo3w9ltvW50Ox9M9s7M3Z4PruOJgEg28jSIIizBu3M5rLXEYLHWJAUO/RD14hJBQYG7u4Px1E1S9NhWUwwcAhzPAldq7CBiOIaLAnuTR0X9jaWnXz3DZCXH4rt0y7i8TICgoqEEPzcnJgZkzPoBqu32lYDQs+gY/SuBCrqrPZB0+YI4hIvJBISSMiZ26gtixEwjBodh8lYKamwtKRjo4168FJR0DqLoarsBxrkBSwN4jW+E6gLWSn8hhNma1J3yx4MsGPVaWZXjk4Ydh/X/WpciM92/pI7dLuao+k9e/Z20X/QMm4nyBUcnOBOcvG0HNyQAlPx/Uozl6nwiHLnAV2mBzNxFq9pc1O3yzOnv7+Az7670ToaG+XfItbNywMQ9z/G9mZ7leIGmuejRX3MPyAFPhk7quYyYTSL36gBAWDoCjNyX9ICjY6eanyusMOEVVOzV330nrKxm4MH/4qD+Pff3NN/UcUX2lbN8Of3t8knqiuOh/MzIy6nyvWqqrHs2VF8sLfM2SttAr+rIXCSIYho8GjynPY6fcS79Lq7WcO7aBff6noOzZVduvAExu3oo/3oFmJEnSUB9P79633X5HgwIJs90w8/0ZUHiicKnJ030RuLCrnljVc0EqvI43Ky57kVb/Oar14T8vxak32QnMxxeMiUPA81/vgClprF5zXfZFMvWWEzFhUdBMooOCvLgsPzJwUGJw33596/04u80Gs2Z+CFu2/HpQVZwvpaWlVYALa5Q8E7ZS6wUOaTg10uuSF+Dw37H6O5D379FHekJoOxC1pGWnLiCGhIHb/Y+Bc+O6WjrpLNYgGTpDzXbqa67aw6OXj7fPoBEjR4hYQ9XrMTgHB2vXroVVK1eW46zda5l5eS6/xKRRgglHW3nF8ZbNWAElXPicTJRAaNMWhPYRwHDmXC04BvLuHcAXfg4MmwsR0wdi22DgtqrLPj/2qAKZwLQdHT/ANaYtC8nLyv7niFEjTXHx8fV+XDZOl7w/fbpadLJodmh4+0VHsrJa/JE5dWm0DDhThaUgqPfgzcCzd2LOyTj6DnD764OYbwo7e7ealwtVb7yEuScc/a1dDc56PD3nwi3QDHAIH2r29o4eMnQo+Pv71+sx5eXloK0Fx4BaqwpslivMu9VHoy1GM3sE7MC+0XmbDqUuXcHtoUnnBZL+S7GZM024B5jBCA0Qeap7VCu4xkSHQ2FM4FqeqD4qKythaXIybNqw4QRXlJczMzNd4lS4+mi0YGJbttgwRbDh7L/d3MDt7vtBCLx0llhr4sDQkIqRGx0iGwDXWMaxY8crKisOrlm9Bior6u4/70hJgTmzZjsVp/x2Rm7uL+ACJ8LVV6Muk8U+09lgEjvHgNgl5rLXynt2Aq86p5/EGOagtOUoI8H94cng8eTzYOg/6LxRHqs5Ze1acyqK/MrqVasqP/n441ovrMBgmzP7IygsLPzOzpXZQK5cUY/wziUJllRrvIVX/N8zXC0vv+RqQ3nfXl5yY1euXVd+dxK3fTSDywf2X/JanJLh5fdO4NaEDtwaF7VpXfNsaRctEREPRHfsdOL5Z57lWVlZF73O0pIS/vcpU3jHyMiNlrDmS2M0p0ZdA/5CsDumCYy98Wa0iMN+w58GXJQ/UrIzwDbjbVDzj4Lh5mHg/sgT+uI4IejS3SFm9gehdVtQ9u3RVhwUhYYELnm9oLgKri3u4eV1gKvs0OFDB/vs2J7iq+2D8zP7gbbuuwpr2OXLlsGC+V86qxyOZzNzcjbDH1Cjfsp9dhQUFcd12MYYH6Ps2y0pGYdBijvdMmHSUt6VApWvTdXn7Ux/uQc8nvoHhnMd8ax1fLXi7qHlCAS7zdEsOzjy8vJs+CMZp1V+3p+2f8KzTz99BzbNWg2kr9tmjB3GdvgTHPEt01ZR/hE1+krLk7GRI0VtaQrOA0vRMWAcMxYEXzM4U7aCvPUXUDCQNN6ff62v+74sTPrJB/eDY+UKnEDeAGputpYdPaLKwqjA1MMHoZlZLJZQHOFZ4HQwGTjPSc/JOQR/oA73hRo9mCqiw9s4TeJWDqx9bdcZ+g4A98ee0jvdZ+brNFoWnB8vAPvi+VCd/DUmmPBv4+Gpr4kCo7GQRUbd4zP947VYE7jUWiBX0CRrwLGj/D3W+yNqvUgbvQWHgRgVpeedBP9AUK1FoJ4o0Js1wc+sZ82FtqEgYN+EefkClyQuBAR8aeXs8aCgoFNAritN0v8QBFihcqg9mHBCT83PBV58EoS8PBC7xmCzFw/GkUk4BSMCx2E2DpH04HLsTgFeWIi1lp3x8jIv06H9Dcp2kmujSYJJdgibBAPXMnxel7uG4ehNirsBpB49wRDbAxjWRHLqbpB//hHkQwdAyTqC0y5HL/XQwZgcbYc/r+utUM2hMDrIy83gHVzNhOAz94kSdwoO6ZhDFk+2auJVC00STMyT54MDtOzv7/Np2KwxLy+cWsGplOGjwDBgsD6SU44cAvu8jzCQduHQv0yrffTOt/4QTBjiJK82inLgTwc+hRVTOju4yExA9K31IUY1mDNlGNbzt+I73A3fMIPI4Pf3R8FepyhXS5LiLE2wHMB3dgM2CutE2XFwempu2bRGHDA0SZ9JO4CiJN7yDN6cisVN6/8YBg7Wi9ilGygH94Fz488g/7ZFX215wUrLSuxc7wKV7wGRpePPLAbiMbsi57bZm1EIRFeIAx3JJD2Bb/ZY/CtGQsM4gbOdOP+xkQNP9vcJTWGNMBndZCeXlcV27KW2Clxk6NU70vTn0cDaBoNyIA2ql3+jbzTg1rOtVAXWNtpJ/emcs+85iL9JjGVViWWFITsKrnVy8rrHExOlEg+1C3PKb/DiwptqdgedT1v2o210Bel0Dk/bTubE+HFetD7DgVdnCqCudyrSdIeh/OjVvOdNFkwYIEbs+6wRPD0TtYVv1d9+BUoO5pjUmhE9fiKOY7W8Gy/cDIphxYzUg/un/YFzNPV1atqUaDEoBPsFcn/75xfPFYrhkSDd2BfnfzrhCDlAv4877KBmZmCOLxv/BtmgYn+U2y/a06CtbvjSJlS+iwF1RafZNWU2WVVyjrxVOWdmX5531HDmU4FBlINVbLKosgWKOxwJ2JZBh4Q2AKuw3yN0DOhnXzDvov/Tzm3wePFVHNhgMphdYg5fWzqNLYK2QNGxagUmhJefO9kein3SZ9y5Zw9rt8in/VMzU6Ghrw2a0NE+oe6edrc5+Ft6qirbJnJ1eb4z44eYNKAziK6AtUdkO7GdZSvOKrS1z51ds7PnHMbht4Lny2/VPUV1mqolhzEonatXYJCddyyWFZgy0bwzayVrwEbRJg0m7Rwma7ylCxO5Wa4y7Wnl4gvqm1pxQtQwwei+EOc1/YVWrUDZu1dfCq3tmtZqGHnndvB87d3zZhTqhLWVtkuo6l8vYnAdO3s3BsYRLvPJ5tSM1QygXpsfXeroYFdXFBc1RmDsM7zpJ0Z10E+SUXKzQNsAaxh4MwgmEwiRFjCNvUvPHDeENg9qf+8NcG4/b7+rlSvyiIC92fXaBEvf6tRCaSPi6u+SQdb2HOJoTcQgUrIyoOqDd8Dx4w8N3o4vde4K7k89h5Om500u+DNJeq+8R8fA+jwHnbbbgjwXZDaAwLRzfPTDM5m3NxgHDQHTuLtxtJYOznVra5b67PwNOHayhfbhIGjLo8X6jbOEgCCQtU0eJ34/5QebrlY4135ibEjEzo8LCmodbVMz14Jgx0WyJkStZpwN1nb+uD88CZjBBPYlX9Wcb3XB8URCcAgYtGBLGq/XXPVRfuetmFS+6OvvfmVcvsu8Ozu7tsfStzq1IPjJl3HM9Q2mV/qIPn4e2tlX9nmz9cWG512nNVU4zleP4azW4gXg/Gk1iJ2ja2YgLB1B8PEBpi02dD99Fq2tEpSiInBoo7r8fP2x585K4L96Mi51xJvZtb0+CqYWRhaV5aIsDeF2221qQT6TunYHXlkJ6skT2EwF6slKKTYBeEU5zjYk66syeOFxULFoU1jM26dmyU9gkD65ruHFRaDk5er9JrdHn8RR4i5w/rymJp6cDi0BbVBrvuX8x9peGzVzLZA1IQIjSFwkmP2jjaOSQOr5J2AmIwZUIci7U8C5bQtmv/3BNGY82ObMwCRlfp3PaejdHwNpMtjeexNHg3dC9VefA2sdjJGmYmDpMfSm/64jz9X2HFQztUD+O7P2lnTr8IhaYv3aPn9uG5g/96JrtGXOhhv76TURXBBMLCAAhKDW+ogQzszXYTDKGITaOn0t6WkcPhqcu7aDAdMPWjCpKq8zIik10EJVGStScFbhMQY85bIHXGnLfs49aAP/bRg8DNz/+hAYBw8H9wcfP/v/2uYPrdnTziHV1pVxVQW328aB88B+reNfyZhQ57p7CqYWSpvdD9yTnox10AOcs98woC6a9tCWQQuRUWdTA1JCTzD2G4j5qaVg/2y2XhsZho6o6aznHcUJ4AyQYmIBMEdln/EWVL78T61Wwljia2wqr/MbzinP1MK9cbz0pD3Ebw3nAr/wFBpeXg6m0XfowaKlBjwwlWD78F1QjhyuWZKSn4dpg3Gg5mTqZ2YZR48FedM6/URkbYGitnQaK71KQVYnt0rN3PdSHa+FOuAuQluQWBYficEk3q8ydQxwpn0XMAhtgvVvf2CKqq8SULVzRs/Qggz7RG4YcBybO2XPThwBLjnzjCo2kpmqkz0asC/9p/q8BgomF5MVHu7m62u4mTN+E8bK/XiXT50PMhr1vNO5B9pi07lU4OoHGZLf5ht27KjHqUcUTC7taJ8+7t7Oor6qot6Of+o4DBAzY6ovwIWrM5mCMVSGwVeKUfQfUGH+jL0ZadMauFiRgukPQtu5IojmUFWAQFFUzlujop0lwkA4VuVmPB62Ja1Ffd8fIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhJC6/RdbD3XFbORH4AAAAABJRU5ErkJggg=="

/***/ }),
/* 1318 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_help_page_vue__ = __webpack_require__(659);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_458706de_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_help_page_vue__ = __webpack_require__(1321);
function injectStyle (ssrContext) {
  __webpack_require__(1320)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-458706de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_help_page_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_458706de_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_help_page_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1320 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container my-5"},[_c('p',{},[_vm._v("For any queries related please write to "),_c('br'),_c('a',{attrs:{"href":""}},[_vm._v("support@gogocinema.com")]),_c('br'),_vm._v(" We will get back to you as soon as possible.")]),_c('br'),_vm._v(" "),_c('p',{staticClass:"font-weight-bold mb-0"},[_vm._v("For any feedback")]),_vm._v(" "),_c('p',{},[_vm._v("Please write in feedback section of your profile: We appreciate your feedback and suggestions.It will help us improve our services to our users.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_faqs_vue__ = __webpack_require__(660);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9591550c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_faqs_vue__ = __webpack_require__(1324);
function injectStyle (ssrContext) {
  __webpack_require__(1323)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9591550c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_faqs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9591550c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_faqs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1323 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container my-5"},[_c('div',{staticClass:"text-center title-pp font-weight-bold"},[_vm._v("\n    Frequently asked Questions\n  ")]),_vm._v(" "),_c('div',{attrs:{"role":"tablist"}},[_c('b-card',{staticClass:"mb-3 faq-box",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-1",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-1",modifiers:{"accordion-1":true}}],staticClass:"py-3 font-weight-bold",attrs:{"block":"","href":"#","variant":"info"}},[_vm._v("\n          1. Do I need to create an account to book tickets?\n          "),_c('span',{staticClass:"float-right plus"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(21)}})]),_vm._v(" "),_c('span',{staticClass:"float-right minus"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(70)}})])])],1),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-1","visible":"","accordion":"my-accordion","role":"tabpanel"}},[_c('b-card-body',[_c('b-card-text',[_vm._v("\n            Yes, you need to create an account by sharing a few details such as your email address and telephone number (see our Privacy Policy for the use and disclosure of the data you provide). We require both in order to send you the booking confirmation and other details including a unique QR.  The QR code will be scanned at the theatre so they know you arrived.   If you do not recieve the QR code or booking confirmation, please feel free to Contact us at support@gogocinema.com and we will get back to you ASAP. \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n          ")])],1)],1)],1),_vm._v(" "),_c('b-card',{staticClass:"mb-3 faq-box",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-1",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-2",modifiers:{"accordion-2":true}}],staticClass:"py-3 font-weight-bold",attrs:{"block":"","href":"#","variant":"info"}},[_vm._v("\n          2. What is the difference between Confirmed and\n          Private screening?\n          "),_c('span',{staticClass:"float-right plus"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(21)}})]),_vm._v(" "),_c('span',{staticClass:"float-right minus"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(70)}})])])],1),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-2","visible":"","accordion":"my-accordion","role":"tabpanel"}},[_c('b-card-body',[_c('b-card-text',[_vm._v("\n            GogoCinema is a unique platform that provides movie lovers different options to book their tickets. During the process to book tickets, we give you 3 options to select the type of screening (Private, Confirmed and Confirmed). \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n            "),_c('p',{staticClass:"mt-2"},[_c('strong',[_vm._v("Private Screening:")]),_vm._v(" "),_vm._v("\n              you book the entire theater like a VIP. You chose what, when and with whom you watch it 😉\n            ")]),_vm._v(" "),_c('p',{staticClass:"mt-2"},[_c('strong',[_vm._v("Confirmed Screening:")]),_vm._v(" "),_vm._v("\n              your selected movie title and time is guaranteed as long as you meet the minimum required tickets to purchase.\n\t\t\t\t\t\t\t\t\t\t\n            ")])])],1)],1)],1),_vm._v(" "),_c('b-card',{staticClass:"mb-3 faq-box",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-1",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-3",modifiers:{"accordion-3":true}}],staticClass:"py-3 font-weight-bold",attrs:{"block":"","href":"#","variant":"info"}},[_vm._v("\n          3. Can I host a Corporate event / Private event with Gogocinema?\n          "),_c('span',{staticClass:"float-right plus"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(21)}})]),_vm._v(" "),_c('span',{staticClass:"float-right minus"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(70)}})])])],1),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-3","visible":"","accordion":"my-accordion","role":"tabpanel"}},[_c('b-card-body',[_c('b-card-text',[_vm._v("\n            Yes, definitely. GoGoCinema offers the most convenient way to create a VIP private screening experience for groups, corporations or your own personal event. Just simply select the theatre, movie and showtime and then select the \"Private Screening\" option. Now, your on your way to an amazing VIP Private Screening for your group, company or for that special occasion such as a birthday party or anniversary. Don't see your favorite movie? Contact us at support@gogocinema.com and we'll get back to you ASAP.  \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n          ")])],1)],1)],1),_vm._v(" "),_c('b-card',{staticClass:"mb-3 faq-box",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-1",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-4",modifiers:{"accordion-4":true}}],staticClass:"py-3 font-weight-bold",attrs:{"block":"","href":"#","variant":"info"}},[_vm._v("\n          4. Unconfirmed Bookings Refund and cancellation:\n          "),_c('span',{staticClass:"float-right plus"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(21)}})]),_vm._v(" "),_c('span',{staticClass:"float-right minus"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(70)}})])])],1),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-4","visible":"","accordion":"my-accordion","role":"tabpanel"}},[_c('b-card-body',[_c('b-card-text',[_c('b-card',{staticClass:"mb-3 faq-box",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-1",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.inner1",modifiers:{"inner1":true}}],staticClass:"py-3 font-weight-bold",attrs:{"block":"","href":"#","variant":"info"}},[_vm._v("\n                  4a. What happens to my Confirmed Screening if the minimum number of tickets is not purchased by the cut-off date?\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n                  "),_c('span',{staticClass:"float-right plus"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(21)}})]),_vm._v(" "),_c('span',{staticClass:"float-right minus"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(70)}})])])],1),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2",attrs:{"id":"inner1","visible":""}},[_c('p',{staticClass:"mb-0 p-3"},[_vm._v("\n                  We will inform you that your screening is cancelled. However, you have the option to confirm the screening by purchasing the number of ticket to confirm it. Or, we will refund the cost of your ticket(s) plus the service fee.  \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n                ")])])],1),_vm._v(" "),_c('b-card',{staticClass:"mb-3 faq-box",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-1",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.inner2",modifiers:{"inner2":true}}],staticClass:"py-3 font-weight-bold",attrs:{"block":"","href":"#","variant":"info"}},[_vm._v("\n                  4b. Can I cancel my booking and request a refund for a Confirmed Screening after it is confirmed?\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n                  "),_c('span',{staticClass:"float-right plus"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(21)}})]),_vm._v(" "),_c('span',{staticClass:"float-right minus"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(70)}})])])],1),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2",attrs:{"id":"inner2"}},[_c('p',{staticClass:"mb-0 p-3"},[_vm._v("\n                  As part of the Terms and Conditions, you agreed to no refunds or cancellations. However, we love movie lovers and you can Contact us at support@gogocinema.com to let us know why you need to cancel. We'll get back to ASAP. \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n                ")])])],1)],1)],1)],1)],1),_vm._v(" "),_c('b-card',{staticClass:"mb-3 faq-box",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-1",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-5",modifiers:{"accordion-5":true}}],staticClass:"py-3 font-weight-bold",attrs:{"block":"","href":"#","variant":"info"}},[_vm._v("\n          5. I made a mistake during the booking process and selected the wrong date / time / movie?  How do I amend my screening?\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n          "),_c('span',{staticClass:"float-right plus"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(21)}})]),_vm._v(" "),_c('span',{staticClass:"float-right minus"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(70)}})])])],1),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-5","visible":"","accordion":"my-accordion","role":"tabpanel"}},[_c('b-card-body',[_c('b-card-text',[_vm._v("\n            Don't worry. Please send an email to: support@gogocinema.com with the Booking ID and tell us the correct date / time / movie. We will take care of it for you or get back to you with options. \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n          ")])],1)],1)],1),_vm._v(" "),_c('b-card',{staticClass:"mb-3 faq-box",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-1",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-6",modifiers:{"accordion-6":true}}],staticClass:"py-3 font-weight-bold",attrs:{"block":"","href":"#","variant":"info"}},[_vm._v("\n        6. I booked a screening but haven't receive my ticket yet. Is my transaction confirmed?\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n          "),_c('span',{staticClass:"float-right plus"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(21)}})]),_vm._v(" "),_c('span',{staticClass:"float-right minus"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(70)}})])])],1),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-6","visible":"","accordion":"my-accordion","role":"tabpanel"}},[_c('b-card-body',[_c('b-card-text',[_vm._v("\n            Simply log into your account and check in My Transactions under My Account tab. If your tansaction is not there, you can Contact us at: support@gogocinema.com for help.\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n          ")])],1)],1)],1),_vm._v(" "),_c('b-card',{staticClass:"mb-3 faq-box",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-1",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-7",modifiers:{"accordion-7":true}}],staticClass:"py-3 font-weight-bold",attrs:{"block":"","href":"#","variant":"info"}},[_vm._v("\n          7. We love GoGoCinema and want to inquire about partnering with you.\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n          "),_c('span',{staticClass:"float-right plus"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(21)}})]),_vm._v(" "),_c('span',{staticClass:"float-right minus"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(70)}})])])],1),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-7","visible":"","accordion":"my-accordion","role":"tabpanel"}},[_c('b-card-body',[_c('b-card-text',[_vm._v("\n            We are delighted that you love GoGoCinema. The best way to reach us is to send an email to support@gogocinema.com and tell us what you have in mind. \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n          ")])],1)],1)],1),_vm._v(" "),_c('b-card',{staticClass:"mb-3 faq-box",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-1",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-8",modifiers:{"accordion-8":true}}],staticClass:"py-3 font-weight-bold",attrs:{"block":"","href":"#","variant":"info"}},[_vm._v("\n          8. My favorite movie is not on GoGoCinema.com. What do I need to do to see my favorite movie?\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n          "),_c('span',{staticClass:"float-right plus"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(21)}})]),_vm._v(" "),_c('span',{staticClass:"float-right minus"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(70)}})])])],1),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-8","visible":"","accordion":"my-accordion","role":"tabpanel"}},[_c('b-card-body',[_c('b-card-text',[_vm._v("\n            We have access to thousands of movies and are constantly adding new content to the site. Please Contact us at support@gogocinema.com with the title and we'll see if it's in our library. We'll get back to you if we can get it for you, but you'll need to book a Private Screening. \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n          ")])],1)],1)],1),_vm._v(" "),_c('b-card',{staticClass:"mb-3 faq-box",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-1",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-9",modifiers:{"accordion-9":true}}],staticClass:"py-3 font-weight-bold",attrs:{"block":"","href":"#","variant":"info"}},[_vm._v("\n          9. I have a question that is not listed in the FAQs. Whom do I contact?\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n          "),_c('span',{staticClass:"float-right plus"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(21)}})]),_vm._v(" "),_c('span',{staticClass:"float-right minus"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(70)}})])])],1),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-9","visible":"","accordion":"my-accordion","role":"tabpanel"}},[_c('b-card-body',[_c('b-card-text',[_vm._v("\n            We're always here to help. Simply write to us at support@gogocinema.com with your question. We'll get back to you with the answer. \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n          ")])],1)],1)],1),_vm._v(" "),_c('b-card',{staticClass:"mb-3 faq-box",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-1",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-10",modifiers:{"accordion-10":true}}],staticClass:"py-3 font-weight-bold",attrs:{"block":"","href":"#","variant":"info"}},[_vm._v("\n          10. Are there any credit card discounts / movie gift vouchers / complimantary tickets / special promotions on GoGoCinema.com?\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n          "),_c('span',{staticClass:"float-right plus"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(21)}})]),_vm._v(" "),_c('span',{staticClass:"float-right minus"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(70)}})])])],1),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-10","visible":"","accordion":"my-accordion","role":"tabpanel"}},[_c('b-card-body',[_c('b-card-text',[_vm._v("\n            We work very closely with the theatre's management to offer movie lovers, like you, special discounts and promotions from time to time. If you are registered, please visit our Offers and Promotions page to see if there are any current offer or promotions. \t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n          ")])],1)],1)],1),_vm._v(" "),_vm._m(0)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center pt-5"},[_c('p',{staticClass:"font-weight-bold"},[_vm._v("\n        Haven’t found what you were looking for? Contact us at:\n      ")]),_vm._v(" "),_c('ul',{staticClass:"list-inline"},[_c('li',{staticClass:"list-inline-item pl-md-5 pl-0"},[_c('img',{staticClass:"img-fluid mr-1",attrs:{"src":__webpack_require__(1325),"height":"auto","width":"25"}}),_vm._v(" "),_c('a',{attrs:{"href":"mailto:support@gogocinema.com","target":"_top"}},[_vm._v("support@gogocinema.com")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1325 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAVCAYAAAC33pUlAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAIrSURBVHgBtZVBltJAEIb/Kgjoey44Qm7gzA2GG+AjrJ0bOHMC4ASjJ5BZC8IN0BPADQZPYBa+N0xCuqzqGAUMERH/TSfpqvpS3V3VBFXS4zcQDPSxhXOLsCLBKBi7IaUR9wUGkk8C+oxzi+QlCXUccIukyw/riGb2XTrny8xiFfGSiOZJxF9Z0wwJtLSPaZ31Iy0eOwjxDzJ/i5XWaerB+Yq1eOdvxA0177AW8PxUoPnVajzXaCEc32/P7cCaE8wScm04wSnAbz1ceBBJKyFpNz5mo4Mw04sPWGaZ5MA6L5666OAIpRGuGqIgFmQbubQ4+zZc5vh8hpUHisREPF1HfIMKbbq11wKfUZyl0jb/Mjs+FMAcgkwude2XanRnJYLSjLjvSEZmF6RyeQhUCTNpQcSNsQIF76wW94FFjYrg3uzMvipeJeyXES1stMBal+/t2ca8Geg84eG4OH+QtbJimTT4UOvy2grURnu3rMqyLlO9atIvk+StLNjIK5pJvI4Qa6Z9B7p9NnZvkWcZC3kgrAce/vOI5SniQRnIz3V5hCNkMcy+LMNijg9mZPuhB6M5cdc4Qs2xG/hl3drXff0GKzbeHBsTd4O/UAH0+1oC3IFpRnfFxpsjTtAOULv99pw/IHq5+asgA77o8HPjT5UBH3t2aXLLF8wPUU6ni2zjKqv/VCXanLX7TzWjFeVXggKJQvwvKch6Jtmzv0oCXOnhDHFmCVzc3GBkrew76cwofMlxTP0AAAAASUVORK5CYII="

/***/ }),
/* 1326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_privacyPolicy_vue__ = __webpack_require__(661);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10ecbe27_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_privacyPolicy_vue__ = __webpack_require__(1328);
function injectStyle (ssrContext) {
  __webpack_require__(1327)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-10ecbe27"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_privacyPolicy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10ecbe27_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_privacyPolicy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1327 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container my-5 privacy_policy"},[_c('article',{staticClass:"text-center title-tc font-weight-bold"},[_vm._v("\n       GOGOCINEMA PRIVACY POLICY\n   ")]),_vm._v(" "),_c('p',[_c('span',[_vm._v("This Privacy Policy (“"),_c('strong',[_vm._v("Privacy Policy")]),_vm._v("”) explains privacy practices of GOGOCINEMA referred to as “"),_c('strong',[_vm._v("GoGoCinema")]),_vm._v("” or “"),_c('strong',[_vm._v("We")]),_vm._v("”), regarding collection, use and disclosure of information you provide, in accordance with the California Consumer Privacy Act (CCPA) of 2018. We may collect information from you if you are users of the GoGoCinema mobile application (“"),_c('strong',[_vm._v("App")]),_vm._v("”) and website located at ")]),_c('a',{attrs:{"href":"http://www.gogocinema.com"}},[_c('span',[_vm._v("www.gogocinema.com")])]),_c('span',[_vm._v(" (“"),_c('strong',[_vm._v("Website")]),_vm._v("”), and when you contact us via the App, the Website, emails and other communication methods that link to other services provided by GoGoCinema (“"),_c('strong',[_vm._v("Services")]),_vm._v("”). By using the GoGoCinema App and/or Website, or by accessing our Services, you agree to this Privacy Policy.  ")])]),_vm._v(" "),_c('ol',[_c('li',[_c('p',[_c('strong',[_vm._v("\n              TYPES OF INFORMAITON\n           ")])]),_vm._v(" "),_c('p',[_vm._v("\n               We collect two main types of information about you – Personal Information and Anonymous Information. \n           ")]),_vm._v(" "),_c('ol',[_c('li',[_c('strong',[_vm._v("\n                      “Personal Information”")]),_vm._v(" means information that identifies you, including your full name (i.e. first and last), telephone number, postal delivery address, email address, payment information (e.g. credit card, debit card, or other payment methods accepted on GoGoCinema App and/or Website). If your Personal Information is combined with Anonymous Information as defined hereunder, we will treat such combined information as Personal Information while it remains combined.\n               ")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("\n                      “Anonymous Information”")]),_vm._v(" means information in a form that does not directly or on its own identify you personally as a specific individual, but relates to you and/or the computer or mobile device you use to access our App, Website or Services. Anonymous Information includes but is not limited to your postal codes, locations, time zone, preferences (e.g. film viewing, downloaded apps, parts or functions of our Services you access, visiting history of websites, advertising you view or you block), or other information regarding your access to our Services (e.g. Internet connection, equipment or software you use to access our Services).\n               ")])])]),_vm._v(" "),_c('li',[_c('p',[_c('strong',[_vm._v("\n               COLLECTION OF INFORMATION")])]),_vm._v(" "),_c('p',[_vm._v("\n                   GoGoCinema undertakes to collect your information as permitted by law, and that the collection of your information will be reasonable and necessary to operate the App or Website, and to perform our Services. We collect your information mainly in three ways as stated below.\n               ")]),_vm._v(" "),_c('ol',[_c('li',[_c('p',[_c('strong',[_vm._v("\n                           Information Directly and Voluntarily Provided by You.")]),_vm._v(" We may collect Personal Information directly from you if you provide it to us voluntarily, when you access our Services, register an account with GoGoCinema App and/or Website, buy movie tickets or make other purchases via our Services, respond to surveys, contact us and when you otherwise communicate or interact with GoGoCinema. When you contact us or otherwise interact with us via publicly available sites and/or platforms, we will collect and store information contained in your communications, comments, ratings or reviews. As you use our App, Website, or other Services, upon your consent, we may collect location-based information such as real-time geographic location of your computer or mobile device through your location-aware devices, and we may access your device’s storage applications and contacts.  If you would like us to delete the information you provided to us, please contact us at "),_c('a',{attrs:{"href":"http://support@gogocinema.com"}},[_vm._v("support@gogocinema.com")]),_vm._v(" and refer to Section 8 below.  Additionally, if you decided to delete your information, GoGoCinema may not be able to continue to provide Services to you as such information is necessary for the GoGoCinema Services to function properly.")]),_vm._v(" "),_c('p',[_vm._v("\nPlease note that independent third parties not affiliated with GoGoCinema "),_c('strong',[_vm._v("\n    (“Third Parties”)")]),_vm._v(" may have access to your devices when your GoGoCinema account stays logged-in, and such Third Parties may share your information with us. At the same time, Third Parties may have access to your information that you have provided to us when your GoGoCinema account stays logged-in. To protect your privacy, you should log off from our App, Website, or Services after using any public or shared devices. Third Parties (including third-party data aggregators) may have their own separate privacy policies which are independent from GoGoCinema.  If you have any questions about privacy policies from Third Parties, please consult such Third Parties.  If you would like the information you provided to us deleted, please contact us at "),_c('a',{attrs:{"href":"http://support@gogocinema.com"}},[_vm._v("support@gogocinema.com")]),_vm._v(" and refer to Section 8 below.  If you would like the information you provided to Third Parties deleted, please contact such Third Parties.  \n                       ")])]),_vm._v(" "),_c('li',[_c('p',[_c('strong',[_vm._v("\n                                Information Automatically Collected by Us.\n                                ")]),_vm._v(" We may gather your information through use of cookies or other technologies, when you visit our Website, download the App, or access our Services. Information automatically collected from you is gathered in aggregate only and cannot be traced to any individual user. As for the App and Website, we may automatically collect and store log files related to Anonymous Information, including browser type, operating system, date/time stamp, Internet service provider, referring/exit pages, and clickstream data. In addition, our servers (which may be hosted by an authorized third party service provider) may collect information from you, including your IP address from which you send any request, browser type, operating system, domain name, date/time stamp of your visit, and/or URL of any page that direct you to our App, Website or Services. \n                       ")]),_vm._v(" "),_c('p',[_vm._v("\n                           After you provide us with your information and when you stay logged-in, we may automatically associate that information and other information we collect through your GoGoCinema account, so that we may identify you across various devices, browsers and networks. We may also automatically collect your information that enables us to recognize you across various devices you use, when you are not logged-in. In addition, when you use a Wi-Fi network that we have access to, we may detect and identify any device(s) you used previously to log in your GoGoCinema account.  If you would like us to delete the information you provided to us, please contact us at "),_c('a',{attrs:{"href":"http://support@gogocinema.com"}},[_vm._v("support@gogocinema.com")]),_vm._v(" and refer to Section 8 below.  Additionally, if you decided to delete your information, GoGoCinema may not be able to continue to provide Services to you as such information is necessary for the GoGoCinema Services to function properly.\n                       ")])]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("\n                           Information Provided by and Obtained from Third Parties.")]),_vm._v("\t We may obtain information of you from a third-party data aggregator, cookie technology operator, advertising network, or another type of data company. When you log in to our App and/or Website, access our Services, interact with social networks or contact us via a social media platform (e.g. a plug-in such as Facebook “Like” button), you may grant to us an ongoing access to your social network profile, including your name, email address, photo, age, gender, location, birthday, social networking ID, current city, etc.  You may opt-out of providing GoGoCinema access to your social network profile at any time either through the Website, App, and/or "),_c('a',{attrs:{"href":"http://support@gogocinema.com"}},[_vm._v("support@gogocinema.com")]),_vm._v(".  Notwithstanding the above, in no event shall GoGoCinema collect any information from you and/or other persons if you and/or other persons are not of legal age, provided that, Third Parties (including third-party data aggregators) may have their own separate privacy policies which are independent from GoGoCinema.  If you have any questions about privacy policies from Third Parties, please consult such Third Parties.  \n                   ")])])]),_vm._v(" "),_c('li',[_c('p',[_c('strong',[_vm._v("\n               \tUSE OF INFORMATION")])]),_vm._v(" "),_c('p',[_vm._v("\n                       We (and/or authorized third party service providers) may use the information collected from you for operation of our App and Website, provision of related Services, and/or other relevant business purposes. \n                   ")]),_vm._v(" "),_c('ol',[_c('li',[_c('strong',[_vm._v("\n                               Ticket-Booking and Communications.")]),_vm._v(" We (and/or authorized third party service providers) may use your Personal Information to create and administer your GoGoCinema account if you register one, confirm your ticket booking orders via the App or Website, keep you updated of screening or order status, process your online payment, deliver any e-ticket(s) to you, and provide you with other customer services. We may use your information to respond to your inquiries, requests and comments on the App, Website, or our Services. From time to time, we may use your Personal Information to send important notices including any changes to this Privacy Policy and/or "),_c('u',[_vm._v("\n                                   Terms and Conditions")]),_vm._v(", announcements and administrative messages. \n                       ")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("\n                               Operation, Maintenance and Improvements.")]),_vm._v(" Your information may be used to provide technical support to our App, Website and Services. We (and/or authorized third party service providers) may use your information to match your device(s) with your GoGoCinema account profile, to do internal research on your demographics, interests, preferences, behaviors or how you use our App, Website or Services, to analyze trends, to administer our App and/or Website, to track traffic patterns and to gather demographic information for aggregate use, and/or to customize and improve our development, services, content display or advertising. To protect the safety of our business and our users, your information might be used to investigate any fraudulent or illegal activities, to comply with legal and regulatory requirements, or to monitor your compliance with our Terms and Conditions. \n                       ")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("\n                               Marketing and Promotion.")]),_vm._v(" Subject to your rights and choices under Article 8 of this Privacy Policy, we may send you emails regarding newsletters on upcoming events, films or screenings, promotional materials, and latest services offered by GoGoCinema. We may use your information to improve our marketing and promotional activities, content offerings, layout and usages of the App, Website and/or Services. \n                       ")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("\n                               Sale of Personal Information (FOR CALIFORNIA RESIDENTS ONLY).")]),_vm._v("  Please be advised that GogoCinema does not, and has not sold any personal information in the last twelve (12) months.  However, GoGoCinema respects and understands that you may still want to ensure your personal information is not sold.  Therefore, if you would still like to proceed with your “do not sell my information” request, we ask that you kindly contact us at "),_c('a',{attrs:{"href":"http://support@gogocinema.com"}},[_vm._v("support@gogocinema.com")]),_vm._v(" and provide us with the following information:\n                              "),_c('div',{staticClass:"mt-3"},[_vm._v("\n                                  1)\tFirst Name\n2)\tLast Name\n3)\tEmail\n4)\tAddress\n5)\tCity\n6)\tState\n7)\tPostal Code\n8)\tRequested Action\n\n                              ")])])])]),_vm._v(" "),_c('li',[_c('p',[_c('strong',[_vm._v("\n             COOKIES AND OTHER TECHNOLOGY")])]),_vm._v(" "),_c('p',[_vm._v("\n                   When you use our App, Website or Services, we (and/or authorized third party service providers) may place Cookies on your device, subject to Article 8 of this Policy and our "),_c('u',[_vm._v("\n                       Cookies Policy")]),_vm._v(". GoGoCinema "),_c('u',[_vm._v("Cookies Policy")]),_vm._v(" applies to any use of our App, Website and Services, and is hereby incorporated into the Privacy Policy.\n               ")])]),_vm._v(" "),_c('li',[_c('p',[_c('strong',[_vm._v("\n              DISCLOSURE TO THIRD PARTIES")])]),_vm._v(" "),_c('p',[_vm._v("\n              We may disclose Anonymous Information to Third Parties, and we generally use your Personal Information within GoGoCinema. We will not disclose your Personal Information to any Third Parties without your prior express consent, unless your Personal Information is required by laws and regulations. You may also revoke your consent at any time by contacting us at "),_c('a',{attrs:{"href":"http://support@gogocinema.com"}},[_vm._v("support@gogocinema.com")]),_vm._v(".  However, we may disclose your information necessary for business purposes relating to our App, Website and Services. \n          ")]),_vm._v(" "),_c('ol',[_c('li',[_c('strong',[_vm._v("\n                      Third Party Service Providers.")]),_vm._v(" We may engage Third Party service providers to offer services such as software and application development, analytics, hosting, database maintenance, contest administration, provision of other technology platforms, payment processing, or deliveries. We may share your Personal Information with Third Party service providers, theatres, venue operators, event promoters, mobile carriers, device makers or operators, to the extent that your Personal Information disclosed to Third Parties is necessary for those Third Parties to perform services on behalf of GoGoCinema. If you separately provide your Personal Information to Third Parties and we share Anonymous Information with those Third Parties thereafter, Third Parties may match Anonymous Information disclosed by us with other Personal Information received from you. Third Parties (including third-party data aggregators) may have their own separate privacy policies which are independent from GoGoCinema.  If you have any questions about privacy policies from Third Parties, please consult such independent Third Parties.  \n              ")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("\n                      Public Postings.")]),_vm._v(" You may use certain features of our App, Website or Services that cause your information to be publicized on your social networks (e,g, Facebook, Twitter). You may also provide or post your information on message boards, chat rooms, or other public areas that constitute part of our App, Website or Services. Those public postings can be freely used or disclosed to Third Parties by GoGoCinema.\n              ")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("\n                      Other Corporate Entities.")]),_vm._v(" We may share your Personal Information with our affiliates, including but not limited to parent companies, subsidiaries, and/or joint venturers, who are engaged to perform services for the App or Website worldwide. The entities with access to your Personal Information are obligated to protect your Personal Information pursuant to privacy policy no less protective of you than this Privacy Policy. \n              ")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("\n                      Legal Reasons.")]),_vm._v(" We may disclose your information by reason of law, legal process, pending or potential litigation or requests from public and governmental bodies, either within or outside your country of residency. We may also disclose your information if such disclosure is necessary to enforce "),_c('u',[_vm._v("\n                          Terms and Conditions")]),_vm._v(", or to protect GoGoCinema or protect the privacy of users of the App, Website or Services.  In the event of any reorganization, merger, or business transfer, we may at our sole discretion sell, transfer, assign any and all your information to a Third Party that is a part of or is related to the transaction. Upon completion of such transaction, the privacy policy of the such Third Party will govern the privacy practices regarding your information.  \n              ")])])]),_vm._v(" "),_c('li',[_c('p',[_c('strong',[_vm._v("\n               SECURITY AND PROTECTION OF INFORMATION")])]),_vm._v(" "),_c('p',[_vm._v("\n                   GoGoCinema endeavors to ensure privacy, integrity and security of your information. We take reasonable technical, physical, and procedural safeguards to protect against loss, misuse or any unauthorized access, disclosure, amendment or destruction of your Personal Information. To uphold your privacy and security of your GoGoCinema account, we may take identity authentication measures before granting you access, such as requiring your user ID and password. However, in light of current technologies, no data transmission over the Internet or any security system can be guaranteed to be 100% secure. It may be possible for unauthorized Third Parties to unlawfully obstruct or access transmissions of your information. Therefore, GoGoCinema cannot guarantee the security of your information or assume any liability for improper use or access to our App, Website, or Services. Please note that any data transmission to us is at your own risk, and you may contact us if you find your interaction with us is no longer secure. \n               ")]),_vm._v(" "),_c('p',[_vm._v("\n                   You shall maintain privacy of your GoGoCinema account, and restrict access to your device(s) that you use to access GoGoCinema account. If you disclose your password to or share your GoGoCinema account with any other person, you shall be liable for that other person’s acts. Where applicable, you shall log out of your GoGoCinema account or deactivate any public or shared devices after you finish using our App, Website or Services. Please remember if you forget to log out of your GoGoCinema account or deactivate your device(s), other persons may access your information contained in your GoGoCinema account or your device(s). \n               ")])]),_vm._v(" "),_c('li',[_c('p',[_c('strong',[_vm._v("\n              RETENTION OF INFORMATION")])]),_vm._v(" "),_c('p',[_vm._v("\n                  We may retain your information as long as the retention is consistent with the purpose of information collection. To operate, maintain and improve our App, Website or Services, we may retain your information in our logs, backups and audit trails within short-term retention cycles as determined by GoGoCinema. After expiry of the cycle(s), we will destroy your information. However, we may retain your information beyond retention cycles as is required by law, court order(s) or any request(s) of law enforcement agencies. Under those circumstances, we may inform you of the retention, unless the law prohibits so. We may also retain your information beyond retention cycles for marketing purposes, unless you opt out under Article 8 of this Policy. While you remain a user of our App, Website, or Services, we will keep your information. If you request to delete your GoGoCinema account, or cease to use our App, Website or Services, we will delete your Personal Information upon your request. However, your Anonymous Information will be kept in our database for future operation, maintenance and improvement of our App, Website or Services. \n              ")])]),_vm._v(" "),_c('li',[_c('p',[_c('strong',[_vm._v("\n              YOUR RIGHTS AND CHOICES")])]),_vm._v(" "),_c('ol',[_c('li',[_c('strong',[_vm._v("\n                      Access, Amendment and Deletion.")]),_vm._v("\tUnless otherwise stated in this Policy, you may access, amend, restrict processing or delete any Personal Information contained in your GoGoCinema account, via the App, Webiste or by contacting us at support@gogocinema.com. Upon receiving your request to close your GoGoCinema account, we will deactivate your account. However, your public postings will not be deleted, nor will any information we retain as required by local laws and regulations. \n              ")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("\n                      Cookies, Similar Technologies and Location.")]),_vm._v(" To opt-out of Cookies, similar technologies or real-time location, you may set settings of your device(s) to stop accepting Cookies (or notify you before accepting any Cookies from any sites you visit) or block the use of the location function. If you do not accept Cookies or block the use of your current location, you may not be able to access all Services provided by us, or certain features of our App or Website.  \n              ")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("\n                      Preferences and Subscription.")]),_vm._v(" Occasionally, you may receive free newsletters and other promotional materials via emails on our App, Website and Services. You may indicate your preference to unsubscribe to those marketing materials via email or by contacting us at "),_c('a',{attrs:{"href":"http://support@gogocinema.com"}},[_vm._v("support@gogocinema.com")]),_vm._v(". If any Services are done by text messages subject to your prior consent, your mobile service provider’s standard rates and fees shall apply. We will not be liable for any receipt delays, as SMS message deliveries are undertaken by your mobile carriers. \n              ")]),_vm._v(" "),_c('li',[_c('p',[_c('strong',[_vm._v("\n                      Opt-out Preferences.")]),_vm._v("  You may opt-out of the following at any time by contacting us at "),_c('a',{attrs:{"href":"http://support@gogocinema.com"}},[_vm._v("support@gogocinema.com")]),_vm._v(":\n                ")]),_vm._v("\n                      1)\tSection 3 – Use of Information\n2)\tSection 4 – Cookies and Other Technology\n3)\tSection 5 – Disclosure to Third Parties\n"),_c('p',[_vm._v("\n    If you decide to opt-out of GoGoCinema’s certain use of information, GoGoCinema may not be able to continue to provide Services to you as such information is necessary for the GoGoCinema Services to function properly.  Additionally, to the extent that any information is in the public domain and/or subject to legal process, GoGoCinema may not be able to fully comply with your opt-out request.  However, GoGoCinema will use commercially reasonable efforts to comply with your opt-out request.\n")]),_vm._v(" "),_c('p',[_vm._v("\n    Furthermore, announcements and administrative reminders may not be opted out, including any updates to this Privacy Policy or our Terms and Conditions, confirmation of your order or payment status, or electronic communications with you relating to security, privacy and other administrative matters about your GoGoCinema account or your use of the App, Website or our Services. \n")])])])]),_vm._v(" "),_c('li',[_c('p',[_c('strong',[_vm._v("\n               CONSENT TO PROCESSING AND TRANSFER OF INFORMATION ABOUT YOU")])]),_vm._v(" "),_c('p',[_vm._v("\n                   Our App, Website and Services are governed by and operated in adherence to the laws of California. GoGoCinema makes no representation whatsoever that the App, Website and our Services are governed by or operated according to the laws of any other jurisdiction. Please be aware that information we collect, including Personal Information may be stored, transferred to, used or handled by GoGoCinema in California. However, government, courts, or law enforcement authorities, either within our outside your country of residency may have access to your Personal Information. \n               ")])]),_vm._v(" "),_c('li',[_c('p',[_c('strong',[_vm._v("\n               CHILDREN ")])]),_vm._v(" "),_c('p',[_vm._v("\n                   We do not collect Personal Information from children under 18 years of age with actual knowledge. If we later learn that we have unintentionally collected any Personal Information of a child aged below 18, we will take prompt steps to remove that child’s Personal Information from our databases and to prevent that child’s access to our App, Website or Services as soon as practically possible.\n               ")])]),_vm._v(" "),_c('li',[_c('p',[_c('strong',[_vm._v("\n            \tTHIRD-PARTY SITES AND SERVICES")])]),_vm._v(" "),_c('p',[_vm._v("\n                    The App, Website or our Services may contain links to third-party applications, websites or services. We may also engage third parties (e.g. advertisers) to use or offer products or services on our App, Website or other Services. Please understand that Third Parties may use cookies or other technologies to collect your information, such as your visits to our App, Website or other apps and websites, Internet service provider, advertising device identifier, or the browser you use to access our App, Website or Services. Your information may be collected, used and handled by third parties in accordance with their privacy practices, which can differ from ours. If you have any questions about privacy policies from Third Parties, please consult such Third Parties.  \n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                    When you access another application, website or services operated by Third Parties, please note that this Privacy Policy does not govern any applications, websites operated by Third Parties or any other Third Party services. You should refer to privacy policy of Third Parties for their use of cookies and other technologies. GoGoCinema is not responsible for any policies of Third Party applications or websites, or any services of Third Parties. You should always examine privacy practices of any Third Parties, before accessing those Third Party applications, websites or services. \n                ")])]),_vm._v(" "),_c('li',[_c('p',[_c('strong',[_vm._v("\n              UPDATES TO THIS POLICY")])]),_vm._v(" "),_c('p',[_vm._v("\n                  We may update this Privacy Policy in the future, at the sole discretion of GoGoCinema. We will inform you of material changes by posting the latest Privacy Policy on our App, Website, and/or through our Services. You may determine when the Privacy Policy was last revised in reference to below “Last updated” date. We may take other appropriate measures under the circumstances to announce such changes. You should regularly check our App, the Website, or consult through our Services for the latest version of this Privacy Policy. \n              ")])]),_vm._v(" "),_c('li',[_c('p',[_c('strong',[_vm._v("\n            \tCONTACT")])]),_vm._v(" "),_c('p',[_vm._v("\n                    We welcome your comments and feedbacks on our App, Website, our Services, including this Privacy Policy. Should you have any further queries with respect to this Privacy Policy, please contact "),_c('a',{attrs:{"href":"http://support@gogocinema.com"}},[_vm._v("\n                    support@gogocinema.com")]),_vm._v(". \n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                    For any questions about the information you provided to GoGoCinema, please contact us at "),_c('a',{attrs:{"href":"http://support@gogocinema.com"}},[_vm._v("\n                    support@gogocinema.com")]),_vm._v(" or GOGOCINEMA ATTN: Customer Service Department, 1016 W. Magnolia Blvd., Burbank, CA 91506\n                ")])])]),_vm._v(" "),_c('p',[_c('a',{attrs:{"href":"http://support@gogocinema.com"}},[_vm._v("\n                    support@gogocinema.com")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cookiesprivacyPolicy_vue__ = __webpack_require__(662);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_514dfd87_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cookiesprivacyPolicy_vue__ = __webpack_require__(1331);
function injectStyle (ssrContext) {
  __webpack_require__(1330)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-514dfd87"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cookiesprivacyPolicy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_514dfd87_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cookiesprivacyPolicy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1330 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container my-5 cookies_privacy_policy"},[_c('div',{staticClass:"text-center title-pp font-weight-bold"},[_vm._v("GOGOCINEMA COOKIES POLICY")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"14px","line-height":"115%"}},[_vm._v("This Cookies Policy (including any updates thereof) (collectively, “"),_c('strong',[_vm._v("Cookies Policy")]),_vm._v("”) explains practices of GOGOCINEMA (referred to as “"),_c('strong',[_vm._v("GoGoCinema")]),_vm._v("” or “"),_c('strong',[_vm._v("We")]),_vm._v("”), regarding application of Cookies in the GoGoCinema mobile application (“"),_c('strong',[_vm._v("App")]),_vm._v("”) and website located at ")]),_c('a',{attrs:{"href":"http://www.gogocinema.com"}},[_c('span',{staticStyle:{"font-size":"14px","line-height":"115%"}},[_vm._v("www.gogocinema.com")])]),_c('span',{staticStyle:{"font-size":"14px","line-height":"115%"}},[_vm._v(" (“"),_c('strong',[_vm._v("Website")]),_vm._v("”), and when you engage with us via the App, the Website, emails and other communication methods that link to other services provided by GoGoCinema (collectively, “"),_c('strong',[_vm._v("Services")]),_vm._v("”). By using the GoGoCinema App and/or Website, or by accessing our Services, you agree to this Cookies Policy.  ")])]),_vm._v(" "),_c('p',[_c('span',{staticStyle:{"font-size":"14px","line-height":"115%"}},[_vm._v("“"),_c('strong',[_vm._v("Cookies")]),_vm._v("” refers to data pieces that a web server issues to browsers of visitors and those data pieces are stored on the hard drive of visitors’ devices for record keeping. Cookies track or remember the frequency of online users visiting a site, user preferences, efficiency of navigation between web pages, or effectiveness of advertisements and web searches.  ")]),_c('span',{staticStyle:{"font-size":"14px","line-height":"115%"}},[_vm._v("For example, we use cookies to remember your preferred language, to make the ads you see more relevant to you, to count how many visitors we receive to a page, to help you sign up for our services, to protect your data, and to remember your ad settings. ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"14px","line-height":"115%"}},[_vm._v("When you use our App, Website or Services, we (and third-party service providers) may place Cookies on your device, subject to this Cookies Policy. We may gather your information through use of Cookies or other technologies, when you visit our Website, download the App, or access our Services, subject to this Cookies Policy. Further to Cookies, we may use other technologies such as pixel tags which are embedded invisibly in our App or Website. A pixel tag tells us when users visit a certain website or open an email, or allows us to gather data for online marketing, email marketing or other website analysis. ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"14px","line-height":"115%"}},[_vm._v("Cookies and other technologies may provide you with a more personal and interactive experience with our App, Website or Services, when we may utilize Cookies and other technologies to diagnose problems, to handle issues of our Services, or to access popular pages, conversion rates, click-through, your special needs and interests. Your information collected by Cookies or other technologies is aggregated thus regarded as Anonymous Information by us, unless local laws and regulations categorize IP addresses or similar identifiers as Personal Information. ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"14px","line-height":"115%"}},[_vm._v("To manage how Cookies are used, you can refuse the use of Cookies through your personalized browser settings. To opt-out of Cookies, and/or similar technologies, you may change options in your privacy settings on your device(s) to accept or stop accepting Cookies (or notify you before accepting any Cookies from any sites you visit) or block the use of location function. Additionally, we shall provide you with a conspicuous option to opt-out of Cookies on our App or Website.  ")]),_c('span',{staticStyle:{"font-size":"11px","line-height":"115%"}},[_c('a',{attrs:{"href":"#_msocom_1","id":"_anchor_1","language":"JavaScript","name":"_msoanchor_1"}},[_vm._v("[KH1]")]),_vm._v(" ")]),_c('span',{staticStyle:{"font-size":"14px","line-height":"115%"}},[_vm._v("If you opt-out of Cookies or block the use of your current location, you may not be able to access all Services provided by us, or certain features of our App or Website. ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"14px","line-height":"115%"}},[_vm._v("Please understand that third parties may use Cookies or other technologies to collect your information, such as your visits to our App, Website or other apps and websites, Internet service provider, advertising device identifier, or the browser you use to access our App, Website or Services. Your information may be collected, used and handled by third parties in accordance with their privacy practices or Cookies policies, which can differ from ours.  If you have any questions about privacy policies or Cookies policies from third parties, please consult such independent Third Parties.  ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"14px","line-height":"115%"}},[_vm._v("GoGoCinema is not responsible for any policies of third-party applications or websites, or any services of third parties. You should always examine privacy practices or Cookies policies of any third parties, before accessing those third-party applications, websites or services.")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"14px","line-height":"115%"}},[_vm._v("We may update this Cookies Policy in the future, at the sole discretion of GoGoCinema. We will inform you of material changes by posting the latest Cookies Policy on our App, Website, and/or through our Services. You may determine when the Cookies Policy was last revised in reference to below “Last updated” date. We may take other appropriate measures under the circumstances to announce such changes. You should regularly check our App, the Website, or consult through our Services for the latest version of this Cookies Policy. ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"14px","line-height":"115%"}},[_vm._v("We welcome your comments and feedbacks on our App, Website, our Services, including this Cookies Policy. Should you have any further queries with respect to this Cookies Policy, please contact us at support@gogocinema.com.")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"14px","line-height":"115%"}},[_vm._v("For any questions about the information you provided to GoGoCinema, please contact us at ")]),_c('a',{attrs:{"href":"mailto:support@gogocinema.com"}},[_c('span',{staticStyle:{"font-size":"14px","line-height":"115%"}},[_vm._v("support@gogocinema.com")])]),_c('span',{staticStyle:{"font-size":"14px","line-height":"115%"}},[_vm._v(" or GOGOCINEMA ATTN: Customer Service Department 1016 W. Magnolia Blvd., Burbank, CA 91506")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"14px","line-height":"115%"}},[_vm._v("Last updated: October 2021")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"center"}},[_c('span',{staticStyle:{"font-size":"14px","line-height":"115%"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"center"}},[_c('strong',[_c('span',{staticStyle:{"font-size":"16px","line-height":"115%"}},[_vm._v("Cookie Consent Banner")])])]),_vm._v(" "),_c('p',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","line-height":"15.0pt","background":"white"}},[_c('span',{staticStyle:{"font-size":"14px","line-height":"115%"}},[_vm._v("This website uses cookies to improve your experience while you navigate through the website. Out of these cookies, the cookies that are categorized as necessary are stored on your browser as they as essential for the working of basic functionalities of the website. We also use third-party cookies that help us analyze and understand how you use this website, to store user preferences and provide them with content and advertisements that are relevant to you. These cookies will only be stored on your browser with your consent to do so. You also have the option to opt-out of these cookies. But opting out of some of these cookies may have an effect on your browsing experience.")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":".0001pt","line-height":"normal"}},[_c('span',{staticStyle:{"font-size":"14px","color":"black","background":"white"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":".0001pt","line-height":"normal"}},[_c('span',{staticStyle:{"font-size":"14px","line-height":"115%"}},[_vm._v("By clicking “Accept All”, you consent to our website's use of cookies to give you the most relevant experience by remembering your preferences and repeat visits. However, you may visit “Cookie Settings” to provide controlled consent.")])]),_vm._v(" "),_c('p',[_vm._v(" ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_termsCondition_vue__ = __webpack_require__(663);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ef64a8c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_termsCondition_vue__ = __webpack_require__(1334);
function injectStyle (ssrContext) {
  __webpack_require__(1333)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_termsCondition_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ef64a8c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_termsCondition_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1333 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container my-5"},[_c('div',{staticClass:"termsCondition"},[_c('div',{staticClass:"text-center title-tc font-weight-bold pb-2"},[_vm._v("GOGOCINEMA TERMS AND CONDITIONS")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","text-align":"center","background":"white"}},[_c('strong',[_c('span',{staticStyle:{"font-size":"14px","color":"#212529"}},[_vm._v(" ")])])]),_vm._v(" "),_c('p',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","background":"white"}},[_c('span',{staticStyle:{"font-size":"14px","color":"#212529"}},[_vm._v("Thank you for visiting the GoGoCinema website and if you\n                have done so, downloading the GoGoCinema mobile application. These Terms and Conditions including\n                any changes thereof (“"),_c('strong',[_vm._v("Terms and Conditions")]),_vm._v("”) were last updated in\n                August 2019 by GOGOCINEMA Asia Pacific Pte Ltd (referred to as\n                “"),_c('strong',[_vm._v("GoGoCinema")]),_vm._v("” or “"),_c('strong',[_vm._v("We")]),_vm._v("”). Terms and\n                Conditions apply to your access and use of GoGoCinema mobile application, including all versions,\n                updates and modifications (“"),_c('strong',[_vm._v("App")]),_vm._v("”), GoGoCinema website located at\n                [gogocinema.com] (“"),_c('strong',[_vm._v("Website")]),_vm._v("”), and other related services provided by\n                GoGoCinema, in connection with the App or Website (“"),_c('strong',[_vm._v("Services")]),_vm._v("”).")])]),_vm._v(" "),_c('p',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","background":"white"}},[_c('span',{staticStyle:{"font-size":"14px","color":"#212529"}},[_vm._v("Your feedback is valuable to us and welcomed at all times.\n                Should you have any feedback, comments or complaints on our App, Website and/or Services, please\n                contact us at ")]),_c('a',{attrs:{"href":"https://www.gogocinema.com/termsCondition"}},[_c('span',{staticStyle:{"font-size":"14px","color":"#007BFF"}},[_vm._v("support@gogocinema.com")])]),_c('span',{staticStyle:{"font-size":"14px","color":"#212529"}},[_vm._v(".")])]),_vm._v(" "),_c('ol',{staticStyle:{"margin-bottom":"0in"},attrs:{"start":"1","type":"1"}},[_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"#212529","background":"white"}},[_c('strong',[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("ACCEPTANCE OF TERMS AND CHANGES")])]),_vm._v(" "),_c('ol',{staticStyle:{"margin-bottom":"0in"},attrs:{"start":"1","type":"1"}},[_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"#212529","background":"white"}},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("By downloading or using the App, visiting the Website or using\n                            our Services, including ordering and buying tickets, attending the theatres, providing\n                            reviews or comments on the App or Website –")]),_vm._v(" "),_c('ol',{staticStyle:{"margin-bottom":"0in"},attrs:{"start":"a","type":"a"}},[_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"#212529","background":"white"}},[_c('strong',[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("You accept and represent that you have read,\n                                        understand and agree to be bound by the Terms and\n                                        Conditions,")])]),_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v(" and that you\n                                    have the legal capacity and authority to enter into Terms and Conditions with\n                                    GoGoCinema, under the laws of California, your place of residency, or any other\n                                    applicable jurisdiction. "),_c('strong',[_vm._v("If you do not agree to the Terms and\n                                        Conditions, do not use the App, Website or Services.")]),_vm._v(" Terms and\n                                    Conditions (including "),_c('u',[_vm._v("Privacy Policy")]),_vm._v(" and "),_c('u',[_vm._v("Cookies Policy")]),_vm._v(") can be\n                                    changed by GoGoCinema at its sole discretion from time to time. The latest\n                                    version of Terms and Conditions will be available via the App and Website, and\n                                    will supersede any previous versions. In case of any changes, the “Latest\n                                    Updated” date at the end of Terms and Conditions will also be\n                                    updated.")])]),_vm._v(" "),_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"#212529","background":"white"}},[_c('strong',[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("You agree to be bound by all terms and\n                                        conditions, privacy policy, house rules and/or other rules set by GoGoCinema\n                                        participating cinema theatres, where the movie contents displayed on the App\n                                        or Website will be screened. Any breach of terms and conditions, policies or\n                                        rules set by relevant cinema theatres will constitute breach of this Terms\n                                        and Conditions.")])]),_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v(" You\n                                    understand that third parties’ terms and conditions, policies or rules can\n                                    differ from ours, and GoGoCinema is not responsible for any terms and\n                                    conditions, policies or rules of third parties. "),_c('strong',[_vm._v("If you do not agree to\n                                        any terms and conditions, policies or rules set by relevant cinema theatres,\n                                        do not use the App, Website or Services.")])])])])]),_vm._v(" "),_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"#212529","background":"white"}},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("You are responsible for reviewing the Terms and Conditions\n                            periodically for such changes. "),_c('strong',[_vm._v("After we post any changes onto the App or\n                                Website, your continued use or access to our App, Website or Services constitutes\n                                acceptance of such changes.")]),_vm._v(" If you register to create your GoGoCinema\n                            account with us, we may send an email to you at the latest email address you provide to\n                            us, informing you of material changes made to the Terms and Conditions. If you do not\n                            agree to any changes after receiving such reminder via email, you should cease the use\n                            of our App, Website or Services.")])])])]),_vm._v(" "),_c('p',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","background":"white"}},[_c('span',{staticStyle:{"font-size":"14px","color":"#212529"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","background":"white"}},[_c('span',{staticStyle:{"font-size":"14px","color":"#212529"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","margin-left":"1.0in","background":"white"}},[_c('span',{staticStyle:{"font-size":"14px","color":"#212529"}},[_vm._v(" ")])]),_vm._v(" "),_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"#212529","background":"white"}},[_c('strong',[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("REGISTRATION, ACCOUNTS AND PASSWORDS")])]),_vm._v(" "),_c('ol',{staticStyle:{"margin-bottom":"0in"},attrs:{"start":"1","type":"1"}},[_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"#212529","background":"white"}},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("To access certain features of our App, Website or Services,\n                            you need to set up a GoGoCinema account. By establishing a GoGoCinema account, you\n                            represent and warrant that you are of legal age to form a binding contract and you are\n                            not barred from opening GoGoCinema account, using the App, Website, or Services under\n                            the laws of California, your place of residency, or any other applicable jurisdiction.\n                            Before registration, you need to prepare necessary device(s) and software(s) fit for\n                            creating GoGoCinema account, or using the App, Website or Services. You will be\n                            responsible for costs and expenses incurred in accessing our App, Website or Services,\n                            including Internet connection or mobile fees.")])]),_vm._v(" "),_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"#212529","background":"white"}},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("If you create a GoGoCinema account, you agree to provide\n                            GoGoCinema with true, accurate, current and complete information about yourself, and to\n                            maintain and update such information to keep it true, accurate, current and complete. If\n                            your information is untrue, inaccurate, not current or incomplete, or GoGoCinema has\n                            reasonable grounds to suspect so, GoGoCinema is entitled to suspend or terminate your\n                            GoGoCinema account, or block your present or future use of the App, Website or Services.\n                            After you complete registration, you will have a password to access and manage your\n                            GoGoCinema account. You agree that you are solely responsible for keeping privacy of\n                            your password and account, and monitoring all use of your GoGoCinema account (whether\n                            authorized by you or not). You should not share your password or account information\n                            with any other person, post or transmit such information via unsecured routes. Please\n                            remember to log off your GoGoCinema account, or deactivate any public or shared\n                            device(s) you use to access your GoGoCinema account. In the event of any violation of\n                            your privacy or account security, you will notify GoGoCinema of any unauthorized use. If\n                            we have reasonable grounds to believe that your password or GoGoCinema account is\n                            insecure or otherwise problematic, we may ask you to change the password, or we could\n                            suspend or terminate your GoGoCinema account, or block your access to the App, Website\n                            or other Services.")])]),_vm._v(" "),_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"#212529","background":"white"}},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("If you access the App, Website or Services through a valid\n                            third-party account, such as an account on a social networking platform (e.g. Facebook,\n                            Twitter), you will connect your GoGoCinema account with such third-party account, by\n                            allowing GoGoCinema to access this third-party account. You represent and warrant that\n                            you have the right to grant GoGoCinema access to your third-party account without breach\n                            of any terms and conditions between you and the third party, and that GoGoCinema does\n                            not have any obligation to pay fees to the third party, subject to terms and conditions\n                            between you and the third party. By granting GoGoCinema access to your third-party\n                            account, you agree that we may access or store any data you provide to the third-party\n                            service provider, so that we could make such data available on the App, Website or\n                            Services through your GoGoCinema account. If your third-party account or any related\n                            services are terminated by the third party service provider, we can no longer access the\n                            data you provide to or store in the third-party account. You may disconnect GoGoCinema\n                            account and third-party account by changing settings of the App, Website or Services.\n                            "),_c('strong',[_vm._v("You understand that terms and conditions (and privacy policy) between you and\n                                the third-party service provider govern your relationship with that third\n                                party.")]),_vm._v(" GoGoCinema shall not be liable for any acts of the third- party\n                            service provider, in breach of terms and policies (and privacy policy) between you and\n                            that third party, and we take no responsibility for accuracy, completeness or legality\n                            of any data you provide to the third-party service provider.")])])])]),_vm._v(" "),_c('p',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","margin-left":"1.0in","background":"white"}},[_c('span',{staticStyle:{"font-size":"14px","color":"#212529"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","margin-left":"1.0in","background":"white"}},[_c('span',{staticStyle:{"font-size":"14px","color":"#212529"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","margin-left":"1.0in","background":"white"}},[_c('span',{staticStyle:{"font-size":"14px","color":"#212529"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","margin-left":"1.0in","background":"white"}},[_c('span',{staticStyle:{"font-size":"14px","color":"#212529"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","margin-left":"1.0in","background":"white"}},[_c('span',{staticStyle:{"font-size":"14px","color":"#212529"}},[_vm._v(" ")])]),_vm._v(" "),_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"#212529","background":"white"}},[_c('strong',[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("USER CONDUCT")])]),_vm._v(" "),_c('ol',{staticStyle:{"margin-bottom":"0in"},attrs:{"start":"1","type":"1"}},[_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"#212529","background":"white"}},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("GoGoCinema grants you permission to use the App, Website or\n                            Services in accordance with the Terms and Conditions, and grants you a personal,\n                            non-commercial, revocable, non-assignable, non-exclusive access to the App, Website or\n                            Services. You are solely responsible for your use of the App, Website or Services\n                            (including any content you make available to GoGoCinema, such as the username or\n                            password of your third-party social networking accounts), and for consequences\n                            thereof.")])]),_vm._v(" "),_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"#212529","background":"white"}},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("While using the App, Website or Services, you shall not make\n                            available any content in any illegal manner or any content that (i) is false,\n                            misleading, defamatory, slanderous, libelous, or sexually suggestive; (ii) contains\n                            explicit sexual content (including nudity), violence, or any matter offending individual\n                            or group based on religion, gender, sexual orientation, race, ethnicity, age, or\n                            disability; (iv) does or may threaten, abuse, harass or invade any third-party privacy,\n                            or infringes rights of GoGoCinema or any third parties, including Intellectual Property\n                            Rights; or (v) contains software viruses, any other computer codes, files, or programs\n                            that interfere, damage or limit functionality of the App, Website, or Services.")])]),_vm._v(" "),_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"#212529","background":"white"}},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("You agree not to violate applicable laws or cause harm to\n                            GoGoCinema when you use the App, Website or Services. You agree not to (i) use the App,\n                            Website or Services for commercial reasons (for example, to access, acquire, copy,\n                            reproduce, sell, trade, or commercially exploit the App, Website, Services or any part\n                            of it); (ii) retrieve content from the App, Website or Services systematically, to\n                            create, compile, directly or indirectly, in single or multiple downloads, a collection,\n                            compilation, directory or the like, without prior written consent of GoGoCinema; (iii)\n                            engage in unauthorized advertising or solicitation, including junk or bulk emails, chain\n                            letters, pyramid schemes, any form of lottery or gambling; (iv) gain (or attempt to\n                            gain) unauthorized access to the App, Website or Services, other systems or networks\n                            connected to the App, Website, Services or any GoGoCinema server; (v) reverse engineer,\n                            decompile, or otherwise derive source codes of any underlying software or intellectual\n                            property in the App, Website or Services; or (vi) access or use the App, Website or\n                            Services in any way not expressly permitted by Terms and Conditions.")])])])]),_vm._v(" "),_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"#212529","background":"white"}},[_c('strong',[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("PRICE, PURCHASE AND REFUND POLICY")])]),_vm._v(" "),_c('ol',{staticStyle:{"margin-bottom":"0in"},attrs:{"start":"1","type":"1"}},[_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"#212529","background":"white"}},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("All ticket prices for content on our App or Website are\n                            established by the GoGoCinema participating theatres and are net at our App and Website.\n                            GoGoCinema shall charge a booking fee at a price of its sole discetion which may apply\n                            to each movie ticket booked on our App and Website and is not refundable. Please\n                             note that the maximum number of tickets booked per transaction is determined by\n                            the GoGoCinema participating cinema theatres, GoGoCinema has no control and/or\n                            discretion over the number of tickets. If you are interested in group or corporate\n                            booking, please contact us at ")]),_c('span',{staticStyle:{"color":"windowtext"}},[_c('a',{attrs:{"href":"https://www.gogocinema.com/termsCondition"}},[_c('span',{staticStyle:{"font-size":"14px","color":"#007BFF"}},[_vm._v("support@gogocinema.com")])])]),_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v(", for special offers, privileges or other promotions (if\n                            applicable).")])]),_vm._v(" "),_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"#212529","background":"white"}},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("GoGoCinema accepts multiple payment methods, including debit\n                            cards and credit cards (such as Visa, MasterCard, PayPal). When you purchase tickets\n                            and/or Services via the App or Website, GoGoCinema or an authorized third party will ask\n                            you to provide certain information, including your full name, address, credit card\n                            and/or other billing information. You agree to provide us or the authorized third party\n                            with accurate, complete and updated information.Unless otherwise agreed by GoGoCinema,\n                            we will only issue confirmation of your ticket order, upon receiving your payment of the\n                            ticket. Please read your mobile or online confirmation page, and/or email containing\n                            confirmation of your order carefully, to retrieve your tickets that may be unique to a\n                            chosen theatre. If you retrieve ticket(s) at the theatre, theatres may require you to\n                            present the physical credit card, and the information on the physical card must match\n                            that stored for your purchase.")])]),_vm._v(" "),_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"#212529","background":"white"}},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("If you purchase tickets via the App or Website, you may elect\n                            either “Ordinary Screening” or “Crowd-sourcing Screening”.\n                            “Ordinary Screening” means a film screening as a single event, without\n                            requirement on Threshold or Due Date. “Crowd-sourcing Screening” refers to a\n                            film screening that satisfies a minimum number of tickets (“Threshold”)\n                            booked by users of the App, Website or Services, prior to a designated due date\n                            (“Due Date”). If you purchase ticket(s) for Ordinary Screening(s) or\n                            Crowd-sourcing Screening(s) that have met the Threshold at the time of your ticket\n                            order, you could select show time(s) and venue(s), and proceed with your payment in\n                            accordance with Terms and Conditions, and any other instructions displayed on the App or\n                            Website. After you pay, you will receive an email containing order confirmation. If you\n                            reserve ticket(s) for Crowd-sourcing Screening(s) that have not met the Threshold at the\n                            time of your ticket order, you may only use credit cards. We will send you an email\n                            indicating status of the Crowd-sourcing Screening you reserve, no later than the Due\n                            Date of that screening. If the Crowd-sourcing Screening is confirmed, your credit card\n                            will be charged and you will receive order confirmation via email thereafter. If the\n                            Crowd-sourcing Screening is cancelled by reason of failure to meet the Threshold by Due\n                            Date, your order will be cancelled and your credit card will not be charged.")])]),_vm._v(" "),_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"#212529","background":"white"}},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("GoGoCinema has the right to cancel or terminate any order, for\n                            any reason whatsoever, with or without notice given to you, even if your order is\n                            confirmed, and GoGoCinema shall not be liable to you or any other party for such\n                            cancellation or termination. In the event of such cancellation or termination,\n                            GoGoCinema shall refund the full ticket price to you. However, once your order is\n                            confirmed, you cannot cancel the order or claim refund.")])])])]),_vm._v(" "),_c('p',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","margin-left":"1.0in","background":"white"}},[_c('span',{staticStyle:{"font-size":"14px","color":"#212529"}},[_vm._v(" ")])]),_vm._v(" "),_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"#212529","background":"white"}},[_c('strong',[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("PRIVACY")])]),_vm._v(" "),_c('ol',{staticStyle:{"margin-bottom":"0in","margin-top":"0in"},attrs:{"start":"1","type":"1"}},[_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"#212529","background":"white"}},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("GoGoCinema "),_c('u',[_vm._v("Privacy Policy")]),_vm._v(" and "),_c('u',[_vm._v("Cookies Policy")]),_vm._v("\n                            apply to any use of our App, Website or Services, and are hereby incorporated into the\n                            Terms and Conditions by reference. You agree to GoGoCinema’s collection, use,\n                            protection and disclosure of your information as set forth in "),_c('u',[_vm._v("Privacy Policy")]),_vm._v(" and\n                            "),_c('u',[_vm._v("Cookies Policy")]),_vm._v(". By using the App, Website or Services, you agree that information\n                            transmission via the Internet is not 100% private or secure, in light of current\n                            technologies. Notwithstanding our privacy practices to safeguard security of your\n                            information, the information you provide to us may still be intercepted or accessed by\n                            unauthorized third parties.")])]),_vm._v(" "),_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"black","background":"white"}},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("By contacting GoGoCinema at support@gogocinema.com, you agree\n                            that the communication may be monitored and transcribed and you consent to the\n                            monitoring and transcribing. Such records may be kept indefinitely or disposed of at our\n                            discretion.")])])])]),_vm._v(" "),_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"#212529","background":"white"}},[_c('strong',[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("OWNERSHIP AND PROPRIETARY RIGHTS")])]),_vm._v(" "),_c('ol',{staticStyle:{"margin-bottom":"0in"},attrs:{"start":"1","type":"1"}},[_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"#212529","background":"white"}},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("You agree that GoGoCinema or its licensor(s) own all rights\n                            (including Intellectual Property Rights), title, and interest in the App, Website and\n                            Services, except any content made available by you or other users of the App, Website or\n                            Service. “"),_c('strong',[_vm._v("Intellectual Property Rights")]),_vm._v("” include but not\n                            limited to, rights in patents, inventions (patentable or not), industrial designs,\n                            utility models, trademarks, service marks, trade secrets, copyrights, mask-work, and\n                            other protecting intangible property or proprietary information recognized by law of any\n                            country or jurisdiction throughout the world. Intellectual Property Rights also include\n                            the right to apply for protection of the said rights. The copyright comprises of any\n                            literary, artistic, dramatic and musical works, such as software and source codes of the\n                            App or Website, video or audio files, cinematograph films (and clips), trailers,\n                            posters, graphics, photos, layouts, visual interfaces, features, and any other media or\n                            content made available through the App, Website or Services.")])]),_vm._v(" "),_c('p',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","background":"white"}},[_c('span',{staticStyle:{"font-size":"14px","color":"#212529"}},[_vm._v(" ")])]),_vm._v(" "),_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"#212529","background":"white"}},[_c('p',{staticStyle:{"font-size":"14px"}},[_vm._v("You represent and warrant that any content (including any\n                            comments, reviews, feedbacks, in the form of images, audio or video files) made\n                            available by you to GoGoCinema will not infringe any rights (including Intellectual\n                            Property Rights) or interests of third parties, and that you have legitimate rights to\n                            grant license in any content made available to GoGoCinema. By making available any\n                            content to GoGoCinema, you irrevocably grant GoGoCinema Parties and other users of the\n                            App, Website or Services a perpetual, non- exclusive, royalty-free, worldwide,\n                            assignable, transferrable and sub-licensable rights (including the right to copy,\n                            reproduce, distribute, alter, translate, remove, analyze, perform or display, prepare\n                            derivatives work of, or commercialize) in any content made available to GoGoCinema by\n                            you. You further irrevocably waive Claims of moral rights in the content you make\n                            available to GoGoCinema, against GoGoCinema Parties or other users of the App, Website\n                            or Services.")]),_vm._v(" "),_c('p',[_vm._v("We hereby fully reserve our rights to take any and all actions (including legal actions)\n                            against and/or to prosecute any party infringing our Intellectual Property\n                            Rights.")]),_vm._v(" "),_c('p',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","margin-left":"1.0in","background":"white"}},[_c('span',{staticStyle:{"font-size":"14px","color":"#212529"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"0in","margin-right":"0in","margin-bottom":".0001pt","margin-left":"1.0in","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","background":"white"}},[_c('strong',[_c('span',{staticStyle:{"font-size":"14px","color":"#212529"}},[_vm._v("Unsolicited Content Submissions to\n                                    GoGoCinema.")])]),_c('span',{staticStyle:{"font-size":"14px","color":"#212529"}},[_vm._v("  ")]),_c('span',{staticStyle:{"font-size":"14px","color":"black","background":"#FDFDFD"}},[_vm._v("GoGoCinema does not accept or\n                                consider unsolicited submissions of any kind through the Website\n                                and/or ")]),_c('a',{attrs:{"href":"mailto:support@gogocinema.com"}},[_c('span',{staticStyle:{"font-size":"14px","background":"#FDFDFD"}},[_vm._v("support@gogocinema.com")])]),_c('span',{staticStyle:{"font-size":"14px","color":"#4472C4","background":"#FDFDFD"}},[_vm._v(" ")]),_c('span',{staticStyle:{"font-size":"14px","color":"black","background":"#FDFDFD"}},[_vm._v("(e.g., proposals for\n                                advertising campaigns, logos, names, processes, products, promotions, services,\n                                slogans, technologies, original creative artwork, blueprints, demonstratives,\n                                designs, layouts, photographs, or samples or otherwise).  ")]),_c('span',{staticStyle:{"font-size":"14px","color":"black","background":"#F6F6F6"}},[_vm._v("All submissions may be\n                                deleted unread or destroyed, at GoGoCinema’s discretion.")]),_c('span',{staticStyle:{"font-size":"14px","color":"black","background":"#FDFDFD"}},[_vm._v("  GoGoCinema therefore\n                                requests that you not send unsolicited content submissions.   GoGoCinema has\n                                adopted this policy to prevent claims that we have copied ideas from unsolicited\n                                content submissions without authorization, when, in fact, we developed the idea\n                                independent of or even long before receiving the unsolicited content submission.\n                                 ")]),_c('span',{staticStyle:{"font-size":"14px","color":"black","background":"#F6F6F6"}},[_vm._v("You ")]),_c('span',{staticStyle:{"font-size":"14px","color":"#0A0A0A","background":"#F6F6F6"}},[_vm._v("hereby grant to GoGoCinema\n                                an irrevocable, perpetual, royalty-free license (including the right to sublicense\n                                to third parties) to exercise the intellectual property rights in any unsolicited\n                                content submissions made by you or on your behalf in connection with the Website\n                                and/or support@gogocinema.com (\"Licensed Submissions\"). You represent and\n                                warrant that use by GoGoCinema or its licensees of the Licensed Submissions will not\n                                infringe the intellectual property rights or other rights belong to you or of any\n                                third party.")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"0in","margin-right":"0in","margin-bottom":".0001pt","margin-left":"1.0in","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","background":"white"}},[_c('span',{staticStyle:{"font-size":"14px","color":"#212529"}},[_vm._v(" ")])])])])]),_vm._v(" "),_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"#212529","background":"white"}},[_c('strong',[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("THIRD PARTY SITES AND SERVICES")])]),_vm._v(" "),_c('ol',{staticStyle:{"margin-bottom":"0in"},attrs:{"start":"1","type":"1"}},[_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"#212529","background":"white"}},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("The App, Website or Services may contain links that direct you\n                            to independent applications, websites, or services offered by third-party services\n                            providers, not subject to the control of GoGoCinema. You understand that third-party\n                            links are for your convenience and easy reference only, while GoGoCinema does not\n                            undertake to approve, review, monitor or endorse any third-party links that may direct\n                            you to third-party applications, websites or services. "),_c('strong',[_vm._v("You acknowledge that your\n                                use or reliance on third-party applications, websites or services is at your own\n                                risk.")]),_vm._v(" When you click third-party links or engage third-party services, you\n                            effectively leave our App, Website or Services, so our Terms and Conditions no longer\n                            govern. Terms and policies of the third-party service provider(s) may vary from our\n                            Terms and Conditions. You should review the third party’s applicable terms and\n                            policies on your own. "),_c('strong',[_vm._v("GoGoCinema makes no warranties as to any third-party\n                                applications, websites or services, and will not be held liable for any Claims due\n                                to your use or reliance on any third-party applications, websites or\n                                services.")])])])])]),_vm._v(" "),_c('p',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","margin-left":"1.0in","background":"white"}},[_c('span',{staticStyle:{"font-size":"14px","color":"#212529"}},[_vm._v(" ")])]),_vm._v(" "),_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"#212529","background":"white"}},[_c('strong',[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("DISCLAIMERS AND NO WARRANTIES")])]),_vm._v(" "),_c('ol',{staticStyle:{"margin-bottom":"0in"},attrs:{"start":"1","type":"1"}},[_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"#212529","background":"white"}},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("You expressly acknowledge and agree that though GoGoCinema\n                            uses its commercially reasonable efforts to operate, maintain or update the App, Website\n                            and Services, your use of the App, Website or Services is at your own risk. The App,\n                            Website or Services are provided on an “AS IS” and “AS\n                            AVAILABLE” basis. To the extent permitted by applicable law, GoGoCinema disclaims\n                            all warranties and conditions, statutory or otherwise, whether express of implied,\n                            including implied warranties of merchantability, fitness for a particular purpose, and\n                            non-infringement.")])]),_vm._v(" "),_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"#212529","background":"white"}},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("GoGoCinema makes no warranties with respect to the App,\n                            Website or Services, including without limitation, quality, accuracy, timeliness,\n                            reliability, completeness, reputation or other features of the App, Website or Services.\n                            Without limiting the foregoing, GoGoCinema does not warrant that (i) the App, Website or\n                            Services will satisfy your requirements; (ii) your use of the App, Website or Services\n                            will be free from errors, inaccuracies, interruptions, delay, danger, temporary\n                            suspension or other harmful components due to technical issues out of our control; or\n                            (iii) the App, Website or Services will operate in the configuration, hardware or\n                            software you use. No information or any advice obtained from GoGoCinema, whether oral or\n                            written, obtained from GoGoCinema, or via the App, Website or Services will not\n                            constitute any warranty not expressly stated herein.")])]),_vm._v(" "),_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"#212529","background":"white"}},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("You understand and agree that unless applicable law states\n                            otherwise, GoGoCinema does not control, approve, endorse or make any warranties with\n                            respect to any content (or any use thereof) made available by you, any other users of\n                            the App, Website or Services, or any other third parties. GoGoCinema has no obligation\n                            to review, monitor, verify, ratify or sanction any content made available by you, any\n                            other users of the App, Website or Services, or any other third parties. GoGoCinema\n                            reserves the right (but does not assume any obligation) at our sole discretion to\n                            accept, edit, reject or remove any content that is made available to us.")])]),_vm._v(" "),_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"#212529","background":"white"}},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Disclaimers under this clause apply to all liabilities,\n                            claims, actions, demands, complaints, investigations, losses, costs and expenses\n                            (including reasonable attorney fees) of any kind (“Claims”) caused by any\n                            failure, error, delay in operation or transmission, defect, interruption, computer\n                            virus, file corruption, communication-line failure, network or system outage, theft or\n                            destruction of, or unauthorized access to, change of, use of your information, whether\n                            for breach of contract, tort (including negligence), or any other cause of\n                            action.")])])])]),_vm._v(" "),_c('p',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","margin-left":"1.0in","background":"white"}},[_c('span',{staticStyle:{"font-size":"14px","color":"#212529"}},[_vm._v(" ")])]),_vm._v(" "),_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"#212529","background":"white"}},[_c('strong',[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("LIMITATION OF LIABILITY")])]),_vm._v(" "),_c('ol',{staticStyle:{"margin-bottom":"0in"},attrs:{"start":"1","type":"1"}},[_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"#212529","background":"white"}},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("You expressly understand and agree that, to the extent\n                            permitted by applicable law, in no event shall GoGoCinema, its parent, affiliates,\n                            suppliers, contractors, subcontractors, licensors, sub-licensees, third-party partners,\n                            designees, assignees, or successors, and each of their respective employees, directors,\n                            officers, shareholders, agents or representatives (“"),_c('strong',[_vm._v("GoGoCinema\n                                Parties")]),_vm._v("”) be liable for any direct, indirect, incidental, special,\n                            consequential, punitive, or exemplary damages (including but not limited to any damages\n                            resulting from loss of use, data, revenue, profits, business, anticipated savings or\n                            goodwill, and any damages for personal or bodily injury, emotional distress, pain and\n                            suffering), arising out of or in connection with this Terms and Conditions (including\n                            "),_c('u',[_vm._v("Privacy Policy")]),_vm._v(" and "),_c('u',[_vm._v("Cookies Policy")]),_vm._v("), your use of the App, Website or\n                            Services, or any other interactions with GoGoCinema, whether caused by breach of\n                            contract, tort, or other causes of action, even if foreseeable or GoGoCinema has been\n                            advised of possibility of such damages.")]),_vm._v(" "),_c('p',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","margin-left":"1.0in","background":"white"}},[_c('span',{staticStyle:{"font-size":"14px","color":"#212529"}},[_vm._v(" ")])])]),_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"#212529","background":"white"}},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Without limiting the foregoing and to the extent permitted by\n                            applicable law,, you acknowledge and agree that you are solely responsible for, and that\n                            GoGoCinema Parties are not liable for any Claims arising out of or in connection with\n                            (i) your failure to comply with this Terms and Conditions (including "),_c('u',[_vm._v("Privacy\n                                Policy")]),_vm._v(" and "),_c('u',[_vm._v("Cookies Policy")]),_vm._v("); (ii) content posted to the App or Website by\n                            you or any third party, or content downloaded from or accessed through the App, Website\n                            or Services by you; (iii) delay, deletion, mis-delivery or failure to store any content,\n                            user communications, or personalized settings; (iv) conducts of third parties, including\n                            third-party service providers or operators of third-party websites; (v) your\n                            interactions with third parties, or any other users of the App, Website or Services; or\n                            (vi) your attendance of any events.")])]),_vm._v(" "),_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"#212529","background":"white"}},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("To the extent permitted by applicable law, under no\n                            circumstances will GoGoCinema Parties’ liability to you exceed the amount received\n                            by GoGoCinema from you (if any), in the three (3) months that precede the date of your\n                            Claims. If you have not paid GoGoCinema within the three (3) months prior to the date of\n                            your Claims, GoGoCinema Parties’ sole and exclusive liability to you will be\n                            limited to fifty United States Dollars (USD 50).")])])])]),_vm._v(" "),_c('p',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","margin-left":"1.0in","background":"white"}},[_c('span',{staticStyle:{"font-size":"14px","color":"#212529"}},[_vm._v(" ")])]),_vm._v(" "),_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"#212529","background":"white"}},[_c('strong',[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("INDEMNITY")])]),_vm._v(" "),_c('ol',{staticStyle:{"margin-bottom":"0in"},attrs:{"start":"1","type":"1"}},[_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"#212529","background":"white"}},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("To the extent permissible under applicable law, you agree to\n                            hold harmless GoGoCinema Parties from any Claims, due to or in relation to your (i) use\n                            of or access to the App, Website or Services (including registration, use of or access\n                            to GoGoCinema account, or making available any content to GoGoCinema); (ii) breach of\n                            this Terms and Conditions (including "),_c('u',[_vm._v("Privacy Policy")]),_vm._v(" and "),_c('u',[_vm._v("Cookies Policy")]),_vm._v(");\n                            (iii) infringement of any rights or interests of third parties; or (iv) violation of any\n                            applicable laws, rules or regulations. GoGoCinema reserves the right to defend or\n                            dispose (including possible settlement) at its sole discretion any matter for which you\n                            should indemnify GoGoCinema at your sole costs and expenses. You will fully cooperate\n                            with us to assert any available defenses. You agree that this indemnity clause shall\n                            survive termination of your GoGoCinema account, this Terms and Conditions, your use of\n                            or access to our App, Website or Services.")])])])]),_vm._v(" "),_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"#212529","background":"white"}},[_c('strong',[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("TERM AND TERMINATION")])]),_vm._v(" "),_c('ol',{staticStyle:{"margin-bottom":"0in"},attrs:{"start":"1","type":"1"}},[_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"#212529","background":"white"}},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Terms and Conditions take effect upon your acceptance\n                            according to Clause 1 (Acceptance of Terms and Changes), and remain in full force and\n                            effect between you and GoGoCinema, so long as you use or access the App, Website, or\n                            Services, unless terminated earlier hereunder. If you use or access the App, Website or\n                            Services before your acceptance of Terms and Conditions, effective date of this Terms\n                            and Conditions will be the date of your first use or access.")])]),_vm._v(" "),_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"#212529","background":"white"}},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("You may terminate your account for any reason at any time, by\n                            contacting GoGoCinema at ")]),_c('span',{staticStyle:{"color":"windowtext"}},[_c('a',{attrs:{"href":"https://www.gogocinema.com/termsCondition"}},[_c('span',{staticStyle:{"font-size":"14px","color":"#007BFF"}},[_vm._v("support@gogocinema.com")])])]),_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v(" or sending notice in writing to us at 1016 West Magnolia\n                            Boulevard, Burbank, California 91506. GoGoCinema has the right to, with or without\n                            notice, at its sole discretion, (i) update, modify, suspend or terminate operation of or\n                            access to the App, Website, Services, or any part thereof, for maintenance, error\n                            correction or other purposes as GoGoCinema deems fit; or (ii) suspend or terminate your\n                            GoGoCinema account, remove, delete or discard any information you provide, or any\n                            information stored by, sent to, or received by GoGoCinema through the App, Website or\n                            Services for any reasonable purposes. Aforesaid purposes include but not limited to (i)\n                            concurrent use of your GoGoCinema account; (ii) any other person’s use or access\n                            to the App, Website or Services through your GoGoCinema account, whether or not with\n                            your permission; (iii) any unauthorized use of or access to the App, Website or\n                            Services; (iv) your breach of Terms and Conditions; or (v) any intrusion or attempted\n                            intrusion of software(s) or data embedded in the App, Website, or Services.")])]),_vm._v(" "),_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"#212529","background":"white"}},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("GoGoCinema will not be liable for any Claims due to any\n                            conducts of GoGoCinema as stated in Clause 11.2. Upon termination of GoGoCinema services\n                            (including operation of or access to the App, Website, Services or your GoGoCinema\n                            account), your right to use said services terminate. Termination of GoGoCinema services\n                            will not affect any right or relief that we are entitled to, at law or in equity. All\n                            clauses under Terms and Conditions that by nature will survive termination of GoGoCinema\n                            services will survive, such as Clauses 6, 7, 8, 9, 10, 11and 12.")])])])]),_vm._v(" "),_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"#212529","background":"white"}},[_c('strong',[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("GENERAL PROVISIONS")])]),_vm._v(" "),_c('ol',{staticStyle:{"margin-bottom":"0in"},attrs:{"start":"1","type":"1"}},[_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"#212529","background":"white"}},[_c('strong',[_c('u',[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Assignment.")])])]),_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v(" Without prior written consent of GoGoCinema, you shall not\n                            assign, subcontract, license, sub-license, delegate or otherwise transfer the Terms and\n                            Conditions, your obligations and rights hereunder to any third party. Any attempted\n                            assignment, subcontract, license, sub-license, delegation or transfer in breach of this\n                            clause will be null and void.")])]),_vm._v(" "),_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"#212529","background":"white"}},[_c('strong',[_c('u',[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("No Waiver.")])])]),_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v(" Any failure or delay by GoGoCinema to enforce any\n                            provision of this Terms and Conditions, or to exercise any right, will not be deemed a\n                            waiver of future enforcement of that or any other provision(s), or of further exercise\n                            of the right or any other right(s). Any waiver in writing signed by GoGoCinema in one\n                            occasion will not be deemed GoGoCinema’s waiver of any subsequent similar cases in\n                            another occasion.ssss")])]),_vm._v(" "),_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"#212529","background":"white"}},[_c('strong',[_c('u',[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Force Majeure.")])])]),_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v(" GoGoCinema shall not be liable for any delay or failure in\n                            performance of the Terms and Conditions due to causes beyond our reasonable control,\n                            including but not limited to acts of hackers, acts or omission of third parties\n                            (including third-party Internet service providers or telecommunications common\n                            carriers), overloading or reduced speed of the Internet, acts of God, war, terrorism,\n                            riots, acts of civil or military authorities, fire, floods, accidents, strikes, or\n                            shortages of transportation facilities, fuel, power, energy, labor or materials.")])]),_vm._v(" "),_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"#212529","background":"white"}},[_c('strong',[_c('u',[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Compliance.")])])]),_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v(" If you believe that GoGoCinema is in breach of the Terms\n                            and Conditions, or if you are aware of any violation of Terms and Conditions by any\n                            other users of the App, Website or Services, please notify GoGoCinema promptly\n                            at ")]),_c('span',{staticStyle:{"color":"windowtext"}},[_c('a',{attrs:{"href":"https://www.gogocinema.com/termsCondition"}},[_c('span',{staticStyle:{"font-size":"14px","color":"#007BFF"}},[_vm._v("support@gogocinema.com")])])]),_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v(".")])]),_vm._v(" "),_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"#212529","background":"white"}},[_c('strong',[_c('u',[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Dispute Resolution.")])])]),_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v(" This Terms and Conditions will be governed by, construed\n                            and enforced in accordance with the laws of California, without giving effect to any\n                            conflict of law rules. All disputes arising out of or in connection with this Terms and\n                            Conditions, which cannot be resolved amicably shall be submitted to the courts with\n                            competent jurisdiction in Los Angeles, California.")])]),_vm._v(" "),_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"#212529","background":"white"}},[_c('strong',[_c('u',[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Severability.")])])]),_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v(" If any provision(s) of this Terms and Conditions are found\n                            under applicable law to be void or unenforceable, by a court of competent jurisdiction,\n                            the other provision(s) shall remain in full force and effect. The invalid or\n                            unenforceable provision(s) will be limited to the minimum extent necessary and replaced\n                            with valid provision(s) that best fits the intent of this Terms and Conditions, to the\n                            maximum extent permitted by applicable law.")])]),_vm._v(" "),_c('li',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","color":"#212529","background":"white"}},[_c('strong',[_c('u',[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("Entire Agreement.")])])]),_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v(" This Terms and Conditions, including the Privacy Policy\n                            and Cookies Policy incorporated herein by reference, constitute the entire agreement\n                            between you and GoGoCinema regarding the subject matter, and supersede or replace all\n                            prior or contemporaneous understandings or agreements, written or oral, with respect to\n                            the subject matter hereof.")])])])])]),_vm._v(" "),_c('p',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","background":"white"}},[_c('span',{staticStyle:{"font-size":"14px","color":"#212529"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\"","background":"white"}},[_c('span',{staticStyle:{"font-size":"14px","color":"#212529"}},[_vm._v("Last Updated October 2021")])]),_vm._v(" "),_c('p',{staticStyle:{"margin":"0in","margin-bottom":".0001pt","font-size":"16px","font-family":"\"Calibri\",\"sans-serif\""}},[_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v(" ")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_terms_condition_vue__ = __webpack_require__(664);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_102f1dd6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_terms_condition_vue__ = __webpack_require__(1337);
function injectStyle (ssrContext) {
  __webpack_require__(1336)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-102f1dd6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_terms_condition_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_102f1dd6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_terms_condition_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1336 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"text-center title-tc font-weight-bold mt-5"},[_vm._v("GOGOCINEMA TERMS AND CONDITIONS")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("GOGOCINEMA TERMS AND CONDITIONS")])]),_vm._v(" "),_c('p',[_c('strong',[_vm._v(" ")])]),_vm._v(" "),_c('p',[_vm._v("Thank you for visiting the GoGoCinema website and if you have done so, downloading the GoGoCinema mobile\n    application. These Terms and Conditions including any changes thereof (“"),_c('strong',[_vm._v("Terms and\n      Conditions")]),_vm._v("”) were last updated in August 2019 by GOGOCINEMA Asia Pacific Pte Ltd (referred to as\n    “"),_c('strong',[_vm._v("GoGoCinema")]),_vm._v("” or “"),_c('strong',[_vm._v("We")]),_vm._v("”). Terms and Conditions apply to\n    your access and use of GoGoCinema mobile application, including all versions, updates and modifications\n    (“"),_c('strong',[_vm._v("App")]),_vm._v("”), GoGoCinema website located at [gogocinema.com]\n    (“"),_c('strong',[_vm._v("Website")]),_vm._v("”), and other related services provided by GoGoCinema, in connection with\n    the App or Website (“"),_c('strong',[_vm._v("Services")]),_vm._v("”).")]),_vm._v(" "),_c('p',[_vm._v("Your feedback is valuable to us and welcomed at all times. Should you have any feedback, comments or complaints\n    on our App, Website and/or Services, please contact us at "),_c('a',{attrs:{"href":"https://www.gogocinema.com/termsCondition"}},[_vm._v("support@gogocinema.com")]),_vm._v(".")]),_vm._v(" "),_c('ol',[_c('li',[_c('strong',[_vm._v("ACCEPTANCE OF TERMS AND CHANGES")])]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("By downloading or using the App, visiting the Website or using our Services, including ordering and buying\n        tickets, attending the theatres, providing reviews or comments on the App or Website –")]),_vm._v(" "),_c('ol',[_c('li',[_c('strong',[_vm._v("You accept and represent that you have read, understand and agree to be bound by the Terms and\n            Conditions,")]),_vm._v(" and that you have the legal capacity and authority to enter into Terms and\n          Conditions with GoGoCinema, under the laws of California, your place of residency, or any other applicable\n          jurisdiction. "),_c('strong',[_vm._v("If you do not agree to the Terms and Conditions, do not use the App, Website or\n            Services.")]),_vm._v(" Terms and Conditions (including "),_c('u',[_vm._v("Privacy\n            Policy")]),_vm._v(" and "),_c('u',[_vm._v("Cookies Policy")]),_vm._v(") can be changed by GoGoCinema at its sole discretion from\n          time to time. The latest version of Terms and Conditions will be available via the App and Website, and will\n          supersede any previous versions. In case of any changes, the “Latest Updated” date at the end of\n          Terms and Conditions will also be updated.")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("You agree to be bound by all terms and conditions, privacy policy, house rules and/or other rules\n            set by GoGoCinema participating cinema theatres, where the movie contents displayed on the App or Website\n            will be screened. Any breach of terms and conditions, policies or rules set by relevant cinema theatres\n            will constitute breach of this Terms and Conditions.")]),_vm._v(" You understand that third\n          parties’ terms and conditions, policies or rules can differ from ours, and GoGoCinema is not\n          responsible for any terms and conditions, policies or rules of third parties. "),_c('strong',[_vm._v("If you do not\n            agree to any terms and conditions, policies or rules set by relevant cinema theatres, do not use the App,\n            Website or Services.")])])]),_vm._v(" "),_c('li',[_vm._v("You are responsible for reviewing the Terms and Conditions periodically for such changes. "),_c('strong',[_vm._v("After\n          we post any changes onto the App or Website, your continued use or access to our App, Website or Services\n          constitutes acceptance of such changes.")]),_vm._v(" If you register to create your GoGoCinema account with\n        us, we may send an email to you at the latest email address you provide to us, informing you of material\n        changes made to the Terms and Conditions. If you do not agree to any changes after receiving such reminder via\n        email, you should cease the use of our App, Website or Services.")])])]),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('ol',[_c('li',[_c('strong',[_vm._v("REGISTRATION, ACCOUNTS AND PASSWORDS")])]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("To access certain features of our App, Website or Services, you need to set up a GoGoCinema account. By\n        establishing a GoGoCinema account, you represent and warrant that you are of legal age to form a binding\n        contract and you are not barred from opening GoGoCinema account, using the App, Website, or Services under the\n        laws of California, your place of residency, or any other applicable jurisdiction. Before registration, you\n        need to prepare necessary device(s) and software(s) fit for creating GoGoCinema account, or using the App,\n        Website or Services. You will be responsible for costs and expenses incurred in accessing our App, Website or\n        Services, including Internet connection or mobile fees.")]),_vm._v(" "),_c('li',[_vm._v("If you create a GoGoCinema account, you agree to provide GoGoCinema with true, accurate, current and\n        complete information about yourself, and to maintain and update such information to keep it true, accurate,\n        current and complete. If your information is untrue, inaccurate, not current or incomplete, or GoGoCinema has\n        reasonable grounds to suspect so, GoGoCinema is entitled to suspend or terminate your GoGoCinema account, or\n        block your present or future use of the App, Website or Services. After you complete registration, you will\n        have a password to access and manage your GoGoCinema account. You agree that you are solely responsible for\n        keeping privacy of your password and account, and monitoring all use of your GoGoCinema account (whether\n        authorized by you or not). You should not share your password or account information with any other person,\n        post or transmit such information via unsecured routes. Please remember to log off your GoGoCinema account, or\n        deactivate any public or shared device(s) you use to access your GoGoCinema account. In the event of any\n        violation of your privacy or account security, you will notify GoGoCinema of any unauthorized use. If we have\n        reasonable grounds to believe that your password or GoGoCinema account is insecure or otherwise problematic,\n        we may ask you to change the password, or we could suspend or terminate your GoGoCinema account, or block your\n        access to the App, Website or other Services.")]),_vm._v(" "),_c('li',[_vm._v("If you access the App, Website or Services through a valid third-party account, such as an account on a\n        social networking platform (e.g. Facebook, Twitter), you will connect your GoGoCinema account with such\n        third-party account, by allowing GoGoCinema to access this third-party account. You represent and warrant that\n        you have the right to grant GoGoCinema access to your third-party account without breach of any terms and\n        conditions between you and the third party, and that GoGoCinema does not have any obligation to pay fees to\n        the third party, subject to terms and conditions between you and the third party. By granting GoGoCinema\n        access to your third-party account, you agree that we may access or store any data you provide to the\n        third-party service provider, so that we could make such data available on the App, Website or Services\n        through your GoGoCinema account. If your third-party account or any related services are terminated by the\n        third party service provider, we can no longer access the data you provide to or store in the third-party\n        account. You may disconnect GoGoCinema account and third-party account by changing settings of the App,\n        Website or Services. "),_c('strong',[_vm._v("You understand that terms and conditions (and privacy policy) between you\n          and the third-party service provider govern your relationship with that third\n          party.")]),_vm._v(" GoGoCinema shall not be liable for any acts of the third- party service provider, in\n        breach of terms and policies (and privacy policy) between you and that third party, and we take no\n        responsibility for accuracy, completeness or legality of any data you provide to the third-party service\n        provider.")])])]),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('ol',[_c('li',[_c('strong',[_vm._v("USER CONDUCT")])]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("GoGoCinema grants you permission to use the App, Website or Services in accordance with the Terms and\n        Conditions, and grants you a personal, non-commercial, revocable, non-assignable, non-exclusive access to the\n        App, Website or Services. You are solely responsible for your use of the App, Website or Services (including\n        any content you make available to GoGoCinema, such as the username or password of your third-party social\n        networking accounts), and for consequences thereof.")]),_vm._v(" "),_c('li',[_vm._v("While using the App, Website or Services, you shall not make available any content in any illegal manner or\n        any content that (i) is false, misleading, defamatory, slanderous, libelous, or sexually suggestive; (ii)\n        contains explicit sexual content (including nudity), violence, or any matter offending individual or group\n        based on religion, gender, sexual orientation, race, ethnicity, age, or disability; (iv) does or may threaten,\n        abuse, harass or invade any third-party privacy, or infringes rights of GoGoCinema or any third parties,\n        including Intellectual Property Rights; or (v) contains software viruses, any other computer codes, files, or\n        programs that interfere, damage or limit functionality of the App, Website, or Services.")]),_vm._v(" "),_c('li',[_vm._v("You agree not to violate applicable laws or cause harm to GoGoCinema when you use the App, Website or\n        Services. You agree not to (i) use the App, Website or Services for commercial reasons (for example, to\n        access, acquire, copy, reproduce, sell, trade, or commercially exploit the App, Website, Services or any part\n        of it); (ii) retrieve content from the App, Website or Services systematically, to create, compile, directly\n        or indirectly, in single or multiple downloads, a collection, compilation, directory or the like, without\n        prior written consent of GoGoCinema; (iii) engage in unauthorized advertising or solicitation, including junk\n        or bulk emails, chain letters, pyramid schemes, any form of lottery or gambling; (iv) gain (or attempt to\n        gain) unauthorized access to the App, Website or Services, other systems or networks connected to the App,\n        Website, Services or any GoGoCinema server; (v) reverse engineer, decompile, or otherwise derive source codes\n        of any underlying software or intellectual property in the App, Website or Services; or (vi) access or use the\n        App, Website or Services in any way not expressly permitted by Terms and Conditions.")])]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("PRICE, PURCHASE AND REFUND POLICY")])]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("All ticket prices for content on our App or Website are established by the GoGoCinema participating theatres\n        and are net at our App and Website. GoGoCinema shall charge a booking fee at a price of its sole discetion\n        which may apply to each movie ticket booked on our App and Website and is not refundable. Please  note\n        that the maximum number of tickets booked per transaction is determined by the GoGoCinema participating cinema\n        theatres, GoGoCinema has no control and/or discretion over the number of tickets. If you are interested in\n        group or corporate booking, please contact us at "),_c('a',{attrs:{"href":"https://www.gogocinema.com/termsCondition"}},[_vm._v("support@gogocinema.com")]),_vm._v(", for special offers, privileges\n        or other promotions (if applicable).")]),_vm._v(" "),_c('li',[_vm._v("GoGoCinema accepts multiple payment methods, including debit cards and credit cards (such as Visa,\n        MasterCard, PayPal). When you purchase tickets and/or Services via the App or Website, GoGoCinema or an\n        authorized third party will ask you to provide certain information, including your full name, address, credit\n        card and/or other billing information. You agree to provide us or the authorized third party with accurate,\n        complete and updated information.Unless otherwise agreed by GoGoCinema, we will only issue confirmation of\n        your ticket order, upon receiving your payment of the ticket. Please read your mobile or online confirmation\n        page, and/or email containing confirmation of your order carefully, to retrieve your tickets that may be\n        unique to a chosen theatre. If you retrieve ticket(s) at the theatre, theatres may require you to present the\n        physical credit card, and the information on the physical card must match that stored for your purchase.")]),_vm._v(" "),_c('li',[_vm._v("If you purchase tickets via the App or Website, you may elect either “Ordinary Screening” or\n        “Crowd-sourcing Screening”. “Ordinary Screening” means a film screening as a single\n        event, without requirement on Threshold or Due Date. “Crowd-sourcing Screening” refers to a film\n        screening that satisfies a minimum number of tickets (“Threshold”) booked by users of the App,\n        Website or Services, prior to a designated due date (“Due Date”). If you purchase ticket(s) for\n        Ordinary Screening(s) or Crowd-sourcing Screening(s) that have met the Threshold at the time of your ticket\n        order, you could select show time(s) and venue(s), and proceed with your payment in accordance with Terms and\n        Conditions, and any other instructions displayed on the App or Website. After you pay, you will receive an\n        email containing order confirmation. If you reserve ticket(s) for Crowd-sourcing Screening(s) that have not\n        met the Threshold at the time of your ticket order, you may only use credit cards. We will send you an email\n        indicating status of the Crowd-sourcing Screening you reserve, no later than the Due Date of that screening.\n        If the Crowd-sourcing Screening is confirmed, your credit card will be charged and you will receive order\n        confirmation via email thereafter. If the Crowd-sourcing Screening is cancelled by reason of failure to meet\n        the Threshold by Due Date, your order will be cancelled and your credit card will not be charged.")]),_vm._v(" "),_c('li',[_vm._v("GoGoCinema has the right to cancel or terminate any order, for any reason whatsoever, with or without notice\n        given to you, even if your order is confirmed, and GoGoCinema shall not be liable to you or any other party\n        for such cancellation or termination. In the event of such cancellation or termination, GoGoCinema shall\n        refund the full ticket price to you. However, once your order is confirmed, you cannot cancel the order or\n        claim refund.")])])]),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('ol',[_c('li',[_c('strong',[_vm._v("PRIVACY")])]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("GoGoCinema "),_c('u',[_vm._v("Privacy Policy")]),_vm._v(" and "),_c('u',[_vm._v("Cookies Policy")]),_vm._v(" apply to any use of our App,\n        Website or Services, and are hereby incorporated into the Terms and Conditions by reference. You agree to\n        GoGoCinema’s collection, use, protection and disclosure of your information as set forth\n        in "),_c('u',[_vm._v("Privacy Policy")]),_vm._v(" and "),_c('u',[_vm._v("Cookies Policy")]),_vm._v(". By using the App, Website or Services, you\n        agree that information transmission via the Internet is not 100% private or secure, in light of current\n        technologies. Notwithstanding our privacy practices to safeguard security of your information, the information\n        you provide to us may still be intercepted or accessed by unauthorized third parties.")]),_vm._v(" "),_c('li',[_vm._v("By contacting GoGoCinema at support@gogocinema.com, you agree that the communication may be monitored and\n        transcribed and you consent to the monitoring and transcribing. Such records may be kept indefinitely or\n        disposed of at our discretion.")])]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("OWNERSHIP AND PROPRIETARY RIGHTS")])]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("You agree that GoGoCinema or its licensor(s) own all rights (including Intellectual Property Rights), title,\n        and interest in the App, Website and Services, except any content made available by you or other users of the\n        App, Website or Service. “"),_c('strong',[_vm._v("Intellectual Property Rights")]),_vm._v("” include but not limited\n        to, rights in patents, inventions (patentable or not), industrial designs, utility models, trademarks, service\n        marks, trade secrets, copyrights, mask-work, and other protecting intangible property or proprietary\n        information recognized by law of any country or jurisdiction throughout the world. Intellectual Property\n        Rights also include the right to apply for protection of the said rights. The copyright comprises of any\n        literary, artistic, dramatic and musical works, such as software and source codes of the App or Website, video\n        or audio files, cinematograph films (and clips), trailers, posters, graphics, photos, layouts, visual\n        interfaces, features, and any other media or content made available through the App, Website or Services.")])])]),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('ol',[_c('ol',[_c('li',[_vm._v("You represent and warrant that any content (including any comments, reviews, feedbacks, in the form of\n        images, audio or video files) made available by you to GoGoCinema will not infringe any rights (including\n        Intellectual Property Rights) or interests of third parties, and that you have legitimate rights to grant\n        license in any content made available to GoGoCinema. By making available any content to GoGoCinema, you\n        irrevocably grant GoGoCinema Parties and other users of the App, Website or Services a perpetual, non-\n        exclusive, royalty-free, worldwide, assignable, transferrable and sub-licensable rights (including the right\n        to copy, reproduce, distribute, alter, translate, remove, analyze, perform or display, prepare derivatives\n        work of, or commercialize) in any content made available to GoGoCinema by you. You further irrevocably waive\n        Claims of moral rights in the content you make available to GoGoCinema, against GoGoCinema Parties or other\n        users of the App, Website or Services.")])])]),_vm._v(" "),_c('p',[_vm._v("We hereby fully reserve our rights to take any and all actions (including legal actions) against and/or to\n    prosecute any party infringing our Intellectual Property Rights.")]),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Unsolicited Content Submissions to GoGoCinema.")]),_vm._v("  GoGoCinema does not accept or consider\n    unsolicited submissions of any kind through the Website and/or "),_c('a',{attrs:{"href":"mailto:support@gogocinema.com"}},[_vm._v("support@gogocinema.com")]),_vm._v(" (e.g., proposals for advertising campaigns,\n    logos, names, processes, products, promotions, services, slogans, technologies, original creative artwork,\n    blueprints, demonstratives, designs, layouts, photographs, or samples or otherwise).  All submissions may be\n    deleted unread or destroyed, at GoGoCinema’s discretion.  GoGoCinema therefore requests that you not\n    send unsolicited content submissions.  GoGoCinema has adopted this policy to prevent claims that we have\n    copied ideas from unsolicited content submissions without authorization, when, in fact, we developed the idea\n    independent of or even long before receiving the unsolicited content submission.  You hereby grant to\n    GoGoCinema an irrevocable, perpetual, royalty-free license (including the right to sublicense to third parties) to\n    exercise the intellectual property rights in any unsolicited content submissions made by you or on your behalf in\n    connection with the Website and/or support@gogocinema.com (\"Licensed Submissions\"). You represent and warrant that\n    use by GoGoCinema or its licensees of the Licensed Submissions will not infringe the intellectual property rights\n    or other rights belong to you or of any third party.")]),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('ol',[_c('li',[_c('strong',[_vm._v("THIRD PARTY SITES AND SERVICES")])]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("The App, Website or Services may contain links that direct you to independent applications, websites, or\n        services offered by third-party services providers, not subject to the control of GoGoCinema. You understand\n        that third-party links are for your convenience and easy reference only, while GoGoCinema does not undertake\n        to approve, review, monitor or endorse any third-party links that may direct you to third-party applications,\n        websites or services. "),_c('strong',[_vm._v("You acknowledge that your use or reliance on third-party applications,\n          websites or services is at your own risk.")]),_vm._v(" When you click third-party links or engage\n        third-party services, you effectively leave our App, Website or Services, so our Terms and Conditions no\n        longer govern. Terms and policies of the third-party service provider(s) may vary from our Terms and\n        Conditions. You should review the third party’s applicable terms and policies on your\n        own. "),_c('strong',[_vm._v("GoGoCinema makes no warranties as to any third-party applications, websites or services, and\n          will not be held liable for any Claims due to your use or reliance on any third-party applications, websites\n          or services.")])])])]),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('ol',[_c('li',[_c('strong',[_vm._v("DISCLAIMERS AND NO WARRANTIES")])]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("You expressly acknowledge and agree that though GoGoCinema uses its commercially reasonable efforts to\n        operate, maintain or update the App, Website and Services, your use of the App, Website or Services is at your\n        own risk. The App, Website or Services are provided on an “AS IS” and “AS AVAILABLE”\n        basis. To the extent permitted by applicable law, GoGoCinema disclaims all warranties and conditions,\n        statutory or otherwise, whether express of implied, including implied warranties of merchantability, fitness\n        for a particular purpose, and non-infringement.")]),_vm._v(" "),_c('li',[_vm._v("GoGoCinema makes no warranties with respect to the App, Website or Services, including without limitation,\n        quality, accuracy, timeliness, reliability, completeness, reputation or other features of the App, Website or\n        Services. Without limiting the foregoing, GoGoCinema does not warrant that (i) the App, Website or Services\n        will satisfy your requirements; (ii) your use of the App, Website or Services will be free from errors,\n        inaccuracies, interruptions, delay, danger, temporary suspension or other harmful components due to technical\n        issues out of our control; or (iii) the App, Website or Services will operate in the configuration, hardware\n        or software you use. No information or any advice obtained from GoGoCinema, whether oral or written, obtained\n        from GoGoCinema, or via the App, Website or Services will not constitute any warranty not expressly stated\n        herein.")]),_vm._v(" "),_c('li',[_vm._v("You understand and agree that unless applicable law states otherwise, GoGoCinema does not control, approve,\n        endorse or make any warranties with respect to any content (or any use thereof) made available by you, any\n        other users of the App, Website or Services, or any other third parties. GoGoCinema has no obligation to\n        review, monitor, verify, ratify or sanction any content made available by you, any other users of the App,\n        Website or Services, or any other third parties. GoGoCinema reserves the right (but does not assume any\n        obligation) at our sole discretion to accept, edit, reject or remove any content that is made available to us.\n      ")]),_vm._v(" "),_c('li',[_vm._v("Disclaimers under this clause apply to all liabilities, claims, actions, demands, complaints,\n        investigations, losses, costs and expenses (including reasonable attorney fees) of any kind\n        (“Claims”) caused by any failure, error, delay in operation or transmission, defect, interruption,\n        computer virus, file corruption, communication-line failure, network or system outage, theft or destruction\n        of, or unauthorized access to, change of, use of your information, whether for breach of contract, tort\n        (including negligence), or any other cause of action.")])])]),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('ol',[_c('li',[_c('strong',[_vm._v("LIMITATION OF LIABILITY")])]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("You expressly understand and agree that, to the extent permitted by applicable law, in no event shall\n        GoGoCinema, its parent, affiliates, suppliers, contractors, subcontractors, licensors, sub-licensees,\n        third-party partners, designees, assignees, or successors, and each of their respective employees, directors,\n        officers, shareholders, agents or representatives (“"),_c('strong',[_vm._v("GoGoCinema Parties")]),_vm._v("”) be\n        liable for any direct, indirect, incidental, special, consequential, punitive, or exemplary damages (including\n        but not limited to any damages resulting from loss of use, data, revenue, profits, business, anticipated\n        savings or goodwill, and any damages for personal or bodily injury, emotional distress, pain and suffering),\n        arising out of or in connection with this Terms and Conditions (including "),_c('u',[_vm._v("Privacy\n          Policy")]),_vm._v(" and "),_c('u',[_vm._v("Cookies Policy")]),_vm._v("), your use of the App, Website or Services, or any other\n        interactions with GoGoCinema, whether caused by breach of contract, tort, or other causes of action, even if\n        foreseeable or GoGoCinema has been advised of possibility of such damages.")])])]),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('ol',[_c('ol',[_c('li',[_vm._v("Without limiting the foregoing and to the extent permitted by applicable law,, you acknowledge and agree\n        that you are solely responsible for, and that GoGoCinema Parties are not liable for any Claims arising out of\n        or in connection with (i) your failure to comply with this Terms and Conditions (including "),_c('u',[_vm._v("Privacy\n          Policy")]),_vm._v(" and "),_c('u',[_vm._v("Cookies Policy")]),_vm._v("); (ii) content posted to the App or Website by you or any\n        third party, or content downloaded from or accessed through the App, Website or Services by you; (iii) delay,\n        deletion, mis-delivery or failure to store any content, user communications, or personalized settings; (iv)\n        conducts of third parties, including third-party service providers or operators of third-party websites; (v)\n        your interactions with third parties, or any other users of the App, Website or Services; or (vi) your\n        attendance of any events.")]),_vm._v(" "),_c('li',[_vm._v("To the extent permitted by applicable law, under no circumstances will GoGoCinema Parties’ liability\n        to you exceed the amount received by GoGoCinema from you (if any), in the three (3) months that precede the\n        date of your Claims. If you have not paid GoGoCinema within the three (3) months prior to the date of your\n        Claims, GoGoCinema Parties’ sole and exclusive liability to you will be limited to fifty United States\n        Dollars (USD 50).")])])]),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('ol',[_c('li',[_c('strong',[_vm._v("INDEMNITY")])]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("To the extent permissible under applicable law, you agree to hold harmless GoGoCinema Parties from any\n        Claims, due to or in relation to your (i) use of or access to the App, Website or Services (including\n        registration, use of or access to GoGoCinema account, or making available any content to GoGoCinema); (ii)\n        breach of this Terms and Conditions (including "),_c('u',[_vm._v("Privacy Policy")]),_vm._v(" and "),_c('u',[_vm._v("Cookies\n          Policy")]),_vm._v("); (iii) infringement of any rights or interests of third parties; or (iv) violation of any\n        applicable laws, rules or regulations. GoGoCinema reserves the right to defend or dispose (including possible\n        settlement) at its sole discretion any matter for which you should indemnify GoGoCinema at your sole costs and\n        expenses. You will fully cooperate with us to assert any available defenses. You agree that this indemnity\n        clause shall survive termination of your GoGoCinema account, this Terms and Conditions, your use of or access\n        to our App, Website or Services.")])]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("TERM AND TERMINATION")])]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("Terms and Conditions take effect upon your acceptance according to Clause 1 (Acceptance of Terms and\n        Changes), and remain in full force and effect between you and GoGoCinema, so long as you use or access the\n        App, Website, or Services, unless terminated earlier hereunder. If you use or access the App, Website or\n        Services before your acceptance of Terms and Conditions, effective date of this Terms and Conditions will be\n        the date of your first use or access.")]),_vm._v(" "),_c('li',[_vm._v("You may terminate your account for any reason at any time, by contacting GoGoCinema at "),_c('a',{attrs:{"href":"https://www.gogocinema.com/termsCondition"}},[_vm._v("support@gogocinema.com")]),_vm._v(" or sending notice in\n        writing to us at 1016 West Magnolia Boulevard, Burbank, California 91506. GoGoCinema has the right to, with or\n        without notice, at its sole discretion, (i) update, modify, suspend or terminate operation of or access to the\n        App, Website, Services, or any part thereof, for maintenance, error correction or other purposes as GoGoCinema\n        deems fit; or (ii) suspend or terminate your GoGoCinema account, remove, delete or discard any information you\n        provide, or any information stored by, sent to, or received by GoGoCinema through the App, Website or Services\n        for any reasonable purposes. Aforesaid purposes include but not limited to (i) concurrent use of your\n        GoGoCinema account; (ii) any other person’s use or access to the App, Website or Services through your\n        GoGoCinema account, whether or not with your permission; (iii) any unauthorized use of or access to the App,\n        Website or Services; (iv) your breach of Terms and Conditions; or (v) any intrusion or attempted intrusion of\n        software(s) or data embedded in the App, Website, or Services.")]),_vm._v(" "),_c('li',[_vm._v("GoGoCinema will not be liable for any Claims due to any conducts of GoGoCinema as stated in Clause 11.2.\n        Upon termination of GoGoCinema services (including operation of or access to the App, Website, Services or\n        your GoGoCinema account), your right to use said services terminate. Termination of GoGoCinema services will\n        not affect any right or relief that we are entitled to, at law or in equity. All clauses under Terms and\n        Conditions that by nature will survive termination of GoGoCinema services will survive, such as Clauses 6, 7,\n        8, 9, 10, 11and 12.")])]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("GENERAL PROVISIONS")])]),_vm._v(" "),_c('ol',[_c('li',[_c('strong',[_c('u',[_vm._v("Assignment.")])]),_vm._v(" Without prior written consent of GoGoCinema, you shall not assign,\n        subcontract, license, sub-license, delegate or otherwise transfer the Terms and Conditions, your obligations\n        and rights hereunder to any third party. Any attempted assignment, subcontract, license, sub-license,\n        delegation or transfer in breach of this clause will be null and void.")]),_vm._v(" "),_c('li',[_c('strong',[_c('u',[_vm._v("No Waiver.")])]),_vm._v(" Any failure or delay by GoGoCinema to enforce any provision of this\n        Terms and Conditions, or to exercise any right, will not be deemed a waiver of future enforcement of that or\n        any other provision(s), or of further exercise of the right or any other right(s). Any waiver in writing\n        signed by GoGoCinema in one occasion will not be deemed GoGoCinema’s waiver of any subsequent similar\n        cases in another occasion.ssss")]),_vm._v(" "),_c('li',[_c('strong',[_c('u',[_vm._v("Force Majeure.")])]),_vm._v(" GoGoCinema shall not be liable for any delay or failure in\n        performance of the Terms and Conditions due to causes beyond our reasonable control, including but not limited\n        to acts of hackers, acts or omission of third parties (including third-party Internet service providers or\n        telecommunications common carriers), overloading or reduced speed of the Internet, acts of God, war,\n        terrorism, riots, acts of civil or military authorities, fire, floods, accidents, strikes, or shortages of\n        transportation facilities, fuel, power, energy, labor or materials.")]),_vm._v(" "),_c('li',[_c('strong',[_c('u',[_vm._v("Compliance.")])]),_vm._v(" If you believe that GoGoCinema is in breach of the Terms and\n        Conditions, or if you are aware of any violation of Terms and Conditions by any other users of the App,\n        Website or Services, please notify GoGoCinema promptly at "),_c('a',{attrs:{"href":"https://www.gogocinema.com/termsCondition"}},[_vm._v("support@gogocinema.com")]),_vm._v(".")]),_vm._v(" "),_c('li',[_c('strong',[_c('u',[_vm._v("Dispute Resolution.")])]),_vm._v(" This Terms and Conditions will be governed by, construed\n        and enforced in accordance with the laws of California, without giving effect to any conflict of law rules.\n        All disputes arising out of or in connection with this Terms and Conditions, which cannot be resolved amicably\n        shall be submitted to the courts with competent jurisdiction in Los Angeles, California.")]),_vm._v(" "),_c('li',[_c('strong',[_c('u',[_vm._v("Severability.")])]),_vm._v(" If any provision(s) of this Terms and Conditions are found under\n        applicable law to be void or unenforceable, by a court of competent jurisdiction, the other provision(s) shall\n        remain in full force and effect. The invalid or unenforceable provision(s) will be limited to the minimum\n        extent necessary and replaced with valid provision(s) that best fits the intent of this Terms and Conditions,\n        to the maximum extent permitted by applicable law.")]),_vm._v(" "),_c('li',[_c('strong',[_c('u',[_vm._v("Entire Agreement.")])]),_vm._v(" This Terms and Conditions, including the Privacy Policy and\n        Cookies Policy incorporated herein by reference, constitute the entire agreement between you and GoGoCinema\n        regarding the subject matter, and supersede or replace all prior or contemporaneous understandings or\n        agreements, written or oral, with respect to the subject matter hereof.")])])]),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('p',[_vm._v("Last Updated October 2021")]),_vm._v(" "),_c('p',[_vm._v(" ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_terms_condition_ticket_vue__ = __webpack_require__(665);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88842fc4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_terms_condition_ticket_vue__ = __webpack_require__(1340);
function injectStyle (ssrContext) {
  __webpack_require__(1339)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_terms_condition_ticket_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88842fc4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_terms_condition_ticket_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1339 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"text-center title-tc font-weight-bold mt-5"},[_vm._v("GOGO CINEMA INSTRUCTIONS / TERMS & CONDITIONS")]),_vm._v(" "),_c('p',{staticClass:"mb-0 py-5"},[_vm._v("\n    Each Ticket purchased is a license to attend a particular Event, and is subject to any additional terms applicable to that Ticket that may be set by the venue or organization hosting the Event on the Ticket.\n  ")]),_vm._v(" "),_c('ol',[_c('li',{staticClass:"py-2"},[_vm._v("\n      Ordering : You do not have (and should not assume that You have) a valid Ticket unless and until You receive a confirmation email, notification, or SMS from GoGoCinema.\n    ")]),_vm._v(" "),_c('li',{staticClass:"py-2"},[_vm._v("\n      Transaction Error: If Your credit card has been charged, GoGoCinema will refund You the amount that You paid.These remedies will apply regardless of whether the error is attributable to human error or a transactional malfunction of the Services.\n    ")]),_vm._v(" "),_c('li',{staticClass:"py-2"},[_vm._v("\n      Using Tickets: All Tickets and Concessions are non-refundable and not redeemable for cash, unless required by law.Tickets for admission to (and related Concessions for) a specific Event at a named venue have no value once the Event date and time has passed.\n    ")]),_vm._v(" "),_c('li',{staticClass:"py-2"},[_vm._v("\n      You may not transfer, reproduce, resell, modify, gift, or trade Tickets or Concessions.\n    ")]),_vm._v(" "),_c('li',{staticClass:"py-2"},[_vm._v("\n      Tickets are generally delivered through the App but may also be delivered via email or SMS.  Tickets may only be redeemed one time.  If You forward a Ticket and it is redeemed by another person, Your Ticket will no longer be valid.\n    ")]),_vm._v(" "),_c('li',{staticClass:"py-2"},[_vm._v("\n      If a venue does not honor the Ticket or Concessions, please contact Us promptly at "),_c('a',{attrs:{"href":""}},[_vm._v("support@gogocinema.com")]),_vm._v(".\n    ")]),_vm._v(" "),_c('li',{staticClass:"py-2"},[_vm._v("\n      Cancelled Events. In the event an Event is canceled or postponed by the venue or organizer, We will provide You with a refund, credit, or exchange (in Our discretion). GoGoCinema will not be liable for any losses (monetary or otherwise) that You or anyone else incurs in connection with a canceled or postponed event.  Please contact Us at "),_c('a',{attrs:{"href":""}},[_vm._v("support@gogocinema.com")])])]),_vm._v(" "),_c('p',{staticClass:"mb-0 py-3"},[_vm._v("\n    Disclaimer: GoGoCinema sells Tickets and Concessions for Events, but is not responsible for the conditions at the venues where the Events take place, any aspect of the Concessions or for the actions of the Event promoters, the owners of the venue, or any participants or spectators at the Events.  The venue is solely responsible for (i) providing the Event or activity and all related goods and services; and (ii) any and all injuries, illnesses, damages, claims, liabilities, and costs You may suffer, directly or indirectly, as a result of You attending the Event.  If You are injured at an Event, immediately ask an usher for directions to a medical station.\n  ")]),_vm._v(" "),_c('p',{staticClass:"mb-0 pt-3 pb-5"},[_vm._v("\n    By purchasing a Ticket through GoGoCinema, You agree to these Terms on behalf of Yourself and any accompanying minor and You agree that You assume all risks incidental to the Event for which a Ticket is issued, whether before, during or after the Event.  To the fullest extent permissible under applicable law, GoGoCinema disclaims all liability for conditions at the venues where the Events take place, and for the actions of the Event promoters, the owners of the venue, or any participants or spectators at the Events, and You expressly waive any and all claims You might have against  GoGoCinema that arise from such conditions or actions.\n  ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_profile_vue__ = __webpack_require__(666);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d427678_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_profile_vue__ = __webpack_require__(1343);
function injectStyle (ssrContext) {
  __webpack_require__(1342)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d427678_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1342 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-auto d-none d-md-block pl-0"},[_c('div',{staticClass:"profileMenu-contanier"},[_c('ul',{staticClass:"profileMenu-list"},[_c('li',[_c('router-link',{class:[_vm.getPath == 'myaccount' ? 'active': ''],attrs:{"to":"/profile/myaccount"}},[_c('div',[_c('svg',{attrs:{"width":"16","height":"16","viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0.577834 5.00569C1.7963 1.97785 4.73412 -0.00409475 7.99771 1.35e-05C11.2621 -0.00596662 14.2017 1.9753 15.4213 5.00357C16.641 8.03183 15.8952 11.4976 13.538 13.7561C13.5358 13.7583 13.5342 13.761 13.5327 13.7637C13.5318 13.7654 13.5308 13.767 13.5298 13.7686C13.529 13.7696 13.5281 13.7706 13.5271 13.7715C13.5012 13.7965 13.474 13.8193 13.4469 13.842L13.4469 13.842L13.4469 13.8421C13.4256 13.8599 13.4043 13.8778 13.3838 13.8966C13.2552 14.0154 13.1267 14.1308 12.9913 14.2394C12.9494 14.273 12.9066 14.3044 12.8636 14.3359C12.8321 14.3589 12.8005 14.382 12.7691 14.4062L12.7691 14.4062C12.6411 14.5016 12.5132 14.597 12.3795 14.6849C12.3172 14.7277 12.2536 14.7656 12.1897 14.8036C12.1604 14.821 12.1312 14.8384 12.1019 14.8563L12.0698 14.8757L12.0698 14.8757C11.9572 14.9436 11.8447 15.0113 11.7284 15.0734C11.6481 15.1159 11.5665 15.154 11.4848 15.1921C11.4567 15.2052 11.4286 15.2183 11.4005 15.2316L11.3252 15.2674L11.3251 15.2674C11.2304 15.3125 11.1356 15.3576 11.0395 15.3973C10.9404 15.4383 10.8341 15.4754 10.7351 15.51L10.735 15.51L10.6687 15.5333C10.6351 15.5452 10.6015 15.5573 10.5678 15.5695C10.4852 15.5995 10.4023 15.6295 10.3174 15.6555C10.2102 15.6878 10.1008 15.7143 9.99147 15.7407L9.9073 15.7612C9.85839 15.7722 9.80947 15.7848 9.76055 15.7974L9.76053 15.7974L9.76042 15.7974C9.69514 15.8142 9.62985 15.831 9.56457 15.844C9.42702 15.8715 9.28773 15.8902 9.14821 15.9089L9.08703 15.9172C9.05027 15.9223 9.01383 15.9282 8.97741 15.934L8.9774 15.934L8.97738 15.934C8.9159 15.944 8.85448 15.9539 8.79171 15.96C8.53009 15.9857 8.26618 16 8 16C7.73381 16 7.4699 15.9857 7.20828 15.96C7.14551 15.9539 7.08409 15.944 7.02261 15.934L7.02257 15.934C6.98616 15.9282 6.94972 15.9223 6.91296 15.9172L6.85179 15.9089C6.71227 15.8902 6.57298 15.8715 6.43542 15.844C6.35415 15.8283 6.27615 15.8081 6.19803 15.7879L6.19798 15.7879L6.19787 15.7879L6.19778 15.7879C6.16287 15.7789 6.12794 15.7698 6.09269 15.7612L6.00851 15.7407L6.00849 15.7407L6.00847 15.7407C5.8992 15.7143 5.78979 15.6878 5.68255 15.6555C5.59165 15.6277 5.50771 15.5972 5.41786 15.5646L5.41783 15.5646L5.33125 15.5333C5.2984 15.5215 5.26563 15.5101 5.23292 15.4987L5.23282 15.4986L5.2328 15.4986L5.23278 15.4986C5.14157 15.4668 5.05089 15.4351 4.96053 15.3973C4.84926 15.3507 4.74175 15.2995 4.63331 15.2478L4.59952 15.2316C4.57142 15.2183 4.54328 15.2052 4.51515 15.1921C4.4335 15.154 4.35194 15.1159 4.27164 15.0734C4.15533 15.0113 4.04283 14.9436 3.93023 14.8757L3.89806 14.8563L3.85165 14.8279L3.85149 14.8278C3.77381 14.7802 3.69614 14.7326 3.62044 14.6849C3.4868 14.597 3.35887 14.5016 3.23094 14.4062L3.23092 14.4062L3.2309 14.4062L3.23087 14.4062C3.15661 14.3536 3.08121 14.2965 3.00867 14.2394C2.90314 14.1534 2.80177 14.0626 2.70132 13.9726L2.61624 13.8966C2.59564 13.8778 2.57439 13.8599 2.5531 13.8421L2.55307 13.842L2.55306 13.842C2.52594 13.8193 2.49878 13.7965 2.47286 13.7715C2.47049 13.7694 2.46889 13.7666 2.46726 13.7637C2.46574 13.761 2.46421 13.7583 2.46201 13.7561C0.10539 11.4982 -0.640628 8.03353 0.577834 5.00569ZM9.10759 7.69552C9.11102 7.69209 9.11445 7.69209 9.1173 7.69209C10.0229 7.18283 10.471 6.12662 10.2078 5.12145C9.94458 4.11629 9.03641 3.41526 7.99743 3.41526C6.95845 3.41526 6.05027 4.11629 5.78707 5.12145C5.52387 6.12662 5.97192 7.18283 6.87755 7.69209L6.88783 7.69552C7.0393 7.77985 7.1994 7.84765 7.36537 7.89775C7.37982 7.90169 7.39331 7.90624 7.40661 7.91072L7.40664 7.91073L7.40665 7.91074C7.42224 7.916 7.43758 7.92116 7.45391 7.92517C7.50578 7.9384 7.55947 7.948 7.61093 7.9572L7.62985 7.96059C7.74065 7.97996 7.85271 7.99122 7.96515 7.99429H8.03027C8.14271 7.99122 8.25478 7.97996 8.36558 7.96059L8.37228 7.95942C8.42896 7.94952 8.48656 7.93946 8.54151 7.92517C8.56023 7.92075 8.57753 7.9149 8.59474 7.90909C8.60642 7.90514 8.61805 7.90121 8.63005 7.89775C8.79602 7.84765 8.95612 7.77985 9.10759 7.69552ZM9.45261 8.81177C11.2936 9.43416 12.5419 11.1501 12.5675 13.0934L12.5441 13.1148C12.5283 13.1293 12.5126 13.1438 12.4961 13.158C12.3921 13.2494 12.2847 13.3362 12.1762 13.4202C12.1122 13.4693 12.0482 13.5179 11.9825 13.5647C11.8792 13.6395 11.7741 13.7104 11.6672 13.7784C11.5896 13.8281 11.5101 13.876 11.4302 13.9229C11.3296 13.98 11.2274 14.0371 11.124 14.0943C11.0326 14.1411 10.9395 14.1851 10.8458 14.2285C10.7521 14.2719 10.6487 14.3182 10.5476 14.3588C10.4465 14.3993 10.3391 14.4376 10.2335 14.473L10.1839 14.4901C10.1039 14.5177 10.0237 14.5454 9.94272 14.5696C9.84003 14.6004 9.73318 14.6261 9.62675 14.6517L9.59085 14.6604C9.56177 14.6672 9.53281 14.6743 9.50385 14.6814C9.44065 14.6969 9.37748 14.7124 9.31323 14.7249C9.18537 14.7498 9.05496 14.7674 8.92393 14.7852L8.90081 14.7883C8.87026 14.7923 8.8398 14.7969 8.80932 14.8015L8.80929 14.8015C8.76114 14.8088 8.71295 14.816 8.66433 14.8209C8.44498 14.842 8.22277 14.8546 7.99828 14.8546C7.77379 14.8546 7.55159 14.842 7.33224 14.8209C7.28362 14.816 7.23543 14.8088 7.18727 14.8015L7.18724 14.8015C7.15677 14.7969 7.1263 14.7923 7.09575 14.7883L7.07264 14.7852C6.94161 14.7674 6.81119 14.7498 6.68333 14.7249C6.61909 14.7124 6.55592 14.6969 6.49272 14.6814L6.49261 14.6814C6.46369 14.6743 6.43476 14.6672 6.40572 14.6604C6.28748 14.6318 6.1698 14.6033 6.05385 14.5696C5.97288 14.5454 5.8927 14.5177 5.81265 14.4901L5.81264 14.4901L5.76309 14.473C5.65742 14.4364 5.55174 14.3993 5.44892 14.3588C5.3461 14.3182 5.249 14.2736 5.15075 14.2285C5.0525 14.1834 4.96396 14.1411 4.87256 14.0943C4.76917 14.0406 4.66692 13.984 4.56639 13.9229C4.48642 13.876 4.40702 13.8281 4.32933 13.7784C4.22251 13.7104 4.11741 13.6395 4.01402 13.5647C3.94832 13.5179 3.88435 13.4693 3.82037 13.4202C3.71184 13.3362 3.60445 13.2488 3.50049 13.158C3.48411 13.1457 3.4687 13.1312 3.45315 13.1166C3.44485 13.1088 3.4365 13.101 3.42794 13.0934C3.45349 11.1501 4.70181 9.43416 6.54281 8.81177C7.46332 9.24971 8.5321 9.24971 9.45261 8.81177ZM10.5225 8.02286C12.0884 8.80112 13.2143 10.2507 13.5808 11.9606C14.4078 10.8047 14.8524 9.419 14.8524 7.99772C14.8539 5.03815 12.9551 2.4121 10.1443 1.48631C7.33347 0.56051 4.24595 1.54424 2.48864 3.92552C0.731331 6.30679 0.701469 9.54733 2.4146 11.9606C2.78117 10.2507 3.90702 8.80112 5.47291 8.02286C4.21856 6.65635 4.27887 4.53984 5.60899 3.24698C6.93911 1.95413 9.05631 1.95413 10.3864 3.24698C11.7166 4.53984 11.7769 6.65635 10.5225 8.02286Z"}})]),_vm._v("\n                    My Account\n                  ")])])],1),_vm._v(" "),_c('li',[_c('router-link',{class:[_vm.getPath == 'myNotification' ? 'active': ''],attrs:{"to":"/profile/myNotification"}},[_c('div',[_c('svg',{attrs:{"width":"16","height":"18","viewBox":"0 0 16 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16 11.6923C16 12.7112 15.1714 13.5385 14.1508 13.5385H1.8492C0.827975 13.5385 0 12.7124 0 11.6923C0 10.6736 0.827281 9.84615 1.8468 9.84615C1.8456 9.84615 1.84615 6.15361 1.84615 6.15361C1.84615 2.75418 4.6009 0 8 0C11.3991 0 14.1538 2.75484 14.1538 6.15361V9.84562C15.1712 9.84615 16 10.6733 16 11.6923ZM14.1532 11.0769C13.4732 11.0769 12.9231 10.5271 12.9231 9.84562V6.15361C12.9231 3.43456 10.7194 1.23077 8 1.23077C5.28058 1.23077 3.07692 3.43398 3.07692 6.15361V9.84562C3.07692 10.5252 2.5255 11.0769 1.8468 11.0769C1.50709 11.0769 1.23077 11.3533 1.23077 11.6923C1.23077 12.032 1.50709 12.3077 1.8492 12.3077H14.1508C14.4921 12.3077 14.7692 12.031 14.7692 11.6923C14.7692 11.3536 14.492 11.0769 14.1532 11.0769ZM6.46154 14.4615H5.23077C5.23077 15.9909 6.4706 17.2308 8 17.2308C9.5294 17.2308 10.7692 15.9909 10.7692 14.4615H9.53846C9.53846 15.3112 8.84967 16 8 16C7.15033 16 6.46154 15.3112 6.46154 14.4615Z"}})]),_vm._v("\n                    Notifications\n                  ")])])],1),_vm._v(" "),_c('li',[_c('router-link',{class:[_vm.getPath == 'myTransaction' ? 'active': ''],attrs:{"to":"/profile/myTransaction"}},[_c('div',[_c('svg',{attrs:{"width":"19","height":"16","viewBox":"0 0 19 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.97927 0H15.9739C17.2369 0.00205197 18.2602 1.02539 18.2623 2.28838V3.54624C18.2623 3.80353 18.0537 4.01211 17.7964 4.01211H14.6154V13.7116C14.6134 14.9746 13.59 15.9979 12.327 16H2.28838C1.02539 15.9979 0.00205197 14.9746 0 13.7116V12.4538C0 12.1965 0.208579 11.9879 0.465875 11.9879H2.66853V2.31074C2.66956 1.03498 3.70351 0.0010276 4.97927 0ZM0.931749 13.7116C0.932776 14.4604 1.53956 15.0672 2.28838 15.0683H10.4859C10.1952 14.6757 10.0384 14.2001 10.0387 13.7116V12.9196H0.931749V13.7116ZM13.6837 2.28838V13.7116C13.6837 14.4614 13.0759 15.0692 12.3261 15.0692C11.5764 15.0692 10.9686 14.4614 10.9686 13.7116V12.4538C10.9686 12.1965 10.76 11.9879 10.5027 11.9879H3.59469V2.31074C3.59572 1.54957 4.21251 0.932776 4.97368 0.931749H14.1346C13.8423 1.3237 13.6842 1.79944 13.6837 2.28838ZM14.6154 3.08036H17.3305V2.28838C17.3305 1.53862 16.7227 0.930818 15.973 0.930818C15.2232 0.930818 14.6154 1.53862 14.6154 2.28838V3.08036ZM8.03913 5.34265C8.1096 5.4442 8.13682 5.5696 8.1148 5.69122C8.09278 5.81285 8.02333 5.92074 7.92173 5.99115C7.30352 6.42047 6.76708 6.95691 6.33776 7.57512C6.25259 7.6986 6.11317 7.77351 5.9632 7.77638H5.9427C5.78329 7.76959 5.63845 7.6817 5.55882 7.54344C5.40162 7.26823 5.17391 7.03988 4.89914 6.8819C4.67821 6.75239 4.60325 6.46883 4.7313 6.24706C4.85934 6.02528 5.14239 5.94843 5.36501 6.07501C5.58536 6.20209 5.78673 6.35954 5.9632 6.54274C6.38066 6.04147 6.86395 5.59892 7.39995 5.22711C7.60916 5.08626 7.89247 5.13747 8.03913 5.34265ZM12.1481 6.92662C12.4054 6.92662 12.614 6.71805 12.614 6.46075C12.614 6.20345 12.4054 5.99488 12.1481 5.99488H9.52434C9.26705 5.99488 9.05847 6.20345 9.05847 6.46075C9.05847 6.71805 9.26705 6.92662 9.52434 6.92662H12.1481ZM4.7277 3.33007C4.78869 3.22253 4.88993 3.14365 5.00912 3.11079C5.12831 3.07794 5.25567 3.09381 5.36315 3.1549C5.58386 3.28078 5.78584 3.43697 5.9632 3.61891C6.38064 3.11763 6.86393 2.67508 7.39995 2.30328C7.61145 2.15663 7.90179 2.20919 8.04845 2.42068C8.19511 2.63218 8.14255 2.92252 7.93105 3.06918C7.30948 3.49525 6.76924 4.02918 6.3359 4.6457C6.25234 4.77077 6.11354 4.84781 5.9632 4.85255H5.9427C5.78329 4.84576 5.63845 4.75787 5.55882 4.61961C5.40218 4.3478 5.17655 4.12216 4.90473 3.96553C4.79687 3.90484 4.71759 3.80374 4.68438 3.68453C4.65117 3.56531 4.66675 3.43778 4.7277 3.33007ZM12.1481 3.99348C12.4054 3.99348 12.614 3.7849 12.614 3.5276C12.614 3.27031 12.4054 3.06173 12.1481 3.06173H9.52434C9.26705 3.06173 9.05847 3.27031 9.05847 3.5276C9.05847 3.7849 9.26705 3.99348 9.52434 3.99348H12.1481ZM8.03913 8.26648C8.18625 8.47748 8.13453 8.76777 7.9236 8.91498C7.30541 9.34433 6.76898 9.88077 6.33962 10.499C6.25407 10.623 6.11383 10.6979 5.9632 10.7002H5.9427C5.78329 10.6934 5.63845 10.6055 5.55882 10.4673C5.40211 10.1955 5.17649 9.96989 4.90473 9.81318C4.7594 9.73056 4.66948 9.57639 4.66912 9.40922C4.66875 9.24204 4.75799 9.08748 4.90295 9.00422C5.04792 8.92095 5.22638 8.92174 5.3706 9.00629C5.58849 9.13155 5.78792 9.28646 5.9632 9.46657C6.38012 8.96546 6.86277 8.52292 7.39809 8.15094C7.60766 8.00886 7.89235 8.06017 8.03913 8.26648ZM12.1481 9.85045C12.4054 9.85045 12.614 9.64188 12.614 9.38458V9.38272C12.613 9.12615 12.4047 8.9187 12.1481 8.9187H9.52434C9.26705 8.9187 9.05847 9.12728 9.05847 9.38458C9.05847 9.64188 9.26705 9.85045 9.52434 9.85045H12.1481Z"}})]),_vm._v("\n                    My Transactions\n                  ")])])],1)])])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('div',{staticClass:"profile-content"},[_c('router-view')],1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_myaccount_vue__ = __webpack_require__(667);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_157ce2c1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_myaccount_vue__ = __webpack_require__(1346);
function injectStyle (ssrContext) {
  __webpack_require__(1345)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_myaccount_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_157ce2c1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_myaccount_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1345 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mx-0 mb-5"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 mb-5 mb-lg-0 mx-auto"},[_c('form',[_c('div',{staticClass:"change-class d-flex align-items-center mb-3 mb-md-4"},[_c('div',{staticClass:"profile-img"},[(_vm.userDetails.ProfileURl != 'https://img.gogocinema.com/')?_c('img',{attrs:{"src":_vm.userDetails.ProfileURl}}):_c('img',{attrs:{"src":__webpack_require__(1347)}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('input',{staticClass:"d-none",attrs:{"type":"file","id":"editProfilePicture"},on:{"change":function($event){return _vm.onFileChanged($event)}}})]),_vm._v(" "),_c('div',{staticClass:"pr-lg-4 pr-xl-0"},[_c('div',{staticClass:"mb-3 mb-lg-4 d-flex align-items-center"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.userDetails.UserName),expression:"userDetails.UserName"}],attrs:{"type":"text","id":"username1","name":"username1","placeholder":"Enter User name","disabled":_vm.isUserNameDisabled},domProps:{"value":(_vm.userDetails.UserName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "UserName", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"mb-0 ml-2 text-nowrap change-class",attrs:{"for":"username1"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(312),"width":"20px"},on:{"click":function($event){_vm.isUserNameDisabled = !_vm.isUserNameDisabled}}})])]),_vm._v(" "),_c('div',{staticClass:"mb-3 mb-md-4",staticStyle:{"padding-right":"28px"}},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"},{name:"model",rawName:"v-model",value:(_vm.userDetails.Email),expression:"userDetails.Email"}],attrs:{"type":"email","id":"editEmail","name":"editEmail","placeholder":"Enter Email Id","disabled":_vm.isEmailDisabled},domProps:{"value":(_vm.userDetails.Email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "Email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"d-flex mb-4 align-items-center"},[_c('div',{staticClass:"w-100 d-flex mob-mx-w"},[_c('div',{staticClass:"country-code-drop drop-mob-max"},[_c('b-dropdown',{staticClass:"pc-input form-control aaaa",attrs:{"slot":"append","text":_vm.userDetails.country_mob_code || 'Code',"disabled":_vm.isPhoneNumberDisabled,"variant":"default"},slot:"append"},[_c('div',{staticClass:"px-2 pb-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchCode),expression:"searchCode"}],staticClass:"form-control form-control-sm",attrs:{"type":"search","placeholder":"Search Code"},domProps:{"value":(_vm.searchCode)},on:{"keyup":function($event){return _vm.onSearchCode($event.target.value)},"keydown":function($event){return _vm.onSearchCode($event.target.value)},"search":function($event){return _vm.onSearchCode($event.target.value)},"input":function($event){if($event.target.composing){ return; }_vm.searchCode=$event.target.value}}})]),_vm._v(" "),_vm._l((_vm.CountryCodeList),function(country,countryIndex){return _c('b-dropdown-item',{key:countryIndex,on:{"click":function($event){return _vm.onChangeCountryCode(country)}}},[_vm._v(_vm._s(country.country_mob_code)+"\n                  "+_vm._s(country.country_name))])})],2)],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.userDetails.MobileNo),expression:"userDetails.MobileNo"}],staticClass:"ml-2",attrs:{"type":"number","min":0,"id":"editNumber","name":"editNumber","placeholder":"Enter Mobile Number","disabled":_vm.isPhoneNumberDisabled},domProps:{"value":(_vm.userDetails.MobileNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "MobileNo", $event.target.value)}}})]),_vm._v(" "),_c('label',{staticClass:"mb-0 ml-2 text-nowrap change-class",attrs:{"for":"editNumber"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(312),"width":"20px"},on:{"click":function($event){_vm.isPhoneNumberDisabled = !_vm.isPhoneNumberDisabled}}})])]),_vm._v(" "),_c('b-modal',{ref:"countryModalRef",attrs:{"id":"countryModal","hide-header":"","hide-footer":""}},[_c('div',{staticClass:"modal-title"},[_vm._v("Choose your country")]),_vm._v(" "),_c('div',{staticClass:"p-3"},[_c('div',{staticClass:"row"},_vm._l((_vm.countries),function(country,index){return _c('div',{key:index,staticClass:"text-center col",attrs:{"index":index},on:{"click":function($event){return _vm.setCountry(country)}}},[_c('img',{staticClass:"flag-class",attrs:{"src":country.CountryFlag,"height":"60px","width":"100px"}}),_vm._v(" "),_c('h6',{staticClass:"pt-3"},[_vm._v(_vm._s(country.CountryName))])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"welcome-b"},[_c('b-modal',{ref:"enterPassword",attrs:{"id":"enterPassword","title":"Enter Your Password","hide-footer":""}},[_c('div',{staticClass:"row mx-4 my-4"},[_c('div',{staticClass:"col-md-12 loginmodal"},[_c('div',{staticClass:"mob-login-box"},[_c('div',{staticClass:"text-danger my-2 small font-weight-bold"},[_vm._v("\n                    "+_vm._s(_vm.errorMessage.error)+"\n                  ")]),_vm._v(" "),_c('b-form',{attrs:{"data-vv-scope":"verifyPassword"},on:{"submit":function($event){$event.preventDefault();return _vm.validateBeforeSubmit('verifyPassword')}}},[_c('b-input',{staticClass:"mb-2 mt-1 mx-auto pc-input",attrs:{"type":"password","id":"password1","name":"password1","placeholder":"Enter Your Password"},model:{value:(_vm.userDetails.password),callback:function ($$v) {_vm.$set(_vm.userDetails, "password", $$v)},expression:"userDetails.password"}}),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_c('input',{staticClass:"btn btn-danger gogo-btn",attrs:{"type":"submit","value":"Confirm"}})])],1)],1)])])])],1),_vm._v(" "),_c('div',{staticClass:"welcome-b"},[_c('b-modal',{ref:"errorModal",attrs:{"id":"errorModal","title":"Something went wrong!"}},[_c('div',{staticClass:"row mx-4 my-4"},[_c('div',{staticClass:"col-md-12 loginmodal"},[_c('div',{staticClass:"mob-login-box"},[_c('div',{staticClass:"text-danger my-2 small font-weight-bold"},[_vm._v("\n                    "+_vm._s(_vm.errorMessage.updateProfile)+"\n                  ")])])])])])],1),_vm._v(" "),_c('div',[_c('div',{staticClass:"text-success small font-weight-bold pb-2"},[_vm._v("\n            "+_vm._s(_vm.errorMessage.updateProfile)+"\n          ")]),_vm._v(" "),_c('input',{staticClass:"btn-gogo",attrs:{"value":"Save Changes"},on:{"click":function($event){return _vm.validateBeforeSubmit('updateProfile')}}})])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"edit-profile-link mb-0",attrs:{"for":"editProfilePicture"}},[_c('img',{attrs:{"src":__webpack_require__(312),"width":"15px","height":"15px"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1347 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mySpecialScreening_vue__ = __webpack_require__(668);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0204e8cc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mySpecialScreening_vue__ = __webpack_require__(1350);
function injectStyle (ssrContext) {
  __webpack_require__(1349)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0204e8cc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mySpecialScreening_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0204e8cc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mySpecialScreening_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1349 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tabs',{attrs:{"content-class":"mt-4","nav-wrapper-class":"switching-tabs"}},[_c('b-tab',{attrs:{"title":"My Created Screening (0)","active":""}},[_c('div',{staticClass:"d-none"},[_c('p',{staticClass:"mb-4"},[_vm._v("\n        Aw shucks! You don’t have any new event(s) that you’ve created\n        "),_c('br'),_vm._v("Go ahead make one! The force is strong with you.\n      ")]),_vm._v(" "),_c('button',{staticClass:"btn-gogo btn-cos"},[_vm._v("Create your own screening")])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"cs-container"},[_c('div',{staticClass:"d-flex flex-wrap"},[_c('div',{staticClass:"w-100"},[_c('div',{staticClass:"d-flex flex-wrap"},[_c('div',{staticClass:"col-3 col-md-2 col-xl-1 px-0"},[_c('img',{staticClass:"img-fluid rounded",attrs:{"src":__webpack_require__(1351),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"col-9 col-md-10 col-xl-11 d-flex flex-wrap pr-0"},[_c('div',{staticClass:"col-md-4 pl-md-0"},[_c('div',{staticClass:"font-weight-bold"},[_vm._v("The Gifted Hands")]),_vm._v(" "),_c('div',{staticClass:"small"},[_c('span',[_vm._v("Korean")]),_vm._v(" "),_c('span',[_vm._v("|")]),_vm._v(" "),_c('span',[_vm._v("120 Min")]),_vm._v(" "),_c('span',[_vm._v("2013")]),_vm._v(" "),_c('span',[_vm._v("Kwn Ha-youg")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 pl-md-0"},[_c('div',{staticClass:"text-primary"},[_vm._v("Capitol Theater")]),_vm._v(" "),_c('div',[_vm._v("Sep 4 , 2018 | 3:30 PM")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 text-md-right"},[_c('button',{staticClass:"btn-gogo mw-230 ml-md-auto d-none d-md-block"},[_vm._v("Share with friends")]),_vm._v(" "),_c('div',{staticClass:"mt-md-2"},[_c('span',{staticClass:"small"},[_c('router-link',{staticClass:"text-dark",attrs:{"to":"#"}},[_vm._v("Resend Email")])],1),_vm._v(" "),_c('span',[_vm._v("|")]),_vm._v(" "),_c('span',{staticClass:"small"},[_c('router-link',{staticClass:"text-dark",attrs:{"to":"#"}},[_vm._v("Resend M-ticket")])],1)])]),_vm._v(" "),_c('div',{staticClass:"col-12 d-none d-md-block"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 col-lg-8 col-xl-5 d-none d-md-block pl-md-0"},[_c('div',{staticClass:"d-flex justify-content-between lh-1"},[_c('div',[_vm._v("NOT CONFIRMED")]),_vm._v(" "),_c('div',{staticClass:"small"},[_vm._v("15 OUT OF 85 SEATS SOLD")])]),_vm._v(" "),_c('b-progress',{staticClass:"my-2",attrs:{"height":"22px","value":50,"variant":_vm.variant,"show-progress":""}}),_vm._v(" "),_c('div',{staticClass:"tiny text-right"},[_vm._v("Only 10 Seats Required")])],1),_vm._v(" "),_c('div',{staticClass:"col-xl-7 d-flex align-items-center justify-content-end"},[_c('div',{staticClass:"small"},[_c('router-link',{staticClass:"text-primary",attrs:{"to":"#"}},[_vm._v("Edit")]),_vm._v(" "),_c('span',[_vm._v("|")]),_vm._v(" "),_c('router-link',{staticClass:"text-primary",attrs:{"to":"#"}},[_vm._v("Delete")])],1)])])])]),_vm._v(" "),_c('div',{staticClass:"w-100 d-md-none mt-2"},[_c('div',{staticClass:"d-flex justify-content-between"},[_c('div',[_vm._v("NOT CONFIRMED")]),_vm._v(" "),_c('div',{staticClass:"small"},[_vm._v("15 OUT OF 85 SEATS SOLD")])]),_vm._v(" "),_c('b-progress',{staticClass:"my-1",attrs:{"height":"18px","value":50,"variant":_vm.variant,"show-progress":""}}),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between align-items-center"},[_c('div',{staticClass:"small"},[_vm._v("Only 10 Seats Required")]),_vm._v(" "),_c('div',[_c('router-link',{staticClass:"text-primary small",attrs:{"to":"#"}},[_vm._v("Edit")]),_vm._v(" "),_c('span',[_vm._v("|")]),_vm._v(" "),_c('router-link',{staticClass:"text-primary small",attrs:{"to":"#"}},[_vm._v("Delete")])],1)])],1)])])])])]),_vm._v(" "),_c('div',{staticClass:"cas-container"},[_c('router-link',{attrs:{"to":"#"}},[_c('svg',{attrs:{"width":"59","height":"59","viewBox":"0 0 59 59","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M29.5 59C45.7924 59 59 45.7924 59 29.5C59 13.2076 45.7924 0 29.5 0C13.2076 0 0 13.2076 0 29.5C0 45.7924 13.2076 59 29.5 59Z","fill":"#2B2D42"}}),_vm._v(" "),_c('path',{attrs:{"d":"M20.5 25H17.5C15.0147 25 13 27.0147 13 29.5C13 31.9853 15.0147 34 17.5 34H20.5C22.9853 34 25 36.0147 25 38.5V41.5C25 43.9853 27.0147 46 29.5 46C31.9853 46 34 43.9853 34 41.5V38.5C34 36.0147 36.0147 34 38.5 34H41.5C43.9853 34 46 31.9853 46 29.5C46 27.0147 43.9853 25 41.5 25H38.5C36.0147 25 34 22.9853 34 20.5V17.5C34 15.0147 31.9853 13 29.5 13C27.0147 13 25 15.0147 25 17.5V20.5C25 22.9853 22.9853 25 20.5 25Z","fill":"#fff"}})]),_vm._v(" "),_c('div',{staticClass:"mt-2 font-weight-bold text-dark"},[_vm._v("Created Another Screening")])])],1)]),_vm._v(" "),_c('b-tab',{attrs:{"title":"My Booked Screening (0)"}},[_c('p',[_vm._v("I'm the second tab content")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/screening.75de290.png";

/***/ }),
/* 1352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_myNotification_vue__ = __webpack_require__(669);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff66a3d0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_myNotification_vue__ = __webpack_require__(1354);
function injectStyle (ssrContext) {
  __webpack_require__(1353)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_myNotification_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff66a3d0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_myNotification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1353 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tabs',{attrs:{"content-class":"my-4","nav-wrapper-class":"switching-tabs"}},[_c('b-tab',{attrs:{"title":'Notifications ('+Object.keys(_vm.notifications).length+')',"active":""}},_vm._l((_vm.notifications),function(singleNotifications,notificationIndex){return _c('ul',{key:notificationIndex,staticClass:"notification-list"},_vm._l((_vm.notifications[notificationIndex]),function(item,index){return _c('li',{key:index},[(index == 0)?_c('div',{staticClass:"col-12 pb-3"},[_c('span',{staticClass:"notification-date"},[_vm._v(_vm._s(item.Date))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-10 d-flex align-items-center"},[_c('div',[_c('img',{staticClass:"pr-3 notificationImage",attrs:{"src":item.notificationImage}})]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(item.Message)}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-12 col-md-2 d-flex align-items-center justify-content-md-end"},[_c('div',{staticClass:"text-right ml-auto"},[_c('span',[_vm._v(_vm._s(item.Time))])])])])}),0)}),0)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_myFavourites_vue__ = __webpack_require__(670);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cdfdc7e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_myFavourites_vue__ = __webpack_require__(1357);
function injectStyle (ssrContext) {
  __webpack_require__(1356)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_myFavourites_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cdfdc7e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_myFavourites_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1356 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},_vm._l((10),function(loop,key){return _c('div',{key:key,staticClass:"col-lg-4 col-xl-3"},[_vm._m(0,true)])}),0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"favourite-container mx-auto ml-md-auto"},[_c('div',{staticClass:"d-flex"},[_c('div',[_c('div',{staticClass:"fav-img"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(1358)}}),_vm._v(" "),_c('div',{staticClass:"status"},[_vm._v("5 Screenig")])]),_vm._v(" "),_c('div',{staticClass:"movie-title"},[_vm._v("Justice League")]),_vm._v(" "),_c('div',{staticClass:"movie-info"},[_c('span',[_vm._v("PG-13")]),_vm._v(" "),_c('span',[_vm._v("|")]),_vm._v(" "),_c('span',[_vm._v("2018")])])]),_vm._v(" "),_c('div',[_c('form',[_c('input',{staticClass:"d-none",attrs:{"type":"checkbox","id":"favourite"}}),_vm._v(" "),_c('label',{attrs:{"for":"favourite"}})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fav.003c64c.png";

/***/ }),
/* 1359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_myTransaction_vue__ = __webpack_require__(671);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74c8091e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_myTransaction_vue__ = __webpack_require__(1366);
function injectStyle (ssrContext) {
  __webpack_require__(1360)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_myTransaction_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74c8091e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_myTransaction_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1360 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"verify-c"},[_c('b-modal',{ref:"resendTicket",attrs:{"id":"resendTicket","title":"Success!"}},[_c('div',{staticClass:"p-5"},[_c('div',{staticClass:"text-center mb-3"},[_c('img',{attrs:{"width":"47","height":"auto","src":__webpack_require__(56)}})]),_vm._v(" "),_c('div',{staticClass:"text-center text-success mt-3 mt-md-0"},[_vm._v("\n          Your ticket has been sent to registered email address.\n        ")])])])],1),_vm._v(" "),_c('div',[_c('div',{staticClass:"transaction-tabs-wrapper"},[_c('div',_vm._l((_vm.TabTransacton),function(item,index){return _c('button',{key:index,staticClass:"btn-transparent mr-2",class:_vm.tabVal == item.val ? 'active' : '',staticStyle:{"outline":"none"},on:{"click":function($event){return _vm.showTransaction(item)}}},[_vm._v("\n          "+_vm._s(item.text)+"\n        ")])}),0)])]),_vm._v(" "),(_vm.transctions.length > 0)?_c('div',_vm._l((_vm.transctions),function(trans,transKey){return _c('div',{key:transKey},[_c('div',{staticClass:"d-none d-lg-block"},[_c('div',{staticClass:"corner-circle-top mt-5 mx-2 overflow-hidden"},[_c('div',{staticClass:"corner-circle-bottom bg-light m-ticket-web"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-8 p-4 p-xl-5"},[_c('div',{staticClass:"h-100"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-4 col-xl-3 pr-0 pr-xl-3"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(trans.md_thumbnail_url),expression:"trans.md_thumbnail_url"}],staticClass:"img-fluid rounded"})]),_vm._v(" "),_c('div',{staticClass:"col-8 col-xl-9"},[_c('div',{staticClass:"px-3"},[_c('div',{},[_c('p',{staticClass:"text-capitalize font-weight-bold mb-0 ticket-mtitle"},[_vm._v("\n                              "+_vm._s(trans.movie_name)+"\n                            ")]),_vm._v(" "),_c('ul',{staticClass:"list-inline m-tick-mInfo"},[_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                                "+_vm._s(trans.movie_language)+" ("+_vm._s(trans.movie_format)+")\n                              ")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                                "+_vm._s(_vm._f("moment")(trans.ss_start_date))+"\n                              ")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                                "+_vm._s(trans.movie_rating)+"\n                              ")])])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between align-items-end my-3"},[_c('div',[_c('p',{staticClass:"mb-0 txt14-light-blue"},[_vm._v("\n                                "+_vm._s(trans.cine_name)+" -\n                                "+_vm._s(trans.screen_name)+"\n                              ")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center text-dark"},[_c('div'),_vm._v(" "),_c('div',{staticClass:"mr-1"},[_c('span',{},[_vm._v(_vm._s(_vm._f("moment")(trans.ss_start_date))+" |\n                                    "+_vm._s(_vm.timeFormat(trans.t_show_time)))])])])])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between align-items-center my-3"},[_c('div',[(trans.booking_type_id == 3)?_c('p',{staticClass:"text-muted mb-0 tiny"},[_vm._v("\n                                Seats: (All Booked)\n                              ")]):_c('p',{staticClass:"text-muted mb-0 tiny"},[_vm._v("\n                                Seats:\n                                "+_vm._s(trans.seat_names &&
                                    trans.seat_names.split(",").length)+"\n                              ")]),_vm._v(" "),_c('ul',{staticClass:"list-inline mt-seat-list mb-0"},[(trans.booking_type_id == 3)?_c('li',{staticClass:"list-inline-item mx-0"},[_vm._v("\n                                  "+_vm._s(trans.seat_name &&
                                      trans.seat_name
                                        .split(",")
                                        .join(", ")
                                        .replace("Hall", "Auditorium"))+"\n                                ")]):_c('li',{staticClass:"list-inline-item mx-0"},[_vm._v("\n                                  "+_vm._s(trans.seat_names &&
                                      trans.seat_names.split(",").join(", "))+"\n                                ")])])])]),_vm._v(" "),_c('div',{staticClass:"m-ticket-details"},[_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-xl-9 col-md-8 text-muted tiny"},[_vm._v("\n                                Ticket Price\n                              ")]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-xl-3 amt-text tiny"},[_vm._v("\n                                "+_vm._s(_vm.curr_code)+"\n                                "+_vm._s(_vm.currFormat(trans.sb_total_net_amount))+"\n                              ")])]),_vm._v(" "),(
                                trans.chargeTypeArray &&
                                  trans.chargeTypeArray.length > 0
                              )?_c('div',{staticClass:"m-ticket-details"},_vm._l((trans.chargeTypeArray),function(charge,chargeIndex){return _c('div',{key:chargeIndex,staticClass:"row mb-2"},[_c('div',{staticClass:"col-xl-9 col-md-8 text-muted tiny"},[_vm._v("\n                                  "+_vm._s(charge.ct_name)+"\n                                ")]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-xl-3 amt-text tiny"},[_vm._v("\n                                  "+_vm._s(_vm.curr_code)+"\n                                  "+_vm._s(_vm.currFormat(charge.tax_amount))+"\n                                ")])])}),0):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-md-8 col-xl-9 text-muted tiny"},[_vm._v("\n                                Discount\n                              ")]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-xl-3 amt-text tiny"},[_vm._v("\n                                "+_vm._s(_vm.curr_code)+"\n                                "+_vm._s(_vm.currFormat(trans.offer_price))+"\n                              ")])])])]),_vm._v(" "),_c('div',{staticClass:"px-3 mt-2 pt-2 d-md-none d-lg-block mt-border-top"},[_c('div',{staticClass:"m-ticket-details"},[_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-xl-9 col-md-8 ticket-mtitle font-weight-bold"},[_vm._v("\n                                Total\n                              ")]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-xl-3 ticket-mtitle font-weight-bold pr-0"},[_vm._v("\n                                "+_vm._s(_vm.curr_code)+"\n                                "+_vm._s(_vm.currFormat(
                                    trans.sb_total_amount_paid -
                                      trans.offer_price - 
                                      trans.TaxOffer
                                  ))+"\n                              ")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-4 text-center p-3 p-lg-3 p-xl-5 mt-border mt-qr-section"},[_c('div',{staticClass:"h-100 d-flex align-items-center justify-content-center"},[_c('div',{staticClass:"w-100"},[(true)?_c('p',{staticClass:"info"},[_vm._v("\n                        Use this QR Code to Enter the Cinema\n                      ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"pb-2"},[_c('img',{staticClass:"img-fluid qr-code",attrs:{"src":trans.qrcode,"alt":'name',"height":"150px","width":"150px"}})]),_vm._v(" "),_c('div',{staticClass:"pt-3 pb-4"},[(
                            trans.booking_type_id != 3 &&
                              trans.booking_type_id
                          )?_c('div',{staticClass:"pb-1 text-center"},[_c('p',{staticClass:"mb-0 font-weight-bold confText",style:(_vm.show_status(trans).isConfirmed == 'N'
                                ? 'color:red'
                                : 'color:green')},[_vm._v("\n                            "+_vm._s(_vm.show_status(trans).status)+"\n                          ")])]):_vm._e(),_vm._v(" "),(
                            trans.booking_type_id != 3 &&
                              trans.booking_type_id
                          )?_c('div',[(trans.booking_type_id == 2)?_c('b-progress',{staticClass:"proBar ticket-proBar mb-0",class:_vm.show_status(trans).isConfirmed == 'N'
                                ? 'red'
                                : 'bg-success',attrs:{"max":_vm.show_status(trans).max}},[_c('b-progress-bar',{attrs:{"value":_vm.show_status(trans).value}},[_c('p',{staticClass:"mb-0 succ-text",class:_vm.show_status(trans).isConfirmed == 'N'
                                    ? ' status-text-h'
                                    : ''},[_vm._v("\n                                "+_vm._s(_vm.show_status(trans).message)+"\n                              ")])])],1):_vm._e(),_vm._v(" "),(trans.booking_type_id == 1)?_c('b-progress',{staticClass:"proBar ticket-proBar mb-0",attrs:{"max":parseInt(100)}},[_c('b-progress-bar',{attrs:{"value":parseInt(100)}},[_c('p',{staticClass:"mb-0 succ-text"},[_vm._v("\n                                "+_vm._s(_vm.show_status(trans).message)+"\n                              ")])])],1):_vm._e()],1):(trans.booking_type_id == 3)?_c('div',[_c('b-progress',{staticClass:"proBar ticket-proBar bg-warning mb-0",attrs:{"max":parseInt(trans.screen_total_seats)}},[_c('b-progress-bar'),_vm._v(" "),_c('p',{staticClass:"mb-0 reqText mx-auto pr-2"},[_vm._v("\n                              Private Screening\n                            ")])],1)],1):_c('div',[_c('b-progress',{staticClass:"proBar ticket-proBar bg-success mb-0",attrs:{"max":parseInt(100)}},[_c('b-progress-bar'),_vm._v(" "),_c('p',{staticClass:"mb-0 reqText mx-auto pr-2"},[_vm._v("\n                              Regular Screening\n                            ")])],1)],1),_vm._v(" "),(
                            trans.ShowStatusMsg == 'UNCONFIRMED' ||
                              trans.ShowStatusMsg == 'CONFIRMED'
                          )?_c('div',[_c('div',{staticClass:"btn-share",attrs:{"id":'tooltip-button-' + (transKey + 1)},on:{"click":function($event){return _vm.copyTextShare(transKey)}}},[_c('p',{staticStyle:{"cursor":"pointer"}},[_vm._v("Share")])])]):_vm._e(),_vm._v(" "),_c('b-tooltip',{attrs:{"show":trans.show,"disabled":true,"target":'tooltip-button-' + (transKey + 1),"placement":"bottom","variant":"outline-success","custom-class":"tool-tip-cop"}},[_c('strong',[_vm._v("Copied")])])],1)])])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-11 mx-auto mt-3"},[_c('ul',{staticClass:"list-inline"},[_c('li',{staticClass:"list-inline-item mr-3"},[_c('p',{staticClass:"mb-1 text-muted"},[_vm._v("Booking Date & Time:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("date")(trans.transaction_date_time))+" |\n                "+_vm._s(_vm.timeFormat(_vm.GetTime(trans.transaction_date_time))))])]),_vm._v(" "),_c('li',{staticClass:"list-inline-item mr-3"},[_c('p',{staticClass:"mb-1 text-muted"},[_vm._v("Payment Method")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(trans.payment_mode))])]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_c('p',{staticClass:"mb-1 text-muted"},[_vm._v("Booking ID")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(trans.sb_booking_code))])])])])]),_vm._v(" "),(false)?_c('div',{staticClass:"d-block d-lg-none d-none"},[(trans.Resend)?_c('div',{staticClass:"corner-circle-top my-5 mx-2 ticket-shadow mt-tick"},[_c('div',{staticClass:"corner-circle-bottom"},[_c('div',{staticClass:"col-12 bg-light py-5 px-3"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-4"},[_c('img',{staticClass:"img-fluid rounded",attrs:{"src":trans.Image}})]),_vm._v(" "),_c('div',{staticClass:"col-8 pl-0"},[_c('p',{staticClass:"text-capitalize font-weight-bold mb-0 ticket-mtitle"},[_vm._v("\n                    "+_vm._s(trans.Title)+"\n                  ")]),_vm._v(" "),_c('ul',{staticClass:"list-inline m-tick-mInfo"},[_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(trans.Language))]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(trans.Runtime))]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(trans.Year))]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(trans.Rated))])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between align-items-end mt-3"},[_c('div',[_c('p',{staticClass:"mb-0 txt14-light-blue"},[_vm._v("\n                        "+_vm._s(trans.CinemaName)+" "+_vm._s(trans.ScreenNo)+"\n                      ")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center text-dark"},[_c('div',[_c('span',[_vm._v(_vm._s(trans.timing[0]))]),_vm._v(" "),_c('span',{staticClass:"tfText"},[_vm._v("\n                            "+_vm._s(trans.timing[1])+"\n                            "),_c('span',{staticClass:"mx-1"},[_vm._v("|")])])]),_vm._v(" "),_c('div',{staticClass:"mr-1"},[_c('span',{},[_vm._v(_vm._s(trans.MovieDate))])])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center my-3 px-3"},[_c('div',[_c('p',{staticClass:"text-muted mb-0 tiny"},[_vm._v("\n                        Seats: "+_vm._s(trans.SeatsBooked)+"\n                      ")]),_vm._v(" "),_c('ul',{staticClass:"list-inline mt-seat-list mb-0"},[_c('li',{staticClass:"list-inline-item mx-0"},[_vm._v("\n                          "+_vm._s(trans.Seats)+"\n                        ")])])])]),_vm._v(" "),_c('div',{staticClass:"m-ticket-details px-3"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-2"},[_c('p',{staticClass:"mb-0 text-muted tiny"},[_vm._v("Ticket Price")]),_vm._v(" "),_c('p',{staticClass:"mb-0 amt-text tiny"},[_vm._v("\n                        "+_vm._s(trans.Currency)+" "+_vm._s(trans.TotalPrice)+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-2"},[_c('p',{staticClass:"mb-0 text-muted tiny"},[_vm._v("GST")]),_vm._v(" "),_c('p',{staticClass:"mb-0 amt-text tiny"},[_vm._v("\n                        "+_vm._s(trans.Currency)+" "+_vm._s(trans.GST)+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-2"},[_c('p',{staticClass:"mb-0 text-muted tiny"},[_vm._v("Service Charge")]),_vm._v(" "),_c('p',{staticClass:"mb-0 amt-text tiny"},[_vm._v("\n                        "+_vm._s(trans.Currency)+" "+_vm._s(trans.TicketHandling)+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between align-items-center"},[_c('p',{staticClass:"mb-0 text-muted tiny"},[_vm._v("Discount")]),_vm._v(" "),_c('p',{staticClass:"mb-0 amt-text tiny"},[_vm._v("\n                        "+_vm._s(trans.Currency)+" "+_vm._s(trans.Discount)+"\n                      ")])])]),_vm._v(" "),_c('div',{staticClass:"pl-3 mt-2 pt-2 mt-border-top"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center"},[_c('p',{staticClass:"mb-0 ticket-mtitle font-weight-bold"},[_vm._v("Total")]),_vm._v(" "),_c('p',{staticClass:"mb-0 ticket-mtitle font-weight-bold"},[_vm._v("\n                        "+_vm._s(trans.Currency)+" "+_vm._s(trans.Total)+"\n                      ")])])])])]),_vm._v(" "),_c('div',{staticClass:"row mt-4"},[_c('div',{staticClass:"col-12 align-self-center text-center"},[(trans.ShowStatus == '1')?_c('p',{staticClass:"info"},[_vm._v("\n                    Use this QR Code to Enter the Cinema\n                  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"pb-2"},[_c('img',{staticClass:"img-fluid qr-code",attrs:{"src":trans.QRCode,"alt":'name',"height":"150px","width":"150px"}})]),_vm._v(" "),_c('div',{staticClass:"pt-3 pb-4"},[(
                        trans.booking_type_id != 3 && trans.booking_type_id
                      )?_c('div',{staticClass:"pb-1 text-center"},[_c('p',{staticClass:"mb-0 font-weight-bold confText",style:(_vm.show_status(trans).isConfirmed == 'N'
                            ? 'color:red'
                            : 'color:green')},[_vm._v("\n                        "+_vm._s(_vm.show_status(trans).status)+"\n                      ")])]):_vm._e(),_vm._v(" "),(
                        trans.booking_type_id != 3 && trans.booking_type_id
                      )?_c('div',[(trans.booking_type_id == 2)?_c('b-progress',{staticClass:"proBar ticket-proBar mb-0",class:_vm.show_status(trans).isConfirmed == 'N'
                            ? 'red'
                            : 'bg-success',attrs:{"max":_vm.show_status(trans).max}},[_c('b-progress-bar',{attrs:{"value":_vm.show_status(trans).value}},[_c('p',{staticClass:"mb-0 succ-text",class:_vm.show_status(trans).isConfirmed == 'N'
                                ? ' status-text-h'
                                : ''},[_vm._v("\n                            "+_vm._s(_vm.show_status(trans).message)+"\n                          ")])])],1):_vm._e(),_vm._v(" "),(trans.booking_type_id == 1)?_c('b-progress',{staticClass:"proBar ticket-proBar mb-0",attrs:{"max":parseInt(100)}},[_c('b-progress-bar',{attrs:{"value":parseInt(100)}},[_c('p',{staticClass:"mb-0 succ-text"},[_vm._v("\n                            "+_vm._s(_vm.show_status(trans).message)+"\n                          ")])])],1):_vm._e()],1):(trans.booking_type_id == 3)?_c('div',[_c('b-progress',{staticClass:"proBar ticket-proBar bg-warning mb-0",attrs:{"max":parseInt(trans.screen_total_seats)}},[_c('b-progress-bar'),_vm._v(" "),_c('p',{staticClass:"mb-0 reqText mx-auto pr-2"},[_vm._v("\n                          Private Screening\n                        ")])],1)],1):_c('div',[_c('b-progress',{staticClass:"proBar ticket-proBar bg-success mb-0",attrs:{"max":parseInt(100)}},[_c('b-progress-bar'),_vm._v(" "),_c('p',{staticClass:"mb-0 reqText mx-auto pr-2"},[_vm._v("\n                          Regular Screening\n                        ")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"pt-3 pb-0 px-3 px-md-4"},[_c('div',{staticClass:"pb-1 text-center"},[_c('p',{staticClass:"mb-0 font-weight-bold",style:(trans.ShowStatus == '3' || trans.ShowStatus == '2'
                            ? 'color:red'
                            : '')},[_vm._v("\n                        "+_vm._s(trans.ShowStatusMsg)+"\n                      ")])]),_vm._v(" "),_c('div',[(
                          trans.ConfirmedStatus == false &&
                            trans.ShowStatus == '0'
                        )?_c('b-progress',{staticClass:"proBar ticket-proBar red mb-0",attrs:{"max":parseInt(trans.TotalSeat)}},[_c('b-progress-bar',{attrs:{"value":trans.SeatsBooked}}),_vm._v(" "),_c('p',{staticClass:"mb-0 reqText mx-auto pr-2",class:trans.ConfirmedStatus ? 'd-none' : '',domProps:{"innerHTML":_vm._s(trans.ExpiryMsg)}})],1):_vm._e(),_vm._v(" "),(
                          trans.ConfirmedStatus && trans.ShowStatus == '1'
                        )?_c('b-progress',{staticClass:"proBar ticket-proBar mb-0",attrs:{"max":parseInt(trans.TotalSeat)}},[_c('b-progress-bar',{attrs:{"value":parseInt(trans.TotalSeat)}},[_c('p',{staticClass:"mb-0 succ-text"},[_vm._v("\n                            "+_vm._s(parseInt(trans.TotalSeat) -
                                parseInt(trans.SeatsBooked))+"\n                            Seats Left\n                          ")])])],1):_vm._e()],1)])])])])])]):_vm._e(),_vm._v(" "),(trans.Resend)?_c('div',{staticClass:"col-12 col-md-11 mx-auto mt-3"},[_c('ul',{staticClass:"list-inline"},[_c('li',{staticClass:"list-inline-item mb-3"},[_c('p',{staticClass:"mb-1 text-muted tiny"},[_vm._v("Booking Date & Time:")]),_vm._v(" "),_c('span',{staticClass:"tiny"},[_vm._v(_vm._s(trans.BookingDate))])]),_vm._v(" "),_c('li',{staticClass:"list-inline-item mb-3"},[_c('p',{staticClass:"mb-1 text-muted tiny"},[_vm._v("Payment Method")]),_vm._v(" "),_c('span',{staticClass:"tiny"},[_vm._v(_vm._s(trans.PaymentMethod))])]),_vm._v(" "),_c('li',{staticClass:"list-inline-item mb-3"},[_c('p',{staticClass:"mb-1 text-muted tiny"},[_vm._v("Booking ID")]),_vm._v(" "),_c('span',{staticClass:"tiny"},[_vm._v(_vm._s(trans.BookingID))])])])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-8 mx-auto px-0 d-block d-lg-none"},[_c('div',{staticClass:"new-mTicket bg-light"},[_c('div',{staticClass:"ticket-info"},[_c('div',{staticClass:"px-3 py-3"},[_c('div',{staticClass:"d-flex align-items-center justify-content-between mb-3"},[_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"text-right"},[_c('p',{staticClass:"pt-2"},[_vm._v("Ticket No :"+_vm._s(trans.sb_booking_code))])])]),_vm._v(" "),_c('div',{staticClass:"col-12 px-0"},[_c('div',{staticClass:"border-bottom pb-2"},[_c('p',{staticClass:"movie-title"},[_vm._v(_vm._s(trans.movie_name))]),_vm._v(" "),_c('ul',{staticClass:"list-inline extra-movie-info py-1"},[_c('li',{staticClass:"list-inline-item"},[_vm._v("\n                      "+_vm._s(trans.movie_language)+"\n                    ")]),_vm._v(" "),_c('li',{staticClass:"list-inline-item"},[_vm._v(_vm._s(trans.movie_format))])]),_vm._v(" "),_c('p',{staticClass:"dark-txt"},[_vm._v(_vm._s(trans.cine_name))])]),_vm._v(" "),_c('div',{staticClass:"row pt-2"},[_c('div',{staticClass:"col-8"},[_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"light-txt"},[_vm._v("Date :")]),_vm._v(" "),_c('p',{staticClass:"dark-txt"},[_vm._v("\n                        "+_vm._s(_vm._f("moment")(trans.ss_start_date))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"light-txt"},[_vm._v("\n                        Seats : - ("+_vm._s(trans.seat_names)+")\n                      ")]),_vm._v(" "),_c('ul',{staticClass:"list-inline m-ticket-seats"},_vm._l((trans.seat_names
                            ? trans.seat_names.split(',')
                            : []),function(item,index){return _c('li',{key:index,staticClass:"list-inline-item"},[_vm._v("\n                          "+_vm._s(item)+"\n                        ")])}),0)])]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"light-txt"},[_vm._v("Time :")]),_vm._v(" "),_c('p',{staticClass:"dark-txt"},[_vm._v("\n                        "+_vm._s(_vm.timeFormat(trans.t_show_time))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"light-txt"},[_vm._v("Screen")]),_vm._v(" "),_c('p',{staticClass:"dark-txt"},[_vm._v(_vm._s(trans.screen_name))])])])]),_vm._v(" "),_c('div',{staticClass:"row pb-2"},[_c('div',{staticClass:"col-8"},[_c('p',{staticClass:"light-txt mb-1"},[_vm._v("Ticket Price")]),_vm._v(" "),_vm._l((trans.chargeTypeArray),function(charge,chargeIndex){return _c('p',{key:chargeIndex,staticClass:"light-txt mb-1"},[_vm._v("\n                      "+_vm._s(charge.ct_name)+"\n                    ")])}),_vm._v(" "),_c('p',{staticClass:"light-txt mb-1"},[_vm._v("Service Charge")]),_vm._v(" "),_c('p',{staticClass:"light-txt mb-1"},[_vm._v("Discount")])],2),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('p',{staticClass:"normal-txt"},[_vm._v("\n                      "+_vm._s(_vm.curr_code)+"\n                      "+_vm._s(_vm.currFormat(trans.sb_total_net_amount))+"\n                    ")]),_vm._v(" "),_vm._l((trans.chargeTypeArray),function(charge,chargeIndex){return _c('p',{key:chargeIndex,staticClass:"normal-txt"},[_vm._v("\n                      "+_vm._s(_vm.curr_code)+"\n                      "+_vm._s(_vm.currFormat(charge.tax_amount))+"\n                    ")])}),_vm._v(" "),_c('p',{staticClass:"normal-txt"},[_vm._v("\n                      "+_vm._s(_vm.curr_code)+" "+_vm._s(_vm.currFormat(trans.offer_price))+"\n                    ")])],2)]),_vm._v(" "),_c('div',{staticClass:"row border-top pt-2"},[_vm._m(1,true),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('p',{staticClass:"dark-txt"},[_vm._v("\n                      "+_vm._s(_vm.curr_code)+"\n                      "+_vm._s(_vm.currFormat(
                          trans.sb_total_amount_paid - trans.offer_price
                        ))+"\n                    ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"qr-section qr-section pt-3 pb-5"},[_c('div',{staticClass:"pt-3 pb-4"},[(trans.booking_type_id != 3 && trans.booking_type_id)?_c('div',{staticClass:"pb-1 text-center"},[_c('p',{staticClass:"mb-0 font-weight-bold confText",style:(_vm.show_status(trans).isConfirmed == 'N'
                      ? 'color:red'
                      : 'color:green')},[_vm._v("\n                  "+_vm._s(_vm.show_status(trans).status)+"\n                ")])]):_vm._e(),_vm._v(" "),(trans.booking_type_id != 3 && trans.booking_type_id)?_c('div',[(trans.booking_type_id == 2)?_c('b-progress',{staticClass:"proBar ticket-proBar mb-0",class:_vm.show_status(trans).isConfirmed == 'N'
                      ? 'red'
                      : 'bg-success',attrs:{"max":_vm.show_status(trans).max}},[_c('b-progress-bar',{attrs:{"value":_vm.show_status(trans).value}},[_c('p',{staticClass:"mb-0 succ-text",class:_vm.show_status(trans).isConfirmed == 'N'
                          ? ' status-text-h'
                          : ''},[_vm._v("\n                      "+_vm._s(_vm.show_status(trans).message)+"\n                    ")])])],1):_vm._e(),_vm._v(" "),(trans.booking_type_id == 1)?_c('b-progress',{staticClass:"proBar ticket-proBar mb-0",attrs:{"max":parseInt(100)}},[_c('b-progress-bar',{attrs:{"value":parseInt(100)}},[_c('p',{staticClass:"mb-0 succ-text"},[_vm._v("\n                      "+_vm._s(_vm.show_status(trans).message)+"\n                    ")])])],1):_vm._e()],1):(trans.booking_type_id == 3)?_c('div',[_c('b-progress',{staticClass:"proBar ticket-proBar bg-warning mb-0",attrs:{"max":parseInt(trans.screen_total_seats)}},[_c('b-progress-bar'),_vm._v(" "),_c('p',{staticClass:"mb-0 reqText mx-auto pr-2"},[_vm._v("\n                    Private Screening\n                  ")])],1)],1):_c('div',[_c('b-progress',{staticClass:"proBar ticket-proBar bg-success mb-0",attrs:{"max":parseInt(100)}},[_c('b-progress-bar'),_vm._v(" "),_c('p',{staticClass:"mb-0 reqText mx-auto pr-2"},[_vm._v("\n                    Regular Screening\n                  ")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"align-self-center text-center"},[(trans.ShowStatus == '1')?_c('p',{staticClass:"qr-note"},[_vm._v("\n                Use this QR Code to Enter the Cinema\n              ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"py-3"},[_c('img',{staticClass:"img-fluid qr-code",attrs:{"src":trans.qrcode,"alt":"'name'","height":"150px","width":"150px"}})]),_vm._v(" "),(
                  (trans.ShowStatusMsg == 'Unconfirmed' ||
                    trans.ShowStatusMsg == 'Confirmed') &&
                    false
                )?_c('div',[_c('navigator-share',{staticClass:"btn-share",attrs:{"on-error":_vm.onError,"on-success":_vm.onSuccess,"text":trans.Seats != 'Private Booking - Complete Hall Booked'
                      ? 'Join me on GoGoCinema to watch ' +
                        trans.Title +
                        ' at ' +
                        trans.CinemaName +
                        ' on ' +
                        trans.MovieDate +
                        ' at ' +
                        trans.timing[0] +
                        ' ' +
                        trans.timing[1] +
                        '. Click the below link to join: \n' +
                        trans.shortLinkPwa
                      : 'I have booked a private screening on GoGoCinema! Join me to watch ' +
                        trans.Title +
                        ' at ' +
                        trans.CinemaName +
                        ' on ' +
                        trans.MovieDate +
                        ' at ' +
                        trans.timing[0] +
                        ' ' +
                        trans.timing[1] +
                        '.'}})],1):_vm._e()])])]),_vm._v(" "),_c('br')])])}),0):(_vm.loading == false)?_c('div',{staticClass:"row"},[_vm._m(2)]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"row"},[_vm._m(3)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":__webpack_require__(214),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-8"},[_c('p',{staticClass:"light-txt"},[_vm._v("Total")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 text-center"},[_c('h5',[_vm._v("No Transaction")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 text-center"},[_c('img',{staticClass:"load-more",attrs:{"src":__webpack_require__(61)}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_myWallet_vue__ = __webpack_require__(673);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c4f16dd_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_myWallet_vue__ = __webpack_require__(1369);
function injectStyle (ssrContext) {
  __webpack_require__(1368)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_myWallet_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c4f16dd_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_myWallet_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1368 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tabs',{attrs:{"content-class":"mt-4","nav-wrapper-class":"switching-tabs"}},[_c('b-tab',{attrs:{"title":"My Wallet","active":""}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7 mb-5"},[_c('small',{staticClass:"d-block mb-2"},[_vm._v("Your Current Balance")]),_vm._v(" "),_c('div',{staticClass:"font-weight-bold h3 mb-4"},[_vm._v(_vm._s(_vm.walletAmount))])]),_vm._v(" "),_c('div',{staticClass:"col-md-5 mb-5"},[_c('div',{staticClass:"d-flex border-bottom pb-2 mb-4"},[_c('svg',{attrs:{"width":"24","height":"22","viewBox":"0 0 24 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M23.1429 22H3.42857C1.53771 22 0 20.4303 0 18.5V1.875C0 1.392 0.384 1 0.857143 1C1.33029 1 1.71429 1.392 1.71429 1.875V18.5C1.71429 19.466 2.484 20.25 3.42857 20.25H22.2857V3.625C22.2857 3.142 22.6697 2.75 23.1429 2.75C23.616 2.75 24 3.142 24 3.625V21.125C24 21.608 23.616 22 23.1429 22Z","fill":"#E70D01"}}),_vm._v(" "),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.59091 5H18.1364C18.6131 5 19 4.62667 19 4.16667V0.833333C19 0.373333 18.6131 0 18.1364 0H2.59091C1.16245 0 0 1.12167 0 2.5C0 3.87833 1.16245 5 2.59091 5ZM2 2C2 1.448 2.37333 1 2.83333 1H17V3H2.83333C2.37333 3 2 2.552 2 2Z","fill":"#E70D01"}}),_vm._v(" "),_c('path',{attrs:{"d":"M23.125 5H17.875C17.392 5 17 4.552 17 4C17 3.448 17.392 3 17.875 3H23.125C23.608 3 24 3.448 24 4C24 4.552 23.608 5 23.125 5Z","fill":"#E70D01"}}),_vm._v(" "),_c('path',{attrs:{"d":"M23.1 15H17.7C16.2114 15 15 13.8783 15 12.5C15 11.1217 16.2114 10 17.7 10H23.1C23.5968 10 24 10.3733 24 10.8333C24 11.2933 23.5968 11.6667 23.1 11.6667H17.7C17.205 11.6667 16.8 12.0417 16.8 12.5C16.8 12.9583 17.205 13.3333 17.7 13.3333H23.1C23.5968 13.3333 24 13.7067 24 14.1667C24 14.6267 23.5968 15 23.1 15Z","fill":"#E70D01"}})]),_vm._v(" "),_c('div',{staticClass:"pl-2"},[_vm._v("Why use the Gogo Walllet you ask?")])]),_vm._v(" "),_c('ul',{staticClass:"pl-4"},[_c('li',{staticClass:"mb-1"},[_vm._v("Quick and Easy Chechkout.")]),_vm._v(" "),_c('li',{staticClass:"mb-1"},[_vm._v("Recive instant refunds directly to your account.")]),_vm._v(" "),_c('li',{staticClass:"mb-1"},[_vm._v("Get exclusive Offers and Discounts.")])])])])]),_vm._v(" "),_c('b-tab',{attrs:{"title":"Transfers"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7 mb-5"},[_c('form',{attrs:{"data-vv-scope":"transfer"},on:{"submit":function($event){$event.preventDefault();return _vm.validateBeforeSubmit('transfer')}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.email),expression:"user.email"}],attrs:{"type":"text","placeholder":"Enter your friend's email id"},domProps:{"value":(_vm.user.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "email", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"d-block mt-1 font-italic mt-2"},[_vm._v("(Please note your friend must be a registered user with Gogo\n            Cinema.)")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.amount),expression:"user.amount"}],attrs:{"type":"number","placeholder":"Enter amount to be transferred","name":"","id":""},domProps:{"value":(_vm.user.amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "amount", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"d-block mt-2 text-danger font-italic"},[_vm._v(_vm._s(_vm.errorMessage))]),_vm._v(" "),_c('small',{staticClass:"d-block mt-2 text-success font-italic"},[_vm._v(_vm._s(_vm.successMessage))]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"personalMessage"}},[_c('textarea',{attrs:{"placeholder":"Your personal message starts here","cols":"5","rows":"5"}})]),_vm._v(" "),_c('button',{staticClass:"btn-gogo mw-250 mt-4",nativeOn:{"click":function($event){return _vm.transferFund()}}},[_vm._v("Send Money")])],1)]),_vm._v(" "),_c('div',{staticClass:"verify-otp"},[_c('b-modal',{ref:"OTPModal",attrs:{"id":"otp","title":"Verify Your Contact Detail"}},[_c('form',{attrs:{"data-vv-scope":"verifyOTP"},on:{"submit":function($event){$event.preventDefault();return _vm.validateBeforeSubmit('verifyOTP')}}},[_c('div',{staticClass:"p-5"},[_c('p',{staticClass:"otp-text text-center mb-0"},[_vm._v("Almost there! Please enter the 4 digit verification code you\n                      might have just received via email / SMS.")]),_vm._v("\n                    "+_vm._s(_vm.errorMessage.otp)+"\n                    "),_c('div',{staticClass:"my-4 otp-section"},[_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"d-flex otp-mob mx-auto"},[_c('div',{staticClass:"col px-2 px-md-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.OTP[0]),expression:"user.OTP[0]"}],ref:"otp1",staticClass:"form-control text-center py-4",attrs:{"type":"number","id":"otp1","btnNumber":"1","placeholder":"","maxlength":"1","pattern":"([12345])\\w{0}"},domProps:{"value":(_vm.user.OTP[0])},on:{"keyup":function($event){return _vm.OTPonKeyUp(0, $event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user.OTP, 0, $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col px-2 px-md-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.OTP[1]),expression:"user.OTP[1]"}],ref:"otp2",staticClass:"form-control text-center py-4",attrs:{"type":"number","id":"otp2","placeholder":"","maxlength":"1","pattern":"([12345])\\w{0}"},domProps:{"value":(_vm.user.OTP[1])},on:{"keyup":function($event){return _vm.OTPonKeyUp(1, $event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user.OTP, 1, $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col px-2 px-md-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.OTP[2]),expression:"user.OTP[2]"}],ref:"otp3",staticClass:"form-control text-center py-4",attrs:{"type":"number","id":"otp2","placeholder":"","maxlength":"1","pattern":"([12345])\\w{0}"},domProps:{"value":(_vm.user.OTP[2])},on:{"keyup":function($event){return _vm.OTPonKeyUp(2, $event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user.OTP, 2, $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col px-2 px-md-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.OTP[3]),expression:"user.OTP[3]"}],ref:"otp4",staticClass:"form-control text-center py-4",attrs:{"type":"number","id":"otp2","placeholder":"","maxlength":"1","pattern":"([12345])\\w{0}"},domProps:{"value":(_vm.user.OTP[3])},on:{"keyup":function($event){return _vm.OTPonKeyUp(3, $event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user.OTP, 3, $event.target.value)}}})])])])]),_vm._v(" "),_c('p',{staticClass:"grey-text text-center mb-4"},[_vm._v("\n                      Haven't received it yet?\n                      "),_c('router-link',{attrs:{"to":"#"},nativeOn:{"click":function($event){return _vm.verifyOTP()}}},[_vm._v("Resend code")])],1),_vm._v(" "),_c('div',[_c('input',{staticClass:"gogo-btn btn btn-danger",attrs:{"type":"submit","value":"Confirm your details"}})])])])])],1)])]),_vm._v(" "),_c('b-tab',{attrs:{"title":"Wallet Log"}},_vm._l((_vm.walletsDetails),function(wallet,key){return _c('div',{key:key,staticClass:"walletLog-container"},[_c('div',{staticClass:"d-flex flex-wrap"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-12 col-lg-12 col-xl-10 py-3 pr-xl-0 jm-mobile"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3 col-sm-2 col-md-2 col-lg-3 col-xl-3 d-flex text-center text-md-left flex-column justify-content-center flex-lg-row justify-content-lg-start"},[_c('div',[(wallet.Status === 'Successfully')?_c('img',{attrs:{"width":"40px","src":__webpack_require__(1370),"alt":""}}):(wallet.Status !== 'Successfully')?_c('img',{attrs:{"rc":"@/assets/img/svg/gc-add.svg","alt":""}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"ml-2 d-none d-lg-block"},[_c('div',{staticClass:"tiny text-muted"},[_vm._v("GoGo Cash")]),_vm._v(" "),_c('div',{staticClass:"small text-muted"},[_vm._v(_vm._s(wallet.Type))])]),_vm._v(" "),_c('div',{staticClass:"small text-muted mt-2 d-lg-none"},[_vm._v("Used")])]),_vm._v(" "),_c('div',{staticClass:"col-9 col-sm-10 col-md-10 col-lg-9 col-xl-9"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 col-sm-6 col-md-6 col-lg-3 col-xl-4 pl-0 mb-2 mb-xl-0"},[(wallet.Type == 'USED')?_c('div',{staticClass:"tiny text-muted"},[_vm._v("For")]):_vm._e(),_vm._v(" "),(wallet.Type == 'TRANSFERRED')?_c('div',{staticClass:"tiny text-muted"},[_vm._v("To")]):_vm._e(),_vm._v(" "),_c('div',[_vm._v(_vm._s(wallet.Title))])]),_vm._v(" "),_c('div',{staticClass:"col-6 col-sm-6 col-md-6 col-lg-3 col-xl pl-0 mb-2 mb-xl-0"},[_c('div',{staticClass:"tiny text-muted pl-0"},[_vm._v("Amount")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.Currency)+" "+_vm._s(wallet.Amount))])]),_vm._v(" "),_c('div',{staticClass:"col-6 col-sm-6 col-md-6 col-lg-3 col-xl pl-0"},[_c('div',{staticClass:"tiny text-muted"},[_vm._v("Status")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(wallet.Status))])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-12 col-lg-12 col-xl-2 d-flex justify-content-between align-items-center flex-xl-column flex-xl-column-reverse align-items-xl-end py-2 py-lg-3"},[_c('div',{staticClass:"small text-muted"},[_c('span',[_vm._v(_vm._s(wallet.Date))])]),_vm._v(" "),_c('div',{staticClass:"small text-muted"},[_vm._v("Transaction Id : "+_vm._s(wallet.ID))])])])])}),0)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1370 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJAAAACDCAYAAABiBJKNAAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAxUSURBVHgB7Z1ddtPIEsdLCvDsHaCsIOHxnmHAWcEos4FxVoBZAckKQlaQZAURK4jhMpe3S1gBYgeZpzknjq2pcpcYx7G729aHq1v9O8cnzKhtgvVXdXV1VXUEFbhO094OQBoD7EUASQGwj68e/rkHgUVupgAnr7IsA4+IYAP+m6Z9fOM7/GMfAmuBD9jBr1k2Ak94ss7gP9N0UCjhJBDYCH7wRuAJVgLCqWr/KcBpESxOHfRtB9IDiz9eF/Ie2JsxwNlBluXGKex/afoG5+73EKiL/GWW7ZoGfU7Tc/wxALncongOYt0I/EecBvHUC1qTS9MYtjwDkE0P/y2nK6cwB54A58Av/Awd6GPTOHxok41WN+3TXyogsjywhnjwi7lFU5bhz29TZdpyCDzgHv0G9Blubcbi92c1TgA3j4SO5vMdCuEY7Bjh2BOflqVSwIf4K/7YB8FQSOKBgHC1leBq67vFe3N881EQTrNw2OQPkLUKoxnm5k6twh5aIFQ9iSfRvRunqMsJwNDWHAf85qcPxGpPdIMLFYo/hkCA+bmM5wjzSvB69msQT2CBmYA47pBoxuW4ijiCQGCBmYDYUVsJOkonwecJLCOyWHmNMPR+AIHAEuIdQ6wBV11nEAisII70u8O3viVABeqFBLSnuf4RAgEN5EQnqy6ic30DgYAGrYDisCkaMKDNB5oGAXnFF1xx0wtqZK2c6ICbcEry+YRX3LjnmY9xJ51SUqEiMQS8huN8V/AwXEP/7yuVZUFFgoA8B6eYISz3c3t8rerndwuuaaOn8Xmk8nppi+YHrTh9zG/iQs+loPV4DhXphIDIVD8DoOqS4XzVbDE3hr5kFBclS2VjtfeXQ8CI91MYlSXhU/Kd0nRNJdd8fUB7g5TaCwEjXlsgqixBqzPYpMKBBIfvH9isVtjCJRPla8xEGqkUmBvfsxhEC2iheUOvzJikmzNlv2WiblK++N51K0tWQKuVa/w9HomonBa5WrdP0+GiOX+qfg/KGz67Axj5OC2KFBDdHCqlhjkBzPsr9OeIX3TT6Cbhj0u0FhndJK6mrbzCYMpl8Av6j/nGEoXd+6ljyTl+Ro7T4skvWXYBHiFOQBy3uIb1KhFoVTWr30cxjShgVnNh3j5bNGJTYVL7m3P8nN7LLPOm2lecE72BeBbpW/YnoqnlAuw7ZQyhHqt2SlYMPEGUBbKpDKkKlRejc3s879yS1XuinO1WVl4+tXgRZYFMudk1cIHBwkc1beQ3UcXJtL3CgT4+LKKrTm2RNoU12hqPAoS666/QwS2qp/DmhUVtuy+9llyLA9EN/ouzKBNYb7qzWkbT9IZ+2BuwhMVCohvNb4XwYoDq23sr3udFH0lpU5gphbZPN5iqRKhJEwrpRaGsSg7VP3sGT2/GTEwSDv3d+Pvs0vS3uI/GYvW+FEqaBaIEft3TT081OaBv6T8wpkI3ml7Hpv6N92rFZQX6Qt9ifbUKRZm1EWrTgsCXdGFRFoie4kiJSMfwy+HhI2ebAnRklYoFP6dQ3SSO1okC7+hXSNQf8IXu82j6MpWKT4KAmuFOrYRy3ZhJUby/XpGaSdMJ3uBdtCKHtKqiKWbd6C+PX3aDy0w+7dTEketEM8SbbQ1xTjTdHAy0HUUqoLiK3vz2wpLPyKFiPjcJ5YnawX8Nah/uEsX43iQejlhrl+iRRZ9EVxC5CqOpDG8E+TmnmmGz7QWctt5CA7BQ1oo8c3c303tyn/bDxOYD8X7RyDBsKGVbgDZwTa0ByR8jywYeITqhbKz8Ie2UgdPBeR3J4VWgqgebdsiRh5mOogVEXzY+tYeGYWW6xVbgfbRr0zhaHfq0C18iPqWV/CGL7YU++kN15f9YU6aemHb/qa+kr93dnMiJvle+hSluctrmBiUnvdmknlDWZOvibgsnBEQrorGayrT+EFqqq7b8IUvxUNzo0Oe8aGeqMtj5PDEMK7c6GsUm1gP/Bh1z8BinynrICZ2ag3BLtzrqgst9tFMSL9cPu1Bb5lxdGPsTuXaMZqujCrbHQOCX+vZAbfR6j3N1YetsdXxK09r6O1JpkUWUuVyuX0BHcLKw0HarA2/6ObQIHzxzDB3C2dJmy62O1rA9C8w3nK6Nj4QIiI+B8DbWo8NZAeHmZWrj0LbAbZePgXBSQLTCmrTs32ggh30AHcU5AdnuP7XMuybCBi7g3CrMIl20zIOue/sg0VwjK0QW0atcHxucEhAH8oxbCPcNbCHwbr8ubDDLCPAxZUOHM1MYZR5aOM2N7T9Zhg06N5U5ISC6KZGF09z0/pNFhmQ5lXUGJwT0VFMwOEfj+0+WGQF9PgGyE4gXEN+MgW4MRYHb8j1spjL8fU63nafdFuIFVJjze/K2o8CWU1njeUkSEC0gzr1JdGO2USZjOZWJKTlqErEC4vrygW5MscUyGZupLNIv+71ArIAsHOd827vfFlPZ/jaqRdpEpIA4ljLQjZFQ4cl1a6aktXc+O9QiBYTWJzUMuZCSb8xWMNcMqeVUHKlIncK0LebGZge2VQpDOgf6Qm98tULiBPQpTcn6JJohYqxPCbe3G2mGeGuFxAkoMrT6lWZ9SsYWVgg8RJSAyMxHev/ng9RaK/q9DDVrPR/jQqIEtGPonWzRP3GrROZGnqbFgXOIElCkF9Ct9M5eJl8Iv+zfwDOkCWhPc/kjuMGHVReo7a9vqzFpTnRfc20EDjA2TLOmado1xAjo2tDbx5XG3KYO9ZE5JdcpxAjoiaHK4t6hxtyF3g96Dh4hRkCmw0cca9L0Y9WFps9DaxtJPtBKAUUVm4ZvAd0UloBHOJETXcgqIjRSuCf4jZEkIG2KKDhE7MlZYDaIEdDE8NT+//ffnXE+dRazAL/OEJNkgXLdxb+nU5fKhnUB0SCgJuBV1sovd+pQ/EQX60EL9A08QpQTPdVsA1CahwvbALzjnqy6Hnty0FyJKAEZvlwnaq1M+Ux3npwXXyJKQGOVDqHzEUTXWllU0XpzUmGJKAGRH1QYGonjE37V5pkYtvCRT9o6MJ9OKiwRF0i8V+duaWNCKLKvXLUqArKKT8xd07w6qbBEnIAsa61oNXP8OU2/b3NKI6eezs2ILFruRUJzuasi9cxUEgdl75mmKuobdI1jb/Dn2V1LPgaJFv++37j02mZlOPLR+hBiW9xRsyjLI5WIfbyZ5zieWtHRSm6E/sjHHZw2UFR5lZ18sjLP8HfAzyfR7OHnpqW1iew+Ih973AZYrIDIkuDNO1hDRCVkteiYgyHedKpyJYtxyzv6ZfPNlYKaS7cg0VCVCPlc5TVb0ZTjqYe016f2iG6yWUFED2CLMZsOi/XeV4WcxeNV4HAR8ekcJCKcAl7YONaCuOFmn16Lh3CizS/7MMNPaTqKVawlAYHwTnunDl1xqlP9qyzLXmbZbqSc0hEIgYRDza5wytrt2ok9Tp4XxkviCz6zfRipgr0E2meErw/3quGDV2katjgpoBJe3QzpRWLC5XZ/gq9Y5ePUut3BxydQkPNjoY7yzroqmnmcFtA8LKYLmKtP/1PtT9EyPCmT2U1lNTj+L+Dl/pRFg19S/p8OHKC7Cd4IaBm/dOTg223i9ImFge0TBBSoRBBQoBJBQIFKaAXkWkVooH1IQCtjGTtBQM7TdDcQrYCmnjUC6CgrjcBU00XElljXuMm3Zkhdg+vodEWOleNkZIF0KnzdlYPTfOSZoSvsTg1dROLC0GHdt55+XWKq7wp7W0ekPp4Y0iJiTzus+w4fVKyzQLV0vY15R3mkGdPn8ysCDmEqA6+rafssDlQYapbiDh0i6wMWJda1FTnOBMQd1nPNuAQVfQUB8dDUZSqxLmossf4Zica/9K1hbP9zmp5DQCwknqcWJdb35jM9rHlQuYICofKZvuE9VHHgda2Ti3CJ95VFifVRnVWyD/bCLA6RJfZJ5TzPBrbMOvX50ECJ9aPaOT5l2Pa46pyaBtyF/ODW+aJ8nT+mqqjAZoGTc61aDjWytPgSzeFxtH43sBGo0PiPqWeNJKUQq1LrvUK5GYnt+7jEupFCx5XVuxuKKCCMJsVDaMu/g4jcpmnxEMb+AeQsF8onCoFEt2hltWzVgILiC7ipehwbOpAGtk/b9flrdTBha0RTWgIBiVzQsehtxug2aoFDQStq70Y16VGY2rYNlVtfUnPSbYRSKvZQ+tkvcB9frzkJP4FAY+D3fEOpqJRNiAHd0bZLrv8B6FXAF8Nr1TUAAAAASUVORK5CYII="

/***/ }),
/* 1371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_offers_promotion_vue__ = __webpack_require__(674);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0795e209_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_offers_promotion_vue__ = __webpack_require__(1373);
function injectStyle (ssrContext) {
  __webpack_require__(1372)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_offers_promotion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0795e209_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_offers_promotion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1372 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container pt-5",staticStyle:{"min-height":"calc(100vh - 470px)"}},[_c('div',{staticClass:"text-center title-pp font-weight-bold"},[_vm._v("Offers and Promotions")]),_vm._v(" "),_c('div',{staticClass:"row pt-5"},_vm._l((_vm.offersPromo),function(offers,key){return (_vm.offersPromo.length > 0)?_c('div',{key:key,staticClass:"col-12 col-sm-6 col-md-3 col-lg-4 col-xl-4"},[_c('div',{staticClass:"offers-card"},[_c('img',{staticClass:"img-fluid",attrs:{"src":offers.Image,"alt":"Offer-Poster"}}),_vm._v(" "),_c('div',{staticClass:"p-3"},[_c('h6',[_vm._v(_vm._s(offers.Title))]),_vm._v(" "),_c('p',{staticClass:"text-muted small"},[_vm._v(_vm._s(offers.Description)+".")]),_vm._v(" "),_c('div',{staticClass:"align-items-end d-flex justify-content-between"},[_c('p',{staticClass:"mb-0 mb-md-2 text-primary small"},[_vm._v(_vm._s(offers.Expiry))]),_vm._v(" "),_c('span',{directives:[{name:"b-modal",rawName:"v-b-modal.offer-modal",modifiers:{"offer-modal":true}}],staticClass:"d-md-none pl-3",on:{"click":function($event){return _vm.onClickModal(offers)}}},[_c('svg',{attrs:{"width":"45","height":"45","viewBox":"0 0 66 66","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M33 66C51.2254 66 66 51.2254 66 33C66 14.7746 51.2254 0 33 0C14.7746 0 0 14.7746 0 33C0 51.2254 14.7746 66 33 66ZM51.066 34.1687C52.3192 32.9353 52.3094 30.9336 51.0482 29.7018L36.1138 15.1152C32.6259 11.7335 27.3938 16.8065 30.8816 20.1882L37.3973 26.5057C38.4839 27.5593 38.1187 28.4134 36.5993 28.4134H18.6996C16.6556 28.4134 15 30.0186 15 32.0005C15 33.9814 16.6556 35.5875 18.6996 35.5875H36.5993C38.1266 35.5875 38.4889 36.4367 37.3973 37.495L30.8816 43.8118C27.3938 47.1935 32.6259 52.2666 36.1138 48.8848L51.066 34.1687Z","fill":"url(#paint0_linear)"}}),_vm._v(" "),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear","x1":"-9.55483","y1":"23.646","x2":"37.7372","y2":"108.756","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#E70D00"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"1","stop-color":"#FA5402"}})],1)],1)])])]),_vm._v(" "),_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.offer-modal",modifiers:{"offer-modal":true}}],staticClass:"d-none d-md-block btn-gogo",on:{"click":function($event){return _vm.onClickModal(offers)}}},[_vm._v("View Details")])])])]):_vm._e()}),0),_vm._v(" "),(_vm.offersPromo.length == 0 && !_vm.loading)?_c('div',[_c('h5',{staticClass:"font-weight-bold text-center mb-5"},[_vm._v("\n      Coming Soon! Please check back for special offers and promotions. \n      ")])]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"row d-md-none"},[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('b-modal',{attrs:{"body-class":"p-0","id":"offer-modal","size":"lg","hide-footer":""}},[_c('img',{staticClass:"img-fluid w-100",attrs:{"src":_vm.offers.Image,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"p-md-4 mb-0 p-3"},[_c('div',{staticClass:"justify-content-between d-md-flex"},[_c('div',[_c('h5',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.offers.Title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.offers.Description))])]),_vm._v(" "),_c('div',{staticClass:"pl-md-3"},[_c('div',{staticClass:"text-primary small"},[_vm._v("Offer valid till:")]),_vm._v(" "),_c('div',{staticClass:"text-nowrap small font-weight-bold"},[_vm._v(_vm._s(_vm.offers.Expiry))])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h6',{staticClass:"font-weight-bold"},[_vm._v("Terms & Condition")]),_vm._v(" "),_c('ul',{staticClass:"pl-3 mb-4"},[_c('li',{domProps:{"innerHTML":_vm._s(_vm.offers.termsAndCondition)}})])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 text-center"},[_c('img',{staticClass:"load-more",attrs:{"src":__webpack_require__(61)}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_error404_vue__ = __webpack_require__(675);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01dc9347_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_error404_vue__ = __webpack_require__(1376);
function injectStyle (ssrContext) {
  __webpack_require__(1375)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_error404_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01dc9347_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_error404_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1375 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',[_c('div',{staticClass:"container text-center"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__(1377),"alt":"Error-404"}}),_vm._v(" "),_c('h4',{staticClass:"font-weight-bold"},[_vm._v("Uh-oh!")]),_vm._v(" "),_c('p',{staticClass:"font-weight-bold"},[_vm._v("We couldn't find what you were looking for.")]),_vm._v(" "),_c('router-link',{staticClass:"btn-gogo mx-auto",attrs:{"to":"/"}},[_vm._v("Go to Home")]),_vm._v(" "),_c('img',{staticClass:"img-fluid my-4",attrs:{"src":__webpack_require__(311)}}),_vm._v(" "),_c('h6',[_vm._v("Browse through our catalogue")])],1)]),_vm._v(" "),_c('section',[_c('div',{staticClass:"container-fluid my-5"},[_c('NowShowing')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/404.64add7b.gif";

/***/ }),
/* 1378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_comingSoon_vue__ = __webpack_require__(676);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bb6e90f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_comingSoon_vue__ = __webpack_require__(1380);
function injectStyle (ssrContext) {
  __webpack_require__(1379)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_comingSoon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bb6e90f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_comingSoon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1379 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',[_c('div',{staticClass:"container text-center"},[_c('h4',{staticClass:"font-weight-bold",staticStyle:{"padding-top":"100px"}},[_vm._v("Coming Soon")]),_vm._v(" "),_c('p',{staticClass:"font-weight-bold"},[_vm._v("We are still working on this, come back soon.")]),_vm._v(" "),_c('router-link',{staticClass:"btn-gogo mx-auto",attrs:{"to":"/"}},[_vm._v("Go to Home")]),_vm._v(" "),_c('img',{staticClass:"img-fluid my-4",attrs:{"src":__webpack_require__(311)}}),_vm._v(" "),_c('h6',[_vm._v("Browse through our film library")])],1)]),_vm._v(" "),_c('section',[_c('div',{staticClass:"container-fluid my-5"},[_c('NowShowing')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contactUs_vue__ = __webpack_require__(677);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0487c18a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contactUs_vue__ = __webpack_require__(1382);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contactUs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0487c18a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contactUs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-us my-5"},[_c('section',{staticClass:"container"},[_c('div',{staticClass:"contact-us__headline"},[_c('h1',[_vm._v("\n        Please feel free to contact us for any further information.\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"contact-us__info"},[_c('h2',[_vm._v("\n      Email Us at:\n    ")]),_vm._v(" "),_c('h3',[_c('a',{attrs:{"href":"mailto:support@gogocinema.com"}},[_vm._v("support@gogocinema.com")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewsRoom_vue__ = __webpack_require__(678);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b4f87a0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewsRoom_vue__ = __webpack_require__(1385);
function injectStyle (ssrContext) {
  __webpack_require__(1384)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewsRoom_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b4f87a0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewsRoom_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1384 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container my-5 newsroom"},[_c('div',{staticClass:"text-center title-au font-weight-bold mb-4"},[_vm._v("Newsroom")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('h1',{staticClass:"news-article"},[_c('a',{attrs:{"href":"https://www.hollywoodreporter.com/movies/movie-news/demand-cinema-platform-launched-by-tech-firm-gdc-1198923/","target":"_blank"}},[_vm._v("\n  CinemaCon: On-Demand Cinema Platform Launched by Tech Firm GDC\n  ")]),_vm._v(" "),_c('p',[_c('span',{staticClass:"news-article-text"},[_vm._v("\n          Digital cinema tech supplier GDC Technology is launching its GoGoCinema on-demand cinema platform and web-based booking app in the second half of the year, the company announced Tuesday at theater owners confab CinemaCon in Las Vegas.")]),_vm._v(" "),_c('span',{staticClass:"readmore"},[_c('a',{attrs:{"href":"https://www.hollywoodreporter.com/movies/movie-news/demand-cinema-platform-launched-by-tech-firm-gdc-1198923/","target":"_blank"}},[_vm._v("\n              ...read more\n          ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('h1',{staticClass:"news-article"},[_c('a',{attrs:{"href":"\n  https://celluloidjunkie.com/wire/gdc-technology-announces-ubernization-of-cinema-with-gogocinema/\n  ","target":"_blank"}},[_vm._v("\n  GDC Technology Announces Ubernization of Cinema with GOGOCINEMA\n  ")]),_vm._v(" "),_c('p',[_c('span',{staticClass:"news-article-text"},[_vm._v("\n          GOGOCINEMA makes it possible for audience to enjoy all genres of movies, current or past-releases from independent films to major blockbusters on the big screen, when and where they want.")]),_c('span',{staticClass:"readmore"},[_c('a',{attrs:{"href":"https://celluloidjunkie.com/wire/gdc-technology-announces-ubernization-of-cinema-with-gogocinema/","target":"_blank"}},[_vm._v("\n              ...read more\n          ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('h1',{staticClass:"news-article"},[_c('a',{attrs:{"href":"https://www.dcinematoday.com/dc/pr?newsID=5430","target":"_blank"}},[_vm._v("\n  GDC Technology Announces Ubernization of Cinema with GOGOCINEMA\n  ")]),_vm._v(" "),_c('p',[_c('span',{staticClass:"news-article-text"},[_vm._v("\n          GDC Technology Limited, a leading global provider of digital cinema solutions announced today at CinemaCon it is launching the GOGOCINEMATM On-Demand-Platform and its App in the second half of this 2019.")]),_vm._v(" "),_c('span',{staticClass:"readmore"},[_c('a',{attrs:{"href":"https://www.dcinematoday.com/dc/pr?newsID=5430","target":"_blank"}},[_vm._v("\n              ...read more\n          ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('h1',{staticClass:"news-article"},[_c('a',{attrs:{"href":"\n  https://www.boxofficepro.com/gdc-technology-golden-screen-cinemas-partner-to-launch-gogocinema/\n  ","target":"_blank"}},[_vm._v("\n  GDC Technology, Golden Screen Cinemas Partner to Launch GoGoCinema\n  ")]),_vm._v(" "),_c('p',[_c('span',{staticClass:"news-article-text"},[_vm._v("\n           GDC Technology Limited (‘GDC’), a leading global provider of digital cinema solutions, announced today at CineEurope 2019 that it signed a Memorandum of Understanding (MoU) with Golden Screen Cinemas Sdn. Bhd. (‘GSC’) to launch GOGOCINEMA™, its Cinema-On-Demand platform.  GoGoCinema is an intuitive and easy-to-use digital platform which is backed by GDC’s innovative Cinema Automation 2.0 (CA2.0) solution.\n       ")]),_vm._v(" "),_c('span',{staticClass:"readmore"},[_c('a',{attrs:{"href":"https://www.boxofficepro.com/gdc-technology-golden-screen-cinemas-partner-to-launch-gogocinema/","target":"_blank"}},[_vm._v("\n               ...read more\n           ")])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./MainStore.js": 1429,
	"./MovieDetails.js": 1441,
	"./checkoutStore.js": 1463,
	"./index.js": 824
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1428;

/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _map = __webpack_require__(1430);

var _map2 = _interopRequireDefault(_map);

var _toConsumableArray2 = __webpack_require__(125);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = __webpack_require__(126);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(127);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defineProperty2 = __webpack_require__(31);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(203);

var _extends3 = _interopRequireDefault(_extends2);

var _mutations; // import MovieService from "@/services/MovieService";
// import { LanguageService } from "@/services/tokenService";


var _mainService = __webpack_require__(28);

var _mainService2 = _interopRequireDefault(_mainService);

var _GlobalServices = __webpack_require__(1440);

var _GlobalServices2 = _interopRequireDefault(_GlobalServices);

var _vue = __webpack_require__(59);

var _vue2 = _interopRequireDefault(_vue);

var _lodash = __webpack_require__(77);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _store = __webpack_require__(239);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
  currentRoute: null,
  nowShowingMovies: [],
  nowShowingCinemas: [],
  nowShowingSchedules: [],
  nowShowingDates: [],
  nowShowingMoviesType: [],
  fileredMovies: null,
  movieGenre: [],
  moviedetails: [],
  Banners: [],
  languages: [],
  allLanguages: [],
  formats: [],
  allFormats: [],
  genres: [],
  allGenres: [],
  selectedDate: null,
  selectedLanguage: null,
  selectedGenre: null,
  selectedFormat: null,
  selectedCinema: null,
  quickBookMovies: [],
  filteredQuickBookMovies: [],
  quickBookCinemas: [],
  quickBookDates: [],
  quickBookTimes: [],
  filteredQuickBookCinemas: [],
  selectedQBMovie: null,
  selectedQBCinema: null,
  selectedQBDate: null,
  selectedQBTime: null,
  user_reviews: [],
  stripePublisherKey: null,
  areLanguagesFiltered: false,
  areGenresFiltered: false,
  areFormatsFiltered: false,
  CinemasList: [],
  global_options: [],
  curr_code: "",
  countries: []
};

var mutations = (_mutations = {
  SET_LANGUAGES: function SET_LANGUAGES(state, payload) {
    return state.languages = payload;
  },
  SET_ALL_LANGUAGES: function SET_ALL_LANGUAGES(state, payload) {
    return state.allLanguages = payload;
  },
  SET_FORMATS: function SET_FORMATS(state, payload) {
    return state.formats = payload;
  },
  SET_ALL_FORMATS: function SET_ALL_FORMATS(state, payload) {
    return state.allFormats = payload;
  },
  SET_GENRES: function SET_GENRES(state, payload) {
    return state.genres = payload;
  },
  SET_ALL_GENRES: function SET_ALL_GENRES(state, payload) {
    return state.allGenres = payload;
  },
  RESET_FILTERS: function RESET_FILTERS(state) {
    return state.fileredMovies = state.nowShowingMoviesType;
  },
  SET_FILTERED_MOVIES: function SET_FILTERED_MOVIES(state, payload) {
    return state.fileredMovies = payload;
  },
  SET_SELECTED_CINEMA: function SET_SELECTED_CINEMA(state, payload) {
    return state.selectedCinema = payload;
  },
  SET_ARE_GENRES_FILTERED: function SET_ARE_GENRES_FILTERED(state, payload) {
    return state.areGenresFiltered = payload;
  },
  SET_ARE_LANGUAGES_FILTERED: function SET_ARE_LANGUAGES_FILTERED(state, payload) {
    return state.areLanguagesFiltered = payload;
  },
  SET_ARE_FORMATS_FILTERED: function SET_ARE_FORMATS_FILTERED(state, payload) {
    return state.areFormatsFiltered = payload;
  },
  RESET_FILTERED_FLAGS: function RESET_FILTERED_FLAGS(state) {
    state.areGenresFiltered = false;
    state.areLanguagesFiltered = false;
    state.areFormatsFiltered = false;
  }
}, (0, _defineProperty3.default)(_mutations, "RESET_FILTERS", function RESET_FILTERS(state) {
  state.selectedFormat = null;
  state.selectedGenre = null;
  state.selectedLanguage = null;
  state.selectedCinema = null;
}), (0, _defineProperty3.default)(_mutations, "SET_CURRENT_ROUTE", function SET_CURRENT_ROUTE(state, payload) {
  state.currentRoute = payload;
}), (0, _defineProperty3.default)(_mutations, "SET_NOWSHOWING_MOVIES", function SET_NOWSHOWING_MOVIES(state, payload) {
  state.nowShowingMovies = payload.MovieListResult;
}), (0, _defineProperty3.default)(_mutations, "SET_NOWSHOWING_MOVIE_TYPE", function SET_NOWSHOWING_MOVIE_TYPE(state, payload) {
  state.nowShowingMoviesType = payload;
}), (0, _defineProperty3.default)(_mutations, "SET_NOWSHOWING_CINEMAS", function SET_NOWSHOWING_CINEMAS(state, payload) {
  state.nowShowingCinemas = payload;
}), (0, _defineProperty3.default)(_mutations, "SET_NOWSHOWING_SCHEDULES", function SET_NOWSHOWING_SCHEDULES(state, payload) {
  state.nowShowingSchedules.push(payload);
}), (0, _defineProperty3.default)(_mutations, "SET_NOWSHOWING_DATES", function SET_NOWSHOWING_DATES(state, payload) {
  state.nowShowingDates = payload;
}), (0, _defineProperty3.default)(_mutations, "SET_NOWSHOWING_GENRE", function SET_NOWSHOWING_GENRE(state, payload) {
  state.moviedetails.push((0, _extends3.default)({}, payload.movieType, {
    g_name: payload.genre.map(function (_ref) {
      var g_name = _ref.g_name;
      return g_name;
    }).join(", ")
  }));

  console.log(" state.moviedetails :", state.moviedetails);
  // let genredetails = payload.genre;

  // moviedetails = moviedetails.map((x, xindex) => {
  //     genredetails.map((y, yindex) => {
  //         if (xindex == yindex) {
  //             y.map(z => {
  //                 x['push'] = z.g_name;
  //             })
  //         }
  //     })
  //     return x;
  // });
  // console.log('moviedetails :', moviedetails);
  console.log("payload.movieType :", payload.movieType);
  console.log("payload.genre :", payload.genre);

  //moviedetails.push(payload.movieType.push(payload.genre.map(x => { ['genre'].push(x.g_name) })))
  // console.log('moviedetails :', payload.genre.map(x => { return x.g_name }));
  // console.log('payload.genre :', payload.genre);

  // state.genre.push(payload.genre.map(x => { return x.g_name }))
  // console.log('state.genre :', state.genre);
}), (0, _defineProperty3.default)(_mutations, "RESET_GENRE", function RESET_GENRE(state) {
  state.moviedetails = [];
}), (0, _defineProperty3.default)(_mutations, "SET_BANNERS_DATA", function SET_BANNERS_DATA(state, payload) {
  state.Banners = payload;
}), (0, _defineProperty3.default)(_mutations, "SET_SELECTED_DATE", function SET_SELECTED_DATE(state, payload) {
  return state.selectedDate = payload;
}), (0, _defineProperty3.default)(_mutations, "SET_SELECTED_LANGUAGE", function SET_SELECTED_LANGUAGE(state, payload) {
  return state.selectedLanguage = payload;
}), (0, _defineProperty3.default)(_mutations, "SET_SELECTED_GENRE", function SET_SELECTED_GENRE(state, payload) {
  return state.selectedGenre = payload;
}), (0, _defineProperty3.default)(_mutations, "SET_SELECTED_FORMAT", function SET_SELECTED_FORMAT(state, payload) {
  return state.selectedFormat = payload;
}), (0, _defineProperty3.default)(_mutations, "SET_QUICK_BOOK_MOVIES", function SET_QUICK_BOOK_MOVIES(state, payload) {
  return state.quickBookMovies = payload;
}), (0, _defineProperty3.default)(_mutations, "SET_FILTERED_QUICK_BOOK_MOVIES", function SET_FILTERED_QUICK_BOOK_MOVIES(state, payload) {
  return state.filteredQuickBookMovies = payload;
}), (0, _defineProperty3.default)(_mutations, "SET_QUICK_BOOK_CINEMAS", function SET_QUICK_BOOK_CINEMAS(state, payload) {
  return state.quickBookCinemas = payload;
}), (0, _defineProperty3.default)(_mutations, "SET_QUICK_BOOK_DATES", function SET_QUICK_BOOK_DATES(state, payload) {
  return state.quickBookDates = payload;
}), (0, _defineProperty3.default)(_mutations, "SET_QUICK_BOOK_TIMES", function SET_QUICK_BOOK_TIMES(state, payload) {
  return state.quickBookTimes = payload;
}), (0, _defineProperty3.default)(_mutations, "SET_FILTERED_QUICK_BOOK_CINEMAS", function SET_FILTERED_QUICK_BOOK_CINEMAS(state, payload) {
  return state.filteredQuickBookCinemas = payload;
}), (0, _defineProperty3.default)(_mutations, "FILTER_QUICK_BOOK_DATA", function FILTER_QUICK_BOOK_DATA(state, payload) {
  var type = payload.type,
      value = payload.value;

  console.log("payload", payload);

  switch (type) {
    case "movie":
      state.filteredQuickBookMovies = state.quickBookMovies.filter(function (item) {
        return item.movie_title.toLowerCase().includes(value.toLowerCase());
      });
    case "cinema":
      state.filteredQuickBookCinemas = state.quickBookCinemas.filter(function (item) {
        return item.cine_name.toLowerCase().includes(value.toLowerCase());
      });
      break;
  }
}), (0, _defineProperty3.default)(_mutations, "SET_SELECTED_QB_MOVIE", function SET_SELECTED_QB_MOVIE(state, payload) {
  return state.selectedQBMovie = payload;
}), (0, _defineProperty3.default)(_mutations, "SET_SELECTED_QB_CINEMA", function SET_SELECTED_QB_CINEMA(state, payload) {
  return state.selectedQBCinema = payload;
}), (0, _defineProperty3.default)(_mutations, "SET_SELECTED_QB_DATE", function SET_SELECTED_QB_DATE(state, payload) {
  return state.selectedQBDate = payload;
}), (0, _defineProperty3.default)(_mutations, "SET_SELECTED_QB_TIME", function SET_SELECTED_QB_TIME(state, payload) {
  return state.selectedQBTime = payload;
}), (0, _defineProperty3.default)(_mutations, "SET_GLOBAL_OPTIONS", function SET_GLOBAL_OPTIONS(state, payload) {
  return state.global_options = payload;
}), (0, _defineProperty3.default)(_mutations, "SET_COUNTRIES", function SET_COUNTRIES(state, payload) {
  return state.countries = payload;
}), (0, _defineProperty3.default)(_mutations, "SET_CURR_CODE", function SET_CURR_CODE(state, payload) {
  return state.curr_code = payload;
}), (0, _defineProperty3.default)(_mutations, "SET_USER_REVIEWS", function SET_USER_REVIEWS(state, payload) {
  return state.user_reviews = payload;
}), (0, _defineProperty3.default)(_mutations, "CLEAR_QB_DATA", function CLEAR_QB_DATA(state) {
  state.selectedQBMovie = null;
  state.selectedQBCinema = null;
  state.selectedQBDate = null;
  state.selectedQBTime = null;
}), (0, _defineProperty3.default)(_mutations, "SET_CINEMAS_LIST", function SET_CINEMAS_LIST(state, payload) {
  return state.CinemasList = payload;
}), (0, _defineProperty3.default)(_mutations, "SET_STRIPE_PUBLISHER_KEY", function SET_STRIPE_PUBLISHER_KEY(state, payload) {
  return state.stripePublisherKey = payload;
}), _mutations);

var actions = {
  fetchGlobalOptions: function () {
    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(_ref2, payload) {
      var commit = _ref2.commit;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              console.log("inside fetch global options");
              _GlobalServices2.default.GetGlobalOptions().then(function () {
                var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(response) {
                  var data, currency, _ref5, currencyData;

                  return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          data = response.data;

                          if (!(data && data.status && data.Records.length > 0)) {
                            _context.next = 12;
                            break;
                          }

                          commit("SET_GLOBAL_OPTIONS", data.Records);
                          currency = data.Records.find(function (go) {
                            return go.go_key === "CURRENCY";
                          });
                          _context.next = 6;
                          return _GlobalServices2.default.GetCurrency({
                            curr_id: currency.go_value
                          });

                        case 6:
                          _ref5 = _context.sent;
                          currencyData = _ref5.data;

                          console.log("SET_CURR_CODE", currencyData);
                          if (currencyData && currencyData.status && currencyData.Records) {
                            if (currencyData.Records.curr_code == "USD") {
                              currencyData.Records.curr_code = "$";
                            }
                            commit("SET_CURR_CODE", currencyData.Records.curr_code);
                          }
                          _context.next = 13;
                          break;

                        case 12:
                          console.log("Erro in fetching global options");

                        case 13:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, undefined);
                }));

                return function (_x3) {
                  return _ref4.apply(this, arguments);
                };
              }());

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, undefined);
    }));

    function fetchGlobalOptions(_x, _x2) {
      return _ref3.apply(this, arguments);
    }

    return fetchGlobalOptions;
  }(),
  fetchCountries: function () {
    var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(_ref6, payload) {
      var commit = _ref6.commit;
      return _regenerator2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _mainService2.default.GetCountries().then(function (response) {
                var data = response.data;

                if (data && data.status && data.Records.length > 0) {
                  commit("SET_COUNTRIES", data.Records);
                } else {
                  console.log("Error", data.message);
                }
              }).catch(function (err) {
                console.log("Error", err);
              });

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, undefined);
    }));

    function fetchCountries(_x4, _x5) {
      return _ref7.apply(this, arguments);
    }

    return fetchCountries;
  }(),
  setCurrentRoute: function setCurrentRoute(_ref8, payload) {
    var commit = _ref8.commit;

    commit("SET_CURRENT_ROUTE", payload);
  },

  // fetchAllCinemas: function({ commit }) {
  //   let payload = {
  //     Flag: "Popular",
  //     latitude: null,
  //     longitude: null,
  //     location: false
  //   };

  //   return MovieService.GetCinemas(payload)
  //     .then(response => {
  //       const { data } = response;
  //       if (data && data.status && data.Records.length > 0) {
  //         commit("SET_CINEMAS_LIST", data.Records);
  //       } else {
  //         this.$toasted.show(data.message);
  //       }
  //     })
  //     .catch(error => {
  //       this.$toasted.show(Error(error));
  //     });
  // },
  // setNowShowingMovies({ commit }, payload) {
  //     commit('SET_NOWSHOWING_MOVIES', payload)
  // },
  getAllMovies: function getAllMovies(_ref9, payload) {
    var state = _ref9.state,
        dispatch = _ref9.dispatch,
        commit = _ref9.commit;
    var date = payload.date;

    var movieFlag = payload.flag ? payload.flag : null;
    commit("RESET_FILTERED_FLAGS");
    commit("SET_FILTERED_MOVIES", null);
    var savedLang = LanguageService.getLanguage();
    var content_lang = void 0;
    if (savedLang && savedLang.lang_id) {
      content_lang = savedLang.lang_id;
    }
    var loader = _vue2.default.$loading.show();
    return MovieService.GetMovies({
      limit: 8,
      date: date,
      content_lang: content_lang,
      flag: movieFlag
    }).then(function (response) {
      var data = response.data;

      if (data && data.status) {
        console.log("mydata :", data);
        // commit('SET_NOWSHOWING_MOVIES', data)
        commit("SET_NOWSHOWING_MOVIE_TYPE", data.Records);
        commit("SET_FILTERED_MOVIES", data.Records);
        commit("SET_CINEMAS_LIST", data.cinemasList);
        commit("RESET_FILTERS");

        filterGenres(state, dispatch, commit);
        filterLanguages(state, dispatch, commit);
        filterFormats(state, dispatch, commit);
      } else {
        _vue2.default.toasted.show(data.message);
      }
    }).catch(function (error) {
      _vue2.default.toasted.show(error);
    }).finally(function () {
      loader.hide();
    });
  },

  getAllMovieTypeDetails: function () {
    var _ref11 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(_ref10) {
      var commit = _ref10.commit,
          dispatch = _ref10.dispatch;
      return _regenerator2.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              MovieService.GetMovieTypeDetails().then(function (response) {
                var data = response.data;

                if (data && data.status) {
                  console.log("mydatatype :", data.Records);

                  // commit('SET_NOWSHOWING_MOVIE_TYPE', data.Records)
                  commit("RESET_GENRE");
                  // dispatch('getGenre', data.Records)
                } else {
                    // Vue.toasted.show(data.message);
                  }
              }).catch(function (error) {
                _vue2.default.toasted.show(error);
              });

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, undefined);
    }));

    function getAllMovieTypeDetails(_x6) {
      return _ref11.apply(this, arguments);
    }

    return getAllMovieTypeDetails;
  }(),

  // getGenre: async ({ commit }, payload) => {
  //     let finalArray = []
  //     for (let i in payload) {
  //         MovieService.GetGenre({ movie_id: payload[i].movie_id })
  //             .then(async response => {
  //                 const { data } = response;
  //                 if (data && data.status) {
  //                     // console.log('mydatagenre :', data.Records);
  //                     await commit('SET_NOWSHOWING_GENRE', { genre: data.Records, movieType: payload[i] })
  //                 }

  //                 else {
  //                     Vue.toasted.show(data.message);
  //                 }
  //             })
  //             .catch(error => {
  //                 Vue.toasted.show(error);
  //             });
  //     }
  // },

  getAllCinemas: function getAllCinemas(_ref12) {
    var commit = _ref12.commit;

    return MovieService.GetCinemas({ location: false }).then(function (response) {
      var data = response.data;

      if (data && data.status) {
        console.log("mydatacinemas :", data);
        commit("SET_NOWSHOWING_CINEMAS", data);
      } else {
        // Vue.toasted.show(data.message);
      }
    }).catch(function (error) {
      _vue2.default.toasted.show(error);
    });
  },
  getAllShowDates: function getAllShowDates(_ref13) {
    var commit = _ref13.commit;

    return MovieService.GetAllShowDates().then(function (response) {
      var data = response.data;

      if (data && data.status) {
        // console.log('mydatadates :', data.Records);
        commit("SET_NOWSHOWING_DATES", data.Records);
      } else {
        _vue2.default.toasted.show(data.message);
      }
    }).catch(function (error) {
      _vue2.default.toasted.show(error);
    });
  },
  getActiveBanners: function getActiveBanners(_ref14) {
    var commit = _ref14.commit;

    var savedLang = LanguageService.getLanguage();
    var content_lang = void 0;
    if (savedLang && savedLang.lang_id) {
      content_lang = savedLang.lang_id;
    }
    return MovieService.GetActiveBanners({ lang_id: content_lang }).then(function (response) {
      var data = response.data;


      if (data && data.status) {
        if (data.Records && data.Records.length > 0) {
          var uniqueMovies = [].concat((0, _toConsumableArray3.default)(new _map2.default(data.Records.map(function (item) {
            return [item["movie_id"], item];
          })).values()));
          commit("SET_BANNERS_DATA", uniqueMovies);
        }
      } else {
        // Vue.toasted.show(data.message);
      }
    }).catch(function (error) {
      _vue2.default.toasted.show(error);
    });
  },
  onSelectLanguage: function onSelectLanguage(_ref15, payload) {
    var commit = _ref15.commit,
        state = _ref15.state,
        dispatch = _ref15.dispatch;

    console.log("onSelectLanguage called");
    if (state.selectedLanguage && state.selectedLanguage.lang_id === payload.lang_id) {
      dispatch("clearFilter", { type: "language" });
      return;
    }

    commit("SET_SELECTED_LANGUAGE", payload);
    dispatch("filterMovies");
  },
  onSelectCinemaFilter: function onSelectCinemaFilter(_ref16, payload) {
    var commit = _ref16.commit,
        state = _ref16.state,
        dispatch = _ref16.dispatch;

    console.log("onSelectCinemaFilter called");
    if (state.selectedCinema && state.selectedCinema.cine_id === payload.cine_id) {
      dispatch("clearFilter", { type: "cinema" });
      return;
    }

    commit("SET_SELECTED_CINEMA", payload);
    dispatch("filterMovies");
  },
  onSelectGenre: function onSelectGenre(_ref17, payload) {
    var commit = _ref17.commit,
        state = _ref17.state,
        dispatch = _ref17.dispatch;

    console.log("onSelectGenre called with payload: ", payload);
    if (state.selectedGenre && state.selectedGenre.g_id === payload.g_id) {
      dispatch("clearFilter", { type: "genre" });
      return;
    }

    commit("SET_SELECTED_GENRE", payload);
    dispatch("filterMovies");
  },
  onSelectFormat: function onSelectFormat(_ref18, payload) {
    var commit = _ref18.commit,
        state = _ref18.state,
        dispatch = _ref18.dispatch;

    if (state.selectedFormat && state.selectedFormat === payload.mf_name) {
      dispatch("clearFilter", { type: "format" });
      return;
    }

    commit("SET_SELECTED_FORMAT", payload.mf_name);
    dispatch("filterMovies");
  },
  onSelectDate: function onSelectDate(_ref19, payload) {
    var commit = _ref19.commit,
        state = _ref19.state,
        dispatch = _ref19.dispatch;

    console.log("payload", payload);
    if (state.selectedDate && state.selectedDate === payload) {
      dispatch("clearFilter", { type: "date" });
      return;
    }

    commit("SET_SELECTED_DATE", payload);
    dispatch("getAllMovies", { date: payload });
  },
  filterMovies: function filterMovies(_ref20, payload) {
    var commit = _ref20.commit,
        state = _ref20.state,
        dispatch = _ref20.dispatch;

    var selectedGenre = state.selectedGenre;
    var selectedLanguage = state.selectedLanguage;
    var selectedFormat = state.selectedFormat;
    var selectedCinema = state.selectedCinema;

    var movies = state.nowShowingMoviesType;

    if (selectedGenre) {
      movies = movies.filter(function (movie) {
        return movie.genres && movie.genres.length > 0 ? movie.genres.some(function (g) {
          return g.genre_id === selectedGenre.genre_id;
        }) : false;
      });
    }

    if (selectedLanguage) {
      movies = movies.filter(function (movie) {
        return movie.languages && movie.languages.length > 0 ? movie.languages.some(function (l) {
          return l.language_id === selectedLanguage.language_id;
        }) : false;
      });
    }

    if (selectedFormat) {
      movies = movies.filter(function (movies) {
        return movies.mf_name === selectedFormat;
      });
    }

    if (selectedCinema) {
      movies = movies.filter(function (movie) {
        return movie.available_in_cinemas && movie.available_in_cinemas.includes(selectedCinema.cine_id);
      });
    }

    commit("SET_FILTERED_MOVIES", movies);
  },
  clearFilter: function clearFilter(_ref21, payload) {
    var commit = _ref21.commit,
        state = _ref21.state,
        dispatch = _ref21.dispatch;

    console.log("clearFilter payload", payload);
    var type = payload.type;

    switch (type) {
      case "date":
        commit("SET_SELECTED_DATE", null);
        dispatch("getAllMovies", { date: null });
        break;
      case "language":
        commit("SET_SELECTED_LANGUAGE", null);
        break;
      case "genre":
        commit("SET_SELECTED_GENRE", null);
        break;
      case "format":
        commit("SET_SELECTED_FORMAT", null);
        break;
      case "cinema":
        commit("SET_SELECTED_CINEMA", null);
        break;
    }
    dispatch("filterMovies");
    // dispatch("getAllMovies", { date: null });
  },
  fetchLanguages: function () {
    var _ref23 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(_ref22) {
      var commit = _ref22.commit,
          state = _ref22.state,
          dispatch = _ref22.dispatch;

      var _ref24, data;

      return _regenerator2.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return MovieService.GetLanguages();

            case 3:
              _ref24 = _context5.sent;
              data = _ref24.data;

              if (!(data && data.status && data.languages.length > 0)) {
                _context5.next = 11;
                break;
              }

              commit("SET_LANGUAGES", data.languages);
              commit("SET_ALL_LANGUAGES", data.languages);
              filterLanguages(state, dispatch, commit);
              _context5.next = 12;
              break;

            case 11:
              throw new Error("Error while fetching languages.");

            case 12:
              _context5.next = 17;
              break;

            case 14:
              _context5.prev = 14;
              _context5.t0 = _context5["catch"](0);

              console.error(_context5.t0);

            case 17:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this, [[0, 14]]);
    }));

    function fetchLanguages(_x7) {
      return _ref23.apply(this, arguments);
    }

    return fetchLanguages;
  }(),
  fetchFormats: function () {
    var _ref26 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(_ref25) {
      var commit = _ref25.commit,
          state = _ref25.state,
          dispatch = _ref25.dispatch;

      var _ref27, data;

      return _regenerator2.default.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              _context6.next = 3;
              return MovieService.GetFormats();

            case 3:
              _ref27 = _context6.sent;
              data = _ref27.data;

              if (!(data && data.status && data.formats.length > 0)) {
                _context6.next = 11;
                break;
              }

              commit("SET_FORMATS", data.formats);
              commit("SET_ALL_FORMATS", data.formats);
              filterFormats(state, dispatch, commit);
              _context6.next = 12;
              break;

            case 11:
              throw new Error("Error while fetching formats.");

            case 12:
              _context6.next = 17;
              break;

            case 14:
              _context6.prev = 14;
              _context6.t0 = _context6["catch"](0);

              console.error(_context6.t0);

            case 17:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, this, [[0, 14]]);
    }));

    function fetchFormats(_x8) {
      return _ref26.apply(this, arguments);
    }

    return fetchFormats;
  }(),
  fetchGenres: function () {
    var _ref29 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(_ref28) {
      var commit = _ref28.commit,
          state = _ref28.state,
          dispatch = _ref28.dispatch;

      var _ref30, data;

      return _regenerator2.default.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              _context7.next = 3;
              return MovieService.GetGenres();

            case 3:
              _ref30 = _context7.sent;
              data = _ref30.data;

              console.log("data", data);

              if (!(data && data.status && data.genres.length > 0)) {
                _context7.next = 12;
                break;
              }

              commit("SET_GENRES", data.genres);
              commit("SET_ALL_GENRES", data.genres);
              filterGenres(state, dispatch, commit);
              _context7.next = 13;
              break;

            case 12:
              throw new Error("Error while fetching genres.");

            case 13:
              _context7.next = 18;
              break;

            case 15:
              _context7.prev = 15;
              _context7.t0 = _context7["catch"](0);

              console.error(_context7.t0);

            case 18:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, this, [[0, 15]]);
    }));

    function fetchGenres(_x9) {
      return _ref29.apply(this, arguments);
    }

    return fetchGenres;
  }(),
  QuickBook: function () {
    var _ref32 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8(_ref31, payload) {
      var commit = _ref31.commit,
          dispatch = _ref31.dispatch,
          state = _ref31.state;

      var _ref33, data;

      return _regenerator2.default.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              _context8.next = 3;
              return MovieService.QuickBook(payload);

            case 3:
              _ref33 = _context8.sent;
              data = _ref33.data;

              if (data && data.status) {
                commit("SET_QUICK_BOOK_MOVIES", data.movies);
                commit("SET_FILTERED_QUICK_BOOK_MOVIES", data.movies);
                if (data.cinemas) {
                  commit("SET_QUICK_BOOK_CINEMAS", data.cinemas);
                  commit("SET_FILTERED_QUICK_BOOK_CINEMAS", data.cinemas);
                }
                if (data.dates) {
                  commit("SET_QUICK_BOOK_DATES", data.dates);
                }
                if (data.times) {
                  commit("SET_QUICK_BOOK_TIMES", data.times);
                }
              }
              _context8.next = 11;
              break;

            case 8:
              _context8.prev = 8;
              _context8.t0 = _context8["catch"](0);

              console.error(_context8.t0);

            case 11:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, this, [[0, 8]]);
    }));

    function QuickBook(_x10, _x11) {
      return _ref32.apply(this, arguments);
    }

    return QuickBook;
  }(),
  onSearchQuickBook: function onSearchQuickBook(_ref34, payload) {
    var commit = _ref34.commit,
        dispatch = _ref34.dispatch,
        state = _ref34.state;

    commit("FILTER_QUICK_BOOK_DATA", payload);
  },
  onSelectMovie: function onSelectMovie(_ref35, payload) {
    var commit = _ref35.commit,
        dispatch = _ref35.dispatch,
        state = _ref35.state;

    dispatch("QuickBook", { movie_id: payload.movie_id });
    commit("CLEAR_QB_DATA");
    commit("SET_SELECTED_QB_MOVIE", payload);
  },
  onSelectCinema: function onSelectCinema(_ref36, payload) {
    var commit = _ref36.commit,
        dispatch = _ref36.dispatch,
        state = _ref36.state;

    dispatch("QuickBook", {
      cinema_id: payload.cine_id,
      movie_id: state.selectedQBMovie.movie_id
    });
    state.selectedQBDate = null;
    state.selectedQBTime = null;
    commit("SET_SELECTED_QB_CINEMA", payload);
  },
  onSelectQBDate: function onSelectQBDate(_ref37, payload) {
    var commit = _ref37.commit,
        dispatch = _ref37.dispatch,
        state = _ref37.state;

    dispatch("QuickBook", {
      date: (0, _moment2.default)(payload.ss_start_date).format("DD-MM-YYYY"),
      cinema_id: payload.cine_id,
      movie_id: state.selectedQBMovie.movie_id
    });
    state.selectedQBTime = null;
    commit("SET_SELECTED_QB_DATE", payload);
  },
  onSelectTime: function onSelectTime(_ref38, payload) {
    var commit = _ref38.commit,
        dispatch = _ref38.dispatch,
        state = _ref38.state;

    commit("SET_SELECTED_QB_TIME", payload);
  },
  onClickResetFilters: function onClickResetFilters(_ref39, payload) {
    var commit = _ref39.commit,
        dispatch = _ref39.dispatch,
        state = _ref39.state;

    commit("RESET_FILTERS");
  },
  addReview: function () {
    var _ref41 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9(_ref40, payload) {
      var commit = _ref40.commit,
          dispatch = _ref40.dispatch,
          state = _ref40.state;

      var stars, review_title, review_description, movie_id, cust_id, _ref42, data;

      return _regenerator2.default.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;
              stars = payload.stars, review_title = payload.review_title, review_description = payload.review_description, movie_id = payload.movie_id, cust_id = payload.cust_id;
              _context9.next = 4;
              return MovieService.AddReview({
                stars: stars,
                review_title: review_title,
                review_description: review_description,
                movie_id: movie_id,
                cust_id: cust_id
              });

            case 4:
              _ref42 = _context9.sent;
              data = _ref42.data;

              if (data && data.status) {
                _vue2.default.toasted.show(data.message);
                dispatch("fetchUserReviews", { movie_id: movie_id });
              } else {
                _vue2.default.toasted.show(data.message);
              }
              _context9.next = 12;
              break;

            case 9:
              _context9.prev = 9;
              _context9.t0 = _context9["catch"](0);

              console.error(_context9.t0);

            case 12:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, this, [[0, 9]]);
    }));

    function addReview(_x12, _x13) {
      return _ref41.apply(this, arguments);
    }

    return addReview;
  }(),
  fetchUserReviews: function () {
    var _ref44 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee10(_ref43, payload) {
      var commit = _ref43.commit,
          dispatch = _ref43.dispatch,
          state = _ref43.state;

      var movie_id, _ref45, data;

      return _regenerator2.default.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.prev = 0;

              commit("SET_USER_REVIEWS", []);
              movie_id = payload.movie_id;
              _context10.next = 5;
              return MovieService.GetMovieReviews({
                movie_id: movie_id
              });

            case 5:
              _ref45 = _context10.sent;
              data = _ref45.data;

              if (data && data.status) {
                commit("SET_USER_REVIEWS", data.reviews);
              } else {
                _vue2.default.toasted.show(data.message);
              }
              _context10.next = 13;
              break;

            case 10:
              _context10.prev = 10;
              _context10.t0 = _context10["catch"](0);

              console.error(_context10.t0);

            case 13:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, this, [[0, 10]]);
    }));

    function fetchUserReviews(_x14, _x15) {
      return _ref44.apply(this, arguments);
    }

    return fetchUserReviews;
  }(),
  likeMovie: function () {
    var _ref48 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee11(_ref46, _ref47) {
      var commit = _ref46.commit,
          dispatch = _ref46.dispatch;
      var movie_id = _ref47.movie_id,
          cust_id = _ref47.cust_id;

      var _ref49, data;

      return _regenerator2.default.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.prev = 0;
              _context11.next = 3;
              return MovieService.LikeMovie({ movie_id: movie_id, cust_id: cust_id });

            case 3:
              _ref49 = _context11.sent;
              data = _ref49.data;

              if (data && data.status && data.action) {
                _vue2.default.toasted.show(data.action + " successful");
                data.action == "Like" ? commit("SET_TEMP_LIKE") : commit("RESET_TEMP_LIKE");
              } else {
                _vue2.default.toasted.show(data.message);
              }
              _context11.next = 11;
              break;

            case 8:
              _context11.prev = 8;
              _context11.t0 = _context11["catch"](0);

              console.error(_context11.t0);

            case 11:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, this, [[0, 8]]);
    }));

    function likeMovie(_x16, _x17) {
      return _ref48.apply(this, arguments);
    }

    return likeMovie;
  }(),
  likeCinema: function () {
    var _ref52 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee12(_ref50, _ref51) {
      var commit = _ref50.commit,
          dispatch = _ref50.dispatch;
      var cinema_id = _ref51.cinema_id,
          cust_id = _ref51.cust_id,
          callback = _ref51.callback;

      var _ref53, data;

      return _regenerator2.default.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.prev = 0;
              _context12.next = 3;
              return MovieService.LikeCinema({ cinema_id: cinema_id, cust_id: cust_id });

            case 3:
              _ref53 = _context12.sent;
              data = _ref53.data;

              if (data && data.status && data.action) {
                _vue2.default.toasted.show(data.action + " successful");
                callback(data.action === "Like" ? true : false);
                data.action == "Like" ? commit("SET_TEMP_LIKE") : commit("RESET_TEMP_LIKE");
              } else {
                _vue2.default.toasted.show(data.message);
              }
              _context12.next = 11;
              break;

            case 8:
              _context12.prev = 8;
              _context12.t0 = _context12["catch"](0);

              console.error(_context12.t0);

            case 11:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, this, [[0, 8]]);
    }));

    function likeCinema(_x18, _x19) {
      return _ref52.apply(this, arguments);
    }

    return likeCinema;
  }(),
  onClickBookNowQB: function onClickBookNowQB(_ref54, payload) {
    var commit = _ref54.commit,
        dispatch = _ref54.dispatch;

    commit("CLEAR_QB_DATA");
  },
  fetchStripePublisherKey: function () {
    var _ref56 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee13(_ref55, payload) {
      var commit = _ref55.commit;

      var _ref57, data;

      return _regenerator2.default.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.prev = 0;
              _context13.next = 3;
              return MovieService.GetStripePublisherKey();

            case 3:
              _ref57 = _context13.sent;
              data = _ref57.data;

              if (data && data.status) {
                commit("SET_STRIPE_PUBLISHER_KEY", data.stripePublisherKey);
              }
              _context13.next = 11;
              break;

            case 8:
              _context13.prev = 8;
              _context13.t0 = _context13["catch"](0);

              console.error(_context13.t0);

            case 11:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, this, [[0, 8]]);
    }));

    function fetchStripePublisherKey(_x20, _x21) {
      return _ref56.apply(this, arguments);
    }

    return fetchStripePublisherKey;
  }(),
  onSuccessStripeToken: function () {
    var _ref59 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee14(_ref58, payload) {
      var commit = _ref58.commit,
          dispatch = _ref58.dispatch;

      var loader, email, country_mob_code, cust_mobile, reservationId, token, _ref60, data;

      return _regenerator2.default.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _context14.prev = 0;
              loader = _vue2.default.$loading.show();
              email = payload.email, country_mob_code = payload.country_mob_code, cust_mobile = payload.cust_mobile;
              reservationId = payload.reservationId, token = payload.token;
              _context14.next = 6;
              return MovieService.CreateStripePaymentIntent({
                reservation_id: reservationId,
                token: token,
                cust_id: _store2.default.getters.login_details.length > 0 ? _store2.default.getters.login_details[0].cust_id : null
              });

            case 6:
              _ref60 = _context14.sent;
              data = _ref60.data;

              if (data && data.status) {
                loader.hide();
                dispatch("bookSeats", { email: email, country_mob_code: country_mob_code, cust_mobile: cust_mobile });
              }
              _context14.next = 14;
              break;

            case 11:
              _context14.prev = 11;
              _context14.t0 = _context14["catch"](0);

              console.error(_context14.t0);

            case 14:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14, this, [[0, 11]]);
    }));

    function onSuccessStripeToken(_x22, _x23) {
      return _ref59.apply(this, arguments);
    }

    return onSuccessStripeToken;
  }()
};

function filterGenres(state, dispatch, commit) {
  if (state.allGenres && state.allGenres.length > 0 && state.fileredMovies && Array.isArray(state.fileredMovies) && !state.areGenresFiltered) {
    commit("SET_ARE_GENRES_FILTERED", true);

    var filteredGenres = [];
    var genreIds = {};
    state.fileredMovies.forEach(function (m) {
      if (m.genres && Array.isArray(m.genres)) {
        m.genres.forEach(function (mg) {
          state.allGenres.forEach(function (g) {
            if (mg.genre_id === g.g_id && !genreIds[g.g_id]) {
              filteredGenres.push(g);
              genreIds[g.g_id] = true;
            }
          });
        });
      }
    });

    commit("SET_GENRES", filteredGenres);
  } else if (!state.fileredMovies || state.fileredMovies.length === 0) {
    commit("SET_GENRES", []);
  }
}

function filterLanguages(state, dispatch, commit) {
  if (state.allLanguages && state.allLanguages.length > 0 && state.fileredMovies && Array.isArray(state.fileredMovies) && !state.areLanguagesFiltered) {
    commit("SET_ARE_LANGUAGES_FILTERED", true);

    var filteredLanguages = [];
    var langIds = {};
    state.fileredMovies.forEach(function (m) {
      if (m.languages && Array.isArray(m.languages)) {
        m.languages.forEach(function (ml) {
          state.allLanguages.forEach(function (l) {
            if (ml.language_id === l.lang_id && !langIds[l.lang_id]) {
              filteredLanguages.push(l);
              langIds[l.lang_id] = true;
            }
          });
        });
      }
    });

    commit("SET_LANGUAGES", filteredLanguages);
  } else if (!state.fileredMovies || state.fileredMovies.length === 0) {
    commit("SET_LANGUAGES", []);
  }
}

function filterFormats(state, dispatch, commit) {
  if (state.allFormats && state.allFormats.length > 0 && state.fileredMovies && Array.isArray(state.fileredMovies) && !state.areFormatsFiltered) {
    commit("SET_ARE_FORMATS_FILTERED", true);

    var filteredFormats = [];
    var formatIds = {};
    state.fileredMovies.forEach(function (m) {
      state.allFormats.forEach(function (f) {
        if (m.mf_id === f.mf_id && !formatIds[f.mf_id]) {
          filteredFormats.push(f);
          formatIds[f.mf_id] = true;
        }
      });
    });

    commit("SET_FORMATS", filteredFormats);
  } else if (!state.fileredMovies || state.fileredMovies.length === 0) {
    commit("SET_FORMATS", []);
  }
}

var getters = {
  getCurrentRoute: function getCurrentRoute(state) {
    return state.currentRoute;
  },
  getNowShowingMovies: function getNowShowingMovies(state) {
    return state.nowShowingMovies;
  },
  getNowShowingCinemas: function getNowShowingCinemas(state) {
    return state.nowShowingCinemas;
  },
  getNowShowingDates: function getNowShowingDates(state) {
    return state.nowShowingDates;
  },
  getnowShowingMoviesType: function getnowShowingMoviesType(state) {
    return state.nowShowingMoviesType;
  },
  getFilteredMovies: function getFilteredMovies(state) {
    return state.fileredMovies;
  },
  getnowGenre: function getnowGenre(state) {
    return state.genre;
  },
  getallMovieDetails: function getallMovieDetails(state) {
    return state.moviedetails;
  },
  getBanners: function getBanners(state) {
    return state.Banners;
  },
  getLanguages: function getLanguages(state) {
    return state.languages;
  },
  getFormats: function getFormats(state) {
    return state.formats;
  },
  getGenres: function getGenres(state) {
    return state.genres;
  },
  getSelectedDate: function getSelectedDate(state) {
    return state.selectedDate;
  },
  getSelectedLanguage: function getSelectedLanguage(state) {
    return state.selectedLanguage;
  },
  getSelectedGenre: function getSelectedGenre(state) {
    return state.selectedGenre;
  },
  getSelectedFormat: function getSelectedFormat(state) {
    return state.selectedFormat;
  },
  getQuickBookMovies: function getQuickBookMovies(state) {
    return state.quickBookMovies;
  },
  getFilteredQuickBookMovies: function getFilteredQuickBookMovies(state) {
    return state.filteredQuickBookMovies;
  },
  getQuickBookCinemas: function getQuickBookCinemas(state) {
    return state.quickBookCinemas;
  },
  getQuickBookDates: function getQuickBookDates(state) {
    return state.quickBookDates;
  },
  getQuickBookTimes: function getQuickBookTimes(state) {
    return state.quickBookTimes;
  },
  getFilteredQuickBookCinemas: function getFilteredQuickBookCinemas(state) {
    return state.filteredQuickBookCinemas;
  },
  getSelectedQBMovie: function getSelectedQBMovie(state) {
    return state.selectedQBMovie;
  },
  getSelectedQBCinema: function getSelectedQBCinema(state) {
    return state.selectedQBCinema;
  },
  getSelectedQBDate: function getSelectedQBDate(state) {
    return state.selectedQBDate;
  },
  getSelectedQBTime: function getSelectedQBTime(state) {
    return state.selectedQBTime;
  },
  getUserReviews: function getUserReviews(state) {
    return state.user_reviews;
  },
  getStripePublisherKey: function getStripePublisherKey(state) {
    return state.stripePublisherKey;
  },
  getAllCinemasList: function getAllCinemasList(state) {
    return state.CinemasList;
  },
  getSelectedCinema: function getSelectedCinema(state) {
    return state.selectedCinema;
  },
  getCurrCode: function getCurrCode(state) {
    return state.curr_code;
  },
  getCountries: function getCountries(state) {
    return state.countries;
  },
  getGlobalOptions: function getGlobalOptions(state) {
    return state.global_options;
  }
};

exports.default = {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Api = __webpack_require__(147);

var _Api2 = _interopRequireDefault(_Api);

var _ApiHelper = __webpack_require__(294);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  GetGlobalOptions: function GetGlobalOptions() {
    return (0, _Api2.default)().get("/global_options");
  },
  GetCurrency: function GetCurrency(_ref) {
    var curr_id = _ref.curr_id;

    return (0, _Api2.default)().get("/api/cinema/currency/" + curr_id);
  }
};

/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(31);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _typeof2 = __webpack_require__(1442);

var _typeof3 = _interopRequireDefault(_typeof2);

var _set = __webpack_require__(1453);

var _set2 = _interopRequireDefault(_set);

var _toConsumableArray2 = __webpack_require__(125);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _objectWithoutProperties2 = __webpack_require__(1459);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _regenerator = __webpack_require__(126);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(127);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getIterator2 = __webpack_require__(1460);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _extends2 = __webpack_require__(203);

var _extends3 = _interopRequireDefault(_extends2);

var _getters;

var _mainService = __webpack_require__(28);

var _mainService2 = _interopRequireDefault(_mainService);

var _vistaServices = __webpack_require__(600);

var _vistaServices2 = _interopRequireDefault(_vistaServices);

var _vue = __webpack_require__(59);

var _vue2 = _interopRequireDefault(_vue);

var _lodash = __webpack_require__(77);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _store = __webpack_require__(239);

var _store2 = _interopRequireDefault(_store);

var _cloneDeep = __webpack_require__(297);

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _rtsServices = __webpack_require__(211);

var _rtsServices2 = _interopRequireDefault(_rtsServices);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initialState() {
  return {
    schedule_details_obj: {},
    seoData: {},
    additionalCharges: [],
    prevSeatType: "",
    totalPrice: 0,
    totalGrossPrice: 0,
    screen: "",
    reservationId: "",
    seatsSelected: [],
    totalNumberOfSeats: 0,
    totalNumberOfSeatsCopy: 0,
    scheduleShowId: "",
    seatLayoutData: [],
    movie_data: [],
    seatLayout: [],
    times: [],
    output: [],
    currentRoute: null,
    movieDetailsFormatList: [],
    movieDetailsScheduleList: [],
    movieDetailsAllScheduleList: [],
    movieDetailsObject: {
      movie_id: null,
      lang_name: null,
      md_thumbnail_url: null,
      mt_link: null,
      mf_name: null,
      genre: null,
      mc_plot: null,
      mc_title: null,
      mrrdr_release_date: null,
      rating: null,
      mrrdr_runtime: null,
      movie_cast_crew: null,
      movie_production: []
    },
    langfilter: [],
    mf_filter: [],
    singleMovieDates: [],
    selectedDate: (0, _moment2.default)().format("DD-MM-YYYY"),
    movie_id: null,
    selectedMovieFilter: {
      showDate: null,
      showFormat: "ALL FORMATS"
    },
    selectedMovieFormat: {},
    offerApplied: null,
    totalTicketPrice: 0,
    selectedOffers: null,
    offerFor: null,
    offerPrice: 0,
    promocode: "",
    OffersList: [],
    offerCategoriesList: [],
    offerSet: false,
    seatGroupAll: [],
    seatGroupByType: [],
    totalAmount: 0,
    cashInput: 0,
    netAmount: 0,
    totalCashCollected: 0,
    totalCardAmount: 0,
    isCompleteRateCard: true,
    vouchers_data: [],
    newSeatLayoutArrayState: [],
    // applied_voucher: null,
    movie_dates: [],
    are_shows_available: true,
    isMultiSelectAllowed: false

  };
}
var state = initialState();

var mutations = {
  SET_ARE_SHOWS_AVAILABLE: function SET_ARE_SHOWS_AVAILABLE(state, payload) {
    return state.are_shows_available = payload;
  },
  SET_TEMP_LIKE: function SET_TEMP_LIKE(state) {
    return state.movieDetailsObject.like_id = true;
  },
  RESET_TEMP_LIKE: function RESET_TEMP_LIKE(state) {
    return state.movieDetailsObject.like_id = false;
  },
  SET_COMPLETE_RATE_CARD: function SET_COMPLETE_RATE_CARD(state, payload) {
    state.isCompleteRateCard = payload;
  },
  SET_SEAT_GROUP_ALL: function SET_SEAT_GROUP_ALL(state, payload) {
    state.seatGroupAll = payload;
  },
  SET_TOTAL_BOX_OFFICE_AMOUNT: function SET_TOTAL_BOX_OFFICE_AMOUNT(state, payload) {
    state.totalAmount = payload.totalAmount;
    state.netAmount = payload.netAmount;
    state.totalTicketPrice = payload.totalAmount;
  },
  REMOVE_PROMO_CODE: function REMOVE_PROMO_CODE(state, payload) {
    state.totalTicketPrice += state.offerPrice;
    state.offerPrice = 0;
    state.offerSet = false;
    state.promocode = "";
    state.selectedOffers = null;
    state.offerFor = null;
  },
  SET_CURRENT_ROUTE: function SET_CURRENT_ROUTE(state, payload) {
    state.currentRoute = payload;
  },
  SET_ON_MOVIE_DETAILS: function SET_ON_MOVIE_DETAILS(state, payload) {
    var Obj = {
      movie_id: state.movieDetailsObject.movie_id,
      lang_name: null,
      md_thumbnail_url: null,
      mt_link: null,
      mf_name: null,
      genre: null,
      mc_plot: null,
      mc_title: null,
      mrrdr_release_date: null,
      rating: null,
      mrrdr_runtime: null,
      movie_cast_crew: null,
      movie_production: []
    };
    state.movieDetailsObject = (0, _extends3.default)({}, Obj, payload);
    state.selectedMovieFilter.showFormat = "ALL FORMATS";
  },
  SET_ON_MOVIE_DETAILS_ID: function SET_ON_MOVIE_DETAILS_ID(state, payload) {
    state.movieDetailsObject.movie_id = payload.movie_id;
  },
  SET_ON_MOVIE_FILTERS: function SET_ON_MOVIE_FILTERS(state, payload) {
    state.selectedMovieFilter[payload.name] = payload.value;
    state.selectedDate = payload.name == "showDate" ? payload.value : (0, _moment2.default)().format("DD-YY-MM");
    state.totalNumberOfSeats = state.totalNumberOfSeatsCopy;
  },
  SET_ON_MOVIE_FORMAT: function SET_ON_MOVIE_FORMAT(state, payload) {
    state.movieDetailsFormatList = payload;
  },
  SET_ON_MOVIE_SCHEDULE: function SET_ON_MOVIE_SCHEDULE(state, payload) {
    state.movieDetailsScheduleList = _.chain(payload).groupBy("cinename_movie_format").toPairs().map(function (currentItem) {
      return _.fromPairs(_.zip(["cinename_movie_format", "ItemsList"], currentItem));
    }).value();

    if (state.movieDetailsScheduleList && state.movieDetailsScheduleList.length > 0) {
      state.movieDetailsScheduleList.map(function (x) {
        if (x["ItemsList"].length > 0 && x["ItemsList"]) {
          x["ItemsList"].map(function (y) {
            var start_show_time = (0, _moment2.default)(y.ss_start_date + " " + y.ss_start_show_time, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD HH:mm:ss");
            var curent_time = (0, _moment2.default)().format("YYYY-MM-DD HH:mm:ss");
            if ((0, _moment2.default)(start_show_time).isBefore((0, _moment2.default)(curent_time))) {
              y["status"] = true;
              x["status"] = true;
            } else {
              y["status"] = false;
              x["status"] = false;
            }
          });
        }
      });
    }
  },
  SET_ON_ALL_MOVIE_SCHEDULE: function SET_ON_ALL_MOVIE_SCHEDULE(state, payload) {
    state.movieDetailsAllScheduleList.concat(payload);
  },
  GET_LANG_FILTER: function GET_LANG_FILTER(state, payload) {
    state.langfilter.push(payload);
  },
  GET_MF_FILTER: function GET_MF_FILTER(state, payload) {
    state.mf_filter.push(payload);
  },
  RESET_LANG_MF: function RESET_LANG_MF(state) {
    state.langfilter = [], state.mf_filter = [];
  },

  SET_DATES: function SET_DATES(state, payload) {
    state.singleMovieDates = [];
    payload.map(function (x) {
      var date = x["ss_start_date"] ? (0, _moment2.default)(x.ss_start_date).format("DD-MM-YYYY") : "-";
      if (state.singleMovieDates.indexOf(date) == -1) {
        state.singleMovieDates.push(date);
      }
      return x;
    });
  },
  SET_MOVIE_DATES: function SET_MOVIE_DATES(state, payload) {
    return state.movie_dates = payload;
  },
  SET_MOVIE_ID: function SET_MOVIE_ID(state, payload) {
    return state.movie_id = payload;
  },
  RESET_DATES: function RESET_DATES(state) {
    state.singleMovieDates = [];
    state.selectedMovieFilter.showDate = null;
    state.movieDetailsScheduleList = null;
    state.movieDetailsFormatList = null;
  },
  SET_SEATS: function SET_SEATS(state, payload) {
    state.seatLayoutData = payload.seats.seatLayoutNew;
  },

  RESET_ALL: function RESET_ALL(state) {
    state.movieDetailsScheduleList = [], state.seatLayoutData = [], state.seatsSelected = [], state.totalNumberOfSeats = 0, state.totalPrice = 0, state.totalGrossPrice = 0;
    state.additionalCharges = [], state.totalTicketPrice = 0, state.offerPrice = 0, state.offerSet = false;
    state.promocode = "";
  },

  RESET_SEAT_DATA: function RESET_SEAT_DATA(state) {
    state.seatLayoutData = [];
    state.seatsSelected = [];
    state.totalNumberOfSeats = 0;
    state.totalNumberOfSeatsCopy = 0;
    state.totalPrice = 0;
    state.totalGrossPrice = 0;
    state.additionalCharges = [];
    state.totalTicketPrice = 0;
    state.offerPrice = 0;
    state.offerSet = false;
    state.promocode = "";
  },
  NUMBER_OF_SEATS: function NUMBER_OF_SEATS(state, payload) {
    state.totalNumberOfSeats = payload;
    state.totalNumberOfSeatsCopy = payload;
    state.seatsSelected.map(function (x) {
      state.seatLayoutData[state.prevSeatType].seatsFinal[x.rowIndex][x.seatIndex].selectStatus = false;
      state.seatLayoutData[state.prevSeatType].seatsFinal[x.rowIndex][x.seatIndex].SelectStatusFlag = false;
    });
    state.prevSeatType = "";
    state.seatsSelected = [];
    state.totalPrice = 0;
    state.totalGrossPrice = 0;
    state.totalTicketPrice = 0, state.offerPrice = 0;
    state.offerSet = false;
    state.promocode = "";
  },

  SELECTED_SEATS: function SELECTED_SEATS(state, payload) {
    var globalOptions = _store2.default.getters.getGlobalOptions;

    if (!state.isMultiSelectAllowed) {
      state.prevSeatType = payload.classIndex;
      state.seatLayoutData[payload.classIndex].seatsFinal[payload.rowIndex][payload.seatIndex].selectStatus = !state.seatLayoutData[payload.classIndex].seatsFinal[payload.rowIndex][payload.seatIndex].selectStatus;

      var seatStatus = state.seatLayoutData[payload.classIndex].seatsFinal[payload.rowIndex][payload.seatIndex].selectStatus;
    }

    if (state.seatLayoutData[payload.classIndex].seatsFinal[payload.rowIndex][payload.seatIndex].selectStatus == false) {
      if (state.seatsSelected.length > 0) {
        state.seatsSelected.splice(state.seatsSelected.indexOf(payload.seat), 1);
      }
      state.totalAmount = 0;
      state.netAmount = 0;
      state.seatsSelected.map(function (x) {
        state.totalAmount = state.totalAmount + x.seat_price;
        state.netAmount = state.netAmount + x.seat_net_price;
      });
    }
    if (state.seatLayoutData[payload.classIndex].seatsFinal[payload.rowIndex][payload.seatIndex].selectStatus == true) {
      if (payload.seat.is_booked == "Y") {
        payload.seat.seat_price = 0.0;
        payload.seat.seat_net_price = 0.0;
        if (!state.isMultiSelectAllowed) {
          payload.seat["seatIndex"] = payload.seatIndex;
          payload.seat["rowIndex"] = payload.rowIndex;
          payload.seat["classIndex"] = payload.classIndex;
          state.seatsSelected.push(payload.seat);
        }
        state.netAmount = 0;
        state.totalAmount = 0;
        state.seatsSelected.map(function (x) {
          state.netAmount = 0.0;
          state.totalAmount = 0.0;
        });
      } else {
        if (!state.isMultiSelectAllowed) {
          payload.seat["seatIndex"] = payload.seatIndex;
          payload.seat["rowIndex"] = payload.rowIndex;
          payload.seat["classIndex"] = payload.classIndex;
          state.seatsSelected.push(payload.seat);
        }
        // state.seatsSelected.push(payload.seat)
        state.netAmount = 0;
        state.totalAmount = 0;
        state.seatsSelected.map(function (x) {
          state.netAmount = state.netAmount + x.seat_net_price;
          state.totalAmount = state.totalAmount + x.seat_price;
        });
      }
    }
    var seatsArray = "";
    for (var i in state.seatsSelected) {
      seatsArray += " " + state.seatsSelected[i].sl_seat_name;
    }
    // store.dispatch("onSetAndSendLog", {
    //   action: `Selected seats are : ${seatsArray} `,
    //   page_name: "pos booking",
    //   api_name: ""
    // });
  },
  __SELECT_SEAT_HANDLDER: function __SELECT_SEAT_HANDLDER(state, payload) {
    var seat = payload.seat,
        rowIndex = payload.rowIndex,
        seatIndex = payload.seatIndex,
        originalIndex = payload.originalIndex,
        backward = payload.backward,
        e = payload.e,
        type = payload.type,
        scheduleShowId = payload.scheduleShowId;

    handlerSeatSelected(seat, rowIndex, seatIndex, originalIndex, backward, e, type);
    function handlerSeatSelected(seat, rowIndex, seatIndex, originalIndex, backward, e, type) {
      var firstTime = 0;
      if (!originalIndex) {
        firstTime = 1;
        originalIndex = seatIndex;
      } else if (state.totalNumberOfSeats != state.seatsSelected.length) {
        state.seatLayoutData[type].seatsFinal[rowIndex][seatIndex].selectStatus = true;
      }
      if (state.seatLayoutData[type].seatsFinal[rowIndex][seatIndex].selectStatus == false) {
        if (state.totalNumberOfSeats != state.seatsSelected.length) {
          state.seatLayoutData[type].seatsFinal[rowIndex][seatIndex].selectStatus = true;
        }
      }

      if (state.totalNumberOfSeats == state.seatsSelected.length && firstTime == 1) {
        //deselect all
        state.seatsSelected.map(function (x) {
          if (x.sst_id != seat.sst_id) {
            state.seatLayoutData[state.prevSeatType].seatsFinal[x.rowIndex][x.seatIndex].selectStatus = false;
            state.seatLayoutData[state.prevSeatType].seatsFinal[x.rowIndex][x.seatIndex].SelectStatusFlag = false;
          } else {
            state.seatLayoutData[type].seatsFinal[x.rowIndex][x.seatIndex].selectStatus = false;
            state.seatLayoutData[type].seatsFinal[x.rowIndex][x.seatIndex].SelectStatusFlag = false;
          }
        });
      }

      if (state.seatLayoutData[type].seatsFinal[rowIndex][seatIndex]["SelectStatusFlag"] == false) {
        //check if seat is selected, if yes, do nothing else
        //check how many selected
        if (parseInt(state.totalNumberOfSeats) - state.seatsSelected.length > 0) {
          state.seatLayoutData[type].seatsFinal[rowIndex][seatIndex]["SelectStatusFlag"] = true;
          state.seatLayoutData[type].seatsFinal[rowIndex][seatIndex].selectStatus = true;
          seat.seatIndex = seatIndex;
          seat.rowIndex = rowIndex;
          state.prevSeatType = type;
          state.seatsSelected.push(seat);
          seatIndex + 1;
          //check on right if available, if yes, select
          if (state.seatLayoutData[type].seatsFinal[rowIndex][parseInt(seatIndex) + 1] && backward != "backward" && (state.seatLayoutData[type].seatsFinal[rowIndex][parseInt(seatIndex) + 1].seat_reserve_type_id == 1 || state.seatLayoutData[type].seatsFinal[rowIndex][parseInt(seatIndex) + 1].seat_reserve_type_id == 11 || state.seatLayoutData[type].seatsFinal[rowIndex][parseInt(seatIndex) + 1].seat_reserve_type_id == 5)) {
            handlerSeatSelected(state.seatLayoutData[type].seatsFinal[rowIndex][parseInt(seatIndex) + 1], rowIndex, seatIndex + 1, originalIndex, backward, e, type);

            //check on left if available, if yes, select
          } else if (state.seatLayoutData[type].seatsFinal[rowIndex][parseInt(originalIndex) - 1] && (state.seatLayoutData[type].seatsFinal[rowIndex][parseInt(originalIndex) - 1].seat_reserve_type_id == 1 || state.seatLayoutData[type].seatsFinal[rowIndex][parseInt(originalIndex) - 1].seat_reserve_type_id == 11 || state.seatLayoutData[type].seatsFinal[rowIndex][parseInt(originalIndex) - 1].seat_reserve_type_id == 5)) {
            handlerSeatSelected(state.seatLayoutData[type].seatsFinal[rowIndex][parseInt(originalIndex) - 1], rowIndex, originalIndex - 1, originalIndex - 1, "backward", e, type);
          }
        } else {
          if (firstTime == 1) {
            state.seatsSelected = [];
            handlerSeatSelected(state.seatLayoutData[type].seatsFinal[rowIndex][parseInt(seatIndex)], rowIndex, seatIndex, originalIndex, null, e, type);
          }
        }
      }
    }
  },
  SELECT_SEAT_HANDLDER: function SELECT_SEAT_HANDLDER(state, payload) {
    var seat = payload.seat,
        rowIndex = payload.rowIndex,
        seatIndex = payload.seatIndex,
        originalIndex = payload.originalIndex,
        backward = payload.backward,
        e = payload.e,
        type = payload.type,
        scheduleShowId = payload.scheduleShowId;


    var oldSelectedSeats = _.cloneDeep(state.seatsSelected);

    handlerSeatSelected(seat, rowIndex, seatIndex, originalIndex, backward, e, type);
    function handlerSeatSelected(seat, rowIndex, seatIndex, originalIndex, backward, e, type) {
      var firstTime = 0;

      if (!originalIndex && originalIndex != 0) {
        firstTime = 1;
        originalIndex = seatIndex;
      } else if (state.totalNumberOfSeats != state.seatsSelected.length) {
        state.seatLayoutData[type].seatsFinal[rowIndex][seatIndex].selectStatus = true;
      }
      if (state.seatLayoutData[type].seatsFinal[rowIndex][seatIndex].selectStatus == false) {
        if (state.totalNumberOfSeats != state.seatsSelected.length) {
          state.seatLayoutData[type].seatsFinal[rowIndex][seatIndex].selectStatus = true;
        }
      }
      if (state.totalNumberOfSeats == state.seatsSelected.length && firstTime == 1) {
        state.seatsSelected.map(function (x) {
          if (x.sst_id != seat.sst_id) {
            state.seatLayoutData[state.prevSeatType].seatsFinal[x.rowIndex][x.seatIndex].selectStatus = false;
            state.seatLayoutData[state.prevSeatType].seatsFinal[x.rowIndex][x.seatIndex].SelectStatusFlag = false;
          } else {
            state.seatLayoutData[type].seatsFinal[x.rowIndex][x.seatIndex].selectStatus = false;
            state.seatLayoutData[type].seatsFinal[x.rowIndex][x.seatIndex].SelectStatusFlag = false;
          }
        });

        state.seatLayoutData.map(function (zw, index) {
          if (index != type) {
            zw.seatsFinal.map(function (diss) {
              diss.map(function (sl) {
                sl.selectStatus = false;
                sl.SelectStatusFlag = false;
              });
            });
          }
        });
        // state.seatsSelected = [];
      }

      if (state.seatLayoutData[type].seatsFinal[rowIndex][seatIndex]["SelectStatusFlag"] == false) {
        //check if seat is selected, if yes, do nothing else
        //check how many selected
        if (parseInt(state.totalNumberOfSeats) - state.seatsSelected.length > 0) {
          if (seat.sl_seat_name != "") {
            state.seatLayoutData[type].seatsFinal[rowIndex][seatIndex]["SelectStatusFlag"] = true;
            state.seatLayoutData[type].seatsFinal[rowIndex][seatIndex].selectStatus = true;
            seat.seatIndex = seatIndex;
            seat.rowIndex = rowIndex;
            seat.classIndex = type;
            state.prevSeatType = type;
            state.seatsSelected.push(seat);
            seatIndex + 1;
          } else {
            state.seatLayoutData[type].seatsFinal[rowIndex][seatIndex]["SelectStatusFlag"] = false;
            state.seatLayoutData[type].seatsFinal[rowIndex][seatIndex].selectStatus = false;
          }
          //check on right if available, if yes, select
          if (state.seatLayoutData[type].seatsFinal[rowIndex][parseInt(seatIndex) + 1] && backward != "backward" && (state.seatLayoutData[type].seatsFinal[rowIndex][parseInt(seatIndex) + 1].seat_reserve_type_id == 1 || state.seatLayoutData[type].seatsFinal[rowIndex][parseInt(seatIndex) + 1].seat_reserve_type_id == 11 || state.seatLayoutData[type].seatsFinal[rowIndex][parseInt(seatIndex) + 1].seat_reserve_type_id == 5 || state.seatLayoutData[type].seatsFinal[rowIndex][parseInt(originalIndex) + 1].seat_reserve_type_id == 3)) {
            //                        state.seatsSelected.push(seat);
            //                        state.seatData.SeatLayouts[classIndex].Seats[rowIndex][parseInt(seatIndex) + 1].SelectStatus = true;
            handlerSeatSelected(state.seatLayoutData[type].seatsFinal[rowIndex][parseInt(seatIndex) + 1], rowIndex, seatIndex + 1, originalIndex, backward, e, type);

            //check on left if available, if yes, select
          } else if (state.seatLayoutData[type].seatsFinal[rowIndex][parseInt(originalIndex) - 1] && (state.seatLayoutData[type].seatsFinal[rowIndex][parseInt(originalIndex) - 1].seat_reserve_type_id == 1 || state.seatLayoutData[type].seatsFinal[rowIndex][parseInt(originalIndex) - 1].seat_reserve_type_id == 11 || state.seatLayoutData[type].seatsFinal[rowIndex][parseInt(originalIndex) - 1].seat_reserve_type_id == 5 || state.seatLayoutData[type].seatsFinal[rowIndex][parseInt(originalIndex) - 1].seat_reserve_type_id == 3)) {
            //                        state.seatsSelected.push(seat);
            //                        state.seatData.SeatLayouts[classIndex].Seats[rowIndex][parseInt(originalIndex) - 1].SelectStatus = true;
            handlerSeatSelected(state.seatLayoutData[type].seatsFinal[rowIndex][parseInt(originalIndex) - 1], rowIndex, originalIndex - 1, originalIndex - 1, "backward", e, type);
          }
        } else {
          if (firstTime == 1) {
            state.seatsSelected = [];
            handlerSeatSelected(state.seatLayoutData[type].seatsFinal[rowIndex][parseInt(seatIndex)], rowIndex, seatIndex, originalIndex, null, e, type);
          }
        }
      }
    }

    var newSelectedSeats = _.cloneDeep(state.seatsSelected);

    var removedSeats = [];
    var newAddedSeats = [];

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      var _loop = function _loop() {
        var oldSeat = _step.value;

        var index = newSelectedSeats.findIndex(function (x) {
          return x.sl_id == oldSeat.sl_id;
        });
        if (index === -1) {
          removedSeats.push(oldSeat);
        }
      };

      for (var _iterator = (0, _getIterator3.default)(oldSelectedSeats), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        _loop();
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      var _loop2 = function _loop2() {
        var newSeat = _step2.value;

        var index = oldSelectedSeats.findIndex(function (x) {
          return x.sl_id == newSeat.sl_id;
        });
        if (index === -1) {
          newAddedSeats.push(newSeat);
        }
      };

      for (var _iterator2 = (0, _getIterator3.default)(newSelectedSeats), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        _loop2();
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    removedSeats.map(function (seat) {
      _store2.default.dispatch("sendSeatToSocket", {
        select: false,
        seat: seat
      });
    });

    newAddedSeats.map(function (seat) {
      _store2.default.dispatch("sendSeatToSocket", {
        select: true,
        seat: seat
      });
    });

    var vipSeatArray = state.seatsSelected.filter(function (x) {
      return x.seat_reserve_type_id == 5 || x.seat_reserve_type_id == 12;
    });
    if (vipSeatArray.length > 0) {
      state.isVipSeatSelected = true;
    } else {
      state.isVipSeatSelected = false;
    }
  },
  ON_RESERVE_SEATS: function ON_RESERVE_SEATS(state, payload) {
    state.reservationId = payload;
  },
  SET_SCREEN: function SET_SCREEN(state, payload) {
    state.screen = payload;
  },
  TOTAL_PRICE: function TOTAL_PRICE(state, payload) {
    state.totalPrice = payload.totalPrice;
    state.totalGrossPrice = payload.totalGrossPrice;
    state.totalTicketPrice = payload.totalGrossPrice;
  },
  SET_ADDITIONAL_CHARGES: function SET_ADDITIONAL_CHARGES(state, payload) {
    state.additionalCharges = _.sortBy(payload.Additional_Charges, ["charge_type_id"]);
  },
  SET_SELECTED_OFFERS: function SET_SELECTED_OFFERS(state, _ref) {
    var offer = _ref.offer,
        offerFor = _ref.offerFor;

    var is_on_net_amount = void 0;
    var is_offer_for = void 0;
    var is_on_gross_amount = void 0;

    if (offerFor === "offersAndPromotions") {
      is_on_net_amount = offer.offer_applicable_on_net_amount;
      is_offer_for = "offersAndPromotions";
      is_on_gross_amount = offer.offer_applicable_on_gross_amount;
    } else if (offerFor === "voucher") {
      is_on_net_amount = offer.voucher_redeem_on_net;
      is_offer_for = "vouchers";
      is_on_gross_amount = offer.voucher_redeem_on_gross;
    }

    state.selectedOffers = (0, _extends3.default)({}, offer, {
      is_on_net_amount: is_on_net_amount,
      is_offer_for: is_offer_for,
      is_offer_applied: true,
      is_on_gross_amount: is_on_gross_amount
    });

    state.offerFor = offerFor;
  },
  CALCULATE_OFFER_PRICE: function CALCULATE_OFFER_PRICE(state, _ref2) {
    var offer = _ref2.offer,
        offerFor = _ref2.offerFor;

    // state.offerApplied = payload;
    var payload = offer;
    if (offerFor === "offersAndPromotions") {
      if (state.totalTicketPrice >= payload.pcs_min_ticket_amount) {
        if (payload.offer_applicable_on_gross_amount == "Y") {
          if (payload.offer_type_id == 6) {
            if (payload.pcs_offer_value) {
              if (payload.pcs_offer_value_is_percentage == "N") {
                state.offerPrice = parseFloat(payload.pcs_offer_value);
              } else if (payload.pcs_offer_value_is_percentage == "Y") {
                state.offerPrice = parseFloat(state.totalTicketPrice) * parseInt(payload.pcs_offer_value) / 100;
                if (state.offerPrice > payload.pcs_max_discount_amount) {
                  state.offerPrice = payload.pcs_max_discount_amount;
                }
              }
            }
          } else if (payload.offer_type_id == 4) {
            if (_store2.default.getters.TOTAL_AMOUNT > payload.cco_min_ticket_amount) {
              if (payload.cco_offer_value) {
                if (payload.cco_offer_value_is_percentage == "N") {
                  state.offerPrice = parseFloat(payload.cco_offer_value);
                } else if (payload.cco_offer_value_is_percentage == "Y") {
                  state.offerPrice = parseFloat(_store2.default.getters.TOTAL_AMOUNT) * parseInt(payload.cco_offer_value) / 100;
                }
                if (state.offerPrice > payload.cco_max_discount_amount) {
                  state.offerPrice = payload.cco_max_discount_amount;
                }
              }
            } else {
              _vue2.default.toasted.show("Minimum amount should be greater than " + payload.cco_min_ticket_amount);
            }
          } else if (payload.offer_type_id == 5) {
            if (payload.bo_offer_value) {
              if (payload.bo_offer_value_is_percentage == "Y") {
                state.offerPrice = parseFloat(_store2.default.getters.TOTAL_AMOUNT) * parseInt(payload.bo_offer_value) / 100;
              } else {
                state.offerPrice = payload.bo_offer_value;
              }
            }
          } else {
            if (payload.oc_get_free_ticket) {
              var defaultRateCardTicketAmount = _store2.default.getters.SELECTED_SEATS[0].rate_card_group.find(function (rateCard) {
                return rateCard.default_rate_card === "Y";
              });
              var ticket_price = parseFloat(defaultRateCardTicketAmount.rc_amount);
              var maxNumberOfApplicableTickets = void 0;
              var totalNumberOfApplicableTickets = Math.floor(_store2.default.getters.SELECTED_SEATS.length / (payload.oc_buy_no_of_ticket + payload.oc_get_free_ticket));
              totalNumberOfApplicableTickets *= payload.oc_get_free_ticket;
              if (totalNumberOfApplicableTickets > parseInt(payload.oc_max_no_of_ticket_per_transaction)) {
                maxNumberOfApplicableTickets = parseInt(payload.oc_max_no_of_ticket_per_transaction);
              } else {
                maxNumberOfApplicableTickets = totalNumberOfApplicableTickets;
              }
              state.offerPrice = ticket_price * maxNumberOfApplicableTickets;
            } else if (payload.oc_discount_value) {
              if (payload.oc_discount_value_is_percentage == "N") {
                var _totalNumberOfApplicableTickets = Math.floor(_store2.default.getters.SELECTED_SEATS.length / payload.oc_buy_no_of_ticket);
                state.offerPrice = parseFloat(payload.oc_discount_value) * _totalNumberOfApplicableTickets;
              } else if (payload.oc_discount_value_is_percentage == "Y") {
                var _totalNumberOfApplicableTickets2 = Math.floor(_store2.default.getters.SELECTED_SEATS.length / payload.oc_buy_no_of_ticket);
                state.offerPrice = parseFloat(_store2.default.getters.TOTAL_AMOUNT) * parseInt(payload.oc_discount_value) / 100 * _totalNumberOfApplicableTickets2;
              }
            }
          }
        }
        //For Net Amount
        else if (payload.offer_applicable_on_net_amount == "Y") {
            if (payload.offer_type_id == 6) {
              if (payload.pcs_offer_value) {
                if (payload.pcs_offer_value_is_percentage == "N") {
                  state.offerPrice = parseFloat(payload.pcs_offer_value);
                } else if (payload.pcs_offer_value_is_percentage == "Y") {
                  state.offerPrice = parseFloat(_store2.default.getters.NET_AMOUNT) * parseInt(payload.pcs_offer_value) / 100;
                }
              }
            } else if (payload.offer_type_id == 4) {
              if (_store2.default.getters.NET_AMOUNT > payload.cco_min_ticket_amount) {
                if (payload.cco_offer_value) {
                  if (payload.cco_offer_value_is_percentage == "N") {
                    state.offerPrice = parseFloat(payload.cco_offer_value);
                  } else if (payload.cco_offer_value_is_percentage == "Y") {
                    state.offerPrice = parseFloat(_store2.default.getters.NET_AMOUNT) * parseInt(payload.cco_offer_value) / 100;
                  }
                  if (state.offerPrice > payload.cco_max_discount_amount) {
                    state.offerPrice = payload.cco_max_discount_amount;
                  }
                }
              } else {
                _vue2.default.toasted.show("Minimum amount should be greater than " + payload.cco_min_ticket_amount);
              }
            } else {
              if (payload.oc_get_free_ticket) {
                state.offerPrice = parseFloat(_store2.default.getters.SELECTED_SEATS[0].seat_net_price) * payload.oc_get_free_ticket;
              } else if (payload.oc_discount_value) {
                if (payload.oc_discount_value_is_percentage == "N") {
                  state.offerPrice = parseFloat(payload.oc_discount_value);
                } else if (payload.oc_discount_value_is_percentage == "Y") {
                  state.offerPrice = parseFloat(_store2.default.getters.NET_AMOUNT) * parseInt(payload.oc_discount_value) / 100;
                }
              }
            }
          }
        // Ensuring offer amount is not greater than max discount amount
        if (payload.oc_max_discount_amount && state.offerPrice > payload.oc_max_discount_amount && payload.oc_discount_value_is_percentage == "N") {
          state.offerPrice = payload.oc_max_discount_amount;
        }
        if (payload.oc_max_discount_amount && payload.oc_discount_value_is_percentage == "Y") {
          var _totalNumberOfApplicableTickets3 = Math.floor(_store2.default.getters.SELECTED_SEATS.length / payload.oc_buy_no_of_ticket);
          var maxDiscountPercentage = _totalNumberOfApplicableTickets3 * payload.oc_discount_value;
          if (maxDiscountPercentage > payload.oc_max_discount_amount) {
            if (payload.offer_applicable_on_net_amount == "Y") {
              state.offerPrice = parseFloat(_store2.default.getters.NET_AMOUNT) * parseInt(payload.oc_max_discount_amount) / 100;
            } else if (payload.offer_applicable_on_gross_amount == "Y") {
              state.offerPrice = parseFloat(_store2.default.getters.TOTAL_AMOUNT) * parseInt(payload.oc_max_discount_amount) / 100;
            }
          }
        }
        if (payload.oc_max_discount_amount && state.offerPrice > payload.oc_max_discount_amount) {
          state.offerPrice = payload.oc_max_discount_amount;
        }
        state.totalTicketPrice -= state.offerPrice;
        state.offerSet = true;

        state.selectedOffers.t_offer_price = state.offerPrice;
        state.selectedOffers.oc_discount_value = state.offerPrice;
      } else {
        _vue2.default.toasted.show("Transaction Amount does not qualify for discount");
      }
    } else if (offerFor === "voucher") {
      var voucherObj = offer;
      var voucherDiscount = 0;
      if (voucherObj.voucher_is_percentage === "Y") {
        voucherDiscount = voucherObj.voucher_redeem_on_gross === "Y" ? voucherObj.voucher_amount / 100 * state.totalTicketPrice : voucherObj.voucher_redeem_on_net === "Y" ? voucherObj.voucher_amount / 100 * state.netAmount : 0;
      } else {
        voucherDiscount = voucherObj.voucher_amount;
      }

      if (voucherDiscount > voucherObj.voucher_max_redemption_amount) {
        voucherDiscount = voucherObj.voucher_max_redemption_amount;
      } else if (voucherDiscount < voucherObj.voucher_min_redemption_amount) {
        voucherDiscount = voucherObj.voucher_min_redemption_amount;
      }

      state.offerPrice = voucherDiscount;
      state.totalTicketPrice -= state.offerPrice;
      state.offerSet = true;

      state.selectedOffers.t_offer_price = state.offerPrice;
      state.selectedOffers.oc_discount_value = state.offerPrice;
    }
  },
  SET_ENTER_PROMO_CODE: function SET_ENTER_PROMO_CODE(state, payload) {
    switch (payload.name) {
      case "enterPromoCode":
        state.promocode = payload.event.target.value;

        break;
      default:
    }
  },
  SET_OFFERS_LIST: function SET_OFFERS_LIST(state, payload) {
    state.OffersList = payload;

    state.OffersList.map(function (x) {
      if (String(x.offer_type_id) === "6") {
        var list = x["booking_user_category_id"] && x["booking_user_category_id"].length > 0 ? x["booking_user_category_id"].split(", ") : [];
        x["booking_user_category_id"] = "";
        list.map(function (z) {
          var a = state.offerCategoriesList.filter(function (y) {
            return String(z) === String(y.buc_id);
          });
          if (a.length > 0) {
            x["booking_user_category_id"] += x["booking_user_category_id"].length > 0 ? ", " + a[0].buc_category_name : "" + a[0].buc_category_name;
          }
        });
      }
    });
  },
  SET_OFFERS_CATEGORIES_LIST: function SET_OFFERS_CATEGORIES_LIST(state, payload) {
    state.offerCategoriesList = payload;
  },
  ON_RESET_SELECTET_OFFER_AND_PRICE: function ON_RESET_SELECTET_OFFER_AND_PRICE(state, payload) {
    state.offerPrice = 0;
    state.selectedOffers = {};
    state.promocode = "";
  },
  SET_SEO_DATA: function SET_SEO_DATA(state, payload) {
    state.seoData = payload;
  },
  SET_SCHEDULE_DETAILS_OBJ: function SET_SCHEDULE_DETAILS_OBJ(state, payload) {
    state.schedule_details_obj = payload;
  },
  SET_SCHEDULE_OBJ: function SET_SCHEDULE_OBJ(state, payload) {
    state.schedule_details_obj = state.movieDetailsScheduleList[payload.index1].ItemsList[payload.index2];
  },
  RESET_MOVIE_DETAILS_SCHEDULE_LIST: function RESET_MOVIE_DETAILS_SCHEDULE_LIST(state) {
    state.movieDetailsScheduleList = [];
  },
  RESET_MOVIE_DETAILS_SCHEDULE_LIST_NEW: function RESET_MOVIE_DETAILS_SCHEDULE_LIST_NEW(state) {
    state.movieDetailsFormatList = [];
    state.movieDetailsScheduleList = [];
    state.movieDetailsAllScheduleList = [];
    state.movieDetailsObject = {
      movie_id: null,
      lang_name: null,
      md_thumbnail_url: null,
      mt_link: null,
      mf_name: null,
      genre: null,
      mc_plot: null,
      mc_title: null,
      mrrdr_release_date: null,
      rating: null,
      mrrdr_runtime: null,
      movie_cast_crew: null,
      movie_production: []
    };
    state.offerPrice = null;
    state.totalPrice = 0;
    state.totalGrossPrice = 0;
    state.totalTicketPrice = 0;
  },
  SET_VOUCHERS_DATA: function SET_VOUCHERS_DATA(state, payload) {
    state.vouchers_data = payload;
  },
  SET_NEW_SEAT_LAYOUT: function SET_NEW_SEAT_LAYOUT(state, payload) {
    state.newSeatLayoutArrayState = payload;
  }
};

var actions = {
  setOfferCode: function () {
    var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref3, payload) {
      var dispatch = _ref3.dispatch,
          commit = _ref3.commit,
          state = _ref3.state;
      var offer;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              offer = null;

              state.OffersList.map(function (x) {
                if (state.promocode == x.promo_code) {
                  offer = x;
                }
              });

              if (!(offer == null)) {
                _context.next = 6;
                break;
              }

              _vue2.default.toasted.show("Please enter a valid promo code");
              _context.next = 8;
              break;

            case 6:
              _context.next = 8;
              return dispatch("applyOffersHandler", {
                offerFor: "offersAndPromotions",
                offer: offer
              });

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, undefined);
    }));

    function setOfferCode(_x, _x2) {
      return _ref4.apply(this, arguments);
    }

    return setOfferCode;
  }(),
  fetchCustomerCategoriesList: function () {
    var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(_ref5, payload) {
      var dispatch = _ref5.dispatch,
          commit = _ref5.commit,
          state = _ref5.state;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              MovieService.GetCustomerCategories().then(function (response) {
                var data = response.data;

                if (data && data.status && data.Records) {
                  if (data.Records.length > 0) {
                    commit("SET_OFFERS_CATEGORIES_LIST", data.Records);
                  }
                } else _vue2.default.toasted.show(data.message || "Opps! Something went wrong");
              }).catch(function (error) {
                _vue2.default.toasted.show("Catch Error on fetchCustomerCategoriesList", error);
              }).finally(function () {
                // setTimeout(() => loader.hide(), 1000);
              });

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, undefined);
    }));

    function fetchCustomerCategoriesList(_x3, _x4) {
      return _ref6.apply(this, arguments);
    }

    return fetchCustomerCategoriesList;
  }(),
  onEnterPromoCodes: function () {
    var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(_ref7, payload) {
      var dispatch = _ref7.dispatch,
          commit = _ref7.commit,
          state = _ref7.state;
      return _regenerator2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return commit("SET_ENTER_PROMO_CODE", payload);

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, undefined);
    }));

    function onEnterPromoCodes(_x5, _x6) {
      return _ref8.apply(this, arguments);
    }

    return onEnterPromoCodes;
  }(),
  applyOffersHandler: function () {
    var _ref10 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(_ref9, payload) {
      var dispatch = _ref9.dispatch,
          commit = _ref9.commit,
          state = _ref9.state;
      var offer, offerFor;
      return _regenerator2.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              offer = payload.offer, offerFor = payload.offerFor;

              if (!(payload.offerFor === "offersAndPromotions")) {
                _context4.next = 52;
                break;
              }

              if (!(offer.offer_type_id == 6)) {
                _context4.next = 9;
                break;
              }

              _context4.next = 5;
              return commit("SET_SELECTED_OFFERS", {
                offerFor: payload.offerFor,
                offer: offer
              });

            case 5:
              _context4.next = 7;
              return commit("CALCULATE_OFFER_PRICE", {
                offer: offer,
                offerFor: offerFor
              });

            case 7:
              _context4.next = 50;
              break;

            case 9:
              if (!(offer.offer_type_id == 4)) {
                _context4.next = 16;
                break;
              }

              _context4.next = 12;
              return commit("SET_SELECTED_OFFERS", {
                offerFor: payload.offerFor,
                offer: offer
              });

            case 12:
              _context4.next = 14;
              return commit("CALCULATE_OFFER_PRICE", {
                offer: offer,
                offerFor: offerFor
              });

            case 14:
              _context4.next = 50;
              break;

            case 16:
              if (!(offer.oc_is_combo == "Y" && offer.oc_is_combo_with_fnb == "Y" || offer.oc_is_combo == "Y" && offer.oc_is_combo_free == "Y")) {
                _context4.next = 22;
                break;
              }

              _vue2.default.toasted.show("Offer is applicable on Fnb");
              _context4.next = 20;
              return dispatch("onResetOffersAndPrice");

            case 20:
              _context4.next = 50;
              break;

            case 22:
              if (!(state.seatsSelected.length >= offer.oc_buy_no_of_ticket + offer.oc_get_free_ticket)) {
                _context4.next = 47;
                break;
              }

              if (!(offer.offer_applicable_on_gross_amount == "Y" && offer.oc_min_ticket_price && parseFloat(state.totalTicketPrice) >= parseFloat(offer.oc_min_ticket_price))) {
                _context4.next = 31;
                break;
              }

              _context4.next = 26;
              return commit("SET_SELECTED_OFFERS", payload);

            case 26:
              _context4.next = 28;
              return commit("CALCULATE_OFFER_PRICE", {
                offer: offer,
                offerFor: offerFor
              });

            case 28:

              vmVue.$root.$emit("bv::hide::modal", "pos-applicable-offers");
              _context4.next = 45;
              break;

            case 31:
              if (!(offer.offer_applicable_on_net_amount == "Y" && offer.oc_min_ticket_price && parseFloat(state.totalPrice) >= parseFloat(offer.oc_min_ticket_price))) {
                _context4.next = 39;
                break;
              }

              _context4.next = 34;
              return commit("SET_SELECTED_OFFERS", payload);

            case 34:
              _context4.next = 36;
              return commit("CALCULATE_OFFER_PRICE", {
                offer: offer,
                offerFor: offerFor
              });

            case 36:
              vmVue.$root.$emit("bv::hide::modal", "pos-applicable-offers");
              _context4.next = 45;
              break;

            case 39:
              if (!(offer.offer_applicable_on_gross_amount == "Y")) {
                _context4.next = 45;
                break;
              }

              _context4.next = 42;
              return commit("SET_SELECTED_OFFERS", payload);

            case 42:
              _context4.next = 44;
              return commit("CALCULATE_OFFER_PRICE", {
                offer: offer,
                offerFor: offerFor
              });

            case 44:

              vmVue.$root.$emit("bv::hide::modal", "pos-applicable-offers");

            case 45:
              _context4.next = 50;
              break;

            case 47:
              _vue2.default.toasted.show("Please select atleast " + (offer.oc_buy_no_of_ticket + offer.oc_get_free_ticket) + " ticket(s)");
              _context4.next = 50;
              return dispatch("onResetOffersAndPrice");

            case 50:
              _context4.next = 57;
              break;

            case 52:
              if (!(offerFor === "voucher")) {
                _context4.next = 57;
                break;
              }

              _context4.next = 55;
              return commit("SET_SELECTED_OFFERS", {
                offerFor: payload.offerFor,
                offer: offer
              });

            case 55:
              _context4.next = 57;
              return commit("CALCULATE_OFFER_PRICE", {
                offer: offer,
                offerFor: offerFor
              });

            case 57:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, undefined);
    }));

    function applyOffersHandler(_x7, _x8) {
      return _ref10.apply(this, arguments);
    }

    return applyOffersHandler;
  }(),
  onResetOffersAndPrice: function () {
    var _ref13 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(_ref11, _ref12) {
      var dispatch = _ref11.dispatch,
          commit = _ref11.commit,
          state = _ref11.state;
      var payload = (0, _objectWithoutProperties3.default)(_ref12, []);
      return _regenerator2.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return commit("ON_RESET_SELECTET_OFFER_AND_PRICE");

            case 2:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, undefined);
    }));

    function onResetOffersAndPrice(_x9, _x10) {
      return _ref13.apply(this, arguments);
    }

    return onResetOffersAndPrice;
  }(),
  RESERVE_SEATS: function () {
    var _ref16 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(_ref14, _ref15) {
      var commit = _ref14.commit,
          state = _ref14.state,
          dispatch = _ref14.dispatch;
      var payload = (0, _objectWithoutProperties3.default)(_ref15, []);
      var seats, SeatTypeId, newSeatLayoutArray, rateCardGroup, login_details, cust_id, guest_user_id;
      return _regenerator2.default.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              seats = payload.seat_layout_id.map(function (x) {
                return x.sl_id;
              });
              SeatTypeId = payload.seat_layout_id.map(function (x) {
                return x.sst_id;
              });
              newSeatLayoutArray = [];
              rateCardGroup = [];

              payload.seatGroup.map(function (seat_g) {
                seat_g.rate_card_group.map(function (rg) {
                  var findIndex32 = rateCardGroup.findIndex(function (newrg) {
                    return newrg.tt_id == rg.tt_id;
                  });

                  if (findIndex32 >= 0) {
                    rateCardGroup[findIndex32]["count"] = rateCardGroup[findIndex32]["count"] + rg.totalSeatSelected;
                  } else {
                    var objRateCard = {
                      tt_id: rg.tt_id,
                      tt_name: rg.tt_name.trim(),
                      count: rg.totalSeatSelected
                    };
                    rateCardGroup.push(objRateCard);
                  }

                  for (var i = 0; i < rg.totalSeatSelected; i++) {
                    var obj = {
                      rate_card_id: rg.rate_card_id,
                      tt_id: rg.tt_id,
                      rc_g_id: rg.rc_g_id,
                      rcg_c_id: rg.rcg_c_id,
                      tt_name: rg.tt_name,
                      seat_type_id: seat_g.sst_id,
                      status: false
                    };
                    newSeatLayoutArray.push(obj);
                  }
                });
              });

              if (!(seats.length > 0)) {
                _context6.next = 13;
                break;
              }

              login_details = _store2.default.getters.login_details;
              cust_id = login_details && login_details.length > 0 && login_details[0].cust_id ? login_details[0].cust_id : null;
              guest_user_id = localStorage.getItem("guest_user_id") ? localStorage.getItem("guest_user_id") : null;
              _context6.next = 11;
              return _mainService2.default.ReserveSeats({
                groupRateCard: true,
                seat_layout_id: seats,
                schedule_show_id: payload.schedule_show_id,
                newSeatLayout: newSeatLayoutArray,
                seat_type_id: SeatTypeId,
                reservation_id: payload.reservation_id,
                cust_id: cust_id,
                aggregator_cinema: payload.aggregator_cinema,
                guest_user_id: guest_user_id
              }).then(function (response) {
                var data = response.data;

                if (data.status) {
                  commit("ON_RESERVE_SEATS", payload.reservation_id);
                } else {
                  state.seatsSelected = [];
                  commit("NUMBER_OF_SEATS", state.totalNumberOfSeats);
                }
              }).catch(function (err) {
                _vue2.default.toasted.show("Catch error in reserve seat");
              });

            case 11:
              _context6.next = 14;
              break;

            case 13:
              _vue2.default.toasted.show("Please select at least one seat");

            case 14:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, undefined);
    }));

    function RESERVE_SEATS(_x11, _x12) {
      return _ref16.apply(this, arguments);
    }

    return RESERVE_SEATS;
  }(),

  RESERVE_SEATS_CREATE_SHOW: function () {
    var _ref19 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(_ref17, _ref18) {
      var commit = _ref17.commit,
          state = _ref17.state,
          dispatch = _ref17.dispatch;
      var payload = (0, _objectWithoutProperties3.default)(_ref18, []);
      var seats, SeatTypeId, newSeatLayoutArray, rateCardGroup, login_details, cust_id, guest_user_id;
      return _regenerator2.default.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              seats = payload.seat_layout_id.map(function (x) {
                return x.sl_id;
              });
              SeatTypeId = payload.seat_layout_id.map(function (x) {
                return x.sst_id;
              });
              newSeatLayoutArray = [];
              rateCardGroup = [];

              payload.seatGroup.map(function (seat_g) {
                seat_g.rate_card_group.map(function (rg) {
                  var findIndex32 = rateCardGroup.findIndex(function (newrg) {
                    return newrg.tt_id == rg.tt_id;
                  });

                  if (findIndex32 >= 0) {
                    rateCardGroup[findIndex32]["count"] = rateCardGroup[findIndex32]["count"] + rg.totalSeatSelected;
                  } else {
                    var objRateCard = {
                      tt_id: rg.tt_id,
                      tt_name: rg.tt_name.trim(),
                      count: rg.totalSeatSelected
                    };
                    rateCardGroup.push(objRateCard);
                  }

                  for (var i = 0; i < rg.totalSeatSelected; i++) {
                    var obj = {
                      rate_card_id: rg.rate_card_id,
                      tt_id: rg.tt_id,
                      rc_g_id: rg.rc_g_id,
                      rcg_c_id: rg.rcg_c_id,
                      tt_name: rg.tt_name,
                      seat_type_id: seat_g.sst_id,
                      status: false
                    };
                    newSeatLayoutArray.push(obj);
                  }
                });
              });

              if (!(seats.length > 0)) {
                _context7.next = 13;
                break;
              }

              login_details = _store2.default.getters.login_details;
              cust_id = login_details && login_details.length > 0 && login_details[0].cust_id ? login_details[0].cust_id : null;
              guest_user_id = localStorage.getItem("guest_user_id") ? localStorage.getItem("guest_user_id") : null;
              _context7.next = 11;
              return _mainService2.default.ReserveSeatsCreateShow({
                groupRateCard: true,
                seat_layout_id: seats,
                newSeatLayout: newSeatLayoutArray,
                seat_type_id: SeatTypeId,
                cinema_reservation_id: payload.cinema_reservation_id,
                cust_id: cust_id,
                cinema_id: payload.cinema_id,
                aggregator_cinema: payload.aggregator_cinema,
                guest_user_id: guest_user_id,
                "mycinema_booking_type_id": payload.mycinema_booking_type_id,
                "mycinema_ss_d_id": payload.mycinema_ss_d_id
              }).then(function (response) {
                var data = response.data;

                if (data.status) {
                  commit("ON_RESERVE_SEATS", payload.reservation_id);
                } else {
                  state.seatsSelected = [];
                  commit("NUMBER_OF_SEATS", state.totalNumberOfSeats);
                }
              }).catch(function (err) {
                _vue2.default.toasted.show("Catch error in reserve seat");
              });

            case 11:
              _context7.next = 14;
              break;

            case 13:
              _vue2.default.toasted.show("Please select at least one seat");

            case 14:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, undefined);
    }));

    function RESERVE_SEATS_CREATE_SHOW(_x13, _x14) {
      return _ref19.apply(this, arguments);
    }

    return RESERVE_SEATS_CREATE_SHOW;
  }(),

  seatHandler: function () {
    var _ref20 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8(context, payload) {
      var newPayload;
      return _regenerator2.default.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              if (!state.isMultiSelectAllowed) {
                _context8.next = 3;
                break;
              }

              _context8.next = 3;
              return context.commit("SELECT_SEAT_HANDLDER", payload);

            case 3:
              newPayload = {
                seat: payload.seat,
                seatIndex: payload.seatIndex,
                rowIndex: payload.rowIndex,
                classIndex: payload.type
              };
              _context8.next = 6;
              return context.commit("SELECTED_SEATS", newPayload);

            case 6:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, undefined);
    }));

    function seatHandler(_x15, _x16) {
      return _ref20.apply(this, arguments);
    }

    return seatHandler;
  }(),
  seatPrice: function seatPrice(_ref21) {
    var commit = _ref21.commit,
        state = _ref21.state;

    var totalPrice = 0;
    var totalGrossPrice = 0;
    state.seatsSelected.map(function (x) {
      totalPrice += x.seat_net_price;
      totalGrossPrice += x.seat_price;
    });
    commit("TOTAL_PRICE", { totalPrice: totalPrice, totalGrossPrice: totalGrossPrice });
  },

  SelectNumberOfSeats: function SelectNumberOfSeats(context, payload) {
    context.commit("NUMBER_OF_SEATS", payload);
  },

  getSeats: function () {
    var _ref23 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9(_ref22, payload) {
      var commit = _ref22.commit;
      var data, login_details, cust_id, guest_user_id, seats;
      return _regenerator2.default.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              data = {};
              login_details = _store2.default.getters.login_details;
              cust_id = login_details && login_details.length > 0 && login_details[0].cust_id ? login_details[0].cust_id : null;
              guest_user_id = localStorage.getItem("guest_user_id") ? localStorage.getItem("guest_user_id") : null;
              seats = void 0;

              if (!payload.vista_schedule_id) {
                _context9.next = 11;
                break;
              }

              _context9.next = 8;
              return _vistaServices2.default.getSeatLayout({ vista_schedule_id: payload.vista_schedule_id });

            case 8:
              seats = _context9.sent;
              _context9.next = 26;
              break;

            case 11:
              if (!payload.rts_performance_id) {
                _context9.next = 17;
                break;
              }

              _context9.next = 14;
              return _rtsServices2.default.getSeatLayout({ rts_performance_id: payload.rts_performance_id });

            case 14:
              seats = _context9.sent;
              _context9.next = 26;
              break;

            case 17:
              if (!payload.ss_id) {
                _context9.next = 23;
                break;
              }

              _context9.next = 20;
              return _mainService2.default.getSeatLayout({
                screen_id: payload.screen_id,
                ss_id: payload.ss_id,
                md_id: payload.md_id
              });

            case 20:
              seats = _context9.sent;
              _context9.next = 26;
              break;

            case 23:
              _context9.next = 25;
              return _mainService2.default.getSeatLayoutCreateScreen({
                mycinema_ss_d_id: payload.mycinema_ss_d_id
              });

            case 25:
              seats = _context9.sent;

            case 26:
              if (seats.data.status) {
                data.seats = seats.data;
                if (seats && seats.status) {
                  commit("SET_SEATS", data);
                } else {
                  _vue2.default.toasted.show(data.message || "Please try later");
                }
              }

            case 27:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, undefined);
    }));

    function getSeats(_x17, _x18) {
      return _ref23.apply(this, arguments);
    }

    return getSeats;
  }(),

  getLangFilter: function getLangFilter(_ref24, payload) {
    var state = _ref24.state,
        commit = _ref24.commit;

    commit("RESET_LANG_MF");
    for (var i in payload) {
      if (state.langfilter.indexOf(payload[i].lang_name) == -1) {
        commit("GET_LANG_FILTER", payload[i].lang_name);
      }
      if (state.mf_filter.indexOf(payload[i].mf_name) == -1) {
        commit("GET_MF_FILTER", payload[i].mf_name);
      }
    }
  },


  onGetMovieDates: function onGetMovieDates(_ref25, _ref26) {
    var commit = _ref25.commit;
    var movie_id = _ref26.movie_id;

    commit("SET_ARE_SHOWS_AVAILABLE", true);
    var guest_user_id = localStorage.getItem("guest_user_id") ? localStorage.getItem("guest_user_id") : null;
    var login_details = _store2.default.getters.login_details;
    var cust_id = login_details && login_details.length > 0 && login_details[0].cust_id ? login_details[0].cust_id : null;
    return MovieService.GetMovieDates({ movie_id: movie_id, guest_user_id: guest_user_id, cust_id: cust_id }).then(function (response) {
      var data = response.data;

      if (data && data.status) {
        if (data.Records && data.Records.length > 0) {

          commit("SET_DATES", data.Records);
        } else {
          commit("RESET_DATES");

          _vue2.default.toasted.show("No Shows Scheduled");
          commit("SET_ARE_SHOWS_AVAILABLE", false);
        }
      } else {}
    }).catch(function (error) {
      _vue2.default.toasted.show(error);
    });
  },
  onGetMovieShowDates: function onGetMovieShowDates(_ref27, _ref28) {
    var commit = _ref27.commit;
    var movie_id = _ref28.movie_id,
        cinema_id = _ref28.cinema_id;

    commit("SET_MOVIE_DATES", []);
    commit("SET_ARE_SHOWS_AVAILABLE", true);
    return MovieService.GetMovieDates({ movie_id: movie_id, cinema_id: cinema_id }).then(function (response) {
      var data = response.data;

      if (data && data.status) {
        if (data.Records && data.Records.length > 0) {
          var dates = [].concat((0, _toConsumableArray3.default)(new _set2.default(data.Records.map(function (date) {
            return date = (0, _moment2.default)(date.ss_start_date).format("DD-MM-YYYY");
          }))));

          commit("SET_MOVIE_DATES", dates);
        } else {
          _vue2.default.toasted.show("No Shows Scheduled");
          commit("SET_ARE_SHOWS_AVAILABLE", false);
        }
      } else {}
    }).catch(function (error) {
      _vue2.default.toasted.show(error);
    });
  },

  onGetMovieDetails: function onGetMovieDetails(_ref29, payload) {
    var commit = _ref29.commit,
        state = _ref29.state,
        dispatch = _ref29.dispatch;

    var content_lang_id = payload.content_lang_id || 1;
    var guest_user_id = localStorage.getItem("guest_user_id") || null;
    commit("SET_ON_MOVIE_DETAILS_ID", { movie_id: payload.movie_id });
    return MovieService.GetMovieDetails((0, _extends3.default)({ content_lang_id: content_lang_id, guest_user_id: guest_user_id }, payload)).then(function () {
      var _ref30 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee10(response) {
        var data;
        return _regenerator2.default.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                data = response.data;

                if (!(data && data.status)) {
                  _context10.next = 12;
                  break;
                }

                if (!(data.Records && data.Records.length > 0)) {
                  _context10.next = 9;
                  break;
                }

                _context10.next = 5;
                return commit("SET_ON_MOVIE_DETAILS", (0, _extends3.default)({ movie_id: payload.movie_id }, data.Records[0]) || {});

              case 5:
                _context10.next = 7;
                return dispatch("getSeoData");

              case 7:
                _context10.next = 10;
                break;

              case 9:
                _vue2.default.toasted.show("No Records Found");

              case 10:
                _context10.next = 12;
                break;

              case 12:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, undefined);
      }));

      return function (_x19) {
        return _ref30.apply(this, arguments);
      };
    }()).catch(function (error) {
      _vue2.default.toasted.show(error);
    });
  },
  onResetSeatLayout: function onResetSeatLayout(_ref31, payload) {
    var commit = _ref31.commit,
        state = _ref31.state,
        dispatch = _ref31.dispatch;

    commit("RESET_SEAT_DATA");
  },
  onSetDefaultFilter: function () {
    var _ref33 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee11(_ref32, payload) {
      var commit = _ref32.commit,
          state = _ref32.state,
          dispatch = _ref32.dispatch;
      return _regenerator2.default.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return commit("RESET_ALL");

            case 2:
              _context11.next = 4;
              return commit("SET_ON_MOVIE_FILTERS", payload);

            case 4:
              _context11.next = 6;
              return dispatch("onGetMovieFormat", {});

            case 6:
              if (!(state.selectedMovieFilter.showDate && state.selectedMovieFilter.showFormat && (0, _typeof3.default)(state.selectedMovieFilter.showFormat) === "object" && state.selectedMovieFilter.showFormat !== "ALL FORMATS")) {
                _context11.next = 9;
                break;
              }

              _context11.next = 9;
              return dispatch("onGetMoviesSchedules", {});

            case 9:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, undefined);
    }));

    function onSetDefaultFilter(_x20, _x21) {
      return _ref33.apply(this, arguments);
    }

    return onSetDefaultFilter;
  }(),
  onGetMovieFormat: function () {
    var _ref35 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee13(_ref34, payload) {
      var commit = _ref34.commit,
          state = _ref34.state,
          dispatch = _ref34.dispatch;
      return _regenerator2.default.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              MovieService.GetMovieFilters({
                movie_id: state.movieDetailsObject.movie_id
              }).then(function () {
                var _ref36 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee12(response) {
                  var data;
                  return _regenerator2.default.wrap(function _callee12$(_context12) {
                    while (1) {
                      switch (_context12.prev = _context12.next) {
                        case 0:
                          data = response.data;

                          if (!(data && data.status)) {
                            _context12.next = 11;
                            break;
                          }

                          if (!(data.Records.length > 0)) {
                            _context12.next = 6;
                            break;
                          }

                          _context12.next = 5;
                          return commit("SET_ON_MOVIE_FORMAT", data.Records || []);

                        case 5:
                          dispatch("getLangFilter", data.Records);

                        case 6:
                          if (!(state.selectedMovieFilter.showDate && state.selectedMovieFilter.showFormat == "ALL FORMATS")) {
                            _context12.next = 9;
                            break;
                          }

                          _context12.next = 9;
                          return dispatch("onGetAllMoviesSchedules", {});

                        case 9:
                          _context12.next = 11;
                          break;

                        case 11:
                        case "end":
                          return _context12.stop();
                      }
                    }
                  }, _callee12, undefined);
                }));

                return function (_x24) {
                  return _ref36.apply(this, arguments);
                };
              }()).catch(function (error) {
                console.log("error", error);
              });

            case 1:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, undefined);
    }));

    function onGetMovieFormat(_x22, _x23) {
      return _ref35.apply(this, arguments);
    }

    return onGetMovieFormat;
  }(),
  onGetMoviesSchedulesOld: function () {
    var _ref38 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee14(_ref37, payload) {
      var commit = _ref37.commit,
          state = _ref37.state,
          dispatch = _ref37.dispatch;
      return _regenerator2.default.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              MovieService.GetSchedules({
                md_id: state.selectedMovieFilter.showFormat.md_id,
                date: state.selectedMovieFilter.showDate
              }).then(function (response) {
                var data = response.data;

                if (data && data.status) {
                  commit("SET_ON_MOVIE_SCHEDULE", data.Records);
                } else {}
              }).catch(function (error) {
                //Vue.toasted.show(error);
                console.log("error", error);
              });

            case 1:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14, undefined);
    }));

    function onGetMoviesSchedulesOld(_x25, _x26) {
      return _ref38.apply(this, arguments);
    }

    return onGetMoviesSchedulesOld;
  }(),
  onGetMoviesSchedules: function onGetMoviesSchedules(_ref39, payload) {
    var commit = _ref39.commit,
        state = _ref39.state,
        dispatch = _ref39.dispatch;

    var loader = _vue2.default.$loading.show();
    return MovieService.GetSchedules({
      md_id: state.selectedMovieFilter.showFormat.md_id,
      date: state.selectedMovieFilter.showDate
    }).then(function (response) {
      var data = response.data;

      if (data && data.status) {
        commit("SET_ON_MOVIE_SCHEDULE", data.Records);
      } else {}
    }).catch(function (error) {
      console.log("error", error);
    }).finally(function (err) {
      return loader.hide();
    });
  },
  onGetAllMoviesSchedulesOld: function () {
    var _ref41 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee15(_ref40, payload) {
      var commit = _ref40.commit,
          state = _ref40.state,
          dispatch = _ref40.dispatch;
      var FinalArray, index, i;
      return _regenerator2.default.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              FinalArray = [];
              index = 0;

              for (i = 0; i <= state.movieDetailsFormatList.length - 1; i++) {
                if (i) {
                  index = index + 1;
                }
                MovieService.GetMovieSchedules({
                  md_id: state.movieDetailsFormatList[i].md_id,
                  date: state.selectedMovieFilter.showDate
                }).then(function (response) {
                  var data = response.data;

                  if (data && data.status) {
                    if (data.Records.length > 0) {
                      FinalArray = FinalArray.concat(data.Records);
                    }
                  } else {}

                  if (index === state.movieDetailsFormatList.length - 1) {
                    commit("SET_ON_MOVIE_SCHEDULE", FinalArray);
                  }
                }).catch(function (error) {
                  console.log("error", error);
                });
              }

            case 3:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15, undefined);
    }));

    function onGetAllMoviesSchedulesOld(_x27, _x28) {
      return _ref41.apply(this, arguments);
    }

    return onGetAllMoviesSchedulesOld;
  }(),
  onGetAllMoviesSchedules: function () {
    var _ref43 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee16(_ref42, payload) {
      var commit = _ref42.commit,
          state = _ref42.state,
          dispatch = _ref42.dispatch;
      var loader, FinalArray, index, i;
      return _regenerator2.default.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              loader = _vue2.default.$loading.show();
              FinalArray = [];
              index = 0;

              for (i = 0; i <= state.movieDetailsFormatList.length - 1; i++) {
                if (i) {
                  index = index + 1;
                }
                MovieService.GetSchedules({
                  md_id: state.movieDetailsFormatList[i].md_id,
                  date: state.selectedMovieFilter.showDate
                }).then(function (response) {
                  var data = response.data;

                  if (data && data.status) {
                    if (data.Records.length > 0) {
                      FinalArray = FinalArray.concat(data.Records);
                    }
                  } else {}

                  if (index === state.movieDetailsFormatList.length - 1) {
                    commit("SET_ON_MOVIE_SCHEDULE", FinalArray);
                  }
                }).catch(function (error) {}).finally(function () {
                  return loader.hide();
                });
              }

            case 4:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16, undefined);
    }));

    function onGetAllMoviesSchedules(_x29, _x30) {
      return _ref43.apply(this, arguments);
    }

    return onGetAllMoviesSchedules;
  }(),
  getScreen: function getScreen(_ref44) {
    var commit = _ref44.commit,
        state = _ref44.state;

    MovieService.GetScreen({ screen_id: state.seatsSelected[0].screen_id }).then(function (response) {
      var data = response.data;

      if (data && data.status) {
        if (data.Records && data.Records.length > 0) {
          commit("SET_SCREEN", data.Records[0]);
        } else {}
      } else {}
    }).catch(function (error) {
      console.log("error", error);
    });
  },
  resetSelectedSeats: function resetSelectedSeats(_ref45) {
    var commit = _ref45.commit;
  },

  getAdditionalCharges: function () {
    var _ref48 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee17(_ref46, _ref47) {
      var commit = _ref46.commit,
          state = _ref46.state;
      var payload = (0, _objectWithoutProperties3.default)(_ref47, []);

      var _ref49, data;

      return _regenerator2.default.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return MovieService.GetAdditionalCharges({
                selectedSeats: state.seatsSelected,
                isGroupCardExist: true,
                showDetails: state.schedule_details_obj,
                newSeatLayout: payload.newSeatLayoutArray
              });

            case 2:
              _ref49 = _context17.sent;
              data = _ref49.data;

              commit("SET_ADDITIONAL_CHARGES", data);

            case 5:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee17, undefined);
    }));

    function getAdditionalCharges(_x31, _x32) {
      return _ref48.apply(this, arguments);
    }

    return getAdditionalCharges;
  }(),
  getOffers: function getOffers(_ref50) {
    var state = _ref50.state,
        commit = _ref50.commit;

    MovieService.GetOffers({
      cinema_id: state.schedule_details_obj.cine_id,
      movie_details_id: state.schedule_details_obj.md_id,
      screen_id: state.schedule_details_obj.screen_id,
      seat_type_id: state.seatsSelected[0].screen_seat_type_id,
      show_date_time: _moment2.default.unix(state.schedule_details_obj.ss_start_date_time / 1000).format()
    }).then(function (response) {
      var data = response.data;

      if (data.status) {
        if (data.Records) {
          commit("SET_OFFERS_LIST", data.Records);
        }
      } else {}
    }).catch(function (err) {
      _vue2.default.toasted.show("Catch error in offers");
    });
  },
  removeCoupon: function removeCoupon(_ref51) {
    var state = _ref51.state,
        commit = _ref51.commit;

    commit("REMOVE_PROMO_CODE");
  },

  getSeoData: function () {
    var _ref53 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee19(_ref52) {
      var _this = this;

      var state = _ref52.state,
          commit = _ref52.commit;
      return _regenerator2.default.wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              MovieService.GetSeo({ seo_id: 2 }).then(function (response) {
                var data = response.data;

                if (data && data.status && data.Records.length > 0) {
                  var seoFinal = {};
                  var seo_obj = {
                    seo_meta_title: data.Records[0].seo_meta_title,
                    seo_meta_description: data.Records[0].seo_meta_description,
                    seo_meta_keywords: data.Records[0].seo_meta_keywords,
                    og_type: data.Records[0].og_type,
                    og_site: data.Records[0].og_site
                  };
                  seoCreate(seo_obj, state.movieDetailsObject.mc_title, state.langfilter, state.movieDetailsObject.genre).then(function () {
                    var _ref54 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee18(response) {
                      return _regenerator2.default.wrap(function _callee18$(_context18) {
                        while (1) {
                          switch (_context18.prev = _context18.next) {
                            case 0:
                              _context18.next = 2;
                              return response;

                            case 2:
                              seoFinal = _context18.sent;

                              commit("SET_SEO_DATA", seoFinal);

                            case 4:
                            case "end":
                              return _context18.stop();
                          }
                        }
                      }, _callee18, _this);
                    }));

                    return function (_x34) {
                      return _ref54.apply(this, arguments);
                    };
                  }()).catch(function (err) {
                    console.log("err :>> ", err);
                  });
                } else {}
              }).catch(function (error) {
                _vue2.default.toasted.show(error);
              });

            case 1:
            case "end":
              return _context19.stop();
          }
        }
      }, _callee19, this);
    }));

    function getSeoData(_x33) {
      return _ref53.apply(this, arguments);
    }

    return getSeoData;
  }(),
  getScheduleDetails: function getScheduleDetails(_ref55, ss_id) {
    var commit = _ref55.commit,
        dispatch = _ref55.dispatch,
        state = _ref55.state;

    var savedLang = _store2.default.getters.getCurrentLang;
    var content_lang_id = savedLang ? savedLang.lang_id : 1;
    return MovieService.GetScheduleDetails({ ss_id: ss_id, content_lang_id: content_lang_id }).then(function () {
      var _ref56 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee20(response) {
        var data;
        return _regenerator2.default.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                data = response.data;

                if (!(data && data.status)) {
                  _context20.next = 14;
                  break;
                }

                if (!(data.Records.length > 0)) {
                  _context20.next = 12;
                  break;
                }

                _context20.next = 5;
                return commit("SET_SCHEDULE_DETAILS_OBJ", data.Records[0] || {});

              case 5:
                _context20.next = 7;
                return dispatch("getSeats", {
                  md_id: state.schedule_details_obj.md_id,
                  screen_id: state.schedule_details_obj.screen_id,
                  ss_id: state.schedule_details_obj.ss_id
                });

              case 7:
                commit("SET_MOVIE_ID", state.schedule_details_obj.movie_id);
                _context20.next = 10;
                return dispatch("onGetMovieDetails", {
                  movie_id: state.schedule_details_obj.movie_id,
                  cust_id: null,
                  content_lang_id: content_lang_id
                });

              case 10:
                _context20.next = 12;
                return dispatch("getAllShowDates");

              case 12:
                _context20.next = 14;
                break;

              case 14:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, undefined);
      }));

      return function (_x35) {
        return _ref56.apply(this, arguments);
      };
    }()).catch(function (error) {
      _vue2.default.toasted.show(error);
    });
  },
  setScheduleObj: function setScheduleObj(_ref57, payload) {
    var commit = _ref57.commit;

    commit("SET_SCHEDULE_OBJ", payload);
  },
  onGetAllMoviesSchedulesSeatPage: function () {
    var _ref59 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee21(_ref58, payload) {
      var commit = _ref58.commit,
          state = _ref58.state,
          dispatch = _ref58.dispatch;
      var FinalArray, index, loader;
      return _regenerator2.default.wrap(function _callee21$(_context21) {
        while (1) {
          switch (_context21.prev = _context21.next) {
            case 0:
              commit("RESET_MOVIE_DETAILS_SCHEDULE_LIST_NEW");
              FinalArray = [];
              index = 0;
              loader = _vue2.default.$loading.show();


              MovieService.GetSchedules({ md_id: payload.md_id, date: payload.showDate }).then(function (response) {
                loader.hide();
                var data = response.data;

                if (data && data.status) {
                  if (data.Records.length > 0) {
                    FinalArray = FinalArray.concat(data.Records);
                  }
                } else {
                  _vue2.default.toasted.show(data.message);
                }

                commit("SET_ON_MOVIE_SCHEDULE", FinalArray);
              }).catch(function (error) {
                _vue2.default.toasted.show(error);
              });

            case 5:
            case "end":
              return _context21.stop();
          }
        }
      }, _callee21, undefined);
    }));

    function onGetAllMoviesSchedulesSeatPage(_x36, _x37) {
      return _ref59.apply(this, arguments);
    }

    return onGetAllMoviesSchedulesSeatPage;
  }(),
  onSetCompleteRateCard: function () {
    var _ref61 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee22(_ref60, payload) {
      var dispatch = _ref60.dispatch,
          commit = _ref60.commit,
          state = _ref60.state;
      return _regenerator2.default.wrap(function _callee22$(_context22) {
        while (1) {
          switch (_context22.prev = _context22.next) {
            case 0:
              _context22.next = 2;
              return commit("SET_COMPLETE_RATE_CARD", payload.status);

            case 2:
              _context22.next = 4;
              return commit("SET_SEAT_GROUP_ALL", payload.seatGroup);

            case 4:
            case "end":
              return _context22.stop();
          }
        }
      }, _callee22, undefined);
    }));

    function onSetCompleteRateCard(_x38, _x39) {
      return _ref61.apply(this, arguments);
    }

    return onSetCompleteRateCard;
  }(),
  onSetCompleteNewTotalAmount: function () {
    var _ref63 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee23(_ref62, payload) {
      var dispatch = _ref62.dispatch,
          commit = _ref62.commit,
          state = _ref62.state;
      return _regenerator2.default.wrap(function _callee23$(_context23) {
        while (1) {
          switch (_context23.prev = _context23.next) {
            case 0:
              _context23.next = 2;
              return commit("SET_TOTAL_BOX_OFFICE_AMOUNT", payload);

            case 2:
            case "end":
              return _context23.stop();
          }
        }
      }, _callee23, undefined);
    }));

    function onSetCompleteNewTotalAmount(_x40, _x41) {
      return _ref63.apply(this, arguments);
    }

    return onSetCompleteNewTotalAmount;
  }(),
  getVouchersList: function () {
    var _ref65 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee24(_ref64, payload) {
      var commit = _ref64.commit,
          state = _ref64.state;
      var guest_user_id, login_details, cust_id, s;
      return _regenerator2.default.wrap(function _callee24$(_context24) {
        while (1) {
          switch (_context24.prev = _context24.next) {
            case 0:
              guest_user_id = localStorage.getItem("guest_user_id") ? localStorage.getItem("guest_user_id") : null;
              login_details = _store2.default.getters.login_details;
              cust_id = login_details && login_details.length > 0 && login_details[0].cust_id ? login_details[0].cust_id : null;
              s = {
                cinema_id: state.schedule_details_obj.cine_id,
                movie_details_id: state.schedule_details_obj.movie_details_id,
                screen_id: state.schedule_details_obj.screen_id,
                seat_type_id: payload.seat.sst_id,
                show_date_time: state.schedule_details_obj.ss_start_date_time,
                aggregator_cinema_id: state.schedule_details_obj.cine_id,
                selectSeats: state.seatsSelected,
                guest_user_id: guest_user_id,
                cust_id: cust_id
              };
              return _context24.abrupt("return", MovieService.GetVouchersList(s).then(function (response) {
                var data = response.data;

                if (data && data.status) {
                  commit("SET_VOUCHERS_DATA", data.Records);
                }
              }).catch(function (err) {
                _vue2.default.toasted.show(err.message);
              }));

            case 5:
            case "end":
              return _context24.stop();
          }
        }
      }, _callee24, undefined);
    }));

    function getVouchersList(_x42, _x43) {
      return _ref65.apply(this, arguments);
    }

    return getVouchersList;
  }(),
  validateVoucher: function () {
    var _ref67 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee25(_ref66, payload) {
      var commit = _ref66.commit,
          state = _ref66.state,
          dispatch = _ref66.dispatch;
      var voucher_code, successCallback, voucherObj;
      return _regenerator2.default.wrap(function _callee25$(_context25) {
        while (1) {
          switch (_context25.prev = _context25.next) {
            case 0:
              voucher_code = payload.voucher_code, successCallback = payload.successCallback;
              voucherObj = state.vouchers_data.find(function (voucher) {
                return voucher.voucher_code === voucher_code;
              });

              if (!voucherObj) {
                _context25.next = 6;
                break;
              }

              return _context25.abrupt("return", MovieService.ValidateVoucherCode({
                vouchercode: voucher_code,
                voucher_title: voucherObj.voucher_title
              }).then(function (resp) {
                var data = resp.data;

                if (data && data.status) {
                  _vue2.default.toasted.show("Voucher applied!");
                  dispatch("applyOffersHandler", {
                    offerFor: "voucher",
                    offer: voucherObj
                  });
                  successCallback ? successCallback() : null;
                } else {
                  _vue2.default.toasted.show(data.message);
                }
              }).catch(function (err) {
                _vue2.default.toasted.show(err.message);
              }));

            case 6:
              _vue2.default.toasted.show("Invalid voucher code.");

            case 7:
            case "end":
              return _context25.stop();
          }
        }
      }, _callee25, undefined);
    }));

    function validateVoucher(_x44, _x45) {
      return _ref67.apply(this, arguments);
    }

    return validateVoucher;
  }()
};

//
var getters = (_getters = {
  getMovieDetailsObject: function getMovieDetailsObject(state) {
    return state.movieDetailsObject;
  },
  isMultiSelectAllowed: function isMultiSelectAllowed(state) {
    return state.isMultiSelectAllowed;
  },
  getMovieDetailsSelectedFilter: function getMovieDetailsSelectedFilter(state) {
    return state.selectedMovieFilter;
  },
  getMovieDetailsFormatList: function getMovieDetailsFormatList(state) {
    return state.movieDetailsFormatList;
  },
  getMovieDetailsScheduleList: function getMovieDetailsScheduleList(state) {
    return state.movieDetailsScheduleList;
  },
  getOP: function getOP(state) {
    return state.output;
  },
  getLang: function getLang(state) {
    return state.langfilter;
  },
  getMf: function getMf(state) {
    return state.mf_filter;
  },
  getSingleMovieDates: function getSingleMovieDates(state) {
    return state.singleMovieDates;
  },
  getSeatLayout: function getSeatLayout(state) {
    return state.seatLayout;
  },
  seatType: function seatType(state) {
    return state.seatLayoutData;
  },
  seatsSelected: function seatsSelected(state) {
    return state.seatsSelected;
  },
  SELECTED_SEATS: function SELECTED_SEATS(state) {
    return state.seatsSelected;
  },
  totalNumberOfSeats: function totalNumberOfSeats(state) {
    return state.totalNumberOfSeats;
  },
  screen: function screen(state) {
    return state.screen;
  },
  totalPrice: function totalPrice(state) {
    return state.totalPrice;
  },
  NET_AMOUNT: function NET_AMOUNT(state) {
    return state.totalPrice;
  },
  reservationId: function reservationId(state) {
    return state.reservationId;
  },
  additionalCharges: function additionalCharges(state) {
    return state.additionalCharges;
  },
  getselectedDate: function getselectedDate(state) {
    return state.selectedDate;
  },
  getOffersCollection: function getOffersCollection(state) {
    return state.OffersList;
  },
  promoCode: function promoCode(state) {
    return state.promocode;
  },
  totalTicketPrice: function totalTicketPrice(state) {
    return state.totalTicketPrice;
  },
  TOTAL_AMOUNT: function TOTAL_AMOUNT(state) {
    return state.totalTicketPrice;
  },
  offerPrice: function offerPrice(state) {
    return state.offerPrice;
  },
  offerSet: function offerSet(state) {
    return state.offerSet;
  },
  totalGrossPrice: function totalGrossPrice(state) {
    return state.totalGrossPrice;
  },
  seoData: function seoData(state) {
    return state.seoData;
  },
  selectedOffers: function selectedOffers(state) {
    return state.selectedOffers;
  },
  schedule_details_obj: function schedule_details_obj(state) {
    return state.schedule_details_obj;
  },
  offerFor: function offerFor(state) {
    return state.offerFor;
  }
}, (0, _defineProperty3.default)(_getters, "SELECTED_SEATS", function SELECTED_SEATS(state) {
  return state.seatsSelected;
}), (0, _defineProperty3.default)(_getters, "getNetAmount", function getNetAmount(state) {
  return state.netAmount;
}), (0, _defineProperty3.default)(_getters, "getMovieDates", function getMovieDates(state) {
  return state.movie_dates;
}), (0, _defineProperty3.default)(_getters, "areShowsAvailable", function areShowsAvailable(state) {
  return state.are_shows_available;
}), (0, _defineProperty3.default)(_getters, "getMovieId", function getMovieId(state) {
  return state.movie_id;
}), _getters);

exports.default = {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(276);

var _keys2 = _interopRequireDefault(_keys);

var _regenerator = __webpack_require__(126);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(127);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vue = __webpack_require__(59);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(275);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _router = __webpack_require__(581);

var _store = __webpack_require__(239);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import MovieService from "@/services/MovieService";
var state = {
  booking_id: "",
  booking_details: []
};

var mutations = {
  SET_BOOKING_ID: function SET_BOOKING_ID(state, payload) {
    state.booking_id = payload;
  },
  SET_BOOKING_DETAILS: function SET_BOOKING_DETAILS(state, payload) {
    state.booking_details = payload;
  }
};

var actions = {
  payment: function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(context, payload) {
      var loader;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              console.log("payload :", payload);
              // console.log('payload.cust_id :', payload.cust_id);
              // console.log('payload.reservationId :', payload.reservationId);
              loader = _vue2.default.$loading.show();
              _context2.next = 4;
              return MovieService.paymentGateway({
                reserveID: payload.reservationId
              }).then(function () {
                var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(response) {
                  var data;
                  return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          data = response.data;
                          // loader.hide();

                          if (!data.status) {
                            _context.next = 11;
                            break;
                          }

                          if (!data.Records) {
                            _context.next = 8;
                            break;
                          }

                          console.log("data.Records :", data.Records);
                          _context.next = 6;
                          return context.dispatch("bookSeats", {
                            reservationId: payload.reservationId,
                            payment_method: data.Records,
                            cust_id: payload.cust_id,
                            email: payload.email,
                            totalTicketPrice: payload.total,
                            country_mob_code: payload.country_mob_code,
                            cust_mobile: payload.cust_mobile
                          });

                        case 6:
                          _context.next = 8;
                          return loader.hide();

                        case 8:
                          // Vue.toasted.show(data.message);
                          loader.hide();
                          _context.next = 13;
                          break;

                        case 11:
                          _vue2.default.toasted.show(data.message);
                          loader.hide();

                        case 13:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, undefined);
                }));

                return function (_x3) {
                  return _ref2.apply(this, arguments);
                };
              }()).catch(function (err) {
                // loader.hide();
                console.log("err :>> ", err);
                _vue2.default.toasted.show("Catch error in payment:", err);
                loader.hide();
              });

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, undefined);
    }));

    function payment(_x, _x2) {
      return _ref.apply(this, arguments);
    }

    return payment;
  }(),
  bookSeats: function () {
    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(context, payload) {
      var loader, guest_user_id, body;
      return _regenerator2.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              loader = _vue2.default.$loading.show();
              // console.log("payload.cust_id :", payload.cust_id);

              guest_user_id = localStorage.getItem("guest_user_id") ? localStorage.getItem("guest_user_id") : null;
              body = {
                reservation_id: _store2.default.getters.reservationId,
                payment_method: 1,
                cust_id: _store2.default.getters.login_details.length > 0 ? _store2.default.getters.login_details[0].cust_id : null,
                customer_id: _store2.default.getters.login_details.length > 0 ? _store2.default.getters.login_details[0].cust_id : null,
                guest_user_id: guest_user_id,
                email: payload.email,
                offer_setting_id: _store2.default.getters.selectedOffers && (0, _keys2.default)(_store2.default.getters.selectedOffers).length > 0 ? _store2.default.getters.selectedOffers.offer_setting_id : null,
                promocode: String(_store2.default.getters.promoCode).length > 0 ? _store2.default.getters.promoCode : null,
                offerFor: _store2.default.getters.offerFor,
                // offer: store.getters.offer,
                // applied_voucher: store.getters.applied_voucher,
                isGroupRateCard: true,
                payment_mode_id: 10,
                cinema_id: _store2.default.getters.schedule_details_obj.cine_id,
                aggregator_cinema: _store2.default.getters.schedule_details_obj.cine_id,
                payment_mode: {
                  bs_id: 1,
                  bs_source: "Box Office",
                  bs_is_active: "Y",
                  created_by: null,
                  created_at: null,
                  updated_by: 4,
                  updated_at: "2020-07-16T04:20:00.000Z",
                  bspm_id: 20,
                  booking_source_id: 1,
                  payment_mode_id: 3,
                  mapping_is_active: "Y",
                  pm_id: 3,
                  pm_payment_mode: "Debit Card",
                  pm_icon_url: null,
                  pm_is_active: "Y",
                  amount: 0
                },
                offer: _store2.default.getters.selectedOffers && (0, _keys2.default)(_store2.default.getters.selectedOffers).length > 0 ? _store2.default.getters.selectedOffers : {
                  t_offer_price: 0,
                  oc_discount_value: 0,
                  is_on_net_amount: "N",
                  is_offer_for: "vouchers",
                  is_offer_applied: false,
                  is_on_gross_amount: "N"
                },
                currency_code: _store2.default.getters.getGlobalCurrency.curr_code,
                country_mob_code: payload.country_mob_code,
                mobile_number: payload.cust_mobile
                // offer: {
                //   t_offer_price: 0,
                //   oc_discount_value: 0,
                //   is_on_net_amount: "N",
                //   is_offer_for: "vouchers",
                //   is_offer_applied: false,
                //   is_on_gross_amount: "N"
                // }
                // offer: {
                //     is_offer_applied:
                //         Object.keys(store.getters.selectedOffers).length > 0
                //             ? true
                //             : false,
                //     ...store.getters.selectedOffers,
                //     t_offer_price: store.getters.offerPrice,
                //     oc_discount_value: store.getters.offerPrice,
                //     is_on_net_amount: null,
                //     is_on_net_amount: null,
                //     is_offer_for: store.getters.offerFor,
                // }
                // totalTicketPrice: payload.totalTicketPrice
              };
              // if (store.getters.offerFor === "offersAndPromotions") {
              //     body.offer["is_on_net_amount"] =
              //         store.getters.selectedOffers["offer_applicable_on_net_amount"] ||
              //         "N";
              //     body.offer["is_on_gross_amount"] =
              //         store.getters.selectedOffers["offer_applicable_on_gross_amount"] ||
              //         "N";
              // }

              _context4.next = 5;
              return MovieService.BookSeats(body).then(function () {
                var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(response) {
                  var data;
                  return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          data = response.data;
                          // loader.hide();

                          if (!data.status) {
                            _context3.next = 15;
                            break;
                          }

                          if (!data.bookingID) {
                            _context3.next = 13;
                            break;
                          }

                          console.log("data.BookingId bookseats :", data.bookingID);
                          _context3.next = 6;
                          return context.commit("SET_BOOKING_ID", data.bookingCode);

                        case 6:
                          _context3.next = 8;
                          return _vue2.default.toasted.show("Seats Booked");

                        case 8:
                          _context3.next = 10;
                          return _router.router.push({ path: "/booking-confirmation" });

                        case 10:
                          _context3.next = 12;
                          return _store2.default.dispatch("onResetOffersAndPrice");

                        case 12:
                          loader.hide();
                          // await context.dispatch('getBookingDetails')

                        case 13:
                          _context3.next = 16;
                          break;

                        case 15:
                          _vue2.default.toasted.show(data.message);

                        case 16:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3, undefined);
                }));

                return function (_x6) {
                  return _ref4.apply(this, arguments);
                };
              }()).catch(function (err) {
                // loader.hide();
                console.log("err :>> ", err);
                _vue2.default.toasted.show("Catch error in book seats", err);
              });

            case 5:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, undefined);
    }));

    function bookSeats(_x4, _x5) {
      return _ref3.apply(this, arguments);
    }

    return bookSeats;
  }(),
  getBookingDetails: function getBookingDetails(_ref5) {
    var state = _ref5.state,
        commit = _ref5.commit;

    console.log("state.booking_id :", state.booking_id);
    MovieService.GetBookingDetails({
      bookingCode: state.booking_id
    }).then(function (response) {
      var data = response.data;
      // loader.hide();

      if (data.status) {
        if (data.Records) {
          console.log("data.Records :", data.Records);
          commit("SET_BOOKING_DETAILS", data.Records);
          commit("SET_SCHEDULE_DETAILS_OBJ", {});
        }
        _vue2.default.toasted.show(data.message);
      } else {
        _vue2.default.toasted.show(data.message);
      }
    }).catch(function (err) {
      // loader.hide();
      _vue2.default.toasted.show("Catch error in payment");
    });
  }
};

var getters = {
  booking_details: function booking_details(state) {
    return state.booking_details;
  }
};

exports.default = {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1472 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1473 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1474 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1475 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1476 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */,
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */,
/* 1505 */,
/* 1506 */,
/* 1507 */,
/* 1508 */,
/* 1509 */,
/* 1510 */,
/* 1511 */,
/* 1512 */,
/* 1513 */,
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */,
/* 1521 */,
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getNumberFormatter = exports.getNumberFormatter = function getNumberFormatter(format, precesion) {
  console.log("format here", format);
  console.log("precesion here", precesion);
  // let precesion = 2;
  return function (number) {
    if (number) {
      return number.toLocaleString(format, {
        minimumFractionDigits: precesion,
        maximumFractionDigits: precesion
      });
    } else {
      return "0.00";
    }
  };
};

/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.combineDateAndTime = exports.getTimeFormatter = undefined;

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getTimeFormatter = exports.getTimeFormatter = function getTimeFormatter(format) {
  return function (time) {
    if (time) {
      var dateString = combineDateAndTime(time);
      if (format == "am/pm") {
        return (0, _moment2.default)(dateString).format("h:mm A");
      } else {
        return (0, _moment2.default)(dateString).format("HH:mm");
      }
    } else {
      return (0, _moment2.default)().format("HH:mm");
    }
  };
};

var combineDateAndTime = exports.combineDateAndTime = function combineDateAndTime(time) {
  var timeString = time;
  var dateString = (0, _moment2.default)().format("YYYY-MM-DD");
  var combined = new Date(dateString + " " + timeString);
  combined = (0, _moment2.default)(dateString + " " + timeString);
  return combined;
};

/***/ }),
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1549 */
/***/ (function(module, exports) {

module.exports = {"name":"GoGoCinema","version":"1.0.0","version-control":"1.0.0","description":"A Vue.js project","author":"Sanath Shetty <sanath@binarynumbers.io>","private":true,"scripts":{"dev":"node build/dev-server.js","start":"node build/dev-server.js","build":"node build/build.js","unit":"cross-env BABEL_ENV=test karma start test/unit/karma.conf.js --single-run","e2e":"node test/e2e/runner.js","test":"npm run unit && npm run e2e","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs"},"dependencies":{"@babel/polyfill":"^7.2.5","axios":"^0.19.0","babel-cli":"^6.26.0","babel-preset-es2015":"^6.24.1","babel-preset-es2015-ie":"^6.7.0","bootstrap-vue":"^2.0.0-rc.25","crypto-js":"^3.1.9-1","debounce":"^1.2.0","jquery":"^3.4.1","lodash":"^4.17.21","moment":"^2.24.0","path":"^0.12.7","pretty-checkbox":"^3.0.3","vee-validate":"^2.2.0","vue":"^2.5.2","vue-braintree":"^2.0.3","vue-burger-menu":"^2.0.0","vue-carousel-3d":"^0.1.23","vue-cookie-law":"^1.10.0","vue-date-pick":"^1.1.0","vue-debounce":"^3.0.1","vue-dragscroll":"^1.8.3","vue-facebook-signin-button":"^1.0.1","vue-faq-accordion":"^1.2.1","vue-functional-calendar":"^2.1.4","vue-google-signin-button":"^1.0.2","vue-html-to-paper":"^1.0.3","vue-infinite-scroll":"^2.0.2","vue-lazyload":"^1.3.3","vue-localstorage":"^0.6.2","vue-meta":"^1.5.8","vue-navigator-share":"^1.0.3","vue-owl-carousel":"^2.0.3","vue-router":"^3.0.1","vue-scrollto":"^2.17.1","vue-slick":"^1.1.15","vue-slick-carousel":"^1.0.6","vue-stripe-elements-plus":"^0.3.0","vue-tel-input":"^2.0.21","vue-youtube-embed":"^2.2.1","vue2-datepicker":"^3.2.2","vuex":"^3.6.2","vuex-persist":"^3.1.3"},"devDependencies":{"autoprefixer":"^7.1.5","babel-core":"^6.26.0","babel-eslint":"^8.0.1","babel-loader":"^7.1.2","babel-plugin-istanbul":"^5.1.4","babel-plugin-transform-runtime":"^6.23.0","babel-preset-env":"^1.6.0","babel-preset-stage-2":"^6.24.1","babel-register":"^6.26.0","chai":"^4.1.2","chalk":"^2.1.0","chokidar":"^2.0.4","connect-history-api-fallback":"^1.4.0","copy-webpack-plugin":"^4.1.1","cross-env":"^5.0.5","cross-spawn":"^5.1.0","css-loader":"^1.0.1","cssnano":"^4.1.10","eslint":"^4.9.0","eslint-config-standard":"^10.2.1","eslint-friendly-formatter":"^3.0.0","eslint-loader":"^1.9.0","eslint-plugin-html":"^3.2.2","eslint-plugin-import":"^2.7.0","eslint-plugin-node":"^5.2.0","eslint-plugin-promise":"^3.6.0","eslint-plugin-standard":"^3.0.1","eventsource-polyfill":"^0.9.6","express":"^4.16.4","extract-text-webpack-plugin":"^3.0.0","file-loader":"^1.1.5","friendly-errors-webpack-plugin":"^1.6.1","html-webpack-plugin":"^2.30.1","http-proxy-middleware":"^0.19.1","inject-loader":"^3.0.1","install":"^0.12.2","karma":"^4.1.0","karma-coverage":"^1.1.1","karma-mocha":"^1.3.0","karma-phantomjs-launcher":"^1.0.4","karma-phantomjs-shim":"^1.5.0","karma-sinon-chai":"^1.3.2","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.31","karma-webpack":"^2.0.5","mocha":"^4.0.1","nightwatch":"^1.1.13","npm":"^6.10.0","opn":"^5.1.0","optimize-css-assets-webpack-plugin":"3.2.0","ora":"^1.3.0","phantomjs-prebuilt":"^2.1.15","rimraf":"^2.6.2","selenium-server":"^3.6.0","semver":"^5.4.1","shelljs":"^0.7.8","sinon":"^4.0.1","sinon-chai":"^2.14.0","sw-precache-webpack-plugin":"^0.11.4","uglify-es":"^3.1.3","url-loader":"^0.6.2","vue-loader":"^13.3.0","vue-loading-overlay":"^3.2.0","vue-style-loader":"^3.0.3","vue-template-compiler":"^2.5.2","webpack":"^3.7.1","webpack-bundle-analyzer":"^3.3.2","webpack-dev-middleware":"^1.12.0","webpack-hot-middleware":"^2.19.1","webpack-merge":"^4.1.0"},"engines":{"node":">= 4.0.0","npm":">= 3.0.0"},"browserslist":["> 1%","last 2 versions","not ie <= 8"]}

/***/ })
],[247]);


// WEBPACK FOOTER //
// static/js/app.73150afa923520f7f05d.js